import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from "moment";
import fileDownload from 'js-file-download';
import * as ReactBootStrap from 'react-bootstrap';
import '../tools/css/Agendas.css';
import '../tools/css/Home.css';
import Profesionales from '../API/Profesionales';
import DiasSemana from '../API/DiasSemana';
import BtnEdit from '../components/BtnEdit';
import BtnVer from '../components/BtnVer';
import cargamultimedia from '../tools/images/iconocargarfoto.svg'
import Logo_nuevo from '../tools/images/Nuevo';
import Info from '../tools/images/Info';
import Logo_agenda from '../tools/images/Agenda';
import BtnAdd from '../components/BtnAdd';
import BtnDelete from '../components/BtnDelete';
import emptypage from '../tools/images/carpeta.gif';
import Buscar from '../tools/images/Buscar';
import file_pdf from '../tools/images/file_arrow.svg';
import Select from 'react-select';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL="https://medicall-api-test.azurewebsites.net";
var institution_id =sessionStorage.getItem('id_institution');
var id_med_anexo =sessionStorage.getItem('identificacion_profesional');
var nom_med_anexo =sessionStorage.getItem('nombre_usua');
var mensaje='';
var id_profe='0';
var id_especialidad='0';
var id_sede='0';
var id_sededit='0'
var nom_sededit='';
var id_especialidad_edit='0';
var dia_intervalo='null';
var agendaid='0';
var nom_agenda='';
var buscar_agenda='';
var buscar_agenda_inactiva='';
var buscar_agenda_vencida='';
var buscar_agenda_anulada='';
var dato=0;
var btn_activar='';
var estado_agenta='';
var est_agenda='';
var id_tipo_servi=0;
var id_cita_cancela=0;
var tipo_filtro='';
var tipo_filtro_atendidos='';
var buscar_solicitada='';
var id_consulta=0;
var diagnosticos_pcte=[];
var avatar=[];
var nombre_tipoanexo="";
var file_base64_doc="";
var id_tipoanexo="0";
var id_anexo_elimina=0

const diagnosticos_hc=[
  {
    "cod_dx": "A000",
    "nombre_dx": "A000-COLERA DEBIDO A VIBRIO CHOLERAE O1, BIOTIPO CHOLERAE",
    "sexo": "A"
  },
  {
    "cod_dx": "A001",
    "nombre_dx": "A001-COLERA DEBIDO A VIBRIO CHOLERAE O1, BIOTIPO EL TOR",
    "sexo": "A"
  },
  {
    "cod_dx": "A009",
    "nombre_dx": "A009-COLERA NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A010",
    "nombre_dx": "A010-FIEBRE TIFOIDEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A011",
    "nombre_dx": "A011-Fiebre paratifoidea A",
    "sexo": "A"
  },
  {
    "cod_dx": "A012",
    "nombre_dx": "A012-FIEBRE PARATIFOIDEA B ",
    "sexo": "A"
  },
  {
    "cod_dx": "A013",
    "nombre_dx": "A013-FIEBRE PARATIFOIDEA C ",
    "sexo": "A"
  },
  {
    "cod_dx": "A014",
    "nombre_dx": "A014-FIEBRE PARATIFOIDEA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A020",
    "nombre_dx": "A020-ENTERITIS DEBIDA A SALMONELLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A021",
    "nombre_dx": "A021-Sepsis debida a Salmonella (antes SEPTICEMIA DEBIDA A SALMONELLA)",
    "sexo": "A"
  },
  {
    "cod_dx": "A022",
    "nombre_dx": "A022-INFECCIONES LOCALIZADAS DEBIDA A SALMONELLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A028",
    "nombre_dx": "A028-OTRAS INFECCIONES ESPECIFICADAS COMO DEBIDAS A SALMONELLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A029",
    "nombre_dx": "A029-INFECCIÓN DEBIDA A SALMONELLA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A030",
    "nombre_dx": "A030-SHIGELOSIS DEBIDA A SHIGELLA DYSENTERIAE",
    "sexo": "A"
  },
  {
    "cod_dx": "A031",
    "nombre_dx": "A031-SHIGELOSIS DEBIDA A SHIGELLAFLEXNERI",
    "sexo": "A"
  },
  {
    "cod_dx": "A032",
    "nombre_dx": "A032-SHIGELOSIS DEBIDA A SHIGELLA BOYDII ",
    "sexo": "A"
  },
  {
    "cod_dx": "A033",
    "nombre_dx": "A033-SHIGELOSIS DEBIDA A SHIGELLA SONNEI ",
    "sexo": "A"
  },
  {
    "cod_dx": "A038",
    "nombre_dx": "A038-OTRAS SHIGELOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A039",
    "nombre_dx": "A039-SHIGELOSIS DE TIPO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A040",
    "nombre_dx": "A040-INFECCION DEBIDA A ESCHERICHIA COLI ENTEROPATOGENA",
    "sexo": "A"
  },
  {
    "cod_dx": "A041",
    "nombre_dx": "A041-INFECCION DEBIDA A ESCHERICHIA COLI ENTEROTOXIGENA",
    "sexo": "A"
  },
  {
    "cod_dx": "A042",
    "nombre_dx": "A042-INFECCION DEBIDA A ESCHERICHIA COLI ENTEROINVASIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "A043",
    "nombre_dx": "A043-INFECCION DEBIDA A ESCHERICHIA COLI ENTEROHEMORRAGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A044",
    "nombre_dx": "A044-OTRAS INFECCIONES INTESTINALES DEBIDAS A ESCHERICHIA COLI ",
    "sexo": "A"
  },
  {
    "cod_dx": "A045",
    "nombre_dx": "A045-ENTERITIS DEBIDA A CAMPYLOBACTER",
    "sexo": "A"
  },
  {
    "cod_dx": "A046",
    "nombre_dx": "A046-ENTERITIS DEBIDA A YERSINIA ENTEROCOLITICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A047",
    "nombre_dx": "A047-ENTEROCOLITIS DEBIDA A CLOSTRIDIUM DIFFICILE",
    "sexo": "A"
  },
  {
    "cod_dx": "A048",
    "nombre_dx": "A048-OTRAS INFECCIONES INTESTINALES BACTERIANAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A049",
    "nombre_dx": "A049-INFECCION INTESTINAL BACTERIANA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A050",
    "nombre_dx": "A050-INTOXICACION ALIMENTARIA ESTAFILOCOCICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A052",
    "nombre_dx": "A052-INTOXICACION ALIMENTARIADEBIDA A CLOSTRIDIUM PERFRINGENS [CLOSTRIDIUM WELCHII]",
    "sexo": "A"
  },
  {
    "cod_dx": "A053",
    "nombre_dx": "A053-INTOXICACION ALIMENTARIADEBIDA A VIBRIO PARAHAEMOLYTICUS",
    "sexo": "A"
  },
  {
    "cod_dx": "A054",
    "nombre_dx": "A054-INTOXICACION ALIMENTARIADEBIDA A BACILLUS CEREUS",
    "sexo": "A"
  },
  {
    "cod_dx": "A058",
    "nombre_dx": "A058-OTRAS INTOXICACIONES ALIMENTARIASDEBIDAS A BACTERIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A059",
    "nombre_dx": "A059-INTOXICACION ALIMENTARIA BACTERIANA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A05X",
    "nombre_dx": "A05X-BOTULISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A060",
    "nombre_dx": "A060-DISENTERIA AMEBIANA AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A061",
    "nombre_dx": "A061-AMEBIASIS INTESTINALCRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A062",
    "nombre_dx": "A062-COLITIS AMEBIANA NO DISENTERICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A063",
    "nombre_dx": "A063-AMEBOMA INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A064",
    "nombre_dx": "A064-ABSCESO AMEBIANO DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A065",
    "nombre_dx": "A065-ABSCESO AMEBIANO DEL PULMON (J99.8*)",
    "sexo": "A"
  },
  {
    "cod_dx": "A066",
    "nombre_dx": "A066-ABSCESO AMEBIANO DEL CEREBRO (G07*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A067",
    "nombre_dx": "A067-AMEBIASIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A068",
    "nombre_dx": "A068-INFECCION AMEBIANA DE OTRAS LOCALIZACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "A069",
    "nombre_dx": "A069-AMEBIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A070",
    "nombre_dx": "A070-BALANTIDIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A071",
    "nombre_dx": "A071-GIARDIASIS [LAMBLIASIS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "A072",
    "nombre_dx": "A072-CRIPTOSPORIDIOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A073",
    "nombre_dx": "A073-ISOSPORIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A078",
    "nombre_dx": "A078-OTRAS ENFERMEDADES INTESTINALES ESPECIFICADAS DEBIDAS A PROTOZOARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A079",
    "nombre_dx": "A079-ENFERMEDAD INTESTINAL DEBIDA A PROTOZOARIOS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A080",
    "nombre_dx": "A080-ENTERITIS DEBIDA A ROTAVIRUS",
    "sexo": "A"
  },
  {
    "cod_dx": "A081",
    "nombre_dx": "A081-GASTROENTEROPATIA AGUDA DEBIDA AL AGENTE DE NORWALK ",
    "sexo": "A"
  },
  {
    "cod_dx": "A082",
    "nombre_dx": "A082-ENTERITIS DEBIDA A ADENOVIRUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A083",
    "nombre_dx": "A083-OTRAS ENTERITIS VIRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "A084",
    "nombre_dx": "A084-INFECCION INTESTINAL VIRAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A085",
    "nombre_dx": "A085-OTRAS INFECCIONES INTESTINALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A090",
    "nombre_dx": "A090-Otras gastroenteritis y colitis de origen infeccioso",
    "sexo": "A"
  },
  {
    "cod_dx": "A099",
    "nombre_dx": "A099-Gastroenteritis y colitis de origen no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "A150",
    "nombre_dx": "A150-TUBERCULOSIS DEL PULMON, CONFIRMADA POR HALLAZGO MICROSCOPICO DEL BACILO TUBERCULOSO EN ESPUTO, CON ",
    "sexo": "A"
  },
  {
    "cod_dx": "A151",
    "nombre_dx": "A151-TUBERCULOSIS DEL PULMON, CONFIRMADA UNICAMENTE POR CULTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "A152",
    "nombre_dx": "A152-TUBERCULOSIS DEL PULMON, CONFIRMADA HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A153",
    "nombre_dx": "A153-TUBERCULOSIS DEL PULMON , CONFIRMADA POR MEDIOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A154",
    "nombre_dx": "A154-TUBERCULOSIS DE GANGLIOS LINFATICOS INTRATORACICOS, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A155",
    "nombre_dx": "A155-TUBERCULOSIS DE LARINGE, TRAQUEA Y BRONQUIOS, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A156",
    "nombre_dx": "A156-PLEURESIA TUBERCULOSA, CONFIRMADA BACTERIOLOGICAE HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A157",
    "nombre_dx": "A157-TUBERCULOSIS RESPIRATORIA PRIMARIA, CONFIRMADA BACTERIOLOGICA E HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A158",
    "nombre_dx": "A158-OTRAS TUBERCULOSIS RESPIRATORIAS, CONFIRMADAS BACTERIOLOGICA E HISTOLOGICAMENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A159",
    "nombre_dx": "A159-TUBERCULOSIS RESPIRATORIA NO ESPECIFICADA, CONFIRMADA BACTERIOLOGICAMENTE E HISTOLOGICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A160",
    "nombre_dx": "A160-TUBERCULOSIS DEL PULMON, CON EXAMEN BACTERIOLOGICO E HISTOLOGICO NEGATIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A161",
    "nombre_dx": "A161-TUBERCULOSIS DEL PULMON, SIN EXAMEN BACTERIOLOGICO E HISTOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "A162",
    "nombre_dx": "A162-TUBERCULOSIS DE PULMON, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A163",
    "nombre_dx": "A163-TUBERCULOSIS DE GANGLIOS LINFATICOS INTRATORACICOS, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A164",
    "nombre_dx": "A164-TUBERCULOSIS DE LARINGE, TRAQUEA Y BRONQUIOS, SIN MENCION DE CONFIRMACION BACTERIOLOGICA O HISTOLOGI",
    "sexo": "A"
  },
  {
    "cod_dx": "A165",
    "nombre_dx": "A165-PLEURESIA TUBERCULOSA, SIN MENCION DE CONFIRMACION BACTERIOLOGICAE HISTOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A167",
    "nombre_dx": "A167-TUBERCULOSIS RESPIRATORIA PRIMARIA, SIN MENCION DE CONFIRMACION BACTERIOLOGICA E HISTOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A168",
    "nombre_dx": "A168-OTRAS TUBERCULOSIS RESPIRATORIAS,SIN MENCION DE CONFIRMACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A169",
    "nombre_dx": "A169-TUBERCULOSIS RESPIRATORIA NO ESPECIFICADA, SIN MENCION DE CONFIRMACION BACTERIOLOGICAO HISTOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A170",
    "nombre_dx": "A170-MENINGITIS TUBERCULOSA (G01*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A171",
    "nombre_dx": "A171-TUBERCULOMA MENINGEO (G07*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A178",
    "nombre_dx": "A178-OTRAS TUBERCULOSIS DEL SISTEMA NERVIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A179",
    "nombre_dx": "A179-TUBERCULOSIS DEL SISTEMA NERVIOSO, NO ESPECIFICADA (G99.8*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A180",
    "nombre_dx": "A180-TUBERCULOSIS DE HUESOS Y ARTICULACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "A181",
    "nombre_dx": "A181-TUBERCULOSIS DEL APARATO GENITOURINARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A182",
    "nombre_dx": "A182-LINFADENOPATIA PERIFERICA TUBERCULOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A183",
    "nombre_dx": "A183-TUBERCULOSIS DE LOS INTESTINOS, EL PERITONEO YLOS GANGLIOS MESENTERICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A184",
    "nombre_dx": "A184-TUBERCULOSIS DE LA PIEL Y EL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "A185",
    "nombre_dx": "A185-TUBERCULOSIS DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "A186",
    "nombre_dx": "A186-TUBERCULOSIS DEL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A187",
    "nombre_dx": "A187-TUBERCULOSIS DE GLANDULAS SUPRARRENALES (E35.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "A188",
    "nombre_dx": "A188-TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A190",
    "nombre_dx": "A190-TUBERCULOSIS MILIAR AGUDA DE UN SOLO SITIO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A191",
    "nombre_dx": "A191-TUBERCULOSIS MILIAR AGUDA DE SITIOS MULTIPLES ",
    "sexo": "A"
  },
  {
    "cod_dx": "A192",
    "nombre_dx": "A192-TUBERCULOSIS MILIAR AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A198",
    "nombre_dx": "A198-OTRAS TUBERCULOSIS MILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "A199",
    "nombre_dx": "A199-TUBERCULOSIS MILIAR, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A200",
    "nombre_dx": "A200-PESTE BUBONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A201",
    "nombre_dx": "A201-PESTE CELULOCUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A202",
    "nombre_dx": "A202-PESTE NEUMONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A203",
    "nombre_dx": "A203-MENINGITIS POR PESTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A207",
    "nombre_dx": "A207-PESTE SEPTICEMICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A208",
    "nombre_dx": "A208-OTRAS FORMAS DE PESTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A209",
    "nombre_dx": "A209-PESTE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A210",
    "nombre_dx": "A210-TULAREMIA ULCEROGLANDULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "A211",
    "nombre_dx": "A211-TULAREMIA OCULOGLANDULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A212",
    "nombre_dx": "A212-TULAREMIA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A213",
    "nombre_dx": "A213-TULAREMIA GASTROINTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A217",
    "nombre_dx": "A217-TULAREMIA GENERALIZADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A218",
    "nombre_dx": "A218-OTRAS FORMAS DE TULAREMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A219",
    "nombre_dx": "A219-TULAREMIA , NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A220",
    "nombre_dx": "A220-CARBUNCO CUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "A221",
    "nombre_dx": "A221-CARBUNCO PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "A222",
    "nombre_dx": "A222-CARBUNCO GASTROINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A227",
    "nombre_dx": "A227-Carbunco séptico",
    "sexo": "A"
  },
  {
    "cod_dx": "A228",
    "nombre_dx": "A228-OTRAS FORMAS DE CARBUNCO",
    "sexo": "A"
  },
  {
    "cod_dx": "A229",
    "nombre_dx": "A229-CARBUNCO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A230",
    "nombre_dx": "A230-BRUCELOSIS DEBIDA A BRUCELLA MELITENSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A231",
    "nombre_dx": "A231-BRUCELOSIS DEBIDA A BRUCELLAABORTUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A232",
    "nombre_dx": "A232-BRUCELOSIS DEBIDA A BRUCELLASUIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A233",
    "nombre_dx": "A233-BRUCELOSIS DEBIDA A BRUCELLA CANIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A238",
    "nombre_dx": "A238-OTRAS BRUCELOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A239",
    "nombre_dx": "A239-BRUCELOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A240",
    "nombre_dx": "A240-MUERMO",
    "sexo": "A"
  },
  {
    "cod_dx": "A241",
    "nombre_dx": "A241-MELIOIDOSIS AGUDA Y FULMINANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A242",
    "nombre_dx": "A242-MELIOIDOSIS SUBAGUDA Y CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A243",
    "nombre_dx": "A243-OTRAS MELIOIDOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A244",
    "nombre_dx": "A244-MELIOIDOSIS , NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A250",
    "nombre_dx": "A250-ESPIRILOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A251",
    "nombre_dx": "A251-ESTREPTOBACILOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A259",
    "nombre_dx": "A259-FIEBRE POR MORDEDURA DE RATA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A260",
    "nombre_dx": "A260-ERISIPELOIDE CUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "A267",
    "nombre_dx": "A267-Sepsis por Erysipelothrix",
    "sexo": "A"
  },
  {
    "cod_dx": "A268",
    "nombre_dx": "A268-OTRAS FORMAS DE ERISIPELOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "A269",
    "nombre_dx": "A269-ERISIPELOIDE, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A270",
    "nombre_dx": "A270-LEPTOSPIROSIS ICTEROHEMORRAGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A278",
    "nombre_dx": "A278-OTRAS FORMAS DE LEPTOSPIROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A279",
    "nombre_dx": "A279-LEPTOSPIROSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A280",
    "nombre_dx": "A280-PASTEURELOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A281",
    "nombre_dx": "A281-ENFERMEDAD POR RASGUÑO DE GATO",
    "sexo": "A"
  },
  {
    "cod_dx": "A282",
    "nombre_dx": "A282-YERSINIOSIS EXTRAINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A288",
    "nombre_dx": "A288-OTRAS ENFERMEDADES ZOONOTICAS BACTERIANAS ESPECIFICADAS, NO CLASIFICADAS EN OTRAPARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A289",
    "nombre_dx": "A289-ENFERMEDAD ZOONOTICA BACTERIANA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A300",
    "nombre_dx": "A300-LEPRA INDETERMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A301",
    "nombre_dx": "A301-LEPRA TUBERCULOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "A302",
    "nombre_dx": "A302-LEPRA TUBERCULOIDE LIMITROFE",
    "sexo": "A"
  },
  {
    "cod_dx": "A303",
    "nombre_dx": "A303-LEPRA LIMITROFE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A304",
    "nombre_dx": "A304-LEPRA LEPROMATOSA LIMITROFE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A305",
    "nombre_dx": "A305-LEPRA LEPROMATOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A308",
    "nombre_dx": "A308-OTRAS FORMAS DE LEPRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A309",
    "nombre_dx": "A309-LEPRA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A310",
    "nombre_dx": "A310-INFECCIONES POR MICOBACTERIAS PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "A311",
    "nombre_dx": "A311-INFECCION CUTANEA POR MICOBACTERIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A318",
    "nombre_dx": "A318-OTRAS INFECCIONES POR MICOBACTERIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A319",
    "nombre_dx": "A319-INFECCIONPOR MICOBACTERIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A320",
    "nombre_dx": "A320-LISTERIOSIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A321",
    "nombre_dx": "A321-MININGITIS Y MENINGOENCEFALITIS LISTERIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "A327",
    "nombre_dx": "A327-Sepsis listeriana",
    "sexo": "A"
  },
  {
    "cod_dx": "A328",
    "nombre_dx": "A328-OTRAS FORMAS DE LISTERIOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A329",
    "nombre_dx": "A329-LISTERIOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A33X",
    "nombre_dx": "A33X-TETANOS NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A34X",
    "nombre_dx": "A34X-TETANOS OBSTETRICO",
    "sexo": "F"
  },
  {
    "cod_dx": "A35X",
    "nombre_dx": "A35X-OTROS TETANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A360",
    "nombre_dx": "A360-DIFTERIA FARINGEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A361",
    "nombre_dx": "A361-DIFTERIA NASOFARINGEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A362",
    "nombre_dx": "A362-DIFTERIA LARINGEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A363",
    "nombre_dx": "A363-DIFTERIA CUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "A368",
    "nombre_dx": "A368-OTRAS DIFTERIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A369",
    "nombre_dx": "A369-DIFTERIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A370",
    "nombre_dx": "A370-TOS FERINA DEBIDA A BORDETELLA PERTUSSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A371",
    "nombre_dx": "A371-TOS FERINA DEBIDA A BORDETELLA PARAPERTUSSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A378",
    "nombre_dx": "A378-TOS FERINA DEBIDA A OTRAS ESPECIES DE BORDETELLA",
    "sexo": "A"
  },
  {
    "cod_dx": "A379",
    "nombre_dx": "A379-TOS FERINA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A38X",
    "nombre_dx": "A38X-ESCARLATINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A390",
    "nombre_dx": "A390-MININGITIS MENINGOCOCICA (G01*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A391",
    "nombre_dx": "A391-SINDROME DE WATERHOUSE-FRIDERICHSEN (E35.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "A392",
    "nombre_dx": "A392-MENINGOCOCEMIA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "A393",
    "nombre_dx": "A393-MENINGOCOCEMIA CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A394",
    "nombre_dx": "A394-MENINGOCOCEMIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A395",
    "nombre_dx": "A395-ENFERMEDAD CARDIACA DEBIDA A MENINGOCOCO",
    "sexo": "A"
  },
  {
    "cod_dx": "A398",
    "nombre_dx": "A398-OTRAS INFECCIONES MENINGOCOCICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A399",
    "nombre_dx": "A399-INFECCION MININGOCOCICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A400",
    "nombre_dx": "A400-SEPTICEMIA DEBIDA A ESTREPTOCOCO, GRUPO A ",
    "sexo": "A"
  },
  {
    "cod_dx": "A401",
    "nombre_dx": "A401-SEPTICEMIA DEBIDA A ESTREPTOCOCO, GRUPO B ",
    "sexo": "A"
  },
  {
    "cod_dx": "A402",
    "nombre_dx": "A402-SEPTICEMIA DEBIDA A ESTREPTOCOCO, GRUPO D ",
    "sexo": "A"
  },
  {
    "cod_dx": "A403",
    "nombre_dx": "A403-SEPTICEMIA DEBIDA A STREPTOCOCCUS PNEUMONIAE",
    "sexo": "A"
  },
  {
    "cod_dx": "A408",
    "nombre_dx": "A408-OTRAS SEPTICEMIAS ESTREPTOCOCICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A409",
    "nombre_dx": "A409-SEPTICEMIA ESTREPTOCOCICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A40X",
    "nombre_dx": "A40X-Sepsis estreptocócica (antes SEPTICEMIA ESTREPTOCOCICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "A410",
    "nombre_dx": "A410-SEPTICEMIA DEBIDA STAPHYLOCOCCUS AUREUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A411",
    "nombre_dx": "A411-SEPTICEMIA DEBIDA A OTRO ESTAFILOCOCO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A412",
    "nombre_dx": "A412-SEPTICEMIA DEBIDA A ESTAFILOCOCO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A413",
    "nombre_dx": "A413-SEPTICEMIA DEBIDA A HAEMOPHILUS INFLUENZAE",
    "sexo": "A"
  },
  {
    "cod_dx": "A414",
    "nombre_dx": "A414-SEPTICEMIA DEBIDA A ANAEROBIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A415",
    "nombre_dx": "A415-SEPTICEMIA DEBIDA A OTROS ORGANISMOS GRAMNEGATIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A418",
    "nombre_dx": "A418-OTRAS SEPTICEMIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A419",
    "nombre_dx": "A419-SEPTICEMIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A41X",
    "nombre_dx": "A41X-Otras sepsis (antes OTRAS SEPTICEMIAS)",
    "sexo": "A"
  },
  {
    "cod_dx": "A420",
    "nombre_dx": "A420-ACTINOMICOSIS PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A421",
    "nombre_dx": "A421-ACTINOMICOSIS ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A422",
    "nombre_dx": "A422-ACTINOMICOSIS CERVICOFACIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A427",
    "nombre_dx": "A427-Sepsis actinomicótica (antes SEPTICEMIA ACTINOMICOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "A428",
    "nombre_dx": "A428-OTRAS FORMAS DE ACTINOMICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A429",
    "nombre_dx": "A429-ACTINOMICOSIS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A430",
    "nombre_dx": "A430-NOCARDIOSIS PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A431",
    "nombre_dx": "A431-NOCARDIOSIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A438",
    "nombre_dx": "A438-OTRAS FORMAS DE NOCARDIOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A439",
    "nombre_dx": "A439-NORCARDIOSIS , NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A440",
    "nombre_dx": "A440-BARTONELOSIS SISTEMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A441",
    "nombre_dx": "A441-BARTONELOSIS CUTANEA Y MUCOCUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "A448",
    "nombre_dx": "A448-OTRAS FORMAS DE BARTONELOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A449",
    "nombre_dx": "A449-BARTONELOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A46X",
    "nombre_dx": "A46X-ERISIPELA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A480",
    "nombre_dx": "A480-GANGRENA GASEOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "A481",
    "nombre_dx": "A481-ENFERMEDAD DE LOS LEGIONARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A482",
    "nombre_dx": "A482-ENFERMEDAD DE LOS LEGIONARIOS NO NEUMONICA [FIEBRE DE PONTIAC]",
    "sexo": "A"
  },
  {
    "cod_dx": "A483",
    "nombre_dx": "A483-SINDROME DE CHOQUE TOXICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A484",
    "nombre_dx": "A484-FIEBRE PURPURICA BRASILEÑA",
    "sexo": "A"
  },
  {
    "cod_dx": "A488",
    "nombre_dx": "A488-OTRAS ENFERMEDADES BACTERIANAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A490",
    "nombre_dx": "A490-INFECCION ESTAFILOCOCICA, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "A491",
    "nombre_dx": "A491-INFECCION ESTREPTOCOCICA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A492",
    "nombre_dx": "A492-INFECCION POR HAEMOPHILUS INFLUENZAE, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A493",
    "nombre_dx": "A493-INFECCION POR MICOPLASMA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A498",
    "nombre_dx": "A498-OTRAS INFECCIONES BACTERIANAS DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A499",
    "nombre_dx": "A499-INFECCION BACTERIANA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A500",
    "nombre_dx": "A500-SIFILIS CONGENITA PRECOZ, SINTOMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A501",
    "nombre_dx": "A501-SIFILIS CONGENITA PRECOZ, LATENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A502",
    "nombre_dx": "A502-SIFILIS CONGENITA PRECOZ SIN OTRA ESPECIFICACIÓN",
    "sexo": "A"
  },
  {
    "cod_dx": "A503",
    "nombre_dx": "A503-OCULOPATIA SIFILITICA CONGENITA TARDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "A504",
    "nombre_dx": "A504-NEUROSIFILIS CONGENITA TARDIA [NEUROSIFILIS JUVENIL]",
    "sexo": "A"
  },
  {
    "cod_dx": "A505",
    "nombre_dx": "A505-OTRAS FORMAS DE SIFILIS CONGENITA TARDIA, SINTOMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A506",
    "nombre_dx": "A506-SIFILIS CONGENITA TARDIA, LATENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A507",
    "nombre_dx": "A507-SIFILIS CONGENITA TARDIA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A509",
    "nombre_dx": "A509-SIFILIS CONGENITA, SIN OTRA ESPECIFICACIÓN",
    "sexo": "A"
  },
  {
    "cod_dx": "A510",
    "nombre_dx": "A510-SIFILIS GENITAL PRIMARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "A511",
    "nombre_dx": "A511-SIFILIS PRIMARIA ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A512",
    "nombre_dx": "A512-SIFILIS PRIMARIA EN OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A513",
    "nombre_dx": "A513-SIFILIS SECUNDARIA DE PIEL Y MEMBRANAS MUCOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A514",
    "nombre_dx": "A514-OTRAS SIFILIS SECUNDARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A515",
    "nombre_dx": "A515-SIFILIS PRECOZ, LATENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A519",
    "nombre_dx": "A519-SIFILIS PRECOZ, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "A520",
    "nombre_dx": "A520-SIFILIS CARDIOVASCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A521",
    "nombre_dx": "A521-NEUROSIFILIS SINTOMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A522",
    "nombre_dx": "A522-NEUROSIFILIS ASINTOMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A523",
    "nombre_dx": "A523-NEUROSIFILIS NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A527",
    "nombre_dx": "A527-OTRAS SIFILIS TARDIAS SINTOMATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A528",
    "nombre_dx": "A528-SIFILIS TARDIA, LATENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A529",
    "nombre_dx": "A529-SIFILIS TARDIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A530",
    "nombre_dx": "A530-SIFILIS LATENTE, NO ESPECIFICADA COMO PRECOZ O TARDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A539",
    "nombre_dx": "A539-SIFILIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A540",
    "nombre_dx": "A540-INFECCION GONOCOCICA DEL TRACTO GENITOURINARIO INFERIOR SIN ABSCESO PERIURETRAL O DE GLANDULA ACCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "A541",
    "nombre_dx": "A541-INFECCION GONOCOCICA DEL TRACTO GENITOURINARIO INFERIOR CON ABSCESO PERIURETRAL Y DE GLANDULAS ACCES",
    "sexo": "A"
  },
  {
    "cod_dx": "A542",
    "nombre_dx": "A542-PELVIPERITONITIS GONOCOCICA Y OTRAS INFECCIONES GONOCOCICAS GENITOURINARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A543",
    "nombre_dx": "A543-INFECCION GONOCOCICA DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "A544",
    "nombre_dx": "A544-INFECCION GONOCOCICA DEL SISTEMA OSTEOMUSCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "A545",
    "nombre_dx": "A545-FARINGITIS GONOCOCICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A546",
    "nombre_dx": "A546-INFECCION GONOCOCICA DEL ANO Y DEL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "A548",
    "nombre_dx": "A548-OTRAS INFECCIONES GONOCOCICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A549",
    "nombre_dx": "A549-INFECCION, GONOCOCICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A55X",
    "nombre_dx": "A55X-LINFOGRANULOMA (VENEREO) POR CLAMIDIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A560",
    "nombre_dx": "A560-INFECCION DEL TRACTO GENITOURINARIO INFERIOR DEBIDA A CLAMIDIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A561",
    "nombre_dx": "A561-INFECCION DEL PELVIPERITONEO Y OTROS ORGANOS GENITOURINARIOS DEBIDA A CLAMIDIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A562",
    "nombre_dx": "A562-INFECCIONES DEL TRACTO GENITOURINARIO DEBIDAS A CLAMIDIAS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A563",
    "nombre_dx": "A563-INFECCION DEL ANO Y DEL RECTO DEBIDA A CLAMIDIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A564",
    "nombre_dx": "A564-INFECCION DE FARINGE DEBIDA A CLAMIDIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A568",
    "nombre_dx": "A568-INFECCION DE TRANSMISIÓN SEXUAL DE OTROS SITIOS DEBIDA A CLAMIDIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A57X",
    "nombre_dx": "A57X-CHANCRO BLANDO",
    "sexo": "A"
  },
  {
    "cod_dx": "A58X",
    "nombre_dx": "A58X-GRANULOMA INGUINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A590",
    "nombre_dx": "A590-TRICOMONIASIS UROGENITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A598",
    "nombre_dx": "A598-TRICOMONIASIS DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A599",
    "nombre_dx": "A599-TRICOMONIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A600",
    "nombre_dx": "A600-INFECCION DE GENITALES Y TRAYECTO UROGENITAL Y DEBIDA A VIRUS DEL HERPES [HERPES SIMPLE]",
    "sexo": "A"
  },
  {
    "cod_dx": "A601",
    "nombre_dx": "A601-INFECCION DE LA PIEL PERIANAL Y RECTO POR VIRUS DEL HERPES SIMPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A609",
    "nombre_dx": "A609-INFECCION ANOGENITAL POR VIRUS DEL HERPES SIMPLE, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A630",
    "nombre_dx": "A630-VERRUGAS (VENEREAS) ANOGENITALES",
    "sexo": "A"
  },
  {
    "cod_dx": "A638",
    "nombre_dx": "A638-OTRAS ENFERMEDADES DE TRANSMISIÓN PREDOMINANTEMENTE SEXUAL, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A64X",
    "nombre_dx": "A64X-ENFERMEDADDE TRANSMISION SEXUAL NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A65X",
    "nombre_dx": "A65X-SIFILIS NO VENEREA",
    "sexo": "A"
  },
  {
    "cod_dx": "A660",
    "nombre_dx": "A660-LESIONES INICIALES DE FRAMBESIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A661",
    "nombre_dx": "A661-LESIONES PAPILOMATOSAS MULTIPLES Y FRAMBESIA CON PASO DE CANGREJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A662",
    "nombre_dx": "A662-OTRAS LESIONES PRECOCES DE LA PIEL EN LA FRAMBESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "A663",
    "nombre_dx": "A663-HIPERQUERATOSIS DE FRAMBESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "A664",
    "nombre_dx": "A664-GOMA Y ULCERAS DE FRAMBESIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A665",
    "nombre_dx": "A665-GANGOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A666",
    "nombre_dx": "A666-LESIONES FRAMBESICAS DE LOS HUESOS Y DE LAS ARTICULACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "A667",
    "nombre_dx": "A667-OTRAS MANIFESTACIONES DE FRAMBESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "A668",
    "nombre_dx": "A668-FRAMBESIA LATENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A669",
    "nombre_dx": "A669-FRAMBESIA , NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A670",
    "nombre_dx": "A670-LESIONES PRIMARIAS DE LA PINTA",
    "sexo": "A"
  },
  {
    "cod_dx": "A671",
    "nombre_dx": "A671-LESIONE INTERMEDIAS DE LA PINTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A672",
    "nombre_dx": "A672-LESIONES TARDIAS DE LA PINTA",
    "sexo": "A"
  },
  {
    "cod_dx": "A673",
    "nombre_dx": "A673-LESIONES MIXTAS DE LA PINTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A679",
    "nombre_dx": "A679-PINTA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A680",
    "nombre_dx": "A680-FIEBRE RECURRENTE TRANSMITIDA POR PIOJOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A681",
    "nombre_dx": "A681-FIEBRE RECURRENTE TRANSMITIDA POR GARRAPATAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A689",
    "nombre_dx": "A689-FIEBRE RECURRENTE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A690",
    "nombre_dx": "A690-ESTOMATITIS ULCERATIVA NECROTIZANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A691",
    "nombre_dx": "A691-OTRAS INFECCIONES DE VICENT ",
    "sexo": "A"
  },
  {
    "cod_dx": "A692",
    "nombre_dx": "A692-ENFERMEDAD DE LYME",
    "sexo": "A"
  },
  {
    "cod_dx": "A698",
    "nombre_dx": "A698-OTRAS INFECCIONES ESPECIFICADAS POR ESPIROQUETAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A699",
    "nombre_dx": "A699-INFECCION POR ESPIROQUETA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A70X",
    "nombre_dx": "A70X-INFECCION DEBIDA A CHLAMYDIAPSITTACI",
    "sexo": "A"
  },
  {
    "cod_dx": "A710",
    "nombre_dx": "A710-ESTADO INICIAL DE TRACOMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A711",
    "nombre_dx": "A711-ESTADO ACTIVO DE TRACOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "A719",
    "nombre_dx": "A719-TRACOMA, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A740",
    "nombre_dx": "A740-CONJUNTIVITIS POR CLAMIDIAS (H13.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "A748",
    "nombre_dx": "A748-OTRAS ENFERMEDADES POR CLAMIDIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A749",
    "nombre_dx": "A749-INFECCION POR CLAMIDIAS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A750",
    "nombre_dx": "A750-TIFUS EPIDEMICO DEBIDO A RICKETTSIA PROWAZEKII TRANSMITIDO POR PIOJOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A751",
    "nombre_dx": "A751-TIFUS RECRUDESCENTE [ENFERMEDAD DE BRILL] ",
    "sexo": "A"
  },
  {
    "cod_dx": "A752",
    "nombre_dx": "A752-TIFUS DEBIDOA RICKETTSIA TYPHI",
    "sexo": "A"
  },
  {
    "cod_dx": "A753",
    "nombre_dx": "A753-TIFUS DEBIDO ARICKETTSIA TSUTSUGAMUSHI",
    "sexo": "A"
  },
  {
    "cod_dx": "A759",
    "nombre_dx": "A759-TIFUS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "A770",
    "nombre_dx": "A770-FIEBRE MACULOSA DEBIDO A RICKETTSIA RICKETTSII",
    "sexo": "A"
  },
  {
    "cod_dx": "A771",
    "nombre_dx": "A771-FIEBRE MACULOSA DEBIDO A RICKETTSIA CONORII ",
    "sexo": "A"
  },
  {
    "cod_dx": "A772",
    "nombre_dx": "A772-FIEBRE MACULOSA DEBIDO A RICKETTSIA SIBERICA",
    "sexo": "A"
  },
  {
    "cod_dx": "A773",
    "nombre_dx": "A773-FIEBRE MACULOSA DEBIDO A RICKETTSIAAUSTRALIS",
    "sexo": "A"
  },
  {
    "cod_dx": "A778",
    "nombre_dx": "A778-OTRAS FIEBRES MACULOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A779",
    "nombre_dx": "A779-FIEBRE MACULOSA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A78X",
    "nombre_dx": "A78X-FIEBRE Q",
    "sexo": "A"
  },
  {
    "cod_dx": "A790",
    "nombre_dx": "A790-FIEBRE DE LAS TRINCHERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A791",
    "nombre_dx": "A791-RICKETTSIOSIS PUSTULOSA DEBIDA A RICKETTSIA AKARI ",
    "sexo": "A"
  },
  {
    "cod_dx": "A798",
    "nombre_dx": "A798-OTRAS RICKETTSIOSIS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A799",
    "nombre_dx": "A799-RICKETTSIOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A800",
    "nombre_dx": "A800-POLIOMIELITIS AGUDA PARALITICA, ASOCIADA A VACUNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A801",
    "nombre_dx": "A801-POLIOMIELITIS AGUDA PARALITICA DEBIDA A VIRUS SALVAJE IMPORTADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A802",
    "nombre_dx": "A802-POLIOMIELITIS AGUDA PARALITICA DEBIDA A VIRUS SALVAJE AUTOCTONO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A803",
    "nombre_dx": "A803-OTRAS POLIOMIELITIS AGUDAS PARALITICAS, Y NO LASESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A804",
    "nombre_dx": "A804-POLIOMIELITIS AGUDA NO PARALITICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A809",
    "nombre_dx": "A809-POLIOMIELITIS AGUDA, SIN OTRA ESPECIFICACIÓN",
    "sexo": "A"
  },
  {
    "cod_dx": "A810",
    "nombre_dx": "A810-ENFERMEDAD DE CREUTZFELDT-JAKOB ",
    "sexo": "A"
  },
  {
    "cod_dx": "A811",
    "nombre_dx": "A811-PANENCEFALITIS ESCLEROSANTE SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "A812",
    "nombre_dx": "A812-LEUCOENCEFALOPATIA MULTIFOCAL PROGRESIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "A818",
    "nombre_dx": "A818-OTRAS INFECCIONES DEL SISTEMA NERVIOSO POR VIRUS ATIPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "A819",
    "nombre_dx": "A819-INFECCIONES DEL SISTEMA NERVIOSO CENTRAL POR VIRUS ATIPICO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A820",
    "nombre_dx": "A820-RABIA SELVATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A821",
    "nombre_dx": "A821-RABIA URBANA",
    "sexo": "A"
  },
  {
    "cod_dx": "A829",
    "nombre_dx": "A829-RABIA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A830",
    "nombre_dx": "A830-ENCEFALITIS JAPONESA",
    "sexo": "A"
  },
  {
    "cod_dx": "A831",
    "nombre_dx": "A831-ENCEFALITIS EQUINA DEL OESTE",
    "sexo": "A"
  },
  {
    "cod_dx": "A832",
    "nombre_dx": "A832-ENCEFALITIS EQUINA DEL ESTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A833",
    "nombre_dx": "A833-ENCEFALITIS DE SAN LUIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A834",
    "nombre_dx": "A834-ENCEFALITIS AUSTRALIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A835",
    "nombre_dx": "A835-ENCEFALITIS DE CALIFORNIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A836",
    "nombre_dx": "A836-ENFERMEDAD POR VIRUS ROCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "A838",
    "nombre_dx": "A838-OTRAS ENCEFALITIS VIRALES TRANSMITIDAS POR MOSQUITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A839",
    "nombre_dx": "A839-ENCEFALITIS VIRAL TRANSMITIDA POR MOSQUITOS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A840",
    "nombre_dx": "A840-ENCEFALITIS DEL LEJANO ORIENTE TRANSMITIDA POR GARRAPATAS[ENCEFALITIS PRIMAVEROESTIVAL RUSA]",
    "sexo": "A"
  },
  {
    "cod_dx": "A841",
    "nombre_dx": "A841-ENCEFALITIS CENTROEUROPEA TRANSMITIDA POR GARRAPATAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A848",
    "nombre_dx": "A848-OTRAS ENCEFALITIS VIRALES TRANSMITIDAS POR GARRAPATAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A849",
    "nombre_dx": "A849-ENCEFALITIS VIRAL TRANSMITIDA POR GARRAPATAS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A850",
    "nombre_dx": "A850-ENCEFALITIS ENTEROVIRAL (G05.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "A851",
    "nombre_dx": "A851-ENCEFALITIS POR ADENOVIRUS (G05.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A852",
    "nombre_dx": "A852-ENCEFALITIS VIRAL TRANSMITIDA POR ARTROPODOS, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "A858",
    "nombre_dx": "A858-OTRAS ENCEFALITIS VIRALES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A86X",
    "nombre_dx": "A86X-ENCEFALITIS VIRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A870",
    "nombre_dx": "A870-MENINGITIS ENTEROVIRAL (G02.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A871",
    "nombre_dx": "A871-MENINGITIS DEBIDA A ADENOVIRUS (G02.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "A872",
    "nombre_dx": "A872-CORIOMENINGITIS LINFOCITICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A878",
    "nombre_dx": "A878-OTRAS MENINGITIS VIRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "A879",
    "nombre_dx": "A879-MENINGITIS VIRAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "A880",
    "nombre_dx": "A880-FIEBRE EXANTEMATICA ENTEROVIRAL [EXANTEMA DE BOSTON]",
    "sexo": "A"
  },
  {
    "cod_dx": "A881",
    "nombre_dx": "A881-VERTIGO EPIDEMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A888",
    "nombre_dx": "A888-OTRAS INFECCIONES VIRALES ESPECIFICADAS DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "A89X",
    "nombre_dx": "A89X-INFECCION VIRAL DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A920",
    "nombre_dx": "A920-ENFERMEDAD POR VIRUS CHIKUNGUNYA",
    "sexo": "A"
  },
  {
    "cod_dx": "A921",
    "nombre_dx": "A921-FIEBRE DE O´NYONG-NYONG ",
    "sexo": "A"
  },
  {
    "cod_dx": "A922",
    "nombre_dx": "A922-FIEBRE EQUINA VENEZOLANA",
    "sexo": "A"
  },
  {
    "cod_dx": "A923",
    "nombre_dx": "A923-Infección por virus del oeste del Nilo (antes ENFERMEDAD VIRAL DEL OESTE DEL NILO)",
    "sexo": "A"
  },
  {
    "cod_dx": "A924",
    "nombre_dx": "A924-FIEBRE DEL VALLE DEL RIFT ",
    "sexo": "A"
  },
  {
    "cod_dx": "A925",
    "nombre_dx": "A925-Enfermedad por virus Zika",
    "sexo": "A"
  },
  {
    "cod_dx": "A928",
    "nombre_dx": "A928-OTRAS FIEBRES VIRALES ESPECIFICADAS TRANSMITIDAS POR MOSQUITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "A929",
    "nombre_dx": "A929-FIEBRE VIRAL TRANSMITIDA POR MOSQUITO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A930",
    "nombre_dx": "A930-ENFERMEDAD POR VIRUS DE OROPOUCHE ",
    "sexo": "A"
  },
  {
    "cod_dx": "A931",
    "nombre_dx": "A931-FIEBRE TRANSMITIDA POR FLEBOTOMOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A932",
    "nombre_dx": "A932-FIEBRE DE COLORADO TRANSMITIDA POR GARRAPATAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A938",
    "nombre_dx": "A938-OTRAS FIEBRES VIRALES ESPECIFICADAS TRANSMITIDAS POR ANTROPODOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A94X",
    "nombre_dx": "A94X-FIEBRE VIRAL TRANSMITIDA POR ARTROPODOS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A950",
    "nombre_dx": "A950-FIEBRE AMARILLA SELVATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A951",
    "nombre_dx": "A951-FIEBRE AMARILLA URBANA",
    "sexo": "A"
  },
  {
    "cod_dx": "A959",
    "nombre_dx": "A959-FIEBRE AMARILLA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "A960",
    "nombre_dx": "A960-FIEBRE HEMORRAGICA DE JUNIN ",
    "sexo": "A"
  },
  {
    "cod_dx": "A961",
    "nombre_dx": "A961-FIEBRE HEMORRAGICA DE MACHUPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "A962",
    "nombre_dx": "A962-FIEBRE DE LASSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "A968",
    "nombre_dx": "A968-OTRAS FIEBRES HEMORRAGICAS POR ARENAVIRUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "A969",
    "nombre_dx": "A969-FIEBRE HEMORRAGICA POR ARENAVIRUS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "A970",
    "nombre_dx": "A970-Dengue sin signos de alarma",
    "sexo": "A"
  },
  {
    "cod_dx": "A971",
    "nombre_dx": "A971-Dengue con signos de alarma",
    "sexo": "A"
  },
  {
    "cod_dx": "A972",
    "nombre_dx": "A972-Dengue severo",
    "sexo": "A"
  },
  {
    "cod_dx": "A979",
    "nombre_dx": "A979-Dengue no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "A980",
    "nombre_dx": "A980-FIEBRE HEMORRAGICA DE CRIMEA-CONGO",
    "sexo": "A"
  },
  {
    "cod_dx": "A981",
    "nombre_dx": "A981-FIEBRE HEMORRAGICA DE OMSK",
    "sexo": "A"
  },
  {
    "cod_dx": "A982",
    "nombre_dx": "A982-ENFERMEDAD DE LA SELVA DE KYASANUR",
    "sexo": "A"
  },
  {
    "cod_dx": "A983",
    "nombre_dx": "A983-ENFERMEDAD POR EL VIRUS DE MARBURG",
    "sexo": "A"
  },
  {
    "cod_dx": "A984",
    "nombre_dx": "A984-ENFERMEDAD POR EL VIRUS DE EBOLA",
    "sexo": "A"
  },
  {
    "cod_dx": "A985",
    "nombre_dx": "A985-FIEBRES HEMORRAGICAS CON SINDROME RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "A988",
    "nombre_dx": "A988-OTRAS FIEBRES HEMORRAGICAS VIRALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "A99X",
    "nombre_dx": "A99X-FIEBRE VIRAL HEMORRAGICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B000",
    "nombre_dx": "B000-ECZEMA HERPETICO",
    "sexo": "A"
  },
  {
    "cod_dx": "B001",
    "nombre_dx": "B001-DERMATITIS VESICULAR HERPETICA",
    "sexo": "A"
  },
  {
    "cod_dx": "B002",
    "nombre_dx": "B002-GINGIVOESTOMATITIS Y FARINGOAMIGDALITIS HERPETICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B003",
    "nombre_dx": "B003-MENINGITIS HERPETICA (G02.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B004",
    "nombre_dx": "B004-ENCEFALITIS HERPETICA (G05.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B005",
    "nombre_dx": "B005-OCULOPATICA HERPETICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B007",
    "nombre_dx": "B007-ENFERMEDAD HERPETICA DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B008",
    "nombre_dx": "B008-OTRAS FORMAS DE INFECCIONES HERPETICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B009",
    "nombre_dx": "B009-INFECCION DEBIDA A EL VIRUSDEL HERPES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B010",
    "nombre_dx": "B010-MENINGITIS DEBIDA A LA VARICELA (G02.0*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B011",
    "nombre_dx": "B011-ENCEFALITIS DEBIDA A LA VARICELA (G05.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B012",
    "nombre_dx": "B012-NEUMONIA DEBIDA A LA VARICELA (J17.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B018",
    "nombre_dx": "B018-VARICELA CON OTRAS COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B019",
    "nombre_dx": "B019-VARICELA SIN COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B020",
    "nombre_dx": "B020-ENCEFALITIS DEBIDA A HERPES ZOSTER (G05.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B021",
    "nombre_dx": "B021-MININGITIS DEBIDA A HERPES ZOSTER (G02.0*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B022",
    "nombre_dx": "B022-HERPES ZOSTER CON OTROS COMPROMISOS DEL SISTEMA NERVIOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "B023",
    "nombre_dx": "B023-HERPES ZOSTER OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "B027",
    "nombre_dx": "B027-HERPES ZOSTER DISEMINADO",
    "sexo": "A"
  },
  {
    "cod_dx": "B028",
    "nombre_dx": "B028-HERPES ZOSTER CON OTRAS COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B029",
    "nombre_dx": "B029-HERPES ZOSTER SIN COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B03X",
    "nombre_dx": "B03X-VIRUELA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B04X",
    "nombre_dx": "B04X-VIRUELA DE LOS MONOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B050",
    "nombre_dx": "B050-SARAMPION COMPLICADO CON ENCEFALITIS (G05.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B051",
    "nombre_dx": "B051-SARAMPION COMPLICADO CON MENINGITIS (G02.0*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B052",
    "nombre_dx": "B052-SARAMPION COMPLICADO CON NEUMONIA (J17.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B053",
    "nombre_dx": "B053-SARAMPION COMPLICADO CON OTITIS MEDIA (H67.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B054",
    "nombre_dx": "B054-SARAMPION CON COMPLICACIONES INTESTINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B058",
    "nombre_dx": "B058-SARAMPION CON OTRAS COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B059",
    "nombre_dx": "B059-SARAMPION SIN COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B060",
    "nombre_dx": "B060-RUBEOLA CON COMPLICACIONES NEUROLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B068",
    "nombre_dx": "B068-RUBEOLA CON OTRAS COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B069",
    "nombre_dx": "B069-RUBEOLA SIN COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B07X",
    "nombre_dx": "B07X-VERRUGAS VIRICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B080",
    "nombre_dx": "B080-OTRAS INFECCIONES DEBIDAS A ORTOPOXVIRUS",
    "sexo": "A"
  },
  {
    "cod_dx": "B081",
    "nombre_dx": "B081-MOLUSCO CONTAGIOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "B082",
    "nombre_dx": "B082-EXANTEMA SUBITO [SEXTA ENFERMEDAD]",
    "sexo": "A"
  },
  {
    "cod_dx": "B083",
    "nombre_dx": "B083-ERITEMA INFECCIOSO [QUINTA ENFERMEDAD]",
    "sexo": "A"
  },
  {
    "cod_dx": "B084",
    "nombre_dx": "B084-ESTOMATITIS VESICULAR ENTEROVIRAL CON EXANTEMA",
    "sexo": "A"
  },
  {
    "cod_dx": "B085",
    "nombre_dx": "B085-FARINGITIS VESICULAR ENTEROVIRICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B088",
    "nombre_dx": "B088-OTRAS INFECCIONES VIRALES ESPECIFICADAS, CARACTERIZADAS POR LESIONES DE LA PIEL Y DE LAS MEMBRANAS M",
    "sexo": "A"
  },
  {
    "cod_dx": "B09X",
    "nombre_dx": "B09X-INFECCION VIRAL NO ESPECIFICADA, CARACTERIZADA POR LESIONES DE LA PIEL Y DE LAS MEMBRANAS MUCOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B150",
    "nombre_dx": "B150-HEPATITIS AGUDA TIPO A, SIN COMA HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B159",
    "nombre_dx": "B159-HEPATITIS AGUDA TIPO A, CON COMA HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B160",
    "nombre_dx": "B160-HEPATITIS AGUDA TIPO B, CON AGENTE DELTA (COINFECCION). CON COMA HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B161",
    "nombre_dx": "B161-HEPATITIS AGUDA TIPO B, CON AGENTE DELTA (COINFECCION), SIN COMA HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B162",
    "nombre_dx": "B162-HEPATITIS AGUDA TIPO B, SIN AGENTE DELTA, CON COMA HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B169",
    "nombre_dx": "B169-HEPATITIS AGUDA TIPO B, SIN AGENTE DELTA Y SIN COMA HEPATICO",
    "sexo": "A"
  },
  {
    "cod_dx": "B170",
    "nombre_dx": "B170-Infeccion (superinfeccion) aguda por agente delta en la hepatitis B cronica",
    "sexo": "A"
  },
  {
    "cod_dx": "B171",
    "nombre_dx": "B171-HEPATITIS AGUDA TIPOC ",
    "sexo": "A"
  },
  {
    "cod_dx": "B172",
    "nombre_dx": "B172-HEPATITIS AGUDA TIPO E",
    "sexo": "A"
  },
  {
    "cod_dx": "B178",
    "nombre_dx": "B178-OTRAS HEPATITIS VIRALES AGUDAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B179",
    "nombre_dx": "B179-Hepatitis viral aguda no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "B180",
    "nombre_dx": "B180-HEPATITIS VIRAL TIPO B CRONICA, CON AGENTE DELTA",
    "sexo": "A"
  },
  {
    "cod_dx": "B181",
    "nombre_dx": "B181-HEPATITIS VIRAL TIPO B CRONICA, SIN AGENTE DELTA",
    "sexo": "A"
  },
  {
    "cod_dx": "B182",
    "nombre_dx": "B182-HEPATITIS VIRAL TIPO C CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "B188",
    "nombre_dx": "B188-OTRAS HEPATITIS VIRALES CRONICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B189",
    "nombre_dx": "B189-HEPATITIS VIRAL CRONICA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B190",
    "nombre_dx": "B190-Hepatitis viral no especificada con coma hepático",
    "sexo": "A"
  },
  {
    "cod_dx": "B199",
    "nombre_dx": "B199-Hepatitis viral no especificada sin coma hepático",
    "sexo": "A"
  },
  {
    "cod_dx": "B200",
    "nombre_dx": "B200-ENFERMEDAD POR EL VIH, RESULTANTE EN INFECCION POR MICOBACTERIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B201",
    "nombre_dx": "B201-ENFERMEDAD POR EL VIH, RESULTANTE EN OTRAS INFECCIONES BACTERIANAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B202",
    "nombre_dx": "B202-ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDAD POR CITOMEGALOVIRUS",
    "sexo": "A"
  },
  {
    "cod_dx": "B203",
    "nombre_dx": "B203-ENFERMEDAD POR VIH, RESULTANTE EN OTRAS INFECCIONES VIRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B204",
    "nombre_dx": "B204-ENFERMEDAD POR VIH, RESULTANTE EN CANDIDIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B205",
    "nombre_dx": "B205-ENFERMEDAD POR VIH, RESULTANTE EN OTRAS MICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B206",
    "nombre_dx": "B206-ENFERMEDAD POR VIH, RESULTANTE EN NEUMONIA POR PNEUMOCYSTIS CARINII ",
    "sexo": "A"
  },
  {
    "cod_dx": "B207",
    "nombre_dx": "B207-ENFERMEDAD POR VIH, RESULTANTE EN INFECCIONES MULTIPLES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B208",
    "nombre_dx": "B208-ENFERMEDAD POR VIH, RESULTANTE EN OTRAS ENFERMEDADES INFECCIOSAS O PARASITARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B209",
    "nombre_dx": "B209-ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDAD INFECCIOSA O PARASITARIA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B210",
    "nombre_dx": "B210-ENFERMEDAD POR VIH, RESULTANTE EN SARCOMA DE KAPOSI ",
    "sexo": "A"
  },
  {
    "cod_dx": "B211",
    "nombre_dx": "B211-ENFERMEDAD POR VIH, RESULTANTE EN LINFOMA DE BURKITT",
    "sexo": "A"
  },
  {
    "cod_dx": "B212",
    "nombre_dx": "B212-ENFERMEDAD POR VIH, RESULTANTE EN OTROS TIPOS DE LINFOMA NO HODGKIN ",
    "sexo": "A"
  },
  {
    "cod_dx": "B213",
    "nombre_dx": "B213-ENFERMEDAD POR VIH, RESULTANTE EN OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJID",
    "sexo": "A"
  },
  {
    "cod_dx": "B217",
    "nombre_dx": "B217-ENFERMEDAD POR VIH, RESULTANTE EN TUMORES MALIGNOS MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "B218",
    "nombre_dx": "B218-ENFERMEDAD POR VIH, RESULTANTE EN OTROS TUMORES MALIGNOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B219",
    "nombre_dx": "B219-ENFERMEDAD POR VIH, RESULTANTE EN TUMORES MALIGNOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B220",
    "nombre_dx": "B220-ENFERMEDAD POR VIH, RESULTANTE EN ENCEFALOPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B221",
    "nombre_dx": "B221-ENFERMEDAD POR VIH, RESULTANTE EN NEUMONITIS LINFOIDE INTERSTICIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B222",
    "nombre_dx": "B222-ENFERMEDAD POR VIH, RESULTANTE EN SINDROME CAQUECTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B227",
    "nombre_dx": "B227-ENFERMEDAD POR VIH, RESULTANTE EN ENFERMEDADES MULTIPLES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "B230",
    "nombre_dx": "B230-SINDROME DE INFECCION AGUDA DEBIDA A VIH",
    "sexo": "A"
  },
  {
    "cod_dx": "B231",
    "nombre_dx": "B231-ENFERMEDAD POR VIH, RESULTANTE EN LINFADENOPATIA GENERALIZADA (PERSISTENTE) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B232",
    "nombre_dx": "B232-ENFERMEDAD POR VIH, RESULTANTE EN ANORMALIDADES INMUNOLOGICAS Y HEMATOLOGICAS, NO CLASIFICADAS EN OT",
    "sexo": "A"
  },
  {
    "cod_dx": "B238",
    "nombre_dx": "B238-ENFERMEDAD POR VIH, RESULTANTE EN OTRAS AFECCIONES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B24X",
    "nombre_dx": "B24X-ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA (VIH), SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B250",
    "nombre_dx": "B250-NEUMONITISDEBIDA A VIRUS CITOMEGALICO (J17.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B251",
    "nombre_dx": "B251-HEPATITIS DEBIDA A VIRUS CITOMEGALICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B252",
    "nombre_dx": "B252-PANCREATITIS DEBIDA A VIRUS CITOMEGALICO",
    "sexo": "A"
  },
  {
    "cod_dx": "B258",
    "nombre_dx": "B258-OTRAS ENFERMEDADES DEBIDAS A VIRUS CITOMEGALICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B259",
    "nombre_dx": "B259-ENFERMEDAD POR VIRUS CITOMEGALICO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B260",
    "nombre_dx": "B260-ORQUITIS POR PAROTIDITIS (N51.1*) ",
    "sexo": "M"
  },
  {
    "cod_dx": "B261",
    "nombre_dx": "B261-MENINGITIS POR PAROTIDITIS (G02.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B262",
    "nombre_dx": "B262-ENCEFALITIS POR PAROTIDITIS (G05.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B263",
    "nombre_dx": "B263-PANCREATITIS POR PAROTIDITIS (K87.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B268",
    "nombre_dx": "B268-PAROTIDITIS INFECCIOSA CON OTRAS COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B269",
    "nombre_dx": "B269-PAROTIDITIS, SIN COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B270",
    "nombre_dx": "B270-MONONUCLEOSIS DEBIDA A HERPES VIRUS GAMMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B271",
    "nombre_dx": "B271-MONONUCLEOSIS POR CITOMEGALOVIRUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B278",
    "nombre_dx": "B278-OTRAS MONONUCLEOSIS INFECCIOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B279",
    "nombre_dx": "B279-MONONUCLEOSIS INFECCIOSA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B300",
    "nombre_dx": "B300-QUERATOCONJUNTIVITIS DEBIDA A ADENOVIRUS (H19.2*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B301",
    "nombre_dx": "B301-CONJUNTIVITIS DEBIDA A ADENOVIRUS (H13.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B302",
    "nombre_dx": "B302-FARINGOCONJUNTIVITIS VIRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B303",
    "nombre_dx": "B303-CONJUNTIVITIS EPIDEMICA AGUDA HEMORRAGICA (ENTEROVIRICA) (H13.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B308",
    "nombre_dx": "B308-OTRAS CONJUNTIVITIS VIRALES (H13.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B309",
    "nombre_dx": "B309-CONJUNTIVITIS VIRAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B330",
    "nombre_dx": "B330-MIALGIA EPIDEMICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B331",
    "nombre_dx": "B331-ENFERMEDAD DEL RIO ROSS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B332",
    "nombre_dx": "B332-CARDITIS VIRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B333",
    "nombre_dx": "B333-INFECCIONES DEBIDAS A RETROVIRUS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "B338",
    "nombre_dx": "B338-OTRAS ENFERMEDADES VIRALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B340",
    "nombre_dx": "B340-INFECCION DEBIDA A ADENOVIRUS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B341",
    "nombre_dx": "B341-INFECCION DEBIDA A ENTEROVIRUS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B342",
    "nombre_dx": "B342-INFECCION DEBIDA A CORONAVIRUS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B343",
    "nombre_dx": "B343-INFECCION DEBIDA A PARVOVIRUS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B344",
    "nombre_dx": "B344-INFECCION DEBIDA A PAPOVAVIRUS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B348",
    "nombre_dx": "B348-OTRAS INFECCIONES VIRALES DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "B349",
    "nombre_dx": "B349-INFECCION VIRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B350",
    "nombre_dx": "B350-TIÑA DE LA BARBA Y DEL CUERO CABELLUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "B351",
    "nombre_dx": "B351-TIÑA DE LAS UÑAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B352",
    "nombre_dx": "B352-TIÑA DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B353",
    "nombre_dx": "B353-TIÑA DEL PIE [TINEA PEDIS]",
    "sexo": "A"
  },
  {
    "cod_dx": "B354",
    "nombre_dx": "B354-TIÑA DEL CUERPO [TINEA CORPORIS]",
    "sexo": "A"
  },
  {
    "cod_dx": "B355",
    "nombre_dx": "B355-TIÑA IMBRICADA [TINEA IMBRICATA]",
    "sexo": "A"
  },
  {
    "cod_dx": "B356",
    "nombre_dx": "B356-TIÑA INGUINAL [TINEA CRURIS]",
    "sexo": "A"
  },
  {
    "cod_dx": "B358",
    "nombre_dx": "B358-OTRAS DERMATOFITOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B359",
    "nombre_dx": "B359-DERMATOFITOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B360",
    "nombre_dx": "B360-PITIRIASIS VERSICOLOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "B361",
    "nombre_dx": "B361-TIÑA NEGRA",
    "sexo": "A"
  },
  {
    "cod_dx": "B362",
    "nombre_dx": "B362-PIEDRA BLANCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B363",
    "nombre_dx": "B363-PIEDRA NEGRA",
    "sexo": "A"
  },
  {
    "cod_dx": "B368",
    "nombre_dx": "B368-OTRAS MICOSIS SUPERFICIALES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B369",
    "nombre_dx": "B369-MICOSIS SUPERFICIAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B370",
    "nombre_dx": "B370-ESTOMATITIS CANDIDIASICA",
    "sexo": "A"
  },
  {
    "cod_dx": "B371",
    "nombre_dx": "B371-CANDIDIASIS PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "B372",
    "nombre_dx": "B372-CANDIDIASIS DE LA PIEL Y DE LAS UÑAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B373",
    "nombre_dx": "B373-CANDIDIASIS DE LA VULVA Y DE LA VAGINA (N77.1*) ",
    "sexo": "F"
  },
  {
    "cod_dx": "B374",
    "nombre_dx": "B374-CANDIDIASIS DE OTRAS LOCALIZACIONES UROGENITALES",
    "sexo": "A"
  },
  {
    "cod_dx": "B375",
    "nombre_dx": "B375-MENINGITIS DEBIDA A CANDIDA (G02.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B376",
    "nombre_dx": "B376-ENDOCARDITIS DEBIDA A CANDIDA (I39.8*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B377",
    "nombre_dx": "B377-Sepsis debida a Candida",
    "sexo": "A"
  },
  {
    "cod_dx": "B378",
    "nombre_dx": "B378-CANDIDIASIS DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B379",
    "nombre_dx": "B379-CANDIDIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B380",
    "nombre_dx": "B380-COCCIDIOIDOMICOSIS PULMONAR AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B381",
    "nombre_dx": "B381-COCCIDIOIDOMICOSIS PULMONAR CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B382",
    "nombre_dx": "B382-COCCIDIOIDOMICOSIS PULMONAR, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B383",
    "nombre_dx": "B383-COCCIDIOIDOMICOSIS CUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "B384",
    "nombre_dx": "B384-MENINGITIS DEBIDA ACOCCIDIOIDOMICOSIS (G02.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B387",
    "nombre_dx": "B387-COCCIDIOIDOMICOSIS DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B388",
    "nombre_dx": "B388-OTRAS FORMAS DE COCCIDIOIDOMICOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B389",
    "nombre_dx": "B389-COCCIDIOIDOMICOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B390",
    "nombre_dx": "B390-INFECCION PULMONAR AGUDA DEBIDA A HISTOPLASMA CAPSULATUM",
    "sexo": "A"
  },
  {
    "cod_dx": "B391",
    "nombre_dx": "B391-INFECCION PULMONAR CRONICA DEBIDA A HISTOPLASMA CAPSULATUM",
    "sexo": "A"
  },
  {
    "cod_dx": "B392",
    "nombre_dx": "B392-INFECCION PULMONAR DEBIDA A HISTOPLASMA CAPSULATUM, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B393",
    "nombre_dx": "B393-INFECCION DISEMINADA DEBIDA A HISTOPLASMA CAPSULATUM",
    "sexo": "A"
  },
  {
    "cod_dx": "B394",
    "nombre_dx": "B394-HISTOPLASMOSIS DEBIDA A HISTOPLASMA CAPSULATUM, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B395",
    "nombre_dx": "B395-INFECCION DEBIDA AHISTOPLASMA DUBOISII",
    "sexo": "A"
  },
  {
    "cod_dx": "B399",
    "nombre_dx": "B399-HISTOPLASMOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B400",
    "nombre_dx": "B400-BLASTOMICOSIS PULMONAR AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "B401",
    "nombre_dx": "B401-BLASTOMICOSIS PULMONAR CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "B402",
    "nombre_dx": "B402-BLASTOMICOSIS PULMONAR, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B403",
    "nombre_dx": "B403-BLASTOMICOSIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B407",
    "nombre_dx": "B407-BLASTOMICOSIS DISEMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B408",
    "nombre_dx": "B408-OTRAS FORMAS DE BLASTOMICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B409",
    "nombre_dx": "B409-BLASTOMICOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B410",
    "nombre_dx": "B410-PARACOCCIDIOIDOMICOSIS PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "B417",
    "nombre_dx": "B417-PARACOCCIDIOIDOMICOSIS DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B418",
    "nombre_dx": "B418-OTRAS FORMAS PARACOCCIDIOIDOMICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B419",
    "nombre_dx": "B419-PARACOCCIDIOIDOMICOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B420",
    "nombre_dx": "B420-ESPOROTRICOSIS PULMONAR (J99.8*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B421",
    "nombre_dx": "B421-ESPOROTRICOSIS LINFOCUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B427",
    "nombre_dx": "B427-ESPOROTRICOSIS DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B428",
    "nombre_dx": "B428-OTRAS FORMAS DE ESPOROTRICOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B429",
    "nombre_dx": "B429-ESPOROTRICOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B430",
    "nombre_dx": "B430-CROMOMICOSIS CUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "B431",
    "nombre_dx": "B431-ABSCESO CEREBRAL FEOMICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "B432",
    "nombre_dx": "B432-ABSCESO Y QUISTE SUBCUTANEO FEOMICOTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B438",
    "nombre_dx": "B438-OTRAS FORMAS DE CROMOMICOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B439",
    "nombre_dx": "B439-CROMOMICOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B440",
    "nombre_dx": "B440-ASPERGILOSIS PULMONAR INVASIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "B441",
    "nombre_dx": "B441-OTRAS ASPERGILOSIS PULMONARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B442",
    "nombre_dx": "B442-ASPERGILOSIS AMIGDALINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B447",
    "nombre_dx": "B447-ASPERGILOSIS DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B448",
    "nombre_dx": "B448-OTRAS FORMAS DE ASPERGILOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B449",
    "nombre_dx": "B449-ASPERGILOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B450",
    "nombre_dx": "B450-CRIPTOCOCOSIS PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "B451",
    "nombre_dx": "B451-CRIPTOCOCOSIS CEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B452",
    "nombre_dx": "B452-CRIPTOCOCOSIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B453",
    "nombre_dx": "B453-CRIPTOCOCOSIS OSEA",
    "sexo": "A"
  },
  {
    "cod_dx": "B457",
    "nombre_dx": "B457-CRIPTOCOCOSIS DISEMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B458",
    "nombre_dx": "B458-OTRAS FORMAS DE CRIPTOCOCOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B459",
    "nombre_dx": "B459-CRIPTOCOCOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B460",
    "nombre_dx": "B460-MUCORMICOSIS PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "B461",
    "nombre_dx": "B461-MUCORMICOSISRINOCEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B462",
    "nombre_dx": "B462-MUCORMICOSIS GASTROINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B463",
    "nombre_dx": "B463-MUCORMICOSIS CUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "B464",
    "nombre_dx": "B464-MUCORMICOSIS DISEMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B465",
    "nombre_dx": "B465-MUCORMICOSIS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B468",
    "nombre_dx": "B468-OTRAS CIGOMICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B469",
    "nombre_dx": "B469-CIGOMICOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B470",
    "nombre_dx": "B470-EUMICETOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "B471",
    "nombre_dx": "B471-ACTINOMICETOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "B479",
    "nombre_dx": "B479-MICETOMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B480",
    "nombre_dx": "B480-LOBOMICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B481",
    "nombre_dx": "B481-RINOSPORIDIOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B482",
    "nombre_dx": "B482-ALESQUERIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B483",
    "nombre_dx": "B483-GEOTRICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B484",
    "nombre_dx": "B484-PENICILOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B485",
    "nombre_dx": "B485-Neumocistosis",
    "sexo": "A"
  },
  {
    "cod_dx": "B487",
    "nombre_dx": "B487-MICOSIS OPORTUNISTAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B488",
    "nombre_dx": "B488-OTRAS MICOSIS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B49X",
    "nombre_dx": "B49X-MICOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B500",
    "nombre_dx": "B500-PALUDISMO DEBIDO A PLASMODIUM FALCIPARUM CON COMPLICACIONES CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "B508",
    "nombre_dx": "B508-OTRO PALUDISMO GRAVE Y COMPLICADO DEBIDO A PLASMODIUM FALCIPARUM",
    "sexo": "A"
  },
  {
    "cod_dx": "B509",
    "nombre_dx": "B509-PALUDISMO DEBIDO A PLASMODIUM FALCIPARUM, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B510",
    "nombre_dx": "B510-PALUDISMO DEBIDO A PLASMODIUM VIVAX CON RUPTURA ESPLENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B518",
    "nombre_dx": "B518-PALUDISMO DEBIDO A PLASMODIUM VIVAX CON OTRAS COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B519",
    "nombre_dx": "B519-PALUDISMO DEBIDO A PLASMODIUM VIVAX, SIN COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B520",
    "nombre_dx": "B520-PALUDISMO DEBIDO A PLASMODIUM MALARIAE CON NEFROPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B528",
    "nombre_dx": "B528-PALUDISMO DEBIDO A PLASMODIUM MALARIAE CON OTRAS COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B529",
    "nombre_dx": "B529-PALUDISMO DEBIDO A PLASMODIUM MALARIAE, SIN COMPLICACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "B530",
    "nombre_dx": "B530-PALUDISMO DEBIDO A PLASMODIUM AVALE ",
    "sexo": "A"
  },
  {
    "cod_dx": "B531",
    "nombre_dx": "B531-PALUDISMO DEBIDO A PLASMODIOS DE LOS SIMIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B538",
    "nombre_dx": "B538-OTROPALUDISMO CONFIRMADO PARASITOLOGICAMENTE, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "B54X",
    "nombre_dx": "B54X-PALUDISMO [MALARIA] NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B550",
    "nombre_dx": "B550-LEIISHMANIASIS VISCERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B551",
    "nombre_dx": "B551-LEISHMANIASIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B552",
    "nombre_dx": "B552-LEISHMANIASIS MUCOCUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B559",
    "nombre_dx": "B559-LEISHMANIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B560",
    "nombre_dx": "B560-TRIPANOSOMIASIS GAMBIENSE ",
    "sexo": "A"
  },
  {
    "cod_dx": "B561",
    "nombre_dx": "B561-TRIPANOSOMIASIS RHODESIENSE ",
    "sexo": "A"
  },
  {
    "cod_dx": "B569",
    "nombre_dx": "B569-TRIPANOSOMIASIS AFRICANA, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "B570",
    "nombre_dx": "B570-ENFERMEDAD DE CHAGAS AGUDA QUE AFECTA AL CORAZON (141.2*, 198.1*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B571",
    "nombre_dx": "B571-ENFERMEDAD DE CHAGAS AGUDA QUE NO AFECTA AL CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "B572",
    "nombre_dx": "B572-ENFERMEDAD DE CHAGAS (CRONICA)QUE AFECTAAL CORAZON (141.2*,198.1*)",
    "sexo": "A"
  },
  {
    "cod_dx": "B573",
    "nombre_dx": "B573-ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "B574",
    "nombre_dx": "B574-ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA AL SISTEMA NERVIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B575",
    "nombre_dx": "B575-ENFERMEDAD DE CHAGAS (CRONICA) QUE AFECTA OTROS ORGANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B580",
    "nombre_dx": "B580-OCULOPATIA DEBIDA A TOXOPLASMA",
    "sexo": "A"
  },
  {
    "cod_dx": "B581",
    "nombre_dx": "B581-HEPATITIS DEBIDAA TOXOPLASMA (K77.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B582",
    "nombre_dx": "B582-MENINGOENCEFALITIS DEBIDA A TOXOPLASMA (G05.2*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B583",
    "nombre_dx": "B583-TOXOPLASMOSIS PULMONAR (J17.3*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "B588",
    "nombre_dx": "B588-TOXOPLASMOSIS CON OTRO ORGANO AFECTADO",
    "sexo": "A"
  },
  {
    "cod_dx": "B589",
    "nombre_dx": "B589-TOXOPLASMOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B600",
    "nombre_dx": "B600-BABESIOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B601",
    "nombre_dx": "B601-ACANTAMEBIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B602",
    "nombre_dx": "B602-NAEGLERIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B608",
    "nombre_dx": "B608-OTRAS ENFERMEDADES ESPECIFICADAS DEBIDAS A PROTOZARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B64X",
    "nombre_dx": "B64X-ENFERMEDAD DEBIDA A PROTOZOARIOS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B650",
    "nombre_dx": "B650-ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA HAEMATOBIUM [ESQUISTOSOMIASIS URINARIA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "B651",
    "nombre_dx": "B651-ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA MANSONI [ESQUISTOSOMIASIS INTESTINAL] ",
    "sexo": "A"
  },
  {
    "cod_dx": "B652",
    "nombre_dx": "B652-ESQUISTOSOMIASIS DEBIDA A SCHISTOSOMA JAPONICUM ",
    "sexo": "A"
  },
  {
    "cod_dx": "B653",
    "nombre_dx": "B653-DERMATITIS POR CERCARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B658",
    "nombre_dx": "B658-OTRAS ESQUISTOSOMIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B659",
    "nombre_dx": "B659-ESQUISTOSOMIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B660",
    "nombre_dx": "B660-OPISTORQUIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B661",
    "nombre_dx": "B661-CLONORQUIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B662",
    "nombre_dx": "B662-DICROCOELIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B663",
    "nombre_dx": "B663-FASCIOLIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B664",
    "nombre_dx": "B664-PARAGONIMIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B665",
    "nombre_dx": "B665-FASCIOLOPSIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B668",
    "nombre_dx": "B668-OTRAS INFECCIONES ESPECIFICADAS DEBIDAS A TREMATODOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B669",
    "nombre_dx": "B669-INFECCION DEBIDA A TREMATODOS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B670",
    "nombre_dx": "B670-INFECCION DEL HIGADO DEBIDA A ECHINOCOCCUS GRANULOSUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B671",
    "nombre_dx": "B671-INFECCION DEL PULMONDEBIDA A ECHINOCOCCUS GRANULOSUS",
    "sexo": "A"
  },
  {
    "cod_dx": "B672",
    "nombre_dx": "B672-INFECCION DE HUESO DEBIDA A ECHINOCOCCUS GRANULOSUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B673",
    "nombre_dx": "B673-INFECCION DE OTRO ORGANO Y DE SITIOS MULTIPLES DEBIDA A ECHINOCOCCUS GRANULOSUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B674",
    "nombre_dx": "B674-INFECCION DEBIDAA ECHINOCOCCUS GRANULOSUS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B675",
    "nombre_dx": "B675-INFECCION DEL HIGADO DEBIDA A ECHINOCOCCUS MULTILOCULARIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B676",
    "nombre_dx": "B676-INFECCION DE OTRO ORGANO Y DE SITIOS MULTIPLES DEBIDA A ECHINOCOCCUS MULTILOCULARIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B677",
    "nombre_dx": "B677-INFECCION DEBIDA A ECHINOCOCCUS MULTILOCULARIS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B678",
    "nombre_dx": "B678-EQUINOCOCOSIS DEL HIGADO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B679",
    "nombre_dx": "B679-EQUINOCOCOSIS, OTRA Y LA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B680",
    "nombre_dx": "B680-TENIASIS DEBIDA A TAENIA SOLIUM ",
    "sexo": "A"
  },
  {
    "cod_dx": "B681",
    "nombre_dx": "B681-INFECCION DEBIDA A TAENIA SAGINATA",
    "sexo": "A"
  },
  {
    "cod_dx": "B689",
    "nombre_dx": "B689-TENIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B690",
    "nombre_dx": "B690-CISTICERCOSIS DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B691",
    "nombre_dx": "B691-CISTICERCOSIS DEL OJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "B698",
    "nombre_dx": "B698-CISTICERCOSIS DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B699",
    "nombre_dx": "B699-CISTICERCOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B700",
    "nombre_dx": "B700-DIFILOBOTRIASIS INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B701",
    "nombre_dx": "B701-ESPARGANOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B710",
    "nombre_dx": "B710-HIMENOLEPIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B711",
    "nombre_dx": "B711-DIPILIDIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B718",
    "nombre_dx": "B718-OTRAS INFECCIONES DEBIDAS A CESTODOS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B719",
    "nombre_dx": "B719-INFECCION DEBIDA A CESTODOS, NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B72X",
    "nombre_dx": "B72X-DRACONTIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B73X",
    "nombre_dx": "B73X-ONCOCERCOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B740",
    "nombre_dx": "B740-FILARIASIS DEBIDA A WUCHERERIA BANCROFTI",
    "sexo": "A"
  },
  {
    "cod_dx": "B741",
    "nombre_dx": "B741-FILARIASIS DEBIDA A BRUGIA MALAYI ",
    "sexo": "A"
  },
  {
    "cod_dx": "B742",
    "nombre_dx": "B742-FILARIASIS DEBIDA A BRUGIA TIMORI ",
    "sexo": "A"
  },
  {
    "cod_dx": "B743",
    "nombre_dx": "B743-LOAIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B744",
    "nombre_dx": "B744-MANSONELIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B748",
    "nombre_dx": "B748-OTRAS FILARIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B749",
    "nombre_dx": "B749-FILARIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B75X",
    "nombre_dx": "B75X-TRIQUINOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B760",
    "nombre_dx": "B760-ANQUILOSTOMIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B761",
    "nombre_dx": "B761-NECATORIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B768",
    "nombre_dx": "B768-OTRAS ENFERMEDADES DEBIDAS A ANQUILOSTOMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B769",
    "nombre_dx": "B769-ENFERMEDAD DEBIDA A ANQUILOSTOMAS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B770",
    "nombre_dx": "B770-ASCARIASIS CON COMPLICACIONES INTESTINALES",
    "sexo": "A"
  },
  {
    "cod_dx": "B778",
    "nombre_dx": "B778-ASCARIASIS CON OTRAS COMPLICACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B779",
    "nombre_dx": "B779-ASCARIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B780",
    "nombre_dx": "B780-ESTRONGILOIDIASIS INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B781",
    "nombre_dx": "B781-ESTRONGILOIDIASIS CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B787",
    "nombre_dx": "B787-ESTRONGILOIDIASIS DISEMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B789",
    "nombre_dx": "B789-ESTRONGILOIDIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B79X",
    "nombre_dx": "B79X-TRICURIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B80X",
    "nombre_dx": "B80X-ENTEROBIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B810",
    "nombre_dx": "B810-ANISAQUIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B811",
    "nombre_dx": "B811-CAPILARIASIS INTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B812",
    "nombre_dx": "B812-TRICOESTRONGILIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B813",
    "nombre_dx": "B813-ANGIOESTRONGILIASIS INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B814",
    "nombre_dx": "B814-HELMINTIASIS INTESTINAL MIXTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B818",
    "nombre_dx": "B818-OTRAS HELMINTIASIS INTESTINALES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B820",
    "nombre_dx": "B820-HELMINTIASIS INTESTINAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B829",
    "nombre_dx": "B829-PARASITOSIS INTESTINAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "B830",
    "nombre_dx": "B830-LARVA MIGRANS VISCERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B831",
    "nombre_dx": "B831-GNATOSTOMIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B832",
    "nombre_dx": "B832-ANGIOESTRONGILIASIS DEBIDA A PARASTRONGYLUS CANTONENSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B833",
    "nombre_dx": "B833-SINGAMIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B834",
    "nombre_dx": "B834-HIRUDINIASIS INTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "B838",
    "nombre_dx": "B838-OTRAS HELMINTIASIS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B839",
    "nombre_dx": "B839-HELMINTIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B850",
    "nombre_dx": "B850-PEDICULOSIS DEBIDA A PEDICULUS HUMANUS CAPITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B851",
    "nombre_dx": "B851-PEDICULOSIS DEBIDA A PEDICULUS HUMANUS CORPORIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B852",
    "nombre_dx": "B852-PEDICULOSIS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "B853",
    "nombre_dx": "B853-PHTHIRIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B854",
    "nombre_dx": "B854-PEDICULOSIS Y PHTHIRIASIS MIXTAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B86X",
    "nombre_dx": "B86X-ESCABIOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "B870",
    "nombre_dx": "B870-MIASIS CUTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "B871",
    "nombre_dx": "B871-MIASIS EN HERIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B872",
    "nombre_dx": "B872-MIASIS OCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "B873",
    "nombre_dx": "B873-MIASIS NASOFARINGEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B874",
    "nombre_dx": "B874-MIASIS AURAL",
    "sexo": "A"
  },
  {
    "cod_dx": "B878",
    "nombre_dx": "B878-MIASIS DE OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B879",
    "nombre_dx": "B879-MIASIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B880",
    "nombre_dx": "B880-OTRAS ACARIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B881",
    "nombre_dx": "B881-TUNGIASIS [INFECCION DEBIDA A PULGA DE ARENA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "B882",
    "nombre_dx": "B882-OTRAS INFESTACIONES DEBIDAS A ARTROPODOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B883",
    "nombre_dx": "B883-HIRUDINIASIS EXTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "B888",
    "nombre_dx": "B888-OTRAS INFESTACIONES ESPECIFICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B889",
    "nombre_dx": "B889-INFESTACION, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "B89X",
    "nombre_dx": "B89X-ENFERMEDAD PARASITARIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B900",
    "nombre_dx": "B900-SECUELAS DE TUBERCULOSIS DEL SISTEMA NERVIOSO CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B901",
    "nombre_dx": "B901-SECUELAS DE TUBERCULOSIS GENITOURINARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B902",
    "nombre_dx": "B902-SECUELAS DE TUBERCULOSIS DE HUESOS Y ARTICULACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "B908",
    "nombre_dx": "B908-SECUELAS DE TUBERCULOSIS DE OTROS ORGANOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B909",
    "nombre_dx": "B909-SECUELAS DE TUBERCULOSIS RESPIRATORIA Y DE TUBERCULOSIS NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B91X",
    "nombre_dx": "B91X-SECUELAS DE POLIOMIELITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B92X",
    "nombre_dx": "B92X-SECUELAS DE LEPRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B940",
    "nombre_dx": "B940-SECUELAS DE TRACOMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "B941",
    "nombre_dx": "B941-SECUELAS DE ENCEFALITIS VIRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B942",
    "nombre_dx": "B942-SECUELAS DE HEPATITIS VIRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "B948",
    "nombre_dx": "B948-SECUELAS DE OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B949",
    "nombre_dx": "B949-SECUELAS DE ENFERMEDADES INFECCIOSAS Y PARASITARIAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "B950",
    "nombre_dx": "B950-ESTREPTOCOCO, GRUPO A, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B951",
    "nombre_dx": "B951-ESTREPTOCOCO, GRUPO B, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B952",
    "nombre_dx": "B952-Estreptococo, grupo D y enterococos, como causa de enfermedades clasificadas en otros capitulos",
    "sexo": "A"
  },
  {
    "cod_dx": "B953",
    "nombre_dx": "B953-STREPTOCOCCUS PNEUMONIAE COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B954",
    "nombre_dx": "B954-OTROS STREPTOCOCOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B955",
    "nombre_dx": "B955-ESTREPTOCOCO NO ESPECIFICADO COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B956",
    "nombre_dx": "B956-STAPHYLOCOCCUS AUREUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B957",
    "nombre_dx": "B957-OTROS ESTAFILOCOCOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B958",
    "nombre_dx": "B958-ESTAFILOCOCO NO ESPECIFICADO, COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B960",
    "nombre_dx": "B960-MYCOPLASMA PNEUMONIAE [M. PNEUMONIAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B961",
    "nombre_dx": "B961-KLEBSIELLA PNEUMONIAE [K. PNEUMONIAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B962",
    "nombre_dx": "B962-ESCHERICHIA COLI [E. COLI] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B963",
    "nombre_dx": "B963-HAEMOPHILUS INFLUENZAE [H. INFLUENZAE] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B964",
    "nombre_dx": "B964-PROTEUS (MIRABILIS) (MORGANII) COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B965",
    "nombre_dx": "B965-Pseudomonas (aeruginosa) como causa de enfermedades clasificadas en otros capítulos",
    "sexo": "A"
  },
  {
    "cod_dx": "B966",
    "nombre_dx": "B966-BACILLUS FRAGILIS [B. FRAGILIS] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B967",
    "nombre_dx": "B967-CLOSTRIDIUM PERFRINGENS [C. PERFRINGENS] COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B968",
    "nombre_dx": "B968-OTROS AGENTES BACTERIANOS ESPECIFICADOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B96X",
    "nombre_dx": "B96X-Otros agentes bacterianos especificados como causa de enfermedades clasificadas en otros capítulos (antes OTROS AGENTES BACTERIANOS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS)",
    "sexo": "A"
  },
  {
    "cod_dx": "B970",
    "nombre_dx": "B970-ADENOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B971",
    "nombre_dx": "B971-ENTEROVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B972",
    "nombre_dx": "B972-CORONAVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B973",
    "nombre_dx": "B973-RETROVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B974",
    "nombre_dx": "B974-VIRUS SINCICIAL RESPIRATORIO COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B975",
    "nombre_dx": "B975-REOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B976",
    "nombre_dx": "B976-PARVOVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "B977",
    "nombre_dx": "B977-PAPILOMAVIRUS COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B978",
    "nombre_dx": "B978-OTROS AGENTES VIRALES COMO CAUSA DE ENFERMEDADES CLASIFICADAS EN OTROS CAPITULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "B980",
    "nombre_dx": "B980-Helicobacter pylori [H.pylori] como la causa de enfermedades clasificadas en otros capítulos",
    "sexo": "A"
  },
  {
    "cod_dx": "B981",
    "nombre_dx": "B981-Vibrio vulnificus como la causa de enfermedades clasificadas en otros capítulos",
    "sexo": "A"
  },
  {
    "cod_dx": "B99X",
    "nombre_dx": "B99X-OTRAS ENFERMEDADES INFECCIOSAS Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C000",
    "nombre_dx": "C000-TUMOR MALIGNO DEL LABIO SUPERIOR, CARA EXTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "C001",
    "nombre_dx": "C001-TUMOR MALIGNO DEL LABIO INFERIOR, CARA EXTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "C002",
    "nombre_dx": "C002-TUMOR MALIGNO DEL LABIO, CARA EXTERNA, SIN OTRA ESPECIFICACIÓN",
    "sexo": "A"
  },
  {
    "cod_dx": "C003",
    "nombre_dx": "C003-TUMOR MALIGNO DEL LABIO SUPERIOR, CARA INTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "C004",
    "nombre_dx": "C004-TUMOR MALIGNO DEL LABIO INFERIOR, CARA INTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "C005",
    "nombre_dx": "C005-TUMOR MALIGNO DEL LABIO, CARA INTERNA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C006",
    "nombre_dx": "C006-TUMOR MALIGNO DE LA COMISURA LABIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C008",
    "nombre_dx": "C008-LESION DE SITIOS CONTIGUOS DEL LABIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C009",
    "nombre_dx": "C009-TUMOR MALIGNO DEL LABIO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C01X",
    "nombre_dx": "C01X-TUMOR MALIGNO DE LA BASE DE LA LENGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C020",
    "nombre_dx": "C020-TUMOR MALIGNO DE LA CARA DORSAL DE LA LENGUA",
    "sexo": "A"
  },
  {
    "cod_dx": "C021",
    "nombre_dx": "C021-TUMOR MALIGNO DEL BORDE DE LA LENGUA",
    "sexo": "A"
  },
  {
    "cod_dx": "C022",
    "nombre_dx": "C022-TUMOR MALIGNO DE LA CARA VENTRAL DE LA LENGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C023",
    "nombre_dx": "C023-TUMOR MALIGNO DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C024",
    "nombre_dx": "C024-TUMOR MALIGNO DE LA AMIGDALA LINGUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C028",
    "nombre_dx": "C028-LESION DE SITIOS CONTIGUOS DE LA LENGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C029",
    "nombre_dx": "C029-TUMOR MALIGNO DE LA LENGUA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C030",
    "nombre_dx": "C030-TUMOR MALIGNO DE LA ENCIA SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C031",
    "nombre_dx": "C031-TUMOR MALIGNO DE LA ENCIA INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C039",
    "nombre_dx": "C039-TUMOR MALIGNO DE LA ENCIA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C040",
    "nombre_dx": "C040-TUMOR MALIGNO DE LA PARTE ANTERIOR DEL PISO DE LA BOCA",
    "sexo": "A"
  },
  {
    "cod_dx": "C041",
    "nombre_dx": "C041-TUMOR MALIGNO DE LA PARTE LATERAL DEL PISO DE LA BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C048",
    "nombre_dx": "C048-LESION DE SITIOS CONTIGUOS DEL PISO DE LA BOCA",
    "sexo": "A"
  },
  {
    "cod_dx": "C049",
    "nombre_dx": "C049-TUMOR MALIGNO DEL PISO DE LA BOCA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C050",
    "nombre_dx": "C050-TUMOR MALIGNO DEL PALADAR DURO",
    "sexo": "A"
  },
  {
    "cod_dx": "C051",
    "nombre_dx": "C051-TUMOR MALIGNO DEL PALADAR BLANDO",
    "sexo": "A"
  },
  {
    "cod_dx": "C052",
    "nombre_dx": "C052-TUMOR MALIGNO DE LA UVULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C058",
    "nombre_dx": "C058-LESION DE SITIOS CONTIGUOS DEL PALADAR",
    "sexo": "A"
  },
  {
    "cod_dx": "C059",
    "nombre_dx": "C059-TUMOR MALIGNO DEL PALADAR, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C060",
    "nombre_dx": "C060-TUMOR MALIGNO DE LA MUCOSA DE LA MEJILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "C061",
    "nombre_dx": "C061-TUMOR MALIGNO DEL VESTIBULO DE LA BOCA",
    "sexo": "A"
  },
  {
    "cod_dx": "C062",
    "nombre_dx": "C062-TUMOR MALIGNO DEL AREA RETROMOLAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C068",
    "nombre_dx": "C068-LESION DE SITIOS CONTIGUOS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C069",
    "nombre_dx": "C069-TUMOR MALIGNO DE LA BOCA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C07X",
    "nombre_dx": "C07X-TUMOR MALIGNO DE LA GLANDULA PAROTIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C080",
    "nombre_dx": "C080-TUMOR MALIGNO DE LA GLANDULA SUBMAXILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C081",
    "nombre_dx": "C081-TUMOR MALIGNO DE LA GLANDULA SUBLINGUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C088",
    "nombre_dx": "C088-LESION DE SITIOS CONTIGUOS DE LAS GLANDULAS SALIVALES MAYORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C089",
    "nombre_dx": "C089-TUMOR MALIGNO DE GLANDULA SALIVAL MAYOR, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C090",
    "nombre_dx": "C090-TUMOR MALIGNO DE LA FOSA AMIGDALINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C091",
    "nombre_dx": "C091-TUMOR MALIGNO DEL PILAR AMIGDALINO (ANTERIOR) (POSTERIOR) ",
    "sexo": "A"
  },
  {
    "cod_dx": "C098",
    "nombre_dx": "C098-LESION DE SITIOS CONTIGUOS DE LA AMIGDALA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C099",
    "nombre_dx": "C099-TUMOR MALIGNO DE LA AMIGDALA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C100",
    "nombre_dx": "C100-TUMOR MALIGNO DE LA VALECULA",
    "sexo": "A"
  },
  {
    "cod_dx": "C101",
    "nombre_dx": "C101-TUMOR MALIGNO DE LA CARA ANTERIOR DE LA EPIGLOTIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C102",
    "nombre_dx": "C102-TUMOR MALIGNO DE LA PARED LATERAL DE LA OROFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C103",
    "nombre_dx": "C103-TUMOR MALIGNO DE LA PARED POSTERIOR DE LA OROFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C104",
    "nombre_dx": "C104-TUMOR MALIGNO DE LA HENDIDURA BRANQUIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C108",
    "nombre_dx": "C108-LESION DE SITIOS CONTIGUOS DE LA OROFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C109",
    "nombre_dx": "C109-TUMOR MALIGNO DE LA OROFARINGE, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C110",
    "nombre_dx": "C110-TUMOR MALIGNO DE LA PARED SUPERIOR DE LA NASOFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C111",
    "nombre_dx": "C111-TUMOR MALIGNO DE LA PARED POSTERIOR DE LA NASOFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C112",
    "nombre_dx": "C112-TUMOR MALIGNO DE LA PARED LATERAL DE LA NASOFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C113",
    "nombre_dx": "C113-TUMOR MALIGNO DE LA PARED ANTERIOR DE LA NASOFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C118",
    "nombre_dx": "C118-LESION DE SITIOS CONTIGUOS DE LA NASOFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C119",
    "nombre_dx": "C119-TUMOR MALIGNO DE LA NASOFARINGE, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C12X",
    "nombre_dx": "C12X-TUMOR MALIGNO DEL SENO PIRIFORME",
    "sexo": "A"
  },
  {
    "cod_dx": "C130",
    "nombre_dx": "C130-TUMOR MALIGNO DE LA REGION POSTCRICOIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "C131",
    "nombre_dx": "C131-TUMOR MALIGNO DEL PLIEGUE ARITENOEPIGLOTICO, CARA HIPOFARINGEA",
    "sexo": "A"
  },
  {
    "cod_dx": "C132",
    "nombre_dx": "C132-TUMOR MALIGNO DE LA PARED POSTERIOR DE LA HIPOFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C138",
    "nombre_dx": "C138-LESION DE SITIOS CONTIGUOS DE LA HIPOFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C139",
    "nombre_dx": "C139-TUMOR MALIGNO DE LA HIPOFARINGE, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C140",
    "nombre_dx": "C140-TUMOR MALIGNO DE LA FARINGE, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C142",
    "nombre_dx": "C142-TUMOR MALIGNO DEL ANILLO DE WALDEYER",
    "sexo": "A"
  },
  {
    "cod_dx": "C148",
    "nombre_dx": "C148-LESION DE SITIOS CONTIGUOS DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C150",
    "nombre_dx": "C150-TUMOR MALIGNO DEL ESOFAGO, PORCION CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C151",
    "nombre_dx": "C151-TUMOR MALIGNO DEL ESOFAGO, PORCION TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C152",
    "nombre_dx": "C152-TUMOR MALIGNO DEL ESOFAGO, PORCION ABDOMINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C153",
    "nombre_dx": "C153-TUMOR MALIGNO DEL TERCIO SUPERIORDEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "C154",
    "nombre_dx": "C154-TUMOR MALIGNO DEL TERCIO MEDIO DEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "C155",
    "nombre_dx": "C155-TUMOR MALIGNO DEL TERCIO INFERIOR DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C158",
    "nombre_dx": "C158-LESION DE SITIOS CONTIGUOS DEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "C159",
    "nombre_dx": "C159-TUMOR MALIGNO DEL ESOFAGO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C160",
    "nombre_dx": "C160-TUMOR MALIGNO DEL CARDIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C161",
    "nombre_dx": "C161-TUMOR MALIGNO DEL FUNDUS GASTRICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C162",
    "nombre_dx": "C162-TUMOR MALIGNO DEL CUERPO DEL ESTOMAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C163",
    "nombre_dx": "C163-TUMOR MALIGNO DEL ANTRO PILORICO",
    "sexo": "A"
  },
  {
    "cod_dx": "C164",
    "nombre_dx": "C164-TUMOR MALIGNO DEL PILORO",
    "sexo": "A"
  },
  {
    "cod_dx": "C165",
    "nombre_dx": "C165-TUMOR MALIGNO DE LA CURVATURA MENOR DEL ESTOMAGO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C166",
    "nombre_dx": "C166-TUMOR MALIGNO DE LA CURVATURA MAYOR DEL ESTOMAGO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C168",
    "nombre_dx": "C168-LESION DE SITIOS CONTIGUOS DEL ESTOMAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C169",
    "nombre_dx": "C169-TUMOR MALIGNO DEL ESTOMAGO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C170",
    "nombre_dx": "C170-TUMOR MALIGNO DELDUODENO",
    "sexo": "A"
  },
  {
    "cod_dx": "C171",
    "nombre_dx": "C171-TUMOR MALIGNO DEL YEYUNO",
    "sexo": "A"
  },
  {
    "cod_dx": "C172",
    "nombre_dx": "C172-TUMOR MALIGNO DEL ILEON ",
    "sexo": "A"
  },
  {
    "cod_dx": "C173",
    "nombre_dx": "C173-TUMOR MALIGNO DEL DIVERTICULO DE MECKEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C178",
    "nombre_dx": "C178-TUMOR MALIGNO DEL LESION DE SITIOS CONTIGUOS DEL INTESTINO DELGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C179",
    "nombre_dx": "C179-TUMOR MALIGNO DEL INTESTINO DELGADO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C180",
    "nombre_dx": "C180-TUMOR MALIGNO DEL CIEGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C181",
    "nombre_dx": "C181-TUMOR MALIGNO DEL APENDICE",
    "sexo": "A"
  },
  {
    "cod_dx": "C182",
    "nombre_dx": "C182-TUMOR MALIGNO DEL COLON ASCENDENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "C183",
    "nombre_dx": "C183-TUMOR MALIGNO DEL ANGULO HEPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C184",
    "nombre_dx": "C184-TUMOR MALIGNO DEL COLON TRANSVERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "C185",
    "nombre_dx": "C185-TUMOR MALIGNO DEL ANGULO ESPLENICO",
    "sexo": "A"
  },
  {
    "cod_dx": "C186",
    "nombre_dx": "C186-TUMOR MALIGNO DEL COLON DESCENDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "C187",
    "nombre_dx": "C187-TUMOR MALIGNO DEL COLON SIGMOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "C188",
    "nombre_dx": "C188-LESION DE SITIOS CONTIGUOS DEL COLON",
    "sexo": "A"
  },
  {
    "cod_dx": "C189",
    "nombre_dx": "C189-TUMOR MALIGNO DEL COLON, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C19X",
    "nombre_dx": "C19X-TUMOR MALIGNO DE LA UNION RECTOSIGMOIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "C20X",
    "nombre_dx": "C20X-TUMOR MALIGNO DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C210",
    "nombre_dx": "C210-TUMOR MALIGNO DEL ANO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C211",
    "nombre_dx": "C211-TUMOR MALIGNO DEL CONDUCTO ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C212",
    "nombre_dx": "C212-TUMOR MALIGNO DE LA ZONA CLOACOGENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C218",
    "nombre_dx": "C218-LESION DE SITIOS CONTIGUOS DEL ANO, DEL CONDUCTO ANAL Y DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C220",
    "nombre_dx": "C220-CARCINOMA DE CELULAS HEPATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "C221",
    "nombre_dx": "C221-CARCINOMA DE VIAS BILIARES INTRAHEPATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C222",
    "nombre_dx": "C222-HEPATOBLASTOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "C223",
    "nombre_dx": "C223-ANGIOSARCOMA DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C224",
    "nombre_dx": "C224-OTROS SARCOMAS DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C227",
    "nombre_dx": "C227-OTROS CARCINOMAS ESPECIFICADOS DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C229",
    "nombre_dx": "C229-TUMOR MALIGNO DEL HIGADO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C23X",
    "nombre_dx": "C23X-TUMOR MALIGNO DE LA VESICULA BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C240",
    "nombre_dx": "C240-TUMOR MALIGNO D E LAS VIAS BILIARES EXTRAHEPATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "C241",
    "nombre_dx": "C241-TUMOR MALIGNO DE LA AMPOLLA DE VATER",
    "sexo": "A"
  },
  {
    "cod_dx": "C248",
    "nombre_dx": "C248-LESION DE SITIOS CONTIGUOS DE LAS VIAS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C249",
    "nombre_dx": "C249-TUMOR MALIGNO DE LAS VIAS BILIARES, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C250",
    "nombre_dx": "C250-TUMOR MALIGNO DE LA CABEZA DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C251",
    "nombre_dx": "C251-TUMOR MALIGNO DEL CUERPO DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C252",
    "nombre_dx": "C252-TUMOR MALIGNO DE LA COLA DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C253",
    "nombre_dx": "C253-TUMOR MALIGNO DEL CONDUCTO PANCREATICO",
    "sexo": "A"
  },
  {
    "cod_dx": "C254",
    "nombre_dx": "C254-TUMOR MALIGNO DEL PANCREAS ENDOCRINO",
    "sexo": "A"
  },
  {
    "cod_dx": "C257",
    "nombre_dx": "C257-TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DEL PANCREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "C258",
    "nombre_dx": "C258-LESION DE SITIOS CONTIGUOS DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C259",
    "nombre_dx": "C259-TUMOR MALIGNO DEL PANCREAS, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C260",
    "nombre_dx": "C260-TUMOR MALIGNO DEL INTESTINO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C261",
    "nombre_dx": "C261-TUMOR MALIGNO DEL BAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "C268",
    "nombre_dx": "C268-LESION DE SITIOS CONTIGUOS DE LOS ORGANOS DIGESTIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C269",
    "nombre_dx": "C269-TUMOR MALIGNO DE SITIOS MAL DEFINIDOS DE LOS ORGANOS DIGESTIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C300",
    "nombre_dx": "C300-TUMOR MALIGNO DE LA FOSA NASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C301",
    "nombre_dx": "C301-TUMOR MALIGNO DEL OIDO MEDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C310",
    "nombre_dx": "C310-TUMOR MALIGNO DEL SENO MAXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "C311",
    "nombre_dx": "C311-TUMOR MALIGNO DEL SENO ETMOIDAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C312",
    "nombre_dx": "C312-TUMOR MALIGNO DEL SENO FRONTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C313",
    "nombre_dx": "C313-TUMOR MALIGNO DEL SENO ESFENOIDAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C318",
    "nombre_dx": "C318-LESION DE SITIOS CONTIGUOS DE LOS SENOS PARANASALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C319",
    "nombre_dx": "C319-TUMOR MALIGNO DEL SENO PARANASAL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C320",
    "nombre_dx": "C320-TUMOR MALIGNO DE LA GLOTIS",
    "sexo": "A"
  },
  {
    "cod_dx": "C321",
    "nombre_dx": "C321-TUMOR MALIGNO DE LA REGION SUPRAGLOTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C322",
    "nombre_dx": "C322-TUMOR MALIGNO DE LA REGION SUBGLOTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C323",
    "nombre_dx": "C323-TUMOR MALIGNO DEL CARTILAGO LARINGEO",
    "sexo": "A"
  },
  {
    "cod_dx": "C328",
    "nombre_dx": "C328-LESION DE SITIOS CONTIGUOS DE LA LARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "C329",
    "nombre_dx": "C329-TUMOR MALIGNO DE LA LARINGE, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C33X",
    "nombre_dx": "C33X-TUMOR MALIGNO DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C340",
    "nombre_dx": "C340-TUMOR MALIGNO DEL BRONQUIO PRINCIPAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C341",
    "nombre_dx": "C341-TUMOR MALIGNO DEL LOBULO SUPERIOR, BRONQUIO O PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "C342",
    "nombre_dx": "C342-TUMOR MALIGNO DEL LOBULO MEDIO, BRONQUIO O PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "C343",
    "nombre_dx": "C343-TUMOR MALIGNO DEL LOBULO INFERIOR, BRONQUIO O PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "C348",
    "nombre_dx": "C348-LESION DE SITIOS CONTIGUOS DE LOS BRONQUIOS Y DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "C349",
    "nombre_dx": "C349-TUMOR MALIGNO DE LOS BRONQUIOS O DEL PULMON, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C37X",
    "nombre_dx": "C37X-TUMOR MALIGNO DEL TIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "C380",
    "nombre_dx": "C380-TUMOR MALIGNO DEL CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "C381",
    "nombre_dx": "C381-TUMOR MALIGNO DEL MEDIASTINO ANTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C382",
    "nombre_dx": "C382-TUMOR MALIGNO DEL MEDIASTINO POSTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C383",
    "nombre_dx": "C383-TUMOR MALIGNO DEL MEDIASTINO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C384",
    "nombre_dx": "C384-TUMOR MALIGNO DE LA PLEURA",
    "sexo": "A"
  },
  {
    "cod_dx": "C388",
    "nombre_dx": "C388-LESION DE SITIOS CONTIGUOS DEL CORAZON, DEL MEDIASTINO Y DE LA PLEURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C390",
    "nombre_dx": "C390-TUMOR MALIGNO DE LAS VIAS RESPIRATORIAS SUPERIORES, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C398",
    "nombre_dx": "C398-LESION DE SITIOS CONTIGUOS DE LOS ORGANOS RESPIRATORIOSE INTRATORACICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C399",
    "nombre_dx": "C399-TUMOR MALIGNO DE SITIOS MAL DEFINIDOS DEL SISTEMA RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C400",
    "nombre_dx": "C400-TUMOR MALIGNODEL OMOPLATO Y DE LOS HUESOS LARGOS DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C401",
    "nombre_dx": "C401-TUMOR MALIGNODE LOS HUESOS CORTOS DEL MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C402",
    "nombre_dx": "C402-TUMOR MALIGNO DE LOS HUESOS LARGOS DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C403",
    "nombre_dx": "C403-TUMOR MALIGNO DE LOS HUESOS CORTOS DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C408",
    "nombre_dx": "C408-LESION DE SITIOS CONTIGUOS DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES DE LOS MIEMBROS",
    "sexo": "A"
  },
  {
    "cod_dx": "C409",
    "nombre_dx": "C409-TUMOR MALIGNO DE LOS HUESOS Y DE LOS CARTILAGOS ARTICULARES DE LOS MIEMBROS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C410",
    "nombre_dx": "C410-TUMOR MALIGNO DE LOS HUESOS DEL CRANEO Y DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C411",
    "nombre_dx": "C411-TUMOR MALIGNO DEL HUESO DEL MAXILAR INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C412",
    "nombre_dx": "C412-TUMOR MALIGNO DE LA COLUMNA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C413",
    "nombre_dx": "C413-TUMOR MALIGNO DE LA COSTILLA, ESTERNON Y CLAVICULA",
    "sexo": "A"
  },
  {
    "cod_dx": "C414",
    "nombre_dx": "C414-TUMOR MALIGNO DE LOS HUESOS DE LA PELVIS, SACRO Y COCCIX",
    "sexo": "A"
  },
  {
    "cod_dx": "C418",
    "nombre_dx": "C418-LESION DE SITIOS CONTIGUOS DEL HUESO Y DEL CARTILAGO ARTICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "C419",
    "nombre_dx": "C419-TUMOR MALIGNO DE HUESO Y DEL CARTILAGO ARTICULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C430",
    "nombre_dx": "C430-MELANOMA MALIGNO DEL LABIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C431",
    "nombre_dx": "C431-MELANOMA MALIGNO DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C432",
    "nombre_dx": "C432-MELANOMA MALIGNO DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "C433",
    "nombre_dx": "C433-MELANOMA MALIGNO DE LAS OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "C434",
    "nombre_dx": "C434-MELANOMA MALIGNO DEL CUERO CABELLUDO Y DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C435",
    "nombre_dx": "C435-MELANOMA MALIGNO DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C436",
    "nombre_dx": "C436-MELANOMA MALIGNO DEL MIEMBRO SUPERIOR, INCLUIDA EL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C437",
    "nombre_dx": "C437-MELANOMA MALIGNO DEL MIEMBRO INFERIOR, INCLUIDO LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C438",
    "nombre_dx": "C438-MELANOMA MALIGNO DE SITIOS CONTIGUOS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C439",
    "nombre_dx": "C439-MELANOMA MALIGNO DE PIEL, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C440",
    "nombre_dx": "C440-TUMOR MALIGNO DE LA PIEL DEL LABIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C441",
    "nombre_dx": "C441-TUMOR MALIGNO DE LA PIEL DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C442",
    "nombre_dx": "C442-TUMOR MALIGNO DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "C443",
    "nombre_dx": "C443-TUMOR MALIGNO DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C444",
    "nombre_dx": "C444-TUMOR MALIGNO DE LA PIEL DEL CUERO CABELLUDO Y DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C445",
    "nombre_dx": "C445-TUMOR MALIGNO DE LA PIEL DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C446",
    "nombre_dx": "C446-TUMOR MALIGNO DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C447",
    "nombre_dx": "C447-TUMOR MALIGNO DE LA PIEL DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C448",
    "nombre_dx": "C448-LESION DE SITIOS CONTIGUOS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C449",
    "nombre_dx": "C449-TUMOR MALIGNO DE LA PIEL, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C450",
    "nombre_dx": "C450-MESOTELIOMA DE LA PLEURA",
    "sexo": "A"
  },
  {
    "cod_dx": "C451",
    "nombre_dx": "C451-MESOTELIOMA DEL PERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C452",
    "nombre_dx": "C452-MESOTELIOMA DEL PERICARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C457",
    "nombre_dx": "C457-MESOTELIOMA DE OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C459",
    "nombre_dx": "C459-MESOTELIOMA,DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C460",
    "nombre_dx": "C460-SARCOMA DE KAPOSI DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "C461",
    "nombre_dx": "C461-SARCOMA DE KAPOSI DEL TEJIDO BLANDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C462",
    "nombre_dx": "C462-SARCOMA DE KAPOSI DEL PALADAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C463",
    "nombre_dx": "C463-SARCOMA DE KAPOSI DE LOS GANGLIOS LINFATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C467",
    "nombre_dx": "C467-SARCOMA DE KAPOSI DE OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C468",
    "nombre_dx": "C468-SARCOMA DE KAPOSI DE MULTIPLES ORGANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C469",
    "nombre_dx": "C469-SARCOMA DE KAPOSI, DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C470",
    "nombre_dx": "C470-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DE LA CABEZA, CARA Y CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "C471",
    "nombre_dx": "C471-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C472",
    "nombre_dx": "C472-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C473",
    "nombre_dx": "C473-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "C474",
    "nombre_dx": "C474-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL ABDOMEN",
    "sexo": "A"
  },
  {
    "cod_dx": "C475",
    "nombre_dx": "C475-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C476",
    "nombre_dx": "C476-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS DEL TRONCO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C478",
    "nombre_dx": "C478-LESION DE SITIOS CONTIGUOS DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C479",
    "nombre_dx": "C479-TUMOR MALIGNO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C480",
    "nombre_dx": "C480-TUMOR MALIGNO DEL RETROPERITONEO",
    "sexo": "A"
  },
  {
    "cod_dx": "C481",
    "nombre_dx": "C481-TUMOR MALIGNO DE PARTE ESPECIFICADA DEL PERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C482",
    "nombre_dx": "C482-TUMOR MALIGNO DEL PERITONEO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C488",
    "nombre_dx": "C488-LESION DE SITIOS CONTIGUOS DEL PERITONEO Y DEL RETROPERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C490",
    "nombre_dx": "C490-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DE LA CABEZA, CARA Y CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C491",
    "nombre_dx": "C491-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "C492",
    "nombre_dx": "C492-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "C493",
    "nombre_dx": "C493-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "C494",
    "nombre_dx": "C494-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL ABDOMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "C495",
    "nombre_dx": "C495-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "C496",
    "nombre_dx": "C496-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO DEL TRONCO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C498",
    "nombre_dx": "C498-LESION DE SITIOS CONTIGUOS DEL TEJIDO CONJUNTIVO Y DEL TEJIDO DEL BLANDO",
    "sexo": "A"
  },
  {
    "cod_dx": "C499",
    "nombre_dx": "C499-TUMOR MALIGNO DEL TEJIDO CONJUNTIVO Y TEJIDO BLANDO, DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C500",
    "nombre_dx": "C500-TUMOR MALIGNO DEL PEZON Y AREOLA MAMARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "C501",
    "nombre_dx": "C501-TUMOR MALIGNO DE LA PORCION CENTRAL DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "C502",
    "nombre_dx": "C502-TUMOR MALIGNO DEL CUADRANTE SUPERIOR INTERNO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C503",
    "nombre_dx": "C503-TUMOR MALIGNO DEL CUADRANTE INFERIOR INTERNO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C504",
    "nombre_dx": "C504-TUMOR MALIGNO DEL CUADRANTE SUPERIOR EXTERNO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C505",
    "nombre_dx": "C505-TUMOR MALIGNO DEL CUADRANTE INFERIOR EXTERNO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C506",
    "nombre_dx": "C506-TUMOR MALIGNO DE LA PROLONGACION AXILAR DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "C508",
    "nombre_dx": "C508-LESION DE SITIOS CONTIGUOS DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C509",
    "nombre_dx": "C509-TUMOR MALIGNO DE LA MAMA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C510",
    "nombre_dx": "C510-TUMOR MALIGNO DEL LABIO MAYOR ",
    "sexo": "F"
  },
  {
    "cod_dx": "C511",
    "nombre_dx": "C511-TUMOR MALIGNO DEL LABIO MENOR ",
    "sexo": "F"
  },
  {
    "cod_dx": "C512",
    "nombre_dx": "C512-TUMOR MALIGNO DEL CLITORIS",
    "sexo": "F"
  },
  {
    "cod_dx": "C518",
    "nombre_dx": "C518-LESION DE SITIOS CONTIGUOS DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "C519",
    "nombre_dx": "C519-TUMOR MALIGNO DE LA VULVA, PARTE NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "C52X",
    "nombre_dx": "C52X-TUMOR MALIGNO DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "C530",
    "nombre_dx": "C530-TUMOR MALIGNO DEL ENDOCERVIX",
    "sexo": "F"
  },
  {
    "cod_dx": "C531",
    "nombre_dx": "C531-TUMOR MALIGNO DE EXOCERVIX",
    "sexo": "F"
  },
  {
    "cod_dx": "C538",
    "nombre_dx": "C538-LESION DE SITIOS CONTIGUOS DEL CUELLO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C539",
    "nombre_dx": "C539-TUMOR MALIGNO DEL CUELLO DEL UTERO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "C540",
    "nombre_dx": "C540-TUMOR MALIGNO DEL ISTMO UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C541",
    "nombre_dx": "C541-TUMOR MALIGNO DEL ENDOMETRIO",
    "sexo": "F"
  },
  {
    "cod_dx": "C542",
    "nombre_dx": "C542-TUMOR MALIGNO DEL MIOMETRIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C543",
    "nombre_dx": "C543-TUMOR MALIGNO DEL FONDO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C548",
    "nombre_dx": "C548-LESION DE SITIOS CONTIGUOS DEL CUERPO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C549",
    "nombre_dx": "C549-TUMOR MALIGNO DEL CUERPO DEL UTERO, PARTE NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "C55X",
    "nombre_dx": "C55X-TUMOR MALIGNO DEL UTERO, PARTE NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "C56X",
    "nombre_dx": "C56X-TUMOR MALIGNO DEL OVARIO",
    "sexo": "F"
  },
  {
    "cod_dx": "C570",
    "nombre_dx": "C570-TUMOR MALIGNO DE LA TROMPA DE FALOPIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C571",
    "nombre_dx": "C571-TUMOR MALIGNO DEL LIGAMENTO ANCHO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C572",
    "nombre_dx": "C572-TUMOR MALIGNO DEL LIGAMENTO REDONDO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C573",
    "nombre_dx": "C573-TUMOR MALIGNO DEL PARAMETRIO",
    "sexo": "F"
  },
  {
    "cod_dx": "C574",
    "nombre_dx": "C574-TUMOR MALIGNO DE LOS ANEXOS UTERINOS, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "F"
  },
  {
    "cod_dx": "C577",
    "nombre_dx": "C577-TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DE LOS ORGANOS GENITALES FEMENINOS",
    "sexo": "F"
  },
  {
    "cod_dx": "C578",
    "nombre_dx": "C578-LESION DE SITIOS CONTIGUOS DE LOS ORGANOS GENITALES FEMENINOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "C579",
    "nombre_dx": "C579-TUMOR MALIGNO DE ORGANO GENITAL FEMENINO, PARTE NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "C58X",
    "nombre_dx": "C58X-TUMOR MALIGNO DE LA PLACENTA",
    "sexo": "F"
  },
  {
    "cod_dx": "C600",
    "nombre_dx": "C600-TUMOR MALIGNO DEL PREPUCIO",
    "sexo": "M"
  },
  {
    "cod_dx": "C601",
    "nombre_dx": "C601-TUMOR MALIGNO DEL GLANDE",
    "sexo": "M"
  },
  {
    "cod_dx": "C602",
    "nombre_dx": "C602-TUMOR MALIGNO DEL CUERPO DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "C608",
    "nombre_dx": "C608-LESION DE SITIOS CONTIGUOS DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "C609",
    "nombre_dx": "C609-TUMOR MALIGNO DEL PENE, PARTE NO ESPECIFICADA ",
    "sexo": "M"
  },
  {
    "cod_dx": "C61X",
    "nombre_dx": "C61X-TUMOR MALIGNO DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "C620",
    "nombre_dx": "C620-TUMOR MALIGNO DEL TESTICULO NO DESCENDIDO ",
    "sexo": "M"
  },
  {
    "cod_dx": "C621",
    "nombre_dx": "C621-TUMOR MALIGNO DEL TESTICULO DESCENDIDO",
    "sexo": "M"
  },
  {
    "cod_dx": "C629",
    "nombre_dx": "C629-TUMOR MALIGNO DEL TESTICULO, NO ESPECIFICADO",
    "sexo": "M"
  },
  {
    "cod_dx": "C630",
    "nombre_dx": "C630-TUMOR MALIGNO DEL EPIDIDIMO ",
    "sexo": "M"
  },
  {
    "cod_dx": "C631",
    "nombre_dx": "C631-TUMOR MALIGNO DEL CORDON ESPERMATICO",
    "sexo": "M"
  },
  {
    "cod_dx": "C632",
    "nombre_dx": "C632-TUMOR MALIGNO DEL ESCROTO ",
    "sexo": "M"
  },
  {
    "cod_dx": "C637",
    "nombre_dx": "C637-TUMOR MALIGNO DE OTRAS PARTES ESPECIFICADAS DE LOS ORGANOS GENITALES MASCULINOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "C638",
    "nombre_dx": "C638-LESION DE SITIOS CONTIGUOS DE LOS ORGANOS GENITALES MASCULINOS",
    "sexo": "M"
  },
  {
    "cod_dx": "C639",
    "nombre_dx": "C639-TUMOR MALIGNO DE ORGANO GENITAL MASCULINO, PARTE NO ESPECIFICADA",
    "sexo": "M"
  },
  {
    "cod_dx": "C64X",
    "nombre_dx": "C64X-TUMOR MALIGNO DEL RIÑON, EXCEPTO DE LA PELVIS RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C65X",
    "nombre_dx": "C65X-TUMOR MALIGNO DE LA PELVIS RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C66X",
    "nombre_dx": "C66X-TUMOR MALIGNO DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "C670",
    "nombre_dx": "C670-TUMOR MALIGNO DEL TRIGONO VESICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C671",
    "nombre_dx": "C671-TUMOR MALIGNO DE LA CUPULA VESICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C672",
    "nombre_dx": "C672-TUMOR MALIGNO DE LA PARED LATERAL DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "C673",
    "nombre_dx": "C673-TUMOR MALIGNO DE LA PARED ANTERIOR DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C674",
    "nombre_dx": "C674-TUMOR MALIGNO DE LA PARED POSTERIOR DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "C675",
    "nombre_dx": "C675-TUMOR MALIGNO DEL CUELLO DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C676",
    "nombre_dx": "C676-TUMOR MALIGNO DEL ORIFICIO URETERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C677",
    "nombre_dx": "C677-TUMOR MALIGNO DEL URACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C678",
    "nombre_dx": "C678-LESION DE SITIOS CONTIGUOS DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C679",
    "nombre_dx": "C679-TUMOR MALIGNODE LA VEJIGA URINARIA,, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C680",
    "nombre_dx": "C680-TUMOR MALIGNO DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "C681",
    "nombre_dx": "C681-TUMOR MALIGNO DE LAS GLANDULAS PARAURETRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "C688",
    "nombre_dx": "C688-LESION DE SITIOS CONTIGUOS DE LOS ORGANOS URINARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C689",
    "nombre_dx": "C689-TUMOR MALIGNO DE ORGANO URINARIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C690",
    "nombre_dx": "C690-TUMOR MALIGNO DE LA CONJUNTIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "C691",
    "nombre_dx": "C691-TUMOR MALIGNO DE LA CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "C692",
    "nombre_dx": "C692-TUMOR MALIGNO DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "C693",
    "nombre_dx": "C693-TUMOR MALIGNO DE LA COROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "C694",
    "nombre_dx": "C694-TUMOR MALIGNO DEL CUERPO CILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C695",
    "nombre_dx": "C695-TUMOR MALIGNO DE LA GLANDULA Y CONDUCTO LAGRIMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "C696",
    "nombre_dx": "C696-TUMOR MALIGNO DE LA ORBITA",
    "sexo": "A"
  },
  {
    "cod_dx": "C698",
    "nombre_dx": "C698-LESION DE SITIOS CONTIGUOS DEL OJO Y SUS ANEXOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C699",
    "nombre_dx": "C699-TUMOR MALIGNO DEL OJO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C700",
    "nombre_dx": "C700-TUMOR MALIGNO DE LAS MENINGES CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "C701",
    "nombre_dx": "C701-TUMOR MALIGNO DE LAS MENINGES RAQUIDEAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C709",
    "nombre_dx": "C709-TUMOR MALIGNO DE LAS MENINGES, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C710",
    "nombre_dx": "C710-TUMOR MALIGNO DEL CEREBRO, EXCEPTO LOBULOS Y VENTRICULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C711",
    "nombre_dx": "C711-TUMOR MALIGNO DEL LOBULO FRONTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C712",
    "nombre_dx": "C712-TUMOR MALIGNO DEL LOBULO TEMPORAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C713",
    "nombre_dx": "C713-TUMOR MALIGNO DEL LOBULO PARIETAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C714",
    "nombre_dx": "C714-TUMOR MALIGNO DEL LOBULO OCCIPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C715",
    "nombre_dx": "C715-TUMOR MALIGNO DEL VENTRICULO CEREBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C716",
    "nombre_dx": "C716-TUMOR MALIGNO DEL CEREBELO",
    "sexo": "A"
  },
  {
    "cod_dx": "C717",
    "nombre_dx": "C717-TUMOR MALIGNO DEL PEDUNCULO CEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C718",
    "nombre_dx": "C718-LESION DE SITIOS CONTIGUOS DEL ENCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C719",
    "nombre_dx": "C719-TUMOR MALIGNO DEL ENCEFALO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C720",
    "nombre_dx": "C720-TUMOR MALIGNO DE LA MEDULA ESPINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C721",
    "nombre_dx": "C721-TUMOR MALIGNO DE LA COLA DE CABALLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C722",
    "nombre_dx": "C722-TUMOR MALIGNO DEL NERVIO OLFATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "C723",
    "nombre_dx": "C723-TUMOR MALIGNO DEL NERVIO OPTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C724",
    "nombre_dx": "C724-TUMOR MALIGNO DEL NERVIO ACUSTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C725",
    "nombre_dx": "C725-TUMOR MALIGNO DE OTROS NERVIOS CRANEALES Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C728",
    "nombre_dx": "C728-LESION DE SITIOS CONTIGUOS DEL ENCEFALO Y OTRAS PARTES DEL SISTEMA NERVIOSO CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C729",
    "nombre_dx": "C729-TUMOR MALIGNO DEL SISTEMA NERVIOSO CENTRAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C73X",
    "nombre_dx": "C73X-TUMOR MALIGNO DE LA GLANDULA TIROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C740",
    "nombre_dx": "C740-TUMOR MALIGNO DE LA CORTEZA DE LA GLANDULA SUPRARRENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "C741",
    "nombre_dx": "C741-TUMOR MALIGNO DE LA MEDULA DE LA GLANDULA SUPRARRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C749",
    "nombre_dx": "C749-TUMOR MALIGNO DE LA GLANDULA SUPRARRENAL, PARTENO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "C750",
    "nombre_dx": "C750-TUMOR MALIGNO DE LA GLANDULA PARATIROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C751",
    "nombre_dx": "C751-TUMOR MALIGNO DE LA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C752",
    "nombre_dx": "C752-TUMOR MALIGNO DEL CONDUCTO CRANEOFARINGEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C753",
    "nombre_dx": "C753-TUMOR MALIGNO DE LA GLANDULA PINEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C754",
    "nombre_dx": "C754-TUMOR MALIGNO DEL CUERPO CAROTIDEO",
    "sexo": "A"
  },
  {
    "cod_dx": "C755",
    "nombre_dx": "C755-TUMOR MALIGNO DEL CUERPO AORTICO Y OTROS CUERPOS CROMAFINES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C758",
    "nombre_dx": "C758-TUMOR MALIGNO PLURIGLANDULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C759",
    "nombre_dx": "C759-TUMOR MALIGNO DE GLANDULA ENDOCRINA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C760",
    "nombre_dx": "C760-TUMOR MALIGNO DE LA CABEZA, CARA Y CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C761",
    "nombre_dx": "C761-TUMOR MALIGNO DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "C762",
    "nombre_dx": "C762-TUMOR MALIGNO DEL ABDOMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "C763",
    "nombre_dx": "C763-TUMOR MALIGNO DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "C764",
    "nombre_dx": "C764-TUMOR MALIGNO DEL MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C765",
    "nombre_dx": "C765-TUMOR MALIGNO DEL MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "C767",
    "nombre_dx": "C767-TUMOR MALIGNO DE OTROS SITIOS MAL DEFINIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C768",
    "nombre_dx": "C768-LESION DE SITIOS CONTIGUOS MAL DEFINIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C770",
    "nombre_dx": "C770-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA CABEZA, CARA Y CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "C771",
    "nombre_dx": "C771-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS INTRATORACICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C772",
    "nombre_dx": "C772-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS INTRAABDOMINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C773",
    "nombre_dx": "C773-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA AXILA Y DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C774",
    "nombre_dx": "C774-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA REGION INGUINAL Y DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "C775",
    "nombre_dx": "C775-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C778",
    "nombre_dx": "C778-TUMOR MALIGNO DE LOS GANGLIOS LINFATICOS DE REGIONES MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "C779",
    "nombre_dx": "C779-TUMOR MALIGNO DEL GANGLIO LINFATICO, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C780",
    "nombre_dx": "C780-TUMOR MALIGNO SECUNDARIO DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "C781",
    "nombre_dx": "C781-TUMOR MALIGNO SECUNDARIO DEL MEDIASTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C782",
    "nombre_dx": "C782-TUMOR MALIGNO SECUNDARIO DE LA PLEURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C783",
    "nombre_dx": "C783-TUMOR MALIGNO SECUNDARIO DE OTROS ORGANOS RESPIRATORIOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C784",
    "nombre_dx": "C784-TUMOR MALIGNO SECUNDARIO DEL INTESTINO DELGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C785",
    "nombre_dx": "C785-TUMOR MALIGNO SECUNDARIO DEL INTESTINO GRUESO Y DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C786",
    "nombre_dx": "C786-TUMOR MALIGNO SECUNDARIO DEL PERITONEO Y DEL RETROPERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C787",
    "nombre_dx": "C787-Tumor maligno secundario del hígado y de los conductos biliares intrahepáticos",
    "sexo": "A"
  },
  {
    "cod_dx": "C788",
    "nombre_dx": "C788-TUMOR MALIGNO SECUNDARIO DE OTROS ORGANOS DIGESTIVOS Y DE LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C790",
    "nombre_dx": "C790-TUMOR MALIGNO SECUNDARIO DEL RIÑON Y DE LA PELVIS RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C791",
    "nombre_dx": "C791-TUMOR MALIGNO SECUNDARIO DE LA VEJIGA, Y DE OTROS ORGANOS Y LOS NO ESPECIFICADOS DE LAS VIAS URINARI",
    "sexo": "A"
  },
  {
    "cod_dx": "C792",
    "nombre_dx": "C792-TUMOR MALIGNO SECUNDARIO DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C793",
    "nombre_dx": "C793-TUMOR MALIGNO SECUNDARIO DEL ENCEFALO Y DE LAS MENINGES CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "C794",
    "nombre_dx": "C794-TUMOR MALIGNO SECUNDARIO DE OTRAS PARTES DEL SISTEMA NERVIOSO Y DE LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C795",
    "nombre_dx": "C795-TUMOR MALIGNO SECUNDARIO DE LOS HUESOS Y DE LA MEDULA OSEA",
    "sexo": "A"
  },
  {
    "cod_dx": "C796",
    "nombre_dx": "C796-TUMOR MALIGNO SECUNDARIO DEL OVARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "C797",
    "nombre_dx": "C797-TUMOR MALIGNO SECUNDARIO DE LA GLANDULA SUPRARRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "C798",
    "nombre_dx": "C798-TUMOR MALIGNO SECUNDARIO DE OTROS SITIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C799",
    "nombre_dx": "C799-Tumor maligno secundario, sitio no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C79X",
    "nombre_dx": "C79X-Tumor maligno secundario de otros sitios y de sitios no especificados (antes TUMOR MALIGNO SECUNDARIO DE OTROS SITIOS)",
    "sexo": "A"
  },
  {
    "cod_dx": "C800",
    "nombre_dx": "C800-Tumor maligno, de sitio primario desconocido, así descrito",
    "sexo": "A"
  },
  {
    "cod_dx": "C809",
    "nombre_dx": "C809-Tumor maligno, sitio primario no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C810",
    "nombre_dx": "C810-Linfoma de Hodgkin nodular con predominio linfocítico",
    "sexo": "A"
  },
  {
    "cod_dx": "C811",
    "nombre_dx": "C811-Linfoma de Hodgkin (clásico) con esclerosis nodular",
    "sexo": "A"
  },
  {
    "cod_dx": "C812",
    "nombre_dx": "C812-Linfoma de Hodgkin (clásico) con celularidad mixta",
    "sexo": "A"
  },
  {
    "cod_dx": "C813",
    "nombre_dx": "C813-Linfoma de Hodgkin (clásico) con depleción linfocítica",
    "sexo": "A"
  },
  {
    "cod_dx": "C814",
    "nombre_dx": "C814-Linfoma de Hodgkin clásico rico en linfocitos",
    "sexo": "A"
  },
  {
    "cod_dx": "C817",
    "nombre_dx": "C817-Otros linfomas de Hodgkin (clásicos)",
    "sexo": "A"
  },
  {
    "cod_dx": "C819",
    "nombre_dx": "C819-Linfoma de Hodgkin, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C81X",
    "nombre_dx": "C81X-Linfoma de Hodgkin (antes ENFERMEDAD DE HODGKIN)",
    "sexo": "A"
  },
  {
    "cod_dx": "C820",
    "nombre_dx": "C820-Linfoma folicular grado I",
    "sexo": "A"
  },
  {
    "cod_dx": "C821",
    "nombre_dx": "C821-Linfoma folicular grado II",
    "sexo": "A"
  },
  {
    "cod_dx": "C822",
    "nombre_dx": "C822-Linfoma folicular grado III, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C823",
    "nombre_dx": "C823-Linfoma folicular grado IIIa",
    "sexo": "A"
  },
  {
    "cod_dx": "C824",
    "nombre_dx": "C824-Linfoma folicular grado IIIb",
    "sexo": "A"
  },
  {
    "cod_dx": "C825",
    "nombre_dx": "C825-Linfoma centro folicular difuso",
    "sexo": "A"
  },
  {
    "cod_dx": "C826",
    "nombre_dx": "C826-Linfoma centro folicular cutáneo",
    "sexo": "A"
  },
  {
    "cod_dx": "C827",
    "nombre_dx": "C827-Otros tipos especificados de linfoma folicular",
    "sexo": "A"
  },
  {
    "cod_dx": "C829",
    "nombre_dx": "C829-Linfoma folicular, sin otra especificación",
    "sexo": "A"
  },
  {
    "cod_dx": "C82X",
    "nombre_dx": "C82X-Linfoma folicular (antes LINFOMA NO HODKING FOLICULAR [NODULAR])",
    "sexo": "A"
  },
  {
    "cod_dx": "C830",
    "nombre_dx": "C830-Linfoma de células B pequeñas",
    "sexo": "A"
  },
  {
    "cod_dx": "C831",
    "nombre_dx": "C831-Linfoma de células del manto",
    "sexo": "A"
  },
  {
    "cod_dx": "C833",
    "nombre_dx": "C833-Linfoma de células grandes B difuso",
    "sexo": "A"
  },
  {
    "cod_dx": "C835",
    "nombre_dx": "C835-Linfoma linfoblástico (difuso)",
    "sexo": "A"
  },
  {
    "cod_dx": "C837",
    "nombre_dx": "C837-Linfoma de Burkitt",
    "sexo": "A"
  },
  {
    "cod_dx": "C838",
    "nombre_dx": "C838-Otros tipos especificados de linfoma no folicular",
    "sexo": "A"
  },
  {
    "cod_dx": "C839",
    "nombre_dx": "C839-Linfoma no folicular (difuso), sin otra especificación",
    "sexo": "A"
  },
  {
    "cod_dx": "C83X",
    "nombre_dx": "C83X-Linfoma no folicular (antes LINFOMA NO HODKING DIFUSO)",
    "sexo": "A"
  },
  {
    "cod_dx": "C840",
    "nombre_dx": "C840-MICOSIS FUNGOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "C841",
    "nombre_dx": "C841-ENFERMEDAD DE SEZARY",
    "sexo": "A"
  },
  {
    "cod_dx": "C844",
    "nombre_dx": "C844-LINFOMA DE CELULAS T PERIFERICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C845",
    "nombre_dx": "C845-OTROS LINFOMAS DE CELULAS YLOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C846",
    "nombre_dx": "C846-Linfoma anaplásico de células grandes ALK-positivo",
    "sexo": "A"
  },
  {
    "cod_dx": "C847",
    "nombre_dx": "C847-Linfoma anaplásico de células grandes ALK-negativo",
    "sexo": "A"
  },
  {
    "cod_dx": "C848",
    "nombre_dx": "C848-Linfoma cutáneo de células T, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C849",
    "nombre_dx": "C849-Linfoma de células T/NK maduras, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "C84X",
    "nombre_dx": "C84X-Linfoma de células T/NK maduras (antes LINFOMA DE CELULAS T, PERIFERICO Y CUTANEO)",
    "sexo": "A"
  },
  {
    "cod_dx": "C851",
    "nombre_dx": "C851-LINFOMA DE CELULAS B, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C852",
    "nombre_dx": "C852-Linfoma mediastinal de células B grandes (del timo)",
    "sexo": "A"
  },
  {
    "cod_dx": "C857",
    "nombre_dx": "C857-OTROS TIPOS ESPECIFICADOS DE LINFOMA NO HODGKIN ",
    "sexo": "A"
  },
  {
    "cod_dx": "C859",
    "nombre_dx": "C859-LINFOMA NO HODGKIN, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C860",
    "nombre_dx": "C860-Linfoma extranodal de células T/NK, tipo nasal",
    "sexo": "A"
  },
  {
    "cod_dx": "C861",
    "nombre_dx": "C861-Linfoma hepatoesplénico de células T",
    "sexo": "A"
  },
  {
    "cod_dx": "C862",
    "nombre_dx": "C862-Linfoma de células T tipo enteropatía (intestinal)",
    "sexo": "A"
  },
  {
    "cod_dx": "C863",
    "nombre_dx": "C863-Linfoma de células T tipo paniculitis subcutánea",
    "sexo": "A"
  },
  {
    "cod_dx": "C864",
    "nombre_dx": "C864-Linfoma blástico de células NK",
    "sexo": "A"
  },
  {
    "cod_dx": "C865",
    "nombre_dx": "C865-Linfoma angioinmunoblástico de células T",
    "sexo": "A"
  },
  {
    "cod_dx": "C866",
    "nombre_dx": "C866-Trastornos linfoproliferativos primario cutáneos de células T CD30-positivo",
    "sexo": "A"
  },
  {
    "cod_dx": "C880",
    "nombre_dx": "C880-MACROGLOBULINEMIA DE WALDENSTROM",
    "sexo": "A"
  },
  {
    "cod_dx": "C882",
    "nombre_dx": "C882-Otras enfermedades de cadena pesada",
    "sexo": "A"
  },
  {
    "cod_dx": "C883",
    "nombre_dx": "C883-ENFERMEDAD INMUNOPROLIFERATIVA DEL INTESTINO DELGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C884",
    "nombre_dx": "C884-Linfoma de células B extranodal de zona marginal de tejido linfoide asociado a mucosas [Linfoma TLAM]",
    "sexo": "A"
  },
  {
    "cod_dx": "C887",
    "nombre_dx": "C887-OTRAS ENFERMEDADES INMUNOPROLIFERATIVAS MALIGNAS",
    "sexo": "A"
  },
  {
    "cod_dx": "C889",
    "nombre_dx": "C889-ENFERMEDAD INMUNOPROLIFERATIVA MALIGNA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "C900",
    "nombre_dx": "C900-MIELOMA MULTIPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "C901",
    "nombre_dx": "C901-LEUCEMIA DE CELULAS PLASMATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C902",
    "nombre_dx": "C902-Plasmocitoma extramedular",
    "sexo": "A"
  },
  {
    "cod_dx": "C903",
    "nombre_dx": "C903-Plasmocitoma solitario",
    "sexo": "A"
  },
  {
    "cod_dx": "C910",
    "nombre_dx": "C910-Leucemia linfoblástica aguda [LLA]",
    "sexo": "A"
  },
  {
    "cod_dx": "C911",
    "nombre_dx": "C911-Leucemia linfocítica crónica de célula tipo B",
    "sexo": "A"
  },
  {
    "cod_dx": "C913",
    "nombre_dx": "C913-Leucemia prolinfocítica de célula tipo B",
    "sexo": "A"
  },
  {
    "cod_dx": "C914",
    "nombre_dx": "C914-LEUCEMIA DE CELULAS VELLOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "C915",
    "nombre_dx": "C915-Leucemia/linfoma de células T adultas [HTLV-1-asociado]",
    "sexo": "A"
  },
  {
    "cod_dx": "C916",
    "nombre_dx": "C916-Leucemia prolinfocítica de células tipo T",
    "sexo": "A"
  },
  {
    "cod_dx": "C917",
    "nombre_dx": "C917-OTRAS LEUCEMIAS LINFOIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C918",
    "nombre_dx": "C918-Leucemia tipo Burkitt de células B maduras",
    "sexo": "A"
  },
  {
    "cod_dx": "C919",
    "nombre_dx": "C919-LEUCEMIA LINFOIDE, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C920",
    "nombre_dx": "C920-Leucemia mieloblástica aguda [LMA]",
    "sexo": "A"
  },
  {
    "cod_dx": "C921",
    "nombre_dx": "C921-Leucemia mieloide crónica [LMC], BCR/ABL-positivo",
    "sexo": "A"
  },
  {
    "cod_dx": "C922",
    "nombre_dx": "C922-Leucemia mieloide crónica atípica, BCR/ABL-negativo",
    "sexo": "A"
  },
  {
    "cod_dx": "C923",
    "nombre_dx": "C923-SARCOMA MIELOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "C924",
    "nombre_dx": "C924-Leucemia promielocítica aguda [LPA]",
    "sexo": "A"
  },
  {
    "cod_dx": "C925",
    "nombre_dx": "C925-LEUCEMIA MIELOMONOCITICA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "C926",
    "nombre_dx": "C926-Leucemia mieloide aguda con anormalidad 11q23",
    "sexo": "A"
  },
  {
    "cod_dx": "C927",
    "nombre_dx": "C927-OTRAS LEUCEMIAS MIELOIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "C928",
    "nombre_dx": "C928-Leucemia mieloide aguda con displasia multilinaje",
    "sexo": "A"
  },
  {
    "cod_dx": "C929",
    "nombre_dx": "C929-LEUCEMIA MIELOIDE, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C930",
    "nombre_dx": "C930-Leucemia monocítica/monoblástica aguda",
    "sexo": "A"
  },
  {
    "cod_dx": "C931",
    "nombre_dx": "C931-Leucemia mielomonocítica crónica",
    "sexo": "A"
  },
  {
    "cod_dx": "C933",
    "nombre_dx": "C933-Leucemia mielomonocítica juvenil",
    "sexo": "A"
  },
  {
    "cod_dx": "C937",
    "nombre_dx": "C937-OTRAS LEUCEMIAS MONOCITICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C939",
    "nombre_dx": "C939-LEUCEMIA MONOCITICA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C940",
    "nombre_dx": "C940-Leucemia eritroide aguda (antes ERITREMIA AGUDA Y ERITROLEUCEMIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "C942",
    "nombre_dx": "C942-LEUCEMIA MEGACARIOBLASTICA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "C943",
    "nombre_dx": "C943-LEUCEMIA DE MASTOCITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "C944",
    "nombre_dx": "C944-Panmielosis aguda con mielofibrosis",
    "sexo": "A"
  },
  {
    "cod_dx": "C946",
    "nombre_dx": "C946-Enfermedad mielodisplásica y mieloproliferativa, no clasificada en otra parte",
    "sexo": "A"
  },
  {
    "cod_dx": "C947",
    "nombre_dx": "C947-OTRAS LEUCEMIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C950",
    "nombre_dx": "C950-LEUCEMIA AGUDA, CELULAS DE TIPO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C951",
    "nombre_dx": "C951-LEUCEMIA CRONICA, CELULAS DE TIPO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "C957",
    "nombre_dx": "C957-OTRAS LEUCEMIAS DE CELULAS DE TIPO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "C959",
    "nombre_dx": "C959-LEUCEMIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "C960",
    "nombre_dx": "C960- Histiocitosis de células de Langerhans multifocal y multisistémica (diseminada) [Enfermedad de Letterer-Siwe]",
    "sexo": "A"
  },
  {
    "cod_dx": "C962",
    "nombre_dx": "C962-TUMOR MALIGNO DE MASTOCITOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "C964",
    "nombre_dx": "C964-Sarcoma de células dendríticas (células accesorias)",
    "sexo": "A"
  },
  {
    "cod_dx": "C965",
    "nombre_dx": "C965-Histiocitosis de células de Langerhans multifocal y unisistémica",
    "sexo": "A"
  },
  {
    "cod_dx": "C966",
    "nombre_dx": "C966-Histiocitosis de células de Langerhans unifocal",
    "sexo": "A"
  },
  {
    "cod_dx": "C967",
    "nombre_dx": "C967-OTROS TUMORES MALIGNOS ESPECIFICADOS DEL TEJIDO LINFATICO, HEMATOPOYETICO Y TEJIDOS AFINES",
    "sexo": "A"
  },
  {
    "cod_dx": "C968",
    "nombre_dx": "C968-Sarcoma histiocítico",
    "sexo": "A"
  },
  {
    "cod_dx": "C969",
    "nombre_dx": "C969-TUMOR MALIGNO DEL TEJIDO LINFATICO, HEMATOPOYETICO Y TEJIDOS AFINES, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "C97X",
    "nombre_dx": "C97X-TUMORES MALIGNO (PRIMARIOS) DE SITIOS MULTIPLES INDEPENDIENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "D000",
    "nombre_dx": "D000-CARCINOMA IN SITU DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "D001",
    "nombre_dx": "D001-CARCINOMA IN SITU DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D002",
    "nombre_dx": "D002-CARCINOMA IN SITU DEL ESTOMAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "D010",
    "nombre_dx": "D010-CARCINOMA IN SITU DEL COLON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D011",
    "nombre_dx": "D011-CARCINOMA IN SITU DE LA UNION RECTOSIGMOIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "D012",
    "nombre_dx": "D012-CARCINOMA IN SITU DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D013",
    "nombre_dx": "D013-CARCINOMA IN SITU DEL ANO Y DEL CONDUCTO ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D014",
    "nombre_dx": "D014-CARCINOMA IN SITU DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D015",
    "nombre_dx": "D015-CARCINOMA IN SITU DEL HIGADO, DE LA VESICULA BILIAR Y DEL CONDUCTO BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D017",
    "nombre_dx": "D017-CARCINOMA IN SITU DE OTRAS PARTES ESPECIFICADAS DE ORGANOS DIGESTIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D019",
    "nombre_dx": "D019-CARCINOMA IN SITU DE ORGANOS DIGESTIVOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D020",
    "nombre_dx": "D020-CARCINOMA IN SITU DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D021",
    "nombre_dx": "D021-CARCINOMA IN SITU DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D022",
    "nombre_dx": "D022-CARCINOMA IN SITU DEL BRONQUIO Y DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D023",
    "nombre_dx": "D023-CARCINOMA IN SITU DE OTRAS PARTES DEL SISTEMA RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "D024",
    "nombre_dx": "D024-CARCINOMA IN SITU DE ORGANOS RESPIRATORIOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D030",
    "nombre_dx": "D030-MELANOMAIN SITU DEL LABIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D031",
    "nombre_dx": "D031-MELANOMAIN SITU DEL PARPADO Y DE LA COMISURA PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D032",
    "nombre_dx": "D032-MELANOMAIN SITU DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D033",
    "nombre_dx": "D033-MELANOMAIN SITU DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "D034",
    "nombre_dx": "D034-MELANOMAIN SITU DEL CUERO CABELLUDO Y DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "D035",
    "nombre_dx": "D035-MELANOMAIN SITU DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "D036",
    "nombre_dx": "D036-MELANOMAIN SITU DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "D037",
    "nombre_dx": "D037-MELANOMAIN SITU DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "D038",
    "nombre_dx": "D038-MELANOMAIN SITU DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D039",
    "nombre_dx": "D039-MELANOMAIN SITU, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D040",
    "nombre_dx": "D040-CARCINOMAIN SITU DE LA PIEL DEL LABIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D041",
    "nombre_dx": "D041-CARCINOMAIN SITU DE LA PIEL DEL PARPADO Y DE LA COMISURA PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D042",
    "nombre_dx": "D042-CARCINOMAIN SITU DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D043",
    "nombre_dx": "D043-CARCINOMAIN SITU DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "D044",
    "nombre_dx": "D044-CARCINOMAIN SITU DE LA PIEL DEL CUERO CABELLUDO Y CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "D045",
    "nombre_dx": "D045-CARCINOMAIN SITU DE LA PIEL DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "D046",
    "nombre_dx": "D046-CARCINOMAIN SITU DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "D047",
    "nombre_dx": "D047-CARCINOMAIN SITU DE LA PIEL DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "D048",
    "nombre_dx": "D048-CARCINOMAIN SITU DE LA PIEL DE OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D049",
    "nombre_dx": "D049-CARCINOMAIN SITU DE LA PIEL, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D050",
    "nombre_dx": "D050-CARCINOMAIN SITU LOBULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D051",
    "nombre_dx": "D051-CARCINOMAIN SITU INTRACANALICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D057",
    "nombre_dx": "D057-OTROS CARCINOMASIN SITU DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "D059",
    "nombre_dx": "D059-CARCINOMAIN SITU DE LA MAMA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D060",
    "nombre_dx": "D060-CARCINOMAIN SITU DEL ENDOCERVIX ",
    "sexo": "F"
  },
  {
    "cod_dx": "D061",
    "nombre_dx": "D061-CARCINOMAIN SITU DEL EXOCERVIX",
    "sexo": "F"
  },
  {
    "cod_dx": "D067",
    "nombre_dx": "D067-CARCINOMAIN SITU DE OTRAS PARTES ESPECIFICADAS DEL CUELLO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D069",
    "nombre_dx": "D069-CARCINOMAIN SITU DEL CUELLO DEL UTERO, PARTE NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "D070",
    "nombre_dx": "D070-CARCINOMAIN SITU DEL ENDOMETRIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D071",
    "nombre_dx": "D071-CARCINOMAIN SITU DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "D072",
    "nombre_dx": "D072-CARCINOMAIN SITU DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "D073",
    "nombre_dx": "D073-CARCINOMAIN SITU DE OTROS SITIOS DE ORGANOS GENITALES FEMENINOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "D074",
    "nombre_dx": "D074-CARCINOMAIN SITU DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "D075",
    "nombre_dx": "D075-CARCINOMAIN SITU DE LA PROSTATA ",
    "sexo": "M"
  },
  {
    "cod_dx": "D076",
    "nombre_dx": "D076-CARCINOMAIN SITU DE OTROS ORGANOS GENITALES MASCULINOS Y DE LOS NO ESPECIFICADOS",
    "sexo": "M"
  },
  {
    "cod_dx": "D090",
    "nombre_dx": "D090-CARCINOMAIN SITU DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D091",
    "nombre_dx": "D091-CARCINOMAIN SITU DE OTROS ORGANOS URINARIOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D092",
    "nombre_dx": "D092-CARCINOMAIN SITU DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "D093",
    "nombre_dx": "D093-CARCINOMAIN SITU DE LA GLANDULA TIROIDES Y DE OTRAS GLANDULAS ENDOCRINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D097",
    "nombre_dx": "D097-CARCINOMAIN SITU DE OTROS SITIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D099",
    "nombre_dx": "D099-CARCINOMAIN SITU, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D100",
    "nombre_dx": "D100-TUMOR BENIGNO DEL LABIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D101",
    "nombre_dx": "D101-TUMOR BENIGNO DE LA LENGUA",
    "sexo": "A"
  },
  {
    "cod_dx": "D102",
    "nombre_dx": "D102-TUMOR BENIGNO DEL PISO DE LA BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D103",
    "nombre_dx": "D103-TUMOR BENIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA BOCA",
    "sexo": "A"
  },
  {
    "cod_dx": "D104",
    "nombre_dx": "D104-TUMOR BENIGNO DE LA AMIGDALA",
    "sexo": "A"
  },
  {
    "cod_dx": "D105",
    "nombre_dx": "D105-TUMOR BENIGNO DE OTRAS PARTES DE LA OROFARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "D106",
    "nombre_dx": "D106-TUMOR BENIGNO DE LA NASOFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D107",
    "nombre_dx": "D107-TUMOR BENIGNO DE LA HIPOFARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D109",
    "nombre_dx": "D109-TUMOR BENIGNO DE LA FARINGE, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D110",
    "nombre_dx": "D110-TUMOR BENIGNO DE LA GLANDULA PAROTIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D117",
    "nombre_dx": "D117-TUMOR BENIGNO DE OTRAS GLANDULAS SALIVALES MAYORES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D119",
    "nombre_dx": "D119-TUMOR BENIGNO DE LA GLANDULA SALIVAL MAYOR, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D120",
    "nombre_dx": "D120-TUMOR BENIGNO DEL CIEGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D121",
    "nombre_dx": "D121-TUMOR BENIGNO DEL APENDICE",
    "sexo": "A"
  },
  {
    "cod_dx": "D122",
    "nombre_dx": "D122-TUMOR BENIGNO DEL COLON ASCENDENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "D123",
    "nombre_dx": "D123-TUMOR BENIGNO DEL COLON TRANSVERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "D124",
    "nombre_dx": "D124-TUMOR BENIGNO DEL COLON DESCENDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D125",
    "nombre_dx": "D125-TUMOR BENIGNO DEL COLON SIGMOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "D126",
    "nombre_dx": "D126-TUMOR BENIGNO DEL COLON, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D127",
    "nombre_dx": "D127-TUMOR BENIGNO DE LA UNION RECTOSIGMOIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "D128",
    "nombre_dx": "D128-TUMOR BENIGNO DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D129",
    "nombre_dx": "D129-TUMOR BENIGNO DEL CONDUCTO ANAL Y DEL ANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D130",
    "nombre_dx": "D130-TUMOR BENIGNO DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D131",
    "nombre_dx": "D131-TUMOR BENIGNO DEL ESTOMAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "D132",
    "nombre_dx": "D132-TUMOR BENIGNO DEL DUODENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D133",
    "nombre_dx": "D133-TUMOR BENIGNO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL INTESTINO DELGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D134",
    "nombre_dx": "D134-TUMOR BENIGNO DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D135",
    "nombre_dx": "D135-TUMOR BENIGNO DE LAS VIAS BILIARES EXTRAHEPATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D136",
    "nombre_dx": "D136-TUMOR BENIGNO DEL PANCREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D137",
    "nombre_dx": "D137-TUMOR BENIGNO DEL PANCREAS ENDOCRINO",
    "sexo": "A"
  },
  {
    "cod_dx": "D139",
    "nombre_dx": "D139-TUMOR BENIGNO DE SITIOS MAL DEFINIDOS DEL SISTEMA DIGESTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D140",
    "nombre_dx": "D140-TUMOR BENIGNO DEL OIDO MEDIO, DE LA CAVIDAD NASAL Y DE LOS SENOS PARANASALES",
    "sexo": "A"
  },
  {
    "cod_dx": "D141",
    "nombre_dx": "D141-TUMOR BENIGNO DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D142",
    "nombre_dx": "D142-TUMOR BENIGNO DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D143",
    "nombre_dx": "D143-TUMOR BENIGNO DE LOS BRONQUIOS Y DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D144",
    "nombre_dx": "D144-TUMOR BENIGNO DEL SISTEMA RESPIRATORIO, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D150",
    "nombre_dx": "D150-TUMOR BENIGNO DEL TIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "D151",
    "nombre_dx": "D151-TUMOR BENIGNO DEL CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D152",
    "nombre_dx": "D152-TUMOR BENIGNO DEL MEDIASTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "D157",
    "nombre_dx": "D157-TUMOR BENIGNO DEOTROS ORGANOS INTRATORACICOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D159",
    "nombre_dx": "D159-TUMOR BENIGNO DEORGANO INTRATORACICO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D160",
    "nombre_dx": "D160-TUMOR BENIGNO DEL OMOPLATO Y HUESOS LARGOS DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D161",
    "nombre_dx": "D161-TUMOR BENIGNO DE LOS HUESOS CORTOS DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D162",
    "nombre_dx": "D162-TUMOR BENIGNO DE LOS HUESOS LARGOS DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D163",
    "nombre_dx": "D163-TUMOR BENIGNO DE LOS HUESOS CORTOS DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D164",
    "nombre_dx": "D164-TUMOR BENIGNO DE LOS HUESOS DEL CRANEO Y DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D165",
    "nombre_dx": "D165-TUMOR BENIGNO DEL MAXILAR INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "D166",
    "nombre_dx": "D166-TUMOR BENIGNO DE LA COLUMNA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D167",
    "nombre_dx": "D167-TUMOR BENIGNO DE LAS COSTILLAS, ESTERNON Y CLAVICULA",
    "sexo": "A"
  },
  {
    "cod_dx": "D168",
    "nombre_dx": "D168-TUMOR BENIGNO DE LOS HUESOS PELVICOS, SACRO Y COCCIX",
    "sexo": "A"
  },
  {
    "cod_dx": "D169",
    "nombre_dx": "D169-TUMOR BENIGNO DEL HUESOS Y DEL CARTILAGO ARTICULAR, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D170",
    "nombre_dx": "D170-TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE CABEZA, CARA Y CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "D171",
    "nombre_dx": "D171-TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "D172",
    "nombre_dx": "D172-TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE MIEMBROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D173",
    "nombre_dx": "D173-TUMOR BENIGNO LIPOMATOSO DE PIEL Y DE TEJIDO SUBCUTANEO DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D174",
    "nombre_dx": "D174-TUMOR BENIGNO LIPOMATOSO DE LOS ORGANOS INTRATORACICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D175",
    "nombre_dx": "D175-TUMOR BENIGNO LIPOMATOSO DE LOS ORGANOS INTRAABDOMINALES",
    "sexo": "A"
  },
  {
    "cod_dx": "D176",
    "nombre_dx": "D176-TUMOR BENIGNO LIPOMATOSO DEL CORDON ESPERMATICO ",
    "sexo": "M"
  },
  {
    "cod_dx": "D177",
    "nombre_dx": "D177-TUMOR BENIGNO LIPOMATOSO DE OTROS SITIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D179",
    "nombre_dx": "D179-TUMOR BENIGNO LIPOMATOSO, DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D180",
    "nombre_dx": "D180-HEMANGIOMA, DE CUALQUIER SITIO",
    "sexo": "A"
  },
  {
    "cod_dx": "D181",
    "nombre_dx": "D181-LINFANGIOMA, DE CUALQUIER SITIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D190",
    "nombre_dx": "D190-TUMOR BENIGNO DEL TEJIDO MESOTELIAL DE LA PLEURA",
    "sexo": "A"
  },
  {
    "cod_dx": "D191",
    "nombre_dx": "D191-TUMOR BENIGNO DEL TEJIDO MESOTELIAL DEL PERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D197",
    "nombre_dx": "D197-TUMOR BENIGNO DEL TEJIDO MESOTELIAL DE OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D199",
    "nombre_dx": "D199-TUMOR BENIGNO DEL TEJIDO MESOTELIAL, DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D200",
    "nombre_dx": "D200-TUMOR BENIGNO DEL RETROPERITONEO",
    "sexo": "A"
  },
  {
    "cod_dx": "D201",
    "nombre_dx": "D201-TUMOR BENIGNO DEL PERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D210",
    "nombre_dx": "D210-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DE CABEZA, CARA Y CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D211",
    "nombre_dx": "D211-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL MIEMBRO SUPERIOR, INCLUIDO EL HOM",
    "sexo": "A"
  },
  {
    "cod_dx": "D212",
    "nombre_dx": "D212-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL MIEMBRO INFERIOR, INCLUIDO LA CAD",
    "sexo": "A"
  },
  {
    "cod_dx": "D213",
    "nombre_dx": "D213-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "D214",
    "nombre_dx": "D214-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL ABDOMEN",
    "sexo": "A"
  },
  {
    "cod_dx": "D215",
    "nombre_dx": "D215-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D216",
    "nombre_dx": "D216-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS DEL TRONCO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "D219",
    "nombre_dx": "D219-TUMOR BENIGNO DEL TEJIDO CUNJUNTIVO Y DE OTROS TEJIDOS BLANDOS, DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D220",
    "nombre_dx": "D220-NEVO MELANOCITICO DEL LABIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D221",
    "nombre_dx": "D221-NEVO MELANOCITICO DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D222",
    "nombre_dx": "D222-NEVO MELANOCITICO DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D223",
    "nombre_dx": "D223-NEVO MELANOCITICO DE OTRAS PARTES DE LAS NO ESPECIFICADAS DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "D224",
    "nombre_dx": "D224-NEVO MELANOCITICO DEL CUERO CABELLUDO Y DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "D225",
    "nombre_dx": "D225-NEVO MELANOCITICO DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "D226",
    "nombre_dx": "D226-NEVO MELANOCITICO DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "D227",
    "nombre_dx": "D227-NEVO MELANOCITICO DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "D229",
    "nombre_dx": "D229-NEVO MELANOCITICO, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D230",
    "nombre_dx": "D230-TUMOR BENIGNO DE LA PIEL DEL LABIO",
    "sexo": "A"
  },
  {
    "cod_dx": "D231",
    "nombre_dx": "D231-TUMOR BENIGNO DE LA PIEL DEL PARPADO, INCLUIDA LA COMISURA PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D232",
    "nombre_dx": "D232-TUMOR BENIGNO DE LA PIEL DE LA OREJA Y DEL CONDUCTO AUDITIVO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "D233",
    "nombre_dx": "D233-TUMOR BENIGNO DE LA PIEL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D234",
    "nombre_dx": "D234-TUMOR BENIGNO DE LA PIEL DEL CUERO CABELLUDO Y DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D235",
    "nombre_dx": "D235-TUMOR BENIGNO DE LA PIEL DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D236",
    "nombre_dx": "D236-TUMOR BENIGNO DE LA PIEL DEL MIEMBRO SUPERIOR, INCLUIDO EL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D237",
    "nombre_dx": "D237-TUMOR BENIGNO DE LA PIEL DEL MIEMBRO INFERIOR, INCLUIDA LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D239",
    "nombre_dx": "D239-TUMOR BENIGNO DE LA PIEL, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D24X",
    "nombre_dx": "D24X-TUMOR BENIGNO DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "D250",
    "nombre_dx": "D250-LEIOMIOMA SUBMUCOSO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D251",
    "nombre_dx": "D251-LEIOMIOMA INTRAMURAL DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "D252",
    "nombre_dx": "D252-LEIOMIOMA SUBSEROSO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D259",
    "nombre_dx": "D259-LEIOMIOMADEL UTERO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "D260",
    "nombre_dx": "D260-TUMOR BENIGNO DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "D261",
    "nombre_dx": "D261-TUMOR BENIGNO DEL CUERPO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "D267",
    "nombre_dx": "D267-TUMOR BENIGNO DE OTRAS PARTES ESPECIFICADAS DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D269",
    "nombre_dx": "D269-TUMOR BENIGNO DEL UTERO, PARTE NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "D27X",
    "nombre_dx": "D27X-TUMOR BENIGNO DEL OVARIO",
    "sexo": "F"
  },
  {
    "cod_dx": "D280",
    "nombre_dx": "D280-TUMOR BENIGNO DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "D281",
    "nombre_dx": "D281-TUMOR BENIGNO DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "D282",
    "nombre_dx": "D282-TUMOR BENIGNO DE LA TROMPA DE FALOPIO Y DE LOS LIGAMENTOS UTERINOS",
    "sexo": "F"
  },
  {
    "cod_dx": "D287",
    "nombre_dx": "D287-TUMOR BENIGNO DE OTROS SITIOS ESPECIFICADOS DE LOS ORGANOS GENITALES FEMENINOS",
    "sexo": "F"
  },
  {
    "cod_dx": "D289",
    "nombre_dx": "D289-TUMOR BENIGNO DE ORGANO GENITAL FEMENINO, SITIO NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D290",
    "nombre_dx": "D290-TUMOR BENIGNO DEL PENE",
    "sexo": "M"
  },
  {
    "cod_dx": "D291",
    "nombre_dx": "D291-TUMOR BENIGNO DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "D292",
    "nombre_dx": "D292-TUMOR BENIGNO DE LOS TESTICULOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "D293",
    "nombre_dx": "D293-TUMOR BENIGNO DEL EPIDIDIMO ",
    "sexo": "M"
  },
  {
    "cod_dx": "D294",
    "nombre_dx": "D294-TUMOR BENIGNO DEL ESCROTO ",
    "sexo": "M"
  },
  {
    "cod_dx": "D297",
    "nombre_dx": "D297-TUMOR BENIGNO DE OTROS ORGANOS GENITALES MASCULINOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "D299",
    "nombre_dx": "D299-TUMOR BENIGNO DE ORGANO GENITAL MASCULINO, SITIO NO ESPECIFICADO",
    "sexo": "M"
  },
  {
    "cod_dx": "D300",
    "nombre_dx": "D300-TUMOR BENIGNO DEL RIÑON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D301",
    "nombre_dx": "D301-TUMOR BENIGNO DE LA PELVIS RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D302",
    "nombre_dx": "D302-TUMOR BENIGNO DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "D303",
    "nombre_dx": "D303-TUMOR BENIGNO DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "D304",
    "nombre_dx": "D304-TUMOR BENIGNO DE LAURETRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D307",
    "nombre_dx": "D307-TUMOR BENIGNO DE OTROS ORGANOS URINARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D309",
    "nombre_dx": "D309-TUMOR BENIGNO DE ORGANO URINARIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D310",
    "nombre_dx": "D310-TUMOR BENIGNO DE LA CONJUNTIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "D311",
    "nombre_dx": "D311-TUMOR BENIGNO DE LA CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "D312",
    "nombre_dx": "D312-TUMOR BENIGNO DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "D313",
    "nombre_dx": "D313-TUMOR BENIGNO DE LA COROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "D314",
    "nombre_dx": "D314-TUMOR BENIGNO DEL CUERPO CILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D315",
    "nombre_dx": "D315-TUMOR BENIGNO DE LAS GLANDULAS Y DE LOS CONDUCTOS LAGRIMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "D316",
    "nombre_dx": "D316-TUMOR BENIGNO DE LA ORBITA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D319",
    "nombre_dx": "D319-TUMOR BENIGNO DEL OJO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D320",
    "nombre_dx": "D320-TUMOR BENIGNO DE LAS MENINGES CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "D321",
    "nombre_dx": "D321-TUMOR BENIGNO DE LAS MENINGES RAQUIDEAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D329",
    "nombre_dx": "D329-TUMOR BENIGNO DE LAS MENINGES, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D330",
    "nombre_dx": "D330-TUMOR BENIGNO DEL ENCEFALO, SUPRATENTORIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D331",
    "nombre_dx": "D331-TUMOR BENIGNO DEL ENCEFALO, INFRATENTORIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D332",
    "nombre_dx": "D332-TUMOR BENIGNO DE ENCEFALO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D333",
    "nombre_dx": "D333-TUMOR BENIGNO DE LOS NERVIOS CRANEALES",
    "sexo": "A"
  },
  {
    "cod_dx": "D334",
    "nombre_dx": "D334-TUMOR BENIGNO DE LA MEDULA ESPINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D337",
    "nombre_dx": "D337-TUMOR BENIGNO DE OTRAS PARTES ESPECIFICADAS DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D339",
    "nombre_dx": "D339-TUMOR BENIGNO DEL SISTEMA NERVIOSO CENTRAL, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D34X",
    "nombre_dx": "D34X-TUMOR BENIGNO DE LA GLANDULA TIROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D350",
    "nombre_dx": "D350-TUMOR BENIGNO DE LA GLANDULA SUPRARRENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D351",
    "nombre_dx": "D351-TUMOR BENIGNO DE LA GLANDULA PARATIROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D352",
    "nombre_dx": "D352-TUMOR BENIGNO DE LA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D353",
    "nombre_dx": "D353-TUMOR BENIGNO DEL CONDUCTO CRANEOFARINGEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D354",
    "nombre_dx": "D354-TUMOR BENIGNO DE LA GLANDULA PINEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D355",
    "nombre_dx": "D355-TUMOR BENIGNO DEL CUERPO CAROTIDEO",
    "sexo": "A"
  },
  {
    "cod_dx": "D356",
    "nombre_dx": "D356-TUMOR BENIGNO DEL CUERPO AORTICO Y DE OTROS CUERPOS CROMAFINES",
    "sexo": "A"
  },
  {
    "cod_dx": "D357",
    "nombre_dx": "D357-TUMOR BENIGNO DE OTRAS GLANDULAS ENDOCRINAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D358",
    "nombre_dx": "D358-TUMOR BENIGNO DE PLURIGLANDULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D359",
    "nombre_dx": "D359-TUMOR BENIGNO DE GLANDULA ENDOCRINA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D360",
    "nombre_dx": "D360-TUMOR BENIGNO DE LOS GANGLIOS LINFATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D361",
    "nombre_dx": "D361-TUMOR BENIGNO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUTONOMO",
    "sexo": "A"
  },
  {
    "cod_dx": "D367",
    "nombre_dx": "D367-TUMOR BENIGNO DE OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D369",
    "nombre_dx": "D369-TUMOR BENIGNO DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D370",
    "nombre_dx": "D370-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL LABIO, DE LA CAVIDAD BUCAL Y DE LA FARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D371",
    "nombre_dx": "D371-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ESTOMAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D372",
    "nombre_dx": "D372-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL INTESTINO DELGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D373",
    "nombre_dx": "D373-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL APENDICE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D374",
    "nombre_dx": "D374-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL COLON",
    "sexo": "A"
  },
  {
    "cod_dx": "D375",
    "nombre_dx": "D375-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "D376",
    "nombre_dx": "D376-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL HIGADO, DE LA VESICULA BILIAR Y DEL CONDUCTO BILI",
    "sexo": "A"
  },
  {
    "cod_dx": "D377",
    "nombre_dx": "D377-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS DIGESTIVOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D379",
    "nombre_dx": "D379-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANOS DIGESTIVOS, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D380",
    "nombre_dx": "D380-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D381",
    "nombre_dx": "D381-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA TRAQUEA, DE LOS BRONQUIOS Y DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "D382",
    "nombre_dx": "D382-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PLEURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D383",
    "nombre_dx": "D383-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL MEDIASTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D384",
    "nombre_dx": "D384-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D385",
    "nombre_dx": "D385-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS RESPIRATORIOS Y DEL OIDO MEDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "D386",
    "nombre_dx": "D386-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANOS RESPIRATORIOS, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D390",
    "nombre_dx": "D390-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "D391",
    "nombre_dx": "D391-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL OVARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D392",
    "nombre_dx": "D392-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PLACENTA ",
    "sexo": "F"
  },
  {
    "cod_dx": "D397",
    "nombre_dx": "D397-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS GENITALES FEMENINOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "D399",
    "nombre_dx": "D399-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO GENITAL FEMENINO NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "D400",
    "nombre_dx": "D400-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PROSTATA ",
    "sexo": "M"
  },
  {
    "cod_dx": "D401",
    "nombre_dx": "D401-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TESTICULO",
    "sexo": "M"
  },
  {
    "cod_dx": "D407",
    "nombre_dx": "D407-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS GENITALES MASCULINOS",
    "sexo": "M"
  },
  {
    "cod_dx": "D409",
    "nombre_dx": "D409-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO GENITAL MASCULINO NO ESPECIFICADO",
    "sexo": "M"
  },
  {
    "cod_dx": "D410",
    "nombre_dx": "D410-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RIÑON",
    "sexo": "A"
  },
  {
    "cod_dx": "D411",
    "nombre_dx": "D411-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEC LA PELVIS RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D412",
    "nombre_dx": "D412-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL URETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "D413",
    "nombre_dx": "D413-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA URETRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D414",
    "nombre_dx": "D414-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D417",
    "nombre_dx": "D417-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS ORGANOS URINARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D419",
    "nombre_dx": "D419-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE ORGANO URINARIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D420",
    "nombre_dx": "D420-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES CEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D421",
    "nombre_dx": "D421-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES RAQUIDEAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D429",
    "nombre_dx": "D429-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LAS MENINGES, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D430",
    "nombre_dx": "D430-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, SUPRATENTORIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D431",
    "nombre_dx": "D431-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, INFRATENTORIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D432",
    "nombre_dx": "D432-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL ENCEFALO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D433",
    "nombre_dx": "D433-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS NERVIOS CRANEALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D434",
    "nombre_dx": "D434-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA MEDULA ESPINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D437",
    "nombre_dx": "D437-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTRAS PARTES ESPECIFICADAS DEL SISTEMA NERVIOSO CE",
    "sexo": "A"
  },
  {
    "cod_dx": "D439",
    "nombre_dx": "D439-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL SISTEMA NERVIOSO CENTRAL, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D440",
    "nombre_dx": "D440-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA TIROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "D441",
    "nombre_dx": "D441-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA SUPRARRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D442",
    "nombre_dx": "D442-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA PARATIROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "D443",
    "nombre_dx": "D443-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D444",
    "nombre_dx": "D444-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CONDUCTO CRANEOFARINGEO",
    "sexo": "A"
  },
  {
    "cod_dx": "D445",
    "nombre_dx": "D445-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA GLANDULA PINEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "D446",
    "nombre_dx": "D446-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CUERPO CAROTIDEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D447",
    "nombre_dx": "D447-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL CUERPO AORTICO Y OTROS CROMAFINES",
    "sexo": "A"
  },
  {
    "cod_dx": "D448",
    "nombre_dx": "D448-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO CON AFECTACION PLURIGLANDULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D449",
    "nombre_dx": "D449-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE GLANDULA ENDOCRINA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D45X",
    "nombre_dx": "D45X-POLICITEMIA VERA",
    "sexo": "A"
  },
  {
    "cod_dx": "D460",
    "nombre_dx": "D460-Anemia refractaria sin sideroblastos en forma de anillo, asi descrita",
    "sexo": "A"
  },
  {
    "cod_dx": "D461",
    "nombre_dx": "D461-Anemia refractaria con sideroblastos en forma de anillo",
    "sexo": "A"
  },
  {
    "cod_dx": "D462",
    "nombre_dx": "D462-Anemia refractaria con exceso de blastos [AREB]",
    "sexo": "A"
  },
  {
    "cod_dx": "D464",
    "nombre_dx": "D464-ANEMIA REFRACTARIA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D465",
    "nombre_dx": "D465-Anemia refractaria con displasia multilinaje",
    "sexo": "A"
  },
  {
    "cod_dx": "D466",
    "nombre_dx": "D466-Síndrome mielodisplásico con anormalidad cromosómica aislada del (5q)",
    "sexo": "A"
  },
  {
    "cod_dx": "D467",
    "nombre_dx": "D467-OTROS SINDROMES MIELODISPLASICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D469",
    "nombre_dx": "D469-SINDROME MIELODISPLASICO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D470",
    "nombre_dx": "D470-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS MASTOCITOS E HISTIOCITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D471",
    "nombre_dx": "D471-ENFERMEDAD MIELOPROLIFERATIVA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D472",
    "nombre_dx": "D472-Gammopatía monoclonal de significado incierto [GMSI]",
    "sexo": "A"
  },
  {
    "cod_dx": "D473",
    "nombre_dx": "D473-Trombocitemia (hemorragica) esencial",
    "sexo": "A"
  },
  {
    "cod_dx": "D474",
    "nombre_dx": "D474-Osteomielofibrosis",
    "sexo": "A"
  },
  {
    "cod_dx": "D475",
    "nombre_dx": "D475-Leucemia eosinofílica crónica [síndrome hipereosinofílico]",
    "sexo": "A"
  },
  {
    "cod_dx": "D477",
    "nombre_dx": "D477-OTROS TUMORES ESPECIFICADOSDE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO LINFATICO, DE LOS O",
    "sexo": "A"
  },
  {
    "cod_dx": "D479",
    "nombre_dx": "D479-TUMORES DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO LINFATICO, DE LOS ORGANOS HEMATOPOYETICO",
    "sexo": "A"
  },
  {
    "cod_dx": "D480",
    "nombre_dx": "D480-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL HUESO Y CARTILAGO ARTICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D481",
    "nombre_dx": "D481-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL TEJIDO CONJUNTIVO Y OTRO TEJIDO BLANDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D482",
    "nombre_dx": "D482-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LOS NERVIOS PERIFERICOS Y DEL SISTEMA NERVIOSO AUT",
    "sexo": "A"
  },
  {
    "cod_dx": "D483",
    "nombre_dx": "D483-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL RETROPERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D484",
    "nombre_dx": "D484-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DEL PERITONEO",
    "sexo": "A"
  },
  {
    "cod_dx": "D485",
    "nombre_dx": "D485-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D486",
    "nombre_dx": "D486-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D487",
    "nombre_dx": "D487-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO DE OTROS SITIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D489",
    "nombre_dx": "D489-TUMOR DE COMPORTAMIENTO INCIERTO O DESCONOCIDO, DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D500",
    "nombre_dx": "D500-ANEMIA POR DEFICIENCIA DE HIERRO SECUNDARIA A PERDIDA DE SANGRE (CRONICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "D501",
    "nombre_dx": "D501-DISFAGIA SIDEROPENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D508",
    "nombre_dx": "D508-OTRAS ANEMIAS POR DEFICIENCIA DE HIERRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D509",
    "nombre_dx": "D509-ANEMIA POR DEFICIENCIA DE HIERRO SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "D510",
    "nombre_dx": "D510-ANEMIA POR DEFICIENCIA DE VITAMINA B12DEBIDA A DEFICIENCIA DEL FACTOR INTRINSECO",
    "sexo": "A"
  },
  {
    "cod_dx": "D511",
    "nombre_dx": "D511-ANEMIA POR DEFICIENCIA DE VITAMINA B12DEBIDA A MALA ABSORCION SELECTIVA DE VITAMINA B12 CON PROTEI",
    "sexo": "A"
  },
  {
    "cod_dx": "D512",
    "nombre_dx": "D512-DEFICIENCIA DE TRASCOBALAMINA II",
    "sexo": "A"
  },
  {
    "cod_dx": "D513",
    "nombre_dx": "D513-OTRAS ANEMIAS POR DEFICIENCIA DIETETICA DE VITAMINA B12 ",
    "sexo": "A"
  },
  {
    "cod_dx": "D518",
    "nombre_dx": "D518-OTRAS ANEMIAS POR DEFICIENCIA DE VITAMINA B12 ",
    "sexo": "A"
  },
  {
    "cod_dx": "D519",
    "nombre_dx": "D519-ANEMIA POR DEFICIENCIA DE VITAMINA B12, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D520",
    "nombre_dx": "D520-ANEMIA POR DEFICIENCIA DIETETICA DE FOLATOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D521",
    "nombre_dx": "D521-ANEMIA POR DEFICIENCIA DE FOLATOS INDUCIDA POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D528",
    "nombre_dx": "D528-OTRAS ANEMIASPOR DEFICIENCIA DE FOLATOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D529",
    "nombre_dx": "D529-ANEMIA POR DEFICIENCIA DE FOLATOS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "D530",
    "nombre_dx": "D530-ANEMIA POR DEFICIENCIA DE PROTEINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D531",
    "nombre_dx": "D531-OTRAS ANEMIAS MEGALOBLASTICAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "D532",
    "nombre_dx": "D532-ANEMIA ESCORBUTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "D538",
    "nombre_dx": "D538-OTRAS ANEMIAS NUTRICIONALES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D539",
    "nombre_dx": "D539-ANEMIA NUTRICIONAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D550",
    "nombre_dx": "D550-ANEMIA DEBIDA A DEFICIENCIADE GLUCOSA-6-FOSFATO DESHIDROGENASA (G6FD) ",
    "sexo": "A"
  },
  {
    "cod_dx": "D551",
    "nombre_dx": "D551-ANEMIA DEBIDA A OTROS TRASTORNOS DEL METABOLISMO DEL GLUTATION",
    "sexo": "A"
  },
  {
    "cod_dx": "D552",
    "nombre_dx": "D552-ANEMIA DEBIDA A TRASTORNOS DE LAS ENZIMAS GLUCOLITICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D553",
    "nombre_dx": "D553-ANEMIA DEBIDA A TRASTORNOS DEL METABOLISMO DE LOS NUCLEOTIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D558",
    "nombre_dx": "D558-OTRAS ANEMIAS DEBIDAS A TRASTORNOS ENZIMATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D559",
    "nombre_dx": "D559-ANEMIA DEBIDA A TRASTORNOS ENZIMATICOS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D560",
    "nombre_dx": "D560-ALFA TALASEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D561",
    "nombre_dx": "D561-BETA TALASEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D562",
    "nombre_dx": "D562-DELTA-BETA TALASEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D563",
    "nombre_dx": "D563-RASGO TALASEMICO",
    "sexo": "A"
  },
  {
    "cod_dx": "D564",
    "nombre_dx": "D564-PERSISTENCIA HEREDITARIA DE LA HEMOGLOBINA FETAL (PHHF) ",
    "sexo": "A"
  },
  {
    "cod_dx": "D568",
    "nombre_dx": "D568-OTRAS TALASEMIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D569",
    "nombre_dx": "D569-TALASEMIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D570",
    "nombre_dx": "D570-ANEMIA FALCIFORME CON CRISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "D571",
    "nombre_dx": "D571-ANEMIA FALCIFORME SIN CRISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "D572",
    "nombre_dx": "D572-TRASTORNOS FALCIFORMES HETEROCIGOTICOS DOBLES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D573",
    "nombre_dx": "D573-RASGO DREPANOCITICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D578",
    "nombre_dx": "D578-OTROS TRASTORNOS FALCIFORMES",
    "sexo": "A"
  },
  {
    "cod_dx": "D580",
    "nombre_dx": "D580-ESFEROCITOSIS HEREDITARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D581",
    "nombre_dx": "D581-ELIPTOCITOSIS HEREDITARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D582",
    "nombre_dx": "D582-OTRAS HEMOGLOBINOPATIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D588",
    "nombre_dx": "D588-OTRAS ANEMIAS HEMOLITICAS HEREDITARIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D589",
    "nombre_dx": "D589-ANEMIA HEMOLITICA HEREDITARIA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "D590",
    "nombre_dx": "D590-ANEMIA HEMOLITICA AUTOINMUNE INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D591",
    "nombre_dx": "D591-OTRAS ANEMIAS HEMOLITICAS AUTOINMUNES ",
    "sexo": "A"
  },
  {
    "cod_dx": "D592",
    "nombre_dx": "D592-ANEMIA HEMOLITICA NOAUTOINMUNE INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D593",
    "nombre_dx": "D593-SINDROME HEMOLITICO-UREMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D594",
    "nombre_dx": "D594-OTRAS ANEMIAS HEMOLITICAS NO AUTOINMUNES",
    "sexo": "A"
  },
  {
    "cod_dx": "D595",
    "nombre_dx": "D595-HEMOGLOBINURIA PAROXISTICA NOCTURNA [MARCHIAFAVA-MICHELI] ",
    "sexo": "A"
  },
  {
    "cod_dx": "D596",
    "nombre_dx": "D596-HEMOGLOBINURIA DEBIDA A HEMOLISIS POR OTRAS CAUSAS EXTERNAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D598",
    "nombre_dx": "D598-OTRAS ANEMIAS HEMOLITICAS ADQUIRIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D599",
    "nombre_dx": "D599-ANEMIAS HEMOLITICA ADQUIRIDA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D600",
    "nombre_dx": "D600-APLASIA CRONICA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D601",
    "nombre_dx": "D601-APLASIA TRANSITORIA ADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D608",
    "nombre_dx": "D608-OTRAS APLASIAS ADQUIRIDAS, EXCLUSIVAS DE LA SERIE ROJA",
    "sexo": "A"
  },
  {
    "cod_dx": "D609",
    "nombre_dx": "D609-APLASIAADQUIRIDA, EXCLUSIVA DE LA SERIE ROJA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D610",
    "nombre_dx": "D610-ANEMIA APLASTICA CONSTITUCIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D611",
    "nombre_dx": "D611-ANEMIA APLASTICA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D612",
    "nombre_dx": "D612-ANEMIA APLASTICA DEBIDA A OTROS AGENTES EXTERNOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D613",
    "nombre_dx": "D613-ANEMIA APLASTICA IDIOPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D618",
    "nombre_dx": "D618-OTRAS ANEMIAS APLASTICAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D619",
    "nombre_dx": "D619-ANEMIA APLASTICA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D62X",
    "nombre_dx": "D62X-ANEMIA POSTHEMORRAGICA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "D630",
    "nombre_dx": "D630-ANEMIAEN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "D638",
    "nombre_dx": "D638-ANEMIA EN OTRAS ENFERMEDADES CRONICAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "D640",
    "nombre_dx": "D640-ANEMIA SIDEROBLASTICA HEREDITARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D641",
    "nombre_dx": "D641-ANEMIA SIDEROBLASTICA SECUNDARIA A OTRA ENFERMEDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "D642",
    "nombre_dx": "D642-ANEMIA SIDEROBLASTICA SECUNDARIA, DEBIDA A DROGAS Y TOXINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D643",
    "nombre_dx": "D643-OTRAS ANEMIAS SIDEROBLASTICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D644",
    "nombre_dx": "D644-ANEMIA DISERITROPOYETICA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "D648",
    "nombre_dx": "D648-OTRAS ANEMIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D649",
    "nombre_dx": "D649-ANEMIA DE TIPO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D65X",
    "nombre_dx": "D65X-COAGULACION INTRAVASCULAR DISEMINADA [SINDROME DE DESFIBRINACION] ",
    "sexo": "A"
  },
  {
    "cod_dx": "D66X",
    "nombre_dx": "D66X-DEFICIENCIA HEREDITARIA DEL FACTOR VIII ",
    "sexo": "M"
  },
  {
    "cod_dx": "D67X",
    "nombre_dx": "D67X-DEFICIENCIA HEREDITARIA DEL FACTOR IX ",
    "sexo": "M"
  },
  {
    "cod_dx": "D680",
    "nombre_dx": "D680-ENFERMEDAD DE VON WILLEBRAND",
    "sexo": "A"
  },
  {
    "cod_dx": "D681",
    "nombre_dx": "D681-DEFICIENCIA HEREDITARIA DEL FACTOR XI ",
    "sexo": "M"
  },
  {
    "cod_dx": "D682",
    "nombre_dx": "D682-DEFICIENCIA HEREDITARIA DE OTROS FACTORES DE LA COAGULACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D683",
    "nombre_dx": "D683-TRASTORNO HEMORRAGICO DEBIDO A ANTICOAGULANTES CIRCULANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "D684",
    "nombre_dx": "D684-DEFICIENCIA ADQUIRIDA DE FACTORES DE LA COAGULACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "D685",
    "nombre_dx": "D685-Trombofilia primaria",
    "sexo": "A"
  },
  {
    "cod_dx": "D686",
    "nombre_dx": "D686-Otra trombofilia",
    "sexo": "A"
  },
  {
    "cod_dx": "D688",
    "nombre_dx": "D688-OTROS DEFECTOS ESPECIFICADOS DE LA COAGULACION",
    "sexo": "A"
  },
  {
    "cod_dx": "D689",
    "nombre_dx": "D689-DEFECTO DE LA COAGULACION, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D690",
    "nombre_dx": "D690-PURPURA ALERGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "D691",
    "nombre_dx": "D691-DEFECTOS CUALITATIVOS DE LAS PLAQUETAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D692",
    "nombre_dx": "D692-OTRAS PURPURAS NO TROMBOCITOPENICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D693",
    "nombre_dx": "D693-PURPURA TROMBOCITOPENICA IDIOPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D694",
    "nombre_dx": "D694-OTRAS TROMBOCITOPENIAS PRIMARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D695",
    "nombre_dx": "D695-TROMBOCITOPENIA SECUNDARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D696",
    "nombre_dx": "D696-TROMBOCITOPENIA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D698",
    "nombre_dx": "D698-OTRAS AFECCIONES HEMORRAGICASESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D699",
    "nombre_dx": "D699-AFECCION HEMORRAGICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D70X",
    "nombre_dx": "D70X-AGRANULOCITOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D71X",
    "nombre_dx": "D71X-TRASTORNOS FUNCIONALES DE LOS POLIMORFONUCLEARES NEUTROFILOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D720",
    "nombre_dx": "D720-ANOMALIAS GENETICAS DE LOS LEUCOCITOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D721",
    "nombre_dx": "D721-EOSINOFILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D728",
    "nombre_dx": "D728-OTROS TRASTORNOS ESPECIFICADOS DE LOS LEUCOCITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D729",
    "nombre_dx": "D729-TRASTORNOSDE LOS LEUCOCITOS,NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D730",
    "nombre_dx": "D730-HIPOESPLENISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "D731",
    "nombre_dx": "D731-HIPERESPLENISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D732",
    "nombre_dx": "D732-ESPLENOMEGALIA CONGESTIVA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D733",
    "nombre_dx": "D733-ABSCESO DEL BAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "D734",
    "nombre_dx": "D734-QUISTE DEL BAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D735",
    "nombre_dx": "D735-INFARTO DEL BAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "D738",
    "nombre_dx": "D738-OTRAS ENFERMEDADES DEL BAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D739",
    "nombre_dx": "D739-ENFERMEDAD DEL BAZO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D740",
    "nombre_dx": "D740-METAHEMOGLOBINEMIA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "D748",
    "nombre_dx": "D748-OTRAS METAHEMOGLOBINEMIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D749",
    "nombre_dx": "D749-METAHEMOGLOBINEMIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D750",
    "nombre_dx": "D750-ERITROCITOSIS FAMILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D751",
    "nombre_dx": "D751-POLICITEMIA SECUNDARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D758",
    "nombre_dx": "D758-OTRAS ENFERMEDADES ESPECIFICADAS DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D759",
    "nombre_dx": "D759-ENFERMEDADDE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D761",
    "nombre_dx": "D761-LINFOHISTIOCITOSIS HEMOFAGOCITICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D762",
    "nombre_dx": "D762-SINDROME HEMOFAGOCITICO ASOCIADO A INFECCION",
    "sexo": "A"
  },
  {
    "cod_dx": "D763",
    "nombre_dx": "D763-OTROS SINDROMES HISTIOCITICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D76X",
    "nombre_dx": "D76X-Otras enfermedades especificadas con participación del tejido linforreticular y del tejido reticulohistiocítico (antes CIERTAS ENFERMEDADES QUE AFECTAN EL TEJIDO LINFORRETICULAR Y AL SISTEMA RETICULOENDOTELIAL)",
    "sexo": "A"
  },
  {
    "cod_dx": "D77X",
    "nombre_dx": "D77X-OTROS TRASTORNOS DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS EN ENFERMEDADES CLASIFICADAS EN OTRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D800",
    "nombre_dx": "D800-HIPOGAMMAGLOBULINEMIA HEREDITARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D801",
    "nombre_dx": "D801-HIPOGAMMAGLOBULINEMIA NO FAMILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D802",
    "nombre_dx": "D802-DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA A [IgA]",
    "sexo": "A"
  },
  {
    "cod_dx": "D803",
    "nombre_dx": "D803-DEFICIENCIA SELECTIVA DE SUBCLASES DE LA INMUNOGLOBULINA G [IgG]",
    "sexo": "A"
  },
  {
    "cod_dx": "D804",
    "nombre_dx": "D804-DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA M [IgM]",
    "sexo": "A"
  },
  {
    "cod_dx": "D805",
    "nombre_dx": "D805-INMUNODEFICIENCIA CON INCREMENTO DE INMUNOGLOBULINA M [IgM] ",
    "sexo": "A"
  },
  {
    "cod_dx": "D806",
    "nombre_dx": "D806-DEFICIENCIA DE ANTICUERPOS CON INMUNOGLOBULINAS CASI NORMALES O CON HIPERINMUNOGLOBULINEMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D807",
    "nombre_dx": "D807-HIPOGAMMAGLOBULINEMIA TRANSITORIA DE LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D808",
    "nombre_dx": "D808-OTRAS INMUNODEFICIENCIAS CON PREDOMINIO DE DEFECTOS DE LOS ANTICUERPOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D809",
    "nombre_dx": "D809-INMUNODEFICIENCIA CON PREDOMINIO DE DEFECTOS DE LOS ANTICUERPOS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D810",
    "nombre_dx": "D810-INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON DISGENESIA RETICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D811",
    "nombre_dx": "D811-INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON LINFOCITOPENIA T Y B",
    "sexo": "A"
  },
  {
    "cod_dx": "D812",
    "nombre_dx": "D812-INMUNODEFICIENCIA COMBINADA SEVERA [IDCS] CON CIFRA BAJA O NORMAL DE LINFOCITOS B ",
    "sexo": "A"
  },
  {
    "cod_dx": "D813",
    "nombre_dx": "D813-DEFICIENCIA DE LA ADENOSINA DEAMINASA [ADA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "D814",
    "nombre_dx": "D814-SINDROME DE NEZELOF ",
    "sexo": "A"
  },
  {
    "cod_dx": "D815",
    "nombre_dx": "D815-DEFICIENCIA DE LA FOSFORILASA PURINONUCLEOSIDA [FPN]",
    "sexo": "A"
  },
  {
    "cod_dx": "D816",
    "nombre_dx": "D816-DEFICIENCIA DE LA CLASE I DEL COMPLEJO DE HISTOCOMPATIBILIDAD MAYOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "D817",
    "nombre_dx": "D817-DEFICIENCIA DE LA CLASE II DEL COMPLEJO DE HISTOCOMPATIBILIDAD MAYOR",
    "sexo": "A"
  },
  {
    "cod_dx": "D818",
    "nombre_dx": "D818-OTRAS INMUNODEFICIENCIAS COMBINADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D819",
    "nombre_dx": "D819-INMUNODEFICIENCIA COMBINADA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "D820",
    "nombre_dx": "D820-SINDROME DE WISKOTT-ALDRICH ",
    "sexo": "A"
  },
  {
    "cod_dx": "D821",
    "nombre_dx": "D821-SINDROME DE DI GEORGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "D822",
    "nombre_dx": "D822-INMUNODEFICIENCIA CON ENANISMO MICROMELICO [MIEMBROS CORTOS]",
    "sexo": "A"
  },
  {
    "cod_dx": "D823",
    "nombre_dx": "D823-INMUNODEFICIENCIA CONSECUTIVA A RESPUESTA DEFECTUOSA HEREDITARIA CONTRA EL VIRUS DE EPSTEIN-BARR",
    "sexo": "A"
  },
  {
    "cod_dx": "D824",
    "nombre_dx": "D824-SINDROME DE HIPERINMUNOGLOBULINA E [IgE]",
    "sexo": "A"
  },
  {
    "cod_dx": "D828",
    "nombre_dx": "D828-INMUNODEFICIENCIA ASOCIADA CON OTROS DEFECTOS MAYORES ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D829",
    "nombre_dx": "D829-INMUNODEFICIENCIA ASOCIADA CON OTROS DEFECTOS MAYORES NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D830",
    "nombre_dx": "D830-INMUNODEFICIENCIA VARIABLE COMUN CON PREDOMINIO DE ANORMALIDADES EN EL NUMERO Y LA FUNCION DE LOS LI",
    "sexo": "A"
  },
  {
    "cod_dx": "D831",
    "nombre_dx": "D831-INMUNODEFICIENCIA VARIABLE COMUN CON PREDOMINIO DE TRASTORNOS INMUNORREGULADORES DE LOS LINFOCITOS T",
    "sexo": "A"
  },
  {
    "cod_dx": "D832",
    "nombre_dx": "D832-INMUNODEFICIENCIA VARIABLE COMUN CON AUTOANTICUERPOS ANTI-B O ANTI-T",
    "sexo": "A"
  },
  {
    "cod_dx": "D838",
    "nombre_dx": "D838-OTRAS INMUNODEFICIENCIAS VARIABLES COMUNES",
    "sexo": "A"
  },
  {
    "cod_dx": "D839",
    "nombre_dx": "D839-INMUNODEFICIENCIA VARIABLE COMUN, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D840",
    "nombre_dx": "D840-DEFECTO DE LA FUNCION DEL ANTIGENO-1 DEL LINFOCITO [LFA-1]",
    "sexo": "A"
  },
  {
    "cod_dx": "D841",
    "nombre_dx": "D841-DEFECTO DEL SISTEMA DEL COMPLEMENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "D848",
    "nombre_dx": "D848-OTRAS INMUNODEFICIENCIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "D849",
    "nombre_dx": "D849-INMUNODEFICIENCIA, NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D860",
    "nombre_dx": "D860-SARCOIDOSIS DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "D861",
    "nombre_dx": "D861-SARCOIDOSIS DE LOS GANGLIOS LINFÁTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D862",
    "nombre_dx": "D862-SARCOIDOSIS DEL PULMON Y DE LOS GANGLIOS LINFATICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "D863",
    "nombre_dx": "D863-SARCOIDOSIS DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "D868",
    "nombre_dx": "D868-SARCOIDOSIS DE OTROS SITIOS ESPECIFICADOS O DE SITIOS COMBINADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "D869",
    "nombre_dx": "D869-SARCOIDOSIS DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "D890",
    "nombre_dx": "D890-HIPERGAMMAGLOBULINEMIA POLICLONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "D891",
    "nombre_dx": "D891-CRIOGLOBULINEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "D892",
    "nombre_dx": "D892-HIPERGAMMAGLOBULINEMIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "D893",
    "nombre_dx": "D893-Síndrome de reconstitución inmune",
    "sexo": "A"
  },
  {
    "cod_dx": "D898",
    "nombre_dx": "D898-OTROS TRASTORNOS ESPECIFICADOS QUE AFECTAN EL MECANISMO DE LA INMUNIDAD, NO CLASIFICADOS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "D899",
    "nombre_dx": "D899-TRASTORNO QUE AFECTA AL MECANISMO DE LA INMUNIDAD, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E000",
    "nombre_dx": "E000-SINDROME CONGENITO DE DEFICIENCIA DE YODO, TIPO NEUROLOGICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E001",
    "nombre_dx": "E001-SINDROME DE DEFICIENCIA CONGENITA DE YODO, TIPO MIXEDEMATOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "E002",
    "nombre_dx": "E002-SINDROME CONGENITO DE DEFICIENCIA DE YODO, TIPO MIXTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E009",
    "nombre_dx": "E009-SINDROME CONGENITO DE DEFICIENCIA DE YODO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E010",
    "nombre_dx": "E010-BOCIO DIFUSO (ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E011",
    "nombre_dx": "E011-BOCIO MULTINODULAR(ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO",
    "sexo": "A"
  },
  {
    "cod_dx": "E012",
    "nombre_dx": "E012-BOCIO (ENDEMICO) RELACIONADO CON DEFICIENCIA DE YODO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E018",
    "nombre_dx": "E018-OTROS TRASTORNOS DE LA TIROIDES RELACIONADOS CON DEFICIENCIA DE YODO Y AFECCIONES SIMILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E02X",
    "nombre_dx": "E02X-HIPOTIROIDISMO SUBCLINICO POR DEFICIENCIA DE YODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E030",
    "nombre_dx": "E030-HIPOTIROIDISMO CONGENITO CON BOCIO DIFUSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E031",
    "nombre_dx": "E031-HIPOTIROIDISMO CONGENITO SIN BOCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E032",
    "nombre_dx": "E032-HIPOTIROIDISMO DEBIDO A MEDICAMENTOS Y A OTRAS SUSTANCIAS EXOGENAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E033",
    "nombre_dx": "E033-HIPOTIROIDISMO POSTINFECCIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E034",
    "nombre_dx": "E034-ATROFIA DE TIROIDES (ADQUIRIDA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "E035",
    "nombre_dx": "E035-COMA MIXEDEMATOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E038",
    "nombre_dx": "E038-OTROS HIPOTIROIDISMOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E039",
    "nombre_dx": "E039-HIPOTIROIDISMO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E040",
    "nombre_dx": "E040-BOCIO DIFUSO NO TOXICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E041",
    "nombre_dx": "E041-NODULO TIROIDEO SOLITARIO NO TOXICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E042",
    "nombre_dx": "E042-BOCIO MULTINODULAR NO TOXICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E048",
    "nombre_dx": "E048-OTROS BOCIOS NO TOXICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E049",
    "nombre_dx": "E049-BOCIO NO TOXICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E050",
    "nombre_dx": "E050-TIROTOXICOSIS CON BOCIO DIFUSO",
    "sexo": "A"
  },
  {
    "cod_dx": "E051",
    "nombre_dx": "E051-TIROTOXICOSIS CON NODULO SOLITARIO TIROIDEO TOXICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E052",
    "nombre_dx": "E052-TIROTOXICOSIS CON BOCIO MULTINODULAR TOXICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E053",
    "nombre_dx": "E053-TIROTOXICOSIS POR TEJIDO TIROIDEO ECTOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E054",
    "nombre_dx": "E054-TIROTOXICOSIS FACTICIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E055",
    "nombre_dx": "E055-CRISIS O TORMENTA TIROTOXICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E058",
    "nombre_dx": "E058-OTRAS TIROTOXICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E059",
    "nombre_dx": "E059-TIROTOXICOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E060",
    "nombre_dx": "E060-TIROIDITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "E061",
    "nombre_dx": "E061-TIROIDITIS SUBAGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E062",
    "nombre_dx": "E062-TIROIDITIS CRONICA CON TIROTOXICOSIS TRANSITORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E063",
    "nombre_dx": "E063-TIROIDITIS AUTOINMUNE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E064",
    "nombre_dx": "E064-TIROIDITIS INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E065",
    "nombre_dx": "E065-OTRAS TIROIDITIS CRONICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E069",
    "nombre_dx": "E069-TIROIDITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E070",
    "nombre_dx": "E070-HIPERSECRECION DE CALCITONINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E071",
    "nombre_dx": "E071-BOCIO DISHORMOGENETICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E078",
    "nombre_dx": "E078-OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA TIROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "E079",
    "nombre_dx": "E079-TRASTORNO DE LA GLANDULA TIROIDES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E100",
    "nombre_dx": "E100-DIABETES MELLITUS INSULINODEPENDIENTE CON COMA",
    "sexo": "A"
  },
  {
    "cod_dx": "E101",
    "nombre_dx": "E101-DIABETES MELLITUS INSULINODEPENDIENTE CON CETOACIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E102",
    "nombre_dx": "E102-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONES RENALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E103",
    "nombre_dx": "E103-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONES OFTALMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E104",
    "nombre_dx": "E104-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONES NEUROLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E105",
    "nombre_dx": "E105-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONES CIRCULATORIAS PERIFERICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E106",
    "nombre_dx": "E106-DIABETES MELLITUS INSULINODEPENDIENTE CON OTRAS COMPLICACIONES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E107",
    "nombre_dx": "E107-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONES MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "E108",
    "nombre_dx": "E108-DIABETES MELLITUS INSULINODEPENDIENTE CON COMPLICACIONESNO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E109",
    "nombre_dx": "E109-DIABETES MELLITUS INSULINODEPENDIENTE SIN MENCION DE COMPLICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "E110",
    "nombre_dx": "E110-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E111",
    "nombre_dx": "E111-DIABETES MELLITUS NO INSULINODEPENDIENTE CON CETOACIDOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E112",
    "nombre_dx": "E112-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONES RENALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E113",
    "nombre_dx": "E113-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONES OFTALMICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E114",
    "nombre_dx": "E114-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONES NEUROLOGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E115",
    "nombre_dx": "E115-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONES CIRCULATORIAS PERIFERICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E116",
    "nombre_dx": "E116-DIABETES MELLITUS NO INSULINODEPENDIENTE CON OTRAS COMPLICACIONES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E117",
    "nombre_dx": "E117-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONES MULTIPLES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E118",
    "nombre_dx": "E118-DIABETES MELLITUS NO INSULINODEPENDIENTE CON COMPLICACIONESNO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E119",
    "nombre_dx": "E119-DIABETES MELLITUS NO INSULINODEPENDIENTE SIN MENCION DE COMPLICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E120",
    "nombre_dx": "E120-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMA",
    "sexo": "A"
  },
  {
    "cod_dx": "E121",
    "nombre_dx": "E121-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON CETOACIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E122",
    "nombre_dx": "E122-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES RENALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E123",
    "nombre_dx": "E123-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES OFTALMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E124",
    "nombre_dx": "E124-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES NEUROLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E125",
    "nombre_dx": "E125-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES CIRCULATORIAS PERIFERICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E126",
    "nombre_dx": "E126-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON OTRAS COMPLICACIONES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E127",
    "nombre_dx": "E127-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "E128",
    "nombre_dx": "E128-DIABETES MELLITUS ASOCIADA CON DESNUTRICION CON COMPLICACIONES NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E129",
    "nombre_dx": "E129-DIABETES MELLITUS ASOCIADA CON DESNUTRICIONSIN MENCION DE COMPLICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E130",
    "nombre_dx": "E130-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMA",
    "sexo": "A"
  },
  {
    "cod_dx": "E131",
    "nombre_dx": "E131-OTRAS DIABETES MELLITUS ESPECIFICADAS CON CETOACIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E132",
    "nombre_dx": "E132-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES RENALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E133",
    "nombre_dx": "E133-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES OFTALMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E134",
    "nombre_dx": "E134-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES NEUROLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E135",
    "nombre_dx": "E135-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES CIRCULATORIAS PERIFERICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E136",
    "nombre_dx": "E136-OTRAS DIABETES MELLITUS ESPECIFICADAS CON OTRAS COMPLICACIONES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E137",
    "nombre_dx": "E137-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "E138",
    "nombre_dx": "E138-OTRAS DIABETES MELLITUS ESPECIFICADAS CON COMPLICACIONES NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E139",
    "nombre_dx": "E139-OTRAS DIABETES MELLITUS ESPECIFICADAS SIN MENCION DE COMPLICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "E140",
    "nombre_dx": "E140-DIABETES MELLITUS, NO ESPECIFICADA CON COMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E141",
    "nombre_dx": "E141-DIABETES MELLITUS, NO ESPECIFICADA CON CETOACIDOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E142",
    "nombre_dx": "E142-DIABETES MELLITUS, NO ESPECIFICADA CON COMPLICACIONES RENALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E143",
    "nombre_dx": "E143-DIABETES MELLITUS, NO ESPECIFICADA CON COMPLICACIONES OFTALMICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E144",
    "nombre_dx": "E144-DIABETES MELLITUS, NO ESPECIFICADA CON COMPLICACIONES NEUROLOGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E145",
    "nombre_dx": "E145-DIABETES MELLITUS, NOESPECIFICADA CON COMPLICACIONES CIRCULATORIAS PERIFERICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E146",
    "nombre_dx": "E146-DIABETES MELLITUS, NO ESPECIFICADA CON OTRAS COMPLICACIONES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E147",
    "nombre_dx": "E147-DIABETES MELLITUS, NO ESPECIFICADA CON COMPLICACIONES MULTIPLES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E148",
    "nombre_dx": "E148-DIABETES MELLITUS, NO ESPECIFICADA CON COMPLICACIONES NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E149",
    "nombre_dx": "E149-DIABETES MELLITUS, NO ESPECIFICADA SIN MENCION DE COMPLICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E15X",
    "nombre_dx": "E15X-COMA HIPOGLICEMICO NO DIABETICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E160",
    "nombre_dx": "E160-HIPOGLICEMIA SIN COMA, INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E161",
    "nombre_dx": "E161-OTRAS HIPOGLICEMIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E162",
    "nombre_dx": "E162-HIPOGLICEMIA , NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E163",
    "nombre_dx": "E163-SECRECION EXAGERADA DEL GLUCAGON",
    "sexo": "A"
  },
  {
    "cod_dx": "E164",
    "nombre_dx": "E164-SECRECION ANORMAL DE GASTRINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E168",
    "nombre_dx": "E168-OTROS TRASTORNOS ESPECIFICADOS DE LA SECRECION INTERNA DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E169",
    "nombre_dx": "E169-TRASTORNOS DE LA SECRECION INTERNA DEL PANCREAS, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E200",
    "nombre_dx": "E200-HIPOPARATIROIDISMO IDIOPATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E201",
    "nombre_dx": "E201-PSEUDOHIPOPARATIROIDISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E208",
    "nombre_dx": "E208-OTROS TIPOS DE HIPOPARATIROIDISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E209",
    "nombre_dx": "E209-HIPOPARATIROIDISMO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E210",
    "nombre_dx": "E210-HIPERPARATIROIDISMO PRIMARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E211",
    "nombre_dx": "E211-HIPERPARATIROIDISMO SECUNDARIO NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E212",
    "nombre_dx": "E212-OTROS TIPOS DE HIPERPARATIROIDISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E213",
    "nombre_dx": "E213-HIPERPARATIROIDISMO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E214",
    "nombre_dx": "E214-OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA PARATIROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "E215",
    "nombre_dx": "E215-TRASTORNO DE LA GLANDULA PARATIROIDES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E220",
    "nombre_dx": "E220-ACROMEGALIA Y GIGANTISMO HIPOFISARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E221",
    "nombre_dx": "E221-HIPERPROLACTINEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E222",
    "nombre_dx": "E222-SINDROME DE SECRECION INAPROPIADA DE HORMONA ANTIDIURETICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E228",
    "nombre_dx": "E228-OTRAS HIPERFUNCIONES DE LA GLANDULA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E229",
    "nombre_dx": "E229-HIPERFUNCION DE LA GLANDULA HIPOFISIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E230",
    "nombre_dx": "E230-HIPOPITUITARISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E231",
    "nombre_dx": "E231-HIPOPITUITARISMO INDUCIDO POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E232",
    "nombre_dx": "E232-DIABETES INSIPIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E233",
    "nombre_dx": "E233-DISFUNCION HIPOTALAMICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E236",
    "nombre_dx": "E236-OTROS TRASTORNOS DE LA GLANDULA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E237",
    "nombre_dx": "E237-TRASTORNO DE LA GLANDULA HIPOFISIS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E240",
    "nombre_dx": "E240-ENFERMEDAD DE CUSHING DEPENDIENTE DE LA HIPOFISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E241",
    "nombre_dx": "E241-SINDROME DE NELSON",
    "sexo": "A"
  },
  {
    "cod_dx": "E242",
    "nombre_dx": "E242-SINDROME DE CUSHING INDUCIDO POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E243",
    "nombre_dx": "E243-SINDROMEDE ACTH ECTOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E244",
    "nombre_dx": "E244-SINDROME DE SEUDO-CUSHING INDUCIDO POR ALCOHOL",
    "sexo": "A"
  },
  {
    "cod_dx": "E248",
    "nombre_dx": "E248-OTROS TIPOS DE SINDROME DE CUSHING",
    "sexo": "A"
  },
  {
    "cod_dx": "E249",
    "nombre_dx": "E249-SINDROME DE CUSHING, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E250",
    "nombre_dx": "E250-TRASTORNOS ADRENOGENITALES CONGENITOS CON DEFICIENCIA ENZIMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E258",
    "nombre_dx": "E258-OTROS TRASTORNOS ADRENOGENITALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E259",
    "nombre_dx": "E259-TRASTORNO ADRENOGENITAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E260",
    "nombre_dx": "E260-HIPERALDOSTERONISMO PRIMARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E261",
    "nombre_dx": "E261-HIPERALDOSTERONISMO SECUNDARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E268",
    "nombre_dx": "E268-OTROS TIPOS DE HIPERALDOSTERONISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E269",
    "nombre_dx": "E269-HIPERALDOSTERONISMO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E270",
    "nombre_dx": "E270-OTRA HIPERACTIVIDAD CORTICOSUPRARRENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "E271",
    "nombre_dx": "E271-INSUFICIENCIA CORTICOSUPRARRENAL PRIMARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E272",
    "nombre_dx": "E272-CRISIS ADDISONIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "E273",
    "nombre_dx": "E273-INSUFICIENCIA CORTICOSUPRARRENAL INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E274",
    "nombre_dx": "E274-OTRAS INSUFICIENCIAS CORTICOSUPRARRENALES Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E275",
    "nombre_dx": "E275-HIPERFUNCION DE LA MEDULA SUPRARRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "E278",
    "nombre_dx": "E278-OTROS TRASTORNOS ESPECIFICADOS DE LA GLANDULA SUPRARRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "E279",
    "nombre_dx": "E279-TRASTORNO DE LA GLANDULA SUPRARRENAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E280",
    "nombre_dx": "E280-EXCESO DE ESTROGENOS",
    "sexo": "F"
  },
  {
    "cod_dx": "E281",
    "nombre_dx": "E281-EXCESO DE ANDROGENOS",
    "sexo": "F"
  },
  {
    "cod_dx": "E282",
    "nombre_dx": "E282-SINDROME DE OVARIO POLIQUISTICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "E283",
    "nombre_dx": "E283-INSUFICIENCIA OVARICA PRIMARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "E288",
    "nombre_dx": "E288-OTRAS DISFUNCIONES OVARICAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "E289",
    "nombre_dx": "E289-DISFUNCION OVARICA, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "E290",
    "nombre_dx": "E290-HIPERFUNCION TESTICULAR ",
    "sexo": "M"
  },
  {
    "cod_dx": "E291",
    "nombre_dx": "E291-HIPOFUNCION TESTICULAR",
    "sexo": "M"
  },
  {
    "cod_dx": "E298",
    "nombre_dx": "E298-OTRAS DISFUNCIONES TESTICULARES ",
    "sexo": "M"
  },
  {
    "cod_dx": "E299",
    "nombre_dx": "E299-DISFUNCION TESTICULAR, NO ESPECIFICADA",
    "sexo": "M"
  },
  {
    "cod_dx": "E300",
    "nombre_dx": "E300-PUBERTAD RETARDADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E301",
    "nombre_dx": "E301-PUBERTAD PRECOZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "E308",
    "nombre_dx": "E308-OTROS TRASTORNOS DE LA PUBERTAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "E309",
    "nombre_dx": "E309-TRASTORNO DE LA PUBERTAD, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E310",
    "nombre_dx": "E310-INSUFICIENCIA PILOGLANDULAR AUTOINMUNE",
    "sexo": "A"
  },
  {
    "cod_dx": "E311",
    "nombre_dx": "E311-HIPERFUNCION POLIGLANDULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "E318",
    "nombre_dx": "E318-OTRAS DISFUNCIONES POLIGLANDULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "E319",
    "nombre_dx": "E319-DISFUNCION POLIGLANDULAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E320",
    "nombre_dx": "E320-HIPERPLASIA PERSISTENTE DEL TIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E321",
    "nombre_dx": "E321-ABSCESO DEL TIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E328",
    "nombre_dx": "E328-OTRAS ENFERMEDADES DEL TIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E329",
    "nombre_dx": "E329-ENFERMEDAD DEL TIMO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E340",
    "nombre_dx": "E340-SINDROME CARCINOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E341",
    "nombre_dx": "E341-OTRAS HIPERSECRECIONES DE HORMONAS INTESTINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E342",
    "nombre_dx": "E342-SECRECION HORMONAL ECTOPICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E343",
    "nombre_dx": "E343-ENANISMO, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "E344",
    "nombre_dx": "E344-ESTATURA ALTA CONSTITUCIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "E345",
    "nombre_dx": "E345-SINDROME DE RESISTENCIA ANDROGENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E348",
    "nombre_dx": "E348-OTROS TRASTORNOSENDOCRINOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E349",
    "nombre_dx": "E349-TRASTORNO ENDOCRINO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E350",
    "nombre_dx": "E350-TRASTORNOS DE LA GLANDULA TIROIDES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E351",
    "nombre_dx": "E351-TRASTORNOS DE LA GLANDULAS SUPRARRENALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E358",
    "nombre_dx": "E358-TRASTORNOS DE OTRAS GLANDULAS ENDOCRINAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E40X",
    "nombre_dx": "E40X-KWASHIORKOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "E41X",
    "nombre_dx": "E41X-MARASMO NUTRICIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "E42X",
    "nombre_dx": "E42X-KWASHIORKOR MARASMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E43X",
    "nombre_dx": "E43X-DESNUTRICION PROTEICOCALORICA SEVERA,NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E440",
    "nombre_dx": "E440-DESNUTRICION PROTEICOCALORICA MODERADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E441",
    "nombre_dx": "E441-DESNUTRICION PROTEICOCALORICA LEVE",
    "sexo": "A"
  },
  {
    "cod_dx": "E45X",
    "nombre_dx": "E45X-RETARDO DEL DESARROLLO DEBIDO A DESNUTRICION PROTEICOCALORICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E46X",
    "nombre_dx": "E46X-DESNUTRICION PROTEICOCALORICA , NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E500",
    "nombre_dx": "E500-DEFICIENCIA DE VITAMINAA CON XEROSIS CONJUNTIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "E501",
    "nombre_dx": "E501-DEFICIENCIA DE VITAMINAA CON MANCHA DE BITOT Y XEROSIS CONJUNTIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "E502",
    "nombre_dx": "E502-DEFICIENCIA DE VITAMINAA CON XEROSIS CORNEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "E503",
    "nombre_dx": "E503-DEFICIENCIA DE VITAMINAA CON ULCERACION CORNEAL Y XEROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E504",
    "nombre_dx": "E504-DEFICIENCIA DE VITAMINAA CON QUERATOMALACIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E505",
    "nombre_dx": "E505-DEFICIENCIA DE VITAMINAA CON CEGUERA NOCTURNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E506",
    "nombre_dx": "E506-DEFICIENCIA DE VITAMINAA CON CICATRICES XEROFTALMICAS DE LA CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "E507",
    "nombre_dx": "E507-OTRAS MANIFESTACIONES OCULARES DE DEFICIENCIA DE VITAMINAA",
    "sexo": "A"
  },
  {
    "cod_dx": "E508",
    "nombre_dx": "E508-OTRAS MANIFESTACIONES DE DEFICIENCIA DE VITAMINAA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E509",
    "nombre_dx": "E509-DEFICIENCIA DE VITAMINA A, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E511",
    "nombre_dx": "E511-BERIBERI",
    "sexo": "A"
  },
  {
    "cod_dx": "E512",
    "nombre_dx": "E512-ENCEFALOPATIA DE WERNICKE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E518",
    "nombre_dx": "E518-OTRAS MANIFESTACIONES DE LA DEFICIENCIA DE TIAMINA",
    "sexo": "A"
  },
  {
    "cod_dx": "E519",
    "nombre_dx": "E519-DEFICIENCIA DE TIAMINA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E52X",
    "nombre_dx": "E52X-DEFICIENCIA DE NIACINA [PELAGRA]",
    "sexo": "A"
  },
  {
    "cod_dx": "E530",
    "nombre_dx": "E530-DEFICIENCIA DE RIBOFLAVINA",
    "sexo": "A"
  },
  {
    "cod_dx": "E531",
    "nombre_dx": "E531-DEFICIENCIA DE PIRIDOXINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E538",
    "nombre_dx": "E538-DEFICIENCIA DE OTRAS VITAMINAS DEL GRUPO B",
    "sexo": "A"
  },
  {
    "cod_dx": "E539",
    "nombre_dx": "E539-DEFICIENCIA DE VITAMINA B, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E54X",
    "nombre_dx": "E54X-DEFICIENCIA DE ACIDO ASCORBICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E550",
    "nombre_dx": "E550-RAQUITISMO ACTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E559",
    "nombre_dx": "E559-DEFICIENCIA DE VITAMINA D, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E560",
    "nombre_dx": "E560-DEFICIENCIA DE VITAMINA E ",
    "sexo": "A"
  },
  {
    "cod_dx": "E561",
    "nombre_dx": "E561-DEFICIENCIA DE VITAMINA K ",
    "sexo": "A"
  },
  {
    "cod_dx": "E568",
    "nombre_dx": "E568-DEFICIENCIA DE OTRAS VITAMINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E569",
    "nombre_dx": "E569-DEFICIENCIA DE VITAMINA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E58X",
    "nombre_dx": "E58X-DEFICIENCIA DIETETICA DE CALCIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E59X",
    "nombre_dx": "E59X-DEFICIENCIA DIETETICA DE SELENIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E60X",
    "nombre_dx": "E60X-DEFICIENCIA DIETETICA DE ZINC ",
    "sexo": "A"
  },
  {
    "cod_dx": "E610",
    "nombre_dx": "E610-DEFICIENCIA DE COBRE",
    "sexo": "A"
  },
  {
    "cod_dx": "E611",
    "nombre_dx": "E611-DEFICIENCIA DE HIERRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E612",
    "nombre_dx": "E612-DEFICIENCIA DE MAGNESIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E613",
    "nombre_dx": "E613-DEFICIENCIA DE MANGANESO",
    "sexo": "A"
  },
  {
    "cod_dx": "E614",
    "nombre_dx": "E614-DEFICIENCIA DE CROMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E615",
    "nombre_dx": "E615-DEFICIENCIA DE MOLIBDENO",
    "sexo": "A"
  },
  {
    "cod_dx": "E616",
    "nombre_dx": "E616-DEFICIENCIA DE VANADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "E617",
    "nombre_dx": "E617-DEFICIENCIA DE MULTIPLES ELEMENTOS NUTRICIONALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E618",
    "nombre_dx": "E618-DEFICIENCIA DE OTROS ELEMENTOS NUTRICIONALES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E619",
    "nombre_dx": "E619-DEFICIENCIA DE OTRO ELEMENTO NUTRICIONAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E630",
    "nombre_dx": "E630-DEFICIENCIA DE ACIDOS GRASOS ESENCIALES [AGE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "E631",
    "nombre_dx": "E631-DESEQUILIBRIO DE LOS CONSTITUYENTES EN LA DIETA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E638",
    "nombre_dx": "E638-OTRAS DEFICIENCIAS NUTRICIONALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E639",
    "nombre_dx": "E639-DEFICIENCIA NUTRICIONAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E640",
    "nombre_dx": "E640-SECUELAS DE LA DESNUTRICION PROTEICOCALORICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E641",
    "nombre_dx": "E641-SECUELAS DE LA DEFICIENCIA DE VITAMINA A",
    "sexo": "A"
  },
  {
    "cod_dx": "E642",
    "nombre_dx": "E642-SECUELAS DE LA DEFICIENCIA DE VITAMINA C",
    "sexo": "A"
  },
  {
    "cod_dx": "E643",
    "nombre_dx": "E643-SECUELAS DEL RAQUITISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E648",
    "nombre_dx": "E648-SECUELAS DE OTRAS DEFICIENCIAS NUTRICIONALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E649",
    "nombre_dx": "E649-SECUELAS DE LA DEFICIENCIA NUTRICIONAL NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E65X",
    "nombre_dx": "E65X-ADIPOSIDAD LOCALIZADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E660",
    "nombre_dx": "E660-OBESIDAD DEBIDA A EXCESO DE CALORIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E661",
    "nombre_dx": "E661-OBESIDAD INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E662",
    "nombre_dx": "E662-OBESIDAD EXTREMA CON HIPOVENTILACIONALVEOLAR",
    "sexo": "A"
  },
  {
    "cod_dx": "E668",
    "nombre_dx": "E668-OTROS TIPOS DE OBESIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "E669",
    "nombre_dx": "E669-OBESIDAD, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E670",
    "nombre_dx": "E670-HIPERVITAMINOSIS A",
    "sexo": "A"
  },
  {
    "cod_dx": "E671",
    "nombre_dx": "E671-HIPERCAROTINEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E672",
    "nombre_dx": "E672-SINDROME DE MEGAVITAMINA B6 ",
    "sexo": "A"
  },
  {
    "cod_dx": "E673",
    "nombre_dx": "E673-HIPERVITAMINOSIS D",
    "sexo": "A"
  },
  {
    "cod_dx": "E678",
    "nombre_dx": "E678-OTROS TIPOS DE HIPERALIMENTACION ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E68X",
    "nombre_dx": "E68X-SECUELAS DE HIPERALIMENTACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "E700",
    "nombre_dx": "E700-FENILCETONURIA CLASICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E701",
    "nombre_dx": "E701-OTRAS HIPERFENILALANINEMIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E702",
    "nombre_dx": "E702-TRASTORNOS DEL METABOLISMO DE LA TIROSINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E703",
    "nombre_dx": "E703-ALBINISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E708",
    "nombre_dx": "E708-OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS AROMATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E709",
    "nombre_dx": "E709-TRASTORNO DEL METABOLISMO DE LOS AMINOACIDOS AROMATICOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E710",
    "nombre_dx": "E710-ENFERMEDAD DE LA ORINA EN JARABE DE ARCE",
    "sexo": "A"
  },
  {
    "cod_dx": "E711",
    "nombre_dx": "E711-OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS DE CADENA RAMIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E712",
    "nombre_dx": "E712-OTROS TRASTORNOS DEL METABOLISMO DE LOS AMINOACIDOS DE CADENA RAMIFICADA, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E713",
    "nombre_dx": "E713-TRASTORNOS DEL METABOLISMO DE LOS ACIDOS GRASOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E720",
    "nombre_dx": "E720-TRASTORNOS DEL TRANSPORTE DE LOS AMINOACIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E721",
    "nombre_dx": "E721-TRASTORNO DEL METABOLISMO DE LOS AMINOACIDOS AZUFRADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E722",
    "nombre_dx": "E722-TRASTORNOS DEL METABOLISMO DEL CICLO DE LA UREA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E723",
    "nombre_dx": "E723-TRASTORNOS DEL METABOLISMO DE LA LISINA Y LA HIDROXILISINA",
    "sexo": "A"
  },
  {
    "cod_dx": "E724",
    "nombre_dx": "E724-TRASTORNO DEL METABOLISMO DE LA ORNITINA",
    "sexo": "A"
  },
  {
    "cod_dx": "E725",
    "nombre_dx": "E725-TRASTORNO DEL METABOLISMO DE LA GLICINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E728",
    "nombre_dx": "E728-OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO DE LOS AMINOACIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E729",
    "nombre_dx": "E729-TRASTORNO DEL METABOLISMO DE LOS AMINOACIDOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E730",
    "nombre_dx": "E730-DEFICIENCIA CONGENITA DE LACTASA",
    "sexo": "A"
  },
  {
    "cod_dx": "E731",
    "nombre_dx": "E731-DEFICIENCIA SECUNDARIA DE LACTASA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E738",
    "nombre_dx": "E738-OTROS TIPOS DE INTOLERANCIA A LA LACTOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "E739",
    "nombre_dx": "E739-INTOLERANCIA A LA LACTOSA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E740",
    "nombre_dx": "E740-ENFERMEDAD DEL ALMACENAMIENTO DE GLUCOGENO",
    "sexo": "A"
  },
  {
    "cod_dx": "E741",
    "nombre_dx": "E741-TRASTORNOS DEL METABOLISMO DE LA FRUCTOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E742",
    "nombre_dx": "E742-TRASTORNO DEL METABOLISMO DE LA GALACTOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E743",
    "nombre_dx": "E743-OTROS TRASTORNOS DE LA ABSORCION INTESTINAL DE CARBOHIDRATOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E744",
    "nombre_dx": "E744-TRASTORNOS DEL METABOLISMO DEL PIRUVATO Y DE LAS GLUCONEOGENESIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E748",
    "nombre_dx": "E748-OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO DE LOS CARBOHIDRATOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E749",
    "nombre_dx": "E749-TRASTORNODEL METABOLISMO DE LOS CARBOHIDRATOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E750",
    "nombre_dx": "E750-GANGLIOSIDOSIS GM2",
    "sexo": "A"
  },
  {
    "cod_dx": "E751",
    "nombre_dx": "E751-OTRAS GANGLIOSIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E752",
    "nombre_dx": "E752-OTRAS ESFINGOLIPIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E753",
    "nombre_dx": "E753-ESFINGOLIPIDOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E754",
    "nombre_dx": "E754-LIPOFUSCINOSIS CEROIDE NEURONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "E755",
    "nombre_dx": "E755-OTROS TRASTORNOS DEL ALMACENAMIENTO DE LIPIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E756",
    "nombre_dx": "E756-TRASTORNOS DE ALMACENAMIENTO DE LIPIDOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E760",
    "nombre_dx": "E760-MUCOPOLISACARIDOSIS TIPO I",
    "sexo": "A"
  },
  {
    "cod_dx": "E761",
    "nombre_dx": "E761-MUCOPOLISACARIDOSIS TIPO II ",
    "sexo": "A"
  },
  {
    "cod_dx": "E762",
    "nombre_dx": "E762-OTRAS MUCOPOLISACARIDOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E763",
    "nombre_dx": "E763-MUCOPOLISACARIDOSIS NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E768",
    "nombre_dx": "E768-OTRO TRASTORNOS DEL METABOLISMO DE LOS GLUCOSAMINOGLICANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E769",
    "nombre_dx": "E769-TRASTORNO DEL METABOLISMO DE LOS GLUCOSAMINOGLICANOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E770",
    "nombre_dx": "E770-DEFECTOS EN LA MODIFICACION POSTRASLACIONAL DE ENZIMAS LISOSOMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E771",
    "nombre_dx": "E771-DEFECTOS DE LA DEGRADACION DE GLUCOPROTEINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E778",
    "nombre_dx": "E778-OTROS TRASTORNOS DEL METABOLISMO DE LAS GLUCOPROTEINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E779",
    "nombre_dx": "E779-TRASTORNO DEL METABOLISMO DE LAS GLUCOPROTEINAS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E780",
    "nombre_dx": "E780-HIPERCOLESTEROLEMIA PURA",
    "sexo": "A"
  },
  {
    "cod_dx": "E781",
    "nombre_dx": "E781-HIPERGLICERIDEMIA PURA",
    "sexo": "A"
  },
  {
    "cod_dx": "E782",
    "nombre_dx": "E782-HIPERLIPIDEMIA MIXTA",
    "sexo": "A"
  },
  {
    "cod_dx": "E783",
    "nombre_dx": "E783-HIPERQUILOMICRONEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E784",
    "nombre_dx": "E784-OTRA HIPERLIPIDEMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E785",
    "nombre_dx": "E785-HIPERLIPIDEMIA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E786",
    "nombre_dx": "E786-DEFICIENCIA DE LIPOPROTEINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E788",
    "nombre_dx": "E788-OTROS TRASTORNOS DEL METABOLISMO DE LAS LIPOPROTEINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E789",
    "nombre_dx": "E789-TRASTORNO DEL METABOLISMO DELAS LIPOPROTEINAS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E790",
    "nombre_dx": "E790-HIPERURICEMIA SIN SIGNOS DE ARTRITIS INFLAMATORIA Y ENFERMEDAD TOFACEA",
    "sexo": "A"
  },
  {
    "cod_dx": "E791",
    "nombre_dx": "E791-SINDROME DE LESCH-NYHAN ",
    "sexo": "A"
  },
  {
    "cod_dx": "E798",
    "nombre_dx": "E798-OTROS TRASTORNOS DEL METABOLISMO DE LAS PURINAS Y DE LAS PIRIMIDINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "E799",
    "nombre_dx": "E799-TRASTORNOS DEL METABOLISMO DE LAS PURINAS Y DE LAS PIRIMIDINAS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E800",
    "nombre_dx": "E800-PORFIRIA ERITROPOYETICA HEREDITARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E801",
    "nombre_dx": "E801-PORFIRIA CUTANEA TARDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E802",
    "nombre_dx": "E802-OTRAS PORFIRIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E803",
    "nombre_dx": "E803-DEFECTOS DE CATALASA Y PEROXIDASA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E804",
    "nombre_dx": "E804-SINDROME DE GILBERT ",
    "sexo": "A"
  },
  {
    "cod_dx": "E805",
    "nombre_dx": "E805-SINDROME DE CRIGLER-NAJJAR",
    "sexo": "A"
  },
  {
    "cod_dx": "E806",
    "nombre_dx": "E806-OTROS TRASTORNOS DEL METABOLISMO DE LA BILIRRUBINA",
    "sexo": "A"
  },
  {
    "cod_dx": "E807",
    "nombre_dx": "E807-TRASTORNOS DEL METABOLISMO DE LA BILIRRUBINA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E830",
    "nombre_dx": "E830-TRASTORNOS DEL METABOLISMO DEL COBRE",
    "sexo": "A"
  },
  {
    "cod_dx": "E831",
    "nombre_dx": "E831-TRASTORNOS DEL METABOLISMO DEL HIERRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E832",
    "nombre_dx": "E832-TRASTORNOS DEL METABOLISMO DEL ZINC ",
    "sexo": "A"
  },
  {
    "cod_dx": "E833",
    "nombre_dx": "E833-Trastornos del metabolismo del fósforo y fosfatasa",
    "sexo": "A"
  },
  {
    "cod_dx": "E834",
    "nombre_dx": "E834-TRASTORNOS DEL METABOLISMO DEL MAGNESIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E835",
    "nombre_dx": "E835-TRASTORNOS DEL METABOLISMO DEL CALCIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E838",
    "nombre_dx": "E838-OTROS TRASTORNOS DEL METABOLISMO DE LOS MINERALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E839",
    "nombre_dx": "E839-TRASTORNO DEL METABOLISMO DE LOS MINERALES, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E840",
    "nombre_dx": "E840-FIBROSIS QUISTICA CON MANIFESTACIONES PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "E841",
    "nombre_dx": "E841-FIBROSIS QUISTICA CON MANIFESTACIONES INTESTINALES",
    "sexo": "A"
  },
  {
    "cod_dx": "E848",
    "nombre_dx": "E848-FIBROSIS QUISTICA CON OTRAS MANIFESTACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "E849",
    "nombre_dx": "E849-FIBROSIS QUISTICA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "E850",
    "nombre_dx": "E850-AMILOIDOSIS HEREDOFAMILIAR NO NEUROPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E851",
    "nombre_dx": "E851-AMILOIDOSIS HEREDOFAMILIAR NEUROPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "E852",
    "nombre_dx": "E852-AMILOIDOSIS HEREDOFAMILIAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "E853",
    "nombre_dx": "E853-AMILOIDOSIS SISTEMICA SECUNDARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E854",
    "nombre_dx": "E854-AMILOIDOSIS LIMITADA A UN ORGANO",
    "sexo": "A"
  },
  {
    "cod_dx": "E858",
    "nombre_dx": "E858-OTRAS AMILOIDOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E859",
    "nombre_dx": "E859-AMILOIDOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "E86X",
    "nombre_dx": "E86X-DEPLECION DEL VOLUMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "E870",
    "nombre_dx": "E870-HIPEROSMOLARIDAD E HIPERNATREMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E871",
    "nombre_dx": "E871-HIPOSMOLARIDAD E HIPERNATREMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E872",
    "nombre_dx": "E872-ACIDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "E873",
    "nombre_dx": "E873-ALCALOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E874",
    "nombre_dx": "E874-TRASTORNOS MIXTOS DEL BALANCE ACIDO-BASICO",
    "sexo": "A"
  },
  {
    "cod_dx": "E875",
    "nombre_dx": "E875-HIPERPOTASEMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E876",
    "nombre_dx": "E876-HIPOPOTASMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "E877",
    "nombre_dx": "E877-SOBRECARGA DE LIQUIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E878",
    "nombre_dx": "E878-OTROS TRASTORNOS DEL EQUILIBRIO DE LOS ELECTROLITOS Y DE LOS LIQUIDOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "E880",
    "nombre_dx": "E880-TRASTORNOS DEL METABOLISMO DE LAS PROTEINAS PLASMATICAS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "E881",
    "nombre_dx": "E881-LIPODISTROFIA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E882",
    "nombre_dx": "E882-LIPOMATOSIS, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "E883",
    "nombre_dx": "E883-Síndrome de lisis tumoral",
    "sexo": "A"
  },
  {
    "cod_dx": "E888",
    "nombre_dx": "E888-OTROS TRASTORNOS ESPECIFICADOS DEL METABOLISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "E889",
    "nombre_dx": "E889-TRASTORNO METABOLICO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "E890",
    "nombre_dx": "E890-HIPOTIROIDISMOCONSECUTIVO A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E891",
    "nombre_dx": "E891-HIPOINSULINEMIA CONSECUTIVAA PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E892",
    "nombre_dx": "E892-HIPOPARATIROIDISMO CONSECUTIVO A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E893",
    "nombre_dx": "E893-HIPOPITUITARISMO CONSECUTIVO A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "E894",
    "nombre_dx": "E894-INSUFICIENCIA OVARICA CONSECUTIVAA PROCEDIMIENTOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "E895",
    "nombre_dx": "E895-HIPOFUNCION TESTICULAR CONSECUTIVA A PROCEDIMIENTOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "E896",
    "nombre_dx": "E896-HIPOFUNCION ADRENOCORTICAL [MEDULA SUPRARRENAL] CONSECUTIVA A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E898",
    "nombre_dx": "E898-OTROS TRASTORNOS METABOLICOS Y ENDOCRINOS CONSECUTIVO A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "E899",
    "nombre_dx": "E899-TRASTORNO ENDOCRINO Y METABOLICO CONSECUTIVO A PROCEDIMIENTOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "E90X",
    "nombre_dx": "E90X-TRASTORNOS NUTRICIONALES Y METABOLICOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F000",
    "nombre_dx": "F000-DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, DE COMIENZO TEMPRANO (G30.0+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F001",
    "nombre_dx": "F001-DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, DE COMIENZO TARDIO (G30.1+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F002",
    "nombre_dx": "F002-DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER,ATIPICA O DE TIPO MIXTO (G30.8+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F009",
    "nombre_dx": "F009-DEMENCIA EN LA ENFERMEDAD DE ALZHEIMER, NO ESPECIFICADA(G30.9+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F010",
    "nombre_dx": "F010-DEMENCIA VASCULAR DE COMIENZOAGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "F011",
    "nombre_dx": "F011-DEMENCIA VASCULAR POR INFARTOS MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "F012",
    "nombre_dx": "F012-DEMENCIA VASCULAR SUBCORTICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F013",
    "nombre_dx": "F013-DEMENCIA VASCULAR MIXTA, CORTICAL Y SUBCORTICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F018",
    "nombre_dx": "F018-OTRAS DEMENCIAS VASCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "F019",
    "nombre_dx": "F019-DEMENCIA VASCULAR, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "F020",
    "nombre_dx": "F020-DEMENCIA EN LA ENFERMEDAD DE PICK (G31.0+)",
    "sexo": "A"
  },
  {
    "cod_dx": "F021",
    "nombre_dx": "F021-DEMENCIA EN LA ENFERMEDAD DE CREUTZFELDT-JAKOB (A81.0+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F022",
    "nombre_dx": "F022-DEMENCIA EN LA ENFERMEDAD DE HUNTINGTON (G10+)",
    "sexo": "A"
  },
  {
    "cod_dx": "F023",
    "nombre_dx": "F023-DEMENCIA EN LA ENFERMEDAD DE PARKINSON (G20+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F024",
    "nombre_dx": "F024-DEMENCIA EN LA ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH] (B22.0+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "F028",
    "nombre_dx": "F028-DEMENCIA EN OTRAS ENFERMEDADES ESPECIFICADAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F03X",
    "nombre_dx": "F03X-DEMENCIA , NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "F04X",
    "nombre_dx": "F04X-SINDROME AMNESICO ORGANICO, NO INDUCIDO POR ACOHOL O POR OTRAS SUSTANCIAS PSICOACTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "F050",
    "nombre_dx": "F050-DELIRIO NO SUPERPUESTO A UN CUADRO DE DEMENCIA, ASI DESCRITO",
    "sexo": "A"
  },
  {
    "cod_dx": "F051",
    "nombre_dx": "F051-DELIRIO SUPERPUESTO A UN CUADRO DE DEMENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F058",
    "nombre_dx": "F058-OTROS DELIRIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F059",
    "nombre_dx": "F059-DELIRIO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F060",
    "nombre_dx": "F060-ALUCINOSIS ORGANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F061",
    "nombre_dx": "F061-TRASTORNO CATATONICO, ORGANICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F062",
    "nombre_dx": "F062-TRASTORNO DELIRANTE [ESQUIZOFRENIFORME], ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F063",
    "nombre_dx": "F063-TRASTORNOS DEL HUMOR [AFECTIVOS], ORGANICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F064",
    "nombre_dx": "F064-TRASTORNO DE ANSIEDAD, ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F065",
    "nombre_dx": "F065-TRASTORNO DISOCIATIVO, ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F066",
    "nombre_dx": "F066-TRASTORNO DE LABILIDAD EMOCIONAL [ASTENICO], ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F067",
    "nombre_dx": "F067-TRASTORNO COGNOSCITIVO LEVE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F068",
    "nombre_dx": "F068-OTROS TRASTORNOS MENTALES ESPECIFICADOS DEBIDOS A LESION Y DISFUNCION CEREBRAL Y A ENFERMEDAD FISICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F069",
    "nombre_dx": "F069-TRASTORNO MENTAL NO ESPECIFICADO DEBIDO A LESION Y DISFUNCION CEREBRAL Y A ENFERMEDAD FISICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F070",
    "nombre_dx": "F070-TRASTORNO DE LA PERSONALIDAD, ORGANICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F071",
    "nombre_dx": "F071-SINDROME POSTENCEFALITICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F072",
    "nombre_dx": "F072-SINDROME POSTCONCUSIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "F078",
    "nombre_dx": "F078-OTROS TRASTORNOS ORGANICOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO DEBIDOS A ENFERMEDAD, LESION Y DI",
    "sexo": "A"
  },
  {
    "cod_dx": "F079",
    "nombre_dx": "F079-TRASTORNO ORGANICO DE LA PERSONALIDAD Y DEL COMPORTAMIENTO, NO ESPECIFICADO,DEBIDO A ENFERMEDAD, L",
    "sexo": "A"
  },
  {
    "cod_dx": "F09X",
    "nombre_dx": "F09X-TRASTORNO MENTAL ORGANICO O SINTOMATICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F100",
    "nombre_dx": "F100-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: INTOXICACION AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F101",
    "nombre_dx": "F101-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: USO NOCIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F102",
    "nombre_dx": "F102-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: SINDROME DE DEPENDENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F103",
    "nombre_dx": "F103-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: ESTADO DE ABSTINENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F104",
    "nombre_dx": "F104-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: ESTADO DE ABSTINENCIA CON DELIR",
    "sexo": "A"
  },
  {
    "cod_dx": "F105",
    "nombre_dx": "F105-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: TRASTORNO PSICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F106",
    "nombre_dx": "F106-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: SINDROME AMNESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F107",
    "nombre_dx": "F107-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: TRASTORNO PSICOTICO RESIDUAL Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "F108",
    "nombre_dx": "F108-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: OTROS TRASTORNOS MENTALES Y DEL",
    "sexo": "A"
  },
  {
    "cod_dx": "F109",
    "nombre_dx": "F109-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEL ALCOHOL: TRASTORNO MENTAL Y DEL COMPORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "F110",
    "nombre_dx": "F110-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS:INTOXICACION AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "F111",
    "nombre_dx": "F111-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: USO NOCIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F112",
    "nombre_dx": "F112-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS:SINDROME DE DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F113",
    "nombre_dx": "F113-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: ESTADO DE ABSTINENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F114",
    "nombre_dx": "F114-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: ESTADO DE ABSTINENCIA CON DELIR",
    "sexo": "A"
  },
  {
    "cod_dx": "F115",
    "nombre_dx": "F115-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: TRASTORNO PSICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F116",
    "nombre_dx": "F116-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: SINDROME AMNESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F117",
    "nombre_dx": "F117-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: TRASTORNO PSICOTICO RESIDUAL Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "F118",
    "nombre_dx": "F118-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: OTROS TRASTORNOS MENTALES Y DEL",
    "sexo": "A"
  },
  {
    "cod_dx": "F119",
    "nombre_dx": "F119-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OPIACEOS: TRASTORNO MENTAL Y DEL COMPORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "F120",
    "nombre_dx": "F120-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES: INTOXICACION AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "F121",
    "nombre_dx": "F121-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES: USO NOCIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F122",
    "nombre_dx": "F122-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES: SINDROME DE DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F123",
    "nombre_dx": "F123-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:ESTADO DE ABSTINENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F124",
    "nombre_dx": "F124-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:ESTADO DE ABSTINENCIA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "F125",
    "nombre_dx": "F125-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:TRASTORNO PSICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F126",
    "nombre_dx": "F126-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:SINDROME AMNESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F127",
    "nombre_dx": "F127-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:TRASTORNO PSICOTICO RESID",
    "sexo": "A"
  },
  {
    "cod_dx": "F128",
    "nombre_dx": "F128-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES:OTROS TRASTORNOS MENTALES",
    "sexo": "A"
  },
  {
    "cod_dx": "F129",
    "nombre_dx": "F129-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE CANNABINOIDES: TRASTORNO MENTAL Y DEL COM",
    "sexo": "A"
  },
  {
    "cod_dx": "F130",
    "nombre_dx": "F130-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: INTOXICACION AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "F131",
    "nombre_dx": "F131-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: USO NOCIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F132",
    "nombre_dx": "F132-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: SINDROME DE DEPEND",
    "sexo": "A"
  },
  {
    "cod_dx": "F133",
    "nombre_dx": "F133-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS:ESTADO DE ABSTINE",
    "sexo": "A"
  },
  {
    "cod_dx": "F134",
    "nombre_dx": "F134-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS:ESTADO DE ABSTINE",
    "sexo": "A"
  },
  {
    "cod_dx": "F135",
    "nombre_dx": "F135-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS:TRASTORNO PSICOTI",
    "sexo": "A"
  },
  {
    "cod_dx": "F136",
    "nombre_dx": "F136-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: SINDROME AMNESICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F137",
    "nombre_dx": "F137-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS:TRASTORNO PSICOTI",
    "sexo": "A"
  },
  {
    "cod_dx": "F138",
    "nombre_dx": "F138-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: OTROS TRASTORNOS M",
    "sexo": "A"
  },
  {
    "cod_dx": "F139",
    "nombre_dx": "F139-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE SEDANTES O HIPNOTICOS: TRASTORNO MENTAL Y",
    "sexo": "A"
  },
  {
    "cod_dx": "F140",
    "nombre_dx": "F140-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: INTOXICACION AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "F141",
    "nombre_dx": "F141-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: USO NOCIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F142",
    "nombre_dx": "F142-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: SINDROME DE DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F143",
    "nombre_dx": "F143-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: ESTADO DE ABSTINENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F144",
    "nombre_dx": "F144-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: ESTADO DE ABSTINENCIA CON DELIRI",
    "sexo": "A"
  },
  {
    "cod_dx": "F145",
    "nombre_dx": "F145-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: TRASTORNO PSICOTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F146",
    "nombre_dx": "F146-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: SINDROME AMNESICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F147",
    "nombre_dx": "F147-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA:TRASTORNO PSICOTICO RESIDUAL Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "F148",
    "nombre_dx": "F148-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: OTROS TRASTORNOS MENTALES Y DEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F149",
    "nombre_dx": "F149-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE COCAINA: TRASTORNO MENTAL Y DEL COMPORTAM",
    "sexo": "A"
  },
  {
    "cod_dx": "F150",
    "nombre_dx": "F150-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F151",
    "nombre_dx": "F151-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F152",
    "nombre_dx": "F152-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F153",
    "nombre_dx": "F153-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F154",
    "nombre_dx": "F154-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA:.",
    "sexo": "A"
  },
  {
    "cod_dx": "F155",
    "nombre_dx": "F155-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F156",
    "nombre_dx": "F156-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F157",
    "nombre_dx": "F157-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F158",
    "nombre_dx": "F158-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F159",
    "nombre_dx": "F159-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE OTROS ESTIMULANTES, INCLUIDA LA CAFEINA: ",
    "sexo": "A"
  },
  {
    "cod_dx": "F160",
    "nombre_dx": "F160-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: INTOXICACION AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F161",
    "nombre_dx": "F161-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: USO NOCIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F162",
    "nombre_dx": "F162-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS:SINDROME DE DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F163",
    "nombre_dx": "F163-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS:ESTADO DE ABSTINENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F164",
    "nombre_dx": "F164-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: ESTADO DE ABSTINENCIA CON D",
    "sexo": "A"
  },
  {
    "cod_dx": "F165",
    "nombre_dx": "F165-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: TRASTORNO PSICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F166",
    "nombre_dx": "F166-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: SINDROME AMNESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F167",
    "nombre_dx": "F167-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS:TRASTORNO PSICOTICO RESIDU",
    "sexo": "A"
  },
  {
    "cod_dx": "F168",
    "nombre_dx": "F168-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: OTROS TRASTORNOS MENTALES Y",
    "sexo": "A"
  },
  {
    "cod_dx": "F169",
    "nombre_dx": "F169-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE ALUCINOGENOS: TRASTORNO MENTAL Y DEL COMP",
    "sexo": "A"
  },
  {
    "cod_dx": "F170",
    "nombre_dx": "F170-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: INTOXICACION AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F171",
    "nombre_dx": "F171-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO:USO NOCIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F172",
    "nombre_dx": "F172-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO:SINDROME DE DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F173",
    "nombre_dx": "F173-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO:ESTADO DE ABSTINENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F174",
    "nombre_dx": "F174-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: ESTADO DE ABSTINENCIA CON DELIRIO",
    "sexo": "A"
  },
  {
    "cod_dx": "F175",
    "nombre_dx": "F175-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: TRASTORNO PSICOTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F176",
    "nombre_dx": "F176-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: SINDROME AMNESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F177",
    "nombre_dx": "F177-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO:TRASTORNO PSICOTICO RESIDUAL Y D",
    "sexo": "A"
  },
  {
    "cod_dx": "F178",
    "nombre_dx": "F178-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: OTROS TRASTORNOS MENTALES Y DEL C",
    "sexo": "A"
  },
  {
    "cod_dx": "F179",
    "nombre_dx": "F179-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE TABACO: TRASTORNO MENTAL Y DEL COMPORTAMI",
    "sexo": "A"
  },
  {
    "cod_dx": "F180",
    "nombre_dx": "F180-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: INTOXICACION AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "F181",
    "nombre_dx": "F181-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: USO NOCIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F182",
    "nombre_dx": "F182-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES:SINDROME DE DEPEN",
    "sexo": "A"
  },
  {
    "cod_dx": "F183",
    "nombre_dx": "F183-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES:ESTADO DE ABSTINE",
    "sexo": "A"
  },
  {
    "cod_dx": "F184",
    "nombre_dx": "F184-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: ESTADO DE ABSTINEN",
    "sexo": "A"
  },
  {
    "cod_dx": "F185",
    "nombre_dx": "F185-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: TRASTORNO PSICOTIC",
    "sexo": "A"
  },
  {
    "cod_dx": "F186",
    "nombre_dx": "F186-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: SINDROME AMNESICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F187",
    "nombre_dx": "F187-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES:TRASTORNO PSICOTI",
    "sexo": "A"
  },
  {
    "cod_dx": "F188",
    "nombre_dx": "F188-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: OTROS TRASTORNOS M",
    "sexo": "A"
  },
  {
    "cod_dx": "F189",
    "nombre_dx": "F189-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE DISOLVENTES VOLATILES: TRASTORNO MENTAL Y",
    "sexo": "A"
  },
  {
    "cod_dx": "F190",
    "nombre_dx": "F190-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F191",
    "nombre_dx": "F191-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F192",
    "nombre_dx": "F192-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F193",
    "nombre_dx": "F193-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F194",
    "nombre_dx": "F194-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F195",
    "nombre_dx": "F195-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F196",
    "nombre_dx": "F196-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F197",
    "nombre_dx": "F197-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DEMULTIPLES DROGAS Y AL USO DE OTRAS SUSTA",
    "sexo": "A"
  },
  {
    "cod_dx": "F198",
    "nombre_dx": "F198-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F199",
    "nombre_dx": "F199-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO DEBIDOS AL USO DE MULTIPLES DROGAS Y AL USO DE OTRAS SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "F200",
    "nombre_dx": "F200-ESQUIZOFRENIA PARANOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F201",
    "nombre_dx": "F201-ESQUIZOFRENIA HEBEFRENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F202",
    "nombre_dx": "F202-ESQUIZOFRENIA CATATONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F203",
    "nombre_dx": "F203-ESQUIZOFRENIA INDIFERENCIADA",
    "sexo": "A"
  },
  {
    "cod_dx": "F204",
    "nombre_dx": "F204-DEPRESION POSTESQUIZOFRENICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F205",
    "nombre_dx": "F205-ESQUIZOFRENIA RESIDUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "F206",
    "nombre_dx": "F206-ESQUIZOFRENIA SIMPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "F208",
    "nombre_dx": "F208-OTRAS ESQUIZOFRENIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "F209",
    "nombre_dx": "F209-ESQUIZOFRENIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "F21X",
    "nombre_dx": "F21X-TRASTORNO ESQUIZOTIPICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F220",
    "nombre_dx": "F220-TRASTORNO DELIRANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F228",
    "nombre_dx": "F228-OTROS TRASTORNOS DELIRANTES PERSISTENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "F229",
    "nombre_dx": "F229-TRASTORNO DELIRANTE PERSISTENTE, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F230",
    "nombre_dx": "F230-TRASTORNO PSICOTICO AGUDO POLIMORFO, SIN SINTOMAS DE ESQUIZOFRENIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F231",
    "nombre_dx": "F231-TRASTORNO PSICOTICO AGUDO POLIMORFO, CON SINTOMAS DE ESQUIZOFRENIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F232",
    "nombre_dx": "F232-TRASTORNO PSICOTICO AGUDO DE TIPOESQUIZOFRENICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F233",
    "nombre_dx": "F233-OTRO TRASTORNO PSICOTICO AGUDO, CON PREDOMINIO DE IDEAS DELIRANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "F238",
    "nombre_dx": "F238-OTROS TRASTORNOS PSICOTICOS AGUDOSY TRANSITORIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F239",
    "nombre_dx": "F239-TRASTORNO PSICOTICO AGUDOY TRANSITORIO, NO ESPECIFICADO DE TIPOESQUIZOFRENICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F24X",
    "nombre_dx": "F24X-TRASTORNO DELIRANTE INDUCIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "F250",
    "nombre_dx": "F250-TRASTORNO ESQUIZOAFECTIVO DE TIPO MANIACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F251",
    "nombre_dx": "F251-TRASTORNO ESQUIZOAFECTIVO DE TIPO DEPRESIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F252",
    "nombre_dx": "F252-TRASTORNO ESQUIZOAFECTIVO DE TIPO MIXTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F258",
    "nombre_dx": "F258-OTROS TRASTORNOS ESQUIZOAFECTIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F259",
    "nombre_dx": "F259-TRASTORNO ESQUIZOAFECTIVO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F28X",
    "nombre_dx": "F28X-OTROS TRASTORNOS PSICOTICOS DE ORIGEN NO ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F29X",
    "nombre_dx": "F29X-PSICOSIS DE ORIGEN NO ORGANICO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F300",
    "nombre_dx": "F300-HPOMANIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F301",
    "nombre_dx": "F301-MANIA SIN SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F302",
    "nombre_dx": "F302-MANIA CON SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F308",
    "nombre_dx": "F308-OTROS EPISODIOS MANIACOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F309",
    "nombre_dx": "F309-EPISODIO MANIACO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F310",
    "nombre_dx": "F310-TRASTORNO AFECTIVO BIPOLAR, EPISODIO HIPOMANIACO PRESENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F311",
    "nombre_dx": "F311-TRASTORNO AFECTIVO BIPOLAR, EPISODIO MANIACO PRESENTE SIN SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F312",
    "nombre_dx": "F312-TRASTORNO AFECTIVO BIPOLAR, EPISODIO MANIACO PRESENTE CON SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F313",
    "nombre_dx": "F313-TRASTORNO AFECTIVO BIPOLAR, EPISODIO DEPRESIVO PRESENTE LEVE O MODERADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F314",
    "nombre_dx": "F314-TRASTORNO AFECTIVO BIPOLAR, EPISODIO DEPRESIVO GRAVE PRESENTE SIN SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F315",
    "nombre_dx": "F315-TRASTORNO AFECTIVO BIPOLAR, EPISODIODEPRESIVO GRAVE PRESENTE CON SINTOMAS PSICOTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F316",
    "nombre_dx": "F316-TRASTORNO AFECTIVO BIPOLAR, EPISODIO MIXTO PRESENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F317",
    "nombre_dx": "F317-TRASTORNO AFECTIVO BIPOLAR, ACTUALMENTE EN REMISION ",
    "sexo": "A"
  },
  {
    "cod_dx": "F318",
    "nombre_dx": "F318-OTROS TRASTORNOS AFECTIVOS BIPOLARES",
    "sexo": "A"
  },
  {
    "cod_dx": "F319",
    "nombre_dx": "F319-TRASTORNO AFECTIVO BIPOLAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F320",
    "nombre_dx": "F320-EPISODIO DEPRESIVOLEVE",
    "sexo": "A"
  },
  {
    "cod_dx": "F321",
    "nombre_dx": "F321-EPISODIO DEPRESIVOMODERADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F322",
    "nombre_dx": "F322-EPISODIO DEPRESIVO GRAVE SIN SINTOMAS PSICOTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F323",
    "nombre_dx": "F323-EPISODIO DEPRESIVO GRAVE CON SINTOMAS PSICOTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F328",
    "nombre_dx": "F328-OTROS EPISODIOS DEPRESIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F329",
    "nombre_dx": "F329-EPISODIO DEPRESIVO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F330",
    "nombre_dx": "F330-TRASTORNO DEPRESIVO RECURRENTE, EPISODIO LEVE PRESENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "F331",
    "nombre_dx": "F331-TRASTORNO DEPRESIVO RECURRENTE, EPISODIO MODERADO PRESENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "F332",
    "nombre_dx": "F332-TRASTORNO DEPRESIVO RECURRENTE, EPISODIO DEPRESIVO GRAVEPRESENTE SIN SINTOMAS PSICOTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F333",
    "nombre_dx": "F333-TRASTORNO DEPRESIVO RECURRENTE, EPISODIO DEPRESIVO GRAVEPRESENTE, CON SINTOMAS PSICOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F334",
    "nombre_dx": "F334-TRASTORNO DEPRESIVO RECURRENTE ACTUALMENTE EN REMISION",
    "sexo": "A"
  },
  {
    "cod_dx": "F338",
    "nombre_dx": "F338-OTROS TRASTORNOS DEPRESIVOS RECURRENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "F339",
    "nombre_dx": "F339-TRASTORNO DEPRESIVO RECURRENTE, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F340",
    "nombre_dx": "F340-CICLOTIMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F341",
    "nombre_dx": "F341-DISTIMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F348",
    "nombre_dx": "F348-OTROS TRASTORNOS DEL HUMOR [AFECTIVOS] PERSISTENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "F349",
    "nombre_dx": "F349-TRASTORNO PERSISTENTE DEL HUMOR [AFECTIVO], NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F380",
    "nombre_dx": "F380-OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], AISLADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F381",
    "nombre_dx": "F381-OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], RECURRENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "F388",
    "nombre_dx": "F388-OTROS TRASTORNOS DEL HUMOR [AFECTIVOS], ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F39X",
    "nombre_dx": "F39X-TRASTORNO DEL HUMOR [AFECTIVO], NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F400",
    "nombre_dx": "F400-AGORAFOBIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F401",
    "nombre_dx": "F401-FOBIAS SOCIALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "F402",
    "nombre_dx": "F402-FOBIAS ESPECIFICADAS [AISLADAS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "F408",
    "nombre_dx": "F408-OTROS TRASTORNOS FOBICOS DE ANSIEDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F409",
    "nombre_dx": "F409-TRASTORNO FOBICO DE ANSIEDAD, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F410",
    "nombre_dx": "F410-TRASTORNO DE PANICO [ANSIEDAD PAROXISTICA EPISODICA]",
    "sexo": "A"
  },
  {
    "cod_dx": "F411",
    "nombre_dx": "F411-TRASTORNO DE ANSIEDAD GENERALIZADA",
    "sexo": "A"
  },
  {
    "cod_dx": "F412",
    "nombre_dx": "F412-TRASTORNO MIXTO DE ANSIEDAD Y DEPRESION ",
    "sexo": "A"
  },
  {
    "cod_dx": "F413",
    "nombre_dx": "F413-OTROS TRASTORNOS DE ANSIEDAD MIXTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F418",
    "nombre_dx": "F418-OTROS TRASTORNOS DE ANSIEDAD ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F419",
    "nombre_dx": "F419-TRASTORNO DE ANSIEDAD , NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F420",
    "nombre_dx": "F420-PREDOMINIO DE PENSAMIENTOS O RUMIACIONES OBSESIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "F421",
    "nombre_dx": "F421-PREDOMINIO DE ACTOS COMPULSIVOS [RITUALES OBSESIVOS]",
    "sexo": "A"
  },
  {
    "cod_dx": "F422",
    "nombre_dx": "F422-ACTOS E IDEAS OBSESIVAS MIXTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F428",
    "nombre_dx": "F428-OTROS TRASTORNOS OBSESIVO-COMPULSIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F429",
    "nombre_dx": "F429-TRASTORNO OBSESIVO-COMPULSIVO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F430",
    "nombre_dx": "F430-REACCION AL ESTRÉS AGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "F431",
    "nombre_dx": "F431-TRASTORNO DE ESTRÉS POSTRAUMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F432",
    "nombre_dx": "F432-TRASTORNOS DE ADAPTACION",
    "sexo": "A"
  },
  {
    "cod_dx": "F438",
    "nombre_dx": "F438-OTRAS REACCIONES AL ESTRÉS GRAVE",
    "sexo": "A"
  },
  {
    "cod_dx": "F439",
    "nombre_dx": "F439-REACCION AL ESTRÉS GRAVE, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F440",
    "nombre_dx": "F440-AMNESIA DISOCIATIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F441",
    "nombre_dx": "F441-FUGA DISOCIATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "F442",
    "nombre_dx": "F442-ESTUPOR DISOCIATIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F443",
    "nombre_dx": "F443-TRASTORNOS DE TRANCE Y DE POSESION",
    "sexo": "A"
  },
  {
    "cod_dx": "F444",
    "nombre_dx": "F444-TRASTORNOS DISOCIATIVOS DEL MOVIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "F445",
    "nombre_dx": "F445-CONVULSIONES DISOCIATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F446",
    "nombre_dx": "F446-ANESTESIA DISOCIATIVA Y PERDIDA SENSORIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F447",
    "nombre_dx": "F447-TRASTORNOS DISOCIATIVOS MIXTOS [Y DE CONVERSION]",
    "sexo": "A"
  },
  {
    "cod_dx": "F448",
    "nombre_dx": "F448-OTROS TRASTORNOS DISOCIATIVOS[DE CONVERSION]",
    "sexo": "A"
  },
  {
    "cod_dx": "F449",
    "nombre_dx": "F449-TRASTORNO DISOCIATIVO[DE CONVERSION], NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F450",
    "nombre_dx": "F450-TRASTORNO DE SOMATIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "F451",
    "nombre_dx": "F451-TRASTORNO SOMATOMORFO INDIFERENCIADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F452",
    "nombre_dx": "F452-TRASTORNO HIPOCONDRIACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F453",
    "nombre_dx": "F453-DISFUNCION AUTONOMICA SOMATOMORFA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F454",
    "nombre_dx": "F454-TRASTORNO DE DOLOR PERSISTENTE SOMATOMORFO",
    "sexo": "A"
  },
  {
    "cod_dx": "F458",
    "nombre_dx": "F458-OTROS TRASTORNOS SOMATOMORFOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F459",
    "nombre_dx": "F459-TRASTORNO SOMATOMORFO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F480",
    "nombre_dx": "F480-NEURASTENIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F481",
    "nombre_dx": "F481-SINDROME DE DESPERSONALIZACION Y DESVINCULACION DE LA REALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F488",
    "nombre_dx": "F488-OTROS TRASTORNOS NEUROTICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F489",
    "nombre_dx": "F489-TRASTORNO NEUROTICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F500",
    "nombre_dx": "F500-ANOREXIA NERVIOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F501",
    "nombre_dx": "F501-ANOREXIA NERVIOSA ATIPICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F502",
    "nombre_dx": "F502-BULIMIA NERVIOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "F503",
    "nombre_dx": "F503-BULIMIA NERVIOSA ATIPICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F504",
    "nombre_dx": "F504-HIPERFAGIA ASOCIADA CON OTRAS ALTERACIONES PSICOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F505",
    "nombre_dx": "F505-VOMITOS ASOCIADOS CON OTRAS ALTERACIONES PSICOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F508",
    "nombre_dx": "F508-OTROS TRASTORNOS DE LA INGESTION DE ALIMENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F509",
    "nombre_dx": "F509-TRASTORNO DE LA INGESTION DE ALIMENTOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F510",
    "nombre_dx": "F510-INSOMNIO NO ORGANICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F511",
    "nombre_dx": "F511-HIPERSOMNIO NO ORGANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F512",
    "nombre_dx": "F512-TRASTORNO NO ORGANICO DEL CICLO SUEÑO-VIGILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F513",
    "nombre_dx": "F513-SONAMBULISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F514",
    "nombre_dx": "F514-TERRORES DEL SUEÑO [TERRORES NOCTURNOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "F515",
    "nombre_dx": "F515-PESADILLAS",
    "sexo": "A"
  },
  {
    "cod_dx": "F518",
    "nombre_dx": "F518-OTROS TRASTORNOS NO ORGANICOS DEL SUEÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F519",
    "nombre_dx": "F519-TRASTORNO NO ORGANICO DEL SUEÑO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F520",
    "nombre_dx": "F520-FALTA O PERDIDA DEL DESEO SEXUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "F521",
    "nombre_dx": "F521-AVERSION AL SEXO Y FALTA DE GOCE SEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F522",
    "nombre_dx": "F522-FALLA DE LA RESPUESTA GENITAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F523",
    "nombre_dx": "F523-DISFUNCION ORGASMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F524",
    "nombre_dx": "F524-EYACULACION PRECOZ",
    "sexo": "M"
  },
  {
    "cod_dx": "F525",
    "nombre_dx": "F525-VAGINISMO NO ORGANICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "F526",
    "nombre_dx": "F526-DISPAREUNIA NO ORGANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F527",
    "nombre_dx": "F527-IMPULSO SEXUAL EXCESIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F528",
    "nombre_dx": "F528-OTRAS DISFUNCIONES SEXUALES, NO OCASIONADAS POR TRASTORNO NI POR ENFERMEDAD ORGANICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F529",
    "nombre_dx": "F529-DISFUNCION SEXUAL, NO OCASIONADA POR TRASTORNO NI POR ENFERMEDAD ORGANICOS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F530",
    "nombre_dx": "F530-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO LEVES, ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA ",
    "sexo": "F"
  },
  {
    "cod_dx": "F531",
    "nombre_dx": "F531-TRASTORNOS MENTALES Y DEL COMPORTAMIENTO GRAVES, ASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA",
    "sexo": "F"
  },
  {
    "cod_dx": "F538",
    "nombre_dx": "F538-TRASTORNOS MENTALES Y DEL COMPORTAMIENTOASOCIADOS CON EL PUERPERIO, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "F"
  },
  {
    "cod_dx": "F539",
    "nombre_dx": "F539-TRASTORNO MENTAL PUERPERAL, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "F54X",
    "nombre_dx": "F54X-FACTORES PSICOLOGICOS Y DEL COMPORTAMIENTO ASOCIADOS CON TRASTORNOS O ENFERMEDADES CLASIFICADOS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "F55X",
    "nombre_dx": "F55X-ABUSO DE SUSTANCIAS QUE NO PRODUCEN DEPENDENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F59X",
    "nombre_dx": "F59X-SINDROMES DEL COMPORTAMIENTO ASOCIADOS CON ALTERACIONES FISIOLOGICAS Y FACTORES FISICOS, NO ESPECIFI",
    "sexo": "A"
  },
  {
    "cod_dx": "F600",
    "nombre_dx": "F600-TRASTORNO PARANOIDE DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F601",
    "nombre_dx": "F601-TRASTORNO ESQUIZOIDE DE LA PERSONALIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "F602",
    "nombre_dx": "F602-TRASTORNO ASOCIAL DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F603",
    "nombre_dx": "F603-TRASTORNO DE LA PERSONALIDAD EMOCIONALMENTE INESTABLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F604",
    "nombre_dx": "F604-TRASTORNO HISTRIONICO DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F605",
    "nombre_dx": "F605-TRASTORNO ANANCASTICO DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F606",
    "nombre_dx": "F606-TRASTORNODE LA PERSONALIDAD ANSIOSA (EVASIVA, ELUSIVA)",
    "sexo": "A"
  },
  {
    "cod_dx": "F607",
    "nombre_dx": "F607-TRASTORNODE LA PERSONALIDAD DEPENDIENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F608",
    "nombre_dx": "F608-OTROS TRASTORNOS ESPECIFICOS DE LA PERSONALIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "F609",
    "nombre_dx": "F609-TRASTORNO DE LA PERSONALIDAD, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F61X",
    "nombre_dx": "F61X-TRASTORNOS MIXTOS Y OTROS TRASTORNOS DE LA PERSONALIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "F620",
    "nombre_dx": "F620-CAMBIO PERDURABLE DE LA PERSONALIDAD DESPUES DE UNA EXPERIENCIA CATASTROFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F621",
    "nombre_dx": "F621-CAMBIO PERDURABLE DE LA PERSONALIDAD CONSECUTIVO A UNA ENFERMEDAD PSIQUIATRICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F628",
    "nombre_dx": "F628-OTROS CAMBIOS PERDURABLES DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "F629",
    "nombre_dx": "F629-CAMBIO PERDURABLE DE LA PERSONALIDAD, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F630",
    "nombre_dx": "F630-JUEGO PATOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "F631",
    "nombre_dx": "F631-PIROMANIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F632",
    "nombre_dx": "F632-HURTO PATOLOGICO (CLEPTOMANIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "F633",
    "nombre_dx": "F633-TRICOTILOMANIA",
    "sexo": "A"
  },
  {
    "cod_dx": "F638",
    "nombre_dx": "F638-OTROS TRASTORNOS DE LOS HABITOS Y DE LOS IMPULSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F639",
    "nombre_dx": "F639-TRASTORNO DE LOS HABITOS Y DE LOS IMPULSOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F640",
    "nombre_dx": "F640-TRANSEXUALISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F641",
    "nombre_dx": "F641-TRANSVESTISMO DE ROL DUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F642",
    "nombre_dx": "F642-TRASTORNO DE LA IDENTIDAD DE GENERO EN LA NIÑEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "F648",
    "nombre_dx": "F648-OTROS TRASTORNOS DE LA IDENTIDAD DE GENERO",
    "sexo": "A"
  },
  {
    "cod_dx": "F649",
    "nombre_dx": "F649-TRASTORNO DE LA IDENTIDAD DE GENERO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F650",
    "nombre_dx": "F650-FETICHISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F651",
    "nombre_dx": "F651-TRANSVESTISMO FETICHISTA",
    "sexo": "A"
  },
  {
    "cod_dx": "F652",
    "nombre_dx": "F652-EXHIBICIONISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F653",
    "nombre_dx": "F653-VOYEURISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F654",
    "nombre_dx": "F654-PEDOFILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F655",
    "nombre_dx": "F655-SADOMASOQUISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F656",
    "nombre_dx": "F656-TRASTORNOS MULTIPLES DE LA PREFERENCIA SEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F658",
    "nombre_dx": "F658-OTROS TRASTORNOS DE LA PREFERENCIA SEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F659",
    "nombre_dx": "F659-TRASTORNO DE LA PREFERENCIA SEXUAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F660",
    "nombre_dx": "F660-TRASTORNO DE LA MADURACION SEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F661",
    "nombre_dx": "F661-ORIENTACION SEXUAL EGODISTONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F662",
    "nombre_dx": "F662-TRASTORNO DE LA RELACION SEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F668",
    "nombre_dx": "F668-OTROS TRASTORNOS DEL DESARROLLO PSICOSEXUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "F669",
    "nombre_dx": "F669-TRASTORNO DEL DESARROLLO PSICOSEXUAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F680",
    "nombre_dx": "F680-ELABORACION DE SINTOMAS FISICOS POR CAUSAS PSICOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F681",
    "nombre_dx": "F681-PRODUCCION INTENCIONAL O SIMULACION DE SINTOMAS O DE INCAPACIDADES, TANTO FISICAS COMO PSICOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F688",
    "nombre_dx": "F688-OTROS TRASTORNOS ESPECIFICADOS DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F69X",
    "nombre_dx": "F69X-TRASTORNO DE LA PERSONALIDAD Y DEL COMPORTAMIENTO EN ADULTOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F700",
    "nombre_dx": "F700-RETRASO MENTAL LEVE: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F701",
    "nombre_dx": "F701-RETRASOMENTAL LEVE: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREATENCION O TRATAMIEN",
    "sexo": "A"
  },
  {
    "cod_dx": "F708",
    "nombre_dx": "F708-RETRASOMENTAL LEVE: OTROSDETERIOROS DEL COMPORTAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "F709",
    "nombre_dx": "F709-RETRASOMENTAL LEVE: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F710",
    "nombre_dx": "F710-RETRASO MENTAL MODERADO: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F711",
    "nombre_dx": "F711-RETRASOMENTAL MODERADO: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREATENCION O TRATA",
    "sexo": "A"
  },
  {
    "cod_dx": "F718",
    "nombre_dx": "F718-RETRASOMENTAL MODERADO: OTROSDETERIOROS DEL COMPORTAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "F719",
    "nombre_dx": "F719-RETRASOMENTAL MODERADO: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F720",
    "nombre_dx": "F720-RETRASO MENTAL GRAVE: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F721",
    "nombre_dx": "F721-RETRASOMENTAL GRAVE: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREATENCION O TRATAMIE",
    "sexo": "A"
  },
  {
    "cod_dx": "F728",
    "nombre_dx": "F728-RETRASOMENTAL GRAVE: OTROSDETERIOROS DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F729",
    "nombre_dx": "F729-RETRASOMENTAL GRAVE: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F730",
    "nombre_dx": "F730-RETRASO MENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F731",
    "nombre_dx": "F731-RETRASOMENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREATENCION O TRATA",
    "sexo": "A"
  },
  {
    "cod_dx": "F738",
    "nombre_dx": "F738-RETRASOMENTAL PROFUNDO: OTROSDETERIOROS DEL COMPORTAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "F739",
    "nombre_dx": "F739-RETRASOMENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F780",
    "nombre_dx": "F780-OTROS TIPOS DE RETRASO MENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO",
    "sexo": "A"
  },
  {
    "cod_dx": "F781",
    "nombre_dx": "F781-OTROS TIPOS DE RETRASOMENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREA",
    "sexo": "A"
  },
  {
    "cod_dx": "F788",
    "nombre_dx": "F788-OTROS TIPOS DE RETRASOMENTAL PROFUNDO: OTROSDETERIOROS DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F789",
    "nombre_dx": "F789-OTROS TIPOS DE RETRASOMENTAL PROFUNDO: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F790",
    "nombre_dx": "F790-RETRASO MENTAL, NO ESPECIFICADO: DETERIORO DEL COMPORTAMIENTO NULO O MINIMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F791",
    "nombre_dx": "F791-RETRASOMENTAL, NO ESPECIFICADO: DETERIORO DEL COMPORTAMIENTO SIGNIFICATIVO, QUE REQUIEREATENCION",
    "sexo": "A"
  },
  {
    "cod_dx": "F798",
    "nombre_dx": "F798-RETRASOMENTAL, NO ESPECIFICADO: OTROSDETERIOROS DEL COMPORTAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "F799",
    "nombre_dx": "F799-RETRASOMENTAL, NO ESPECIFICADO: DETERIORO DEL COMPORTAMIENTO DE GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F800",
    "nombre_dx": "F800-TRASTORNO ESPECIFICO DE LA PRONUNCIACION",
    "sexo": "A"
  },
  {
    "cod_dx": "F801",
    "nombre_dx": "F801-TRASTORNO DEL LENGUAJE EXPRESIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F802",
    "nombre_dx": "F802-TRASTORNO DE LA RECEPCION DEL LENGUAJE",
    "sexo": "A"
  },
  {
    "cod_dx": "F803",
    "nombre_dx": "F803-AFASIA ADQUIRIDA CON EPILEPSIA [LANDAU-KLEFFNER]",
    "sexo": "A"
  },
  {
    "cod_dx": "F808",
    "nombre_dx": "F808-OTROS TRASTORNOS DEL DESARROLLO DEL HABLA Y DEL LENGUAJE",
    "sexo": "A"
  },
  {
    "cod_dx": "F809",
    "nombre_dx": "F809-TRASTORNO DEL DESARROLLO DEL HABLA Y DEL LENGUAJE NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F810",
    "nombre_dx": "F810-TRASTORNO ESPECIFICO DE LA LECTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "F811",
    "nombre_dx": "F811-TRASTORNO ESPECIFICO DEL DELETREO (ORTOGRAFIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "F812",
    "nombre_dx": "F812-TRASTORNO ESPECIFICO DE LAS HABILIDADES ARITMETICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F813",
    "nombre_dx": "F813-TRASTORNO MIXTO DE LAS HABILIDADES ESCOLARES",
    "sexo": "A"
  },
  {
    "cod_dx": "F818",
    "nombre_dx": "F818-OTROS TRASTORNOS DEL DESARROLLO DE LAS HABILIDADES ESCOLARES",
    "sexo": "A"
  },
  {
    "cod_dx": "F819",
    "nombre_dx": "F819-TRASTORNO DEL DESARROLLO DE LAS HABILIDADES ESCOLARES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F82X",
    "nombre_dx": "F82X-TRASTORNO ESPECIFICO DEL DESARROLLO DE LA FUNCION MOTRIZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F83X",
    "nombre_dx": "F83X-TRASTORNOS ESPECIFICOS MIXTOS DEL DESARROLLO",
    "sexo": "A"
  },
  {
    "cod_dx": "F840",
    "nombre_dx": "F840-AUTISMO EN LA NIÑEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "F841",
    "nombre_dx": "F841-AUTISMO ATIPICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F842",
    "nombre_dx": "F842-SINDROME DE RETT",
    "sexo": "F"
  },
  {
    "cod_dx": "F843",
    "nombre_dx": "F843-OTRO TRASTORNO DESINTEGRATIVO DE LA NIÑEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "F844",
    "nombre_dx": "F844-TRASTORNO HIPERACTIVO ASOCIADO CON RETRASO MENTAL Y MOVIMIENTOS ESTEREOTIPADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F845",
    "nombre_dx": "F845-SINDROME DE ASPERGER",
    "sexo": "A"
  },
  {
    "cod_dx": "F848",
    "nombre_dx": "F848-OTROS TRASTORNOS GENERALIZADOS DEL DESARROLLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F849",
    "nombre_dx": "F849-TRASTORNO GENERALIZADO DEL DESARROLLO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F88X",
    "nombre_dx": "F88X-OTROS TRASTORNOS DEL DESARROLLO PSICOLOGICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F89X",
    "nombre_dx": "F89X-TRASTORNO DEL DESARROLLO PSICOLOGICO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F900",
    "nombre_dx": "F900-PERTURBACION DE LA ACTIVIDAD Y DE LA ATENCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "F901",
    "nombre_dx": "F901-TRASTORNO HIPERCINETICO DE LA CONDUCTA",
    "sexo": "A"
  },
  {
    "cod_dx": "F908",
    "nombre_dx": "F908-OTROS TRASTORNOS HIPERCINETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F909",
    "nombre_dx": "F909-TRASTORNO HIPERCINETICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F910",
    "nombre_dx": "F910-TRASTORNO DE LA CONDUCTA LIMITADO AL CONTEXTO FAMILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "F911",
    "nombre_dx": "F911-TRASTORNO DE LA CONDUCTA INSOCIABLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F912",
    "nombre_dx": "F912-TRASTORNO DE LA CONDUCTA SOCIABLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F913",
    "nombre_dx": "F913-TRASTORNO OPOSITOR DESAFIANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "F918",
    "nombre_dx": "F918-OTROS TRASTORNOS DE LA CONDUCTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F919",
    "nombre_dx": "F919-TRASTORNO DE LA CONDUCTA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F920",
    "nombre_dx": "F920-TRASTORNO DEPRESIVO DE LACONDUCTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F928",
    "nombre_dx": "F928-OTROS TRASTORNOS MIXTOS DE LA CONDUCTA Y DE LAS EMOCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "F929",
    "nombre_dx": "F929-TRASTORNO MIXTO DE LA CONDUCTA Y DE LAS EMOCIONES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F930",
    "nombre_dx": "F930-TRASTORNO DE ANSIEDAD DE SEPARACION EN LA NIÑEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "F931",
    "nombre_dx": "F931-TRASTORNO DE ANSIEDAD FOBICA EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F932",
    "nombre_dx": "F932-TRASTORNO DE ANSIEDAD SOCIAL EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F933",
    "nombre_dx": "F933-TRASTORNO DE RIVALIDAD ENTRE HERMANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "F938",
    "nombre_dx": "F938-OTROS TRASTORNOS EMOCIONALES EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F939",
    "nombre_dx": "F939-TRASTORNO EMOCIONAL EN LA NIÑEZ, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F940",
    "nombre_dx": "F940-MUTISMO ELECTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "F941",
    "nombre_dx": "F941-TRASTORNO DE VINCULACION REACTIVA EN LA NIÑEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "F942",
    "nombre_dx": "F942-TRASTORNO DE VINCULACION DESINHIBIDA EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F948",
    "nombre_dx": "F948-OTROS TRASTORNOS DEL COMPORTAMIENTO SOCIAL EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F949",
    "nombre_dx": "F949-TRASTORNO DEL COMPORTAMIENTO SOCIAL EN LA NIÑEZ, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F950",
    "nombre_dx": "F950-TRASTORNO POR TIC TRANSITORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F951",
    "nombre_dx": "F951-TRASTORNO POR TIC MOTOR O VOCAL CRONICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F952",
    "nombre_dx": "F952-TRASTORNOS POR TICS MOTORES Y VOCALES MULTIPLES COMBINADOS [DE LA TOURETTE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "F958",
    "nombre_dx": "F958-OTROS TRASTORNOS POR TIC",
    "sexo": "A"
  },
  {
    "cod_dx": "F959",
    "nombre_dx": "F959-TRASTORNOPOR TIC, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F980",
    "nombre_dx": "F980-ENURESIS NO ORGANICA",
    "sexo": "A"
  },
  {
    "cod_dx": "F981",
    "nombre_dx": "F981-ECOPRESIS NO ORGANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "F982",
    "nombre_dx": "F982-TRASTORNO DE LA INGESTION ALIMENTARIA EN LA INFANCIA Y EN LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F983",
    "nombre_dx": "F983-PICA EN LA INFANCIA Y LA NIÑEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "F984",
    "nombre_dx": "F984-TRASTORNOS DE LOS MOVIMIENTOS ESTEREOTIPADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "F985",
    "nombre_dx": "F985-TARTAMUDEZ [ESPASMOFEMIA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "F986",
    "nombre_dx": "F986-FARFULLEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "F988",
    "nombre_dx": "F988-OTROS TRASTORNOS EMOCIONALES Y DEL COMPORTAMIENTO QUE APARECEN HABITUALMENTE EN LA NIÑEZ Y EN LA ADO",
    "sexo": "A"
  },
  {
    "cod_dx": "F989",
    "nombre_dx": "F989-TRASTORNOS NO ESPECIFICADOS, EMOCIONALES Y DEL COMPORTAMIENTO, QUE APARECEN HABITUALMENTE EN LA NIÑE",
    "sexo": "A"
  },
  {
    "cod_dx": "F99X",
    "nombre_dx": "F99X-TRASTORNO MENTAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G000",
    "nombre_dx": "G000-MENINGITIS POR HEMOFILOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G001",
    "nombre_dx": "G001-MENINGITIS NEUMOCOCICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G002",
    "nombre_dx": "G002-MENINGITIS ESTREPTOCOCICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G003",
    "nombre_dx": "G003-MENINGITIS ESTAFILOCOCICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G008",
    "nombre_dx": "G008-OTRAS MENINGITIS BACTERIANAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G009",
    "nombre_dx": "G009-MENINGITIS BACTERIANA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G01X",
    "nombre_dx": "G01X-MENINGITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G020",
    "nombre_dx": "G020-MENINGITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G021",
    "nombre_dx": "G021-MENINGITIS ENMICOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "G028",
    "nombre_dx": "G028-MENINGITISEN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS CLASIFICADAS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "G030",
    "nombre_dx": "G030-MENINGITIS APIOGENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G031",
    "nombre_dx": "G031-MENINGITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G032",
    "nombre_dx": "G032-MENINGITIS RECURRENTE BENIGNA [MOLLARET]",
    "sexo": "A"
  },
  {
    "cod_dx": "G038",
    "nombre_dx": "G038-MENINGITIS DEBIDAS A OTRAS CAUSAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G039",
    "nombre_dx": "G039-MENINGITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G040",
    "nombre_dx": "G040-ENCEFALITIS AGUDA DISEMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G041",
    "nombre_dx": "G041-Mielopatia asociada al virus linfotropico de celulas T humanas",
    "sexo": "A"
  },
  {
    "cod_dx": "G042",
    "nombre_dx": "G042-MENINGOENCEFALITIS Y MENINGOMIELITIS BACTERIANAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G048",
    "nombre_dx": "G048-OTRAS ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "G049",
    "nombre_dx": "G049-ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS, NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G050",
    "nombre_dx": "G050-ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G051",
    "nombre_dx": "G051-ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G052",
    "nombre_dx": "G052-ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "G058",
    "nombre_dx": "G058-ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS ENENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G060",
    "nombre_dx": "G060-ABSCESO Y GRANULOMA INTRACRANEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G061",
    "nombre_dx": "G061-ABSCESO Y GRANULOMA INTRARRAQUIDEO",
    "sexo": "A"
  },
  {
    "cod_dx": "G062",
    "nombre_dx": "G062-ABSCESO EXTRADURAL Y SUBDURAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G07X",
    "nombre_dx": "G07X-ABSCESO Y GRANULOMA INTRACRANEAL E INTRARRAQUIDEO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G08x",
    "nombre_dx": "G08x-FLEBITIS Y TROMBOFLEBITIS INTRACRANEAL E INTRARRAQUIDEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G09X",
    "nombre_dx": "G09X-SECUELAS DE ENFERMEDADES INFLAMATORIAS DEL SISTEMA NERVIOSO CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G10X",
    "nombre_dx": "G10X-ENFERMEDAD DE HUNTINGTON",
    "sexo": "A"
  },
  {
    "cod_dx": "G110",
    "nombre_dx": "G110-ATAXIA CONGENITA NO PROGRESIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "G111",
    "nombre_dx": "G111-ATAXIA CEREBELOSA DE INICIACION TEMPRANA",
    "sexo": "A"
  },
  {
    "cod_dx": "G112",
    "nombre_dx": "G112-ATAXIA CEREBELOSA DE INICIACION TARDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "G113",
    "nombre_dx": "G113-ATAXIA CEREBELOSA CON REPARACION DEFECTUOSA DEL ADN ",
    "sexo": "A"
  },
  {
    "cod_dx": "G114",
    "nombre_dx": "G114-PARAPLEJÍA ESPASTICA HEREDITARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "G118",
    "nombre_dx": "G118-OTRAS ATAXIAS HEREDITARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G119",
    "nombre_dx": "G119-ATAXIA HEREDITARIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G120",
    "nombre_dx": "G120-ATROFIA MUSCULAR ESPINAL INFANTIL, TIPO I [WERDNIG-HOFFMAN] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G121",
    "nombre_dx": "G121-OTRAS ATROFIAS MUSCULARES ESPINALES HEREDITARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G122",
    "nombre_dx": "G122-ENFERMEDADES DE LAS NEURONAS MOTORAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G128",
    "nombre_dx": "G128-OTRAS ATROFIAS MUSCULARES ESPINALES Y SINDROMES AFINES",
    "sexo": "A"
  },
  {
    "cod_dx": "G129",
    "nombre_dx": "G129-ATROFIA MUSCULAR ESPINAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "G130",
    "nombre_dx": "G130-NEUROMIOPATIA Y NEUROPATIA PARANEOPLASICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G131",
    "nombre_dx": "G131-OTRAS ATROFIAS SISTEMICAS QUE AFECTAN EL SISTEMA NERVIOSO CENTRAL EN ENFERMEDAD NEOPLASICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G132",
    "nombre_dx": "G132-ATROFIA SISTEMICA QUE AFECTA PRIMARIAMENTE EL SISTEMA NERVIOSO CENTRAL EN EL MIXEDEMA (E00.1+, E03.-",
    "sexo": "A"
  },
  {
    "cod_dx": "G138",
    "nombre_dx": "G138-ATROFIA SISTEMICA QUE AFECTA PRIMARIAMENTE EL SISTEMA NERVIOSO CENTRAL EN OTRAS ENFERMEDADES CLASIFI",
    "sexo": "A"
  },
  {
    "cod_dx": "G14X",
    "nombre_dx": "G14X-Síndrome postpolio",
    "sexo": "A"
  },
  {
    "cod_dx": "G20X",
    "nombre_dx": "G20X-ENFERMEDAD DE PARKINSON ",
    "sexo": "A"
  },
  {
    "cod_dx": "G210",
    "nombre_dx": "G210-SINDROME NEUROLEPTICO MALIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G211",
    "nombre_dx": "G211-OTRO PARKINSONISMO SECUNDARIO INDUCIDO POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G212",
    "nombre_dx": "G212-PARKINSONISMO SECUNDARIODEBIDO A OTROS AGENTES EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G213",
    "nombre_dx": "G213-PARKINSONISMOPOSTENCEFALITICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G214",
    "nombre_dx": "G214-Parkinsonismo vascular",
    "sexo": "A"
  },
  {
    "cod_dx": "G218",
    "nombre_dx": "G218-OTROS TIPOS DE PARKINSONISMO SECUNDARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G219",
    "nombre_dx": "G219-PARKINSONISMOSECUNDARIO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G22X",
    "nombre_dx": "G22X-PARKINSONISMO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G230",
    "nombre_dx": "G230-ENFERMEDAD DE HALLERVORDEN-SPATZ",
    "sexo": "A"
  },
  {
    "cod_dx": "G231",
    "nombre_dx": "G231-OFTALMOPLEJIA SUPRANUCLEAR PROGRESIVA [STEELE-RICHARDSON-OLSZEWSKI] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G232",
    "nombre_dx": "G232-Atrofia sistemica multiple, tipo parkinsoniana [AMS-P]",
    "sexo": "A"
  },
  {
    "cod_dx": "G238",
    "nombre_dx": "G238-OTRAS ENFERMEDADES DEGENERATIVAS ESPECIFICADAS DE LOS NUCLEOS DE LA BASE",
    "sexo": "A"
  },
  {
    "cod_dx": "G239",
    "nombre_dx": "G239-ENFERMEDAD DEGENERATIVA DE LOS NUCLEOS DE LA BASE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G240",
    "nombre_dx": "G240-DISTONIA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G241",
    "nombre_dx": "G241-DISTONIA IDIOPATICA FAMILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "G242",
    "nombre_dx": "G242-DISTONIA IDIOPATICA NO FAMILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G243",
    "nombre_dx": "G243-TORTICOLIS ESPASMODICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G244",
    "nombre_dx": "G244-DISTONIA BUCOFACIAL IDIOPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G245",
    "nombre_dx": "G245-BLEFAROSPASMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G248",
    "nombre_dx": "G248-OTRAS DISTONIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G249",
    "nombre_dx": "G249-DISTONIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G250",
    "nombre_dx": "G250-TEMBLOR ESENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G251",
    "nombre_dx": "G251-TEMBLOR INDUCIDO POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G252",
    "nombre_dx": "G252-OTRAS FORMAS ESPECIFICADAS DE TEMBLOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G253",
    "nombre_dx": "G253-MIOCLONIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G254",
    "nombre_dx": "G254-COREA INDUCIDA POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G255",
    "nombre_dx": "G255-OTRAS COREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G256",
    "nombre_dx": "G256-TIC INDUCIDOS POR DROGAS Y OTROS TICS DE ORIGEN ORGANICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G258",
    "nombre_dx": "G258-OTROS TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "G259",
    "nombre_dx": "G259-TRASTORNO EXTRAPIRAMIDAL Y DEL MOVIMIENTO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G26X",
    "nombre_dx": "G26X-TRASTORNOS EXTRAPIRAMIDALES Y DEL MOVIMIENTO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G300",
    "nombre_dx": "G300-ENFERMEDAD DE ALZHEIMER DE COMIENZO TEMPRANO",
    "sexo": "A"
  },
  {
    "cod_dx": "G301",
    "nombre_dx": "G301-ENFERMEDAD DE ALZHEIMER COMIENZO TARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G308",
    "nombre_dx": "G308-OTROS TIPOS DE ENFERMEDAD DE ALZHEIMER",
    "sexo": "A"
  },
  {
    "cod_dx": "G309",
    "nombre_dx": "G309-ENFERMEDAD DE ALZHEIMER, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G310",
    "nombre_dx": "G310-ATROFIA CEREBRAL CIRCUNSCRITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G311",
    "nombre_dx": "G311-DEGENERACION CEREBRAL SENIL NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G312",
    "nombre_dx": "G312-DEGENERACION DEL SISTEMA NERVIOSO DEBIDA A EL ALCOHOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G318",
    "nombre_dx": "G318-OTRAS ENFERMEDADES DEGENERATIVAS ESPECIFICADAS DEL SISTEMA NERVIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G319",
    "nombre_dx": "G319-DEGENERACION DEL SISTEMA NERVIOSO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G320",
    "nombre_dx": "G320-DEGENERACION COMBINADA SUBAGUDA DE LA MEDULA ESPINAL EN ENFERNEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G328",
    "nombre_dx": "G328-OTROS TRASTORNOS DEGENERATIVOS ESPECIFICADOS DEL SISTEMA NERVIOSOEN ENFERMEDADES CLASIFICADAS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "G35X",
    "nombre_dx": "G35X-ESCLEROSIS MULTIPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G360",
    "nombre_dx": "G360-NEUROMIELITIS OPTICA [DEVIC]",
    "sexo": "A"
  },
  {
    "cod_dx": "G361",
    "nombre_dx": "G361-LEUCOENCEFALITIS HEMORRAGICA AGUDA Y SUBAGUDA [HURST] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G368",
    "nombre_dx": "G368-OTRAS DESMIELINIZACIONES AGUDAS DISEMINADAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G369",
    "nombre_dx": "G369-DESMIELINIZACION DISEMINADA AGUDA SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "G370",
    "nombre_dx": "G370-ESCLEROSIS DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G371",
    "nombre_dx": "G371-DESMIELINIZACION CENTRAL DEL CUERPO CALLOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G372",
    "nombre_dx": "G372-MIELINOLISIS CENTRAL PONTINA",
    "sexo": "A"
  },
  {
    "cod_dx": "G373",
    "nombre_dx": "G373-MIELITIS TRANSVERSA AGUDA EN ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G374",
    "nombre_dx": "G374-MIELITIS NECROTIZANTE SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "G375",
    "nombre_dx": "G375-ESCLEROSIS CONCENTRICA (BALO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G378",
    "nombre_dx": "G378-OTRAS ENFERMEDADES DESMIELINIZANTES DEL SISTEMA NERVIOSO CENTRAL, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G379",
    "nombre_dx": "G379-ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G400",
    "nombre_dx": "G400-EPILEPSIA Y SINDROMES EPILEPTICOS IDIOPATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES) (PARCIALES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G401",
    "nombre_dx": "G401-EPILEPSIA Y SINDROMES EPILEPTICOS SINTOMATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES) (PARCIALES)",
    "sexo": "A"
  },
  {
    "cod_dx": "G402",
    "nombre_dx": "G402-EPILEPSIA Y SINDROMES EPILEPTICOS SINTOMATICOS RELACIONADOS CON LOCALIZACIONES (FOCALES) (PARCIALES)",
    "sexo": "A"
  },
  {
    "cod_dx": "G403",
    "nombre_dx": "G403-EPILEPSIA Y SINDROMES EPILEPTICOS IDIOPATICOS GENERALIZADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G404",
    "nombre_dx": "G404-OTRAS EPILEPSIAS Y SINDROMES EPILEPTICOS GENERALIZADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G405",
    "nombre_dx": "G405-SINDROMES EPILEPTICOS ESPECIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "G406",
    "nombre_dx": "G406-ATAQUES DE GRAN MAL, NO ESPECIFICADOS (CON O SIN PEQUEÑO MAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G407",
    "nombre_dx": "G407-PEQUEÑO MAL, NO ESPECIFICADO (SIN ATAQUE DE GRAN MAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G408",
    "nombre_dx": "G408-OTRAS EPILEPSIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G409",
    "nombre_dx": "G409-EPILEPSIA, TIPO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G410",
    "nombre_dx": "G410-ESTADO DE GRAN MAL EPILEPTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G411",
    "nombre_dx": "G411-ESTADO DE PEQUEÑO MAL EPILEPTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G412",
    "nombre_dx": "G412-ESTADO DEMAL EPILEPTICO PARCIAL COMPLEJO",
    "sexo": "A"
  },
  {
    "cod_dx": "G418",
    "nombre_dx": "G418-OTROS ESTADOS EPILÉPTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G419",
    "nombre_dx": "G419-ESTADO DE MAL EPILEPTICODE TIPO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G430",
    "nombre_dx": "G430-MIGRAÑA SIN AURA [MIGRAÑA COMUN]",
    "sexo": "A"
  },
  {
    "cod_dx": "G431",
    "nombre_dx": "G431-MIGRAÑA CON AURA [MIGRAÑA CLASICA]",
    "sexo": "A"
  },
  {
    "cod_dx": "G432",
    "nombre_dx": "G432-ESTADO MIGRAÑOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "G433",
    "nombre_dx": "G433-MIGRAÑACOMPLICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G438",
    "nombre_dx": "G438-OTRAS MIGRAÑAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G439",
    "nombre_dx": "G439-MIGRAÑA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "G440",
    "nombre_dx": "G440-SINDROME DE CEFALEA EN RACIMOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G441",
    "nombre_dx": "G441-CEFALEA VASCULAR, NCOP",
    "sexo": "A"
  },
  {
    "cod_dx": "G442",
    "nombre_dx": "G442-CEFALEA DEBIDA A TENSION",
    "sexo": "A"
  },
  {
    "cod_dx": "G443",
    "nombre_dx": "G443-CEFALEA POSTRAUMATICA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G444",
    "nombre_dx": "G444-CEFALEA INDUCIDA POR DROGAS, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G448",
    "nombre_dx": "G448-OTROS SINDROMES DE CEFALEA ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G450",
    "nombre_dx": "G450-SINDROME ARTERIAL VERTEBRO-BASILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "G451",
    "nombre_dx": "G451-SINDROME DE LA ARTERIA CAROTIDA (HEMISFÉRICO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G452",
    "nombre_dx": "G452-SINDROMES ARTERIALES PRECEREBRALES BILATERALES Y MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "G453",
    "nombre_dx": "G453-AMAUROSIS FUGAZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "G454",
    "nombre_dx": "G454-AMNESIA GLOBAL TRANSITORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "G458",
    "nombre_dx": "G458-OTRAS ISQUEMIAS CEREBRALES TRANSITORIAS Y SINDROMES AFINES",
    "sexo": "A"
  },
  {
    "cod_dx": "G459",
    "nombre_dx": "G459-ISQUEMIA CEREBRAL TRANSITORIA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "G460",
    "nombre_dx": "G460-CEREBRAL MEDIA (I66.0+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G461",
    "nombre_dx": "G461-SINDROME DE LA ARTERIA CEREBRALANTERIOR (I66.1+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G462",
    "nombre_dx": "G462-SINDROME DE LA ARTERIA CEREBRALPOSTERIOR (I66.2+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G463",
    "nombre_dx": "G463-SINDROMES APOPLETICOS DEL TALLO ENCEFALICO (I60-I67+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G464",
    "nombre_dx": "G464-SINDROMEDE INFARTO CEREBELOSO (I60-I67+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G465",
    "nombre_dx": "G465-SINDROME LACUNAR MOTOR PURO (I60-I67+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G466",
    "nombre_dx": "G466-SINDROME LACUNAR SENSORIAL PURO (I60-I67+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G467",
    "nombre_dx": "G467-OTROS SINDROMES LACUNARES (I60-I67+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G468",
    "nombre_dx": "G468-OTROS SINDROMES VASCULARES ENCEFALICOS EN ENFERMEDADES CEREBROVASCULARES (I60-I67+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G470",
    "nombre_dx": "G470-TRASTORNOS DEL INICIO Y DEL MANTENIMIENTO DEL SUEÑO [INSOMNIOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G471",
    "nombre_dx": "G471-TRASTORNOS DE SOMNOLENCIA EXCESIVA [HIPERSOMNIOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G472",
    "nombre_dx": "G472-TRASTORNOS DEL RITMO NICTAMERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G473",
    "nombre_dx": "G473-APNEA DEL SUEÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G474",
    "nombre_dx": "G474-NARCOLEPSIA Y CATAPLEXIA",
    "sexo": "A"
  },
  {
    "cod_dx": "G478",
    "nombre_dx": "G478-OTROS TRASTORNOS DEL SUEÑO",
    "sexo": "A"
  },
  {
    "cod_dx": "G479",
    "nombre_dx": "G479-TRASTORNO DEL SUEÑO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G500",
    "nombre_dx": "G500-NEURALGIA DEL TRIGEMINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G501",
    "nombre_dx": "G501-DOLOR FACIAL ATIPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G508",
    "nombre_dx": "G508-OTROS TRASTORNOS DEL TRIGEMINO",
    "sexo": "A"
  },
  {
    "cod_dx": "G509",
    "nombre_dx": "G509-TRASTORNOS DEL TRIGEMINO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G510",
    "nombre_dx": "G510-PARALISIS DE BELL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G511",
    "nombre_dx": "G511-GANGLIONITIS GENICULADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G512",
    "nombre_dx": "G512-SINDROME DE MELKERSSON",
    "sexo": "A"
  },
  {
    "cod_dx": "G513",
    "nombre_dx": "G513-ESPASMO HEMIFACIAL CLONICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G514",
    "nombre_dx": "G514-MIOQUIMIA FACIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G518",
    "nombre_dx": "G518-OTROS TRASTORNOS DEL NERVIO FACIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G519",
    "nombre_dx": "G519-TRASTORNOS DEL NERVIO FACIAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G520",
    "nombre_dx": "G520-TRASTORNOS DEL NERVIO OLFATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G521",
    "nombre_dx": "G521-TRASTORNOS DEL NERVIO GLOSOFARINGEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G522",
    "nombre_dx": "G522-TRASTORNOS DEL NERVIO VAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "G523",
    "nombre_dx": "G523-TRASTORNOS DEL NERVIO HIPOGLOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G527",
    "nombre_dx": "G527-TRASTORNOS DE MULTIPLES NERVIOS CRANEALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "G528",
    "nombre_dx": "G528-TRASTORNOS DE OTROS NERVIOS CRANEALES ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G529",
    "nombre_dx": "G529-TRASTORNO DE NERVIO CRANEAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G530",
    "nombre_dx": "G530-NEURALGIA POSTHERPES ZOSTER (B02.2+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G531",
    "nombre_dx": "G531-PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G532",
    "nombre_dx": "G532-PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES, EN LA SARCOIDOSIS (D86.8+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G533",
    "nombre_dx": "G533-PARALISIS MULTIPLE DE LOS NERVIOS CRANEALES, EN ENFERMEDADES NEOPLASICAS (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G538",
    "nombre_dx": "G538-OTROS TRASTORNOS DE LOS NERVIOS CRANEALES EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G540",
    "nombre_dx": "G540-TRASTORNOS DEL PLEXO BRAQUIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G541",
    "nombre_dx": "G541-TRASTORNOS DEL PLEXO LUMBOSACRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G542",
    "nombre_dx": "G542-TRASTORNOS DE LA RAIZ CERVICAL, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G543",
    "nombre_dx": "G543-TRASTORNOS DE LA RAIZ TORACICA, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G544",
    "nombre_dx": "G544-TRASTORNOS DE LA RAIZ LUMBOSACRA, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G545",
    "nombre_dx": "G545-AMIOTROFIA NEURALGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G546",
    "nombre_dx": "G546-SINDROME DEL MIEMBRO FANTASMA CON DOLOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G547",
    "nombre_dx": "G547-SINDROME DEL MIEMBRO FANTASMA SIN DOLOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G548",
    "nombre_dx": "G548-OTROS TRASTORNOS DE LAS RAICES Y PLEXOS NERVIOSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G549",
    "nombre_dx": "G549-TRASTORNO DE LA RAIZ Y PLEXOS NERVIOSOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G550",
    "nombre_dx": "G550-COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN ENFERMEDADES NEOPLASICAS(C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G551",
    "nombre_dx": "G551-COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN TRASTORNOS DE LOS DISCOS INTERVERTEBRALES (M50-M51+",
    "sexo": "A"
  },
  {
    "cod_dx": "G552",
    "nombre_dx": "G552-COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN LA ESPONDILOSIS (M47.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G553",
    "nombre_dx": "G553-COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN OTRAS DORSOPATIAS (M45-M46+, M48.-+, M53-M54+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G558",
    "nombre_dx": "G558-COMPRESIONES DE LAS RAICES Y PLEXOS NERVIOSOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G560",
    "nombre_dx": "G560-SINDROME DEL TUNEL CARPIANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G561",
    "nombre_dx": "G561-OTRAS LESIONES DEL NERVIO MEDIANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G562",
    "nombre_dx": "G562-LESION DEL NERVIO CUBITAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G563",
    "nombre_dx": "G563-LESION DEL NERVIO RADIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G564",
    "nombre_dx": "G564-CAUSALGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G568",
    "nombre_dx": "G568-OTRAS MONONEUROPATIAS DEL MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "G569",
    "nombre_dx": "G569-MONONEUROPATIA DEL MIEMBRO SUPERIOR SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "G570",
    "nombre_dx": "G570-LESION DEL NERVIO CIATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G571",
    "nombre_dx": "G571-MERALGIA PARESTESICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G572",
    "nombre_dx": "G572-LESION DEL NERVIO CRURAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G573",
    "nombre_dx": "G573-LESION DEL NERVIO CIATICO POPLITEO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "G574",
    "nombre_dx": "G574-LESION DEL NERVIO CIATICO POPLITEO INTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "G575",
    "nombre_dx": "G575-SINDROME DEL TUNEL CALCANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G576",
    "nombre_dx": "G576-LESION DEL NERVIO PLANTAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G578",
    "nombre_dx": "G578-OTRAS MONONEUROPATIAS DEL MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "G579",
    "nombre_dx": "G579-MONONEUROPATIA DEL MIEMBRO INFERIOR, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "G580",
    "nombre_dx": "G580-NEUROPATIA INTERCOSTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G587",
    "nombre_dx": "G587-MONONEURITIS MULTIPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G588",
    "nombre_dx": "G588-OTRAS MONONEUROPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G589",
    "nombre_dx": "G589-MONONEUROPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G590",
    "nombre_dx": "G590-MONONEUROPATIA DIABETICA (E10-E14+ COMO CUARTO CARACTER COMUN .4) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G598",
    "nombre_dx": "G598-OTRAS MONONEUROPATIAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G600",
    "nombre_dx": "G600-NEUROPTIA HEREDITARIA MOTORA Y SENSORIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G601",
    "nombre_dx": "G601-ENFERMEDAD DE REFSUM",
    "sexo": "A"
  },
  {
    "cod_dx": "G602",
    "nombre_dx": "G602-NEUROPATIA ASOCIADA CON ATAXIA HEREDITARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "G603",
    "nombre_dx": "G603-NEUROPATIA PROGRESIVA IDIOPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G608",
    "nombre_dx": "G608-OTRAS NEUROPATIAS HEREDITARIAS E IDIOPATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G609",
    "nombre_dx": "G609-NEUROPATIA HEREDITARIA E IDIOPATICA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "G610",
    "nombre_dx": "G610-SINDROME DE GUILLAIN-BARRE",
    "sexo": "A"
  },
  {
    "cod_dx": "G611",
    "nombre_dx": "G611-NEUROPATIA AL SUERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G618",
    "nombre_dx": "G618-OTRAS POLINEUROPATIAS INFLAMATORIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G619",
    "nombre_dx": "G619-POLINEUROPATIAINFLAMATORIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G620",
    "nombre_dx": "G620-POLINEUROPATIA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G621",
    "nombre_dx": "G621-POLINEUROPATIA ALCOHOLICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G622",
    "nombre_dx": "G622-POLINEUROPATIA DEBIDA A OTRO AGENTE TOXICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G628",
    "nombre_dx": "G628-OTRAS POLINEUROPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G629",
    "nombre_dx": "G629-POLINEUROPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G630",
    "nombre_dx": "G630-POLINEUROPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G631",
    "nombre_dx": "G631-POLINEUROPATIA EN ENFERMEDAD NEOPLASICA (C00-D48+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G632",
    "nombre_dx": "G632-POLINEUROPATIA DIABETICA (E10-E14+ CON CUARTO CARACTER COMUN .4)",
    "sexo": "A"
  },
  {
    "cod_dx": "G633",
    "nombre_dx": "G633-POLINEUROPATIA EN OTRASENFERMEDADES ENDOCRINAS Y METABOLICAS (E00-E07+, E15-E16+, E20-E34+, E70-E8",
    "sexo": "A"
  },
  {
    "cod_dx": "G634",
    "nombre_dx": "G634-POLINEUROPATIA EN DEFICIENCIA NUTRICIONAL (E40-E64+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G635",
    "nombre_dx": "G635-POLINEUROPATIA EN TRASTORNOS DEL TEJIDO CONECTIVO SISTEMICO (M30-M35+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G636",
    "nombre_dx": "G636-POLINEUROPATIA EN OTROS TRASTORNOS OSTEOMUSCULARES (M00-M25+, M40-M96+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G638",
    "nombre_dx": "G638-POLINEUROPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G64X",
    "nombre_dx": "G64X-OTROS TRASTORNOS DEL SISTEMA NERVIOSO PERIFERICO",
    "sexo": "A"
  },
  {
    "cod_dx": "G700",
    "nombre_dx": "G700-MIASTENIA GRAVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "G701",
    "nombre_dx": "G701-TRASTORNOS TOXICOS NEUROMUSCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "G702",
    "nombre_dx": "G702-MIASTENIA CONGENITA O DEL DESARROLLO",
    "sexo": "A"
  },
  {
    "cod_dx": "G708",
    "nombre_dx": "G708-OTROS TRASTORNOS NEUROMUSCULARES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G709",
    "nombre_dx": "G709-TRASTORNO NEUROMUSCULAR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G710",
    "nombre_dx": "G710-DISTROFIA MUSCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "G711",
    "nombre_dx": "G711-TRASTORNOS MIOTONICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G712",
    "nombre_dx": "G712-MIOPATIAS CONGENITAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G713",
    "nombre_dx": "G713-MIOPATIA MITOCONDRICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G718",
    "nombre_dx": "G718-OTROS TRASTORNOS PRIMARIOS DE LOS MUSCULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "G719",
    "nombre_dx": "G719-TRASTORNO PRIMARIO DEL MUSCULO, TIPO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G720",
    "nombre_dx": "G720-MIOPATIA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G721",
    "nombre_dx": "G721-MIOPATIA ALCOHOLICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G722",
    "nombre_dx": "G722-MIOPATIA DEBIDA A OTROS AGENTES TOXICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G723",
    "nombre_dx": "G723-PARALISIS PERIODICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G724",
    "nombre_dx": "G724-MIOPATIA INFLAMATORIA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G728",
    "nombre_dx": "G728-OTRAS MIOPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G729",
    "nombre_dx": "G729-MIOPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G730",
    "nombre_dx": "G730-SINDROMES MIASTENICOS EN ENFERMEDADES ENDOCRINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G731",
    "nombre_dx": "G731-Síndrome de Eaton-Lambert (C00-D48†)(antes SINDROME DE EATON-LAMBERT (C80†))",
    "sexo": "A"
  },
  {
    "cod_dx": "G732",
    "nombre_dx": "G732-OTROS SINDROMES MIASTENICOS EN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G733",
    "nombre_dx": "G733-SINDROMES MIASTENICOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G734",
    "nombre_dx": "G734-MIOPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G735",
    "nombre_dx": "G735-MIOPATIA EN ENFERMEDADES ENDOCRINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G736",
    "nombre_dx": "G736-MIOPATIA EN ENFERMEDADES METABOLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G737",
    "nombre_dx": "G737-MIOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G800",
    "nombre_dx": "G800-PARALISIS CEREBRAL ESPASTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G801",
    "nombre_dx": "G801-DIPLEJIA ESPASTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G802",
    "nombre_dx": "G802-HEMIPLEJIA INFANTIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G803",
    "nombre_dx": "G803-PARALISIS CEREBRAL DISCINETICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G804",
    "nombre_dx": "G804-PARALISIS CEREBRAL ATAXICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G808",
    "nombre_dx": "G808-OTROS TIPOS DE PARALISIS CEREBRAL INFANTIL",
    "sexo": "A"
  },
  {
    "cod_dx": "G809",
    "nombre_dx": "G809-PARALISIS CEREBRAL INFANTIL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "G810",
    "nombre_dx": "G810-HEMIPLEJIA FLACIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "G811",
    "nombre_dx": "G811-HEMIPLEJIA ESPASTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G819",
    "nombre_dx": "G819-HEMIPLEJIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G820",
    "nombre_dx": "G820-PARAPLEJIA FLACIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "G821",
    "nombre_dx": "G821-PARAPLEJIA ESPASTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G822",
    "nombre_dx": "G822-PARAPLEJIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G823",
    "nombre_dx": "G823-CUADRIPLEJIA FLACIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "G824",
    "nombre_dx": "G824-CUADRIPLEJIA ESPASTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G825",
    "nombre_dx": "G825-CUADRIPLEJIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G830",
    "nombre_dx": "G830-DIPLEJIA DE LOS MIEMBROS SUPERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "G831",
    "nombre_dx": "G831-MONOPLEJIA DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G832",
    "nombre_dx": "G832-MONOPLEJIA DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G833",
    "nombre_dx": "G833-MONOPLEJIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G834",
    "nombre_dx": "G834-SINDROME DE LA COLA DE CABALLO",
    "sexo": "A"
  },
  {
    "cod_dx": "G835",
    "nombre_dx": "G835-Sindrome de enclaustramiento",
    "sexo": "A"
  },
  {
    "cod_dx": "G838",
    "nombre_dx": "G838-OTROS SINDROMES PARALITICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G839",
    "nombre_dx": "G839-SINDROME PARALITICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G900",
    "nombre_dx": "G900-NEUROPATIA AUTONOMA PERIFERICA IDIOPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G901",
    "nombre_dx": "G901-DISAUTONOMIA FAMILIAR [SINDROME DE RILEY-DAY] ",
    "sexo": "A"
  },
  {
    "cod_dx": "G902",
    "nombre_dx": "G902-SINDROME DE HORNER",
    "sexo": "A"
  },
  {
    "cod_dx": "G908",
    "nombre_dx": "G908-OTROS TRASTORNOS DEL SISTEMA NERVIOSO AUTONOMO",
    "sexo": "A"
  },
  {
    "cod_dx": "G909",
    "nombre_dx": "G909-TRASTORNO DEL SISTEMA NERVIOSO AUTONOMO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G910",
    "nombre_dx": "G910-HIDROCEFALO COMUNICANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G911",
    "nombre_dx": "G911-HIDROCEFALO OBSTRUCTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G912",
    "nombre_dx": "G912-HIDROCEFALO DE PRESION NORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G913",
    "nombre_dx": "G913-HIDROCEFALO POSTRAUMATICO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "G918",
    "nombre_dx": "G918-OTROS TIPOS DE HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "G919",
    "nombre_dx": "G919-HIDROCEFALO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "G92X",
    "nombre_dx": "G92X-ENCEFALOPATIA TOXICA",
    "sexo": "A"
  },
  {
    "cod_dx": "G930",
    "nombre_dx": "G930-QUISTE CEREBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G931",
    "nombre_dx": "G931-LESION CEREBRAL ANOXICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G932",
    "nombre_dx": "G932-HIPERTENSION INTRACRANEAL BENIGNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G933",
    "nombre_dx": "G933-SINDROME DE FATIGA POSTVIRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G934",
    "nombre_dx": "G934-ENCEFALOPATIA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G935",
    "nombre_dx": "G935-COMPRESION DEL ENCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G936",
    "nombre_dx": "G936-EDEMA CEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G937",
    "nombre_dx": "G937-SINDROME DE REYE",
    "sexo": "A"
  },
  {
    "cod_dx": "G938",
    "nombre_dx": "G938-OTROS TRASTORNOS ESPECIFICADOS DEL ENCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G939",
    "nombre_dx": "G939-TRASTORNO DEL ENCEFALO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G940",
    "nombre_dx": "G940-HIDROCEFALO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE (A00-B99+)",
    "sexo": "A"
  },
  {
    "cod_dx": "G941",
    "nombre_dx": "G941-HIDROCEFALO EN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "G942",
    "nombre_dx": "G942-HIDROCEFALO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G948",
    "nombre_dx": "G948-OTROS TRASTORNOS ENCEFALITICOS ESPECIFICADOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G950",
    "nombre_dx": "G950-SIRINGOMIELIA Y SIRINGOBULBIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G951",
    "nombre_dx": "G951-MIELOPATIAS VASCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "G952",
    "nombre_dx": "G952-COMPRESION MEDULAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G958",
    "nombre_dx": "G958-OTRAS ENFERMEDADES ESPECIFICADAS DE LA MEDULA ESPINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "G959",
    "nombre_dx": "G959-ENFERMEDADDE LA MEDULA ESPINAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "G960",
    "nombre_dx": "G960-PERDIDA DE LIQUIDO CEFALORRAQUIDEO",
    "sexo": "A"
  },
  {
    "cod_dx": "G961",
    "nombre_dx": "G961-TRASTORNOS DE LA MENINGES, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G968",
    "nombre_dx": "G968-OTROS TRASTORNOS ESPECIFICADOSDEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G969",
    "nombre_dx": "G969-TRASTORNO DEL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "G970",
    "nombre_dx": "G970-PERDIDA DE LIQUIDO CEFALORRAQUIDEO POR PUNCION ESPINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "G971",
    "nombre_dx": "G971-OTRA REACCION A LA PUNCION ESPINAL Y LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "G972",
    "nombre_dx": "G972-HIPOTENSION INTRACRANEAL POSTERIOR A ANASTOMOSIS VENTRICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "G978",
    "nombre_dx": "G978-OTROS TRASTORNOS DEL SISTEMA NERVIOSO CONSECUTIVOS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G979",
    "nombre_dx": "G979-TRASTORNOS NO ESPECIFICADOS DEL SISTEMA NERVIOSO, CONSECUTIVOS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "G98X",
    "nombre_dx": "G98X-OTROS TRASTORNOS DEL SISTEMA NERVIOSO, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "G990",
    "nombre_dx": "G990-NEUROPATIA AUTONOMICA EN ENFERNEDADES METABOLICAS Y ENDOCRINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "G991",
    "nombre_dx": "G991-OTROS TRASTORNOS DEL SISTEMA NERVIOSO AUTONOMO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G992",
    "nombre_dx": "G992-MIELOPATIA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "G998",
    "nombre_dx": "G998-OTROS TRASTORNOS ESPECIFICADOS DEL SISTEMA NERVIOSO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H000",
    "nombre_dx": "H000-ORZUELO Y OTRAS INFLAMACIONES PROFUNDAS DEL PARPADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H001",
    "nombre_dx": "H001-CALACIO [CHALAZION] ",
    "sexo": "A"
  },
  {
    "cod_dx": "H010",
    "nombre_dx": "H010-BLEFARITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H011",
    "nombre_dx": "H011-DERMATOSIS NOINFECCIOSA DEL PARPADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H018",
    "nombre_dx": "H018-OTRAS INFLAMACIONES ESPECIFICADAS DEL PARPADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H019",
    "nombre_dx": "H019-INFLAMACION DEL PARPADO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H020",
    "nombre_dx": "H020-ENTROPION Y TRIQUIASIS PALPEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H021",
    "nombre_dx": "H021-ECTROPION DEL PARPADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H022",
    "nombre_dx": "H022-LAGOFTALMOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H023",
    "nombre_dx": "H023-BLEFAROCALASIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H024",
    "nombre_dx": "H024-BLEFAROPTOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H025",
    "nombre_dx": "H025-OTROS TRASTORNOS FUNCIONALES DEL PARPADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H026",
    "nombre_dx": "H026-XANTELASMA DEL PARPADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H027",
    "nombre_dx": "H027-OTROS TRASTORNOS DEGENERATIVOS DEL PARPADO Y DEL AREA PERIOCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H028",
    "nombre_dx": "H028-OTROS TRASTORNOS ESPECIFICADOS DEL PARPADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H029",
    "nombre_dx": "H029-TRASTORNOS DEL PARPADO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H030",
    "nombre_dx": "H030-INFECCION E INFESTACION PARASITARIAS DEL PARPADO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H031",
    "nombre_dx": "H031-COMPROMISO DEL PARPADO EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H038",
    "nombre_dx": "H038-COMPROMISO DEL PARPADO EN ENFERMEDADESCLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H040",
    "nombre_dx": "H040-DACRIOADENITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H041",
    "nombre_dx": "H041-OTROS TRASTORNOS DE LA GLANDULA LAGRIMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H042",
    "nombre_dx": "H042-EPIFORA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H043",
    "nombre_dx": "H043-INFLAMACION AGUDA Y LA NO ESPECIFICADA DE LAS VIAS LAGRIMALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H044",
    "nombre_dx": "H044-INFLAMACION CRONICA DE LAS VIAS LAGRIMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H045",
    "nombre_dx": "H045-ESTENOSIS E INSUFICIENCIA DE LAS VIAS LAGRIMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H046",
    "nombre_dx": "H046-OTROS CAMBIOS DE LAS VIAS LAGRIMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H048",
    "nombre_dx": "H048-OTROS TRASTORNOS ESPECIFICADOS DEL APARATO LAGRIMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H049",
    "nombre_dx": "H049-TRASTORNO DEL APARATO LAGRIMAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H050",
    "nombre_dx": "H050-INFLAMACION AGUDA DE LA ORBITA",
    "sexo": "A"
  },
  {
    "cod_dx": "H051",
    "nombre_dx": "H051-TRASTORNOS INFLAMATORIOS CRONICOS DE LA ORBITA",
    "sexo": "A"
  },
  {
    "cod_dx": "H052",
    "nombre_dx": "H052-AFECCIONES EXOFTALMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H053",
    "nombre_dx": "H053-DEFORMIDAD DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H054",
    "nombre_dx": "H054-ENOFTALMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H055",
    "nombre_dx": "H055-RETENCION DE CUERPO EXTRAÑO (ANTIGUO), CONSECUTIVA A HERIDA PENETRANTE DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H058",
    "nombre_dx": "H058-OTROS TRASTORNOS DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H059",
    "nombre_dx": "H059-TRASTORNO DE LA ORBITA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H060",
    "nombre_dx": "H060-TRASTORNOS DEL APARATO LAGRIMAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H061",
    "nombre_dx": "H061-INFECCION O INFESTACION PARASITARIA DE LA ORBITA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H062",
    "nombre_dx": "H062-EXOFTALMIA HIPERTIROIDEA (E05.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "H063",
    "nombre_dx": "H063-OTROS TRASTORNOS DE LA ORBITA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H100",
    "nombre_dx": "H100-CONJUNTIVITIS MUCOPURULENTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H101",
    "nombre_dx": "H101-CONJUNTIVITIS ATOPICA AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H102",
    "nombre_dx": "H102-OTRAS CONJUNTIVITIS AGUDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H103",
    "nombre_dx": "H103-CONJUNTIVITIS AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H104",
    "nombre_dx": "H104-CONJUNTIVITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H105",
    "nombre_dx": "H105-BLEFAROCONJUNTIVITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H108",
    "nombre_dx": "H108-OTRAS CONJUNTIVITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H109",
    "nombre_dx": "H109-CONJUNTIVITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H110",
    "nombre_dx": "H110-PTERIGION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H111",
    "nombre_dx": "H111-DEGENERACIONES Y DEPOSITOS CONJUNTIVALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H112",
    "nombre_dx": "H112-CICATRICES CONJUNTIVALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H113",
    "nombre_dx": "H113-HEMORRAGIA CONJUNTIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H114",
    "nombre_dx": "H114-OTROS TRASTORNOS VASCULARES Y QUISTES CONJUNTIVALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H118",
    "nombre_dx": "H118-OTROS TRASTORNOS ESPECIFICADOS DE LA CONJUNTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H119",
    "nombre_dx": "H119-TRASTORNO DE LA CONJUNTIVA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H130",
    "nombre_dx": "H130-INFECCION FILARICA DE LA CONJUNTIVA (B74.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "H131",
    "nombre_dx": "H131-CONJUNTIVITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H132",
    "nombre_dx": "H132-CONJUNTIVITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H133",
    "nombre_dx": "H133-PENFIGOIDE OCULAR (L12.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "H138",
    "nombre_dx": "H138-OTROS TRASTORNOS DE LA CONJUNTIVA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H150",
    "nombre_dx": "H150-ESCLERITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H151",
    "nombre_dx": "H151-EPISCLERITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H158",
    "nombre_dx": "H158-OTROS TRASTORNOS DE LA ESCLEROTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "H159",
    "nombre_dx": "H159-TRASTORNOS DE LA ESCLEROTICA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H160",
    "nombre_dx": "H160-ULCERA DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H161",
    "nombre_dx": "H161-OTRAS QUERATITIS SUPERFICIALES SIN CUNJUNTIVITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H162",
    "nombre_dx": "H162-QUERATOCONJUNTIVITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H163",
    "nombre_dx": "H163-QUERATITIS INTERSTICIAL Y PROFUNDA",
    "sexo": "A"
  },
  {
    "cod_dx": "H164",
    "nombre_dx": "H164-NEOVASCULARIZACION DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H168",
    "nombre_dx": "H168-OTRAS QUERATITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H169",
    "nombre_dx": "H169-QUERATITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H170",
    "nombre_dx": "H170-LEUCOMA ADHERENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H171",
    "nombre_dx": "H171-OTRAS OPACIDADES CENTRALES DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H178",
    "nombre_dx": "H178-OTRAS OPACIDADES O CICATRICESDE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H179",
    "nombre_dx": "H179-CICATRIZ U OPACIDAD DE LA CORNEA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H180",
    "nombre_dx": "H180-PIGMENTACIONES Y DEPOSITOS EN LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H181",
    "nombre_dx": "H181-QUERATOPATIA VESICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H182",
    "nombre_dx": "H182-OTROS EDEMAS DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H183",
    "nombre_dx": "H183-CAMBIOS EN LAS MEMBRANAS DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H184",
    "nombre_dx": "H184-DEGENERACION DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H185",
    "nombre_dx": "H185-DISTROFIA HEREDITARIA DE LA CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "H186",
    "nombre_dx": "H186-QUERATOCONO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H187",
    "nombre_dx": "H187-OTRAS DEFORMIDADES DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H188",
    "nombre_dx": "H188-OTROS TRASTORNOS ESPECIFICADOS DE LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H189",
    "nombre_dx": "H189-TRASTORNO DE LA CORNEA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H190",
    "nombre_dx": "H190-ESCLERITIS Y EPISCLERITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H191",
    "nombre_dx": "H191-QUERATITIS Y QUERATOCONJUNTIVITIS POR HERPES SIMPLE (B00.5+)",
    "sexo": "A"
  },
  {
    "cod_dx": "H192",
    "nombre_dx": "H192-QUERATITIS Y QUERATOCONJUNTIVITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS, CLASIFICADAS EN OTRA P",
    "sexo": "A"
  },
  {
    "cod_dx": "H193",
    "nombre_dx": "H193-QUERATITIS Y QUERATOCONJUNTIVITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H198",
    "nombre_dx": "H198-OTROS TRASTORNOS DE LA ESCLEROTICA Y DE LA CORNEA EN ENFERMEDADESCLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H200",
    "nombre_dx": "H200-IRIDOCICLITIS AGUDA Y SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "H201",
    "nombre_dx": "H201-IRIDOCICLITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H202",
    "nombre_dx": "H202-IRIDOCICLITIS INDUCIDA POR TRASTORNO DEL CRISTALINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H208",
    "nombre_dx": "H208-OTRAS IRIDOCICLITIS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H209",
    "nombre_dx": "H209-IRIDOCICLITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H210",
    "nombre_dx": "H210-HIFEMA",
    "sexo": "A"
  },
  {
    "cod_dx": "H211",
    "nombre_dx": "H211-OTROS TRASTORNOS VASCULARES DEL IRIS Y DEL CUERPO CILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H212",
    "nombre_dx": "H212-DEGENERACION DEL IRIS Y DEL CUERPO CILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H213",
    "nombre_dx": "H213-QUISTE DEL IRIS, DEL CUERPO CILIAR Y DE LA CAMARA ANTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "H214",
    "nombre_dx": "H214-MEMBRANAS PUPILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H215",
    "nombre_dx": "H215-OTRAS ADHERENCIAS Y DESGARROS DEL IRIS Y DEL CUERPO CILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H218",
    "nombre_dx": "H218-OTROS TRASTORNOS ESPECIFICADOS DEL IRIS Y DEL CUERPO CILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H219",
    "nombre_dx": "H219-DEL IRIS Y DEL CUERPO CILIAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H220",
    "nombre_dx": "H220-IRIDOCICLITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H221",
    "nombre_dx": "H221-IRIDOCICLITIS EN OTRAS ENFERMEDADESCLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H228",
    "nombre_dx": "H228-OTROS TRASTORNOS DEL IRIS Y DEL CUERPO CILIAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H250",
    "nombre_dx": "H250-CATARATA SENIL INCIPIENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H251",
    "nombre_dx": "H251-CATARATA SENIL NUCLEAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H252",
    "nombre_dx": "H252-CATARATA SENIL, TIPO MORGAGNIAN ",
    "sexo": "A"
  },
  {
    "cod_dx": "H258",
    "nombre_dx": "H258-OTRAS CATARATAS SENILES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H259",
    "nombre_dx": "H259-CATARATA SENIL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H260",
    "nombre_dx": "H260-CATARATA INFANTIL, JUVENIL Y PRESENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H261",
    "nombre_dx": "H261-CATARATA TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H262",
    "nombre_dx": "H262-CATARATA COMPLICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H263",
    "nombre_dx": "H263-CATARATA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H264",
    "nombre_dx": "H264-CATARATA RESIDUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H268",
    "nombre_dx": "H268-OTRAS FORMAS ESPECIFICADAS DE CATARATA",
    "sexo": "A"
  },
  {
    "cod_dx": "H269",
    "nombre_dx": "H269-CATARATA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H270",
    "nombre_dx": "H270-AFAQUIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H271",
    "nombre_dx": "H271-LUXACION DEL CRISTALINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H278",
    "nombre_dx": "H278-OTROS TRASTORNOS ESPECIFICADOS DEL CRISTALINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H279",
    "nombre_dx": "H279-TRASTORNODEL CRISTALINO, NOESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H280",
    "nombre_dx": "H280-CATARATA DIABETICA (E10-E14+ CON CUARTO CARACTER COMUN .3)",
    "sexo": "A"
  },
  {
    "cod_dx": "H281",
    "nombre_dx": "H281-CATARATA EN OTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H282",
    "nombre_dx": "H282-CATARATA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H288",
    "nombre_dx": "H288-OTROS TRASTORNOS DEL CRISTALINO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H300",
    "nombre_dx": "H300-CORIORRETINITIS FOCAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H301",
    "nombre_dx": "H301-CORIORRETINITIS DISEMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H302",
    "nombre_dx": "H302-CICLITIS POSTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "H308",
    "nombre_dx": "H308-OTRAS CORIORRETINITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H309",
    "nombre_dx": "H309-CORIORRETINITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H310",
    "nombre_dx": "H310-CICATRICES CORIORRETINIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H311",
    "nombre_dx": "H311-DESGENERACION COROIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "H312",
    "nombre_dx": "H312-DISTROFIA COROIDEA HEREDITARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H313",
    "nombre_dx": "H313-HEMORRAGIA Y RUPTURA DE LA COROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H314",
    "nombre_dx": "H314-DESPRENDIMIENTO DE LA COROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "H318",
    "nombre_dx": "H318-OTROS TRASTORNOS ESPECIFICADOS DE LA COROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H319",
    "nombre_dx": "H319-TRASTORNO DE LA COROIDES, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H320",
    "nombre_dx": "H320-INFLAMACION CORIORRETINIANA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H328",
    "nombre_dx": "H328-OTROS TRASTORNOS CORIORRETINIANOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H330",
    "nombre_dx": "H330-DESPRENDIMIENTO DE LA RETINA CON RUPTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "H331",
    "nombre_dx": "H331-RETINOSQUISIS Y QUISTES DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "H332",
    "nombre_dx": "H332-DESPRENDIMIENTO SEROSO DE LA RETINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H333",
    "nombre_dx": "H333-DESGARRO DE LA RETINA SIN DESPRENDIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H334",
    "nombre_dx": "H334-DESPRENDIMIENTO DE LA RETINA POR TRACCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H335",
    "nombre_dx": "H335-OTROS DESPRENDIMIENTO DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "H340",
    "nombre_dx": "H340-OCLUSION ARTERIAL TRANSITORIA DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "H341",
    "nombre_dx": "H341-OCLUSION DE LA ARTERIA CENTRAL DE LA RETINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H342",
    "nombre_dx": "H342-OTRAS FORMAS DE OCLUSION DE LA ARTERIA DE LA RETINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H348",
    "nombre_dx": "H348-OTRAS OCLUSIONES VASCULARES RETINIANAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H349",
    "nombre_dx": "H349-OCLUSION VASCULAR RETINIANA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "H350",
    "nombre_dx": "H350-RETINOPATIAS DEL FONDO Y CAMBIOS VASCULARES RETINIANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "H351",
    "nombre_dx": "H351-RETINOPATIA DE LA PREMATURIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "H352",
    "nombre_dx": "H352-OTRAS RETINOPATIAS PROLIFERATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H353",
    "nombre_dx": "H353-DEGENERACION DE LA MACULA Y DEL POLO POSTERIOR DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "H354",
    "nombre_dx": "H354-DEGENERACION PERIFERICA DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "H355",
    "nombre_dx": "H355-DISTROFIA HEREDITARIA DE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "H356",
    "nombre_dx": "H356-HEMORRAGIA RETINIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "H357",
    "nombre_dx": "H357-SEPARACION DE LAS CASPAS DE LA RETINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H358",
    "nombre_dx": "H358-OTROS TRASTORNOS ESPECIFICADOS DE LA RETINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H359",
    "nombre_dx": "H359-TRASTORNO DE LA RETINA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H360",
    "nombre_dx": "H360-RETINOPATIA DIABETICA (E10-E14+ CON CUARTO CARACTER COMUN .3) ",
    "sexo": "A"
  },
  {
    "cod_dx": "H368",
    "nombre_dx": "H368-OTROS TRASTORNOS DE LA RETINA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H400",
    "nombre_dx": "H400-SOSPECHA DE GLAUCOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "H401",
    "nombre_dx": "H401-GLAUCOMA PRIMARIO DE ANGULO ABIERTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H402",
    "nombre_dx": "H402-GLAUCOMA PRIMARIO DE ANGULO CERRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H403",
    "nombre_dx": "H403-GLAUCOMA SECUNDARIO A TRAUMATISMO OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H404",
    "nombre_dx": "H404-GLAUCOMA SECUNDARIO A INFLAMACIONOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H405",
    "nombre_dx": "H405-GLAUCOMA SECUNDARIO A OTROS TRASTORNOS DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "H406",
    "nombre_dx": "H406-GLAUCOMA SECUNDARIO A DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H408",
    "nombre_dx": "H408-OTROS GLAUCOMAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H409",
    "nombre_dx": "H409-GLAUCOMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H420",
    "nombre_dx": "H420-GLAUCOMA EN ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS, CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H428",
    "nombre_dx": "H428-GLAUCOMA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H430",
    "nombre_dx": "H430-PROLAPSO DEL VITREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H431",
    "nombre_dx": "H431-HEMORRAGIA DEL VITREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H432",
    "nombre_dx": "H432-DEPOSITOS CRISTALINOS EN EL CUERPO VITREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H433",
    "nombre_dx": "H433-OTRAS OPACIDADES VITREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H438",
    "nombre_dx": "H438-OTROS TRASTORNOS DEL CUERPO VITREO",
    "sexo": "A"
  },
  {
    "cod_dx": "H439",
    "nombre_dx": "H439-TRASTORNOS DEL CUERPO VITREO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H440",
    "nombre_dx": "H440-ENDOFTALMITIS PURULENTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H441",
    "nombre_dx": "H441-OTRAS ENDOFTALMITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H442",
    "nombre_dx": "H442-MIOPIA DEGENERATIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H443",
    "nombre_dx": "H443-OTROS TRASTORNOS DEGENERATIVOS DEL GLOBO OCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H444",
    "nombre_dx": "H444-HIPOTONIA OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H445",
    "nombre_dx": "H445-AFECCIONES DEGENERATIVAS DEL GLOBO OCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H446",
    "nombre_dx": "H446-RETENCION INTRAOCULAR DE CUERPO EXTRAÑO MAGNETICO (ANTIGUO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "H447",
    "nombre_dx": "H447-RETENCION INTRAOCULAR DE CUERPO EXTRAÑO NO MAGNETICO (ANTIGUO)",
    "sexo": "A"
  },
  {
    "cod_dx": "H448",
    "nombre_dx": "H448-OTROS TRASTORNOS DEL GLOBO OCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H449",
    "nombre_dx": "H449-TRASTORNO DEL GLOBO OCULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H450",
    "nombre_dx": "H450-HEMORRAGIA DEL VITREO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H451",
    "nombre_dx": "H451-ENDOFTALMITIS EN ENFERNEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H458",
    "nombre_dx": "H458-OTROS TRASTORNOS DEL CUERPO VITREO Y DEL GLOBO OCULAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H46X",
    "nombre_dx": "H46X-NEURITIS OPTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H470",
    "nombre_dx": "H470-TRASTORNOS DEL NERVIOOPTICO, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H471",
    "nombre_dx": "H471-PAPILEDEMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H472",
    "nombre_dx": "H472-ATROFIA OPTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "H473",
    "nombre_dx": "H473-OTROS TRASTORNOS DEL DISCO OPTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H474",
    "nombre_dx": "H474-TRASTORNOS DEL QUIASMA OPTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H475",
    "nombre_dx": "H475-TRASTORNOS DE OTRAS VIAS OPTICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H476",
    "nombre_dx": "H476-TRASTORNOS DE LA CORTEZA VISUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H477",
    "nombre_dx": "H477-TRASTORNOS DE LAS VIAS OPTICAS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H480",
    "nombre_dx": "H480-ATROFIA OPTICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H481",
    "nombre_dx": "H481-NEURITIS RETROBULBAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H488",
    "nombre_dx": "H488-OTROS TRASTORNOS DEL NERVIO OPTICO Y DE LAS VIAS OPTICAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H490",
    "nombre_dx": "H490-PARALISIS DEL NERVIO MOTOR OCULAR COMUN [III PAR] ",
    "sexo": "A"
  },
  {
    "cod_dx": "H491",
    "nombre_dx": "H491-PARALISIS DEL NERVIO PATETICO [IV PAR]",
    "sexo": "A"
  },
  {
    "cod_dx": "H492",
    "nombre_dx": "H492-PARALISIS DEL NERVIO MOTOR OCULAR EXTERNO[VI PAR] ",
    "sexo": "A"
  },
  {
    "cod_dx": "H493",
    "nombre_dx": "H493-OFTALMOPLEJIA TOTAL (EXTERNA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "H494",
    "nombre_dx": "H494-OFTALMOPLEJIAEXTERNA PROGRESIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H498",
    "nombre_dx": "H498-OTROS ESTRABISMOS PARALITICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H499",
    "nombre_dx": "H499-ESTRABISMO PARALITICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H500",
    "nombre_dx": "H500-ESTRABISMO CONCOMITANTE CONVERGENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H501",
    "nombre_dx": "H501-ESTRABISMO CONCOMITANTE DIVERGENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H502",
    "nombre_dx": "H502-ESTRABISMO VERTICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H503",
    "nombre_dx": "H503-HETEROTROPIA INTERMITENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H504",
    "nombre_dx": "H504-OTRAS HETEROTROPIAS O LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H505",
    "nombre_dx": "H505-HETEROFORIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H506",
    "nombre_dx": "H506-ESTRABISMO MECANICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H508",
    "nombre_dx": "H508-OTROS ESTRABISMOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H509",
    "nombre_dx": "H509-ESTRABISMO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H510",
    "nombre_dx": "H510-PARALISIS DE LA CONJUGACION DE LA MIRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H511",
    "nombre_dx": "H511-EXCESO E INSUFICIENCIA DE LA CONVERGENCIA OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H512",
    "nombre_dx": "H512-OFTALMOPLEJIA INTERNUCLEAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H518",
    "nombre_dx": "H518-OTROS TRASTORNOS ESPECIFICADOS DE LOS MOVIMIENTOS BINOCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H519",
    "nombre_dx": "H519-TRASTORNOS DEL MOVIMIENTO BINOCULAR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H520",
    "nombre_dx": "H520-HIPERMETROPIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H521",
    "nombre_dx": "H521-MIOPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H522",
    "nombre_dx": "H522-ASTIGMATISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "H523",
    "nombre_dx": "H523-ANISOMETROPIA Y ANISEICONIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H524",
    "nombre_dx": "H524-PRESBICIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H525",
    "nombre_dx": "H525-TRASTORNOS DE LA ACOMODACION",
    "sexo": "A"
  },
  {
    "cod_dx": "H526",
    "nombre_dx": "H526-OTROS TRASTORNOS DE LA REFRACCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H527",
    "nombre_dx": "H527-TRASTORNO DE LA REFRACCION, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H530",
    "nombre_dx": "H530-AMBLIOPIA EX ANOPSIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H531",
    "nombre_dx": "H531-ALTERACIONES VISUALES SUBJETIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H532",
    "nombre_dx": "H532-DIPLOPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H533",
    "nombre_dx": "H533-OTROS TRASTORNOS DE LA VISION BINOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H534",
    "nombre_dx": "H534-DEFECTOS DEL CAMPO VISUAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H535",
    "nombre_dx": "H535-DEFICIENCIAS DE LA VISION CROMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H536",
    "nombre_dx": "H536-CEGUERA NOCTURNA",
    "sexo": "A"
  },
  {
    "cod_dx": "H538",
    "nombre_dx": "H538-OTRAS ALTERACIONES VISUALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H539",
    "nombre_dx": "H539-ALTERACION VISUAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H540",
    "nombre_dx": "H540-Ceguera binocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H541",
    "nombre_dx": "H541-Deficiencia visual severa, binocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H542",
    "nombre_dx": "H542-Deficiencia visual moderada, binocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H543",
    "nombre_dx": "H543-Deficiencia visual leve o ausente, binocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H544",
    "nombre_dx": "H544-Ceguera monocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H545",
    "nombre_dx": "H545-Deficiencia visual severa, monocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H546",
    "nombre_dx": "H546-Deficiencia visual moderada, monocular",
    "sexo": "A"
  },
  {
    "cod_dx": "H549",
    "nombre_dx": "H549-Deficiencia visual no especificada (binocular)",
    "sexo": "A"
  },
  {
    "cod_dx": "H54X",
    "nombre_dx": "H54X-Ceguera y deficiencia visual (binicular o monocular) (antes CEGUERA Y DISMINUCION DE LA AGUDEZA VISUAL)",
    "sexo": "A"
  },
  {
    "cod_dx": "H55X",
    "nombre_dx": "H55X-NISTAGMO Y OTROS MOVIMIENTOS OCULARES IRREGULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "H570",
    "nombre_dx": "H570-ANOMALIAS DE LA FUNCION PUPILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H571",
    "nombre_dx": "H571-DOLOR OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "H578",
    "nombre_dx": "H578-OTROS TRASTORNOS ESPECIFICADOS DEL OJO Y SUS ANEXOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H579",
    "nombre_dx": "H579-TRASTORNO DEL OJO Y SUS ANEXOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H580",
    "nombre_dx": "H580-ANOMALIAS DE LA FUNCION PUPILAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H581",
    "nombre_dx": "H581-ALTERACIONES DE LA VISION EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H588",
    "nombre_dx": "H588-OTROS TRASTORNOS ESPECIFICADOS DEL OJO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H590",
    "nombre_dx": "H590-SINDROME VITREO CONSECUTIVO A CIRUGIA DE CATARATA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H598",
    "nombre_dx": "H598-OTROS TRASTORNOS DEL OJO Y SUS ANEXOS, CONSECUTIVOS A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "H599",
    "nombre_dx": "H599-TRASTORNO NO ESPECIFICADO DEL OJO Y SUS ANEXOS, CONSECUTIVO A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "H600",
    "nombre_dx": "H600-ABSCESO DEL OIDO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "H601",
    "nombre_dx": "H601-CELULITIS DEL OIDO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "H602",
    "nombre_dx": "H602-OTITIS EXTERNA MALIGNA",
    "sexo": "A"
  },
  {
    "cod_dx": "H603",
    "nombre_dx": "H603-OTRAS OTITIS EXTERNAS INFECCIOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H604",
    "nombre_dx": "H604-COLESTEATOMA DEL OIDO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H605",
    "nombre_dx": "H605-OTITIS EXTERNA AGUDA, NO INFECCIOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H608",
    "nombre_dx": "H608-OTRAS OTITIS EXTERNAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H609",
    "nombre_dx": "H609-OTITIS EXTERNA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H610",
    "nombre_dx": "H610-PERICONDRITIS DEL OIDO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "H611",
    "nombre_dx": "H611-AFECCIONES NO INFECCIOSAS DEL PABELLON AUDITIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H612",
    "nombre_dx": "H612-CERUMEN IMPACTADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H613",
    "nombre_dx": "H613-ESTENOSIS ADQUIRIDA DEL CONDUCTO AUDITIVO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H618",
    "nombre_dx": "H618-OTROS TRASTORNOS ESPECIFICADOS DEL OIDO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H619",
    "nombre_dx": "H619-TRASTORNO DEL OIDO EXTERNO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H620",
    "nombre_dx": "H620-OTITIS EXTERNA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H621",
    "nombre_dx": "H621-OTITIS EXTERNA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H622",
    "nombre_dx": "H622-OTITIS EXTERNA EN MICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H623",
    "nombre_dx": "H623-OTITIS EXTERNA EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PATE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H624",
    "nombre_dx": "H624-OTITIS EXTERNA EN OTRAS ENFERMEDADESCLASIFICADAS EN OTRA PATE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H628",
    "nombre_dx": "H628-OTROS TRASTORNOS DEL OIDO EXTERNO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H650",
    "nombre_dx": "H650-OTITIS MEDIA AGUDA SEROSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H651",
    "nombre_dx": "H651-OTRA OTITIS MEDIA AGUDA, NO SUPURATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "H652",
    "nombre_dx": "H652-OTITIS MEDIA CRONICA SEROSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H653",
    "nombre_dx": "H653-OTITIS MEDIA CRONICA MUCOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "H654",
    "nombre_dx": "H654-OTRAS OTITIS MEDIAS CRONICAS NO SUPURATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H659",
    "nombre_dx": "H659-OTITISMEDIA NO SUPURATIVA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "H660",
    "nombre_dx": "H660-OTITIS MEDIA SUPURATIVA AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H661",
    "nombre_dx": "H661-OTITIS MEDIA TUBOTIMPANICA SUPURATIVA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H662",
    "nombre_dx": "H662-OTITIS MEDIA SUPURATIVA CRONICA ATICOANTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H663",
    "nombre_dx": "H663-OTRAS OTITIS MEDIAS CRONICAS SUPURATIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "H664",
    "nombre_dx": "H664-OTITIS MEDIA SUPURATIVA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "H669",
    "nombre_dx": "H669-OTITIS MEDIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H670",
    "nombre_dx": "H670-OTITIS MEDIA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H671",
    "nombre_dx": "H671-OTITIS MEDIA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H678",
    "nombre_dx": "H678-OTITIS MEDIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H680",
    "nombre_dx": "H680-SALPINGITIS EUSTAQUIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H681",
    "nombre_dx": "H681-OBSTRUCCION DE LA TROMPA DE EUSTAQUIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H690",
    "nombre_dx": "H690-DISTENSION DE LA TROMPA DE EUSTAQUIO",
    "sexo": "A"
  },
  {
    "cod_dx": "H698",
    "nombre_dx": "H698-OTROS TRASTORNOS ESPECIFICADOS DE LA TROMPA DE EUSTAQUIO",
    "sexo": "A"
  },
  {
    "cod_dx": "H699",
    "nombre_dx": "H699-TRASTORNO DE LA TROMPA DE EUSTAQUIO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H700",
    "nombre_dx": "H700-MASTOIDITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H701",
    "nombre_dx": "H701-MASTOIDITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H702",
    "nombre_dx": "H702-PETROSITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H708",
    "nombre_dx": "H708-OTRAS MASTOIDITIS Y AFECCIONES RELACIONADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H709",
    "nombre_dx": "H709-MASTOIDITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H71X",
    "nombre_dx": "H71X-COLESTEATOMA DEL OIDO MEDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H720",
    "nombre_dx": "H720-PERFORACION CENTRAL DE LA MEMBRANA TIMPANICA",
    "sexo": "A"
  },
  {
    "cod_dx": "H721",
    "nombre_dx": "H721-PERFORACION ATICA DE LA MEMBRANA TIMPANICA",
    "sexo": "A"
  },
  {
    "cod_dx": "H722",
    "nombre_dx": "H722-OTRAS PERFORACIONES MARGINALES DE LA MEMBRANA TIMPANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H728",
    "nombre_dx": "H728-OTRAS PERFORACIONESDE LA MEMBRANA TIMPANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H729",
    "nombre_dx": "H729-PERFORACION DE LA MEMBRANA TIMPANICA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H730",
    "nombre_dx": "H730-MIRINGITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "H731",
    "nombre_dx": "H731-MIRINGITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "H738",
    "nombre_dx": "H738-OTROS TRASTORNOS ESPECIFICADOS DE LA MEMBRANA TIMPANICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H739",
    "nombre_dx": "H739-TRASTORNO DE LA MEMBRANA TIMPANICA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H740",
    "nombre_dx": "H740-TIMPANOSCLEROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H741",
    "nombre_dx": "H741-ENFERMEDAD ADHESIVA DEL OIDO MEDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "H742",
    "nombre_dx": "H742-DISCONTINUIDAD Y DISLOCACION DE LOS HUESECILLOS DEL OIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "H743",
    "nombre_dx": "H743-OTRAS ANORMALIDADES ADQUIRIDAS DE LOS HUESECILLOS DEL OIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "H744",
    "nombre_dx": "H744-POLIPO DEL OIDO MEDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H748",
    "nombre_dx": "H748-OTROS TRASTORNOS ESPECIFICADOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "H749",
    "nombre_dx": "H749-TRASTORNO DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "H750",
    "nombre_dx": "H750-MASTOIDITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H758",
    "nombre_dx": "H758-OTROS TRASTORNOS ESPECIFICADOS DEL OIDO MEDIO Y DE LA APOFISIS MASTOIDES EN ENFERMEDADES CLASIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H800",
    "nombre_dx": "H800-OTOSCLEROSIS QUE AFECTA LA VENTANA OVAL, NO OBLITERANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H801",
    "nombre_dx": "H801-OTOSCLEROSIS QUE AFECTA LA VENTANA OVAL, OBLITERANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H802",
    "nombre_dx": "H802-OSTOSCLEROSIS COCLEAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H808",
    "nombre_dx": "H808-OTRAS OTOSCLEROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H809",
    "nombre_dx": "H809-OTOSCLEROSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H810",
    "nombre_dx": "H810-ENFERMEDAD DE MENIERE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H811",
    "nombre_dx": "H811-VERTIGO PAROXISTICO BENIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H812",
    "nombre_dx": "H812-NEURONITIS VESTIBULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H813",
    "nombre_dx": "H813-OTROS VERTIGOS PERIFERICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "H814",
    "nombre_dx": "H814-VERTIGO DE ORIGEN CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H818",
    "nombre_dx": "H818-OTROS TRASTORNOS DE LA FUNCION VESTIBULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "H819",
    "nombre_dx": "H819-TRASTORNO DE LA FUNCION VESTIBULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H82X",
    "nombre_dx": "H82X-SINDROMES VERTIGINOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H830",
    "nombre_dx": "H830-LABERINTITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "H831",
    "nombre_dx": "H831-FISTULA DEL LABERINTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H832",
    "nombre_dx": "H832-DISFUNCION DEL LABERINTO",
    "sexo": "A"
  },
  {
    "cod_dx": "H833",
    "nombre_dx": "H833-EFECTOS DEL RUIDO SOBRE EL OIDO INTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H838",
    "nombre_dx": "H838-OTROS TRASTORNOS ESPECIFICADOS DEL OIDO INTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H839",
    "nombre_dx": "H839-TRASTORNO DEL OIDO INTERNO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H900",
    "nombre_dx": "H900-HIPOACUSIA CONDUCTIVA BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H901",
    "nombre_dx": "H901-HIPOACUSIA CONDUCTIVA, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H902",
    "nombre_dx": "H902-HIPOACUSIACONDUCTIVA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H903",
    "nombre_dx": "H903-HIPOACUSIANEUROSENSORIAL, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "H904",
    "nombre_dx": "H904-HIPOACUSIA NEUROSENSORIAL, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H905",
    "nombre_dx": "H905-HIPOACUSIANEUROSENSORIAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "H906",
    "nombre_dx": "H906-HIPOACUSIAMIXTA CONDUCTIVA Y NEUROSENSORIAL, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H907",
    "nombre_dx": "H907-HIPOACUSIAMIXTA CONDUCTIVA Y NEUROSENSORIAL, UNILATERAL CON AUDICION IRRESTRICTA CONTRALATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "H908",
    "nombre_dx": "H908-HIPOACUSIAMIXTA CONDUCTIVA Y NEUROSENSORIAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "H910",
    "nombre_dx": "H910-HIPOACUSIAOTOTOXICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H911",
    "nombre_dx": "H911-PRESBIACUSIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H912",
    "nombre_dx": "H912-HIPOACUSIASUBIDA IDIOPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H913",
    "nombre_dx": "H913-SORDOMUDEZ, NOCLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "H918",
    "nombre_dx": "H918-OTRAS HIPOACUSIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H919",
    "nombre_dx": "H919-HIPOACUSIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H920",
    "nombre_dx": "H920-OTALGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H921",
    "nombre_dx": "H921-OTORREA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H922",
    "nombre_dx": "H922-OTORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H930",
    "nombre_dx": "H930-TRASTORNOS DEGENERATIVOS Y VASCULARES DEL OIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "H931",
    "nombre_dx": "H931-TINNITUS",
    "sexo": "A"
  },
  {
    "cod_dx": "H932",
    "nombre_dx": "H932-OTRAS PERCEPCIONES AUDITIVAS ANORMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "H933",
    "nombre_dx": "H933-TRASTORNOS DEL NERVIO AUDITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "H938",
    "nombre_dx": "H938-OTROS TRASTORNOS ESPECIFICADOS DEL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H939",
    "nombre_dx": "H939-TRASTORNO DEL OIDO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "H940",
    "nombre_dx": "H940-NEURITIS DEL NERVIO AUDITIVO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H948",
    "nombre_dx": "H948-OTROS TRASTORNOS DEL OIDO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "H950",
    "nombre_dx": "H950-COLESTEATOMA RECURRENTE DE LA CAVIDAD RESULTANTE DE LA MASTOIDECTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "H951",
    "nombre_dx": "H951-OTROS TRASTORNOS POSTERIORES A LA MASTOIDECTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "H958",
    "nombre_dx": "H958-OTROS TRASTORNOS DEL OIDO Y DE LA APOFISIS MASTOIDES, CONSECUTIVOS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "H959",
    "nombre_dx": "H959-TRASTORNOS NO ESPECIFICADOS DEL OIDO Y DE LA APOFISIS MASTOIDES, CONSECUTIVOS A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "I00X",
    "nombre_dx": "I00X-FIEBRE REUMATICA SIN MENCION DE COMPLICACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I010",
    "nombre_dx": "I010-PERICARDITIS REUMATICA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I011",
    "nombre_dx": "I011-ENDOCARDITIS REUMATICA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I012",
    "nombre_dx": "I012-MIOCARDITIS REUMATICA AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I018",
    "nombre_dx": "I018-OTRAS ENFERMEDADES REUMATICAS AGUDAS DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "I019",
    "nombre_dx": "I019-ENFERMEDAD REUMATICA AGUDA DEL CORAZON, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I020",
    "nombre_dx": "I020-COREA REUMATICA CON COMPLICACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I029",
    "nombre_dx": "I029-COREA REUMATICA SIN MENCION DE COMPLICACION CARDIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "I050",
    "nombre_dx": "I050-ESTENOSIS MITRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I051",
    "nombre_dx": "I051-INSUFICIENCIA MITRAL REUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I052",
    "nombre_dx": "I052-ESTENOSIS MITRAL CON INSUFICIENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I058",
    "nombre_dx": "I058-OTRAS ENFERMEDADES DE LA VALVULA MITRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I059",
    "nombre_dx": "I059-ENFERMEDAD VALVULAR MITRAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I060",
    "nombre_dx": "I060-ESTENOSIS AORTICA REUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I061",
    "nombre_dx": "I061-INSUFICIENCIA AORTICA REUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I062",
    "nombre_dx": "I062-INSUFICIENCIA AORTICA REUMATICA CON INSUFICIENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I068",
    "nombre_dx": "I068-OTRAS ENFERMEDADES REUMATICAS DE LA VALVULA AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I069",
    "nombre_dx": "I069-ENFERMEDAD VALVULAR AORTICA REUMATICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I070",
    "nombre_dx": "I070-ESTENOSIS TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "I071",
    "nombre_dx": "I071-INSUFICIENCIA TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "I072",
    "nombre_dx": "I072-ESTENOSIS E INSUFICIENCIA TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "I078",
    "nombre_dx": "I078-OTRAS ENFERMEDADES DE LA VALVULA TRICUSPIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I079",
    "nombre_dx": "I079-ENFERMEDAD DE LA VALVULA TRICUSPIDE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I080",
    "nombre_dx": "I080-TRASTORNOS DE LAS VALVULAS MITRAL Y AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I081",
    "nombre_dx": "I081-TRASTORNOS DE LAS VALVULAS MITRAL Y TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "I082",
    "nombre_dx": "I082-TRASTORNOS DE LAS VALVULAS AORTICA Y TRICUSPIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I083",
    "nombre_dx": "I083-TRASTORNOS COMBINADOS DE LAS VALVULAS MITRAL, TRICUSPIDEY AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I088",
    "nombre_dx": "I088-OTRAS ENFERMEDADES DE MULTIPLES VALVULAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I089",
    "nombre_dx": "I089-ENFERMEDAD DE MULTIPLES VALVULAS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I090",
    "nombre_dx": "I090-MIOCARDITIS REUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I091",
    "nombre_dx": "I091-ENFERMEDADESREUMATICAS DEL ENDOCARDIO, VALVULA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I092",
    "nombre_dx": "I092-PERICARDITIS REUMATICA CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I098",
    "nombre_dx": "I098-OTRAS ENFERMEDADES REUMATICAS ESPECIFICADAS DEL CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "I099",
    "nombre_dx": "I099-ENFERMEDAD REUMATICA DEL CORAZON, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I10X",
    "nombre_dx": "I10X-HIPERTENSION ESENCIAL (PRIMARIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "I110",
    "nombre_dx": "I110-ENFERMEDAD CARDIACA HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA)",
    "sexo": "A"
  },
  {
    "cod_dx": "I119",
    "nombre_dx": "I119-ENFERMEDAD CARDIACA HIPERTENSIVA SIN INSUFICIENCIA CARDIACA (CONGESTIVA)",
    "sexo": "A"
  },
  {
    "cod_dx": "I120",
    "nombre_dx": "I120-ENFERMEDAD RENAL HIPERTENSIVA CON INSUFICIENCIA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I129",
    "nombre_dx": "I129-ENFERMEDAD RENAL HIPERTENSIVA SIN INSUFICIENCIA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I130",
    "nombre_dx": "I130-ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA)",
    "sexo": "A"
  },
  {
    "cod_dx": "I131",
    "nombre_dx": "I131-ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I132",
    "nombre_dx": "I132-ENFERMEDAD CARDIORRENAL HIPERTENSIVA CON INSUFICIENCIA CARDIACA (CONGESTIVA) E INSUFICIENCIA RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I139",
    "nombre_dx": "I139-ENFERMEDAD CARDIORRENAL HIPERTENSIVA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I150",
    "nombre_dx": "I150-HIPERTENSION RENOVASCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I151",
    "nombre_dx": "I151-HIPERTENSION SECUNDARIA A OTROS TRASTORNOS RENALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I152",
    "nombre_dx": "I152-HIPERTENSION SECUNDARIA A TRASTORNOS ENDOCRINOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I158",
    "nombre_dx": "I158-OTROS TIPOS DE HIPERTENSION SECUNDARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I159",
    "nombre_dx": "I159-HIPERTENSION SECUNDARIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I200",
    "nombre_dx": "I200-ANGINA INESTABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "I201",
    "nombre_dx": "I201-ANGINA DE PECHO CON ESPASMO DOCUMENTADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I208",
    "nombre_dx": "I208-OTRAS FORMAS ESPECIFICADAS DE ANGINA DE PECHO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I209",
    "nombre_dx": "I209-ANGINA DE PECHO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I210",
    "nombre_dx": "I210-INFARTO TRANSMURAL AGUDO DEL MIOCARDIO DE LA PARED ANTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I211",
    "nombre_dx": "I211-INFARTO TRANSMURAL AGUDO DEL MIOCARDIO DE LA PARED INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I212",
    "nombre_dx": "I212-INFARTO AGUDO TRANSMURAL DEL MIOCARDIO DE OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "I213",
    "nombre_dx": "I213-INFARTO TRANSMURAL AGUDO DEL MIOCARDIO, DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I214",
    "nombre_dx": "I214-INFARTO SUBENDOCARDICO AGUDO DEL MIOCARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "I219",
    "nombre_dx": "I219-INFARTO AGUDO DEL MIOCARDIO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "I220",
    "nombre_dx": "I220-INFARTO SUBSECUENTE DEL MIOCARDIO DE LA PARED ANTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "I221",
    "nombre_dx": "I221-INFARTO SUBSECUENTE DEL MIOCARDIO DE LA PARED INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "I228",
    "nombre_dx": "I228-INFARTO SUBSECUENTE DEL MIOCARDIO DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I229",
    "nombre_dx": "I229-INFARTO SUBSECUENTE DEL MIOCARDIO DE PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I230",
    "nombre_dx": "I230-HEMOPERICARDIO COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "I231",
    "nombre_dx": "I231-DEFECTO DEL TABIQUE AURICULAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO DEL MIOCARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I232",
    "nombre_dx": "I232-DEFECTO DEL TABIQUE VENTRICULAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO DEL MIOCARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I233",
    "nombre_dx": "I233-RUPTURA DE LA PARED CARDIACA SIN HEMOPERICARDIO COMO COMPILACION PRESENTE POSTERIOR AL INFARTO AGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "I234",
    "nombre_dx": "I234-RUPTURA DE LAS CUERDAS TENDINOSAS COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDI",
    "sexo": "A"
  },
  {
    "cod_dx": "I235",
    "nombre_dx": "I235-RUPTURA DE MUSCULO PAPILAR COMO COMPLICACION PRESENTE POSTERIOR AL INFARTO AGUDO DEL MIOCARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "I236",
    "nombre_dx": "I236-TROMBOSIS DE LA AURICULA, APENDICE AURICULAR Y VENTRICULO COMO COMPLICACION PRESENTE POSTERIOR AL IN",
    "sexo": "A"
  },
  {
    "cod_dx": "I238",
    "nombre_dx": "I238-OTRAS COMPLICACIONES PRESENTES POSTERIORES AL INFARTO AGUDO DEL MIOCARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I240",
    "nombre_dx": "I240-TROMBOSIS CORONARIA QUE NO RESULTA EN INFARTO DEL MIOCARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I241",
    "nombre_dx": "I241-SINDROME DE DRESSLER",
    "sexo": "A"
  },
  {
    "cod_dx": "I248",
    "nombre_dx": "I248-OTRAS FORMAS DE ENFERMEDAD ISQUEMICA AGUDA DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "I249",
    "nombre_dx": "I249-ENFERMEDAD ISQUEMICA AGUDA DEL CORAZON, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I250",
    "nombre_dx": "I250-ENFERMEDAD CARDIOVASCULAR ATEROSCLEROTICA, ASI DESCRITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I251",
    "nombre_dx": "I251-ENFERMEDAD ATEROSCLEROTICA DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "I252",
    "nombre_dx": "I252-INFARTO ANTIGUO DEL MIOCARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I253",
    "nombre_dx": "I253-ANEURISMA CARDIACO",
    "sexo": "A"
  },
  {
    "cod_dx": "I254",
    "nombre_dx": "I254-ANEURISMA DE ARTERIA CORONARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I255",
    "nombre_dx": "I255-CARDIOMIOPATIA ISQUEMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I256",
    "nombre_dx": "I256-ISQUEMIA SILENTE DEL MIOCARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "I258",
    "nombre_dx": "I258-OTRAS FORMAS DE ENFERMEDAD ISQUEMICA CRONICA DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "I259",
    "nombre_dx": "I259-ENFERMEDAD ISQUEMIA CRONICA DEL CORAZON, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I260",
    "nombre_dx": "I260-EMBOLIA PULMONAR CON MENCION DE CORAZON PULMONAR AGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "I269",
    "nombre_dx": "I269-EMBOLIA PULMONAR SIN MENCION DE CORAZON PULMONAR AGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "I270",
    "nombre_dx": "I270-HIPERTENSION PULMONAR PRIMARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I271",
    "nombre_dx": "I271-ENFERMEDAD CIFOSCOLIOTICA DEL CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "I278",
    "nombre_dx": "I278-OTRAS ENFERMEDADES CARDIOPULMONARES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I279",
    "nombre_dx": "I279-ENFERMEDAD PULMONAR DEL CORAZON, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I280",
    "nombre_dx": "I280-FISTULA ARTERIOVENOSA DE LOS VASOS PULMONARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I281",
    "nombre_dx": "I281-ANEURISMA DE LA ARTERIA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I288",
    "nombre_dx": "I288-OTRAS ENFERMEDADES ESPECIFICADAS DE LOS VASOS PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "I289",
    "nombre_dx": "I289-ENFERMEDAD DE LOS VASOS PULMONARES, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I300",
    "nombre_dx": "I300-PERICARDITIS IDIOPATICA AGUDA INESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I301",
    "nombre_dx": "I301-PERICARDITIS INFECCIOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I308",
    "nombre_dx": "I308-OTRAS FORMAS DE PERICARDITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I309",
    "nombre_dx": "I309-PERICARDITIS AGUDA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I310",
    "nombre_dx": "I310-PERICARDITIS CRONICA ADHESIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I311",
    "nombre_dx": "I311-PERICARDITIS CONSTRICTIVA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I312",
    "nombre_dx": "I312-HEMOPERICARDIO, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I313",
    "nombre_dx": "I313-DERRAME PERICARDICO (NO INFLAMATORIO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "I318",
    "nombre_dx": "I318-OTRAS ENFERMEDADES ESPECIFICADAS DEL PERICARDIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I319",
    "nombre_dx": "I319-ENFERMEDAD DEL PERICARDIO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I320",
    "nombre_dx": "I320-PERICARDITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I321",
    "nombre_dx": "I321-PERICARDITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I328",
    "nombre_dx": "I328-PERICARDITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I330",
    "nombre_dx": "I330-ENDOCARDITIS INFECCIOSA AGUDA Y SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I339",
    "nombre_dx": "I339-ENDOCARDITIS AGUDA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I340",
    "nombre_dx": "I340-INSUFICIENCIA (DE LA VALVULA) MITRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I341",
    "nombre_dx": "I341-PROLAPSO (DE LA VALVULA) MITRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I342",
    "nombre_dx": "I342-ESTENOSIS (DE LA VALVULA) MITRAL, NO REUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I348",
    "nombre_dx": "I348-OTROS TRASTORNOS NO REUMATICOS DE LA VALVULA MITRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I349",
    "nombre_dx": "I349-TRASTORNO MITRAL NO REUMATICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I350",
    "nombre_dx": "I350-ESTENOSIS (DE LA VALVULA) AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I351",
    "nombre_dx": "I351-INSUFICIENCIA (DE LA VALVULA) AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I352",
    "nombre_dx": "I352-ESTENOSIS (DE LA VALVULA) AORTICA CON INSUFICIENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I358",
    "nombre_dx": "I358-OTROS TRASTORNOS DE LA VALVULA AORTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I359",
    "nombre_dx": "I359-TRASTORNO DE LA VALVULA AORTICA, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I360",
    "nombre_dx": "I360-ESTENOSIS NO REUMATICA (DE LA VALVULA) TRICUSPIDE)",
    "sexo": "A"
  },
  {
    "cod_dx": "I361",
    "nombre_dx": "I361-INSUFICIENCIA NO REUMATICA (DE LA VALVULA) TRICUSPIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I362",
    "nombre_dx": "I362-ESTENOSIS CON INSUFICIENCIA NO REUMATICA (DE LA VALVULA) TRICUSPIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I368",
    "nombre_dx": "I368-OTROS TRASTORNOS NO REUMATICOS DE LA VALVULA TRICUSPIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I369",
    "nombre_dx": "I369-TRASTORNO NO REUMATICO DE LA VALVULA TRICUSPIDE, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I370",
    "nombre_dx": "I370-ESTENOSIS DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I371",
    "nombre_dx": "I371-INSUFICIENCIA DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I372",
    "nombre_dx": "I372-ESTENOSIS DE LA VALVULA PULMONAR CON INSUFICIENCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I378",
    "nombre_dx": "I378-OTROS TRASTORNOS DE LA VALVULA PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I379",
    "nombre_dx": "I379-TRASTORNO DE LA VALVULA PULMONAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I38X",
    "nombre_dx": "I38X-ENDOCARDITIS, VALVULA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I390",
    "nombre_dx": "I390-TRASTORNOS DE LA VALVULA MITRAL EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I391",
    "nombre_dx": "I391-TRASTORNOS DE LA VALVULA AORTICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I392",
    "nombre_dx": "I392-TRASTORNOS DE LA VALVULA TRICUSPIDE EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I393",
    "nombre_dx": "I393-TRASTORNOS DE LA VALVULA PULMONAR EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I394",
    "nombre_dx": "I394-TRASTORNOS DE LA VALVULARES MULTIPLES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I398",
    "nombre_dx": "I398-ENDOCARDITIS,VALVULA NO ESPECIFICADA, EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I400",
    "nombre_dx": "I400-MIOCARDITIS INFECCIOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "I401",
    "nombre_dx": "I401-MIOCARDITIS AISLADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I408",
    "nombre_dx": "I408-OTRAS MIOCARDITIS AGUDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I409",
    "nombre_dx": "I409-MIOCARDITIS AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I410",
    "nombre_dx": "I410-MIOCARDITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I411",
    "nombre_dx": "I411-MIOCARDITIS EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I412",
    "nombre_dx": "I412-MIOCARDITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I418",
    "nombre_dx": "I418-MIOCARDITIS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I420",
    "nombre_dx": "I420-CARDIOMIOPATIA DILATADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I421",
    "nombre_dx": "I421-CARDIOMIOPATIAHIPERTROFICA OBSTRUCTIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "I422",
    "nombre_dx": "I422-OTRAS CARDIOMIOPATIAHIPERTROFICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I423",
    "nombre_dx": "I423-ENFERMEDAD ENDOMIOCARDICA (EOSINOFILICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "I424",
    "nombre_dx": "I424-FIBROELASTOSIS ENDOCARDICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I425",
    "nombre_dx": "I425-OTRAS CARDIOMIOPATIAS RESTRICTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I426",
    "nombre_dx": "I426-CARDIOMIOPATIA ALCOHOLICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I427",
    "nombre_dx": "I427-CARDIOMIOPATIA DEBIDA A DROGAS Y A OTROS AGENTES EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I428",
    "nombre_dx": "I428-OTRAS CARDIOMIOPATIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I429",
    "nombre_dx": "I429-CARDIOMIOPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I430",
    "nombre_dx": "I430-CARDIOMIOPATIA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I431",
    "nombre_dx": "I431-CARDIOMIOPATIA EN ENFERMEDADES METABOLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I432",
    "nombre_dx": "I432-CARDIOMIOPATIA EN ENFERMEDADES NUTRICIONALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I438",
    "nombre_dx": "I438-CARDIOMIOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I440",
    "nombre_dx": "I440-BLOQUEO AURICULOVENTRICULAR DE PRIMER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I441",
    "nombre_dx": "I441-BLOQUEO AURICULOVENTRICULAR DE SEGUNDO GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I442",
    "nombre_dx": "I442-BLOQUEO AURICULOVENTRICULAR COMPLETO",
    "sexo": "A"
  },
  {
    "cod_dx": "I443",
    "nombre_dx": "I443-OTROS TIPOS DE BLOQUEO AURICULOVENTRICULARY LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "I444",
    "nombre_dx": "I444-BLOQUEO FASCICULAR ANTERIOR IZQUIERDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I445",
    "nombre_dx": "I445-BLOQUEO FASCICULAR POSTERIOR IZQUIERDO",
    "sexo": "A"
  },
  {
    "cod_dx": "I446",
    "nombre_dx": "I446-OTROS TIPOS DE BLOQUEO FASCICULARY LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I447",
    "nombre_dx": "I447-BLOQUEO DE RAMA IZQUIERDA DEL HAZ, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "I450",
    "nombre_dx": "I450-BLOQUEO FASCICULAR DERECHO",
    "sexo": "A"
  },
  {
    "cod_dx": "I451",
    "nombre_dx": "I451-OTROS TIPOS DE BLOQUEO DE RAMA DERECHA DEL HAZ Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I452",
    "nombre_dx": "I452-BLOQUEO BIFASCICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I453",
    "nombre_dx": "I453-BLOQUEO TRIFASCICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I454",
    "nombre_dx": "I454-BLOQUEO INTRAVENTRICULAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I455",
    "nombre_dx": "I455-OTROS TIPOS ESPECIFICADOS DE BLOQUEO DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "I456",
    "nombre_dx": "I456-SINDROME DE PREEXCITACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "I458",
    "nombre_dx": "I458-OTROS TRASTORNOS ESPECIFICADOS DE LA CONDUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "I459",
    "nombre_dx": "I459-TRASTORNO DE LA CONDUCCION, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I460",
    "nombre_dx": "I460-PARO CARDIACO CON RESUCITACION EXITOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "I461",
    "nombre_dx": "I461-MUERTE CARDIACA SUBITA, ASI DESCRITA",
    "sexo": "A"
  },
  {
    "cod_dx": "I469",
    "nombre_dx": "I469-PARO CARDIACO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I470",
    "nombre_dx": "I470-ARRITMIA POR REENTRADA VENTRICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I471",
    "nombre_dx": "I471-TAQUICARDIA SUPRAVENTRICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I472",
    "nombre_dx": "I472-TAQUICARDIA VENTRICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I479",
    "nombre_dx": "I479-TAQUICARDIA PAROXISTICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I480",
    "nombre_dx": "I480-Fibrilación auricular paroxística",
    "sexo": "A"
  },
  {
    "cod_dx": "I481",
    "nombre_dx": "I481-Fibrilación auricular persistente",
    "sexo": "A"
  },
  {
    "cod_dx": "I482",
    "nombre_dx": "I482-Fibrilación auricular crónica",
    "sexo": "A"
  },
  {
    "cod_dx": "I483",
    "nombre_dx": "I483-Aleteo auricular típico",
    "sexo": "A"
  },
  {
    "cod_dx": "I484",
    "nombre_dx": "I484-Aleteo auricular atípico",
    "sexo": "A"
  },
  {
    "cod_dx": "I489",
    "nombre_dx": "I489-Fibrilación y aleteo auricular, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "I490",
    "nombre_dx": "I490-FIBRILACION Y ALETEO VENTRICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I491",
    "nombre_dx": "I491-DESPOLARIZACION AURICULAR PREMATURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I492",
    "nombre_dx": "I492-DESPOLARIZACION PREMATURA NODAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I493",
    "nombre_dx": "I493-DESPOLARIZACION VENTRICULAR PREMATURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I494",
    "nombre_dx": "I494-OTROS TIPOS DE DESPOLARIZACION PREMATURA Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I495",
    "nombre_dx": "I495-SINDROME DEL SENO ENFERMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I498",
    "nombre_dx": "I498-OTRAS ARRITMIAS CARDIACAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I499",
    "nombre_dx": "I499-ARRITMIA CARDIACA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I500",
    "nombre_dx": "I500-INSUFICIENCIA CARDIACA CONGESTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I501",
    "nombre_dx": "I501-INSUFICIENCIA VENTRICULAR IZQUIERDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I509",
    "nombre_dx": "I509-INSUFICIENCIA CARDIACA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I510",
    "nombre_dx": "I510-DEFECTO DEL TABIQUE CARDIACO, ADQUIRIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I511",
    "nombre_dx": "I511-RUPTURA DE CUERDA TENDINOSA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I512",
    "nombre_dx": "I512-RUPTURA DEL MUSCULO PAPILAR, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I513",
    "nombre_dx": "I513-TROMBOSIS INTRACARDIACA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I514",
    "nombre_dx": "I514-MIOCARDITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I515",
    "nombre_dx": "I515-DEGENERACION MIOCARDICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I516",
    "nombre_dx": "I516-ENFERMEDAD CARDIOVASCULAR, NO ESPECIFICADAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "I517",
    "nombre_dx": "I517-CARDIOMEGALIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I518",
    "nombre_dx": "I518-OTRAS ENFERMEDADES CARDIACAS MAL DEFINIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I519",
    "nombre_dx": "I519-ENFERMEDAD CARDIACA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I520",
    "nombre_dx": "I520-OTROS TRASTORNOS CARDIACOS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I521",
    "nombre_dx": "I521-OTROS TRASTORNOS CARDIACOS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I528",
    "nombre_dx": "I528-OTROS TRASTORNOS CARDIACOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I600",
    "nombre_dx": "I600-HEMORRAGIA SUBARACNOIDEA DE SIFON Y BIFURCACION CAROTIDEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I601",
    "nombre_dx": "I601-HEMORRAGIA SUBARACNOIDEA DE ARTERIA CEREBRAL MEDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I602",
    "nombre_dx": "I602-HEMORRAGIA SUBARACNOIDEA DE ARTERIA COMUNICANTE ANTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "I603",
    "nombre_dx": "I603-HEMORRAGIA SUBARACNOIDEA DE ARTERIA COMUNICANTE POSTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I604",
    "nombre_dx": "I604-HEMORRAGIA SUBARACNOIDEA DE ARTERIA BASILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I605",
    "nombre_dx": "I605-HEMORRAGIA SUBARACNOIDEA DE ARTERIA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I606",
    "nombre_dx": "I606-HEMORRAGIA SUBARACNOIDEA DE OTRAS ARTERIAS INTRACRANEALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I607",
    "nombre_dx": "I607-HEMORRAGIA SUBARACNOIDEA DE ARTERIA INTRACRANEAL NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I608",
    "nombre_dx": "I608-OTRAS HEMORRAGIAS SUBARACNOIDEAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I609",
    "nombre_dx": "I609-HEMORRAGIA SUBARACNOIDEA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I610",
    "nombre_dx": "I610-HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, SUBCORTICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I611",
    "nombre_dx": "I611-HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, CORTICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I612",
    "nombre_dx": "I612-HEMORRAGIA INTRACEREBRAL EN HEMISFERIO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I613",
    "nombre_dx": "I613-HEMORRAGIA INTRAENCEFALICA EN TALLO CEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I614",
    "nombre_dx": "I614-HEMORRAGIA INTRAENCEFALICA EN CEREBELO",
    "sexo": "A"
  },
  {
    "cod_dx": "I615",
    "nombre_dx": "I615-HEMORRAGIA INTRAENCEFALICA, INTRAVENTRICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I616",
    "nombre_dx": "I616-HEMORRAGIA INTRAENCEFALICA DE LOCALIZACIONES MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "I618",
    "nombre_dx": "I618-OTRAS HEMORRAGIAS INTRAENCEFALICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I619",
    "nombre_dx": "I619-HEMORRAGIA INTRAENCEFALICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I620",
    "nombre_dx": "I620-HEMORRAGIA SUBDURAL (AGUDA) (NO TRAUMATICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "I621",
    "nombre_dx": "I621-HEMORRAGIA EXTRADURAL NO TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I629",
    "nombre_dx": "I629-HEMORRAGIA INTRACRANEAL (NO TRAUMATICA), NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I630",
    "nombre_dx": "I630-INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIAS PRECEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I631",
    "nombre_dx": "I631-INFARTO CEREBRAL DEBIDO A EMBOLIA DE ARTERIAS PRECEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I632",
    "nombre_dx": "I632-INFARTO CEREBRAL DEBIDO A OCLUSION O ESTENOSIS NO ESPECIFICADADE ARTERIAS PRECEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I633",
    "nombre_dx": "I633-INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIAS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I634",
    "nombre_dx": "I634-INFARTO CEREBRAL DEBIDO A EMBOLIA DE ARTERIAS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I635",
    "nombre_dx": "I635-INFARTO CEREBRAL DEBIDO A OCLUSION O ESTENOSIS NO ESPECIFICADADE ARTERIAS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I636",
    "nombre_dx": "I636-INFARTO CEREBRAL DEBIDO A TROMBOSIS DE VENAS CEREBRALES, NO PIOGENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I638",
    "nombre_dx": "I638-OTROS INFARTOS CEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I639",
    "nombre_dx": "I639-INFARTO CEREBRAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I64X",
    "nombre_dx": "I64X-ACCIDENTE VASCULAR ENCEFALICO AGUDO, NO ESPECIFICADO COMO HEMORRAGICO O ISQUEMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I650",
    "nombre_dx": "I650-OCLUSION Y ESTENOSIS DE ARTERIA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I651",
    "nombre_dx": "I651-OCLUSION Y ESTENOSIS DE ARTERIA BASILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I652",
    "nombre_dx": "I652-OCLUSION Y ESTENOSIS DE ARTERIA CAROTIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I653",
    "nombre_dx": "I653-OCLUSION Y ESTENOSIS MULTIPLE BILATERAL DE ARTERIAS PRECEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I658",
    "nombre_dx": "I658-OCLUSION Y ESTENOSIS DE OTRAS ARTERIAS PRECEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I659",
    "nombre_dx": "I659-OCLUSION Y ESTENOSIS DE ARTERIA PRECEREBRAL NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I660",
    "nombre_dx": "I660-OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL MEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I661",
    "nombre_dx": "I661-OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL ANTERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "I662",
    "nombre_dx": "I662-OCLUSION Y ESTENOSIS DE LA ARTERIA CEREBRAL POSTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "I663",
    "nombre_dx": "I663-OCLUSION Y ESTENOSIS DEARTERIAS CEREBELOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I664",
    "nombre_dx": "I664-OCLUSION Y ESTENOSIS MULTIPLE BILATERAL DE ARTERIAS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I668",
    "nombre_dx": "I668-OCLUSION Y ESTENOSIS DE OTRAS ARTERIAS CEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I669",
    "nombre_dx": "I669-OCLUSION Y ESTENOSIS DE ARTERIA CEREBRAL NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I670",
    "nombre_dx": "I670-DISECCION DE ARTERIAS CEREBRALES, SIN RUPTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I671",
    "nombre_dx": "I671-ANEURISMA CEREBRAL, SIN RUPTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I672",
    "nombre_dx": "I672-ATEROSCLEROSIS CEREBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I673",
    "nombre_dx": "I673-LEUCOENCEFALOPATIA VASCULAR PROGRESIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "I674",
    "nombre_dx": "I674-ENCEFALOPATIA HIPERTENSIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "I675",
    "nombre_dx": "I675-ENFERMEDAD DE MOYAMOYA",
    "sexo": "A"
  },
  {
    "cod_dx": "I676",
    "nombre_dx": "I676-TROMBOSIS APIOGENA DEL SISTEMA VENOSO INTRACRANEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I677",
    "nombre_dx": "I677-ARTERITIS CEREBRAL, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I678",
    "nombre_dx": "I678-OTRAS ENFERMEDADES CEREBROVASCULARES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I679",
    "nombre_dx": "I679-ENFERMEDAD CEREBROVASCULAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I680",
    "nombre_dx": "I680-ANGIOPATIA CEREBRAL AMILOIDE (E85.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "I681",
    "nombre_dx": "I681-ARTERITIS CEREBRAL EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I682",
    "nombre_dx": "I682-ARTERITIS CEREBRAL EN OTRAS ENFERMEDADES CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I688",
    "nombre_dx": "I688-OTROS TRASTORNOS CEREBROVASCULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I690",
    "nombre_dx": "I690-SECUELAS DE HEMORRAGIA SUBARACNOIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "I691",
    "nombre_dx": "I691-SECUELAS DE HEMORRAGIA INTRAENCEFALICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I692",
    "nombre_dx": "I692-SECUELAS DE OTRAS HEMORRAGIAS INTRACRANEALES NO TRAUMATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I693",
    "nombre_dx": "I693-SECUELAS DE INFARTO CEREBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I694",
    "nombre_dx": "I694-SECUELAS DE ENFERMEDAD CEREBROVASCULAR, NO ESPECIFICADA COMO HEMORRAGICA U OCLUSIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I698",
    "nombre_dx": "I698-SECUELAS DE OTRAS ENFERMEDADES CEREBROVASCULARES Y DE LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I700",
    "nombre_dx": "I700-ATEROSCLEROSIS DE LA AORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "I701",
    "nombre_dx": "I701-ATEROSCLEROSIS DE LA ARTERIA RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I702",
    "nombre_dx": "I702-ATEROSCLEROSIS DE LAS ARTERIAS DE LOS MIEMBROS",
    "sexo": "A"
  },
  {
    "cod_dx": "I708",
    "nombre_dx": "I708-ATEROSCLEROSIS DE OTRAS ARTERIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I709",
    "nombre_dx": "I709-ATEROSCLEROSIS GENERALIZADA Y LA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I710",
    "nombre_dx": "I710-DISECCION DE AORTA (CUALQUIER PARTE)",
    "sexo": "A"
  },
  {
    "cod_dx": "I711",
    "nombre_dx": "I711-RUPTURA DE ANEURISMA DE LA AORTA TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I712",
    "nombre_dx": "I712-ANEURISMA DE LA AORTA TORACICA, SIN MENCION DE RUPTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "I713",
    "nombre_dx": "I713-RUPTURA DE ANEURISMA DE LA AORTA ABDOMINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I714",
    "nombre_dx": "I714-ANEURISMA DE LA AORTA ABDOMINAL, SIN MENCION DE RUPTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I715",
    "nombre_dx": "I715-RUPTURA DE ANEURISMA DE LA AORTA TORACOABDOMINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I716",
    "nombre_dx": "I716-ANEURISMA DE LA AORTA TORACOABDOMINAL, SIN MENCION DE RUPTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I718",
    "nombre_dx": "I718-RUPTURA DE ANEURISMA AORTICO, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I719",
    "nombre_dx": "I719-ANEURISMA DE LA AORTA, SITIO NO ESPECIFICADO, SIN MENCION DE RUPTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "I720",
    "nombre_dx": "I720-Aneurisma y disección de la arteria carótida",
    "sexo": "A"
  },
  {
    "cod_dx": "I721",
    "nombre_dx": "I721-Aneurisma y disección de arteria del miembro superior",
    "sexo": "A"
  },
  {
    "cod_dx": "I722",
    "nombre_dx": "I722-Aneurisma y disección de arteria renal",
    "sexo": "A"
  },
  {
    "cod_dx": "I723",
    "nombre_dx": "I723-Aneurisma y disección de arteria ilíaca",
    "sexo": "A"
  },
  {
    "cod_dx": "I724",
    "nombre_dx": "I724-Aneurisma y disección de arteria del miembro inferior",
    "sexo": "A"
  },
  {
    "cod_dx": "I725",
    "nombre_dx": "I725-Aneurisma y disección de otras arterias precerebrales",
    "sexo": "A"
  },
  {
    "cod_dx": "I726",
    "nombre_dx": "I726-Aneurisma y disección de arteria vertebral",
    "sexo": "A"
  },
  {
    "cod_dx": "I728",
    "nombre_dx": "I728-Aneurisma y disección de otras arterias especificadas",
    "sexo": "A"
  },
  {
    "cod_dx": "I729",
    "nombre_dx": "I729-Aneurisma y disección de sitio no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "I72X",
    "nombre_dx": "I72X-Otros aneurismas y aneurismas disecantes (antes OTROS ANEURISMAS)",
    "sexo": "A"
  },
  {
    "cod_dx": "I730",
    "nombre_dx": "I730-SINDROME DE RAYNAUD ",
    "sexo": "A"
  },
  {
    "cod_dx": "I731",
    "nombre_dx": "I731-TROMBOANGEITIS OBLITERANTE [BUERGER]",
    "sexo": "A"
  },
  {
    "cod_dx": "I738",
    "nombre_dx": "I738-OTRAS ENFERMEDADES VASCULARES PERIFERICAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I739",
    "nombre_dx": "I739-ENFERMEDAD VASCULAR PERIFERICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I740",
    "nombre_dx": "I740-EMBOLIA Y TROMBOSIS DE LA AORTA ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I741",
    "nombre_dx": "I741-EMBOLIA Y TROMBOSIS DE OTRAS PORCIONES Y LAS NO ESPECIFICADAS DE LA AORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I742",
    "nombre_dx": "I742-EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS SUPERIORES",
    "sexo": "A"
  },
  {
    "cod_dx": "I743",
    "nombre_dx": "I743-EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS INFERIORES",
    "sexo": "A"
  },
  {
    "cod_dx": "I744",
    "nombre_dx": "I744-EMBOLIA Y TROMBOSIS DE ARTERIAS DE LOS MIEMBROS, NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I745",
    "nombre_dx": "I745-EMBOLIA Y TROMBOSIS DE ARTERIA ILIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I748",
    "nombre_dx": "I748-EMBOLIA Y TROMBOSIS DE OTRAS ARTERIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I749",
    "nombre_dx": "I749-EMBOLIA Y TROMBOSIS DE ARTERIA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I770",
    "nombre_dx": "I770-FISTULA ARTERIOVENOSA, ADQUIRIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "I771",
    "nombre_dx": "I771-ESTRECHEZ ARTERIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I772",
    "nombre_dx": "I772-RUPTURA ARTERIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I773",
    "nombre_dx": "I773-Displasia fibromuscular arterial",
    "sexo": "A"
  },
  {
    "cod_dx": "I774",
    "nombre_dx": "I774-Sindrome de compresion del tronco celiaco",
    "sexo": "A"
  },
  {
    "cod_dx": "I775",
    "nombre_dx": "I775-Necrosis arterial",
    "sexo": "A"
  },
  {
    "cod_dx": "I776",
    "nombre_dx": "I776-Arteritis, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "I778",
    "nombre_dx": "I778-OTROS TRASTORNOS ESPECIFICADOS DE ARTERIAS Y ARTERIOLAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I779",
    "nombre_dx": "I779-Trastornos de arterias y arteriolas, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "I780",
    "nombre_dx": "I780-TELANGIECTASIA HEMORRAGICA HEREDITARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "I781",
    "nombre_dx": "I781-NEVO, NONEOPLASICO",
    "sexo": "A"
  },
  {
    "cod_dx": "I788",
    "nombre_dx": "I788-OTRAS ENFERMEDADES DE LOS CAPILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I789",
    "nombre_dx": "I789-ENFERMEDAD DE LOS VASOS CAPILARES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I790",
    "nombre_dx": "I790-ANEURISMA DE LA AORTA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I791",
    "nombre_dx": "I791-AORTITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I792",
    "nombre_dx": "I792-ANGIOPATIA PERIFERICA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I798",
    "nombre_dx": "I798-OTROS TRASTORNOSDE ARTERIAS, ARTERIOLAS Y VASOS CAPILARES EN ENFERMEDADES CLASIFICADAS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I800",
    "nombre_dx": "I800-FLEBITIS Y TROMBOFLEBITIS DE VASOS SUPERFICIALES DE LOS MIEMBROS INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I801",
    "nombre_dx": "I801-FLEBITIS Y TROMBOFLEBITIS DE LA VENA FEMORAL",
    "sexo": "A"
  },
  {
    "cod_dx": "I802",
    "nombre_dx": "I802-FLEBITIS Y TROMBOFLEBITIS DE OTROS VASOS PROFUNDOS DE LOS MIEMBROS INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "I803",
    "nombre_dx": "I803-FLEBITIS Y TROMBOFLEBITIS DE LOS MIEMBROS INFERIORES, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I808",
    "nombre_dx": "I808-FLEBITIS Y TROMBOFLEBITIS DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I809",
    "nombre_dx": "I809-FLEBITIS Y TROMBOFLEBITIS DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "I81X",
    "nombre_dx": "I81X-TROMBOSIS DE LA VENA PORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "I820",
    "nombre_dx": "I820-SINDROME DE BUDD-CHIARI ",
    "sexo": "A"
  },
  {
    "cod_dx": "I821",
    "nombre_dx": "I821-TROMBOFLEBITIS MIGRATORIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I822",
    "nombre_dx": "I822-EMBOLIA Y TROMBOSIS DE VENA CAVA",
    "sexo": "A"
  },
  {
    "cod_dx": "I823",
    "nombre_dx": "I823-EMBOLIA Y TROMBOSIS DE VENA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "I828",
    "nombre_dx": "I828-EMBOLIA Y TROMBOSIS DE OTRAS VENAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I829",
    "nombre_dx": "I829-EMBOLIA Y TROMBOSIS DE VENA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I830",
    "nombre_dx": "I830-VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON ULCERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I831",
    "nombre_dx": "I831-VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON INFLAMACION",
    "sexo": "A"
  },
  {
    "cod_dx": "I832",
    "nombre_dx": "I832-VENAS VARICOSAS DE LOS MIEMBROS INFERIORES CON ULCERA E INFLAMACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "I839",
    "nombre_dx": "I839-VENAS VARICOSAS DE LOS MIEMBROS INFERIORES SIN ULCERA NI INFLAMACION",
    "sexo": "A"
  },
  {
    "cod_dx": "I850",
    "nombre_dx": "I850-VARICES ESOFAGICAS CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I859",
    "nombre_dx": "I859-VARICES ESOFAGICAS SIN HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I860",
    "nombre_dx": "I860-VARICES SUBLINGUALES",
    "sexo": "A"
  },
  {
    "cod_dx": "I861",
    "nombre_dx": "I861-VARICES ESCROTALES",
    "sexo": "M"
  },
  {
    "cod_dx": "I862",
    "nombre_dx": "I862-VARICES PELVICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I863",
    "nombre_dx": "I863-VARICES DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "I864",
    "nombre_dx": "I864-VARICES GASTRICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I868",
    "nombre_dx": "I868-VARICES EN OTROS SITIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I870",
    "nombre_dx": "I870-Síndrome postrombótico",
    "sexo": "A"
  },
  {
    "cod_dx": "I871",
    "nombre_dx": "I871-COMPRESION DE VENA",
    "sexo": "A"
  },
  {
    "cod_dx": "I872",
    "nombre_dx": "I872-INSUFICIENCIA VENOSA (CRONICA) (PERIFERICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "I878",
    "nombre_dx": "I878-OTROS TRASTORNOS VENOSOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "I879",
    "nombre_dx": "I879-TRASTORNO VENOSO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I880",
    "nombre_dx": "I880-LINFADENITISMESENTERICA INESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I881",
    "nombre_dx": "I881-LINFADENITIS CRONICA, EXCEPTO LA MESENTERICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I888",
    "nombre_dx": "I888-OTRAS LINFADENITIS INESPECIFICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "I889",
    "nombre_dx": "I889-LINFADENITIS INESPECIFICA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I890",
    "nombre_dx": "I890-LINFEDEMA, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "I891",
    "nombre_dx": "I891-LINFANGITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I898",
    "nombre_dx": "I898-OTROS TRASTORNOS ESPECIFICADOS NO INFECCIOSOS DE LOS VASOS Y GANGLIOS LINFATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "I899",
    "nombre_dx": "I899-TRASTORNO NO INFECCIOSO DE VASOS Y GANGLIOS LINFATICOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "I950",
    "nombre_dx": "I950-HIPOTENSION IDIOPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "I951",
    "nombre_dx": "I951-HIPOTENSION ORTOSTATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I952",
    "nombre_dx": "I952-HIPOTENSION DEBIDA A DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I958",
    "nombre_dx": "I958-OTROS TIPOS DE HIPOTENSION",
    "sexo": "A"
  },
  {
    "cod_dx": "I959",
    "nombre_dx": "I959-HIPOTENSION, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "I970",
    "nombre_dx": "I970-SINDROME DE POSTCARDIOTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I971",
    "nombre_dx": "I971-OTRAS ALTERACIONES FUNCIONALES CONSECUTIVAS A CIRUGIA CARDIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "I972",
    "nombre_dx": "I972-SINDROME DE LINFEDEMA POSTMASTECTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "I978",
    "nombre_dx": "I978-OTROS TRASTORNOS DEL SISTEMA CIRCULATORIO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I979",
    "nombre_dx": "I979-TRASTORNO NO ESPECIFICADO DEL SISTEMA CIRCULATORIO CONSECUTIVO A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "I980",
    "nombre_dx": "I980-SIFILIS CARDIOVASCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "I981",
    "nombre_dx": "I981-TRASTORNOS CARDIOVASCULARES EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PA",
    "sexo": "A"
  },
  {
    "cod_dx": "I982",
    "nombre_dx": "I982-Várices esofágicas sin hemorragia en enfermedades clasificadas en otra parte",
    "sexo": "A"
  },
  {
    "cod_dx": "I983",
    "nombre_dx": "I983-Várices esofágicas con hemorragia en enfermedades clasificadas en otra parte",
    "sexo": "A"
  },
  {
    "cod_dx": "I988",
    "nombre_dx": "I988-OTROS TRASTORNOS ESPECIFICADOS DEL APARATO CIRCULATORIO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "I99X",
    "nombre_dx": "I99X-OTROS TRASTORNOS Y LOS NO ESPECIFICADOS DEL SISTEMA CIRCULATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "J00X",
    "nombre_dx": "J00X-RINOFARINGITIS AGUDA (RESFRIADO COMUN)",
    "sexo": "A"
  },
  {
    "cod_dx": "J010",
    "nombre_dx": "J010-SINUSITIS MAXILAR AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J011",
    "nombre_dx": "J011-SINUSITIS FRONTAL AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J012",
    "nombre_dx": "J012-SINUSITISETMOIDAL AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J013",
    "nombre_dx": "J013-SINUSITIS ESFENOIDAL AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "J014",
    "nombre_dx": "J014-PANSINUSITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "J018",
    "nombre_dx": "J018-OTRAS SINUSITISAGUDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J019",
    "nombre_dx": "J019-SINUSITIS AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J020",
    "nombre_dx": "J020-FARINGITISESTREPTOCOCICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J028",
    "nombre_dx": "J028-FARINGITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J029",
    "nombre_dx": "J029-FARINGITIS AGUDA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J030",
    "nombre_dx": "J030-AMIGDALITIS ESTREPTOCOCICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J038",
    "nombre_dx": "J038-AMIGDALITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J039",
    "nombre_dx": "J039-AMIGDALITIS AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J040",
    "nombre_dx": "J040-LARINGITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "J041",
    "nombre_dx": "J041-TRAQUEITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "J042",
    "nombre_dx": "J042-LARINGOTRAQUEITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J050",
    "nombre_dx": "J050-LARINGITIS OBSTRUCTIVA, AGUDA [CRUP]",
    "sexo": "A"
  },
  {
    "cod_dx": "J051",
    "nombre_dx": "J051-EPIGLOTITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J060",
    "nombre_dx": "J060-LARINGOFARINGITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J068",
    "nombre_dx": "J068-OTRAS INFECCIONES AGUDAS DE SITIOS MULTIPLES DE LAS VIAS RESPIRATORIAS SUPERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J069",
    "nombre_dx": "J069-INFECCION AGUDA DE LAS VIAS RESPIRATORIAS SUPERIORES, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J09X",
    "nombre_dx": "J09X-Influenza debida a otro virus de la influenza aviar identificado (antes INFLUENZA DEBIDA A CIERTOS VIRUS DE LA INFLUENZA IDENTIFICADO)",
    "sexo": "A"
  },
  {
    "cod_dx": "J100",
    "nombre_dx": "J100-INFLUENZA CON NEUMONIA, DEBIDA A VIRUS DE LA INFLUENZA IDENTIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J101",
    "nombre_dx": "J101-INFLUENZA CON OTRAS MANIFESTACIONES RESPIRATORIAS, DEBIDA A VIRUS DE LA INFLUENZA IDENTIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "J108",
    "nombre_dx": "J108-INFLUENZA, CON OTRAS MANIFESTACIONES, DEBIDA A VIRUS DE LA INFLUENZA IDENTIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J110",
    "nombre_dx": "J110-INFLUENZA CON NEUMONIA, VIRUS NO IDENTIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J111",
    "nombre_dx": "J111-INFLUENZA CONOTRAS MANIFESTACIONES RESPIRATORIAS, VIRUS NO IDENTIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J118",
    "nombre_dx": "J118-INFLUENZA CONOTRAS MANIFESTACIONES, VIRUS NO IDENTIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J120",
    "nombre_dx": "J120-NEUMONIA DEBIDA A ADENOVIRUS",
    "sexo": "A"
  },
  {
    "cod_dx": "J121",
    "nombre_dx": "J121-NEUMONIA DEBIDA A VIRUS SINCITIALRESPIRATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J122",
    "nombre_dx": "J122-NEUMONIA DEBIDA A VIRUS PARAINFLUENZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J123",
    "nombre_dx": "J123-Neumonía debida a metaneumovirus humano",
    "sexo": "A"
  },
  {
    "cod_dx": "J128",
    "nombre_dx": "J128-NEUMONIA DEBIDA A OTROS VIRUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J129",
    "nombre_dx": "J129-NEUMONIA VIRAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J13X",
    "nombre_dx": "J13X-NEUMONIA DEBIDA A STREPTOCOCCUS PNEUMONIAE",
    "sexo": "A"
  },
  {
    "cod_dx": "J14X",
    "nombre_dx": "J14X-NEUMONIA DEBIDA A HAEMOPHILUS INFLUENZAE",
    "sexo": "A"
  },
  {
    "cod_dx": "J150",
    "nombre_dx": "J150-NEUMONIA DEBIDA A KLEBSIELLA PNEUMONIAE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J151",
    "nombre_dx": "J151-NEUMONIA DEBIDA A PSEUDOMONAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J152",
    "nombre_dx": "J152-NEUMONIA DEBIDA A ESTAFILOCOCOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J153",
    "nombre_dx": "J153-NEUMONIA DEBIDA A ESTREPTOCOCOS DEL GRUPO B ",
    "sexo": "A"
  },
  {
    "cod_dx": "J154",
    "nombre_dx": "J154-NEUMONIA DEBIDA A OTROS ESTREPTOCOCOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J155",
    "nombre_dx": "J155-NEUMONIA DEBIDA A ESCHERICHIA COLI",
    "sexo": "A"
  },
  {
    "cod_dx": "J156",
    "nombre_dx": "J156-NEUMONIA DEBIDA A OTRAS BACTERIAS AEROBICAS GRAMNEGATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J157",
    "nombre_dx": "J157-NEUMONIA DEBIDA A MYCOPLASMA PNEUMONIAE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J158",
    "nombre_dx": "J158-OTRAS NEUMONIAS BACTERIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J159",
    "nombre_dx": "J159-NEUMONIABACTERIANA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J160",
    "nombre_dx": "J160-NEUMONIA DEBIDA A CLAMIDIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J168",
    "nombre_dx": "J168-NEUMONIA DEBIDA A OTROS MICROORGANISMOS INFECCIOSOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J170",
    "nombre_dx": "J170-NEUMONIA EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J171",
    "nombre_dx": "J171-NEUMONIA EN ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J172",
    "nombre_dx": "J172-NEUMONIA EN MICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J173",
    "nombre_dx": "J173-NEUMONIA EN ENFERMEDADES PARASITARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J178",
    "nombre_dx": "J178-NEUMONIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J180",
    "nombre_dx": "J180-BRONCONEUMONIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J181",
    "nombre_dx": "J181-NEUMONÍA LOBAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J182",
    "nombre_dx": "J182-NEUMONIA HIPOSTATICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J188",
    "nombre_dx": "J188-OTRAS NEUMONIAS, DE MICROORGANISMO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "J189",
    "nombre_dx": "J189-NEUMONIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J200",
    "nombre_dx": "J200-BRONQUITIS AGUDA DEBIDA A MYCOPLASMA PNEUMONIAE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J201",
    "nombre_dx": "J201-BRONQUITIS AGUDA DEBIDA A HAEMOPHILUS INFLUENZAE",
    "sexo": "A"
  },
  {
    "cod_dx": "J202",
    "nombre_dx": "J202-BRONQUITIS AGUDA DEBIDA A ESTREPTOCOCOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J203",
    "nombre_dx": "J203-BRONQUITIS AGUDA DEBIDA A VIRUS COXSACKIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J204",
    "nombre_dx": "J204-BRONQUITIS AGUDA DEBIDA A VIRUS PARAINFLUENZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J205",
    "nombre_dx": "J205-BRONQUITIS AGUDA DEBIDA A VIRUS SINCITIAL RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "J206",
    "nombre_dx": "J206-BRONQUITIS AGUDA DEBIDA A RINOVIRUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J207",
    "nombre_dx": "J207-BRONQUITIS AGUDA DEBIDA A VIRUS ECHO",
    "sexo": "A"
  },
  {
    "cod_dx": "J208",
    "nombre_dx": "J208-BRONQUITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J209",
    "nombre_dx": "J209-BRONQUITIS AGUDA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J210",
    "nombre_dx": "J210-BRONQUIOLITIS AGUDA DEBIDA A VIRUS SINCITIAL RESPIRATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J211",
    "nombre_dx": "J211-Bronquiolitis aguda debida a metaneumovirus humano",
    "sexo": "A"
  },
  {
    "cod_dx": "J218",
    "nombre_dx": "J218-BRONQUIOLITIS AGUDA DEBIDA A OTROS MICROORGANISMOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J219",
    "nombre_dx": "J219-BRONQUIOLITIS AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J22X",
    "nombre_dx": "J22X-INFECCION AGUDA NO ESPECIFICADA DE LAS VIAS RESPIRATORIAS INFERIORES",
    "sexo": "A"
  },
  {
    "cod_dx": "J300",
    "nombre_dx": "J300-RINITIS VASOMOTORA",
    "sexo": "A"
  },
  {
    "cod_dx": "J301",
    "nombre_dx": "J301-RINITIS ALERGICA DEBIDA AL POLEN",
    "sexo": "A"
  },
  {
    "cod_dx": "J302",
    "nombre_dx": "J302-OTRA RINITIS ALERGICA ESTACIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "J303",
    "nombre_dx": "J303-OTRAS RINITIS ALERGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J304",
    "nombre_dx": "J304-RINITIS ALERGICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J310",
    "nombre_dx": "J310-RINITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J311",
    "nombre_dx": "J311-RINOFARINGITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J312",
    "nombre_dx": "J312-FARINGITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J320",
    "nombre_dx": "J320-SINUSITIS MAXILAR CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J321",
    "nombre_dx": "J321-SINUSITIS FRONTAL CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J322",
    "nombre_dx": "J322-SINUSITIS ETMOIDAL CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J323",
    "nombre_dx": "J323-SINUSITIS ESFENOIDAL CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J324",
    "nombre_dx": "J324-PANSINUSITISCRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J328",
    "nombre_dx": "J328-OTRAS SINUSITIS CRONICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J329",
    "nombre_dx": "J329-SINUSITIS CRONICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J330",
    "nombre_dx": "J330-POLIPO DE LA CAVIDAD NASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "J331",
    "nombre_dx": "J331-DEGENERACION POLIPOIDE DE SENO PARANASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "J338",
    "nombre_dx": "J338-OTROS POLIPOS DE LOS SENOS PARANASALES",
    "sexo": "A"
  },
  {
    "cod_dx": "J339",
    "nombre_dx": "J339-POLIPO NASAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J340",
    "nombre_dx": "J340-ABSCESO, FURUNCULO Y ANTRAX DE LA NARIZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "J341",
    "nombre_dx": "J341-QUISTE Y MUCOCELE DEL SENO PARANASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "J342",
    "nombre_dx": "J342-DESVIACION DEL TABIQUE NASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "J343",
    "nombre_dx": "J343-HIPERTROFIA DE LOS CORNETES NASALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J348",
    "nombre_dx": "J348-OTROS TRASTORNOS ESPECIFICADOS DE LA NARIZ Y DE LOS SENOS PARANASALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J350",
    "nombre_dx": "J350-AMIGDALITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J351",
    "nombre_dx": "J351-HIPERTROFIA DE LAS AMIGDALAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J352",
    "nombre_dx": "J352-HIPERTROFIA DE LAS ADENOIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "J353",
    "nombre_dx": "J353-HIPERTROFIA DE LAS AMIGDALAS CON HIPERTROFIADE LAS ADENOIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "J358",
    "nombre_dx": "J358-OTRAS ENFERMEDADES CRONICAS DE LAS AMIGDALAS Y DE LAS ADENOIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J359",
    "nombre_dx": "J359-ENFERMEDAD CRONICAS DE LAS AMIGDALAS Y DE LAS ADENOIDES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J36X",
    "nombre_dx": "J36X-ABSCESO PERIAMIGDALINO",
    "sexo": "A"
  },
  {
    "cod_dx": "J370",
    "nombre_dx": "J370-LARINGITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J371",
    "nombre_dx": "J371-LARINGOTRAQUEITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J380",
    "nombre_dx": "J380-PARALISIS DE LAS CUERDAS VOCALES Y DE LA LARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "J381",
    "nombre_dx": "J381-POLIPO DE LAS CUERDAS VOCALES Y DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J382",
    "nombre_dx": "J382-NODULOS DE LAS CUERDAS VOCALES",
    "sexo": "A"
  },
  {
    "cod_dx": "J383",
    "nombre_dx": "J383-OTRAS ENFERMEDADES DE LAS CUERDAS VOCALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J384",
    "nombre_dx": "J384-EDEMA DE LARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "J385",
    "nombre_dx": "J385-ESPASMO LARINGEO",
    "sexo": "A"
  },
  {
    "cod_dx": "J386",
    "nombre_dx": "J386-ESTENOSIS LARINGEA",
    "sexo": "A"
  },
  {
    "cod_dx": "J387",
    "nombre_dx": "J387-OTRAS ENFERMEDADES DE LA LARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "J390",
    "nombre_dx": "J390-ABSCESO RETROFARINGEO Y PARAFARINGEO",
    "sexo": "A"
  },
  {
    "cod_dx": "J391",
    "nombre_dx": "J391-OTROS ABSCESOS DE LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "J392",
    "nombre_dx": "J392-OTRAS ENFERMEDADES DE LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "J393",
    "nombre_dx": "J393-REACCION DE HIPERSENSIBILIDAD DE LAS VIAS RESPIRATORIAS SUPERIORES, SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J398",
    "nombre_dx": "J398-OTRAS ENFERMEDADES ESPECIFICADAS DE LAS VIAS RESPIRATORIAS SUPERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J399",
    "nombre_dx": "J399-ENFERMEDAD DE LAS VIAS RESPIRATORIAS SUPERIORES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J40X",
    "nombre_dx": "J40X-BRONQUITIS, NO ESPECIFICADA COMO AGUDA O CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J410",
    "nombre_dx": "J410-BRONQUITIS CRONICA SIMPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J411",
    "nombre_dx": "J411-BRONQUITIS CRONICA MUCOPURULENTA",
    "sexo": "A"
  },
  {
    "cod_dx": "J418",
    "nombre_dx": "J418-BRONQUITIS CRONICA MIXTA SIMPLE Y MUCOPURULENTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J42X",
    "nombre_dx": "J42X-BRONQUITIS CRONICA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J430",
    "nombre_dx": "J430-SINDROME DE MACLEOD ",
    "sexo": "A"
  },
  {
    "cod_dx": "J431",
    "nombre_dx": "J431-ENFISEMA PANLOBULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "J432",
    "nombre_dx": "J432-ENFISEMA CENTROLOBULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "J438",
    "nombre_dx": "J438-OTROS TIPOS DE ENFISEMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J439",
    "nombre_dx": "J439-ENFISEMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J440",
    "nombre_dx": "J440-ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA CON INFECCION AGUDA DE LAS VIAS RESPIRATORIAS INFERIORES",
    "sexo": "A"
  },
  {
    "cod_dx": "J441",
    "nombre_dx": "J441-ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA CON EXACERBACION AGUDA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J448",
    "nombre_dx": "J448-OTRAS ENFERMEDADES PULMONARES OBSTRUCTIVAS CRONICAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J449",
    "nombre_dx": "J449-ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J450",
    "nombre_dx": "J450-ASMAPREDOMINANTEMENTE ALERGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J451",
    "nombre_dx": "J451-ASMA NO ALERGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J458",
    "nombre_dx": "J458-ASMA MIXTA",
    "sexo": "A"
  },
  {
    "cod_dx": "J459",
    "nombre_dx": "J459-ASMA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J46X",
    "nombre_dx": "J46X-ESTADO ASMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J47X",
    "nombre_dx": "J47X-BRONQUIECTASIA",
    "sexo": "A"
  },
  {
    "cod_dx": "J60X",
    "nombre_dx": "J60X-NEUMOCONIOSIS DE LOS MINEROS DEL CARBON ",
    "sexo": "A"
  },
  {
    "cod_dx": "J61X",
    "nombre_dx": "J61X-NEUMOCONIOSIS DEBIDA AL ASBESTO Y A OTRAS FIBRAS MINERALES",
    "sexo": "A"
  },
  {
    "cod_dx": "J620",
    "nombre_dx": "J620-NEUMOCONIOSIS DEBIDA A POLVO DE TALCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J628",
    "nombre_dx": "J628-NEUMOCONIOSISDEBIDA A OTROS POLVOS QUE CONTIENEN SILICE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J630",
    "nombre_dx": "J630-ALUMINOSIS (DEL PULMON) ",
    "sexo": "A"
  },
  {
    "cod_dx": "J631",
    "nombre_dx": "J631-FIBROSIS (DEL PULMON) DEBIDA A BAUXITA",
    "sexo": "A"
  },
  {
    "cod_dx": "J632",
    "nombre_dx": "J632-BERILIOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "J633",
    "nombre_dx": "J633-FIBROSIS (DEL PULMON) DEBIDA A GRAFITO",
    "sexo": "A"
  },
  {
    "cod_dx": "J634",
    "nombre_dx": "J634-SIDEROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J635",
    "nombre_dx": "J635-ESTAÑOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J638",
    "nombre_dx": "J638-NEUMOCONIOSIS DEBIDA A OTROS POLVOS INORGANICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J64X",
    "nombre_dx": "J64X-NEUMOCONIOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J65X",
    "nombre_dx": "J65X-NEUMOCONIOSIS, ASOCIADA CON TUBERCULOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "J660",
    "nombre_dx": "J660-BISINOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J661",
    "nombre_dx": "J661-ENFERMEDAD DE LOS TRABAJADORES DEL LINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J662",
    "nombre_dx": "J662-CANABINOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J668",
    "nombre_dx": "J668-ENFERMEDAD DE LAS VIAS AEREAS DEBIDAS A OTROS POLVOS ORGANICOS ESPECIFICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J670",
    "nombre_dx": "J670-PULMON DEL GRANJERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J671",
    "nombre_dx": "J671-BAGAZOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J672",
    "nombre_dx": "J672-PULMON DEL ORNITOFILO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J673",
    "nombre_dx": "J673-SUBEROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J674",
    "nombre_dx": "J674-PULMON DEL MANIPULADOR DE MALTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J675",
    "nombre_dx": "J675-PULMON DEL MANIPULADOR DE HONGOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J676",
    "nombre_dx": "J676-PULMON DEL DESCORTEZADOR DEL ARCE ",
    "sexo": "A"
  },
  {
    "cod_dx": "J677",
    "nombre_dx": "J677-NEUMONITIS DE LA VENTILACION DEBIDA AL ACONDICIONADOR Y HUMIDIFICADOR DEL AIRE",
    "sexo": "A"
  },
  {
    "cod_dx": "J678",
    "nombre_dx": "J678-NEUMONITIS DEBIDAA HIPERSENSIBILIDAD A OTROS POLVOS ORGANICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J679",
    "nombre_dx": "J679-NEUMONITIS DEBIDAA HIPERSENSIBILIDAD APOLVO ORGANICO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "J680",
    "nombre_dx": "J680-BRONQUITIS Y NEUMONITIS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J681",
    "nombre_dx": "J681-EDEMA PULMONAR AGUDO DEBIDO A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J682",
    "nombre_dx": "J682-INFLAMACION RESPIRATORIA SUPERIOR DEBIDA A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J683",
    "nombre_dx": "J683-OTRAS AFECCIONES RESPIRATORIAS AGUDAS Y SUBAGUDAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "J684",
    "nombre_dx": "J684-AFECCIONES RESPIRATORIAS CRONICAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J688",
    "nombre_dx": "J688-OTRAS AFECCIONES RESPIRATORIAS DEBIDAS A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUIMICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J689",
    "nombre_dx": "J689-AFECCION RESPIRATORIA NO ESPECIFICADA, DEBIDA A INHALACION DE GASES, HUMOS, VAPORES Y SUSTANCIAS QUI",
    "sexo": "A"
  },
  {
    "cod_dx": "J690",
    "nombre_dx": "J690-NEUMONITIS DEBIDA A ASPIRACION DE ALIMENTO O VOMITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J691",
    "nombre_dx": "J691-NEUMONITIS DEBIDA A ASPIRACION DE ACEITES Y ESENCIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J698",
    "nombre_dx": "J698-NEUMONITIS DEBIDA A ASPIRACION DE OTROS SOLIDOS Y LIQUIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J700",
    "nombre_dx": "J700-MANIFESTACIONES PULMONARES AGUDAS DEBIDAS A RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "J701",
    "nombre_dx": "J701-MANIFESTACIONES PULMONARES CRONICAS Y OTRAS MANIFESTACIONES DEBIDAS A RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "J702",
    "nombre_dx": "J702-TRASTORNOS PULMONARES INTERSTICIALES AGUDOS INDUCIDOS POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J703",
    "nombre_dx": "J703-TRASTORNOS PULMONARES INTERSTICIALES CRONICOS INDUCIDOS POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J704",
    "nombre_dx": "J704-TRASTORNOS PULMONARES INTERSTICIALES NO ESPECIFICADOS INDUCIDOS POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J708",
    "nombre_dx": "J708-AFECCIONES RESPIRATORIAS DEBIDAS A OTROS AGENTES EXTERNOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J709",
    "nombre_dx": "J709-AFECCIONES RESPIRATORIAS DEBIDAS A AGENTES EXTERNOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J80X",
    "nombre_dx": "J80X-ENFERMEDAD PULMONAR OBSTRUCTIVA CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J81X",
    "nombre_dx": "J81X-EDEMA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "J82X",
    "nombre_dx": "J82X-EOSINOFILIA PULMONAR, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "J840",
    "nombre_dx": "J840-AFECCIONES ALVEOLARES Y ALVEOLOPARIETALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "J841",
    "nombre_dx": "J841-OTRAS ENFERMEDADES PULMONARES INTERSTICIALES CON FIBROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J848",
    "nombre_dx": "J848-OTRAS ENFERMEDADES PULMONARES INTERSTICIALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "J849",
    "nombre_dx": "J849-ENFERMEDAD PULMONAR INTERSTICIAL, NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "J850",
    "nombre_dx": "J850-GANGRENA Y NECROSIS DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "J851",
    "nombre_dx": "J851-ABSCESO DEL PULMON CON NEUMONIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J852",
    "nombre_dx": "J852-ABSCESO DEL PULMON SIN NEUMONIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J853",
    "nombre_dx": "J853-ABSCESO DEL MEDIASTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "J860",
    "nombre_dx": "J860-PIOTORAX CON FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "J869",
    "nombre_dx": "J869-PIOTORAX SIN FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "J90X",
    "nombre_dx": "J90X-DERRAME PLEURAL NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "J91X",
    "nombre_dx": "J91X-DERRAME PLEURAL EN AFECCIONES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "J920",
    "nombre_dx": "J920-PAQUIPLEURITIS CON ASBESTOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J929",
    "nombre_dx": "J929-PAQUIPLEURITIS SIN ASBESTOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J930",
    "nombre_dx": "J930-NEUMOTORAX ESPONTANEO A PRESION ",
    "sexo": "A"
  },
  {
    "cod_dx": "J931",
    "nombre_dx": "J931-OTROS TIPOS DE NEUMOTORAX ESPONTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "J938",
    "nombre_dx": "J938-OTROS NEUMOTORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "J939",
    "nombre_dx": "J939-NEUMOTORAX, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J940",
    "nombre_dx": "J940-QUILOTORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "J941",
    "nombre_dx": "J941-FIBROTORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "J942",
    "nombre_dx": "J942-HEMOTORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "J948",
    "nombre_dx": "J948-OTRAS AFECCIONES ESPECIFICADAS DE LA PLEURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J949",
    "nombre_dx": "J949-AFECCION PLEURAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J950",
    "nombre_dx": "J950-FUNCIONAMIENTO DEFECTUOSO DE LA TRAQUEOSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J951",
    "nombre_dx": "J951-INSUFICIENCIA PULMONAR AGUDA CONSECUTIVA A CIRUGIA TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J952",
    "nombre_dx": "J952-INSUFICIENCIA PULMONAR AGUDA CONSECUTIVA A CIRUGIA EXTRATORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J953",
    "nombre_dx": "J953-INSUFICIENCIA PULMONAR CRONICA CONSECUTIVA A CIRUGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "J954",
    "nombre_dx": "J954-SINDROME DE MENDELSON ",
    "sexo": "A"
  },
  {
    "cod_dx": "J955",
    "nombre_dx": "J955-ESTENOSIS SUBGLOTICA CONSECUTIVA A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "J958",
    "nombre_dx": "J958-OTROS TRASTORNOS RESPIRATORIOS CONSECUTIVOS A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J959",
    "nombre_dx": "J959-TRASTORNO NO ESPECIFICADO DEL SISTEMARESPIRATORIO, CONSECUTIVOS A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J960",
    "nombre_dx": "J960-INSUFICIENCIA RESPIRATORIA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "J961",
    "nombre_dx": "J961-INSUFICIENCIA RESPIRATORIA CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "J969",
    "nombre_dx": "J969-INSUFICIENCIA RESPIRATORIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "J980",
    "nombre_dx": "J980-ENFERMEDADES DE LA TRAQUEA Y DE LOS BRONQUIOS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "J981",
    "nombre_dx": "J981-COLAPSO PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "J982",
    "nombre_dx": "J982-ENFISEMA INTERSTICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "J983",
    "nombre_dx": "J983-ENFISEMA COMPENSATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "J984",
    "nombre_dx": "J984-OTROS TRASTORNOS DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "J985",
    "nombre_dx": "J985-ENFERMEDADES DEL MEDIASTINO, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "J986",
    "nombre_dx": "J986-TRASTORNOS DEL DIAFRAGMA",
    "sexo": "A"
  },
  {
    "cod_dx": "J987",
    "nombre_dx": "J987-Infecciones respiratorias, no clasificadas en otra parte",
    "sexo": "A"
  },
  {
    "cod_dx": "J988",
    "nombre_dx": "J988-OTROS TRASTORNOS RESPIRATORIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "J989",
    "nombre_dx": "J989-TRASTORNO RESPIRATORIO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "J990",
    "nombre_dx": "J990-ENFERMEDAD PULMONAR REUMATOIDE (M05.1+)",
    "sexo": "A"
  },
  {
    "cod_dx": "J991",
    "nombre_dx": "J991-TRASTORNOS RESPIRATORIOS EN OTROS TRASTORNOS DIFUSOS DEL TEJIDO CONJUNTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "J998",
    "nombre_dx": "J998-TRASTORNOS RESPIRATORIOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K000",
    "nombre_dx": "K000-ANODONCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K001",
    "nombre_dx": "K001-DIENTES SUPERNUMERARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K002",
    "nombre_dx": "K002-ANOMALIAS DEL TAMAÑO Y DE LA FORMA DEL DIENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K003",
    "nombre_dx": "K003-DIENTES MOTEADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K004",
    "nombre_dx": "K004-ALTERACIONES EN LA FORMACION DENTARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K005",
    "nombre_dx": "K005-ALTERACIONES HEREDITARIAS DE LA ESTRUCTURA DENTARIA, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K006",
    "nombre_dx": "K006-ALTERACIONES EN LA ERUPCION DENTARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K007",
    "nombre_dx": "K007-SINDROME DE LA ERUPCION DENTARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K008",
    "nombre_dx": "K008-OTROS TRASTORNOS DEL DESARROLLO DE LOS DIENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "K009",
    "nombre_dx": "K009-TRASTORNO DEL DESARROLLO DE LOS DIENTES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K010",
    "nombre_dx": "K010-DIENTES INCLUIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K011",
    "nombre_dx": "K011-DIENTES IMPACTADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K020",
    "nombre_dx": "K020-CARIES LIMITADA AL ESMALTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K021",
    "nombre_dx": "K021-CARIES DE LA DENTINA",
    "sexo": "A"
  },
  {
    "cod_dx": "K022",
    "nombre_dx": "K022-CARIES DEL CEMENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "K023",
    "nombre_dx": "K023-CARIES DENTARIA DETENIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K024",
    "nombre_dx": "K024-ODONTOCLASIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K025",
    "nombre_dx": "K025-Caries con exposición pulpar",
    "sexo": "A"
  },
  {
    "cod_dx": "K028",
    "nombre_dx": "K028-OTRAS CARIES DENTALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K029",
    "nombre_dx": "K029-CARIES DENTAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K030",
    "nombre_dx": "K030-ATRICION EXCESIVA DE LOS DIENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "K031",
    "nombre_dx": "K031-ABRASION DE LOS DIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K032",
    "nombre_dx": "K032-EROSION DE LOS DIENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "K033",
    "nombre_dx": "K033-REABSORCION PATOLOGICA DE LOS DIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K034",
    "nombre_dx": "K034-HIPERCEMENTOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K035",
    "nombre_dx": "K035-ANQUILOSIS DENTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K036",
    "nombre_dx": "K036-DEPOSITOS [ACRECIONES] EN LOS DIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K037",
    "nombre_dx": "K037-CAMBIOS POSTERUPTIVOS DEL COLOR DE LOS TEJIDOS DENTALES DUROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K038",
    "nombre_dx": "K038-OTRAS ENFERMEDADES ESPECIFICADAS DE LOS TEJIDOS DUROS DE LOS DIENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "K039",
    "nombre_dx": "K039-ENFERMEDAD NO ESPECIFICADA DE LOS TEJIDOS DENTALES DUROS",
    "sexo": "A"
  },
  {
    "cod_dx": "K040",
    "nombre_dx": "K040-PULPITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K041",
    "nombre_dx": "K041-NECROSIS DE LA PULPA",
    "sexo": "A"
  },
  {
    "cod_dx": "K042",
    "nombre_dx": "K042-DEGENERACION DE LA PULPA",
    "sexo": "A"
  },
  {
    "cod_dx": "K043",
    "nombre_dx": "K043-FORMACION ANORMAL DE TEJIDO DURO EN LA PULPA",
    "sexo": "A"
  },
  {
    "cod_dx": "K044",
    "nombre_dx": "K044-PERIODONTITIS APICAL AGUDA ORIGINADA EN LA PULPA",
    "sexo": "A"
  },
  {
    "cod_dx": "K045",
    "nombre_dx": "K045-PERIODONTITIS APICAL CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K046",
    "nombre_dx": "K046-ABSCESO PERIAPICAL CON FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "K047",
    "nombre_dx": "K047-ABSCESO PERIAPICAL SIN FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "K048",
    "nombre_dx": "K048-QUISTE RADICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K049",
    "nombre_dx": "K049-OTRAS ENFERMEDADES Y LAS NO ESPECIFICADAS DE LA PULPA Y DEL TEJIDO PERIAPICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K050",
    "nombre_dx": "K050-GINGIVITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K051",
    "nombre_dx": "K051-GINGIVITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K052",
    "nombre_dx": "K052-PERIODONTITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K053",
    "nombre_dx": "K053-PERIODONTITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K054",
    "nombre_dx": "K054-PERIODONTOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K055",
    "nombre_dx": "K055-OTRAS ENFERMEDADES PERIODONTALES",
    "sexo": "A"
  },
  {
    "cod_dx": "K056",
    "nombre_dx": "K056-ENFERMEDAD DE PERIODONTO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K060",
    "nombre_dx": "K060-RETRACCION GINGIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K061",
    "nombre_dx": "K061-HIPERPLASIA GINGIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K062",
    "nombre_dx": "K062-LESIONES DE LA ENCIA Y DE LA ZONA EDENTULA ASOCIADAS CON TRAUMATISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "K068",
    "nombre_dx": "K068-OTROS TRASTORNOS ESPECIFICADOS DE LA ENCIA Y DE LA ZONA EDENTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "K069",
    "nombre_dx": "K069-TRASTORNO NO ESPECIFICADO DE LA ENCIA Y DE LA ZONA EDENTULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K070",
    "nombre_dx": "K070-ANOMALIAS EVIDENTES DEL TAMAÑO DE LOS MAXILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K071",
    "nombre_dx": "K071-ANOMALIAS DE LA RELACION MAXILOBASILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K072",
    "nombre_dx": "K072-ANOMALIAS DE LA RELACION ENTRE LOS ARCOS DENTARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K073",
    "nombre_dx": "K073-ANOMALIAS DE LA POSICION DEL DIENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K074",
    "nombre_dx": "K074-MALOCLUSION DE TIPO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K075",
    "nombre_dx": "K075-ANOMALIAS DENTOFACIALES FUNCIONALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K076",
    "nombre_dx": "K076-TRASTORNOS DE LA ARTICULACION TEMPOROMAXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K078",
    "nombre_dx": "K078-OTRAS ANOMALIAS DENTOFACIALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K079",
    "nombre_dx": "K079-ANOMALIA DENTOFACIAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K080",
    "nombre_dx": "K080-EXFOLIACION DE LOS DIENTES DEBIDA A CAUSAS SISTEMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K081",
    "nombre_dx": "K081-PERDIDA DE DIENTES DEBIDA A ACCIDENTE, EXTRACCION O ENFERMEDAD PERIODONTAL LOCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K082",
    "nombre_dx": "K082-ATROFIA DE REBORDE ALVEOLAR DESDENTADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K083",
    "nombre_dx": "K083-RAIZ DENTAL RETENIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K088",
    "nombre_dx": "K088-OTRAS AFECCIONES ESPECIFICADAS DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN",
    "sexo": "A"
  },
  {
    "cod_dx": "K089",
    "nombre_dx": "K089-TRASTORNO DE LOS DIENTES Y DE SUS ESTRUCTURAS DE SOSTEN, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K090",
    "nombre_dx": "K090-QUISTES ORIGINADOS POR EL DESARROLLO DE LOS DIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K091",
    "nombre_dx": "K091-Quistes de las fisuras de la región oral (no odontogénicos)",
    "sexo": "A"
  },
  {
    "cod_dx": "K092",
    "nombre_dx": "K092-OTROS QUISTES DE LOS MAXILARES",
    "sexo": "A"
  },
  {
    "cod_dx": "K098",
    "nombre_dx": "K098-OTROS QUISTES DE LA REGION BUCAL, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K099",
    "nombre_dx": "K099-QUISTE DE LA REGION BUCAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K100",
    "nombre_dx": "K100-TRASTORNOS DEL DESARROLLO DE LOS MAXILARES",
    "sexo": "A"
  },
  {
    "cod_dx": "K101",
    "nombre_dx": "K101-GRANULOMA CENTRAL DE CELULAS GIGANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K102",
    "nombre_dx": "K102-AFECCIONES INFLAMATORIAS DE LOS MAXILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K103",
    "nombre_dx": "K103-ALVEOLITIS DEL MAXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K108",
    "nombre_dx": "K108-OTRAS ENFERMEDADES ESPECIFICADAS DE LOS MAXILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K109",
    "nombre_dx": "K109-ENFERMEDAD DE LOS MAXILARES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K110",
    "nombre_dx": "K110-ATROFIA DE GLANDULA SALIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K111",
    "nombre_dx": "K111-HIPERTROFIA DE GLANDULA SALIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K112",
    "nombre_dx": "K112-SIALADENITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K113",
    "nombre_dx": "K113-ABSCESO DE GLANDULA SALIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K114",
    "nombre_dx": "K114-FISTULA DE GLANDULA SALIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K115",
    "nombre_dx": "K115-SIALOLITIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K116",
    "nombre_dx": "K116-MUCOCELE DE GLANDULA SALIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K117",
    "nombre_dx": "K117-ALTERACIONES DE LA SECRECION SALIVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K118",
    "nombre_dx": "K118-OTRAS ENFERMEDADES DE LAS GLANDULAS SALIVALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K119",
    "nombre_dx": "K119-ENFERMEDAD DE GLANDULA SALIVAL. NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K120",
    "nombre_dx": "K120-ESTOMATITIS AFTOSA RECURRENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K121",
    "nombre_dx": "K121-OTRAS FORMAS DE ESTOMATITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K122",
    "nombre_dx": "K122-CELULITIS Y ABSCESO DE BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K123",
    "nombre_dx": "K123-Mucositis oral (ulcerativa)",
    "sexo": "A"
  },
  {
    "cod_dx": "K130",
    "nombre_dx": "K130-ENFERMEDADES DE LOS LABIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K131",
    "nombre_dx": "K131-MORDEDURA DEL LABIO Y DE LA MEJILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K132",
    "nombre_dx": "K132-LEUCOPLASIA Y OTRAS ALTERACIONES DEL EPITELIO BUCAL, INCLUYENDO LA LENGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K133",
    "nombre_dx": "K133-LEUCOPLASIA PILOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "K134",
    "nombre_dx": "K134-GRANULOMA Y LESIONES SEMEJANTES DE LA MUCOSA BUCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K135",
    "nombre_dx": "K135-FIBROSIS DE LA SUBMUCOSA BUCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K136",
    "nombre_dx": "K136-HIPERPLASIA IRRITATIVA DE LA MUCOSA BUCAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K137",
    "nombre_dx": "K137-OTRAS LESIONES Y LAS NO ESPECIFICADAS DE LA MUCOSA BUCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K140",
    "nombre_dx": "K140-GLOSITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K141",
    "nombre_dx": "K141-LENGUA GEOGRAFICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K142",
    "nombre_dx": "K142-GLOSITIS ROMBOIDEA MEDIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "K143",
    "nombre_dx": "K143-HIPERTROFIA DE LAS PAPILAS LINGUALES",
    "sexo": "A"
  },
  {
    "cod_dx": "K144",
    "nombre_dx": "K144-ATROFIA DE LAS PAPILAS LINGUALES",
    "sexo": "A"
  },
  {
    "cod_dx": "K145",
    "nombre_dx": "K145-LENGUA PLEGADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K146",
    "nombre_dx": "K146-GLOSODINIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K148",
    "nombre_dx": "K148-OTRAS ENFERMEDADES DE LA LENGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K149",
    "nombre_dx": "K149-ENFERMEDAD DE LA LENGUA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K20X",
    "nombre_dx": "K20X-ESOFAGITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K210",
    "nombre_dx": "K210-ENFERMEDAD DEL REFLUJO GASTROESOFAGICO CON ESOFAGITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K219",
    "nombre_dx": "K219-ENFERMEDAD DEL REFLUJO GASTROESOFAGICO SINESOFAGITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K220",
    "nombre_dx": "K220-ACALASIA DEL CARDIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K221",
    "nombre_dx": "K221-ULCERA DEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "K222",
    "nombre_dx": "K222-OBSTRUCCION DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K223",
    "nombre_dx": "K223-PERFORACION DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K224",
    "nombre_dx": "K224-DISQUINESIA DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K225",
    "nombre_dx": "K225-DIVERTICULO DEL ESOFAGO, ADQUIRIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "K226",
    "nombre_dx": "K226-SINDROME DE LACERACION Y HEMORRAGIA GASTROESOFAGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K228",
    "nombre_dx": "K228-OTRAS ENFERMEDADES ESPECIFICADAS DEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "K229",
    "nombre_dx": "K229-ENFERMEDAD DEL ESOFAGO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K230",
    "nombre_dx": "K230-ESOFAGITIS TUBERCULOSA (A18.+)",
    "sexo": "A"
  },
  {
    "cod_dx": "K231",
    "nombre_dx": "K231-MEGAESOFAGO EN LA ENFERMEDAD DE CHAGAS (B57.3+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K238",
    "nombre_dx": "K238-TRASTORNOS DEL ESOFAGO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K250",
    "nombre_dx": "K250-ULCERA GASTRICA AGUDA CON HEMORRAGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K251",
    "nombre_dx": "K251-ULCERA GASTRICA AGUDA CON PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K252",
    "nombre_dx": "K252-ULCERA GASTRICA AGUDA CON HEMORRAGIA Y PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K253",
    "nombre_dx": "K253-ULCERA GASTRICA AGUDA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K254",
    "nombre_dx": "K254-ULCERA GASTRICA CRONICA O NO ESPECIFICADA, CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K255",
    "nombre_dx": "K255-ULCERA GASTRICA CRONICA O NO ESPECIFICADA, CON PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K256",
    "nombre_dx": "K256-ULCERA GASTRICA CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K257",
    "nombre_dx": "K257-ULCERA GASTRICA CRONICA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K259",
    "nombre_dx": "K259-ULCERA GASTRICA NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIANI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K260",
    "nombre_dx": "K260-ULCERA DUODENAL AGUDA CON HEMORRAGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K261",
    "nombre_dx": "K261-ULCERA DUODENAL AGUDA CON PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K262",
    "nombre_dx": "K262-ULCERA DUODENAL AGUDA CON HEMORRAGIA Y PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K263",
    "nombre_dx": "K263-ULCERA DUODENAL AGUDA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K264",
    "nombre_dx": "K264-ULCERA DUODENAL CRONICA O NO ESPECIFICADA, CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K265",
    "nombre_dx": "K265-ULCERA DUODENAL CRONICA O NO ESPECIFICADA, CON PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K266",
    "nombre_dx": "K266-ULCERA DUODENAL CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K267",
    "nombre_dx": "K267-ULCERA DUODENAL CRONICA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K269",
    "nombre_dx": "K269-ULCERA DUODENAL NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIANI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K270",
    "nombre_dx": "K270-ULCERA PEPTICA, DE SITIO NO ESPECIFICADO AGUDA CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K271",
    "nombre_dx": "K271-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOAGUDA CON PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K272",
    "nombre_dx": "K272-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOAGUDA CON HEMORRAGIA Y PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K273",
    "nombre_dx": "K273-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOAGUDA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K274",
    "nombre_dx": "K274-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOCRONICA O NO ESPECIFICADA, CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K275",
    "nombre_dx": "K275-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOCRONICA O NO ESPECIFICADA, CON PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K276",
    "nombre_dx": "K276-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOCRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K277",
    "nombre_dx": "K277-ULCERA PEPTICA, DE SITIO NO ESPECIFICADOCRONICA SIN HEMORRAGIA NI PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K279",
    "nombre_dx": "K279-ULCERA PEPTICA, DE SITIO NO ESPECIFICADONO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIANI ",
    "sexo": "A"
  },
  {
    "cod_dx": "K280",
    "nombre_dx": "K280-ULCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K281",
    "nombre_dx": "K281-ULCERA GASTROYEYUNAL AGUDA CON PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K282",
    "nombre_dx": "K282-ULCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA Y PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K283",
    "nombre_dx": "K283-ULCERA GASTROYEYUNAL AGUDA SIN HEMORRAGIA NI PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K284",
    "nombre_dx": "K284-ULCERA GASTROYEYUNAL CRONICA O NO ESPECIFICADA, CON HEMORRAGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K285",
    "nombre_dx": "K285-ULCERA GASTROYEYUNAL CRONICA O NO ESPECIFICADA, CON PERFORACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K286",
    "nombre_dx": "K286-ULCERA GASTROYEYUNAL CRONICA O NO ESPECIFICADA, CON HEMORRAGIA Y PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K287",
    "nombre_dx": "K287-ULCERA GASTROYEYUNAL CRONICA SIN HEMORRAGIA NI PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K289",
    "nombre_dx": "K289-ULCERA GASTROYEYUNAL NO ESPECIFICADA COMO AGUDA NI CRONICA, SIN HEMORRAGIANI PERFORACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K290",
    "nombre_dx": "K290-GASTRITIS AGUDA HEMORRAGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K291",
    "nombre_dx": "K291-OTRAS GASTRITIS AGUDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K292",
    "nombre_dx": "K292-GASTRITIS ALCOHOLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K293",
    "nombre_dx": "K293-GASTRITIS CRONICA SUPERFICIAL.",
    "sexo": "A"
  },
  {
    "cod_dx": "K294",
    "nombre_dx": "K294-GASTRITIS CRONICA ATROFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K295",
    "nombre_dx": "K295-GASTRITIS CRONICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K296",
    "nombre_dx": "K296-OTRAS GASTRITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K297",
    "nombre_dx": "K297-GASTRITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K298",
    "nombre_dx": "K298-DUODENITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K299",
    "nombre_dx": "K299-GASTRODUODENITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K30X",
    "nombre_dx": "K30X-Dispepsia funcional",
    "sexo": "A"
  },
  {
    "cod_dx": "K310",
    "nombre_dx": "K310-DILATACION AGUDA DEL ESTOMAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K311",
    "nombre_dx": "K311-ESTENOSIS PILORICA HIPERTROFICA DEL ADULTO",
    "sexo": "A"
  },
  {
    "cod_dx": "K312",
    "nombre_dx": "K312-ESTRECHEZ O ESTENOSIS DEL ESTOMAGO EN RELOJ DE ARENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K313",
    "nombre_dx": "K313-ESPASMO DEL PILORO, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K314",
    "nombre_dx": "K314-DIVERTICULO GASTRICO",
    "sexo": "A"
  },
  {
    "cod_dx": "K315",
    "nombre_dx": "K315-OBSTRUCCION DEL DUODENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K316",
    "nombre_dx": "K316-FISTULA DEL ESTOMAGO Y DEL DUODENO",
    "sexo": "A"
  },
  {
    "cod_dx": "K317",
    "nombre_dx": "K317-POLIPO DEL ESTOMAGO Y DEL DUODENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K318",
    "nombre_dx": "K318-OTRAS ENFERMEDADES ESPECIFICADAS DEL ESTOMAGO Y DEL DUODENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K319",
    "nombre_dx": "K319-ENFERMEDAD DEL ESTOMAGO Y DEL DUODENO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K352",
    "nombre_dx": "K352-Apendicitis aguda con peritonitis generalizada",
    "sexo": "A"
  },
  {
    "cod_dx": "K353",
    "nombre_dx": "K353-Apendicitis aguda con peritonitis localizada",
    "sexo": "A"
  },
  {
    "cod_dx": "K358",
    "nombre_dx": "K358-Otras apendicitis agudas, y las no especificadas",
    "sexo": "A"
  },
  {
    "cod_dx": "K36X",
    "nombre_dx": "K36X-OTROS TIPOS DE APENDICITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K37X",
    "nombre_dx": "K37X-APENDICITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K380",
    "nombre_dx": "K380-HIPERPLASIA DEL APENDICE",
    "sexo": "A"
  },
  {
    "cod_dx": "K381",
    "nombre_dx": "K381-CONCRECIONES APENDICULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "K382",
    "nombre_dx": "K382-DIVERTICULO DEL APENDICE",
    "sexo": "A"
  },
  {
    "cod_dx": "K383",
    "nombre_dx": "K383-FISTULA DEL APENDICE",
    "sexo": "A"
  },
  {
    "cod_dx": "K388",
    "nombre_dx": "K388-OTRAS ENFERMEDADES ESPECIFICADAS DEL APENDICE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K389",
    "nombre_dx": "K389-ENFERMEDAD DEL APENDICE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K400",
    "nombre_dx": "K400-HERNIA INGUINAL BILATERAL CON OBSTRUCCION, SIN GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K401",
    "nombre_dx": "K401-HERNIA INGUINAL BILATERAL CON GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K402",
    "nombre_dx": "K402-HERNIA INGUINAL BILATERAL,SIN OBSTRUCCION NI GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K403",
    "nombre_dx": "K403-HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K404",
    "nombre_dx": "K404-HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, CON GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K409",
    "nombre_dx": "K409-HERNIA INGUINAL UNILATERAL O NO ESPECIFICADA, SIN OBSTRUCION NI GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K410",
    "nombre_dx": "K410-HERNIA FEMORAL BILATERAL, CON OBSTRUCCION, SIN GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K411",
    "nombre_dx": "K411-HERNIA FEMORAL BILATERAL, CON GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K412",
    "nombre_dx": "K412-HERNIA FEMORAL BILATERAL, SIN OBSTRUCCION NI GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K413",
    "nombre_dx": "K413-HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K414",
    "nombre_dx": "K414-HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, CON GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K419",
    "nombre_dx": "K419-HERNIA FEMORAL UNILATERAL O NO ESPECIFICADA, SIN OBSTRUCCION NI GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K420",
    "nombre_dx": "K420-HERNIA UMBILICAL CON OBSTRUCCION, SIN GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K421",
    "nombre_dx": "K421-HERNIA UMBILICAL CON GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K429",
    "nombre_dx": "K429-HERNIA UMBILICAL SIN OBSTRUCCION NI GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K430",
    "nombre_dx": "K430-Hernia incisional con obstrucción, sin gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K431",
    "nombre_dx": "K431-Hernia incisional con gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K432",
    "nombre_dx": "K432-Hernia incisional sin obstrucción o gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K433",
    "nombre_dx": "K433-Hernia paraestomal con obstrucción, sin gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K434",
    "nombre_dx": "K434-Hernia paraestomal con gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K435",
    "nombre_dx": "K435-Hernia paraestomal sin obstrucción o gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K436",
    "nombre_dx": "K436-Otras hernias ventrales y las no especificadas con obstrucción, sin gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K437",
    "nombre_dx": "K437-Otras hernias ventrales y las no especificadas con gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K439",
    "nombre_dx": "K439-Otras hernias ventrales y las no especificadas sin obstrucción o gangrena",
    "sexo": "A"
  },
  {
    "cod_dx": "K440",
    "nombre_dx": "K440-HERNIA DIAFRAGMATICA CON OBSTRUCCION, SIN GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K441",
    "nombre_dx": "K441-HERNIA DIAFRAGMATICA CON GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K449",
    "nombre_dx": "K449-HERNIA DIAFRAGMATICA SIN OBSTRUCCIÓN NI GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K450",
    "nombre_dx": "K450-OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, CON OBSTRUCCION, SIN GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K451",
    "nombre_dx": "K451-OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, CON GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K458",
    "nombre_dx": "K458-OTRAS HERNIAS DE LA CAVIDAD ABDOMINAL ESPECIFICADAS, SIN OBSTRUCCION NI GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K460",
    "nombre_dx": "K460-HERNIA ABDOMINAL NO ESPECIFICADA, CON OBSTRUCCION, SIN GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K461",
    "nombre_dx": "K461-HERNIA ABDOMINAL NO ESPECIFICADA, CON GANGRENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K469",
    "nombre_dx": "K469-HERNIA ABDOMINAL NO ESPECIFICADA, SIN OBSTRUCCION NI GANGRENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K500",
    "nombre_dx": "K500-ENFERMEDAD DE CROHN DEL INTESTINO DELGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K501",
    "nombre_dx": "K501-ENFERMEDAD DE CROHN DEL INTESTINO GRUESO",
    "sexo": "A"
  },
  {
    "cod_dx": "K508",
    "nombre_dx": "K508-OTROS TIPOS DE ENFERMEDAD DE CROHN",
    "sexo": "A"
  },
  {
    "cod_dx": "K509",
    "nombre_dx": "K509-ENFERMEDAD DE CROHN, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K510",
    "nombre_dx": "K510-Pancolitis ulcerativa (crónica) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K512",
    "nombre_dx": "K512-PROCTITIS (CRONICA) ULCERATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "K513",
    "nombre_dx": "K513-RECTOSIGMOIDITIS (CRONICA) ULCERATIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K514",
    "nombre_dx": "K514-Pólipos inflamatorios",
    "sexo": "A"
  },
  {
    "cod_dx": "K515",
    "nombre_dx": "K515-Colitis del lado izquierdo",
    "sexo": "A"
  },
  {
    "cod_dx": "K518",
    "nombre_dx": "K518-OTRAS COLITIS ULCERATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K519",
    "nombre_dx": "K519-COLITIS ULCERATIVA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K520",
    "nombre_dx": "K520-COLITIS Y GASTROENTERITIS DEBIDAS A RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K521",
    "nombre_dx": "K521-COLITIS Y GASTROENTERITISTOXICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K522",
    "nombre_dx": "K522-COLITIS Y GASTROENTERITIS ALERGICAS Y DIETETICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K523",
    "nombre_dx": "K523-Colitis de etiología indeterminada",
    "sexo": "A"
  },
  {
    "cod_dx": "K528",
    "nombre_dx": "K528-OTRAS COLITIS Y GASTROENTERITIS NO INFECCIOSAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K529",
    "nombre_dx": "K529-COLITIS Y GASTROENTERITIS NO INFECCIOSAS, NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K550",
    "nombre_dx": "K550-TRASTORNO VASCULAR AGUDO DE LOS INTESTINOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K551",
    "nombre_dx": "K551-TRASTORNO VASCULAR CRONICO DEL INTESTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "K552",
    "nombre_dx": "K552-ANGIODISPLASIA DEL COLON",
    "sexo": "A"
  },
  {
    "cod_dx": "K558",
    "nombre_dx": "K558-OTROS TRASTORNOS VASCULARES DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K559",
    "nombre_dx": "K559-TRASTORNO VASCULAR DEL INTESTINO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K560",
    "nombre_dx": "K560-ILEO PARALITICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K561",
    "nombre_dx": "K561-INVAGINACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K562",
    "nombre_dx": "K562-VOLVULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K563",
    "nombre_dx": "K563-ILEO POR CALCULO BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K564",
    "nombre_dx": "K564-OTRAS OBSTRUCCIONES DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K565",
    "nombre_dx": "K565-ADHERENCIAS [BRIDAS] INTESTINALES CON OBSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K566",
    "nombre_dx": "K566-OTRAS OBSTRUCCIONES INTESTINALES Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K567",
    "nombre_dx": "K567-ILEO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K570",
    "nombre_dx": "K570-ENFERMEDAD DIVERTICULAR DEL INTESTINO DELGADO CON PERFORACION Y ABSCESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K571",
    "nombre_dx": "K571-ENFERMEDAD DIVERTICULAR DEL INTESTINO DELGADO SIN PERFORACION NI ABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "K572",
    "nombre_dx": "K572-ENFERMEDAD DIVERTICULAR DEL INTESTINO GRUESO CON PERFORACION Y ABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "K573",
    "nombre_dx": "K573-ENFERMEDAD DIVERTICULAR DEL INTESTINO GRUESO SIN PERFORACION NI ABSCESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K574",
    "nombre_dx": "K574-ENFERMEDAD DIVERTICULAR DE AMBOS INTESTINOS CON PERFORACION Y ABSCESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K575",
    "nombre_dx": "K575-ENFERMEDAD DIVERTICULAR DE AMBOS INTESTINOS, SIN PERFORACION NI ABSCESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K578",
    "nombre_dx": "K578-ENFERMEDAD DIVERTICULAR DEL INTESTINO, PARTE NO ESPECIFICADA, CON PERFORACION YABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "K579",
    "nombre_dx": "K579-ENFERMEDAD DIVERTICULAR DEL INTESTINO, PARTE NO ESPECIFICADA, SIN PERFORACION NI ABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "K581",
    "nombre_dx": "K581-Síndrome decolon irritablecon predominio de diarrea [IBS-D]",
    "sexo": "A"
  },
  {
    "cod_dx": "K582",
    "nombre_dx": "K582-Síndrome de colon irritable con predominio de constipación [IBS-C]",
    "sexo": "A"
  },
  {
    "cod_dx": "K583",
    "nombre_dx": "K583-Síndrome de colon irrtable con hábito Intestinal Mixto [IBS-M]",
    "sexo": "A"
  },
  {
    "cod_dx": "K588",
    "nombre_dx": "K588-Otros síndromes de colon irritable y los no especificados",
    "sexo": "A"
  },
  {
    "cod_dx": "K590",
    "nombre_dx": "K590-CONSTIPACION",
    "sexo": "A"
  },
  {
    "cod_dx": "K591",
    "nombre_dx": "K591-DIARREA FUNCIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K592",
    "nombre_dx": "K592-INTESTINO NEUROGENICO, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K593",
    "nombre_dx": "K593-MEGACOLON, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K594",
    "nombre_dx": "K594-ESPASMO ANAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K598",
    "nombre_dx": "K598-OTROS TRASTORNOS FUNCIONALES ESPECIFICADOS DEL INTESTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "K599",
    "nombre_dx": "K599-TRASTORNO FUNCIONAL INTESTINAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K600",
    "nombre_dx": "K600-FISURA ANAL AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K601",
    "nombre_dx": "K601-FISURA ANAL CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K602",
    "nombre_dx": "K602-FISURA ANAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K603",
    "nombre_dx": "K603-FISURA ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K604",
    "nombre_dx": "K604-FISTULA RECTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K605",
    "nombre_dx": "K605-FISTULA ANORRECTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K610",
    "nombre_dx": "K610-ABSCESO ANAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K611",
    "nombre_dx": "K611-ABSCESO RECTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K612",
    "nombre_dx": "K612-ABSCESO ANORRECTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K613",
    "nombre_dx": "K613-ABSCESO ISQUIORRECTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K614",
    "nombre_dx": "K614-ABSCESO INTRAESFINTERIANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K620",
    "nombre_dx": "K620-POLIPO ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K621",
    "nombre_dx": "K621-POLIPO RECTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K622",
    "nombre_dx": "K622-PROLAPSO ANAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K623",
    "nombre_dx": "K623-PROLAPSO RECTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K624",
    "nombre_dx": "K624-ESTENOSIS DEL ANO Y DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K625",
    "nombre_dx": "K625-HEMORRAGIA DEL ANO Y DEL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "K626",
    "nombre_dx": "K626-ULCERA DEL ANO Y DEL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "K627",
    "nombre_dx": "K627-PROCTITIS POR RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "K628",
    "nombre_dx": "K628-OTRAS ENFERMEDADES ESPECIFICADAS DEL ANO Y DEL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "K629",
    "nombre_dx": "K629-ENFERMEDAD DEL ANO Y DEL RECTO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K630",
    "nombre_dx": "K630-ABSCESO DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K631",
    "nombre_dx": "K631-PERFORACION DEL INTESTINO (NO TRAUMATICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K632",
    "nombre_dx": "K632-FISTULA DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K633",
    "nombre_dx": "K633-ULCERA DEL INTESTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "K634",
    "nombre_dx": "K634-ENTEROPTOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K635",
    "nombre_dx": "K635-POLIPO DEL COLON",
    "sexo": "A"
  },
  {
    "cod_dx": "K638",
    "nombre_dx": "K638-OTRAS ENFERMEDADES ESPECIFICADAS DEL INTESTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "K639",
    "nombre_dx": "K639-ENFERMEDAD DEL INTESTINO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K640",
    "nombre_dx": "K640-Hemorroides de primer grado",
    "sexo": "A"
  },
  {
    "cod_dx": "K641",
    "nombre_dx": "K641-Hemorroides de segundo grado",
    "sexo": "A"
  },
  {
    "cod_dx": "K642",
    "nombre_dx": "K642-Hemorroides de tercer grado",
    "sexo": "A"
  },
  {
    "cod_dx": "K643",
    "nombre_dx": "K643-Hemorroides de cuarto grado",
    "sexo": "A"
  },
  {
    "cod_dx": "K644",
    "nombre_dx": "K644-Marcas residuales en la piel, de hemorroides",
    "sexo": "A"
  },
  {
    "cod_dx": "K645",
    "nombre_dx": "K645-Trombosis venosa perianal",
    "sexo": "A"
  },
  {
    "cod_dx": "K648",
    "nombre_dx": "K648-Otras hemorroides especificadas",
    "sexo": "A"
  },
  {
    "cod_dx": "K649",
    "nombre_dx": "K649-Hemorroides, sin otra especificación",
    "sexo": "A"
  },
  {
    "cod_dx": "K650",
    "nombre_dx": "K650-PERITONITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K658",
    "nombre_dx": "K658-OTRAS PERITONITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K659",
    "nombre_dx": "K659-PERITONITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K660",
    "nombre_dx": "K660-ADHERENCIAS PERITONEALES",
    "sexo": "A"
  },
  {
    "cod_dx": "K661",
    "nombre_dx": "K661-HEMOPERITONEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K668",
    "nombre_dx": "K668-OTROS TRASTORNOS ESPECIFICADOS DEL PERITONEO",
    "sexo": "A"
  },
  {
    "cod_dx": "K669",
    "nombre_dx": "K669-TRASTORNO DEL PERITONEO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K670",
    "nombre_dx": "K670-PERITONITIS POR CLAMIDIAS (A74.8+)",
    "sexo": "A"
  },
  {
    "cod_dx": "K671",
    "nombre_dx": "K671-PERITONITIS GONOCOCICA (A54.8+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K672",
    "nombre_dx": "K672-PERITONITIS SIFILITICA (A52.7+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K673",
    "nombre_dx": "K673-PERITONITIS TUBERCULOSA (A18.3+)",
    "sexo": "A"
  },
  {
    "cod_dx": "K678",
    "nombre_dx": "K678-OTROS TRASTORNOS DEL PERITONEO EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K700",
    "nombre_dx": "K700-HIGADO ALCOHOLICO ADIPOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K701",
    "nombre_dx": "K701-HEPATITIS ALCOHOLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K702",
    "nombre_dx": "K702-FIBROSIS Y ESCLEROSIS DEL HIGADO, ALCOHOLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K703",
    "nombre_dx": "K703-CIRROSIS HEPATICA ALCOHOLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K704",
    "nombre_dx": "K704-INSUFICIENCIA HEPATICA ALCOHOLICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K709",
    "nombre_dx": "K709-ENFERMEDAD HEPATICA ALCOHOLICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K710",
    "nombre_dx": "K710-ENFERMEDAD TOXICA DEL HIGADO, CON COLESTASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K711",
    "nombre_dx": "K711-ENFERMEDAD TOXICA DEL HIGADO, CON NECROSIS HEPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K712",
    "nombre_dx": "K712-ENFERMEDAD TOXICA DEL HIGADO, CON HEPATITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K713",
    "nombre_dx": "K713-ENFERMEDAD TOXICA DEL HIGADO, CON HEPATITIS CRONICA PERSISTENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K714",
    "nombre_dx": "K714-ENFERMEDAD TOXICA DEL HIGADO, CON HEPATITIS CRONICA LOBULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K715",
    "nombre_dx": "K715-ENFERMEDAD TOXICA DEL HIGADO, CON HEPATITIS CRONICAACTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K716",
    "nombre_dx": "K716-ENFERMEDAD TOXICA DEL HIGADO, CON HEPATITIS NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K717",
    "nombre_dx": "K717-ENFERMEDAD TOXICA DEL HIGADO, CON CIRROSIS Y FIBROSIS DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K718",
    "nombre_dx": "K718-ENFERMEDAD TOXICA DEL HIGADO, CON OTROS TRASTORNOS HEPATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "K719",
    "nombre_dx": "K719-ENFERMEDAD TOXICA DEL HIGADO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K720",
    "nombre_dx": "K720-INSUFICIENCIA HEPATICAAGUDA O SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K721",
    "nombre_dx": "K721-INSUFICIENCIA HEPATICA CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K729",
    "nombre_dx": "K729-INSUFICIENCIA HEPATICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K730",
    "nombre_dx": "K730-HEPATITIS CRONICA PERSISTENTE, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K731",
    "nombre_dx": "K731-HEPATITIS CRONICA LOBULAR, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K732",
    "nombre_dx": "K732-HEPATITIS CRONICA ACTIVA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K738",
    "nombre_dx": "K738-OTRAS HEPATITIS CRONICAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K739",
    "nombre_dx": "K739-HEPATITIS CRONICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K740",
    "nombre_dx": "K740-FIBROSIS HEPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K741",
    "nombre_dx": "K741-ESCLEROSIS HEPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K742",
    "nombre_dx": "K742-FIBROSIS HEPATICA CON ESCLEROSIS HEPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K743",
    "nombre_dx": "K743-CIRROSIS BILIAR PRIMARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K744",
    "nombre_dx": "K744-CIRROSIS BILIAR SECUNDARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K745",
    "nombre_dx": "K745-CIRROSIS BILIAR, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K746",
    "nombre_dx": "K746-OTRAS CIRROSIS DEL HIGADO Y LA NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K750",
    "nombre_dx": "K750-ABSCESO DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K751",
    "nombre_dx": "K751-FLEBITIS DE LA VENA PORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K752",
    "nombre_dx": "K752-HEPATITIS REACTIVA NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K753",
    "nombre_dx": "K753-HEPATITIS GRANULOMATOSA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K754",
    "nombre_dx": "K754-HEPATITIS AUTOINMUNE",
    "sexo": "A"
  },
  {
    "cod_dx": "K758",
    "nombre_dx": "K758-OTRAS ENFERMEDADES INFLAMATORIAS DEL HIGADO, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K759",
    "nombre_dx": "K759-ENFERMEDAD INFLAMATORIA DEL HIGADO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K760",
    "nombre_dx": "K760-DEGENERACION GRASA DEL HIGADO, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K761",
    "nombre_dx": "K761-CONGESTION PASIVA CRONICA DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K762",
    "nombre_dx": "K762-NECROSIS HEMORRAGICA CENTRAL DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K763",
    "nombre_dx": "K763-INFARTO DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "K764",
    "nombre_dx": "K764-PELIOSIS HEPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K765",
    "nombre_dx": "K765-ENFERMEDAD VENO-OCLUSIVA DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K766",
    "nombre_dx": "K766-HIPERTENSION PORTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K767",
    "nombre_dx": "K767-SINDROME HEPATORRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K768",
    "nombre_dx": "K768-OTRAS ENFERMEDADES ESPECIFICAS DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "K769",
    "nombre_dx": "K769-ENFERMEDAD DEL HIGADO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K770",
    "nombre_dx": "K770-TRASTORNOS DEL HIGADO EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K778",
    "nombre_dx": "K778-TRASTORNO DEL HIGADO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K800",
    "nombre_dx": "K800-CALCULO DE LA VESICULA BILIAR CON COLECISTITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K801",
    "nombre_dx": "K801-CALCULO DE LA VESICULA BILIAR CON OTRA COLECISTITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K802",
    "nombre_dx": "K802-CALCULO DE LA VESICULA BILIAR SIN COLECISTITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K803",
    "nombre_dx": "K803-CALCULO DE CONDUCTO BILIAR CON COLANGITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K804",
    "nombre_dx": "K804-CALCULO DE CONDUCTO BILIAR CON COLECISTITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K805",
    "nombre_dx": "K805-CALCULO DE CONDUCTO BILIAR SIN COLANGITIS NI COLECISTITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K808",
    "nombre_dx": "K808-OTRAS COLELITIASIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K810",
    "nombre_dx": "K810-COLECISTITIS AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "K811",
    "nombre_dx": "K811-COLECISTITIS CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K818",
    "nombre_dx": "K818-OTRAS COLECISTITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K819",
    "nombre_dx": "K819-COLECISTITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K820",
    "nombre_dx": "K820-OBSTRUCCION DE LA VESICULA BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K821",
    "nombre_dx": "K821-HIDROPESIA DE LA VESICULA BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K822",
    "nombre_dx": "K822-PERFORACION DE LA VESICULA BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K823",
    "nombre_dx": "K823-FISTULA DE LA VESICULA BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K824",
    "nombre_dx": "K824-COLESTEROLOSIS DE LA VESICULA BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K828",
    "nombre_dx": "K828-OTRAS ENFERMEDADES ESPECIFICADAS DE LA VESICULA BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K829",
    "nombre_dx": "K829-ENFERMEDAD DE LA VESICULA BILIAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K830",
    "nombre_dx": "K830-COLANGITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "K831",
    "nombre_dx": "K831-OBSTRUCCION DEL CONDUCTO BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K832",
    "nombre_dx": "K832-PERFORACION DEL CONDUCTO BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K833",
    "nombre_dx": "K833-FISTULADEL CONDUCTO BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "K834",
    "nombre_dx": "K834-ESPASMO DEL ESFINTER DE ODDI",
    "sexo": "A"
  },
  {
    "cod_dx": "K835",
    "nombre_dx": "K835-QUISTE BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "K838",
    "nombre_dx": "K838-OTRASENFERMEDADES ESPECIALIZADAS DE LAS VIAS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "K839",
    "nombre_dx": "K839-ENFERMEDAD DE LAS VIAS BILIARES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K85X",
    "nombre_dx": "K85X-Pancreatitis aguda",
    "sexo": "A"
  },
  {
    "cod_dx": "K860",
    "nombre_dx": "K860-PANCREATITIS CRONICA INDUCIDA POR EL ALCOHOL",
    "sexo": "A"
  },
  {
    "cod_dx": "K861",
    "nombre_dx": "K861-OTRAS PANCREATITIS CRONICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K862",
    "nombre_dx": "K862-QUISTE DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K863",
    "nombre_dx": "K863-SEUDOQUISTE DEL PANCREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "K868",
    "nombre_dx": "K868-OTRAS ENFERMEDADES ESPECIFICADAS DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K869",
    "nombre_dx": "K869-ENFERMEDAD DEL PANCREAS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K870",
    "nombre_dx": "K870-TRASTORNOS DE LA VESICULA BILIAR Y DE LAS VIAS BILIARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K871",
    "nombre_dx": "K871-TRASTORNOS DEL PANCREAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K900",
    "nombre_dx": "K900-ENFERMEDAD CELIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "K901",
    "nombre_dx": "K901-ESPRUE TROPICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K902",
    "nombre_dx": "K902-SINDROME DEL ASA CIEGA, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K903",
    "nombre_dx": "K903-ESTEATORREA PANCREATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K904",
    "nombre_dx": "K904-MALABSORCION DEBIDA A INTOLERANCIA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K908",
    "nombre_dx": "K908-OTROS TIPOS DE MALABSORCION INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "K909",
    "nombre_dx": "K909-MALABSORCION INTESTINAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K910",
    "nombre_dx": "K910-VOMITO POSTCIRUGIA GASTROINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "K911",
    "nombre_dx": "K911-SINDROMES CONSECUTIVOS A LA CIRUGIA GASTRICA",
    "sexo": "A"
  },
  {
    "cod_dx": "K912",
    "nombre_dx": "K912-MALABSORCION POSTQUIRURGICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "K913",
    "nombre_dx": "K913-OBSTRUCION INTESTINAL POSTOPERATORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K914",
    "nombre_dx": "K914-DISFUNCION DE COLOSTOMIA O ENTEROSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K915",
    "nombre_dx": "K915-SINDROME POSTCOLECISTECTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "K918",
    "nombre_dx": "K918-OTROS TRASTORNOS DEL SISTEMADIGESTIVO CONSECUTIVOS A PROCEDIMIENTOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "K919",
    "nombre_dx": "K919-TRASTORNO NO ESPECIFICADO AL SISTEMA DIGESTIVO CONSECUTIVO A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K920",
    "nombre_dx": "K920-HEMATEMESIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "K921",
    "nombre_dx": "K921-MELENA",
    "sexo": "A"
  },
  {
    "cod_dx": "K922",
    "nombre_dx": "K922-HEMORRAGIA GASTROINTESTINAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "K928",
    "nombre_dx": "K928-OTRAS ENFERMEDADES ESPECIFICADAS DEL SISTEMA DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "K929",
    "nombre_dx": "K929-ENFERMEDAD DEL SISTEMA DIGESTIVO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "K930",
    "nombre_dx": "K930-TRASTORNOS TUBERCULOSOS DEL INTESTINO, PERITONEO Y GANGLIOS MESENTERICOS (A18.3+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K931",
    "nombre_dx": "K931-MEGACOLON EN LA ENFERMEDAD DE CHAGAS (B57.3+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "K938",
    "nombre_dx": "K938-TRASTORNOS DE OTROS ORGANOS DIGESTIVOS ESPECIFICADOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L00X",
    "nombre_dx": "L00X-SINDROME ESTAFILOCOCICO DE LA PIEL ESCALDADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L010",
    "nombre_dx": "L010-IMPETIGO [CUALQUIER SITIO ANATOMICO] [CUALQUIER ORGANISMO]",
    "sexo": "A"
  },
  {
    "cod_dx": "L011",
    "nombre_dx": "L011-IMPETIGINIZACION DE OTRAS DERMATOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L020",
    "nombre_dx": "L020-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "L021",
    "nombre_dx": "L021-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE LA CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "L022",
    "nombre_dx": "L022-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "L023",
    "nombre_dx": "L023-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE GLUTEOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L024",
    "nombre_dx": "L024-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE MIEMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "L028",
    "nombre_dx": "L028-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L029",
    "nombre_dx": "L029-ABSCESO CUTANEO, FURUNCULO Y ANTRAX DE SITIONO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L030",
    "nombre_dx": "L030-CELULITIS DE LOS DEDOS DE LA MANO Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L031",
    "nombre_dx": "L031-CELULITIS DE OTRAS PARTES DE LOS MIEMBROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L032",
    "nombre_dx": "L032-CELULITIS DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "L033",
    "nombre_dx": "L033-CELULITIS DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "L038",
    "nombre_dx": "L038-CELULITIS DE OTROS SITIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L039",
    "nombre_dx": "L039-CELULITIS DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L040",
    "nombre_dx": "L040-LINFADENITIS AGUDA DE CARA, CABEZA Y CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L041",
    "nombre_dx": "L041-LINFADENITIS AGUDA DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L042",
    "nombre_dx": "L042-LINFADENITIS AGUDA DEL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L043",
    "nombre_dx": "L043-LINFADENITIS AGUDA DEL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L048",
    "nombre_dx": "L048-LINFADENITIS AGUDA DE OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L049",
    "nombre_dx": "L049-LINFADENITIS AGUDA DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L050",
    "nombre_dx": "L050-QUISTE PILONIDAL CON ABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "L059",
    "nombre_dx": "L059-QUISTE PILONIDAL SIN ABSCESO",
    "sexo": "A"
  },
  {
    "cod_dx": "L080",
    "nombre_dx": "L080-PIODERMA",
    "sexo": "A"
  },
  {
    "cod_dx": "L081",
    "nombre_dx": "L081-ERITRASMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L088",
    "nombre_dx": "L088-OTRAS INFECCIONES LOCALES ESPECIFICADAS DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "L089",
    "nombre_dx": "L089-INFECCION LOCAL DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L100",
    "nombre_dx": "L100-PENFIGO VULGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L101",
    "nombre_dx": "L101-PENFIGO VEGETANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L102",
    "nombre_dx": "L102-PENFIGO FOLIACEO",
    "sexo": "A"
  },
  {
    "cod_dx": "L103",
    "nombre_dx": "L103-PENFIGO BRASILEÑO [FOGO SELVAGEM] ",
    "sexo": "A"
  },
  {
    "cod_dx": "L104",
    "nombre_dx": "L104-PENFIGO ERITEMATOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L105",
    "nombre_dx": "L105-PENFIGO INDUCIDO POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L108",
    "nombre_dx": "L108-OTROS PENFIGOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L109",
    "nombre_dx": "L109-PENFIGO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L110",
    "nombre_dx": "L110-QUERATOSIS FOLICULAR ADQUIRIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "L111",
    "nombre_dx": "L111-DERMATOSIS ACANTOLITICA TRANSITORIA [GROVER]",
    "sexo": "A"
  },
  {
    "cod_dx": "L118",
    "nombre_dx": "L118-OTROS TRASTORNOS ACANTOLITICOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L119",
    "nombre_dx": "L119-TRASTORNO ACANTOLITICO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L120",
    "nombre_dx": "L120-PENFIGOIDE FLICTENULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L121",
    "nombre_dx": "L121-PENFIGOIDE CICATRICIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L122",
    "nombre_dx": "L122-ENFERMEDAD FLICTENULAR CRONICA DE LA INFANCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L123",
    "nombre_dx": "L123-EPIDERMOLISIS BULLOSA ADQUIRIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L128",
    "nombre_dx": "L128-OTROS PENFIGOIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L129",
    "nombre_dx": "L129-PENFIGOIDE, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L130",
    "nombre_dx": "L130-DERMATITIS HERPETIFORME ",
    "sexo": "A"
  },
  {
    "cod_dx": "L131",
    "nombre_dx": "L131-DERMATITIS PUSTULOSA SUBCORNEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L138",
    "nombre_dx": "L138-OTROS TRASTORNOS FLICTENULARES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L139",
    "nombre_dx": "L139-TRASTORNO FLICTENULAR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L14X",
    "nombre_dx": "L14X-TRASTORNOS FLICTENULARES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L200",
    "nombre_dx": "L200-PRURIGO DE BESNIER",
    "sexo": "A"
  },
  {
    "cod_dx": "L208",
    "nombre_dx": "L208-OTRAS DERMATITIS ATOPICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L209",
    "nombre_dx": "L209-DERMATITIS ATOPICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L210",
    "nombre_dx": "L210-SEBORREA CAPITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L211",
    "nombre_dx": "L211-DERMATITIS SEBORREICA INFANTIL",
    "sexo": "A"
  },
  {
    "cod_dx": "L218",
    "nombre_dx": "L218-OTRAS DERMATITIS SEBORREICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L219",
    "nombre_dx": "L219-DERMATITIS SEBORREICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L22X",
    "nombre_dx": "L22X-DERMATITIS DEL PAÑAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L230",
    "nombre_dx": "L230-DERMATITIS ALERGICA DE CONTACTO DEBIDA A METALES",
    "sexo": "A"
  },
  {
    "cod_dx": "L231",
    "nombre_dx": "L231-DERMATITIS ALERGICA DE CONTACTO DEBIDA A ADHESIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L232",
    "nombre_dx": "L232-DERMATITIS ALERGICA DE CONTACTO DEBIDA A COSMETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L233",
    "nombre_dx": "L233-DERMATITIS ALERGICA DE CONTACTO DEBIDA A DROGAS EN CONTACTO CON LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L234",
    "nombre_dx": "L234-DERMATITIS ALERGICA DE CONTACTO DEBIDA A COLORANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L235",
    "nombre_dx": "L235-DERMATITIS ALERGICA DE CONTACTO DEBIDA A OTROS PRODUCTOS QUIMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L236",
    "nombre_dx": "L236-DERMATITIS ALERGICA DE CONTACTO DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "L237",
    "nombre_dx": "L237-DERMATITIS ALERGICA DE CONTACTO DEBIDA A PLANTAS, EXCEPTO LAS ALIMENTICIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L238",
    "nombre_dx": "L238-DERMATITIS ALERGICA DE CONTACTO DEBIDA A OTROS AGENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "L239",
    "nombre_dx": "L239-DERMATITIS ALERGICA DE CONTACTO, DE CAUSA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L240",
    "nombre_dx": "L240-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A DETERGENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L241",
    "nombre_dx": "L241-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A ACEITES Y GRASAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L242",
    "nombre_dx": "L242-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA ADISOLVENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "L243",
    "nombre_dx": "L243-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A COSMETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L244",
    "nombre_dx": "L244-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A DROGAS EN CONTACTO CON LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "L245",
    "nombre_dx": "L245-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A OTROS PRODUCTOS QUIMICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L246",
    "nombre_dx": "L246-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L247",
    "nombre_dx": "L247-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA A PLANTAS, EXCEPTOLAS ALIMENTICIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L248",
    "nombre_dx": "L248-DERMATITIS DE CONTACTO POR IRRITANTES, DEBIDA AOTROS AGENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "L249",
    "nombre_dx": "L249-DERMATITIS DE CONTACTO POR IRRITANTES, DE CAUSA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L250",
    "nombre_dx": "L250-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA,DEBIDA A COSMETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L251",
    "nombre_dx": "L251-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA,DEBIDA A DROGAS EN CONTACTO CON LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L252",
    "nombre_dx": "L252-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A COLORANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "L253",
    "nombre_dx": "L253-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA,DEBIDA A OTROS PRODUCTOS QUIMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L254",
    "nombre_dx": "L254-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, DEBIDA A ALIMENTOS EN CONTACTO CON LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L255",
    "nombre_dx": "L255-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA, , DEBIDA A PLANTAS, EXCEPTOLAS ALIMENTICIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L258",
    "nombre_dx": "L258-DERMATITIS DE CONTACTO, FORMA NO ESPECIFICADA,DEBIDA AOTROS AGENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L259",
    "nombre_dx": "L259-DERMATITIS DE CONTACTO, FORMA Y CAUSA NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L26X",
    "nombre_dx": "L26X-DERMATITIS EXFOLIATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "L270",
    "nombre_dx": "L270-ERUPCION CUTANEA GENERALIZADA DEBIDA A DROGAS Y MEDICAMENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L271",
    "nombre_dx": "L271-ERUPCION CUTANEA LOCALIZADA DEBIDA A DROGAS Y MEDICAMENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L272",
    "nombre_dx": "L272-DERMATITIS DEBIDA A INGESTION DE ALIMENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L278",
    "nombre_dx": "L278-DERMATITIS DEBIDA A OTRAS SUSTANCIAS INGERIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L279",
    "nombre_dx": "L279-DERMATITIS DEBIDA A SUSTANCIAS INGERIDAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L280",
    "nombre_dx": "L280-LIQUEN SIMPLE CRONICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L281",
    "nombre_dx": "L281-PRURIGO NODULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L282",
    "nombre_dx": "L282-OTROS PRURIGOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L290",
    "nombre_dx": "L290-PRURITO ANAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L291",
    "nombre_dx": "L291-PRURITO ESCROTAL",
    "sexo": "M"
  },
  {
    "cod_dx": "L292",
    "nombre_dx": "L292-PRURITO VULVAR",
    "sexo": "F"
  },
  {
    "cod_dx": "L293",
    "nombre_dx": "L293-PRURITO ANOGENITAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L298",
    "nombre_dx": "L298-OTROS PRURITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L299",
    "nombre_dx": "L299-PRURITO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L300",
    "nombre_dx": "L300-DERMATITIS NUMULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L301",
    "nombre_dx": "L301-DISHIDROSIS [PONFOLIX]",
    "sexo": "A"
  },
  {
    "cod_dx": "L302",
    "nombre_dx": "L302-AUTOSENSIBILIZACION CUTANEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L303",
    "nombre_dx": "L303-DERMATITIS INFECCIOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L304",
    "nombre_dx": "L304-ERITEMA INTERTRIGO",
    "sexo": "A"
  },
  {
    "cod_dx": "L305",
    "nombre_dx": "L305-PITIRIASIS ALBA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L308",
    "nombre_dx": "L308-OTRAS DERMATITIS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L309",
    "nombre_dx": "L309-DERMATITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L400",
    "nombre_dx": "L400-PSORIASIS VULGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L401",
    "nombre_dx": "L401-PSORIASIS PUSTULOSA GENERALIZADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L402",
    "nombre_dx": "L402-ACRODERMATITIS CONTINUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L403",
    "nombre_dx": "L403-PUSTULOSIS PALMAR Y PLANTAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L404",
    "nombre_dx": "L404-PSORIASIS GUTTATA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L405",
    "nombre_dx": "L405-ARTROPATIA PSORIASICA (M07.0*-M07.3*, M09.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "L408",
    "nombre_dx": "L408-OTRAS PSORIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L409",
    "nombre_dx": "L409-PSORIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L410",
    "nombre_dx": "L410-PITIRIASIS LINQUENOIDE Y VARIOLIFORME AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L411",
    "nombre_dx": "L411-PITIRIASIS LINQUENOIDE CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L413",
    "nombre_dx": "L413-PARAPSORIASIS EN PLACAS PEQUEÑAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L414",
    "nombre_dx": "L414-PARAPSORIASIS EN PLACAS GRANDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L415",
    "nombre_dx": "L415-PARAPSORIASIS RETIFORME ",
    "sexo": "A"
  },
  {
    "cod_dx": "L418",
    "nombre_dx": "L418-OTRAS PARAPSORIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L419",
    "nombre_dx": "L419-PARAPSORIASIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L42X",
    "nombre_dx": "L42X-PITIRIASIS ROSADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L430",
    "nombre_dx": "L430-LIQUEN PLANO HIPERTROFICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L431",
    "nombre_dx": "L431-LIQUEN PLANO FLICTENULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L432",
    "nombre_dx": "L432-REACCION LINQUENOIDE DEBIDA ADROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L433",
    "nombre_dx": "L433-LIQUEN PLANO SUBAGUDO (ACTIVO)",
    "sexo": "A"
  },
  {
    "cod_dx": "L438",
    "nombre_dx": "L438-OTROS LIQUENES PLANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L439",
    "nombre_dx": "L439-LIQUEN PLANO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L440",
    "nombre_dx": "L440-PITIRIASIS RUBRA PILARIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L441",
    "nombre_dx": "L441-LIQUEN NITIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L442",
    "nombre_dx": "L442-LIQUEN ESTRIADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L443",
    "nombre_dx": "L443-LIQUEN ROJO MONILIFORME ",
    "sexo": "A"
  },
  {
    "cod_dx": "L444",
    "nombre_dx": "L444-ACRODERMATITIS PAPULAR INFANTIL [GIANNOTTI-CROSTI]",
    "sexo": "A"
  },
  {
    "cod_dx": "L448",
    "nombre_dx": "L448-OTROS TRASTORNOS PALPULOESCAMOSOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L449",
    "nombre_dx": "L449-TRASTORNO PAPULOESCAMOSO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L45X",
    "nombre_dx": "L45X-TRASTORNOS PAPULOESCAMOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L500",
    "nombre_dx": "L500-URTICARIA ALERGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L501",
    "nombre_dx": "L501-URTICARIA IDIOPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L502",
    "nombre_dx": "L502-URTICARIA DEBIDA AL CALOR Y AL FRIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L503",
    "nombre_dx": "L503-URTICARIA DERMATOGRAFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L504",
    "nombre_dx": "L504-URTICARIA VIBRATORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "L505",
    "nombre_dx": "L505-URTICARIA COLINERGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L506",
    "nombre_dx": "L506-URTICARIA POR CONTACTO",
    "sexo": "A"
  },
  {
    "cod_dx": "L508",
    "nombre_dx": "L508-OTRAS URTICARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L509",
    "nombre_dx": "L509-URTICARIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L510",
    "nombre_dx": "L510-ERITEMA MULTIFORME NO FLICTENULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L511",
    "nombre_dx": "L511-ERITEMA MULTIFORME FLICTENULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L512",
    "nombre_dx": "L512-NECROLISIS EPIDERMICA TOXICA [LYELL]",
    "sexo": "A"
  },
  {
    "cod_dx": "L518",
    "nombre_dx": "L518-OTROS ERITEMAS MULTIFORMES",
    "sexo": "A"
  },
  {
    "cod_dx": "L519",
    "nombre_dx": "L519-ERITEMA MULTIFORME, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L52X",
    "nombre_dx": "L52X-ERITEMA NUDOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "L530",
    "nombre_dx": "L530-ERITEMA TOXICO",
    "sexo": "A"
  },
  {
    "cod_dx": "L531",
    "nombre_dx": "L531-ERITEMA ANULAR CENTRIFUGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L532",
    "nombre_dx": "L532-ERITEMA MARGINADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L533",
    "nombre_dx": "L533-OTROS ERITEMAS FIGURADOS CRONICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L538",
    "nombre_dx": "L538-OTRAS AFECCIONES ERITEMATOSAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L539",
    "nombre_dx": "L539-AFECCION ERITEMATOSA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L540",
    "nombre_dx": "L540-ERITEMA MARGINADO EN LA FIEBRE REUMATICA AGUDA (I00+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "L548",
    "nombre_dx": "L548-ERITEMA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L550",
    "nombre_dx": "L550-QUEMADURA SOLAR PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L551",
    "nombre_dx": "L551-QUEMADURA SOLAR SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L552",
    "nombre_dx": "L552-QUEMADURA SOLAR TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L558",
    "nombre_dx": "L558-OTRAS QUEMADURAS SOLARES",
    "sexo": "A"
  },
  {
    "cod_dx": "L559",
    "nombre_dx": "L559-QUEMADURA SOLAR, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L560",
    "nombre_dx": "L560-RESPUESTA FOTOTOXICA A DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L561",
    "nombre_dx": "L561-RESPUESTA FOTOALERGICA A DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L562",
    "nombre_dx": "L562-DERMATITIS POR FOTOCONTACTO [DERMATITIS DE BERLOQUE]",
    "sexo": "A"
  },
  {
    "cod_dx": "L563",
    "nombre_dx": "L563-URTICARIA SOLAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L564",
    "nombre_dx": "L564-ERUPCION POLIMORFA A LA LUZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "L568",
    "nombre_dx": "L568-OTROS CAMBIOS AGUDOS ESPECIFICADOS DE LA PIEL DEBIDOS A RADIACION ULTRAVIOLETA",
    "sexo": "A"
  },
  {
    "cod_dx": "L569",
    "nombre_dx": "L569-CAMBIO AGUDO DE LA PIEL DEBIDO A RADIACION ULTRAVIOLETA,SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "L570",
    "nombre_dx": "L570-QUERATOSIS ACTINICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L571",
    "nombre_dx": "L571-RETICULOIDE ACTINICO",
    "sexo": "A"
  },
  {
    "cod_dx": "L572",
    "nombre_dx": "L572-PIEL ROMBOIDAL DE LA NUCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L573",
    "nombre_dx": "L573-POIQUILODERMIA DE CIVATTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L574",
    "nombre_dx": "L574-PIEL LAXA SENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L575",
    "nombre_dx": "L575-GRANULOMA ACTINICO",
    "sexo": "A"
  },
  {
    "cod_dx": "L578",
    "nombre_dx": "L578-OTROS CAMBIOS DE LA PIEL DEBIDOS A EXPOSICION CRONICA A RADIACION NO IONIZANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L579",
    "nombre_dx": "L579-CAMBIOS DE LA PIEL DEBIDOS A EXPOSICION CRONICA A RADIACION NO IONIZANTE, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "L580",
    "nombre_dx": "L580-RADIODERMATITIS AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L581",
    "nombre_dx": "L581-RADIODERMATITIS CRONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L589",
    "nombre_dx": "L589-RADIODERMATITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L590",
    "nombre_dx": "L590-ERITEMA AB IGNE [DERMATITIS AB IGNE]",
    "sexo": "A"
  },
  {
    "cod_dx": "L598",
    "nombre_dx": "L598-OTROS TRASTORNOS ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO RELACIONADOS CON RADIACION",
    "sexo": "A"
  },
  {
    "cod_dx": "L599",
    "nombre_dx": "L599-TRASTORNOS NO ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO RELACIONADOS CON RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "L600",
    "nombre_dx": "L600-UÑA ENCARNADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L601",
    "nombre_dx": "L601-ONICOLISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L602",
    "nombre_dx": "L602-ONICOGRIPOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L603",
    "nombre_dx": "L603-DISTROFIA UNGUEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L604",
    "nombre_dx": "L604-LINEAS DE BEAU",
    "sexo": "A"
  },
  {
    "cod_dx": "L605",
    "nombre_dx": "L605-SINDROME DE LA UÑA AMARILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L608",
    "nombre_dx": "L608-OTROS TRASTORNOS DE LAS UÑAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L609",
    "nombre_dx": "L609-TRASTORNO DE LA UÑA, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L620",
    "nombre_dx": "L620-UÑA DEFORME DE LA PAQUIDERMOPERIOSTOSIS (M89.4+)",
    "sexo": "A"
  },
  {
    "cod_dx": "L628",
    "nombre_dx": "L628-TRASTORNOS DE LAS UÑAS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L630",
    "nombre_dx": "L630-ALOPECIA (CAPITIS) TOTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L631",
    "nombre_dx": "L631-ALOPECIA UNIVERSAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L632",
    "nombre_dx": "L632-OFIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L638",
    "nombre_dx": "L638-OTRAS ALOPECIAS AREATAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L639",
    "nombre_dx": "L639-ALOPECIA AREATA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L640",
    "nombre_dx": "L640-ALOPECIAANDROGENA, INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L648",
    "nombre_dx": "L648-OTRAS ALOPECIASANDROGENAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L649",
    "nombre_dx": "L649-ALOPECIA ANDROGENA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L650",
    "nombre_dx": "L650-PERDIDA CAPILAR TELOGENA",
    "sexo": "A"
  },
  {
    "cod_dx": "L651",
    "nombre_dx": "L651-PERDIDA CAPILAR ANAGENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L652",
    "nombre_dx": "L652-ALOPECIA MUCINOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L658",
    "nombre_dx": "L658-OTRAS PERDIDAS ESPECIFICADAS NO CICATRICIALES DEL PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "L659",
    "nombre_dx": "L659-PERDIDA NO CICATRICIAL DEL PELO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "L660",
    "nombre_dx": "L660-SEUDOPELADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L661",
    "nombre_dx": "L661-LIQUEN PLANO PILARIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L662",
    "nombre_dx": "L662-FOLICULITIS DECALVANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L663",
    "nombre_dx": "L663-PERIFOLICULITIS CAPITIS ABSCEDENS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L664",
    "nombre_dx": "L664-FOLICULITIS ULERITEMATOSA RETICULADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L668",
    "nombre_dx": "L668-OTRAS ALOPECIAS CICATRICIALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L669",
    "nombre_dx": "L669-ALOPECIA CICATRICIAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L670",
    "nombre_dx": "L670-TRICORREXIS NUDOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "L671",
    "nombre_dx": "L671-VARIACION DEL COLOR DEL PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "L678",
    "nombre_dx": "L678-OTRAS ANOMALIAS DEL TALLO Y DEL COLOR DEL PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "L679",
    "nombre_dx": "L679-ANORMALIDAD NO ESPECIFICADA DEL TALLO Y DEL COLOR DEL PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "L680",
    "nombre_dx": "L680-HIRSUTISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "L681",
    "nombre_dx": "L681-HIPERTRICOSIS LANUGINOSA ADQUIRIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "L682",
    "nombre_dx": "L682-HIPERTRICOSISLOCALIZADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L683",
    "nombre_dx": "L683-POLITRIQUIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L688",
    "nombre_dx": "L688-OTRAS HIPERTRICOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L689",
    "nombre_dx": "L689-HIPERTRICOSIS , NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L700",
    "nombre_dx": "L700-ACNE VULGAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "L701",
    "nombre_dx": "L701-ACNE CONGLOBADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L702",
    "nombre_dx": "L702-ACNE VARIOLIFORME ",
    "sexo": "A"
  },
  {
    "cod_dx": "L703",
    "nombre_dx": "L703-ACNE TROPICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L704",
    "nombre_dx": "L704-ACNE INFANTIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L705",
    "nombre_dx": "L705-ACNE EXCORIADO DE LA MUJER JOVEN",
    "sexo": "F"
  },
  {
    "cod_dx": "L708",
    "nombre_dx": "L708-OTROS ACNES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L709",
    "nombre_dx": "L709-ACNE, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L710",
    "nombre_dx": "L710-DERMATITIS PERIBUCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L711",
    "nombre_dx": "L711-RINOFIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "L718",
    "nombre_dx": "L718-OTRAS ROSACEAS",
    "sexo": "A"
  },
  {
    "cod_dx": "L719",
    "nombre_dx": "L719-ROSACEA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L720",
    "nombre_dx": "L720-QUISTE EPIDERMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L721",
    "nombre_dx": "L721-QUISTE TRICODERMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L722",
    "nombre_dx": "L722-ESTEATOCISTOMA MULTIPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L728",
    "nombre_dx": "L728-OTROS QUISTES FOLICULARES DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "L729",
    "nombre_dx": "L729-QUISTE FOLICULAR DE LA PIEL Y DEL TEJIDO SUBCUTANEO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "L730",
    "nombre_dx": "L730-ACNE QUELOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L731",
    "nombre_dx": "L731-SEUDOFOLICULITIS DE LA BARBA",
    "sexo": "A"
  },
  {
    "cod_dx": "L732",
    "nombre_dx": "L732-HIDRADENITIS SUPURATIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L738",
    "nombre_dx": "L738-OTROS TRASTORNOS FOLICULARES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L739",
    "nombre_dx": "L739-TRASTORNO FOLICULAR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L740",
    "nombre_dx": "L740-MILIARIA RUBRA",
    "sexo": "A"
  },
  {
    "cod_dx": "L741",
    "nombre_dx": "L741-MILIARIA CRISTALINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L742",
    "nombre_dx": "L742-MILIARIA PROFUNDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L743",
    "nombre_dx": "L743-MILIARIA , NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "L744",
    "nombre_dx": "L744-ANHIDROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L748",
    "nombre_dx": "L748-OTROS TRASTORNOS SUDORIPADOS ECRINOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L749",
    "nombre_dx": "L749-TRASTORNO SUDORIPARO ECRINO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L750",
    "nombre_dx": "L750-BROMHIDROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L751",
    "nombre_dx": "L751-CROMHIDROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "L752",
    "nombre_dx": "L752-MILIARIA APOCRINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L758",
    "nombre_dx": "L758-OTROS TRASTORNOS SUDORIPARO APOCRINO",
    "sexo": "A"
  },
  {
    "cod_dx": "L759",
    "nombre_dx": "L759-TRASTORNO SUDORIPARO APOCRINO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L80X",
    "nombre_dx": "L80X-VITILIGO",
    "sexo": "A"
  },
  {
    "cod_dx": "L810",
    "nombre_dx": "L810-HIPERPIGMENTACION POSTINFLAMATORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "L811",
    "nombre_dx": "L811-CLOASMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L812",
    "nombre_dx": "L812-EFELIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L813",
    "nombre_dx": "L813-MANCHAS CAFÉ CON LECHE",
    "sexo": "A"
  },
  {
    "cod_dx": "L814",
    "nombre_dx": "L814-OTROS TIPOS DE HIPERPIGMENTACION MELANODERMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L815",
    "nombre_dx": "L815-LEUCODERMIA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L816",
    "nombre_dx": "L816-OTROS TRASTORNOS DE DISMINUCION DE LA FORMACION DE LA MELANINA",
    "sexo": "A"
  },
  {
    "cod_dx": "L817",
    "nombre_dx": "L817-DERMATOSIS PURPURICA PIGMENTADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L818",
    "nombre_dx": "L818-OTROS TRASTORNOS ESPECIFICADOS DE LA PIGMENTACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "L819",
    "nombre_dx": "L819-TRASTORNO DE LA PIGMENTACION, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L82X",
    "nombre_dx": "L82X-QUERATOSIS SEBORREICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L83X",
    "nombre_dx": "L83X-ACANTOSIS NIGRICANS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L84X",
    "nombre_dx": "L84X-CALLOS Y CALLOSIDADES ",
    "sexo": "A"
  },
  {
    "cod_dx": "L850",
    "nombre_dx": "L850-ICTIOSIS ADQUIRIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "L851",
    "nombre_dx": "L851-QUERATOSIS [QUERATODERMIA] PALMAR YPLANTAR ADQUIRIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "L852",
    "nombre_dx": "L852-QUERATOSIS PUNCTATA (PALMAR Y PLANTAR)",
    "sexo": "A"
  },
  {
    "cod_dx": "L853",
    "nombre_dx": "L853-XEROSIS DEL CUTIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L858",
    "nombre_dx": "L858-OTROS ENGROSAMIENTOS EPIDERMICOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L859",
    "nombre_dx": "L859-ENGROSAMIENTO EPIDERMICO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L86X",
    "nombre_dx": "L86X-QUERODERMA ENENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L870",
    "nombre_dx": "L870-QUERATOSIS FOLICULAR Y PARAFOLICULAR PENETRANTE DEL CUTIS [KYRLE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "L871",
    "nombre_dx": "L871-COLAGENOSIS PERFORANTE REACTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L872",
    "nombre_dx": "L872-ELASTOSIS SERPIGINOSA PERFORANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L878",
    "nombre_dx": "L878-OTROS TRASTORNOS DE LA ELIMINACION TRANSEPIDERMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L879",
    "nombre_dx": "L879-TRASTORNO DE LA ELIMINACION TRANSEPIDERMICA. NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L88X",
    "nombre_dx": "L88X-PIODERMA GANGRENOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L890",
    "nombre_dx": "L890-Úlcera de decúbito y por área de presión, etapa I",
    "sexo": "A"
  },
  {
    "cod_dx": "L891",
    "nombre_dx": "L891-Úlcera de decúbito, etapa II",
    "sexo": "A"
  },
  {
    "cod_dx": "L892",
    "nombre_dx": "L892-Úlcera de decúbito, etapa III",
    "sexo": "A"
  },
  {
    "cod_dx": "L893",
    "nombre_dx": "L893-Úlcera de decúbito, etapa IV",
    "sexo": "A"
  },
  {
    "cod_dx": "L899",
    "nombre_dx": "L899-Úlcera de decúbito y por área de presión, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "L900",
    "nombre_dx": "L900-LIQUEN ESCLEROSOY ATROFICO",
    "sexo": "A"
  },
  {
    "cod_dx": "L901",
    "nombre_dx": "L901-ANETODERMIA DE SCHWENINGER-BUZZI",
    "sexo": "A"
  },
  {
    "cod_dx": "L902",
    "nombre_dx": "L902-ANETODERMIA DE JADASSOHN-PELLIZZARI ",
    "sexo": "A"
  },
  {
    "cod_dx": "L903",
    "nombre_dx": "L903-ATROFODERMA DE PASINI Y PIERINI ",
    "sexo": "A"
  },
  {
    "cod_dx": "L904",
    "nombre_dx": "L904-ACRODERMATITIS CRONICA ATROFICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L905",
    "nombre_dx": "L905-FIBROSIS Y AFECCIONES CICATRICIALES DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "L906",
    "nombre_dx": "L906-ESTRIAS ATROFICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "L908",
    "nombre_dx": "L908-OTROS TRASTORNOS ATROFICOS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L909",
    "nombre_dx": "L909-TRASTORNO ATROFICO DE LA PIEL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L910",
    "nombre_dx": "L910-Cicatriz hipertrófica",
    "sexo": "A"
  },
  {
    "cod_dx": "L918",
    "nombre_dx": "L918-OTROS TRASTORNOS HIPERTROFICOS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L919",
    "nombre_dx": "L919-TRASTORNO HIPERTROFICO DE LA PIEL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "L920",
    "nombre_dx": "L920-GRANULOMA ANULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "L921",
    "nombre_dx": "L921-NECROBIOSIS LIPIDICA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "L922",
    "nombre_dx": "L922-GRANULOMA FACIAL [GRANULOMA EOSINOFILO DE LA PIEL]",
    "sexo": "A"
  },
  {
    "cod_dx": "L923",
    "nombre_dx": "L923-GRANULOMA POR CUERPO EXTRAÑO DE LA PIEL Y EN EL TEJIDO SUBCUTANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L928",
    "nombre_dx": "L928-OTROS TRASTORNOS GRANULOMATOSOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "L929",
    "nombre_dx": "L929-TRASTORNO GRANULOMATOSO DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L930",
    "nombre_dx": "L930-LUPUS ERITEMATOSO DISCOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "L931",
    "nombre_dx": "L931-LUPUS ERITEMATOSO CUTANEO SUBAGUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "L932",
    "nombre_dx": "L932-OTROS LUPUS ERITEMATOSOS LOCALIZADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "L940",
    "nombre_dx": "L940-ESCLERODERMA LOCALIZADO [MORFEA]",
    "sexo": "A"
  },
  {
    "cod_dx": "L941",
    "nombre_dx": "L941-ESCLERODERMALINEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "L942",
    "nombre_dx": "L942-CALCINOSIS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L943",
    "nombre_dx": "L943-ESCLERODACTILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L944",
    "nombre_dx": "L944-PAPULAS DE GOTTRON",
    "sexo": "A"
  },
  {
    "cod_dx": "L945",
    "nombre_dx": "L945-POIQUILODERMIA VASCULAR ATROFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "L946",
    "nombre_dx": "L946-AINHUM",
    "sexo": "A"
  },
  {
    "cod_dx": "L948",
    "nombre_dx": "L948-OTROS TRASTORNOS LOCALIZADOS ESPECIFICADOS DEL TEJIDO CONJUNTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "L949",
    "nombre_dx": "L949-TRASTORNO LOCALIZADO DEL TEJIDO CONJUNTIVO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L950",
    "nombre_dx": "L950-VASCULITIS LIVEDOIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "L951",
    "nombre_dx": "L951-ERITEMA ELEVATUM DIUTINUM ",
    "sexo": "A"
  },
  {
    "cod_dx": "L958",
    "nombre_dx": "L958-OTRAS VASCULITIS LIMITADAS DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "L959",
    "nombre_dx": "L959-VASCULITIS LIMITADA A LA PIEL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "L97X",
    "nombre_dx": "L97X-ULCERA DEL MIEMBRO INFERIOR, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L980",
    "nombre_dx": "L980-GRANULOMA PIOGENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L981",
    "nombre_dx": "L981-DERMATITIS FACTICIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "L982",
    "nombre_dx": "L982-DERMATOSIS NEUTROFILA FEBRIL [SWEET]",
    "sexo": "A"
  },
  {
    "cod_dx": "L983",
    "nombre_dx": "L983-CELULITIS EOSINOFILA [WELLS]",
    "sexo": "A"
  },
  {
    "cod_dx": "L984",
    "nombre_dx": "L984-ULCERA CRONICA DE LA PIEL, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "L985",
    "nombre_dx": "L985-MUCINOSIS DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "L986",
    "nombre_dx": "L986-OTROS TRASTORNOS INFILTRATIVOS DE LA PIEL Y DEL TEJIDO SUBCUTÁNEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L987",
    "nombre_dx": "L987-Piel y tejido subcutaneo excesiva y redundante",
    "sexo": "A"
  },
  {
    "cod_dx": "L988",
    "nombre_dx": "L988-OTROS TRASTORNOS ESPECIFICADOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L989",
    "nombre_dx": "L989-TRASTORNO DE LA PIEL Y DEL TEJIDO SUBCUTANEO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "L990",
    "nombre_dx": "L990-AMILOIDOSIS DE LA PIEL (E85.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "L998",
    "nombre_dx": "L998-OTROS TRASTORNOS DE LA PIEL Y DEL TEJIDO SUBCUTANEO EN ENFERMEDADES CLASIFICADASEN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M000",
    "nombre_dx": "M000-ARTRITIS Y POLIARTRITIS ESTAFILOCOCICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M001",
    "nombre_dx": "M001-ARTRITIS Y POLIARTRITIS NEUMOCOCICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M002",
    "nombre_dx": "M002-ARTRITIS Y POLIARTRITIS ESTREPTOCOCICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M008",
    "nombre_dx": "M008-ARTRITIS Y POLIARTRITIS DEBIDAS A OTROS AGENTES BACTERIANOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M009",
    "nombre_dx": "M009-ARTRITIS PIOGENA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M010",
    "nombre_dx": "M010-ARTRITISMENINGOCOCICA (A39.8+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M011",
    "nombre_dx": "M011-TUBERCULOSA (A18.0+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M012",
    "nombre_dx": "M012-ARTRITISEN LA ENFERMEDAD DE LYME (A69.2+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M013",
    "nombre_dx": "M013-ARTRITIS EN OTRAS ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M014",
    "nombre_dx": "M014-ARTRITIS EN RUBEOLA (B06.8+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M015",
    "nombre_dx": "M015-ARTRITIS EN OTRAS ENFERMEDADES VIRALES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M016",
    "nombre_dx": "M016-ARTRITIS EN MICOSIS (B35-B49+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M018",
    "nombre_dx": "M018-ARTRITIS EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M020",
    "nombre_dx": "M020-ARTROPATIA CONSECUTIVA A DERIVACION INTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M021",
    "nombre_dx": "M021-ARTROPATIA POSTDISENTERICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M022",
    "nombre_dx": "M022-ARTROPATIA POSTINMUNIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M023",
    "nombre_dx": "M023-ENFERMEDAD DE REITER",
    "sexo": "A"
  },
  {
    "cod_dx": "M028",
    "nombre_dx": "M028-OTRAS ARTROPATIA REACTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M029",
    "nombre_dx": "M029-ARTROPATIA REACTIVA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M030",
    "nombre_dx": "M030-ARTRITIS POSTMENINGOCOCICA (A39.8+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M031",
    "nombre_dx": "M031-ARTROPATIA POSTINFECCIOSA EN SIFILIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M032",
    "nombre_dx": "M032-OTRAS ARTROPATIAS POSTINFECCIOSAS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M036",
    "nombre_dx": "M036-ARTROPATIA REACTIVA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M050",
    "nombre_dx": "M050-SINDROME DE FELTY ",
    "sexo": "A"
  },
  {
    "cod_dx": "M051",
    "nombre_dx": "M051-ENFERMEDAD REUMATOIDE DEL PULMON (J99.0*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M052",
    "nombre_dx": "M052-VASCULITIS REUMATOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M053",
    "nombre_dx": "M053-ARTRITIS REUMATOIDE CON COMPROMISO DE OTROS ORGANOS O SISTEMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M058",
    "nombre_dx": "M058-OTRAS ARTRITIS REUMATOIDEAS SEROPOSITIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M059",
    "nombre_dx": "M059-ARTRITIS REUMATOIDE SEROPOSITIVA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M060",
    "nombre_dx": "M060-ARTRITIS REUMATOIDE SERONEGATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "M061",
    "nombre_dx": "M061-ENFERMEDAD DE STILL DE COMIENZO EN EL ADULTO",
    "sexo": "A"
  },
  {
    "cod_dx": "M062",
    "nombre_dx": "M062-BURSITIS REUMATOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M063",
    "nombre_dx": "M063-NODULO REUMATOIDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M064",
    "nombre_dx": "M064-POLIARTROPATIA INFLAMATORIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M068",
    "nombre_dx": "M068-OTRAS ARTRITIS REUMATOIDEAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M069",
    "nombre_dx": "M069-ARTRITIS REUMATOIDE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M070",
    "nombre_dx": "M070-ARTROPATIA PSORIASICA INTERFALANGICA DISTAL (L40.5+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M071",
    "nombre_dx": "M071-ARTRITIS MUTILANTE (L40.5+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M072",
    "nombre_dx": "M072-ESPONDILITIS PSORIASICA (L40.5+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M073",
    "nombre_dx": "M073-OTRAS ARTROPATIAS PSORIASICAS (L40.5+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M074",
    "nombre_dx": "M074-ARTROPATIA EN LA ENFERMEDAD DE CROHN (ENTERITIS REGIONAL) (K50.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M075",
    "nombre_dx": "M075-ARTROPATIA EN LA COLITIS ULCERATIVA (K51.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M076",
    "nombre_dx": "M076-OTRAS ARTROPATIAS ENTEROPATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M080",
    "nombre_dx": "M080-ARTRITIS REUMATOIDE JUVENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M081",
    "nombre_dx": "M081-ESPONDILITIS ANQUILOSANTE JUVENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M082",
    "nombre_dx": "M082-ARTRITIS JUVENIL DE COMIENZO GENERALIZADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M083",
    "nombre_dx": "M083-POLIARTRITIS JUVENIL (SERONEGATIVA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M084",
    "nombre_dx": "M084-ARTRITIS JUVENIL PAUCIARTICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M088",
    "nombre_dx": "M088-OTRAS ARTRITIS JUVENILES",
    "sexo": "A"
  },
  {
    "cod_dx": "M089",
    "nombre_dx": "M089-ARTRITIS JUVENIL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M090",
    "nombre_dx": "M090-ARTRITIS JUVENIL EN LA PSORIASIS (L40.5+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M091",
    "nombre_dx": "M091-ARTRITIS JUVENIL EN LA ENFERMEDAD DE CROHN [ENTERITIS REGIONAL] (K50.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M092",
    "nombre_dx": "M092-ARTRITIS JUVENIL EN LA COLITIS ULCERATIVA (K51.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M098",
    "nombre_dx": "M098-ARTRITIS JUVENIL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M100",
    "nombre_dx": "M100-GOTA IDIOPATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M101",
    "nombre_dx": "M101-GOTA SATURNINA",
    "sexo": "A"
  },
  {
    "cod_dx": "M102",
    "nombre_dx": "M102-GOTA INDUCIDA POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M103",
    "nombre_dx": "M103-Gota debida a alteración de la función renal",
    "sexo": "A"
  },
  {
    "cod_dx": "M104",
    "nombre_dx": "M104-OTRAS GOTASSECUNDARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M109",
    "nombre_dx": "M109-GOTA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M110",
    "nombre_dx": "M110-ENFERMEDAD POR DEPOSITO DE HIDROXIAPATITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M111",
    "nombre_dx": "M111-CONDROCALCINOSIS FAMILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M112",
    "nombre_dx": "M112-OTRAS CONDROCALCINOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M118",
    "nombre_dx": "M118-OTRAS ARTROPATIAS POR CRISTALES, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M119",
    "nombre_dx": "M119-ARTROPATIA POR CRISTALES, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M120",
    "nombre_dx": "M120-ARTROPATIA POSTREUMATICA CRONICA [DE JACCOUD] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M121",
    "nombre_dx": "M121-ENFERMEDAD DE KASCHIN-BECK",
    "sexo": "A"
  },
  {
    "cod_dx": "M122",
    "nombre_dx": "M122-SINOVITIS VELLONODULAR (PIGMENTADA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M123",
    "nombre_dx": "M123-REUMATISMO PALINDROMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M124",
    "nombre_dx": "M124-HIDRARTROSIS INTERMITENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M125",
    "nombre_dx": "M125-ARTROPATIA TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M128",
    "nombre_dx": "M128-OTRAS ARTROPATIAS ESPECIFICAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M130",
    "nombre_dx": "M130-POLIARTRITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M131",
    "nombre_dx": "M131-MONOARTRITIS, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M138",
    "nombre_dx": "M138-OTRAS ARTRITIS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M139",
    "nombre_dx": "M139-ARTRITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M140",
    "nombre_dx": "M140-ARTROPATIA GOTOSA DEBIDA A DEFECTOS ENZIMATICOS Y A OTROS TRASTORNOS HEREDITARIOS, CLASIFICADOS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "M141",
    "nombre_dx": "M141-ARTROPATIA POR CRISTALES EN OTROS TRASTORNOS METABÓLICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M142",
    "nombre_dx": "M142-ARTROPATIA DIABETICA (E10-E14+ CON CUARTO CARÁCTER COMUN .6)",
    "sexo": "A"
  },
  {
    "cod_dx": "M143",
    "nombre_dx": "M143-DERMATOARTRITIS LIPOIDE (E78.8+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M144",
    "nombre_dx": "M144-ARTROPATIA EN LA AMILOIDOSIS (E85.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M145",
    "nombre_dx": "M145-ARTROPATIA EN OTROS TRASTORNOS ENDOCRINOS, METABOLICOS Y NUTRICIONALES",
    "sexo": "A"
  },
  {
    "cod_dx": "M146",
    "nombre_dx": "M146-ARTROPATIA NEUROPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M148",
    "nombre_dx": "M148-ARTROPATIA EN OTRAS ENFERMEDADES ESPECIFICADAS, CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M150",
    "nombre_dx": "M150-(OSTEO)ARTROSIS PRIMARIA GENERALIZADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M151",
    "nombre_dx": "M151-NODULOS DE HEBERDEN (CON ARTROPATIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "M152",
    "nombre_dx": "M152-NODULOS DE BOUCHARD (CON ARTROPATIA)",
    "sexo": "A"
  },
  {
    "cod_dx": "M153",
    "nombre_dx": "M153-ARTROSIS SECUNDARIA MULTIPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "M154",
    "nombre_dx": "M154-(OSTEO)ARTROSIS EROSIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M158",
    "nombre_dx": "M158-OTRAS POLIARTROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M159",
    "nombre_dx": "M159-POLIARTROSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M160",
    "nombre_dx": "M160-COXARTROSIS PRIMARIA, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M161",
    "nombre_dx": "M161-OTRAS COXARTROSIS PRIMARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M162",
    "nombre_dx": "M162-COXARTROSIS A CONSECUENCIA DE DISPLASIA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M163",
    "nombre_dx": "M163-OTRAS COXARTROSIS DISPLASICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M164",
    "nombre_dx": "M164-COXARTROSIS POSTRAUMATICA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M165",
    "nombre_dx": "M165-OTRA COXARTROSIS POSTRAUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M166",
    "nombre_dx": "M166-OTRA COXARTROSIS SECUNDARIA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M167",
    "nombre_dx": "M167-OTRAS COXARTROSIS SECUNDARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M169",
    "nombre_dx": "M169-COXARTROSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M170",
    "nombre_dx": "M170-GONARTROSIS PRIMARIA, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M171",
    "nombre_dx": "M171-OTRAS GONARTROSIS PRIMARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M172",
    "nombre_dx": "M172-GONARTROSIS POSTRAUMATICA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M173",
    "nombre_dx": "M173-OTRAS GONARTROSIS POSTRAUMATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M174",
    "nombre_dx": "M174-OTRAS GONARTROSIS SECUNDARIAS, BILATERALES",
    "sexo": "A"
  },
  {
    "cod_dx": "M175",
    "nombre_dx": "M175-OTRAS GONARTROSIS SECUNDARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M179",
    "nombre_dx": "M179-GONARTROSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M180",
    "nombre_dx": "M180-ARTROSIS PRIMARIA DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M181",
    "nombre_dx": "M181-OTRAS ARTROSIS PRIMARIAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M182",
    "nombre_dx": "M182-ARTROSIS POSTRAUMATICA DE LA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M183",
    "nombre_dx": "M183-OTRAS ARTROSIS POSTRAUMATICAS DE LA PRIMERA ARTICULACION CARPOMETACARPIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "M184",
    "nombre_dx": "M184-OTRAS ARTROSIS SECUNDARIAS DELA PRIMERA ARTICULACION CARPOMETACARPIANA, BILATERALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M185",
    "nombre_dx": "M185-OTRAS ARTROSIS SECUNDARIAS DELA PRIMERA ARTICULACION CARPOMETACARPIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "M189",
    "nombre_dx": "M189-ARTROSISDE LA PRIMERA ARTICULACION CARPOMETACARPIANA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M190",
    "nombre_dx": "M190-ARTROSIS PRIMARIA DE OTRAS ARTICULACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M191",
    "nombre_dx": "M191-ARTROSIS POSTRAUMATICA DE OTRAS ARTICULACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "M192",
    "nombre_dx": "M192-ARTROSIS SECUNDARIA DE OTRAS ARTICULACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M198",
    "nombre_dx": "M198-OTRAS ARTROSIS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M199",
    "nombre_dx": "M199-ARTROSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M200",
    "nombre_dx": "M200-DEFORMIDAD DE DEDO(S) DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "M201",
    "nombre_dx": "M201-HALLUX VALGUS (ADQUIRIDO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M202",
    "nombre_dx": "M202-HALLUX RIGIDUS",
    "sexo": "A"
  },
  {
    "cod_dx": "M203",
    "nombre_dx": "M203-OTRAS DEFORMIDADES DEL HALLUX (ADQUIRIDAS)",
    "sexo": "A"
  },
  {
    "cod_dx": "M204",
    "nombre_dx": "M204-OTRO(S) DEDO(S) DEL PIE EN MARTILLO (ADQUIRIDOS)",
    "sexo": "A"
  },
  {
    "cod_dx": "M205",
    "nombre_dx": "M205-OTRAS DEFORMIDADES (ADQUIRIDAS) DEL (DE LOS) DEDO(S) DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "M206",
    "nombre_dx": "M206-DEFORMIDADES ADQUIRIDAS DE LOS DEDOS DEL PIE,NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M210",
    "nombre_dx": "M210-DEFORMIDAD EN VALGO, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M211",
    "nombre_dx": "M211-DEFORMIDAD EN VARO, NO CLASIFICADA EN OTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "M212",
    "nombre_dx": "M212-DEFORMIDAD EN FLEXION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M213",
    "nombre_dx": "M213-MUÑECA O PIE EN PENDULO (ADQUIRIDO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M214",
    "nombre_dx": "M214-PIE PLANO [PES PLANUS] (ADQUIRIDO)",
    "sexo": "A"
  },
  {
    "cod_dx": "M215",
    "nombre_dx": "M215-MANO O PIE EN GARRA O EN TALIPES, PIE EQUINOVARO O ZAMBO ADQUIRIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M216",
    "nombre_dx": "M216-OTRAS DEFORMIDADES ADQUIRIDAS DEL TOBILLO Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M217",
    "nombre_dx": "M217-LONGITUD DESIGUAL DE LOS MIEMBROS (ADQUIRIDA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M218",
    "nombre_dx": "M218-OTRAS DEFORMIDADES ADQUIRIDAS DE LOS MIEMBROS, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M219",
    "nombre_dx": "M219-DEFORMIDAD ADQUIRIDA DEL MIEMBRO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M220",
    "nombre_dx": "M220-LUXACION RECIDIVANTE DE LAROTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "M221",
    "nombre_dx": "M221-SUBLUXACION RECIDIVANTE DE LA ROTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "M222",
    "nombre_dx": "M222-TRASTORNOS ROTULOFEMORALES",
    "sexo": "A"
  },
  {
    "cod_dx": "M223",
    "nombre_dx": "M223-OTROS DESARREGLOS DE LA ROTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "M224",
    "nombre_dx": "M224-CONDROMALACIA DE LA ROTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "M228",
    "nombre_dx": "M228-OTROS TRASTORNOS DE LA ROTULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M229",
    "nombre_dx": "M229-TRASTORNO DE LA ROTULA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M230",
    "nombre_dx": "M230-MENISCO QUISTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "M231",
    "nombre_dx": "M231-MENISCO DISCOIDE (CONGENITO)",
    "sexo": "A"
  },
  {
    "cod_dx": "M232",
    "nombre_dx": "M232-TRASTORNO DEL MENISCO DEBIDO A DESGARRO O LESION ANTIGUA",
    "sexo": "A"
  },
  {
    "cod_dx": "M233",
    "nombre_dx": "M233-OTROS TRASTORNOS DE LOS MENISCOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M234",
    "nombre_dx": "M234-CUERPO FLOTANTE EN LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M235",
    "nombre_dx": "M235-INESTABILIDAD CRONICA DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M236",
    "nombre_dx": "M236-OTRA RUPTURA ESPONTANEA DEL (DE LOS) LIGAMENTO(S) DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M238",
    "nombre_dx": "M238-OTROS TRASTORNOS INTERNOS DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M239",
    "nombre_dx": "M239-TRASTORNOS INTERNO DE LA RODILLA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M240",
    "nombre_dx": "M240-CUERPO FLOTANTE ARTICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M241",
    "nombre_dx": "M241-OTROS TRASTORNOS DEL CARTILAGO ARTICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M242",
    "nombre_dx": "M242-TRASTORNO DEL LIGAMENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M243",
    "nombre_dx": "M243-LUXACION Y SUBLUXACION PATOLOGICA DE LA ARTICULACION, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M244",
    "nombre_dx": "M244-LUXACION Y SUBLUXACION RECIDIVANTE DE LA ARTICULACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M245",
    "nombre_dx": "M245-CONTRACTURA ARTICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M246",
    "nombre_dx": "M246-ANQUILOSIS ARTICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M247",
    "nombre_dx": "M247-PROTRUSION DE ACETABULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M248",
    "nombre_dx": "M248-OTRAS LESIONES ARTICULADAS ESPECIFICADAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M249",
    "nombre_dx": "M249-DESARREGLO ARTICULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M250",
    "nombre_dx": "M250-HEMARTROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M251",
    "nombre_dx": "M251-FISTULA ARTICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M252",
    "nombre_dx": "M252-ARTICULACION INESTABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "M253",
    "nombre_dx": "M253-OTRAS INESTABILIDADESARTICULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "M254",
    "nombre_dx": "M254-DERRAME ARTICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M255",
    "nombre_dx": "M255-DOLOR EN ARTICULACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M256",
    "nombre_dx": "M256-RIGIDEZ ARTICULAR, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M257",
    "nombre_dx": "M257-OSTEOFITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M258",
    "nombre_dx": "M258-OTROS TRASTORNOS ARTICULARES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M259",
    "nombre_dx": "M259-TRASTORNO ARTICULAR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M300",
    "nombre_dx": "M300-POLIARTERITIS NUDOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "M301",
    "nombre_dx": "M301-POLIARTERITISCON COMPROMISO PULMONAR [CHURG-STRAUSS]",
    "sexo": "A"
  },
  {
    "cod_dx": "M302",
    "nombre_dx": "M302-POLIARTERITIS JUVENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M303",
    "nombre_dx": "M303-SINDROME MUCOCUTANEO LIFONODULAR [KAWASAKI] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M308",
    "nombre_dx": "M308-OTRAS AFECCIONES RELACIONADAS CON LA POLIARTERITIS NUDOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M310",
    "nombre_dx": "M310-ANGIITIS DEBIDA A HIPERSENSIBILIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "M311",
    "nombre_dx": "M311-MICROANGIOPATIA TROMBOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M312",
    "nombre_dx": "M312-GRANULOMA LETAL DE LA LINEA MEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M313",
    "nombre_dx": "M313-GRANULOMATOSIS DE WEGENER ",
    "sexo": "A"
  },
  {
    "cod_dx": "M314",
    "nombre_dx": "M314-SINDROME DEL CAYADO DE LA AORTA [TAKAYASU]",
    "sexo": "A"
  },
  {
    "cod_dx": "M315",
    "nombre_dx": "M315-ARTERITIS DECELULAS GIGANTES CON POLIMIALGIA REUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M316",
    "nombre_dx": "M316-OTRAS ARTERITIS DE CELULAS GIGANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M318",
    "nombre_dx": "M318-OTRAS VASCULOPATIAS NECROTIZANTES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M319",
    "nombre_dx": "M319-VASCULOPATIA NECROTIZANTE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M320",
    "nombre_dx": "M320-LUPUS ERITEMATOSO SISTEMICO, INDUCIDO POR DROGAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M321",
    "nombre_dx": "M321-LUPUS ERITEMATOSO SISTEMICO CON COMPROMISO DE ORGANOS O SISTEMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M328",
    "nombre_dx": "M328-OTRAS FORMAS DE LUPUS ERITEMATOSO SISTEMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M329",
    "nombre_dx": "M329-LUPUS ERITEMATOSO SISTEMICO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "M330",
    "nombre_dx": "M330-DERMATOMIOSITIS JUVENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M331",
    "nombre_dx": "M331-OTRAS DERMATOMIOSITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M332",
    "nombre_dx": "M332-POLIMIOSITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M339",
    "nombre_dx": "M339-DERMATOPOLIMIOSITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M340",
    "nombre_dx": "M340-ESCLEROSIS SISTEMICA PROGRESIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M341",
    "nombre_dx": "M341-SINDROME CR(E)ST",
    "sexo": "A"
  },
  {
    "cod_dx": "M342",
    "nombre_dx": "M342-ESCLEROSIS SISTEMICA INDUCIDA POR DROGAS O PRODUCTOS QUIMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M348",
    "nombre_dx": "M348-OTRAS FORMASDE ESCLEROSIS SISTEMICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M349",
    "nombre_dx": "M349-ESCLEROSIS SISTEMICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M350",
    "nombre_dx": "M350-SINDROME SECO [SJÖGREN] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M351",
    "nombre_dx": "M351-OTROS SINDROMES SUPERPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M352",
    "nombre_dx": "M352-ENFERMEDAD DE BEHCET",
    "sexo": "A"
  },
  {
    "cod_dx": "M353",
    "nombre_dx": "M353-POLIMIALGIA REUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M354",
    "nombre_dx": "M354-FASCITIS DIFUSA (EOSINOFILICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "M355",
    "nombre_dx": "M355-FIBROSCLEROSIS MULTIFOCAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M356",
    "nombre_dx": "M356-PANICULITIS RECIDIVANTE [WEBER-CHRISTIAN] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M357",
    "nombre_dx": "M357-SINDROME DE HIPERMOVILIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "M358",
    "nombre_dx": "M358-OTRAS ENFERMEDADES ESPECIFICADAS CON COMPROMISO SISTEMICO DEL TEJIDO CONJUNTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M359",
    "nombre_dx": "M359-COMPROMISO SISTEMICO DEL TEJIDO CONJUNTIVO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M360",
    "nombre_dx": "M360-DERMATO(POLI)MIOSITIS EN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M361",
    "nombre_dx": "M361-ARTROPATIA EN ENFERMEDAD NEOPLASICA (C00-D48+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M362",
    "nombre_dx": "M362-ARTROPATIA HEMOFILICA (D66-D68+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M363",
    "nombre_dx": "M363-ARTROPATIA EN OTROS TRASTORNOS DE LA SANGRE (D50-D76+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M364",
    "nombre_dx": "M364-ARTROPATIA EN REACCIONES DE HIPERSENSIBILIDAD CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M368",
    "nombre_dx": "M368-TRASTORNOS SISTEMICOS DEL TEJIDO CONJUNTIVO EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M400",
    "nombre_dx": "M400-CIFOSIS POSTURAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M401",
    "nombre_dx": "M401-OTRAS CIFOSIS SECUNDARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M402",
    "nombre_dx": "M402-OTRAS CIFOSIS Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M403",
    "nombre_dx": "M403-SINDROME DE ESPALDA PLANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M404",
    "nombre_dx": "M404-OTRAS LORDOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M405",
    "nombre_dx": "M405-LORDOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M410",
    "nombre_dx": "M410-ESCOLIOSIS IDIOPATICA INFANTIL",
    "sexo": "A"
  },
  {
    "cod_dx": "M411",
    "nombre_dx": "M411-ESCOLIOSIS IDIOPATICA JUVENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M412",
    "nombre_dx": "M412-OTRAS ESCOLIOSIS IDIOPATICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M413",
    "nombre_dx": "M413-ESCOLIOSIS TORACOGENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M414",
    "nombre_dx": "M414-ESCOLIOSIS NEUROMUSCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M415",
    "nombre_dx": "M415-OTRAS ESCOLIOSIS SECUNDARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M418",
    "nombre_dx": "M418-OTRAS FORMAS DE ESCOLIOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M419",
    "nombre_dx": "M419-ESCOLIOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M420",
    "nombre_dx": "M420-OSTEOCONDROSIS JUVENIL DE LA COLUMNA VERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M421",
    "nombre_dx": "M421-OSTEOCONDROSISDE LA COLUMNA VERTEBRAL DEL ADULTO",
    "sexo": "A"
  },
  {
    "cod_dx": "M429",
    "nombre_dx": "M429-OSTEOCONDROSISVERTEBRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M430",
    "nombre_dx": "M430-ESPONDILOLISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M431",
    "nombre_dx": "M431-ESPONDILOLISTESIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M432",
    "nombre_dx": "M432-OTRAS FUSIONES COLUMNA VERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M433",
    "nombre_dx": "M433-SUBLUXACION ATLANTO-AXOIDEA RECURRENTE, CON MIELOPATIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M434",
    "nombre_dx": "M434-OTRAS SUBLUXACIONESATLANTO-AXOIDEAS RECURRENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M435",
    "nombre_dx": "M435-OTRAS SUBLUXACIONESVERTEBRALES RECURRENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "M436",
    "nombre_dx": "M436-TORTICOLIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M438",
    "nombre_dx": "M438-OTRAS DORSOPATIAS DEFORMANTESDE LA COLUMNAVERTEBRAL ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M439",
    "nombre_dx": "M439-DORSOPATIADEFORMANTE,NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M450",
    "nombre_dx": "M450-Espondilitis anquilosante, sitios múltiples de la columna vertebral",
    "sexo": "A"
  },
  {
    "cod_dx": "M451",
    "nombre_dx": "M451-Espondilitis anquilosante, región occipitocervical ",
    "sexo": "A"
  },
  {
    "cod_dx": "M452",
    "nombre_dx": "M452-Espondilitis anquilosante, región cervical",
    "sexo": "A"
  },
  {
    "cod_dx": "M453",
    "nombre_dx": "M453-Espondilitis anquilosante, región cervicotorácica",
    "sexo": "A"
  },
  {
    "cod_dx": "M454",
    "nombre_dx": "M454-Espondilitis anquilosante, región torácica",
    "sexo": "A"
  },
  {
    "cod_dx": "M455",
    "nombre_dx": "M455-Espondilitis anquilosante, región toracolumbar",
    "sexo": "A"
  },
  {
    "cod_dx": "M456",
    "nombre_dx": "M456-Espondilitis anquilosante, región lumbar",
    "sexo": "A"
  },
  {
    "cod_dx": "M457",
    "nombre_dx": "M457-Espondilitis anquilosante, región lumbosacra",
    "sexo": "A"
  },
  {
    "cod_dx": "M458",
    "nombre_dx": "M458-M458Espondilitis anquilosante, región sacra y sacrococcígea",
    "sexo": "A"
  },
  {
    "cod_dx": "M459",
    "nombre_dx": "M459-Espondilitis anquilosante, sitio no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "M460",
    "nombre_dx": "M460-ENTESOPATIA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M461",
    "nombre_dx": "M461-SACROILIITIS,NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M462",
    "nombre_dx": "M462-OSTEOMIELITIS DE VERTEBRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M463",
    "nombre_dx": "M463-INFECCION DE DISCO INTERVERTEBRAL (PIOGENA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M464",
    "nombre_dx": "M464-DISCITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M465",
    "nombre_dx": "M465-OTRAS ESPONDILOPATIAS INFECCIOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M468",
    "nombre_dx": "M468-OTRAS ESPONDILOPATIAS INFLAMATORIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M469",
    "nombre_dx": "M469-ESPONDILOPATIA INFLAMATORIA, NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M470",
    "nombre_dx": "M470-SINDROMES DE COMPRESION DE LA ARTERIA ESPINAL O VERTEBRAL ANTERIOR (G99.2*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M471",
    "nombre_dx": "M471-OTRAS ESPONDILOSIS CON MIELOPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M472",
    "nombre_dx": "M472-OTRAS ESPONDILOSIS CON RADICULOPATIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M478",
    "nombre_dx": "M478-OTRAS ESPONDILOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M479",
    "nombre_dx": "M479-ESPONDILOSIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M480",
    "nombre_dx": "M480-ESTENOSIS ESPINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M481",
    "nombre_dx": "M481-HIPEROSTOSIS ANQUILOSANTE [FORESTIER] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M482",
    "nombre_dx": "M482-ESPONDILOPATIAINTERESPINOSA (VERTEBRAS EN BESO) \"\"",
    "sexo": "A"
  },
  {
    "cod_dx": "M483",
    "nombre_dx": "M483-ESPONDILOPATIA TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M484",
    "nombre_dx": "M484-FRACTURA DE VERTEBRA POR FATIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M485",
    "nombre_dx": "M485-VERTEBRA COLAPSADA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M488",
    "nombre_dx": "M488-OTRAS ESPONDILOPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M489",
    "nombre_dx": "M489-ESPONDILOPATIA , NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M490",
    "nombre_dx": "M490-TUBERCULOSIS DE LA COLUMNA VERTEBRAL (A180+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M491",
    "nombre_dx": "M491-ESPONDILITIS POR BRUCELOSIS (A23.-+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M492",
    "nombre_dx": "M492-ESPONDILITIS POR ENTEROBACTERIAS (A01-A04+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M493",
    "nombre_dx": "M493-ESPONDILOPATIA EN OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M494",
    "nombre_dx": "M494-ESPONDILOPATIA NEUROPATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M495",
    "nombre_dx": "M495-VERTEBRA COLAPSADA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M498",
    "nombre_dx": "M498-ESPONDILOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M500",
    "nombre_dx": "M500-TRASTORNO DE DISCO CERVICAL CON MIELOPATIA (G99.2*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M501",
    "nombre_dx": "M501-TRASTORNO DE DISCO CERVICAL CON RADICULOPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M502",
    "nombre_dx": "M502-OTROS DESPLAZAMIENTOS DEL DISCO CERVICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M503",
    "nombre_dx": "M503-OTRAS DEGENERACIONES DEL DISCO CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M508",
    "nombre_dx": "M508-OTROS TRASTORNOS DEL DISCO CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M509",
    "nombre_dx": "M509-TRASTORNO DE DISCO CERVICAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M510",
    "nombre_dx": "M510-TRASTORNOS DE DISCOS INTERVERTEBRALES LUMBARES Y OTROS, CON MIELOPATIA (G99.2*) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M511",
    "nombre_dx": "M511-TRASTORNO DE DISCOLUMBAR Y OTROS, CON RADICULOPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M512",
    "nombre_dx": "M512-OTROS DESPLAZAMIENTOS DEL DISCO INTERVERTEBRAL,ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M513",
    "nombre_dx": "M513-OTRAS DEGENERACIONES ESPECIFICADAS DE DISCO INTERVERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M514",
    "nombre_dx": "M514-NODULOS DE SCHMORL",
    "sexo": "A"
  },
  {
    "cod_dx": "M518",
    "nombre_dx": "M518-OTROS TRASTORNOS ESPECIFICADOS DE LOS DISCOS INTERVERTEBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M519",
    "nombre_dx": "M519-TRASTORNOS DE LOS DISCOS INTERVERTEBRALES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M530",
    "nombre_dx": "M530-SINDROME CERVICOCRANEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M531",
    "nombre_dx": "M531-SINDROME CERVICOBRAQUIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M532",
    "nombre_dx": "M532-INESTABILIDAD DE LA COLUMNA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M533",
    "nombre_dx": "M533-TRASTORNOS SACROCOCCIGEOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M538",
    "nombre_dx": "M538-OTRAS DORSOPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M539",
    "nombre_dx": "M539-DORSOPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M540",
    "nombre_dx": "M540-PANICULITIS QUE AFECTA REGIONES DEL CUELLO Y DE LA ESPALDA",
    "sexo": "A"
  },
  {
    "cod_dx": "M541",
    "nombre_dx": "M541-RADICULOPATIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M542",
    "nombre_dx": "M542-CERVICALGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M543",
    "nombre_dx": "M543-CIATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M544",
    "nombre_dx": "M544-LUMBAGO CON CIATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M545",
    "nombre_dx": "M545-LUMBAGO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M546",
    "nombre_dx": "M546-DOLOR EN LA COLUMNA DORSAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M548",
    "nombre_dx": "M548-OTRAS DORSALGIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M549",
    "nombre_dx": "M549-DORSALGIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M600",
    "nombre_dx": "M600-MIOSITIS INFECCIOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M601",
    "nombre_dx": "M601-MIOSITIS INTERSTICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M602",
    "nombre_dx": "M602-GRANULOMA POR CUERPO EXTRAÑO EN TEJIDO BLANDO, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M608",
    "nombre_dx": "M608-OTRAS MIOSITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M609",
    "nombre_dx": "M609-MIOSITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M610",
    "nombre_dx": "M610-MIOSITIS OSIFICANTE TRAUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M611",
    "nombre_dx": "M611-MIOSITIS OSIFICANTE PROGRESIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "M612",
    "nombre_dx": "M612-CALCIFICACION Y OSIFICACION PARALITICA DEL MUSCULO",
    "sexo": "A"
  },
  {
    "cod_dx": "M613",
    "nombre_dx": "M613-CALCIFICACION Y OSIFICACION DE LOSMUSCULOS ASOCIADAS CON QUEMADURAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M614",
    "nombre_dx": "M614-OTRAS CALCIFICACIONES DEL MUSCULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M615",
    "nombre_dx": "M615-OTRAS OSIFICACIONES DEL MUSCULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M619",
    "nombre_dx": "M619-CALCIFICACION Y OSIFICACION DELMUSCULO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M620",
    "nombre_dx": "M620-DIASTASIS DEL MUSCULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M621",
    "nombre_dx": "M621-OTROS DESGARROS (NO TRAUMATICOS) DEL MUSCULO",
    "sexo": "A"
  },
  {
    "cod_dx": "M622",
    "nombre_dx": "M622-INFARTO ISQUEMICO DEL MUSCULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M623",
    "nombre_dx": "M623-SINDROME DE INMOVILIDAD (PARAPLEJICO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M624",
    "nombre_dx": "M624-CONTRACTURA MUSCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M625",
    "nombre_dx": "M625-ATROFIA Y DESGASTE MUSCULARES, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M626",
    "nombre_dx": "M626-DISTENSION MUSCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M628",
    "nombre_dx": "M628-OTROS TRASTORNOS ESPECIFICADOS DE LOS MUSCULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M629",
    "nombre_dx": "M629-TRASTORNO MUSCULAR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M630",
    "nombre_dx": "M630-MIOSITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M631",
    "nombre_dx": "M631-MIOSITIS EN INFECCIONES POR PROTOZOARIOS Y PARASITOS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M632",
    "nombre_dx": "M632-MIOSITIS EN ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M633",
    "nombre_dx": "M633-MIOSITIS EN SARCOIDOSIS (D86.8+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M638",
    "nombre_dx": "M638-OTROS TRASTORNOS DE LOS MUSCULOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M650",
    "nombre_dx": "M650-ABSCESO DE VAINA TENDINOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "M651",
    "nombre_dx": "M651-OTRAS (TENO) SINOVITIS INFECCIOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M652",
    "nombre_dx": "M652-TENDINITIS CALCIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M653",
    "nombre_dx": "M653-DEDO EN GATILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M654",
    "nombre_dx": "M654-TENOSINOVITIS DE ESTILOIDES RADIAL [DE QUERVAIN]",
    "sexo": "A"
  },
  {
    "cod_dx": "M658",
    "nombre_dx": "M658-OTRAS SINOVITIS Y TENOSINOVITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M659",
    "nombre_dx": "M659-SINOVITIS Y TENOSINOVITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M660",
    "nombre_dx": "M660-RUPTURA DE QUISTE SINOVIAL POPLITEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M661",
    "nombre_dx": "M661-RUPTURA DE LA SINOVIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M662",
    "nombre_dx": "M662-RUPTURA ESPONTANEA DETENDONES EXTENSORES",
    "sexo": "A"
  },
  {
    "cod_dx": "M663",
    "nombre_dx": "M663-RUPTURA ESPONTANEA DETENDONES FLEXORES",
    "sexo": "A"
  },
  {
    "cod_dx": "M664",
    "nombre_dx": "M664-RUPTURA ESPONTANEA DE OTROS TENDONES",
    "sexo": "A"
  },
  {
    "cod_dx": "M665",
    "nombre_dx": "M665-RUPTURA ESPONTANEA DE TENDON NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M670",
    "nombre_dx": "M670-ACORTAMIENTO DEL TENDON DE AQUILES (ADQUIRIDO)",
    "sexo": "A"
  },
  {
    "cod_dx": "M671",
    "nombre_dx": "M671-OTRAS CONTRACTURAS DE TENDON (VAINA)",
    "sexo": "A"
  },
  {
    "cod_dx": "M672",
    "nombre_dx": "M672-HIPERTROFIA SINOVIAL, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M673",
    "nombre_dx": "M673-SINOVITIS TRANSITORIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M674",
    "nombre_dx": "M674-GANGLION",
    "sexo": "A"
  },
  {
    "cod_dx": "M678",
    "nombre_dx": "M678-OTROS TRASTORNOS ESPECIFICADOS DE LA SINOVIA Y DEL TENDON ",
    "sexo": "A"
  },
  {
    "cod_dx": "M679",
    "nombre_dx": "M679-HIPERTROFIA SINOVIAL Y TENDINOSO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M680",
    "nombre_dx": "M680-SINOVITISY TENOSINOVITIS EN ENFERMEDADES BACTERIANAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M688",
    "nombre_dx": "M688-OTROS TRASTORNOS SINOVIALES Y TENDINOSOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M700",
    "nombre_dx": "M700-SINOVITIS CREPITANTE CRONICADE LA MANO Y DE LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M701",
    "nombre_dx": "M701-BURSITISDE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "M702",
    "nombre_dx": "M702-BURSITIS DEL OLECRANON",
    "sexo": "A"
  },
  {
    "cod_dx": "M703",
    "nombre_dx": "M703-OTRAS BURSITIS DEL CODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M704",
    "nombre_dx": "M704-OTRAS BURSITIS PRERROTULIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M705",
    "nombre_dx": "M705-OTRAS BURSITIS DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "M706",
    "nombre_dx": "M706-BURSITIS DEL TROCANTER",
    "sexo": "A"
  },
  {
    "cod_dx": "M707",
    "nombre_dx": "M707-OTRAS BURSITIS DE LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M708",
    "nombre_dx": "M708-OTROS TRASTORNOS DE LOS TEJIDOS BLANDOS RELACIONADOS CON ELUSO, EL USO EXCESIVO Y LA PRESION",
    "sexo": "A"
  },
  {
    "cod_dx": "M709",
    "nombre_dx": "M709-TRASTORNO NO ESPECIFICADO DE LOS TEJIDOS BLANDOS RELACIONADO CON EL USO EXCESIVO Y LA PRESION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M710",
    "nombre_dx": "M710-ABSCESO DE LA BOLSA SINOVIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M711",
    "nombre_dx": "M711-OTRAS BURSITISINFECCIOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M712",
    "nombre_dx": "M712-QUISTE SINOVIAL DEL HUECO POPLITEO [DE BAKER] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M713",
    "nombre_dx": "M713-OTROS QUISTES DE LA BOLSA SEROSA",
    "sexo": "A"
  },
  {
    "cod_dx": "M714",
    "nombre_dx": "M714-DEPOSITO DE CALCIO EN LA BOLSA SEROSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M715",
    "nombre_dx": "M715-OTRAS BURSITIS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M718",
    "nombre_dx": "M718-OTROS TRASTORNOS ESPECIFICADOS DE LA BOLSA SEROSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M719",
    "nombre_dx": "M719-BURSOPATIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M720",
    "nombre_dx": "M720-FIBROMATOSIS DE LA APONEUROSIS PALMAR [DUPUYTREN] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M721",
    "nombre_dx": "M721-NODULOS INTERFALANGICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M722",
    "nombre_dx": "M722-FIBROMATOSIS DE LA APONEUROSIS PLANTAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M723",
    "nombre_dx": "M723-FASCITIS NODULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "M724",
    "nombre_dx": "M724-FIBROMATOSIS SEUDOSARCOMATOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M725",
    "nombre_dx": "M725-FASCITIS, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M728",
    "nombre_dx": "M728-OTROS TRASTORNOS FIBROBLASTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M729",
    "nombre_dx": "M729-TRASTORNO FIBROBLASTICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M730",
    "nombre_dx": "M730-BURSITIS GONOCOCICA (A54.4+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M731",
    "nombre_dx": "M731-BURSITIS SIFILITICA (A52.7+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M738",
    "nombre_dx": "M738-OTROS TRASTORNOS DE LOS TEJIDOS BLANDOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M750",
    "nombre_dx": "M750-CAPSULITIS ADHESIVA DEL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "M751",
    "nombre_dx": "M751-SINDROME DE MANGUITO ROTATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "M752",
    "nombre_dx": "M752-TENDINITIS DE BICEPS",
    "sexo": "A"
  },
  {
    "cod_dx": "M753",
    "nombre_dx": "M753-TENDINITIS CALCIFICANTE DEL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "M754",
    "nombre_dx": "M754-SINDROME DE ABDUCCION DOLOROSA DEL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M755",
    "nombre_dx": "M755-BURSITIS DEL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M758",
    "nombre_dx": "M758-OTRAS LESIONES DEL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M759",
    "nombre_dx": "M759-LESIONES DEL HOMBRO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M760",
    "nombre_dx": "M760-TENDINITIS DEL GLUTEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M761",
    "nombre_dx": "M761-TENDINITIS DEL PSOAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M762",
    "nombre_dx": "M762-ESPOLON DE LA CRESTA ILIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M763",
    "nombre_dx": "M763-SINDROME DEL TENDON DELTENSOR DE LA FASCIA LATA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M764",
    "nombre_dx": "M764-BURSITIS TIBIAL COLATERAL [PELLEGRINI-STIEDA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M765",
    "nombre_dx": "M765-TENDINITIS ROTULIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "M766",
    "nombre_dx": "M766-TENDINITIS AQUILIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "M767",
    "nombre_dx": "M767-TENDINITIS PERONEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M768",
    "nombre_dx": "M768-OTRAS ENTESOPATIAS DEL MIEMBRO INFERIOR, EXCLUIDO EL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "M769",
    "nombre_dx": "M769-ENTESOPATIA DEL MIEMBRO INFERIOR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M770",
    "nombre_dx": "M770-EPICONDILITIS MEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M771",
    "nombre_dx": "M771-EPICONDILITIS LATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M772",
    "nombre_dx": "M772-PERIARTRITIS DE LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M773",
    "nombre_dx": "M773-ESPOLON CALCANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "M774",
    "nombre_dx": "M774-METATARSALGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M775",
    "nombre_dx": "M775-OTRAS ENTESOPATIAS DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "M778",
    "nombre_dx": "M778-OTRAS ENTESOPATIAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M779",
    "nombre_dx": "M779-ENTESOPATIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M790",
    "nombre_dx": "M790-REUMATISMO, NOESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M791",
    "nombre_dx": "M791-MIALGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M792",
    "nombre_dx": "M792-NEURALGIA Y NEURITIS, NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M793",
    "nombre_dx": "M793-PANICULITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M794",
    "nombre_dx": "M794-HIPERTROFIA DE PAQUETE ADIPOSO (INFRARROTULIANO)",
    "sexo": "A"
  },
  {
    "cod_dx": "M795",
    "nombre_dx": "M795-CUERPO EXTRAÑO RESIDUAL EN TEJIDO BLANDO",
    "sexo": "A"
  },
  {
    "cod_dx": "M796",
    "nombre_dx": "M796-DOLOR EN MIEMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "M797",
    "nombre_dx": "M797-FIBROMIALGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M798",
    "nombre_dx": "M798-OTROS TRASTORNOS ESPECIFICADOS DE LOSTEJIDOS BLANDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M799",
    "nombre_dx": "M799-TRASTORNO DE LOS TEJIDOS BLANDOS, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M800",
    "nombre_dx": "M800-OSTEOPOROSIS POSTMENOPAUSICA, CON FRACTURA PATOLOGICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "M801",
    "nombre_dx": "M801-OSTEOPOROSIS POSTOOFORECTOMIA, CON FRACTURA PATOLOGICA",
    "sexo": "F"
  },
  {
    "cod_dx": "M802",
    "nombre_dx": "M802-OSTEOPOROSIS POR DESUSO, CON FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M803",
    "nombre_dx": "M803-OSTEOPOROSIS POR MALABSORCION POSTQUIRURGICA, CON FRACTURAPATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M804",
    "nombre_dx": "M804-OSTEOPOROSIS INDUCIDA POR DROGAS, CON FRACTURA PATOLOGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M805",
    "nombre_dx": "M805-OSTEOPOROSIS IDIOPATICA, CON FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M808",
    "nombre_dx": "M808-OTRAS OSTEOPOROSIS,CON FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M809",
    "nombre_dx": "M809-OSTEOPOROSIS NO ESPECIFICADA, CON FRACTURA PATOLOGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M810",
    "nombre_dx": "M810-OSTEOPOROSIS POSTMENOPAUSICA, SIN FRACTURA PATOLOGICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "M811",
    "nombre_dx": "M811-OSTEOPOROSIS POSTOOFORECTOMIA, SIN FRACTURA PATOLOGICA",
    "sexo": "F"
  },
  {
    "cod_dx": "M812",
    "nombre_dx": "M812-OSTEOPOROSIS POR DESUSO, SIN FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M813",
    "nombre_dx": "M813-OSTEOPOROSIS POR MALABSORCION POSTQUIRURGICA, SIN FRACTURAPATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M814",
    "nombre_dx": "M814-OSTEOPOROSIS INDUCIDA POR DROGAS, SIN FRACTURA PATOLOGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M815",
    "nombre_dx": "M815-OSTEOPOROSIS IDIOPATICA, SIN FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M816",
    "nombre_dx": "M816-OSTEOPOROSIS LOCALIZADA [LEQUESNE], SIN FRACTURA PATOLOGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M818",
    "nombre_dx": "M818-OTRAS OSTEOPOROSIS,SIN FRACTURA PATOLOGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M819",
    "nombre_dx": "M819-OSTEOPOROSIS NO ESPECIFICADA, SIN FRACTURA PATOLOGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M820",
    "nombre_dx": "M820-OSTEOPOROSIS EN MIELOMATOSIS MULTIPLE (C90.0+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M821",
    "nombre_dx": "M821-OSTEOPOROSIS EN TRASTORNOS ENDOCRINOS (E00-E34+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M828",
    "nombre_dx": "M828-OSTEOPOROSIS EN OTRASENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M830",
    "nombre_dx": "M830-OSTEOMALACIA PUERPERAL",
    "sexo": "F"
  },
  {
    "cod_dx": "M831",
    "nombre_dx": "M831-OSTEOMALACIASENIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M832",
    "nombre_dx": "M832-OSTEOMALACIADEL ADULTO DEBIDA A MALABSORCION",
    "sexo": "A"
  },
  {
    "cod_dx": "M833",
    "nombre_dx": "M833-OSTEOMALACIADEL ADULTO DEBIDA A DESNUTRICION",
    "sexo": "A"
  },
  {
    "cod_dx": "M834",
    "nombre_dx": "M834-ENFERMEDAD DE LOS HUESOS POR ALUMINIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M835",
    "nombre_dx": "M835-OTRAS OSTEOMALACIAS DEL ADULTO INDUCIDAS POR DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M838",
    "nombre_dx": "M838-OTRAS OSTEOMALACIAS DEL ADULTO",
    "sexo": "A"
  },
  {
    "cod_dx": "M839",
    "nombre_dx": "M839-OSTEOMALACIA DEL ADULTO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M840",
    "nombre_dx": "M840-CONSOLIDACION DEFECTUOSA DE FRACTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "M841",
    "nombre_dx": "M841-FALTA DE CONSOLIDACION DEFRACTURA [SEUDOARTROSIS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M842",
    "nombre_dx": "M842-CONSOLIDACION RETARDADA DE FRACTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M843",
    "nombre_dx": "M843-FRACTURA POR TENSION, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M844",
    "nombre_dx": "M844-FRACTURA PATOLOGICA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M848",
    "nombre_dx": "M848-OTROS TRASTORNOS DE LA CONTINUIDAD DEL HUESO",
    "sexo": "A"
  },
  {
    "cod_dx": "M849",
    "nombre_dx": "M849-TRASTORNO DE LA CONTINUIDAD DEL HUESO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M850",
    "nombre_dx": "M850-DISPLASIA FIBROSA (MONOSTOTICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M851",
    "nombre_dx": "M851-FLUOROSIS DEL ESQUELETO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M852",
    "nombre_dx": "M852-HIPEROSTOSIS DEL CRANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M853",
    "nombre_dx": "M853-OSTEITIS CONDENSANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M854",
    "nombre_dx": "M854-QUISTE OSEO SOLITARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M855",
    "nombre_dx": "M855-QUISTE OSEO ANEURISMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M856",
    "nombre_dx": "M856-OTROS QUISTES OSEOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M858",
    "nombre_dx": "M858-OTROS TRASTORNOS ESPECIFICADOS DE LA DENSIDAD Y DE LA ESTRUCTURA OSEAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M859",
    "nombre_dx": "M859-TRASTORNO DE LA DENSIDAD Y DE LA ESTRUCTURA OSEAS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M860",
    "nombre_dx": "M860-OSTEOMIELITIS HEMATOGENA AGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "M861",
    "nombre_dx": "M861-OTRAS OSTEOMIELITIS AGUDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M862",
    "nombre_dx": "M862-OSTEOMIELITIS SUBAGUDA",
    "sexo": "A"
  },
  {
    "cod_dx": "M863",
    "nombre_dx": "M863-OSTEOMIELITIS MULTIFOCAL CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "M864",
    "nombre_dx": "M864-OSTEOMIELITIS CRONICA CON DRENAJE DEL SENO",
    "sexo": "A"
  },
  {
    "cod_dx": "M865",
    "nombre_dx": "M865-OTRAS OSTEOMIELITIS HEMATOGENAS CRONICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M866",
    "nombre_dx": "M866-OTRAS OSTEOMIELITIS CRONICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M868",
    "nombre_dx": "M868-OTRAS OSTEOMIELITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M869",
    "nombre_dx": "M869-OSTEOMIELITIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M870",
    "nombre_dx": "M870-NECROSIS ASEPTICA IDIOPATICA OSEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M871",
    "nombre_dx": "M871-OSTEONECROSIS DEBIDA A DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M872",
    "nombre_dx": "M872-OSTEONECROSIS DEBIDA A TRAUMATISMO PREVIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M873",
    "nombre_dx": "M873-OTRAS OSTEONECROSIS SECUNDARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M878",
    "nombre_dx": "M878-OTRAS OSTEONECROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M879",
    "nombre_dx": "M879-OSTEONECROSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M880",
    "nombre_dx": "M880-ENFERMEDAD DE PAGET DEL CRANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "M888",
    "nombre_dx": "M888-ENFERMEDAD DE PAGET DE OTROS HUESOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M889",
    "nombre_dx": "M889-ENFERMEDAD OSEA DE PAGET, HUESOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M890",
    "nombre_dx": "M890-ALGONEURODISTROFIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M891",
    "nombre_dx": "M891-DETENCION DEL CRECIMIENTO EPIFISARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "M892",
    "nombre_dx": "M892-OTROS TRASTORNOS DEL DESARROLLO Y CRECIMIENTO OSEO",
    "sexo": "A"
  },
  {
    "cod_dx": "M893",
    "nombre_dx": "M893-HIPERTROFIA DEL HUESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M894",
    "nombre_dx": "M894-OTRAS OSTEOARTROPATIAS HIPERTROFICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M895",
    "nombre_dx": "M895-OSTEOLISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M896",
    "nombre_dx": "M896-OSTEOPATIA A CONSECUENCIA DE POLIOMIELITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M898",
    "nombre_dx": "M898-OTROS TRASTORNOS ESPECIFICADOS DEL HUESO",
    "sexo": "A"
  },
  {
    "cod_dx": "M899",
    "nombre_dx": "M899-TRASTORNO DEL HUESO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M900",
    "nombre_dx": "M900-TUBERCULOSIS OSEAS (A18.0+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M901",
    "nombre_dx": "M901-PERIOSTITIS EN OTRAS ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M902",
    "nombre_dx": "M902-OSTEOPATIA EN OTRAS ENFERMEDADES INFECCIOSAS CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M903",
    "nombre_dx": "M903-OSTEONECROSIS EN LA ENFERMEDAD CAUSADA PORDESCOMPRESION (T70.3+)",
    "sexo": "A"
  },
  {
    "cod_dx": "M904",
    "nombre_dx": "M904-OSTEONECROSIS DEBIDAA HEMOGLOBINOPATIA (D50-D64+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M905",
    "nombre_dx": "M905-OSTEONECROSISEN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M906",
    "nombre_dx": "M906-OSTEITIS DEFORMANTE EN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M907",
    "nombre_dx": "M907-FRACTURA OSEA EN ENFERMEDAD NEOPLASICA (C00-D48+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M908",
    "nombre_dx": "M908-OSTEOPATIA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M910",
    "nombre_dx": "M910-OSTEOCONDROSIS JUVENIL DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M911",
    "nombre_dx": "M911-OSTEOCONDROSIS JUVENIL DE LA CABEZA DEL FEMUR [LEGG-CALVE-PERTHES]",
    "sexo": "A"
  },
  {
    "cod_dx": "M912",
    "nombre_dx": "M912-COXA PLANA",
    "sexo": "A"
  },
  {
    "cod_dx": "M913",
    "nombre_dx": "M913-PSEUDOCOXALGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M918",
    "nombre_dx": "M918-OTRAS OSTEOCONDROSIS JUVENILES DE LA CADERA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "M919",
    "nombre_dx": "M919-OSTEOCONDROSIS JUVENIL DE LA CADERA Y DE LA PELVIS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M920",
    "nombre_dx": "M920-OSTEOCONDROSIS JUVENIL DEL HUMERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M921",
    "nombre_dx": "M921-OSTEOCONDROSIS JUVENIL DEL CUBITO Y DEL RADIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M922",
    "nombre_dx": "M922-OSTEOCONDROSIS JUVENIL DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M923",
    "nombre_dx": "M923-OTRAS OSTEOCONDROSIS JUVENILESDEL MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "M924",
    "nombre_dx": "M924-OSTEOCONDROSIS JUVENIL DE LA ROTULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M925",
    "nombre_dx": "M925-OSTEOCONDROSIS JUVENIL DE LA TIBIA Y DEL PERONE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M926",
    "nombre_dx": "M926-OSTEOCONDROSIS JUVENIL DEL TARSO",
    "sexo": "A"
  },
  {
    "cod_dx": "M927",
    "nombre_dx": "M927-OSTEOCONDROSIS JUVENIL DEL METATARSO",
    "sexo": "A"
  },
  {
    "cod_dx": "M928",
    "nombre_dx": "M928-OTRAS OSTEOCONDROSIS JUVENILES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "M929",
    "nombre_dx": "M929-OSTEOCONDROSIS JUVENIL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M930",
    "nombre_dx": "M930-DESLIZAMIENTO DE LA EPIFISIS FEMORAL SUPERIOR (NO TRAUMATICO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M931",
    "nombre_dx": "M931-ENFERMEDAD DE KIENBÖCK DEL ADULTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M932",
    "nombre_dx": "M932-OSTEOCONDROSIS DISECANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M938",
    "nombre_dx": "M938-OTRAS OSTEOCONDROPATIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M939",
    "nombre_dx": "M939-OSTEOCONDROPATIA, NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "M940",
    "nombre_dx": "M940-SINDROME DE LA ARTICULACION CONDROCOSTAL [TIETZE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "M941",
    "nombre_dx": "M941-POLICONDRITIS RECIDIVANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "M942",
    "nombre_dx": "M942-CONDROMALACIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M943",
    "nombre_dx": "M943-CONDROLISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M948",
    "nombre_dx": "M948-OTROS TRASTORNOS ESPECIFICADOS DEL CARTILAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "M949",
    "nombre_dx": "M949-TRASTORNO DEL CARTILAGO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "M950",
    "nombre_dx": "M950-DEFORMIDAD ADQUIRIDA DE LA NARIZ",
    "sexo": "A"
  },
  {
    "cod_dx": "M951",
    "nombre_dx": "M951-OREJA EN COLIFLOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M952",
    "nombre_dx": "M952-OTRAS DEFORMIDADES ADQUIRIDAS DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "M953",
    "nombre_dx": "M953-DEFORMIDAD ADQUIRIDA DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "M954",
    "nombre_dx": "M954-DEFORMIDAD ADQUIRIDA DE COSTILLAS Y TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "M955",
    "nombre_dx": "M955-DEFORMIDAD ADQUIRIDA DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M958",
    "nombre_dx": "M958-OTRAS DEFORMIDADESADQUIRIDA ESPECIFICADAS DEL SISTEMA OSTEOMUSCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "M959",
    "nombre_dx": "M959-DEFORMIDAD ADQUIRIDA DEL SISTEMA OSTEOMUSCULAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M960",
    "nombre_dx": "M960-SEUDOARTROSIS CONSECUTIVA A FUSION O ARTRODESIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M961",
    "nombre_dx": "M961-SINDROME POSTLAMINECTOMIA, NO CLASIFICADOEN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "M962",
    "nombre_dx": "M962-CIFOSIS POSTRADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M963",
    "nombre_dx": "M963-CIFOSIS POSTLAMINECTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "M964",
    "nombre_dx": "M964-LORDOSIS POSTQUIRURGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M965",
    "nombre_dx": "M965-ESCOLIOSIS POSTRRADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "M966",
    "nombre_dx": "M966-FRACTURA DE HUESO POSTERIOR A INSERCION O IMPLANTE ORTOPEDICO, PROTESIS ARTICULAR O PLACA OSEA",
    "sexo": "A"
  },
  {
    "cod_dx": "M968",
    "nombre_dx": "M968-OTROS TRASTORNOS OSTEOMUSCULARES CONSECUTIVOS A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "M969",
    "nombre_dx": "M969-TRASTORNOS OSTEOMUSCULARES NO ESPECIFICADOS CONSECUTIVOS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M990",
    "nombre_dx": "M990-DISFUNCION SEGMENTAL O SOMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "M991",
    "nombre_dx": "M991-COMPLEJO DE SUBLUXACION (VERTEBRAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "M992",
    "nombre_dx": "M992-SUBLUXACION CON ESTENOSIS DEL CANAL NEURAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M993",
    "nombre_dx": "M993-ESTENOSIS OSEA DEL CANAL NEURAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M994",
    "nombre_dx": "M994-ESTENOSIS DEL CANAL NEURAL POR TEJIDO CONJUNTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "M995",
    "nombre_dx": "M995-ESTENOSIS DEL CANAL NEURAL POR DISCO INTERVERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "M996",
    "nombre_dx": "M996-ESTENOSIS OSEA Y SUBLUXACION DE LOS AGUJEROS INTERVERTEBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "M997",
    "nombre_dx": "M997-ESTENOSIS DE LOS AGUJEROS INTERVERTEBRALESPOR TEJIDO CONJUNTIVO O POR DISCO INTERVERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "M998",
    "nombre_dx": "M998-OTRAS LESIONES BIOMECANICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "M999",
    "nombre_dx": "M999-LESION BIOMECANICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N000",
    "nombre_dx": "N000-SINDROME NEFRÍTICO AGUDO: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N001",
    "nombre_dx": "N001-SINDROME NEFRÍTICO AGUDO: LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N002",
    "nombre_dx": "N002-SINDROME NEFRITICO AGUDO: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N003",
    "nombre_dx": "N003-SINDROME NEFRITICO AGUDO: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N004",
    "nombre_dx": "N004-SINDROME NEFRITICO AGUDO: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N005",
    "nombre_dx": "N005-SINDROME NEFRITICO AGUDO: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N006",
    "nombre_dx": "N006-SINDROME NEFRITICO AGUDO: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N007",
    "nombre_dx": "N007-SINDROME NEFRITICO AGUDO: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N008",
    "nombre_dx": "N008-SINDROME NEFRITICO AGUDO: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N009",
    "nombre_dx": "N009-SINDROME NEFRITICO AGUDO: NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N010",
    "nombre_dx": "N010-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: ANOMALIA GLOMERULAR MINIMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N011",
    "nombre_dx": "N011-SINDROME NEFRÍTICO RAPIDAMENTE PROGRESIVO: LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N012",
    "nombre_dx": "N012-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: GLOMERULONEFRITIS MEMBRANOSA DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N013",
    "nombre_dx": "N013-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N014",
    "nombre_dx": "N014-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N015",
    "nombre_dx": "N015-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N016",
    "nombre_dx": "N016-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: ENFERMEDAD POR DEPOSITOS DENSOS",
    "sexo": "A"
  },
  {
    "cod_dx": "N017",
    "nombre_dx": "N017-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N018",
    "nombre_dx": "N018-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: OTRAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N019",
    "nombre_dx": "N019-SINDROME NEFRITICO RAPIDAMENTE PROGRESIVO: NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N020",
    "nombre_dx": "N020-HEMATURIA RECURRENTE Y PERSISTENTE: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N021",
    "nombre_dx": "N021-HEMATURIA RECURRENTE Y PERSISTENTE:LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N022",
    "nombre_dx": "N022-HEMATURIA RECURRENTE Y PERSISTENTE: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N023",
    "nombre_dx": "N023-HEMATURIA RECURRENTE Y PERSISTENTE: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N024",
    "nombre_dx": "N024-HEMATURIA RECURRENTE Y PERSISTENTE: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N025",
    "nombre_dx": "N025-HEMATURIA RECURRENTE Y PERSISTENTE: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N026",
    "nombre_dx": "N026-HEMATURIA RECURRENTE Y PERSISTENTE: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N027",
    "nombre_dx": "N027-HEMATURIA RECURRENTE Y PERSISTENTE: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N028",
    "nombre_dx": "N028-HEMATURIA RECURRENTE Y PERSISTENTE: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N029",
    "nombre_dx": "N029-HEMATURIA RECURRENTE Y PERSISTENTE: NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N030",
    "nombre_dx": "N030-SINDROME NEFRITICO CRONICO: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N031",
    "nombre_dx": "N031-SINDROME NEFRITICO CRONICO: LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N032",
    "nombre_dx": "N032-SINDROME NEFRITICO CRONICO: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N033",
    "nombre_dx": "N033-SINDROME NEFRITICO CRONICO: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N034",
    "nombre_dx": "N034-SINDROME NEFRITICO CRONICO: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N035",
    "nombre_dx": "N035-SINDROME NEFRITICO CRONICO: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N036",
    "nombre_dx": "N036-SINDROME NEFRITICO CRONICO: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N037",
    "nombre_dx": "N037-SINDROME NEFRITICO CRONICO: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N038",
    "nombre_dx": "N038-SINDROME NEFRITICO CRONICO: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N039",
    "nombre_dx": "N039-SINDROME NEFRITICO CRONICO: NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N040",
    "nombre_dx": "N040-SINDROME NEFROTICO: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N041",
    "nombre_dx": "N041-SINDROME NEFROTICO:LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N042",
    "nombre_dx": "N042-SINDROME NEFROTICO: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N043",
    "nombre_dx": "N043-SINDROME NEFROTICO: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N044",
    "nombre_dx": "N044-SINDROME NEFROTICO: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N045",
    "nombre_dx": "N045-SINDROME NEFROTICO: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N046",
    "nombre_dx": "N046-SINDROME NEFROTICO: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N047",
    "nombre_dx": "N047-SINDROME NEFROTICO: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N048",
    "nombre_dx": "N048-SINDROME NEFROTICO: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N049",
    "nombre_dx": "N049-SINDROME NEFROTICO: NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N050",
    "nombre_dx": "N050-SINDROME NEFRITICO NO ESPECIFICADO: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N051",
    "nombre_dx": "N051-SINDROME NEFRITICO NO ESPECIFICADO: LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N052",
    "nombre_dx": "N052-SINDROME NEFRITICO NO ESPECIFICADO: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N053",
    "nombre_dx": "N053-SINDROME NEFRITICO NO ESPECIFICADO: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N054",
    "nombre_dx": "N054-SINDROME NEFRITICO NO ESPECIFICADO: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N055",
    "nombre_dx": "N055-SINDROME NEFRITICO NO ESPECIFICADO: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N056",
    "nombre_dx": "N056-SINDROME NEFRITICO NO ESPECIFICADO: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N057",
    "nombre_dx": "N057-SINDROME NEFRITICO NO ESPECIFICADO: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N058",
    "nombre_dx": "N058-SINDROME NEFRITICO NO ESPECIFICADO: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N059",
    "nombre_dx": "N059-SINDROME NEFRITICO NO ESPECIFICADO: NOESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N060",
    "nombre_dx": "N060-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: ANOMALIA GLOMERULAR MINIMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N061",
    "nombre_dx": "N061-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N062",
    "nombre_dx": "N062-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: GLOMERULONEFRITIS MEMBRANOSA DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N063",
    "nombre_dx": "N063-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL D",
    "sexo": "A"
  },
  {
    "cod_dx": "N064",
    "nombre_dx": "N064-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "N065",
    "nombre_dx": "N065-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N066",
    "nombre_dx": "N066-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: ENFERMEDAD POR DEPOSITOS DENSOS",
    "sexo": "A"
  },
  {
    "cod_dx": "N067",
    "nombre_dx": "N067-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N068",
    "nombre_dx": "N068-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: OTRAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N069",
    "nombre_dx": "N069-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N070",
    "nombre_dx": "N070-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: ANOMALIA GLOMERULAR MINIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N071",
    "nombre_dx": "N071-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N072",
    "nombre_dx": "N072-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: GLOMERULONEFRITIS MEMBRANOSA DIFUSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N073",
    "nombre_dx": "N073-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFU",
    "sexo": "A"
  },
  {
    "cod_dx": "N074",
    "nombre_dx": "N074-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DI",
    "sexo": "A"
  },
  {
    "cod_dx": "N075",
    "nombre_dx": "N075-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N076",
    "nombre_dx": "N076-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: ENFERMEDAD POR DEPOSITOS DENSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N077",
    "nombre_dx": "N077-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: GLOMERULONEFRITIS DIFUSA EN MEDIA LUNA",
    "sexo": "A"
  },
  {
    "cod_dx": "N078",
    "nombre_dx": "N078-NEFROPATIA HEREDITARIA, NO CLASIFICADA EN OTRA PARTE: OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N079",
    "nombre_dx": "N079-PROTEINURIA AISLADA CON LESION MORFOLOGICA ESPECIFICADA: NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N080",
    "nombre_dx": "N080-TRASTORNOS GLOMERULARES ENENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N081",
    "nombre_dx": "N081-TRASTORNOS GLOMERULARES ENENFERMEDADES NEOPLASICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N082",
    "nombre_dx": "N082-TRASTORNOS GLOMERULARES ENENFERMEDADES DE LA SANGRE Y OTROS TRASTORNOS QUE AFECTAN AL MECANISMO IN",
    "sexo": "A"
  },
  {
    "cod_dx": "N083",
    "nombre_dx": "N083-TRASTORNOS GLOMERULARES EN DIABETES MELLITUS (E10-E14+ CON CUARTO CARÁCTER COMUN .2)",
    "sexo": "A"
  },
  {
    "cod_dx": "N084",
    "nombre_dx": "N084-TRASTORNOS GLOMERULARES ENOTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N085",
    "nombre_dx": "N085-TRASTORNOS GLOMERULARES ENTRASTORNOS SISTEMICOS DEL TEJIDO CONJUNTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N088",
    "nombre_dx": "N088-TRASTORNOS GLOMERULARES ENOTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "N10X",
    "nombre_dx": "N10X-NEFRITIS TUBULOINTERSTICIAL AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N110",
    "nombre_dx": "N110-PIELONEFRITIS CRONICA NO OBSTRUCTIVA ASOCIADA CON REFLUJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N111",
    "nombre_dx": "N111-PIELONEFRITIS CRONICA OBSTRUCTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N118",
    "nombre_dx": "N118-OTRAS NEFRITIS TUBULOINTERSTICIALES CRONICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N119",
    "nombre_dx": "N119-NEFRITIS TUBULOINTERSTICIAL CRONICA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "N12X",
    "nombre_dx": "N12X-NEFRITIS TUBULOINTERSTICIAL, NOESPECIFICADA COMO AGUDA O CRONICA",
    "sexo": "A"
  },
  {
    "cod_dx": "N130",
    "nombre_dx": "N130-HIDRONEFROSIS CON OBSTRUCCION DE LA UNION URETERO-PELVICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N131",
    "nombre_dx": "N131-HIDRONEFROSIS CON ESTRECHEZ URETERAL, NO CLASIFICADA ENOTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "N132",
    "nombre_dx": "N132-HIDRONEFROSIS CON OBSTRUCCION POR CALCULOS DEL RIÑON Y DEL URETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "N133",
    "nombre_dx": "N133-OTRAS HIDRONEFROSIS Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N134",
    "nombre_dx": "N134-HIDROURETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "N135",
    "nombre_dx": "N135-TORSION Y ESTRECHEZ DEL URETER SIN HIDRONEFROSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "N136",
    "nombre_dx": "N136-PIONEFROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N137",
    "nombre_dx": "N137-UROPATIA ASOCIADA CON REFLUJO VESICOURETERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "N138",
    "nombre_dx": "N138-OTRAS UROPATIAS OBSTRUCTIVAS POR REFLUJO",
    "sexo": "A"
  },
  {
    "cod_dx": "N139",
    "nombre_dx": "N139-UROPATIA OBSTRUCTIVA POR REFLUJO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "N140",
    "nombre_dx": "N140-NEFROPATIA INDUCIDA POR ANALGESICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N141",
    "nombre_dx": "N141-NEFROPATIA INDUCIDA POR OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N142",
    "nombre_dx": "N142-NEFROPATIA INDUCIDA POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N143",
    "nombre_dx": "N143-NEFROPATIA INDUCIDA POR METALES PESADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N144",
    "nombre_dx": "N144-NEFROPATIA TOXICA, NO ESPECIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N150",
    "nombre_dx": "N150-NEFROPATIA DE LOS BALCANES",
    "sexo": "A"
  },
  {
    "cod_dx": "N151",
    "nombre_dx": "N151-ABSCESO RENAL YPERIRRENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N158",
    "nombre_dx": "N158-OTRAS ENFERMEDADES RENALES TUBULOINTERSTICIALES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N159",
    "nombre_dx": "N159-ENFERMEDAD RENAL TUBULOINTERSTICIAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N160",
    "nombre_dx": "N160-TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "N161",
    "nombre_dx": "N161-TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES NEOPLASICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N162",
    "nombre_dx": "N162-TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES DE LA SANGRE Y EN TRASTORNOS QUE AFECTAN EL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N163",
    "nombre_dx": "N163-TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES METABOLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N164",
    "nombre_dx": "N164-TRASTORNOS RENALES TUBULOINTERSTICIALES EN ENFERMEDADES DEL TEJIDO CONJUNTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N165",
    "nombre_dx": "N165-TRASTORNOS RENALES TUBULOINTERSTICIALES EN RECHAZO DE TRASPLANTE (T86.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "N168",
    "nombre_dx": "N168-TRASTORNOS RENALES TUBULOINTERSTICIALES EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N170",
    "nombre_dx": "N170-INSUFICIENCIA RENAL AGUDA CON NECROSIS TUBULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "N171",
    "nombre_dx": "N171-INSUFICIENCIA RENAL AGUDA CON NECROSIS CORTICAL AGUDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N172",
    "nombre_dx": "N172-INSUFICIENCIA RENAL AGUDA CON NECROSIS MEDULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "N178",
    "nombre_dx": "N178-OTRAS INSUFICIENCIAS RENALES AGUDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N179",
    "nombre_dx": "N179-INSUFICIENCIA RENAL AGUDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N181",
    "nombre_dx": "N181-Enfermedad renal crónica, etapa 1",
    "sexo": "A"
  },
  {
    "cod_dx": "N182",
    "nombre_dx": "N182-Enfermedad renal crónica, etapa 2",
    "sexo": "A"
  },
  {
    "cod_dx": "N183",
    "nombre_dx": "N183-Enfermedad renal crónica, etapa 3",
    "sexo": "A"
  },
  {
    "cod_dx": "N184",
    "nombre_dx": "N184-Enfermedad renal crónica, etapa 4",
    "sexo": "A"
  },
  {
    "cod_dx": "N185",
    "nombre_dx": "N185-Enfermedad renal crónica, etapa 5",
    "sexo": "A"
  },
  {
    "cod_dx": "N189",
    "nombre_dx": "N189-Enfermedad renal crónica, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "N18X",
    "nombre_dx": "N18X-Enfermedad renal crónica (antes INSUFICIENCIA RENAL CRONICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "N19X",
    "nombre_dx": "N19X-INSUFICIENCIA RENAL NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N200",
    "nombre_dx": "N200-CALCULO DEL RIÑON ",
    "sexo": "A"
  },
  {
    "cod_dx": "N201",
    "nombre_dx": "N201-CALCULO DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "N202",
    "nombre_dx": "N202-CALCULO DEL RIÑON CON CALCULO DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "N209",
    "nombre_dx": "N209-CALCULO URINARIO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N210",
    "nombre_dx": "N210-CALCULO EN LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "N211",
    "nombre_dx": "N211-CALCULO EN LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "N218",
    "nombre_dx": "N218-OTROS CALCULOS DE LAS VIAS URINARIAS INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "N219",
    "nombre_dx": "N219-CALCULO DE LAS VIAS URINARIAS INFERIORES, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N220",
    "nombre_dx": "N220-LITIASIS URINARIA EN ESQUISTOSOMIASIS [BILHARZIASIS] (B65.-+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "N228",
    "nombre_dx": "N228-CALCULO DE LAS VIAS URINARIAS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N23X",
    "nombre_dx": "N23X-COLICO RENAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N250",
    "nombre_dx": "N250-OSTEODISTROFIA RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "N251",
    "nombre_dx": "N251-DIABETES INSIPIDA NEFROGENA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N258",
    "nombre_dx": "N258-OTROS TRASTORNOS RESULTANTES DE LA FUNCION TUBULAR RENAL ALTERADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N259",
    "nombre_dx": "N259-TRASTORNO NO ESPECIFICADO, RESULTANTE DE LA FUNCION TUBULAR RENAL ALTERADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N26X",
    "nombre_dx": "N26X-RIÑON CONTRAIDO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "N270",
    "nombre_dx": "N270-RIÑONPEQUEÑO, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "N271",
    "nombre_dx": "N271-RIÑONPEQUEÑO, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N279",
    "nombre_dx": "N279-RIÑONPEQUEÑO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N280",
    "nombre_dx": "N280-ISQUEMIA E INFARTO DEL RIÑON",
    "sexo": "A"
  },
  {
    "cod_dx": "N281",
    "nombre_dx": "N281-QUISTE DE RIÑON, ADQUIRIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "N288",
    "nombre_dx": "N288-OTROS TRASTORNOS ESPECIFICADOS DEL RIÑON Y DEL URETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "N289",
    "nombre_dx": "N289-TRASTORNO DEL RIÑON Y DEL URETER, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N290",
    "nombre_dx": "N290-SIFILIS RENAL TARDIA (A52.7+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "N291",
    "nombre_dx": "N291-OTROS TRASTORNOS DEL RIÑON Y DEL URETER EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "N298",
    "nombre_dx": "N298-OTROS TRASTORNOS DEL RIÑON Y DEL URETER EN OTRASENFERMEDADESCLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N300",
    "nombre_dx": "N300-CISTITIS AGUDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N301",
    "nombre_dx": "N301-CISTITIS INTERSTICIAL (CRONICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "N302",
    "nombre_dx": "N302-OTRAS CISTITIS CRONICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N303",
    "nombre_dx": "N303-TRIGONITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "N304",
    "nombre_dx": "N304-CISTITIS POR IRRADIACION",
    "sexo": "A"
  },
  {
    "cod_dx": "N308",
    "nombre_dx": "N308-OTRAS CISTITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "N309",
    "nombre_dx": "N309-CISTITIS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N310",
    "nombre_dx": "N310-VEJIGA NEUROPATICA NO INHIBIDA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N311",
    "nombre_dx": "N311-VEJIGA NEUROPATICA REFLEJA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N312",
    "nombre_dx": "N312-VEJIGA NEUROPATICA FLACIDA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N318",
    "nombre_dx": "N318-OTRAS DISFUNCIONES NEUROMUSCULARES DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N319",
    "nombre_dx": "N319-DISFUNCION NEUROMUSCULAR DE LA VEJIGA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N320",
    "nombre_dx": "N320-OBSTRUCCION DE CUELLO DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "N321",
    "nombre_dx": "N321-FISTULA VESICOINTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "N322",
    "nombre_dx": "N322-FISTULA DE LA VEJIGA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N323",
    "nombre_dx": "N323-DIVERTICULO DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "N324",
    "nombre_dx": "N324-RUPTURA DE LA VEJIGA, NO TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N328",
    "nombre_dx": "N328-OTROS TRASTORNOS ESPECIFICADOS DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N329",
    "nombre_dx": "N329-TRASTORNO DE LA VEJIGA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N330",
    "nombre_dx": "N330-CISTITIS TUBERCULOSA (A18.1+) ",
    "sexo": "A"
  },
  {
    "cod_dx": "N338",
    "nombre_dx": "N338-TRASTORNOS DE LA VEJIGA EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N340",
    "nombre_dx": "N340-ABSCESO URETRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N341",
    "nombre_dx": "N341-URETRITIS NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N342",
    "nombre_dx": "N342-OTRAS URETRITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N343",
    "nombre_dx": "N343-SINDROME URETRAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N350",
    "nombre_dx": "N350-ESTRECHEZ URETRAL POSTRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N351",
    "nombre_dx": "N351-ESTRECHEZ URETRAL POSTINFECCION, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "N358",
    "nombre_dx": "N358-OTRAS ESTRECHECES URETRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "N359",
    "nombre_dx": "N359-ESTRECHEZ URETRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N360",
    "nombre_dx": "N360-FISTULA DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "N361",
    "nombre_dx": "N361-DIVERTICULO DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "N362",
    "nombre_dx": "N362-CARUNCULA URETRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N363",
    "nombre_dx": "N363-PROLAPSO DE LA MUCOSA URETRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "N368",
    "nombre_dx": "N368-OTROSTRASTORNOS ESPECIFICADOS DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "N369",
    "nombre_dx": "N369-TRASTORNO DE LA URETRA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N370",
    "nombre_dx": "N370-URETRITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "N378",
    "nombre_dx": "N378-OTROS TRASTORNOS URETRALES EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "N390",
    "nombre_dx": "N390-INFECCION DE VIAS URINARIAS, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "N391",
    "nombre_dx": "N391-PROTEINURIA PERSISTENTE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N392",
    "nombre_dx": "N392-PROTEINURIA ORTOSTATICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "N393",
    "nombre_dx": "N393-INCONTINENCIA URINARIA POR TENSION",
    "sexo": "A"
  },
  {
    "cod_dx": "N394",
    "nombre_dx": "N394-OTRAS INCONTINENCIAS URINARIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N398",
    "nombre_dx": "N398-OTROS TRASTORNOS ESPECIFICADOS DEL SISTEMA URINARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N399",
    "nombre_dx": "N399-TRASTORNO DEL SISTEMA URINARIO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N40X",
    "nombre_dx": "N40X-HIPERPLASIA DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "N410",
    "nombre_dx": "N410-PROSTATITIS AGUDA ",
    "sexo": "M"
  },
  {
    "cod_dx": "N411",
    "nombre_dx": "N411-PROSTATITIS CRONICA ",
    "sexo": "M"
  },
  {
    "cod_dx": "N412",
    "nombre_dx": "N412-ABSCESO DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "N413",
    "nombre_dx": "N413-PROSTATOCISTITIS",
    "sexo": "M"
  },
  {
    "cod_dx": "N418",
    "nombre_dx": "N418-OTRAS ENFERMEDADES INFLAMATORIAS DE LA PROSTATA ",
    "sexo": "M"
  },
  {
    "cod_dx": "N419",
    "nombre_dx": "N419-ENFERMEDAD INFLAMATORIA DE LA PROSTATA, NO ESPECIFICADA ",
    "sexo": "M"
  },
  {
    "cod_dx": "N420",
    "nombre_dx": "N420-CALCULO DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "N421",
    "nombre_dx": "N421-CONGESTION Y HEMORRAGIA DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "N422",
    "nombre_dx": "N422-ATROFIA DE LA PROSTATA",
    "sexo": "M"
  },
  {
    "cod_dx": "N423",
    "nombre_dx": "N423-Displasia de la próstata",
    "sexo": "A"
  },
  {
    "cod_dx": "N428",
    "nombre_dx": "N428-OTROS TRASTORNOS ESPECIFICADOS DE LA PROSTATA ",
    "sexo": "M"
  },
  {
    "cod_dx": "N429",
    "nombre_dx": "N429-TRASTORNO DE LA PROSTATA, NO ESPECIFICADO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N430",
    "nombre_dx": "N430-HIDROCELE ENQUISTADO",
    "sexo": "M"
  },
  {
    "cod_dx": "N431",
    "nombre_dx": "N431-HIDROCELE INFECTADO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N432",
    "nombre_dx": "N432-OTRAS HIDROCELES",
    "sexo": "M"
  },
  {
    "cod_dx": "N433",
    "nombre_dx": "N433-HIDROCELE, NO ESPECIFICADO",
    "sexo": "M"
  },
  {
    "cod_dx": "N434",
    "nombre_dx": "N434-ESPERMATOCELE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N44X",
    "nombre_dx": "N44X-TORSION DEL TESTICULO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N450",
    "nombre_dx": "N450-ORQUITIS, EPIDIDIMITIS Y ORQUIEPIDIDIMITIS CON ABSCESO",
    "sexo": "M"
  },
  {
    "cod_dx": "N459",
    "nombre_dx": "N459-ORQUITIS, EPIDIDIMITIS Y ORQUIEPIDIDIMITIS SIN ABSCESO",
    "sexo": "M"
  },
  {
    "cod_dx": "N46X",
    "nombre_dx": "N46X-ESTERILIDAD EN EL VARON ",
    "sexo": "M"
  },
  {
    "cod_dx": "N47X",
    "nombre_dx": "N47X-PREPUCIO REDUNDANTE, FIMOSIS Y PARAFIMOSIS",
    "sexo": "M"
  },
  {
    "cod_dx": "N480",
    "nombre_dx": "N480-LEUCOPLASIA DEL PENE",
    "sexo": "M"
  },
  {
    "cod_dx": "N481",
    "nombre_dx": "N481-BALANOPOSTITIS",
    "sexo": "M"
  },
  {
    "cod_dx": "N482",
    "nombre_dx": "N482-OTROS TRASTORNOS INFLAMATORIOS DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N483",
    "nombre_dx": "N483-PRIAPISMO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N484",
    "nombre_dx": "N484-IMPOTENCIA DE ORIGEN ORGANICO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N485",
    "nombre_dx": "N485-ULCERA DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N486",
    "nombre_dx": "N486-BALANITIS XEROTICA OBLITERANTE",
    "sexo": "M"
  },
  {
    "cod_dx": "N488",
    "nombre_dx": "N488-OTROS TRASTORNOS ESPECIFICADOS DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N489",
    "nombre_dx": "N489-TRASTORNO DEL PENE, NO ESPECIFICADO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N490",
    "nombre_dx": "N490-TRASTORNOS INFLAMATORIOS DE VESICULA SEMINAL",
    "sexo": "M"
  },
  {
    "cod_dx": "N491",
    "nombre_dx": "N491-TRASTORNOS INFLAMATORIOS DEL CORDON ESPERMATICO, TUNICA VAGINAL Y CONDUCTO DEFERENTE",
    "sexo": "M"
  },
  {
    "cod_dx": "N492",
    "nombre_dx": "N492-TRASTORNOS INFLAMATORIOS DEL ESCROTO",
    "sexo": "M"
  },
  {
    "cod_dx": "N498",
    "nombre_dx": "N498-OTROS TRASTORNOS INFLAMATORIOS DE LOS ORGANOS GENITALES MASCULINOS",
    "sexo": "M"
  },
  {
    "cod_dx": "N499",
    "nombre_dx": "N499-TRASTORNO INFLAMATORIO DE ORGANO MASCULINO, NO ESPECIFICADO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N500",
    "nombre_dx": "N500-ATROFIA DEL TESTICULO ",
    "sexo": "M"
  },
  {
    "cod_dx": "N501",
    "nombre_dx": "N501-TRASTORNOS VASCULARES DE LOS ORGANOS GENITALES MASCULINOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "N508",
    "nombre_dx": "N508-OTROS TRASTORNOS ESPECIFICADOS DE LOS ORGANOS GENITALES MASCULINOS",
    "sexo": "M"
  },
  {
    "cod_dx": "N509",
    "nombre_dx": "N509-TRASTORNO NO ESPECIFICADO DE LOS ORGANOS GENITALES MASCULINOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "N510",
    "nombre_dx": "N510-TRASTORNOS DE PROSTATA EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N511",
    "nombre_dx": "N511-TRASTORNO DEL TESTICULO Y DEL EPIDIDIMO EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "M"
  },
  {
    "cod_dx": "N512",
    "nombre_dx": "N512-BALANITIS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "M"
  },
  {
    "cod_dx": "N518",
    "nombre_dx": "N518-OTROS TRASTORNOS DE LOS ORGANOS GENITALES MASCULINOS EN ENFERMEDADES CLASIFICADAS EN OTRA PARTE ",
    "sexo": "M"
  },
  {
    "cod_dx": "N600",
    "nombre_dx": "N600-QUISTE SOLITARIO DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N601",
    "nombre_dx": "N601-MASTOPATIA QUISTICA DIFUSA",
    "sexo": "A"
  },
  {
    "cod_dx": "N602",
    "nombre_dx": "N602-FIBROADENOSIS DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N603",
    "nombre_dx": "N603-FIBROESCLEROSIS DE MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N604",
    "nombre_dx": "N604-ECTASIA DE CONDUCTO MAMARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N608",
    "nombre_dx": "N608-OTRAS DISPLASIAS MAMARIAS BENIGNAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N609",
    "nombre_dx": "N609-DISPLASIA MAMARIA BENIGNA, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "N61X",
    "nombre_dx": "N61X-TRASTORNOS INFLAMATORIOS DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N62X",
    "nombre_dx": "N62X-HIPERTROFIA DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N63X",
    "nombre_dx": "N63X-MASA NO ESPECIFICADA EN LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N640",
    "nombre_dx": "N640-FISURA Y FISTULA DEL PEZON",
    "sexo": "A"
  },
  {
    "cod_dx": "N641",
    "nombre_dx": "N641-NECROSIS GRASA DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N642",
    "nombre_dx": "N642-ATROFIA DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "N643",
    "nombre_dx": "N643-GALACTORREA NO ASOCIADA CON EL PARTO",
    "sexo": "A"
  },
  {
    "cod_dx": "N644",
    "nombre_dx": "N644-MASTODINIA",
    "sexo": "A"
  },
  {
    "cod_dx": "N645",
    "nombre_dx": "N645-OTROS SIGNOS Y SINTOMAS RELATIVOS A LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N648",
    "nombre_dx": "N648-OTROS TRASTORNOS ESPECIFICADOS DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "N649",
    "nombre_dx": "N649-TRASTORNO DE LA MAMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "N700",
    "nombre_dx": "N700-SALPINGITIS Y OOFORITIS AGUDA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N701",
    "nombre_dx": "N701-SALPINGITIS Y OOFORITIS CRONICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N709",
    "nombre_dx": "N709-SALPINGITIS Y OOFORITIS, NO ESPECIFICADAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N710",
    "nombre_dx": "N710-ENFERMEDAD INFLAMATORIA AGUDA DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N711",
    "nombre_dx": "N711-ENFERMEDAD INFLAMATORIA CRONICA DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N719",
    "nombre_dx": "N719-ENFERMEDAD INFLAMATORIADEL UTERO, NO ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "N72X",
    "nombre_dx": "N72X-ENFERMEDAD INFLAMATORIA DEL CUELLO UTERINO",
    "sexo": "F"
  },
  {
    "cod_dx": "N730",
    "nombre_dx": "N730-PARAMETRITIS Y CELULITIS PELVICA AGUDA",
    "sexo": "F"
  },
  {
    "cod_dx": "N731",
    "nombre_dx": "N731-PARAMETRITIS Y CELULITIS PELVICA CRONICA",
    "sexo": "F"
  },
  {
    "cod_dx": "N732",
    "nombre_dx": "N732-PARAMETRITIS Y CELULITIS PELVICA NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N733",
    "nombre_dx": "N733-PERITONITIS PELVICA AGUDA, FEMENINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N734",
    "nombre_dx": "N734-PERITONITIS PELVICA CRONICA, FEMENINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N735",
    "nombre_dx": "N735-PERITONITIS PELVICAFEMENINA, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N736",
    "nombre_dx": "N736-ADHERENCIAS PERITONEALES PELVICAS FEMENINAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N738",
    "nombre_dx": "N738-OTRAS ENFERMEDADES INFLAMATORIAS PELVICAS FEMENINAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N739",
    "nombre_dx": "N739-ENFERMEDAD INFLAMATORIA PELVICA FEMENINA, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N740",
    "nombre_dx": "N740-INFECCION TUBERCULOSA DEL CUELLO DEL UTERO (A18.1+) ",
    "sexo": "F"
  },
  {
    "cod_dx": "N741",
    "nombre_dx": "N741-ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR TUBERCULOSIS (A18.1+)",
    "sexo": "F"
  },
  {
    "cod_dx": "N742",
    "nombre_dx": "N742-ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR SIFILIS (A51.4+, A52.7+) ",
    "sexo": "F"
  },
  {
    "cod_dx": "N743",
    "nombre_dx": "N743-ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR GONOCOCOS (A54.2+) ",
    "sexo": "F"
  },
  {
    "cod_dx": "N744",
    "nombre_dx": "N744-ENFERMEDAD INFLAMATORIA PELVICA FEMENINA POR CLAMIDIAS (A56.1+) ",
    "sexo": "F"
  },
  {
    "cod_dx": "N748",
    "nombre_dx": "N748-TRASTORNOS INFLAMATORIOS PELVICOS FEMENINOS EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "F"
  },
  {
    "cod_dx": "N750",
    "nombre_dx": "N750-QUISTE DE LA GLANDULA DE BARTHOLIN",
    "sexo": "F"
  },
  {
    "cod_dx": "N751",
    "nombre_dx": "N751-ABSCESO DE LA GLANDULA DE BARTHOLIN ",
    "sexo": "F"
  },
  {
    "cod_dx": "N758",
    "nombre_dx": "N758-OTRAS ENFERMEDADESDE LA GLANDULA DE BARTHOLIN ",
    "sexo": "F"
  },
  {
    "cod_dx": "N759",
    "nombre_dx": "N759-ENFERMEDADDE LA GLANDULA DE BARTHOLIN,NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N760",
    "nombre_dx": "N760-VAGINITIS AGUDA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N761",
    "nombre_dx": "N761-VAGINITIS SUBAGUDA Y CRONICA",
    "sexo": "F"
  },
  {
    "cod_dx": "N762",
    "nombre_dx": "N762-VULVITIS AGUDA",
    "sexo": "F"
  },
  {
    "cod_dx": "N763",
    "nombre_dx": "N763-VULVITIS SUBAGUDA Y CRONICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N764",
    "nombre_dx": "N764-ABSCESO VULVAR",
    "sexo": "F"
  },
  {
    "cod_dx": "N765",
    "nombre_dx": "N765-ULCERACION DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N766",
    "nombre_dx": "N766-ULCERACION DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "N768",
    "nombre_dx": "N768-OTRAS INFLAMACIONES ESPECIFICADAS DE LA VAGINA Y DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "N770",
    "nombre_dx": "N770-ULCERACION DE LA VULVA EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA PARTE",
    "sexo": "F"
  },
  {
    "cod_dx": "N771",
    "nombre_dx": "N771-VAGINITIS, VULVITIS Y VULVOVAGINITIS EN ENFERMEDADES INFECCIOSAS Y PARASITARIAS CLASIFICADAS EN OTRA",
    "sexo": "F"
  },
  {
    "cod_dx": "N778",
    "nombre_dx": "N778-ULCERACION E INFLAMACION VULVOVAGINAL EN OTRAS ENFERMEDADES CLASIFICADAS EN OTRA PARTE",
    "sexo": "F"
  },
  {
    "cod_dx": "N800",
    "nombre_dx": "N800-ENDOMETRIOSIS DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N801",
    "nombre_dx": "N801-ENDOMETRIOSIS DEL OVARIO",
    "sexo": "F"
  },
  {
    "cod_dx": "N802",
    "nombre_dx": "N802-ENDOMETRIOSIS DE LA TROMPA DE FALOPIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N803",
    "nombre_dx": "N803-ENDOMETRIOSIS DELPERITONEO PELVICO",
    "sexo": "F"
  },
  {
    "cod_dx": "N804",
    "nombre_dx": "N804-ENDOMETRIOSIS DEL TABIQUE RECTOVAGINAL Y DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N805",
    "nombre_dx": "N805-ENDOMETRIOSIS DEL INTESTINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N806",
    "nombre_dx": "N806-ENDOMETRIOSIS EN CICATRIZ CUTANEA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N808",
    "nombre_dx": "N808-OTRAS ENDOMETRIOSIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N809",
    "nombre_dx": "N809-ENDOMETRIOSIS, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N810",
    "nombre_dx": "N810-URETROCELE FEMENINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N811",
    "nombre_dx": "N811-CISTOCELE ",
    "sexo": "F"
  },
  {
    "cod_dx": "N812",
    "nombre_dx": "N812-PROLAPSO UTEROVAGINAL INCOMPLETO",
    "sexo": "F"
  },
  {
    "cod_dx": "N813",
    "nombre_dx": "N813-PROLAPSO UTEROVAGINAL COMPLETO",
    "sexo": "F"
  },
  {
    "cod_dx": "N814",
    "nombre_dx": "N814-PROLAPSO UTEROVAGINAL, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "N815",
    "nombre_dx": "N815-ENTEROCELE VAGINAL",
    "sexo": "F"
  },
  {
    "cod_dx": "N816",
    "nombre_dx": "N816-RECTOCELE ",
    "sexo": "F"
  },
  {
    "cod_dx": "N818",
    "nombre_dx": "N818-OTROS PROLAPSOS GENITALES FEMENINOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N819",
    "nombre_dx": "N819-PROLAPSO GENITAL FEMENINO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "N820",
    "nombre_dx": "N820-FISTULA VESICOVAGINAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N821",
    "nombre_dx": "N821-OTRAS FISTULAS DE LAS VIAS GENITOURINARIAS FEMENINAS",
    "sexo": "F"
  },
  {
    "cod_dx": "N822",
    "nombre_dx": "N822-FISTULA DE LA VAGINA AL INTESTINO DELGADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N823",
    "nombre_dx": "N823-FISTULA DE LA VAGINA AL INTESTINO GRUESO",
    "sexo": "F"
  },
  {
    "cod_dx": "N824",
    "nombre_dx": "N824-OTRAS FISTULAS DEL TRACTO INTESTINAL GENITAL FEMENINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N825",
    "nombre_dx": "N825-FISTULA DEL TRACTO GENITAL FEMENINO A LA PIEL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N828",
    "nombre_dx": "N828-OTRAS FISTULAS DEL TRACTO GENITAL FEMENINO",
    "sexo": "F"
  },
  {
    "cod_dx": "N829",
    "nombre_dx": "N829-FISTULA DEL TRACTO GENITAL FEMENINO, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "N830",
    "nombre_dx": "N830-QUISTE FOLICULAR DEL OVARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N831",
    "nombre_dx": "N831-QUISTE DEL CUERPO AMARILLO",
    "sexo": "F"
  },
  {
    "cod_dx": "N832",
    "nombre_dx": "N832-OTROS QUISTES OVARICOS Y LOS NO ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N833",
    "nombre_dx": "N833-ATROFIA ADQUIRIDA DEL OVARIO Y DE LA TROMPA FALOPIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N834",
    "nombre_dx": "N834-PROLAPSO Y HERNIA DEL OVARIO Y DE LA TROMPA DE FALOPIO",
    "sexo": "F"
  },
  {
    "cod_dx": "N835",
    "nombre_dx": "N835-TORSION DE OVARIO, PEDICULO DE OVARIO Y TROMPA DE FALOPIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N836",
    "nombre_dx": "N836-HEMATOSALPINX ",
    "sexo": "F"
  },
  {
    "cod_dx": "N837",
    "nombre_dx": "N837-HEMATOMA DEL LIGAMENTO ANCHO",
    "sexo": "F"
  },
  {
    "cod_dx": "N838",
    "nombre_dx": "N838-OTROS TRASTORNOS NO INFLAMATORIOSDEL OVARIO, DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO",
    "sexo": "F"
  },
  {
    "cod_dx": "N839",
    "nombre_dx": "N839-ENFERMEDAD NO INFLAMATORIA DEL OVARIO, DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO, NO ESPECIFICAD",
    "sexo": "F"
  },
  {
    "cod_dx": "N840",
    "nombre_dx": "N840-POLIPO DEL CUERPO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N841",
    "nombre_dx": "N841-POLIPODEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N842",
    "nombre_dx": "N842-POLIPO DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N843",
    "nombre_dx": "N843-POLIPO DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "N848",
    "nombre_dx": "N848-POLIPO DE OTRAS PARTES DEL TRACTO GENITAL FEMENINO",
    "sexo": "F"
  },
  {
    "cod_dx": "N849",
    "nombre_dx": "N849-POLIPO DEL TRACTO GENITAL FEMENINO, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N850",
    "nombre_dx": "N850-HIPERPLASIA DE GLANDULA DEL ENDOMETRIO",
    "sexo": "F"
  },
  {
    "cod_dx": "N851",
    "nombre_dx": "N851-HIPERPLASIA ADENOMATOSADEL ENDOMETRIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N852",
    "nombre_dx": "N852-HIPERTROFIA DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N853",
    "nombre_dx": "N853-SUBINVOLUCION DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N854",
    "nombre_dx": "N854-MALA POSICION DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N855",
    "nombre_dx": "N855-INVERSION DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N856",
    "nombre_dx": "N856-SINEQUIAS INTRAUTERINAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N857",
    "nombre_dx": "N857-HEMATOMETRA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N858",
    "nombre_dx": "N858-OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N859",
    "nombre_dx": "N859-TRASTORNO NO INFLAMATORIO DEL UTERO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "N86X",
    "nombre_dx": "N86X-EROSION Y ECTROPION DEL CUELLODEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N870",
    "nombre_dx": "N870-DISPLASIA CERVICALLEVE",
    "sexo": "F"
  },
  {
    "cod_dx": "N871",
    "nombre_dx": "N871-DISPLASIA CERVICAL MODERADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N872",
    "nombre_dx": "N872-DISPLASIA CERVICAL SEVERA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "F"
  },
  {
    "cod_dx": "N879",
    "nombre_dx": "N879-DISPLASIA DEL CUELLO DEL UTERO, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N880",
    "nombre_dx": "N880-LEUCOPLASIA DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N881",
    "nombre_dx": "N881-LACERACION ANTIGUADEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N882",
    "nombre_dx": "N882-ESTRECHEZ Y ESTENOSIS DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N883",
    "nombre_dx": "N883-INCOMPETENCIA DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N884",
    "nombre_dx": "N884-ELONGACION HIPERTROFICA DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N888",
    "nombre_dx": "N888-OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DEL CUELLO DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "N889",
    "nombre_dx": "N889-TRASTORNO NO INFLAMATORIO DEL CUELLO DEL UTERO, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N890",
    "nombre_dx": "N890-DISPLASIA VAGINAL LEVE",
    "sexo": "F"
  },
  {
    "cod_dx": "N891",
    "nombre_dx": "N891-DISPLASIA VAGINAL MODERADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N892",
    "nombre_dx": "N892-DISPLASIA VAGINAL SEVERA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "F"
  },
  {
    "cod_dx": "N893",
    "nombre_dx": "N893-DISPLASIA DE LA VAGINA, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N894",
    "nombre_dx": "N894-LEUCOPLASIA DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "N895",
    "nombre_dx": "N895-ESTRECHEZ Y ATRESIA DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "N896",
    "nombre_dx": "N896-ANILLO DE HIMEN ESTRECHO",
    "sexo": "F"
  },
  {
    "cod_dx": "N897",
    "nombre_dx": "N897-HEMATOCOLPOS",
    "sexo": "F"
  },
  {
    "cod_dx": "N898",
    "nombre_dx": "N898-OTROS TRASTORNOS ESPECIFICADOS NO INFLAMATORIOS DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "N899",
    "nombre_dx": "N899-TRASTORNO NO INFLAMATORIO DE LA VAGINA, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N900",
    "nombre_dx": "N900-DISPLASIA VULVAR LEVE ",
    "sexo": "F"
  },
  {
    "cod_dx": "N901",
    "nombre_dx": "N901-DISPLASIA VULVAR MODERADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N902",
    "nombre_dx": "N902-DISPLASIAVULVAR SEVERA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "F"
  },
  {
    "cod_dx": "N903",
    "nombre_dx": "N903-DISPLASIA DE LA VULVA, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N904",
    "nombre_dx": "N904-LEUCOPLASIA DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N905",
    "nombre_dx": "N905-ATROFIA DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N906",
    "nombre_dx": "N906-HIPERTROFIA DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N907",
    "nombre_dx": "N907-QUISTE DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "N908",
    "nombre_dx": "N908-OTROS TRASTORNOS NO INFLAMATORIOS ESPECIFICADOS DE LA VULVA Y DEL PERINEO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N909",
    "nombre_dx": "N909-TRASTORNO NO INFLAMATORIO DE LA VULVA Y DEL PERINEO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "N910",
    "nombre_dx": "N910-AMENORREA PRIMARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N911",
    "nombre_dx": "N911-AMENORREA SECUNDARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N912",
    "nombre_dx": "N912-AMENORREA, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "N913",
    "nombre_dx": "N913-OLIGOMENORREA PRIMARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N914",
    "nombre_dx": "N914-OLIGOMENORREA SECUNDARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N915",
    "nombre_dx": "N915-OLIGOMENORREA NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N920",
    "nombre_dx": "N920-MENSTRUACION EXCESIVA Y FRECUENTE CON CICLO REGULAR ",
    "sexo": "F"
  },
  {
    "cod_dx": "N921",
    "nombre_dx": "N921-MENSTRUACION EXCESIVA Y FRECUENTE CON CICLO IRREGULAR ",
    "sexo": "F"
  },
  {
    "cod_dx": "N922",
    "nombre_dx": "N922-MENSTRUACION EXCESIVA EN LA PUBERTAD",
    "sexo": "F"
  },
  {
    "cod_dx": "N923",
    "nombre_dx": "N923-HEMORRAGIA POR OVULACION",
    "sexo": "F"
  },
  {
    "cod_dx": "N924",
    "nombre_dx": "N924-HEMORRAGIA EXCESIVA EN PERIODO PREMENOPAUSICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N925",
    "nombre_dx": "N925-OTRAS MENSTRUACIONES IRREGULARES ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "N926",
    "nombre_dx": "N926-MENSTRUACION IRREGULAR,NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N930",
    "nombre_dx": "N930-HEMORRAGIA POSTCOITO Y POSTCONTACTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N938",
    "nombre_dx": "N938-OTRAS HEMORRAGIAS UTERINAS O VAGINALES ANORMALES ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "N939",
    "nombre_dx": "N939-HEMORRAGIA VAGINAL Y UTERINA ANORMAL, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N940",
    "nombre_dx": "N940-DOLOR INTERMENSTRUAL",
    "sexo": "F"
  },
  {
    "cod_dx": "N941",
    "nombre_dx": "N941-DISPAREUNIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N942",
    "nombre_dx": "N942-VAGINISMO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N943",
    "nombre_dx": "N943-SINDROME DE TENSION PREMENSTRUAL",
    "sexo": "F"
  },
  {
    "cod_dx": "N944",
    "nombre_dx": "N944-DISMENORREA PRIMARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N945",
    "nombre_dx": "N945-DISMENORREA SECUNDARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N946",
    "nombre_dx": "N946-DISMENORREA,NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "N948",
    "nombre_dx": "N948-OTRAS AFECCIONES ESPECIFICADAS ASOCIADAS CON LOS ORGANOS GENITALES FEMENINOS Y EL CICLO MENSTRUAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N949",
    "nombre_dx": "N949-AFECCIONES NO ESPECIFICADAS ASOCIADAS CON LOS ORGANOS GENITALES FEMENINOS Y EL CICLO MENSTRUAL",
    "sexo": "F"
  },
  {
    "cod_dx": "N950",
    "nombre_dx": "N950-HEMORRAGIA POSTMENOPAUSICA",
    "sexo": "F"
  },
  {
    "cod_dx": "N951",
    "nombre_dx": "N951-ESTADOS MENOPAUSICOS Y CLIMATERICOS FEMENINOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "N952",
    "nombre_dx": "N952-VAGINITIS ATROFICA POSTMENOPAUSICA",
    "sexo": "F"
  },
  {
    "cod_dx": "N953",
    "nombre_dx": "N953-ESTADOS ASOCIADOS CON MENOPAUSIA ARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N958",
    "nombre_dx": "N958-OTROS TRASTORNOS MENOPAUSICOS Y PERIMENOPAUSICOS ESPECIFICADOS",
    "sexo": "F"
  },
  {
    "cod_dx": "N959",
    "nombre_dx": "N959-TRASTORNO MENOPAUSICO Y PERIMENOPAUSICO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "N96X",
    "nombre_dx": "N96X-ABORTADORA HABITUAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N970",
    "nombre_dx": "N970-INFERTILIDAD FEMENINA ASOCIADA CON FALTA DE OVULACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "N971",
    "nombre_dx": "N971-INFERTILIDAD FEMENINA DE ORIGEN TUBARICO",
    "sexo": "F"
  },
  {
    "cod_dx": "N972",
    "nombre_dx": "N972-INFERTILIDAD FEMENINA DE ORIGEN UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N973",
    "nombre_dx": "N973-INFERTILIDAD FEMENINA DE ORIGENCERVICAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N974",
    "nombre_dx": "N974-INFERTILIDAD FEMENINA ASOCIADA CON FACTORES MASCULINOS",
    "sexo": "F"
  },
  {
    "cod_dx": "N978",
    "nombre_dx": "N978-INFERTILIDAD FEMENINA DE OTRO ORIGEN",
    "sexo": "F"
  },
  {
    "cod_dx": "N979",
    "nombre_dx": "N979-INFERTILIDAD FEMENINA, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "N980",
    "nombre_dx": "N980-INFECCIONASOCIADA CON INSEMINACION ARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N981",
    "nombre_dx": "N981-HIPERESTIMULACION DE OVARIOS",
    "sexo": "F"
  },
  {
    "cod_dx": "N982",
    "nombre_dx": "N982-COMPLICACIONESEN EL INTENTO DEINTRODUCCION DEL HUEVO FECUNDADO EN LA FERTILIZACION EN VITRO ",
    "sexo": "F"
  },
  {
    "cod_dx": "N983",
    "nombre_dx": "N983-COMPLICACIONES EN EL INTENTO INTRODUCCION DEL EMBRION EN LA TRANSFERENCIA DE EMBRIONES",
    "sexo": "F"
  },
  {
    "cod_dx": "N988",
    "nombre_dx": "N988-OTRAS COMPLICACIONES ASOCIADAS CON LA FECUNDACIONARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N989",
    "nombre_dx": "N989-COMPLICACIONNO ESPECIFICADAASOCIADA CON LA FECUNDACION ARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "N990",
    "nombre_dx": "N990-INSUFICIENCIA RENALCONSECUTIVA A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N991",
    "nombre_dx": "N991-ESTRECHEZ URETRAL CONSECUTIVA A PROCEDIMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "N992",
    "nombre_dx": "N992-ADHERENCIAS POSTOPERATORIAS DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "N993",
    "nombre_dx": "N993-PROLAPSO DE LA CUPULA VAGINAL DESPUES DE HISTERECTOMIA",
    "sexo": "F"
  },
  {
    "cod_dx": "N994",
    "nombre_dx": "N994-ADHERENCIAS PERITONEALES PELVICAS CONSECUTIVAS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N995",
    "nombre_dx": "N995-MAL FUNCIONAMIENTO DE ESTOMA EXTERNO DE VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "N998",
    "nombre_dx": "N998-OTROS TRASTORNOS DEL SISTEMA GENITOURINARIO CONSECUTIVOS A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "N999",
    "nombre_dx": "N999-TRASTORNO NO ESPECIFICADO DEL SISTEMA GENITOURINARIO CONSECUTIVO A PROCEDIMIENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "O000",
    "nombre_dx": "O000-EMBARAZO ABDOMINAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O001",
    "nombre_dx": "O001-EMBARAZO TUBARICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O002",
    "nombre_dx": "O002-EMBARAZO OVARICO",
    "sexo": "F"
  },
  {
    "cod_dx": "O008",
    "nombre_dx": "O008-OTROS EMBARAZOS ECTOPICOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O009",
    "nombre_dx": "O009-EMBARAZO ECTOPICO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O010",
    "nombre_dx": "O010-MOLA HIDATIFORME CLASICA",
    "sexo": "F"
  },
  {
    "cod_dx": "O011",
    "nombre_dx": "O011-MOLA HIDATIFORME, INCOMPLETA O PARCIAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O019",
    "nombre_dx": "O019-MOLA HIDATIFORME, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O020",
    "nombre_dx": "O020-DETENCION DEL DESARROLLO DEL HUEVO Y MOLA NO HIDATIFORME",
    "sexo": "F"
  },
  {
    "cod_dx": "O021",
    "nombre_dx": "O021-ABORTO RETENIDO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O028",
    "nombre_dx": "O028-OTROS PRODUCTOS ANORMALES ESPECIFICADOS DE LA CONCEPCION",
    "sexo": "F"
  },
  {
    "cod_dx": "O029",
    "nombre_dx": "O029-PRODUCTO ANORMAL DE LA CONCEPCION, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O030",
    "nombre_dx": "O030-ABORTO ESPONTANEO: INCOMPLETO, COMPLICADO CON INFECCIÓN GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O031",
    "nombre_dx": "O031-ABORTO ESPONTANEO: INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O032",
    "nombre_dx": "O032-ABORTO ESPONTANEO: INCOMPLETO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O033",
    "nombre_dx": "O033-ABORTO ESPONTANEO: INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O034",
    "nombre_dx": "O034-ABORTO ESPONTANEO: INCOMPLETO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O035",
    "nombre_dx": "O035-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O036",
    "nombre_dx": "O036-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O037",
    "nombre_dx": "O037-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O038",
    "nombre_dx": "O038-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPEC",
    "sexo": "F"
  },
  {
    "cod_dx": "O039",
    "nombre_dx": "O039-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O040",
    "nombre_dx": "O040-ABORTO MEDICO: INCOMPLETO, COMPLICADO CON INFECCIÓN GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O041",
    "nombre_dx": "O041-ABORTO MEDICO: INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O042",
    "nombre_dx": "O042-ABORTO ESPONTANEO: INCOMPLETO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O043",
    "nombre_dx": "O043-ABORTO ESPONTANEO: INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O044",
    "nombre_dx": "O044-ABORTO ESPONTANEO: INCOMPLETO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O045",
    "nombre_dx": "O045-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O046",
    "nombre_dx": "O046-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O047",
    "nombre_dx": "O047-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O048",
    "nombre_dx": "O048-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPEC",
    "sexo": "F"
  },
  {
    "cod_dx": "O049",
    "nombre_dx": "O049-ABORTO ESPONTANEO: COMPLETO O NO ESPECIFICADO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O050",
    "nombre_dx": "O050-OTRO ABORTO: INCOMPLETO, COMPLICADO CON INFECCIÓN GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O051",
    "nombre_dx": "O051-OTRO ABORTO: INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O052",
    "nombre_dx": "O052-OTRO ABORTO: INCOMPLETO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O053",
    "nombre_dx": "O053-OTRO ABORTO: INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O054",
    "nombre_dx": "O054-OTRO ABORTO: INCOMPLETO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O055",
    "nombre_dx": "O055-OTRO ABORTO: COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O056",
    "nombre_dx": "O056-OTRO ABORTO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O057",
    "nombre_dx": "O057-OTRO ABORTO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O058",
    "nombre_dx": "O058-OTRO ABORTO: COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICAD",
    "sexo": "F"
  },
  {
    "cod_dx": "O059",
    "nombre_dx": "O059-OTRO ABORTO: COMPLETO O NO ESPECIFICADO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O060",
    "nombre_dx": "O060-ABORTO NO ESPECIFICADO: INCOMPLETO, COMPLICADO CON INFECCIÓN GENITAL Y PELVIANA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O061",
    "nombre_dx": "O061-ABORTO NO ESPECIFICADO: INCOMPLETO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O062",
    "nombre_dx": "O062-ABORTO NO ESPECIFICADO: INCOMPLETO, COMPLICADO POR EMBOLIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O063",
    "nombre_dx": "O063-ABORTO NO ESPECIFICADO: INCOMPLETO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICADAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O064",
    "nombre_dx": "O064-ABORTO NO ESPECIFICADO: INCOMPLETO, SIN COMPLICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O065",
    "nombre_dx": "O065-ABORTO NO ESPECIFICADO: COMPLETO O NO ESPECIFICADO, COMPLICADO CON INFECCION GENITAL Y PELVIANA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O066",
    "nombre_dx": "O066-ABORTO NO ESPECIFICADO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O067",
    "nombre_dx": "O067-ABORTO NO ESPECIFICADO: COMPLETO O NO ESPECIFICADO, COMPLICADO POR EMBOLIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O068",
    "nombre_dx": "O068-ABORTO NO ESPECIFICADO: COMPLETO O NO ESPECIFICADO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O069",
    "nombre_dx": "O069-ABORTO NO ESPECIFICADO: COMPLETO O NO ESPECIFICADO, SIN COMPLICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O070",
    "nombre_dx": "O070-FALLA DE LA INDUCCION MEDICA DEL ABORTO, COMPLICADO CON INFECCIÓN GENITAL Y PELVIANA",
    "sexo": "F"
  },
  {
    "cod_dx": "O071",
    "nombre_dx": "O071-FALLA DE LA INDUCCION MEDICA DEL ABORTO, COMPLICADO POR HEMORRAGIA EXCESIVA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O072",
    "nombre_dx": "O072-FALLA DE LA INDUCCION MEDICA DEL ABORTO,COMPLICADO POR EMBOLIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O073",
    "nombre_dx": "O073-FALLA DE LA INDUCCION MEDICA DEL ABORTO, CON OTRAS COMPLICACIONES ESPECIFICADAS Y LAS NO ESPECIFICAD",
    "sexo": "F"
  },
  {
    "cod_dx": "O074",
    "nombre_dx": "O074-FALLA DE LA INDUCCION MEDICA DEL ABORTO, SIN COMPLICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O075",
    "nombre_dx": "O075-OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR INFECCION GENITAL Y PELVIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O076",
    "nombre_dx": "O076-OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR HEMORRAGIA EXCESIVA O TARD",
    "sexo": "F"
  },
  {
    "cod_dx": "O077",
    "nombre_dx": "O077-OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, COMPLICADOS POR EMBOLIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O078",
    "nombre_dx": "O078-OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, CON OTRAS COMPLICACIONES ESPECIFICADAS Y L",
    "sexo": "F"
  },
  {
    "cod_dx": "O079",
    "nombre_dx": "O079-OTROS INTENTOS FALLIDOS DE ABORTO Y LOS NO ESPECIFICADOS, SIN COMPLICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O080",
    "nombre_dx": "O080-INFECCION GENITAL Y PELVIANA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O081",
    "nombre_dx": "O081-HEMORRAGIA EXCESIVA O TARDIA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O082",
    "nombre_dx": "O082-EMBOLIA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR ",
    "sexo": "F"
  },
  {
    "cod_dx": "O083",
    "nombre_dx": "O083-CHOQUE CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O084",
    "nombre_dx": "O084-INSUFICIENCIA RENAL CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR ",
    "sexo": "F"
  },
  {
    "cod_dx": "O085",
    "nombre_dx": "O085-TRASTORNO METABOLICO CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O086",
    "nombre_dx": "O086-LESION DE ORGANOS O TEJIDOS DE LA PELVIS CONSECUTIVO AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO M",
    "sexo": "F"
  },
  {
    "cod_dx": "O087",
    "nombre_dx": "O087-OTRAS COMPLICACIONES VENOSAS CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O088",
    "nombre_dx": "O088-OTRAS COMPLICACIONES CONSECUTIVAS AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR ",
    "sexo": "F"
  },
  {
    "cod_dx": "O089",
    "nombre_dx": "O089-COMPLICACION NO ESPECIFICADA CONSECUTIVA AL ABORTO, AL EMBARAZO ECTOPICO Y AL EMBARAZO MOLAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O100",
    "nombre_dx": "O100-HIPERTENSION ESENCIAL PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O101",
    "nombre_dx": "O101-ENFERMEDAD CARDIACA HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O102",
    "nombre_dx": "O102-ENFERMEDAD RENAL HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O103",
    "nombre_dx": "O103-ENFERMEDAD CARDIO-RENAL HIPERTENSIVA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O104",
    "nombre_dx": "O104-HIPERTENSION SECUNDARIA PREEXISTENTE QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O109",
    "nombre_dx": "O109-HIPERTENSION PREEXISTENTE NO ESPECIFICADA, QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O11X",
    "nombre_dx": "O11X-Preeclampsia superpuesta en hipertensión crónica",
    "sexo": "F"
  },
  {
    "cod_dx": "O120",
    "nombre_dx": "O120-EDEMA GESTACIONAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O121",
    "nombre_dx": "O121-PROTEINURIA GESTACIONAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O122",
    "nombre_dx": "O122-EDEMA GESTACIONAL CON PROTEINURIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O13X",
    "nombre_dx": "O13X-Hipertensión gestacional [inducida por el embarazo] (antes TRASTORNOS HIPERTENSIVOS PREEXISTENTES, SIN PROTEINURIA AGREGADA)",
    "sexo": "F"
  },
  {
    "cod_dx": "O140",
    "nombre_dx": "O140-Preeclampsia leve a moderada",
    "sexo": "F"
  },
  {
    "cod_dx": "O141",
    "nombre_dx": "O141-PREECLAMPSIA SEVERA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O142",
    "nombre_dx": "O142-Síndrome HELLP",
    "sexo": "A"
  },
  {
    "cod_dx": "O149",
    "nombre_dx": "O149-PREECLAMPSIA, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O14X",
    "nombre_dx": "O14X-Preeclampsia (antes HIPERTENSION GESTACIONAL [INDUCIDA POR EL EMBARAZO] CON PROTEINURIA SIGNIFICATIVA)",
    "sexo": "A"
  },
  {
    "cod_dx": "O150",
    "nombre_dx": "O150-PREECLAMPSIA EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O151",
    "nombre_dx": "O151-PREECLAMPSIA DURANTE EL TRABAJO DE PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O152",
    "nombre_dx": "O152-PREECLAMPSIA EN EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O159",
    "nombre_dx": "O159-PREECLAMPSIA, EN PERIODO NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O16X",
    "nombre_dx": "O16X-HIPERTENSION MATERNA, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O200",
    "nombre_dx": "O200-AMENAZA DE ABORTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O208",
    "nombre_dx": "O208-OTRAS HEMORRAGIASPRECOCES DEL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O209",
    "nombre_dx": "O209-HEMORRAGIAPRECOZ DEL EMBARAZO, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O210",
    "nombre_dx": "O210-HIPEREMESIS GRAVIDICA LEVE",
    "sexo": "F"
  },
  {
    "cod_dx": "O211",
    "nombre_dx": "O211-HIPEREMESIS GRAVIDICA CON TRASTORNOS METABOLICOS",
    "sexo": "F"
  },
  {
    "cod_dx": "O212",
    "nombre_dx": "O212-HIPEREMESIS GRAVIDICA TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O218",
    "nombre_dx": "O218-OTROS VOMITOS QUE COMPLICAN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O219",
    "nombre_dx": "O219-VOMITOS DEL EMBARAZO, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O220",
    "nombre_dx": "O220-VENAS VARICOSAS DE LOS MIEMBROS INFERIORES EN ELEMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O221",
    "nombre_dx": "O221-VARICES GENITALES EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O222",
    "nombre_dx": "O222-TROMBOFLEBITIS EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O223",
    "nombre_dx": "O223-FLEBOTROMBOSIS PROFUNDA EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O224",
    "nombre_dx": "O224-HEMORROIDES EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O225",
    "nombre_dx": "O225-TROMBOSIS VENOSA CEREBRAL EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O228",
    "nombre_dx": "O228-OTRAS COMPLICACIONES VENOSAS EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O229",
    "nombre_dx": "O229-COMPLICACION VENOSA NO ESPECIFICADA EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O22X",
    "nombre_dx": "O22X-Complicaciones venosas y hemorroides en el embarazo (COMPLICACIONES VENOSAS EN EL EMBARAZO)",
    "sexo": "A"
  },
  {
    "cod_dx": "O230",
    "nombre_dx": "O230-INFECCION DEL RIÑON EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O231",
    "nombre_dx": "O231-INFECCION DE LA VEJIGA URINARIA EN EL EMBARAZ0",
    "sexo": "F"
  },
  {
    "cod_dx": "O232",
    "nombre_dx": "O232-INFECCION DE LA URETRA EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O233",
    "nombre_dx": "O233-INFECCION DE OTRAS PARTES DE LAS VIAS URINARIAS EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O234",
    "nombre_dx": "O234-INFECCION NO ESPECIFICADA DE LAS VIAS URINARIAS EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O235",
    "nombre_dx": "O235-INFECCION GENITAL EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O239",
    "nombre_dx": "O239-OTRAS INFECCION Y LAS NO ESPECIFICADAS DELAS VIAS GENITOURINARIAS EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O240",
    "nombre_dx": "O240-DIABETES MELLITUSPREEXISTENTE INSULINODEPENDIENTE, EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O241",
    "nombre_dx": "O241-DIABETES MELLITUSPREEXISTENTE NO INSULINODEPENDIENTE, EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O242",
    "nombre_dx": "O242-DIABETES MELLITUSPREEXISTENTE RELACIONADA CON DESNUTRICION, EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O243",
    "nombre_dx": "O243-DIABETES MELLITUSPREEXISTENTE, SIN OTRA ESPECIFICACION, EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O244",
    "nombre_dx": "O244-DIABETES MELLITUS QUE SEORIGINA EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O249",
    "nombre_dx": "O249-DIABETES MELLITUS NOESPECIFICADA, EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O25X",
    "nombre_dx": "O25X-DESNUTRICION EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O260",
    "nombre_dx": "O260-AUMENTO EXCESIVO DE PESO EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O261",
    "nombre_dx": "O261-AUMENTO PEQUEÑO DE PESO EN EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O262",
    "nombre_dx": "O262-ATENCION DEL EMBARAZO EN UNA ABORTADORA HABITUAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O263",
    "nombre_dx": "O263-RETENCION DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO EN EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O264",
    "nombre_dx": "O264-HERPES GESTACIONAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O265",
    "nombre_dx": "O265-SINDROME DE HIPOTENSION MATERNA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O266",
    "nombre_dx": "O266-TRASTORNO DEL HIGADO EN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O267",
    "nombre_dx": "O267-SUBLUXACION DE LA SINFISIS (DEL PUBIS) EN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O268",
    "nombre_dx": "O268-OTRAS COMPLICACIONES ESPECIFICADAS RELACIONADAS CON EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O269",
    "nombre_dx": "O269-COMPLICACION RELACIONADA CON EL EMBARAZO, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O280",
    "nombre_dx": "O280-HALLAZGO HEMATOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LAMADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O281",
    "nombre_dx": "O281-HALLAZGO BIOQUIMICO ANORMAL EN EL EXAMEN PRENATAL DE LAMADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O282",
    "nombre_dx": "O282-HALLAZGO CITOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LAMADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O283",
    "nombre_dx": "O283-HALLAZGO ULTRASONICO ANORMAL EN EL EXAMEN PRENATAL DE LAMADRE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O284",
    "nombre_dx": "O284-HALLAZGO RADIOLOGICO ANORMAL EN EL EXAMEN PRENATAL DE LAMADRE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O285",
    "nombre_dx": "O285-HALLAZGO CROMOSOMICO O GENETICOANORMAL EN EL EXAMEN PRENATAL DE LAMADRE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O288",
    "nombre_dx": "O288-OTROS HALLAZGOSANORMALES EN EL EXAMEN PRENATAL DE LAMADRE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O289",
    "nombre_dx": "O289-HALLAZGO ANORMAL NO ESPECIFICADOEN EL EXAMEN PRENATAL DE LAMADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O290",
    "nombre_dx": "O290-COMPLICACIONES PULMONARES DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O291",
    "nombre_dx": "O291-COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O292",
    "nombre_dx": "O292-COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL DEBIDAS A LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O293",
    "nombre_dx": "O293-REACCION TOXICA A LA ANESTESIALOCAL ADMINISTRADA DURANTE EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O294",
    "nombre_dx": "O294-CEFALALGIA INDUCIDA POR LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O295",
    "nombre_dx": "O295-OTRAS COMPLICACIONES DE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O296",
    "nombre_dx": "O296-FALLA O DIFICULTAD EN LA INTUBACION DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O298",
    "nombre_dx": "O298-OTRAS COMPLICACIONESDE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O299",
    "nombre_dx": "O299-COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL EMBARAZO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O300",
    "nombre_dx": "O300-EMBARAZO DOBLE",
    "sexo": "F"
  },
  {
    "cod_dx": "O301",
    "nombre_dx": "O301-EMBARAZO TRIPLE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O302",
    "nombre_dx": "O302-EMBARAZO CUADRUPLE",
    "sexo": "F"
  },
  {
    "cod_dx": "O308",
    "nombre_dx": "O308-OTROS EMBARAZOS MULTIPLES ",
    "sexo": "F"
  },
  {
    "cod_dx": "O309",
    "nombre_dx": "O309-EMBARAZO MULTIPLE, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O310",
    "nombre_dx": "O310-FETO PAPIRACEO",
    "sexo": "F"
  },
  {
    "cod_dx": "O311",
    "nombre_dx": "O311-EMBARAZO QUE CONTINUA DESPUES DEL ABORTO DE UN FETO O MAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O312",
    "nombre_dx": "O312-EMBARAZO QUE CONTINUA DESPUES DE LA MUERTE INTRAUTERINA DE UN FETO O MAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O318",
    "nombre_dx": "O318-OTRASCOMPLICACIONES ESPECIFICADAS DEL EMBARAZO",
    "sexo": "F"
  },
  {
    "cod_dx": "O320",
    "nombre_dx": "O320-ATENCION MATERNA POR POSICION FETAL INESTABLE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O321",
    "nombre_dx": "O321-ATENCION MATERNA POR PRESENTACION DE NALGAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O322",
    "nombre_dx": "O322-ATENCION MATERNA POR POSICION FETAL OBLICUA O TRANSVERSA",
    "sexo": "F"
  },
  {
    "cod_dx": "O323",
    "nombre_dx": "O323-ATENCION MATERNA POR PRESENTACION DE CARA, DE FRENTE O DE MENTON",
    "sexo": "F"
  },
  {
    "cod_dx": "O324",
    "nombre_dx": "O324-ATENCION MATERNA POR CABEZA ALTA EN GESTACION A TERMINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O325",
    "nombre_dx": "O325-ATENCION MATERNA POR EMBARAZO MULTIPLE CON PRESENTACION ANORMAL DE UN FETO O MAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O326",
    "nombre_dx": "O326-ATENCION MATERNA POR PRESENTACION COMPUESTA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O328",
    "nombre_dx": "O328-ATENCION MATERNA POR OTRAS PRESENTACIONES ANORMALES DEL FETO",
    "sexo": "F"
  },
  {
    "cod_dx": "O329",
    "nombre_dx": "O329-ATENCION MATERNA POR PRESENTACION ANORMAL NO ESPECIFICADA DEL FETO",
    "sexo": "F"
  },
  {
    "cod_dx": "O330",
    "nombre_dx": "O330-ATENCION MATERNA PORDESPROPORCION DEBIDA A DEFORMIDAD DELA PELVIS OSEA EN LA MADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O331",
    "nombre_dx": "O331-ATENCION MATERNA PORDESPROPORCION DEBIDA A ESTRECHEZ GENERAL DELA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O332",
    "nombre_dx": "O332-ATENCION MATERNA PORDESPROPORCION DEBIDA A DISMINUCION DEL ESTRECHO SUPERIORDELA PELVIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O333",
    "nombre_dx": "O333-ATENCION MATERNA PORDESPROPORCION DEBIDA A DISMINUCION DEL ESTRECHO INFERIORDELA PELVIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O334",
    "nombre_dx": "O334-ATENCION MATERNA PORDESPROPORCION FETOPELVIANA DE ORIGEN MIXTO, MATERNO Y FETAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O335",
    "nombre_dx": "O335-ATENCION MATERNA PORDESPROPORCION DEBIDA A FETO DEMASIADO GRANDE",
    "sexo": "F"
  },
  {
    "cod_dx": "O336",
    "nombre_dx": "O336-ATENCION MATERNA PORDESPROPORCION DEBIDA A FETO HIDROCEFALICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O337",
    "nombre_dx": "O337-ATENCION MATERNA PORDESPROPORCION DEBIDA A OTRA DEFORMIDAD FETAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O338",
    "nombre_dx": "O338-ATENCION MATERNA PORDESPROPORCION DE OTRO ORIGEN",
    "sexo": "F"
  },
  {
    "cod_dx": "O339",
    "nombre_dx": "O339-ATENCION MATERNA PORDESPROPORCION DE ORIGEN NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O340",
    "nombre_dx": "O340-ATENCION MATERNA POR ANOMALIA CONGENITA DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O341",
    "nombre_dx": "O341-ATENCION MATERNA POR TUMOR DEL CUERPO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O342",
    "nombre_dx": "O342-ATENCION MATERNA POR CICATRIZ UTERINA DEBIDA A CIRUGIA PREVIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O343",
    "nombre_dx": "O343-ATENCION MATERNA POR INCOMPETENCIA DEL CUELLO UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O344",
    "nombre_dx": "O344-ATENCION MATERNA POR OTRA ANORMALIDAD DEL CUELLO UTERINO",
    "sexo": "F"
  },
  {
    "cod_dx": "O345",
    "nombre_dx": "O345-ATENCION MATERNA POR OTRAS ANORMALIDADES DEL UTERO GRAVIDO",
    "sexo": "F"
  },
  {
    "cod_dx": "O346",
    "nombre_dx": "O346-ATENCION MATERNA POR ANORMALIDAD DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O347",
    "nombre_dx": "O347-ATENCION MATERNA POR ANORMALIDAD DE LA VULVA Y DEL PERINEO",
    "sexo": "F"
  },
  {
    "cod_dx": "O348",
    "nombre_dx": "O348-ATENCION MATERNA POR ANORMALIDADES DE LOS ORGANOS PELVIANOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O349",
    "nombre_dx": "O349-ATENCION MATERNA POR ANORMALIDAD NO ESPECIFICADA DE ORGANO PELVIANO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O350",
    "nombre_dx": "O350-ATENCION MATERNA POR (PRESUNTA)MALFORMACION DEL SISTEMA NERVIOSO CENTRAL EN EL FETO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O351",
    "nombre_dx": "O351-ATENCION MATERNA POR (PRESUNTA)ANORMALIDAD CROMOSOMICA EN EL FETO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O352",
    "nombre_dx": "O352-ATENCION MATERNA POR (PRESUNTA)ENFERMEDAD HEREDITARIA EN EL FETO",
    "sexo": "F"
  },
  {
    "cod_dx": "O353",
    "nombre_dx": "O353-ATENCION MATERNA POR (PRESUNTA)LESION FETAL DEBIDA A ENFERMEDAD VIRICA EN LA MADRE",
    "sexo": "F"
  },
  {
    "cod_dx": "O354",
    "nombre_dx": "O354-ATENCION MATERNA POR (PRESUNTA)LESION AL FETO DEBIDA AL ALCOHOL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O355",
    "nombre_dx": "O355-ATENCION MATERNA POR (PRESUNTA) LESION FETAL DEBIDA A DROGAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O356",
    "nombre_dx": "O356-ATENCION MATERNA POR (PRESUNTA)LESION AL FETO DEBIDA A RADIACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O357",
    "nombre_dx": "O357-ATENCION MATERNA POR (PRESUNTA)LESION FETAL DEBIDA A OTROS PROCEDIMIENTOS MEDICOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O358",
    "nombre_dx": "O358-ATENCION MATERNA POR OTRAS (PRESUNTA)ANORMALIDADES Y LESIONES FETALES ",
    "sexo": "F"
  },
  {
    "cod_dx": "O359",
    "nombre_dx": "O359-ATENCION MATERNA POR (PRESUNTA) ANORMALIDAD Y LESIONFETAL NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O360",
    "nombre_dx": "O360-ATENCION MATERNA POR ISOINMUNIZACION RHESUS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O361",
    "nombre_dx": "O361-ATENCION MATERNA POR OTRA ISOINMUNIZACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O362",
    "nombre_dx": "O362-ATENCION MATERNA POR HIDROPESIA FETAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O363",
    "nombre_dx": "O363-ATENCION MATERNA POR SIGNOS DE HIPOXIA FETAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O364",
    "nombre_dx": "O364-ATENCION MATERNA POR MUERTE INTRAUTERINA",
    "sexo": "F"
  },
  {
    "cod_dx": "O365",
    "nombre_dx": "O365-ATENCION MATERNA POR DEFICIT DEL CRECIMIENTO FETAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O366",
    "nombre_dx": "O366-ATENCION MATERNA POR CRECIMIENTO FETAL EXCESIVO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O367",
    "nombre_dx": "O367-ATENCION MATERNA POR FETO VIABLEEN EMBARAZO ABDOMINAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O368",
    "nombre_dx": "O368-ATENCION MATERNA POR OTROS PROBLEMAS FETALESESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O369",
    "nombre_dx": "O369-ATENCION MATERNA POR OTROS PROBLEMAS FETALES NO ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O40X",
    "nombre_dx": "O40X-POLIHIDRAMNIOS",
    "sexo": "F"
  },
  {
    "cod_dx": "O410",
    "nombre_dx": "O410-OLIGOHIDRAMNIOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O411",
    "nombre_dx": "O411-INFECCION DE LA BOLSA AMNIOTICA O DE LAS MEMBRANAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O418",
    "nombre_dx": "O418-OTROS TRASTORNOS ESPECIFICADOS DEL LIQUIDO AMNIOTICO Y DE LAS MEMBRANAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O419",
    "nombre_dx": "O419-TRASTORNO DEL LIQUIDO AMNIOTICO Y DE LAS MEMBRANAS, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O420",
    "nombre_dx": "O420-RUPTURA PREMATURA DE LAS MEMBRANAS, E INICIO DEL TRABAJO DE PARTO DENTRO DE LAS 24 HORAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O421",
    "nombre_dx": "O421-RUPTURA PREMATURA DE LAS MEMBRANAS, E INICIO DEL TRABAJO DE PARTO DESPUÉS DE LAS 24 HORAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O422",
    "nombre_dx": "O422-RUPTURA PREMATURA DE LAS MEMBRANAS, TRABAJO DE PARTO RETRASADO POR LA TERAPEUTICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O429",
    "nombre_dx": "O429-RUPTURA PREMATURA DE LAS MEMBRANAS, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O430",
    "nombre_dx": "O430-SINDROME DE TRANSFUSION PLACENTERA",
    "sexo": "F"
  },
  {
    "cod_dx": "O431",
    "nombre_dx": "O431-MALFORMACION DE LA PLACENTA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O432",
    "nombre_dx": "O432-Placenta anormalmente adherida",
    "sexo": "A"
  },
  {
    "cod_dx": "O438",
    "nombre_dx": "O438-OTROS TRASTORNOS PLACENTARIOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O439",
    "nombre_dx": "O439-TRASTORNO DE LA PLACENTA, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O440",
    "nombre_dx": "O440-PLACENTA PREVIA CON ESPECIFICACION DE QUE NO HUBO HEMORRAGIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O441",
    "nombre_dx": "O441-PLACENTA PREVIA CON HEMORRAGIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O450",
    "nombre_dx": "O450-DESPRENDIMIENTO PREMATURO DE LA PLACENTA CON DEFECTO DE LA COAGULACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O458",
    "nombre_dx": "O458-OTROS DESPRENDIMIENTOS PREMATUROS DE LA PLACENTA",
    "sexo": "F"
  },
  {
    "cod_dx": "O459",
    "nombre_dx": "O459-DESPRENDIMIENTO PREMATURO DE LA PLACENTA, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O460",
    "nombre_dx": "O460-HEMORRAGIA ANTEPARTO CON DEFECTODE LA COAGULACIÓN ",
    "sexo": "F"
  },
  {
    "cod_dx": "O468",
    "nombre_dx": "O468-OTRAS HEMORRAGIAS ANTEPARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O469",
    "nombre_dx": "O469-HEMORRAGIA ANTEPARTO, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O470",
    "nombre_dx": "O470-FALSO TRABAJO DE PARTO ANTES DE LA 37 SEMANAS COMPLETAS DE GESTACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O471",
    "nombre_dx": "O471-FALSO TRABAJO DE PARTO ANTES DE LA 37Y MAS SEMANAS COMPLETAS DE GESTACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O479",
    "nombre_dx": "O479-FALSO TRABAJO DE PARTO SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O48X",
    "nombre_dx": "O48X-EMBARAZO PROLONGADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O601",
    "nombre_dx": "O601-Trabajo de parto prematuro espontáneo con parto prematuro",
    "sexo": "A"
  },
  {
    "cod_dx": "O602",
    "nombre_dx": "O602-Trabajo de parto prematuro espontáneo con parto a término",
    "sexo": "A"
  },
  {
    "cod_dx": "O603",
    "nombre_dx": "O603-Parto prematuro sin trabajo de parto espontáneo",
    "sexo": "A"
  },
  {
    "cod_dx": "O60X",
    "nombre_dx": "O60X-Trabajo de parto prematuro y parto (antes TRABAJO DE PARTO PREMATURO)",
    "sexo": "F"
  },
  {
    "cod_dx": "O610",
    "nombre_dx": "O610-FRACASO DE LA INDUCCION MEDICA DEL TRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O611",
    "nombre_dx": "O611-FRACASO DE LA INDUCCION INSTRUMENTALDEL TRABAJO DE PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O618",
    "nombre_dx": "O618-OTROS FRACASOS DE LA INDUCCION DEL TRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O619",
    "nombre_dx": "O619-FRACASO NO ESPECIFICADO DE LA INDUCCION DEL TRABAJO DE PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O620",
    "nombre_dx": "O620-CONTRACCIONES PRIMARIAS INADECUADAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O621",
    "nombre_dx": "O621-INERCIA UTERINA SECUNDARIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O622",
    "nombre_dx": "O622-OTRAS INERCIAS UTERINAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O623",
    "nombre_dx": "O623-TRABAJO DE PARTO PRECIPITADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O624",
    "nombre_dx": "O624-CONTRACCIONES UTERINAS HIPERTONICAS, INCOORDINADAS Y PROLONGADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O628",
    "nombre_dx": "O628-OTRAS ANOMALIAS DINAMICAS DEL TRABAJO DE PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O629",
    "nombre_dx": "O629-ANOMALIA DINAMICA DEL TRABAJO DE PARTO, NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O630",
    "nombre_dx": "O630-PROLONGACION DEL PRIMER PERIODO (DEL TRABAJO DE PARTO)",
    "sexo": "F"
  },
  {
    "cod_dx": "O631",
    "nombre_dx": "O631-PROLONGACION DEL SEGUNDO PERIODO (DEL TRABAJO DE PARTO) ",
    "sexo": "F"
  },
  {
    "cod_dx": "O632",
    "nombre_dx": "O632-RETRASO DE LA EXPULSION DEL SEGUNDO GEMELO, DEL TERCERO, ETC",
    "sexo": "F"
  },
  {
    "cod_dx": "O639",
    "nombre_dx": "O639-TRABAJO DE PARTO PROLONGADO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O640",
    "nombre_dx": "O640-TRABAJO DE PARTO OBSTRUIDO DEBIDO A ROTACION INCOMPLETA DE LA CABEZA FETAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O641",
    "nombre_dx": "O641-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE NALGAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O642",
    "nombre_dx": "O642-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACIONDE CARA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O643",
    "nombre_dx": "O643-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE FRENTE",
    "sexo": "F"
  },
  {
    "cod_dx": "O644",
    "nombre_dx": "O644-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION DE HOMBRO",
    "sexo": "F"
  },
  {
    "cod_dx": "O645",
    "nombre_dx": "O645-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION COMPUESTA",
    "sexo": "F"
  },
  {
    "cod_dx": "O648",
    "nombre_dx": "O648-TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS PRESENTACIONES ANORMALES DEL FETO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O649",
    "nombre_dx": "O649-TRABAJO DE PARTO OBSTRUIDO DEBIDO A PRESENTACION ANORMAL DEL FETONO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O650",
    "nombre_dx": "O650-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DEFORMIDAD DE LA PELVIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O651",
    "nombre_dx": "O651-TRABAJO DE PARTO OBSTRUIDO DEBIDO A ESTRECHEZ GENERAL DE LA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O652",
    "nombre_dx": "O652-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISMINUCION DEL ESTRECHO SUPERIOR DE LA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O653",
    "nombre_dx": "O653-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISMINUCION DEL ESTRECHO INFERIOR DE LA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O654",
    "nombre_dx": "O654-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DESPROPORCION FETOPELVIANA, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O655",
    "nombre_dx": "O655-TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALIAS DE LOS ORGANOS PELVIANOS MATERNOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O658",
    "nombre_dx": "O658-TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS ANOMALIAS PELVIANASMATERNAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O659",
    "nombre_dx": "O659-TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALIA PELVIANA NO ESPECIFICADA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O660",
    "nombre_dx": "O660-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA DE HOMBROS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O661",
    "nombre_dx": "O661-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA GEMELAR",
    "sexo": "F"
  },
  {
    "cod_dx": "O662",
    "nombre_dx": "O662-TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA POR FETO INUSUALMENTE GRANDE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O663",
    "nombre_dx": "O663-TRABAJO DE PARTO OBSTRUIDO DEBIDO A OTRAS ANORMALIDADES DEL FETO",
    "sexo": "F"
  },
  {
    "cod_dx": "O664",
    "nombre_dx": "O664-FRACASO DE LA PRUEBA DEL TRABAJO DE PARTO, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O665",
    "nombre_dx": "O665-FRACASO NO ESPECIFICADO DE LA APLICACION DE FORCEPS O DEVENTOSA EXTRACTORA",
    "sexo": "F"
  },
  {
    "cod_dx": "O668",
    "nombre_dx": "O668-OTRAS OBSTRUCCIONES ESPECIFICADAS DELTRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O669",
    "nombre_dx": "O669-TRABAJO DE PARTO OBSTRUIDO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O670",
    "nombre_dx": "O670-HEMORRAGIA INTRAPARTO CON DEFECTOS DE LA COAGULACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O678",
    "nombre_dx": "O678-OTRAS HEMORRAGIAS INTRAPARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O679",
    "nombre_dx": "O679-HEMORRAGIA INTRAPARTO, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O680",
    "nombre_dx": "O680-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR ANOMALIAS DE LA FRECUENCIA CARDIACA FETAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O681",
    "nombre_dx": "O681-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR LA PRESENCIA DE MECONIO EN EL LIQUIDO AMNIOTICO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O682",
    "nombre_dx": "O682-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR ANOMALIA DE LA FRECUENCIA CARDIACA FETAL ASOCIADA CON PRES",
    "sexo": "F"
  },
  {
    "cod_dx": "O683",
    "nombre_dx": "O683-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR EVIDENCIA BIOQUIMICA DE SUFRIMIENTO FETAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O688",
    "nombre_dx": "O688-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR OTRAS EVIDENCIAS DE SUFRIMIENTO FETAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O689",
    "nombre_dx": "O689-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORSUFRIMIENTO FETAL, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O690",
    "nombre_dx": "O690-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORPROLAPSO DEL CORDON UMBILICAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O691",
    "nombre_dx": "O691-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORCIRCULAR PERICERVICAL DEL CORDON,CON COMPRESION",
    "sexo": "F"
  },
  {
    "cod_dx": "O692",
    "nombre_dx": "O692-Trabajo de parto y parto complicados por otros enredos del cordón umblical con compresión (antes TRABAJO DE PARTO Y PARTO COMPLICADOS POR OTROS ENREDOS DEL CORDON)",
    "sexo": "F"
  },
  {
    "cod_dx": "O693",
    "nombre_dx": "O693-TRABAJO DE PARTO Y PARTOCOMPLICADOS POR CORDON UMBILICAL CORTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O694",
    "nombre_dx": "O694-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORVASA PREVIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O695",
    "nombre_dx": "O695-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORLESION VASCULAR DEL CORDON ",
    "sexo": "F"
  },
  {
    "cod_dx": "O698",
    "nombre_dx": "O698-TRABAJO DE PARTO Y PARTOCOMPLICADOS POROTROS PROBLEMAS DEL CORDON UMBILICAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O699",
    "nombre_dx": "O699-TRABAJO DE PARTO Y PARTOCOMPLICADOS PORPROBLEMAS NO ESPECIFICADOS DEL CORDON UMBILICAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O700",
    "nombre_dx": "O700-DESGARRO PERINEAL DE PRIMER GRADO DURANTE EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O701",
    "nombre_dx": "O701-DESGARRO PERINEAL DE SEGUNDO GRADO DURANTE EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O702",
    "nombre_dx": "O702-DESGARRO PERINEAL DE TERCER GRADO DURANTE EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O703",
    "nombre_dx": "O703-DESGARRO PERINEAL DE CUARTOGRADO DURANTE EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O709",
    "nombre_dx": "O709-DESGARRO PERINEALDURANTE EL PARTO, DE GRADO NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O710",
    "nombre_dx": "O710-RUPTURA DEL UTERO ANTES DEL INICIO DEL TRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O711",
    "nombre_dx": "O711-RUPTURA DEL UTERO DURANTE EL TRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O712",
    "nombre_dx": "O712-INVERSION DEL UTERO, POSTPARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O713",
    "nombre_dx": "O713-DESGARRO OBSTETRICO DEL CUELLO UTERINO",
    "sexo": "F"
  },
  {
    "cod_dx": "O714",
    "nombre_dx": "O714-Desgarro vaginal obstétrico alto (antes DESGARRO VAGINAL OBSTETRICO ALTO, SOLO)",
    "sexo": "F"
  },
  {
    "cod_dx": "O715",
    "nombre_dx": "O715-OTROS TRAUMATISMOS OBSTETRICOS DE LOS ORGANOS PELVIANOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O716",
    "nombre_dx": "O716-TRAUMATISMO OBSTETRICO DE LOS LIGAMENTOS ARTICULACIONES DE LA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O717",
    "nombre_dx": "O717-HEMATOMA OBSTETRICO DE LA PELVIS",
    "sexo": "F"
  },
  {
    "cod_dx": "O718",
    "nombre_dx": "O718-OTROS TRAUMAS OBSTETRICOS ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O719",
    "nombre_dx": "O719-TRAUMA OBSTETRICO, NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "O720",
    "nombre_dx": "O720-HEMORRAGIA DEL TERCER PERIODO DEL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O721",
    "nombre_dx": "O721-OTRAS HEMORRAGIAS POSTPARTO INMEDIATAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O722",
    "nombre_dx": "O722-HEMORRAGIA POSTPARTO SECUNDARIA O TARDIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O723",
    "nombre_dx": "O723-DEFECTO DE LA COAGULACIÓN POSTPARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O730",
    "nombre_dx": "O730-RETENCION DE LA PLACENTA SIN HEMORRAGIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O731",
    "nombre_dx": "O731-RETENCION DE FRAGMENTOS DE LA PLACENTA O DE LAS MEMBRANAS, SIN HEMORRAGIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O740",
    "nombre_dx": "O740-NEUMONITIS POR ASPIRACION DEBIDA A LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O741",
    "nombre_dx": "O741-OTRAS COMPLICACIONES PULMONARES DEBIDAS A LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL",
    "sexo": "F"
  },
  {
    "cod_dx": "O742",
    "nombre_dx": "O742-COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O743",
    "nombre_dx": "O743-COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL POR LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PART",
    "sexo": "F"
  },
  {
    "cod_dx": "O744",
    "nombre_dx": "O744-REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O745",
    "nombre_dx": "O745-CEFALALGIA INDUCIDA PORLA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL TRABAJO DE PARTO Y",
    "sexo": "F"
  },
  {
    "cod_dx": "O746",
    "nombre_dx": "O746-OTRAS COMPLICACIONESDE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL TRABAJO DE PARTO Y",
    "sexo": "F"
  },
  {
    "cod_dx": "O747",
    "nombre_dx": "O747-FALLA O DIFICULTAD EN LA INTUBACION DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O748",
    "nombre_dx": "O748-OTRAS COMPLICACIONES DE LA ANESTESIAADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O749",
    "nombre_dx": "O749-COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O750",
    "nombre_dx": "O750-SUFRIMIENTO MATERNO DURANTE EL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O751",
    "nombre_dx": "O751-CHOQUE DURANTE O DESPUES DEL TRABAJO DE PARTO Y EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O752",
    "nombre_dx": "O752-PIREXA DURANTE EL TRABAJO DE PARTO, NO CLASIFICADA ENOTRA PARTE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O753",
    "nombre_dx": "O753-OTRAS INFECCIONES DURANTE EL TRABAJO DE PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O754",
    "nombre_dx": "O754-OTRAS COMPLICACIONES DE LA CIRUGIA Y OTROS PROCEDIMIENTOS OBSTETRICOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O755",
    "nombre_dx": "O755-RETRASO DEL PARTO DESPUES DE LA RUPTURA ARTIFICIAL DE LAS MEMBRANAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O756",
    "nombre_dx": "O756-RETRASO DEL PARTO DESPUES DE LA RUPTURA ESPONTANEA O NO ESPECIFICADA DE LAS MEMBRANAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O757",
    "nombre_dx": "O757-PARTO VAGINAL POSTERIOR A UNA CESAREA PREVIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O758",
    "nombre_dx": "O758-OTRAS COMPLICACIONES ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O759",
    "nombre_dx": "O759-COMPLICACION NO ESPECIFICADA DEL TRABAJO DE PARTO Y DEL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O800",
    "nombre_dx": "O800-PARTO UNICO ESPONTANEO, PRESENTACION CEFALICA DE VERTICE",
    "sexo": "F"
  },
  {
    "cod_dx": "O801",
    "nombre_dx": "O801-PARTO UNICO ESPONTANEO, PRESENTACION DE NALGAS O PODALICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O808",
    "nombre_dx": "O808-PARTO UNICO ESPONTANEO, OTRAS PRESENTACIONES",
    "sexo": "F"
  },
  {
    "cod_dx": "O809",
    "nombre_dx": "O809-PARTO UNICO ESPONTANEO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O810",
    "nombre_dx": "O810-PARTO CON FORCEPS BAJO",
    "sexo": "F"
  },
  {
    "cod_dx": "O811",
    "nombre_dx": "O811-PARTO CON FORCEPS MEDIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O812",
    "nombre_dx": "O812-PARTO CON FORCEPS MEDIO CON ROTACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O813",
    "nombre_dx": "O813-PARTO CON FORCEPS DE OTROS TIPOS Y LOS NO ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O814",
    "nombre_dx": "O814-PARTO CON VENTOSA EXTRACTORA",
    "sexo": "F"
  },
  {
    "cod_dx": "O815",
    "nombre_dx": "O815-PARTO CON COMBINACION DE FORCEPS Y VENTOSA EXTRACTORA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O820",
    "nombre_dx": "O820-PARTO POR CESAREA ELECTIVA",
    "sexo": "F"
  },
  {
    "cod_dx": "O821",
    "nombre_dx": "O821-PARTO POR CESAREA DE EMERGENCIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O822",
    "nombre_dx": "O822-PARTO POR CESAREA CON HISTERECTOMIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O828",
    "nombre_dx": "O828-OTROS PARTOS UNICOS POR CESAREA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O829",
    "nombre_dx": "O829-PARTO POR CESAREA, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "O830",
    "nombre_dx": "O830-EXTRACCION DE NALGAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O831",
    "nombre_dx": "O831-OTROS PARTOS UNICOS ASISTIDOS, DE NALGAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O832",
    "nombre_dx": "O832-OTROS PARTOS UNICOS CON AYUDA DE MANIPULACION OBSTETRICA",
    "sexo": "F"
  },
  {
    "cod_dx": "O833",
    "nombre_dx": "O833-PARTO DE FETO VIABLE EN EMBARAZOABDOMINAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O834",
    "nombre_dx": "O834-OPERACION DESTRUCTIVA PARA FACILITAR EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O838",
    "nombre_dx": "O838-OTROS PARTOS UNICOS ASISTIDOS ESPECIFICADOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O839",
    "nombre_dx": "O839-PARTO UNICO ASISTIDO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "O840",
    "nombre_dx": "O840-PARTO MULTIPLE, TODOS ESPONTANEOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O841",
    "nombre_dx": "O841-PARTO MULTIPLE, TODOS FORCEPS Y VENTOSA EXTRACTORA",
    "sexo": "F"
  },
  {
    "cod_dx": "O842",
    "nombre_dx": "O842-PARTO MULTIPLE, TODOS POR CESAREA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O848",
    "nombre_dx": "O848-OTROS PARTOS MULTIPLES",
    "sexo": "F"
  },
  {
    "cod_dx": "O849",
    "nombre_dx": "O849-PARTO MULTIPLE, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O85X",
    "nombre_dx": "O85X-SEPSIS PUERPERAL",
    "sexo": "F"
  },
  {
    "cod_dx": "O860",
    "nombre_dx": "O860-INFECCION DE HERIDA QUIRURGICA OBSTETRICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O861",
    "nombre_dx": "O861-OTRAS INFECCIONES GENITALES CONSECUTIVAS AL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O862",
    "nombre_dx": "O862-INFECCION DE LAS VIAS URINARIAS CONSECUTIVA AL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O863",
    "nombre_dx": "O863-OTRAS INFECCIONES DE LAS VIAS GENITOURINARIAS CONSECUTIVAS AL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O864",
    "nombre_dx": "O864-PIREXA DE ORIGEN DESCONOCIDO CONSECUTIVA AL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O868",
    "nombre_dx": "O868-OTRAS INFECCIONES PUERPERALES ESPECIFICADAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "O870",
    "nombre_dx": "O870-TROMBOFLEBITIS SUPERFICIAL EN EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O871",
    "nombre_dx": "O871-FLEBOTROMBOSIS PROFUNDA EN EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O872",
    "nombre_dx": "O872-HEMORROIDES EN EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O873",
    "nombre_dx": "O873-TROBOSIS VENOSA CEREBRAL EN EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O878",
    "nombre_dx": "O878-OTRAS COMPLICACIONES VENOSAS EN EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O879",
    "nombre_dx": "O879-COMPLICACION VENOSA EN EL PUERPERIO, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O87X",
    "nombre_dx": "O87X-Complicaciones venosas y hemorroides en el puerperio (antes COMPLICACIONES VENOSAS EN EL PUERPERIO)",
    "sexo": "A"
  },
  {
    "cod_dx": "O880",
    "nombre_dx": "O880-EMBOLIA GASEOSA, OBSTETRICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O881",
    "nombre_dx": "O881-EMBOLIA DE LIQUIDO AMNIOTICO",
    "sexo": "F"
  },
  {
    "cod_dx": "O882",
    "nombre_dx": "O882-EMBOLIA DE COAGULO SANGUINEO, OBSTETRICA",
    "sexo": "F"
  },
  {
    "cod_dx": "O883",
    "nombre_dx": "O883-EMBOLIA SEPTICA Y PIEMICA, OBSTETRICA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O888",
    "nombre_dx": "O888-OTRAS EMBOLIAS OBSTETRICAS",
    "sexo": "F"
  },
  {
    "cod_dx": "O890",
    "nombre_dx": "O890-COMPLICACIONES PULMONARES DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O891",
    "nombre_dx": "O891-COMPLICACIONES CARDIACAS DE LA ANESTESIA ADMINISTRADA DURANTE EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O892",
    "nombre_dx": "O892-COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL DEBIDAS ALA ANESTESIA ADMINISTRADA DURANTE EL PUERPERI",
    "sexo": "F"
  },
  {
    "cod_dx": "O893",
    "nombre_dx": "O893-REACCION TOXICA A LA ANESTESIA LOCAL ADMINISTRADA DURANTE EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O894",
    "nombre_dx": "O894-CEFALALGIA INDUCIDA PORLA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O895",
    "nombre_dx": "O895-OTRAS COMPLICACIONESDE LA ANESTESIA ESPINAL O EPIDURAL ADMINISTRADAS DURANTE EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O896",
    "nombre_dx": "O896-FALLA O DIFICULTAD EN LA INTUBACION DURANTE EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O898",
    "nombre_dx": "O898-OTRAS COMPLICACIONES DE LA ANESTESIAADMINISTRADA DURANTE EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O899",
    "nombre_dx": "O899-COMPLICACION NO ESPECIFICADA DE LA ANESTESIA ADMINISTRADA DURANTE EL TRABAJO PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O900",
    "nombre_dx": "O900-DEHISCENCIA DE SUTURA DE CESAREA",
    "sexo": "F"
  },
  {
    "cod_dx": "O901",
    "nombre_dx": "O901-DEHISCENCIA DE SUTURA OBSTÉTRICA PERINEAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O902",
    "nombre_dx": "O902-HEMATOMA DE HERIDA QUIRÚRGICA OBSTETRICA",
    "sexo": "F"
  },
  {
    "cod_dx": "O903",
    "nombre_dx": "O903-CARDIOMIOPATIA EN EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O904",
    "nombre_dx": "O904-INSUFICIENCIARENAL AGUDA POSTPARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O905",
    "nombre_dx": "O905-TIROIDITIS POSTPARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O908",
    "nombre_dx": "O908-OTRAS COMPLICACIONES PUERPERALES, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "F"
  },
  {
    "cod_dx": "O909",
    "nombre_dx": "O909-COMPLICACION PUERPERAL , NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O910",
    "nombre_dx": "O910-INFECCIONES DEL PEZON ASOCIADAS CON EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O911",
    "nombre_dx": "O911-ABSCESO DE LA MAMA ASOCIADO CON EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O912",
    "nombre_dx": "O912-MASTITIS NO PURULENTA ASOCIADA CON EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O920",
    "nombre_dx": "O920-RETRACCION DEL PEZON ASOCIADA CON EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O921",
    "nombre_dx": "O921-FISURAS DEL PEZON ASOCIADAS CON EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O922",
    "nombre_dx": "O922-OTROS TRASTORNOS DE LA MAMA Y LOS NO ESPECIFICADOS ASOCIADOS CON EL PARTO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O923",
    "nombre_dx": "O923-AGALACTIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O924",
    "nombre_dx": "O924-HIPOGALACTIA",
    "sexo": "F"
  },
  {
    "cod_dx": "O925",
    "nombre_dx": "O925-SUPRESION DE LA LACTANCIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O926",
    "nombre_dx": "O926-GALACTORREA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O927",
    "nombre_dx": "O927-OTROS TRASTORNOS Y LOS NO ESPECIFICADOS DE LA LACTANCIA ",
    "sexo": "F"
  },
  {
    "cod_dx": "O93X",
    "nombre_dx": "O93X-Muerte Materna de causa básica especificada en otro capitulo",
    "sexo": "M"
  },
  {
    "cod_dx": "O95X",
    "nombre_dx": "O95X-MUERTE OBSTETRICA DE CAUSA NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "O960",
    "nombre_dx": "O960-Muerte por causa obstétrica directa que ocurre después de 42 días pero antes de un año del parto",
    "sexo": "A"
  },
  {
    "cod_dx": "O961",
    "nombre_dx": "O961-Muerte por causa obstétrica indirecta que ocurre después de 42 días pero antes de un año del parto",
    "sexo": "A"
  },
  {
    "cod_dx": "O969",
    "nombre_dx": "O969-Muerte por causa obstétrica no especificada, que ocurre después de 42 días pero antes de un año del parto",
    "sexo": "A"
  },
  {
    "cod_dx": "O970",
    "nombre_dx": "O970-Muerte por secuelas de causa obstétrica directa",
    "sexo": "A"
  },
  {
    "cod_dx": "O971",
    "nombre_dx": "O971-Muerte por secuelas de causa obstétrica indirecta",
    "sexo": "A"
  },
  {
    "cod_dx": "O979",
    "nombre_dx": "O979-Muerte por secuelas de causa obstétrica no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "O980",
    "nombre_dx": "O980-TUBERCULOSIS QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O981",
    "nombre_dx": "O981-SIFILIS QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O982",
    "nombre_dx": "O982-GONORREA A QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O983",
    "nombre_dx": "O983-OTRAS INFECCIONES CON UN MODO DE TRANSMISION PREDOMINANTE SEXUAL QUE COMPLICAN EL EMBARAZO, EL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "O984",
    "nombre_dx": "O984-HEPATITIS VIRAL QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O985",
    "nombre_dx": "O985-OTRASENFERMEDADES VIRALES QUECOMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O986",
    "nombre_dx": "O986-ENFERMEDADES CAUSADAS PORPROTOZOARIOS QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O987",
    "nombre_dx": "O987-Enfermedad por virus de la inmunodeficiencia humana [VIH] que complica el embarazo, el parto y el puerperio",
    "sexo": "A"
  },
  {
    "cod_dx": "O988",
    "nombre_dx": "O988-OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIASMATERNAS QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUE",
    "sexo": "F"
  },
  {
    "cod_dx": "O989",
    "nombre_dx": "O989-ENFERMEDAD INFECCIOSA Y PARASITARIA MATERNA NO ESPECIFICADA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O990",
    "nombre_dx": "O990-ANEMIA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O991",
    "nombre_dx": "O991-OTRAS ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS Y CIERTOS TRASTORNOS QUE AFECTAN EL",
    "sexo": "F"
  },
  {
    "cod_dx": "O992",
    "nombre_dx": "O992-ENFERMEDADES ENDOCRINAS, DE LA NUTRICION Y DEL METABOLISMO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL ",
    "sexo": "F"
  },
  {
    "cod_dx": "O993",
    "nombre_dx": "O993-TRASTORNOS MENTALES Y ENFERMEDADES DEL SISTEMA NERVIOSO QUE COMPLICANEL EMBARAZO, EL PARTO Y EL PU",
    "sexo": "F"
  },
  {
    "cod_dx": "O994",
    "nombre_dx": "O994-ENFERMEDADES DEL SISTEMA CIRCULATORIO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O995",
    "nombre_dx": "O995-ENFERMEDADES DEL SISTEMARESPIRATORIO QUECOMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "O996",
    "nombre_dx": "O996-ENFERMEDADES DEL SISTEMA DIGESTIVO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O997",
    "nombre_dx": "O997-ENFERMEDADES DE LA PIEL Y DE TEJIDO SUBCUTANEO QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "O998",
    "nombre_dx": "O998-OTRAS ENFERMEDADES ESPECIFICADAS Y AFECCIONES QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO",
    "sexo": "F"
  },
  {
    "cod_dx": "P000",
    "nombre_dx": "P000-FETO Y RECIEN NACIDO AFECTADOS POR TRASTORNOS HIPERTENSIVOS DE LA MADRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P001",
    "nombre_dx": "P001-FETO Y RECIEN NACIDO AFECTADOS POR ENFERMEDADES RENALES Y DE LAS VIAS URINARIAS DE LA MADRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P002",
    "nombre_dx": "P002-FETO Y RECIEN NACIDO AFECTADOS POR ENFERMEDADES INFECCIOSAS Y PARASITARIAS DE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P003",
    "nombre_dx": "P003-FETO Y RECIEN NACIDO AFECTADOS POR ENFERMEDADES CIRCULATORIAS Y RESPIRATORIASDE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P004",
    "nombre_dx": "P004-FETO Y RECIEN NACIDO AFECTADOS POR TRASTORNOS NUTRICIONALESDE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P005",
    "nombre_dx": "P005-FETO Y RECIEN NACIDO AFECTADOS POR TRAUMATISMO DE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P006",
    "nombre_dx": "P006-FETO Y RECIEN NACIDO AFECTADOS POR PROCEDIMIENTO QUIRURGICODE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P007",
    "nombre_dx": "P007-FETO Y RECIEN NACIDO AFECTADOS POR OTRO PROCEDIMIENTO MEDICO DE LA MADRE, NO CLASIFICADO EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "P008",
    "nombre_dx": "P008-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS AFECCIONES MATERNAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P009",
    "nombre_dx": "P009-FETO Y RECIEN NACIDO AFECTADOS POR AFECCION MATERNA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P010",
    "nombre_dx": "P010-FETO Y RECIEN NACIDO AFECTADOS POR INCOMPETENCIA DEL CUELLO UTERINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P011",
    "nombre_dx": "P011-FETO Y RECIEN NACIDO AFECTADOS POR RUPTURA PREMATURA DE LAS MEMBRANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P012",
    "nombre_dx": "P012-FETO Y RECIEN NACIDO AFECTADOS POR OLIGOHIDRAMNIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "P013",
    "nombre_dx": "P013-FETO Y RECIEN NACIDO AFECTADOS POR POLIHIDRAMNIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P014",
    "nombre_dx": "P014-FETO Y RECIEN NACIDO AFECTADOS POR EMBARAZO ECTOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "P015",
    "nombre_dx": "P015-FETO Y RECIEN NACIDO AFECTADOS POR EMBARAZO MULTIPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "P016",
    "nombre_dx": "P016-FETO Y RECIEN NACIDO AFECTADOS POR MUERTE MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P017",
    "nombre_dx": "P017-FETO Y RECIEN NACIDO AFECTADOS POR PRESENTACION ANOMALA ANTES DEL TRABAJO DE PARTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P018",
    "nombre_dx": "P018-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES MATERNAS DEL EMBARAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P019",
    "nombre_dx": "P019-FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES MATERNAS NO ESPECIFICADAS DEL EMBARAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "P020",
    "nombre_dx": "P020-FETO Y RECIEN NACIDO AFECTADOS POR PLACENTA PREVIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P021",
    "nombre_dx": "P021-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS FORMAS DE DESPRENDIMIENTO Y DE HEMORRAGIA PLACENTARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P022",
    "nombre_dx": "P022-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS ANOMALIAS MORFOLOGICAS Y FUNCIONALES DE LA PLACENTA Y LAS N",
    "sexo": "A"
  },
  {
    "cod_dx": "P023",
    "nombre_dx": "P023-FETO Y RECIEN NACIDO AFECTADOS POR SINDROMES DE TRANSFUSION PLACENTARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P024",
    "nombre_dx": "P024-FETO Y RECIEN NACIDO AFECTADOS POR PROLAPSO DEL CORDON UMBILICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P025",
    "nombre_dx": "P025-FETO Y RECIEN NACIDO AFECTADOS POR OTRA COMPRESION DEL CORDON UMBILICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P026",
    "nombre_dx": "P026-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES DEL CORDON UMBILICAL Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P027",
    "nombre_dx": "P027-FETO Y RECIEN NACIDO AFECTADOS POR CORIOAMNIONITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "P028",
    "nombre_dx": "P028-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS ANORMALIDADES DE LAS MEMBRANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P029",
    "nombre_dx": "P029-FETO Y RECIEN NACIDO AFECTADOS POR ANORMALIDAD NO ESPECIFICADA DE LAS MEMBRANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P030",
    "nombre_dx": "P030-FETO Y RECIEN NACIDO AFECTADOS POR PARTO Y EXTRACCION DE NALGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P031",
    "nombre_dx": "P031-FETO Y RECIEN NACIDO AFECTADOS POR OTRA PRESENTACION ANOMALA, POSICION ANOMALA Y DESPROPORCION DURAN",
    "sexo": "A"
  },
  {
    "cod_dx": "P032",
    "nombre_dx": "P032-FETO Y RECIEN NACIDO AFECTADOS POR PARTO CON FORCEPS",
    "sexo": "A"
  },
  {
    "cod_dx": "P033",
    "nombre_dx": "P033-FETO Y RECIEN NACIDO AFECTADOS POR PARTO CON VENTOSA EXTRACTORA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P034",
    "nombre_dx": "P034-FETO Y RECIEN NACIDO AFECTADOS POR PARTO POR CESAREA",
    "sexo": "A"
  },
  {
    "cod_dx": "P035",
    "nombre_dx": "P035-FETO Y RECIEN NACIDO AFECTADOS POR PARTO PRECIPITADO",
    "sexo": "A"
  },
  {
    "cod_dx": "P036",
    "nombre_dx": "P036-FETO Y RECIEN NACIDO AFECTADOS POR CONTRACCIONES UTERINAS ANORMALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "P038",
    "nombre_dx": "P038-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS COMPLICACIONES ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "P039",
    "nombre_dx": "P039-FETO Y RECIEN NACIDO AFECTADOS POR COMPLICACIONES NO ESPECIFICADAS DEL TRABAJO DE PARTO Y DEL PARTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P040",
    "nombre_dx": "P040-FETO Y RECIEN NACIDO AFECTADOS POR ANESTESIA Y ANALGESIA MATERNA EN EL EMBARAZO, EN EL TRABAJO DE PA",
    "sexo": "A"
  },
  {
    "cod_dx": "P041",
    "nombre_dx": "P041-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS MEDICACIONES MATERNAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P042",
    "nombre_dx": "P042-FETO Y RECIEN NACIDO AFECTADOS POR TABAQUISMO DE LA MADRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P043",
    "nombre_dx": "P043-FETO Y RECIEN NACIDO AFECTADOS POR ALCOHOLISMO DE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P044",
    "nombre_dx": "P044-FETO Y RECIEN NACIDO AFECTADOS POR DROGADICCION MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P045",
    "nombre_dx": "P045-FETO Y RECIEN NACIDO AFECTADOS POR EL USO MATERNO DE SUSTANCIAS QUIMICAS NUTRICIONALES",
    "sexo": "A"
  },
  {
    "cod_dx": "P046",
    "nombre_dx": "P046-FETO Y RECIEN NACIDO AFECTADOS POR EXPOSICION MATERNA A SUSTANCIAS QUIMICAS AMBIENTALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "P048",
    "nombre_dx": "P048-FETO Y RECIEN NACIDO AFECTADOS POR OTRAS INFLUENCIAS NOCIVAS DE LA MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "P049",
    "nombre_dx": "P049-FETO Y RECIEN NACIDO AFECTADOS POR INFLUENCIAS NOCIVAS DE LA MADRE, NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P050",
    "nombre_dx": "P050-BAJO PESO PARA LA EDAD GESTACIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P051",
    "nombre_dx": "P051-PEQUEÑO PARA EDAD GESTACIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P052",
    "nombre_dx": "P052-DESNUTRICION FETAL, SIN MENCION DE PESO O TALLA BAJOS PARA LA EDAD GESTACIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P059",
    "nombre_dx": "P059-RETARDO DEL CRECIMIENTO FETAL, NOESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P070",
    "nombre_dx": "P070-PESO EXTREMADAMENTE BAJO AL NACER ",
    "sexo": "A"
  },
  {
    "cod_dx": "P071",
    "nombre_dx": "P071-OTRO PESO BAJO AL NACER ",
    "sexo": "A"
  },
  {
    "cod_dx": "P072",
    "nombre_dx": "P072-INMATURIDAD EXTREMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P073",
    "nombre_dx": "P073-OTROS RECIEN NACIDOS PRETERMINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P080",
    "nombre_dx": "P080-RECIEN NACIDO EXCEPCIONALMENTE GRANDE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P081",
    "nombre_dx": "P081-OTROS RECIEN NACIDOS CON SOBREPESO PARA LA EDAD GESTACIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P082",
    "nombre_dx": "P082-RECIEN NACIDOPOSTERMINO SINSOBREPESO PARA SU EDAD GESTACIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P100",
    "nombre_dx": "P100-HEMORRAGIA SUBDURAL DEBIDAA TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P101",
    "nombre_dx": "P101-HEMORRAGIA CEREBRAL DEBIDAA TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P102",
    "nombre_dx": "P102-HEMORRAGIA INTRAVENTRICULAR DEBIDAA TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P103",
    "nombre_dx": "P103-HEMORRAGIA SUBARACNOIDEA DEBIDAA TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P104",
    "nombre_dx": "P104-DESGARRO TENTORIAL DEBIDOA TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P108",
    "nombre_dx": "P108-OTRAS HEMORRAGIAS YLACERACIONES INTRACRANEALESDEBIDASA TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P109",
    "nombre_dx": "P109-HEMORRAGIA YLACERACION INTRACRANEALES NO ESPECIFICADAS, DEBIDASA TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P110",
    "nombre_dx": "P110-EDEMA CEREBRAL DEBIDO A TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P111",
    "nombre_dx": "P111-OTRAS LESIONES ESPECIFICADAS DEL ENCEFALO DEBIDASA TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P112",
    "nombre_dx": "P112-LESION NO ESPECIFICADA DEL ENCEFALO,DEBIDAA TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P113",
    "nombre_dx": "P113-TRAUMATISMO DEL NACIMIENTO EN EL NERVIO FACIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P114",
    "nombre_dx": "P114-TRAUMATISMO DEL NACIMIENTOEN OTROS NERVIOS CRANEALES",
    "sexo": "A"
  },
  {
    "cod_dx": "P115",
    "nombre_dx": "P115-TRAUMATISMO DEL NACIMIENTO EN LA COLUMNA VERTEBRAL Y EN LA MEDULA ESPINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P119",
    "nombre_dx": "P119-TRAUMATISMO DEL NACIMIENTO EN EL SISTEMA NERVIOSO CENTRAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "P120",
    "nombre_dx": "P120-CEFALOHEMATOMA DEBIDO A TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P121",
    "nombre_dx": "P121-CAPUT SUCCEDANEUMDEBIDO A TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P122",
    "nombre_dx": "P122-HEMORRAGIA EPICRANEAL SUBAPONEUROTICA DEBIDA A TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P123",
    "nombre_dx": "P123-EQUIMOSIS DEL CUERO CABELLUDO DEBIDA A TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P124",
    "nombre_dx": "P124-TRAUMATISMO EN EL CUERO CABELLUDO DEL RECIEN NACIDO POR MONITOREO FETAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P128",
    "nombre_dx": "P128-OTROS TRAUMATISMOS DEL NACIMIENTO EN EL CUERO CABELLUDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P129",
    "nombre_dx": "P129-TRAUMATISMO DEL NACIMIENTO EN EL CUERO CABELLUDO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P130",
    "nombre_dx": "P130-FRACTURA DEL CRANEO DEBIDA A TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P131",
    "nombre_dx": "P131-OTROS TRAUMATISMOS DEL CRANEO DURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P132",
    "nombre_dx": "P132-TRAUMATISMO DEL FEMUR DURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P133",
    "nombre_dx": "P133-TRAUMATISMO DE OTROS HUESOS LARGOS DURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P134",
    "nombre_dx": "P134-FRACTURA DE LA CLAVICULA DEBIDA A TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P138",
    "nombre_dx": "P138-TRAUMATISMO DEL NACIMIENTO EN OTRAS PARTES DEL ESQUELETO",
    "sexo": "A"
  },
  {
    "cod_dx": "P139",
    "nombre_dx": "P139-TRAUMATISMO NO ESPECIFICADO DEL ESQUELETO DURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P140",
    "nombre_dx": "P140-PARALISIS DE ERB DEBIDA ATRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P141",
    "nombre_dx": "P141-PARALISIS DEKLUMPKE DEBIDA A TRAUMATISMO DL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P142",
    "nombre_dx": "P142-PARALISIS DEL NERVIO FRENICO DEBIDA A TRAUMATISMO DEL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P143",
    "nombre_dx": "P143-OTRO TRAUMATISMO DEL PLEXO BRAQUIALDURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P148",
    "nombre_dx": "P148-TRAUMATISMO DURANTE EL NACIMIENTO EN OTRAS PARTES DEL SISTEMA NERVIOSO PERIFERICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P149",
    "nombre_dx": "P149-TRAUMATISMO NO ESPECIFICADO DEL SISTEMA NERVIOSO PERIFERICO DURANTE ELNACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P150",
    "nombre_dx": "P150-LESION DEL HIGADO DURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P151",
    "nombre_dx": "P151-LESION DEL BAZO DURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P152",
    "nombre_dx": "P152-TRAUMATISMO DEL MÚSCULO ESTERNOCLEIDOMASTOIDEO DURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P153",
    "nombre_dx": "P153-TRAUMATISMO OCULARDURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P154",
    "nombre_dx": "P154-TRAUMATISMO FACIALDURANTE EL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P155",
    "nombre_dx": "P155-TRAUMATISMO DE LOS GENITALES EXTERNOSDURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P156",
    "nombre_dx": "P156-NECROSIS GRASA SUBCUTANEA DEBIDA A TRAUMATISMO DEL NACIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P158",
    "nombre_dx": "P158-OTROS TRAUMATISMOS ESPECIFICADOS,DURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P159",
    "nombre_dx": "P159-TRAUMATISMO NO ESPECIFICADO, DURANTE EL NACIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P200",
    "nombre_dx": "P200-HIPOXIA INTRAUTERINA NOTADA POR PRIMERAVEZ ANTES DEL INICIO DEL TRABAJO DE PARTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P201",
    "nombre_dx": "P201-HIPOXIA INTRAUTERINA NOTADA POR PRIMERAVEZDURANTE EL TRABAJO DE PARTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P209",
    "nombre_dx": "P209-HIPOXIA INTRAUTERINA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P210",
    "nombre_dx": "P210-ASFIXIA DEL NACIMIENTO, SEVERA",
    "sexo": "A"
  },
  {
    "cod_dx": "P211",
    "nombre_dx": "P211-ASFIXIA DEL NACIMIENTO, LEVE Y MODERADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P219",
    "nombre_dx": "P219-ASFIXIA DEL NACIMIENTO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P220",
    "nombre_dx": "P220-SINDROME DE DIFICULTAD RESPIRATORIA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P221",
    "nombre_dx": "P221-TAQUIPNEA TRANSITORIA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P228",
    "nombre_dx": "P228-OTRAS DIFICULTADES RESPIRATORIAS DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P229",
    "nombre_dx": "P229-DIFICULTAD RESPIRATORIA DEL RECIEN NACIDO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "P230",
    "nombre_dx": "P230-NEUMONIA CONGENITA DEBIDA AAGENTE VIRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P231",
    "nombre_dx": "P231-NEUMONIA CONGENITA DEBIDA ACHLAMYDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P232",
    "nombre_dx": "P232-NEUMONIA CONGENITA DEBIDA A ESTAFILOCOCOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P233",
    "nombre_dx": "P233-NEUMONIA CONGENITA DEBIDA AESTREPTOCOCOS DEL GRUPO B",
    "sexo": "A"
  },
  {
    "cod_dx": "P234",
    "nombre_dx": "P234-NEUMONIA CONGENITA DEBIDA AESCHERICHIA COLI ",
    "sexo": "A"
  },
  {
    "cod_dx": "P235",
    "nombre_dx": "P235-NEUMONIA CONGENITA DEBIDA APSEUDOMONAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P236",
    "nombre_dx": "P236-NEUMONIA CONGENITA DEBIDA AOTROS AGENTES BACTERIANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "P238",
    "nombre_dx": "P238-NEUMONIA CONGENITA DEBIDA AOTROS ORGANISMOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P239",
    "nombre_dx": "P239-NEUMONIA CONGENITA, ORGANISMO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P240",
    "nombre_dx": "P240-ASPIRACION NEONATAL DE MECONIO",
    "sexo": "A"
  },
  {
    "cod_dx": "P241",
    "nombre_dx": "P241-ASPIRACION NEONATAL DEL LIQUIDO AMNIOTICO Y DE MOCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P242",
    "nombre_dx": "P242-ASPIRACION NEONATAL DE SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P243",
    "nombre_dx": "P243-ASPIRACION NEONATAL DE LECHE Y ALIMENTO REGURGITADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P248",
    "nombre_dx": "P248-OTROS SINDROMES DE ASPIRACION NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P249",
    "nombre_dx": "P249-SINDROME DE ASPIRACION NEONATAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "P250",
    "nombre_dx": "P250-ENFISEMA INTERSTICIAL ORIGINADO EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P251",
    "nombre_dx": "P251-NEUMOTORAX ORIGINADO EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P252",
    "nombre_dx": "P252-NEUMOMEDIASTINO ORIGINADO ENEL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P253",
    "nombre_dx": "P253-NEUMOPERICARDIO ORIGINADO EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P258",
    "nombre_dx": "P258-OTRAS AFECCIONES RELACIONADAS CON ELENFISEMA INTERSTICIAL,ORIGINADAS EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P260",
    "nombre_dx": "P260-HEMORRAGIA TRAQUEOBRONQUIAL ORIGINADA EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P261",
    "nombre_dx": "P261-HEMORRAGIA PULMONAR MASIVA ORIGINADA EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P268",
    "nombre_dx": "P268-OTRAS HEMORRAGIAS PULMONARES ORIGINADAS EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P269",
    "nombre_dx": "P269-HEMORRAGIA PULMONAR NO ESPECIFICADA,ORIGINADA EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P270",
    "nombre_dx": "P270-SINDROME DE WILSON-MIKITY ",
    "sexo": "A"
  },
  {
    "cod_dx": "P271",
    "nombre_dx": "P271-DISPLASIA BRONCOPULMONAR ORIGINADA EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P278",
    "nombre_dx": "P278-OTRAS ENFERMEDADES RESPIRATORIAS CRONICAS ORIGINADAS EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P279",
    "nombre_dx": "P279-ENFERMEDAD RESPIRATORIA CRONICA NO ESPECIFICADA ORIGINADA EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P280",
    "nombre_dx": "P280-ATELECTASIA PRIMARIA DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P281",
    "nombre_dx": "P281-OTRAS ATELECTASIAS DEL RECIEN NACIDO Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P282",
    "nombre_dx": "P282-ATAQUE CIANOTICO DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P283",
    "nombre_dx": "P283-APNEA PRIMARIA DEL SUEÑO DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P284",
    "nombre_dx": "P284-OTRAS APNEAS DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P285",
    "nombre_dx": "P285-INSUFICIENCIA RESPIRATORIA DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P288",
    "nombre_dx": "P288-OTROS PROBLEMAS RESPIRATORIOSESPECIFICADOS DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P289",
    "nombre_dx": "P289-AFECCION RESPIRATORIA NO ESPECIFICADA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P290",
    "nombre_dx": "P290-INSUFICIENCIA CARDIACA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P291",
    "nombre_dx": "P291-DISRITMIA CARDIACA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P292",
    "nombre_dx": "P292-HIPERTENSION NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P293",
    "nombre_dx": "P293-VALVULAS CARDÍACAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P294",
    "nombre_dx": "P294-ISQUEMIA MIOCARDICA TRANSITORIA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P298",
    "nombre_dx": "P298-OTROS TRASTORNOS CARDIOVASCULARES ORIGINADOS EN EL PERIODOPERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P299",
    "nombre_dx": "P299-TRASTORNO CARDIOVASCULAR NO ESPECIFICADO, ORIGINADO EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P350",
    "nombre_dx": "P350-SINDROME DERUBEOLA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "P351",
    "nombre_dx": "P351-INFECCION CITOMEGALOVIRICA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "P352",
    "nombre_dx": "P352-INFECCIONESCONGENITAS POR VIRUS DEL HERPES SIMPLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P353",
    "nombre_dx": "P353-HEPATITIS VIRAL CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P354",
    "nombre_dx": "P354-Enfermedad congenita por Virus Zika",
    "sexo": "A"
  },
  {
    "cod_dx": "P358",
    "nombre_dx": "P358-OTRAS ENFERMEDADES VIRALES CONGENITAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P359",
    "nombre_dx": "P359-ENFERMEDAD VIRAL CONGÉNITA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "P360",
    "nombre_dx": "P360-SEPSIS DEL RECIEN NACIDO DEBIDA A ESTREPTOCOCO DEL GRUPO B",
    "sexo": "A"
  },
  {
    "cod_dx": "P361",
    "nombre_dx": "P361-SEPSIS DEL RECIEN NACIDO DEBIDA A ESTREPTOCOCO DE OTRO GRUPO Y EL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P362",
    "nombre_dx": "P362-SEPSIS DEL RECIEN NACIDO DEBIDA A STAPHYLOCOCCUS AUREUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P363",
    "nombre_dx": "P363-SEPSIS DEL RECIEN NACIDO DEBIDA A ESTAFILOCOCO DE OTRA ESPECIE Y LA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P364",
    "nombre_dx": "P364-SEPSIS DEL RECIEN NACIDO DEBIDA A ESCHERICHIA COLI",
    "sexo": "A"
  },
  {
    "cod_dx": "P365",
    "nombre_dx": "P365-SEPSIS DEL RECIEN NACIDO DEBIDA A ANAEROBIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "P368",
    "nombre_dx": "P368-SEPSIS DEL RECIEN NACIDO DEBIDA A OTRAS BACTERIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P369",
    "nombre_dx": "P369-SEPSIS BACTERIANA DEL RECIEN NACIDO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "P370",
    "nombre_dx": "P370-TUBERCULOSIS CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "P371",
    "nombre_dx": "P371-TOXOPLASMOSIS CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P372",
    "nombre_dx": "P372-LISTERIOSIS CONGENITA (DISEMINADA)",
    "sexo": "A"
  },
  {
    "cod_dx": "P373",
    "nombre_dx": "P373-PALUDISMO CONGENITO POR PLASMODIUM FALCIPARUM ",
    "sexo": "A"
  },
  {
    "cod_dx": "P374",
    "nombre_dx": "P374-OTROS PALUDISMOS CONGENITOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P375",
    "nombre_dx": "P375-CANDIDIASIS NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P378",
    "nombre_dx": "P378-OTRAS ENFERMEDADES NEONATALES INFECCIOSAS O PARASITARIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P379",
    "nombre_dx": "P379-ENFERMEDAD INFECCIOSA O PARASITARIA CONGENITA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "P38X",
    "nombre_dx": "P38X-ONFALITIS DEL RECIEN NACIDO CON O SIN HEMORRAGIA LEVE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P390",
    "nombre_dx": "P390-MASTITIS INFECCIOSA NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P391",
    "nombre_dx": "P391-CONJUNTIVITIS Y DACRIOCISTITIS NEONATALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "P392",
    "nombre_dx": "P392-INFECCION INTRAAMNIOTICA DEL FETO, NO CLASIFICADA EN OTRA PARTE3",
    "sexo": "A"
  },
  {
    "cod_dx": "P393",
    "nombre_dx": "P393-INFECCION NEONATAL DE LAS VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P394",
    "nombre_dx": "P394-INFECCION CUTANEA NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P398",
    "nombre_dx": "P398-OTRAS INFECCIONES ESPECIFICADAS PROPIAS DEL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P399",
    "nombre_dx": "P399-INFECCION PROPIA DEL PERIODO PERINATAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P500",
    "nombre_dx": "P500-PERDIDA DE SANGRE FETAL POR VASA PREVIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P501",
    "nombre_dx": "P501-PERDIDA DE SANGRE FETAL POR RUPTURA DEL CORDON UMBILICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P502",
    "nombre_dx": "P502-PERDIDA DE SANGRE FETAL POR LA PLACENTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P503",
    "nombre_dx": "P503-HEMORRAGIA FETAL HACIA OTRO GEMELO",
    "sexo": "A"
  },
  {
    "cod_dx": "P504",
    "nombre_dx": "P504-HEMORRAGIA FETAL HACIA LA CIRCULACION MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P505",
    "nombre_dx": "P505-PERDIDA DE SANGRE FETAL POR EL CORTE DEL CORDON UMBILICAL EN EL OTRO GEMELO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P508",
    "nombre_dx": "P508-OTRAS PERDIDAS DE SANGRE FETAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P509",
    "nombre_dx": "P509-PERDIDA DE SANGRE FETAL NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P510",
    "nombre_dx": "P510-HEMORRAGIA UMBILICAL MASIVA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P518",
    "nombre_dx": "P518-OTRAS HEMORRAGIAS UMBILICALES DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P519",
    "nombre_dx": "P519-HEMORRAGIA UMBILICAL DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "P520",
    "nombre_dx": "P520-HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 1, DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P521",
    "nombre_dx": "P521-HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 2, DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P522",
    "nombre_dx": "P522-HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) GRADO 3, DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P523",
    "nombre_dx": "P523-HEMORRAGIA INTRAVENTRICULAR (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "P524",
    "nombre_dx": "P524-HEMORRAGIA INTRACEREBRAL (NO TRAUMATICA)DEL FETO Y DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P525",
    "nombre_dx": "P525-HEMORRAGIA SUBARACNOIDEA (NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P526",
    "nombre_dx": "P526-HEMORRAGIA CEREBELOSA Y DE LA FOSA POSTERIOR(NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P528",
    "nombre_dx": "P528-OTRAS HEMORRAGIAS INTRACRANEALES (NO TRAUMATICAS) DEL FETO Y DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P529",
    "nombre_dx": "P529-HEMORRAGIA INTRACRANEAL(NO TRAUMATICA) DEL FETO Y DEL RECIEN NACIDO, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "P53X",
    "nombre_dx": "P53X-ENFERMEDAD HEMORRAGICA DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P540",
    "nombre_dx": "P540-HEMATEMESIS NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P541",
    "nombre_dx": "P541-MELENA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P542",
    "nombre_dx": "P542-HEMORRAGIA RECTAL NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P543",
    "nombre_dx": "P543-OTRAS HEMORRAGIAS GASTROINTESTINALES NEONATALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "P544",
    "nombre_dx": "P544-HEMORRAGIA SUPRARRENAL NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P545",
    "nombre_dx": "P545-HEMORRAGIA CUTANEA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P546",
    "nombre_dx": "P546-HEMORRAGIA VAGINAL NEONATAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "P548",
    "nombre_dx": "P548-OTRAS HEMORRAGIAS FETALES Y NEONATALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P549",
    "nombre_dx": "P549-HEMORRAGIA NEONATAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "P550",
    "nombre_dx": "P550-INCOMPATIBILIDAD RH DEL FETO Y DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P551",
    "nombre_dx": "P551-INCOMPATIBILIDAD ABO DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P558",
    "nombre_dx": "P558-OTRAS ENFERMEDADES HEMOLITICAS DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P559",
    "nombre_dx": "P559-ENFERMEDAD HEMOLITICA DEL FETO Y DEL RECIEN NACIDO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P560",
    "nombre_dx": "P560-HIDROPESIA FETAL DEBIDA A INCOMPATIBILIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "P569",
    "nombre_dx": "P569-HIDROPESIA FETAL DEBIDA A OTRAS ENFERMEDADES HEMOLITICAS ESPECIFICADAS Y A LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P570",
    "nombre_dx": "P570-KERNICTERUS DEBIDO A INCOMPATIBILIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "P578",
    "nombre_dx": "P578-KERNICTERUS DEBIDO A OTRASCAUSAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "P579",
    "nombre_dx": "P579-KERNICTERUS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "P580",
    "nombre_dx": "P580-ICTERICIA NEONATAL DEBIDA A CONTUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "P581",
    "nombre_dx": "P581-ICTERICIA NEONATAL DEBIDA A HEMORRAGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P582",
    "nombre_dx": "P582-ICTERICIA NEONATAL DEBIDA A INFECCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "P583",
    "nombre_dx": "P583-ICTERICIA NEONATAL DEBIDA A POLICITEMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P584",
    "nombre_dx": "P584-ICTERICIA NEONATAL DEBIDA A DROGAS OTOXINAS TRANSMITIDAS POR LA MADRE O ADMINISTRADAS AL RECIEN NA",
    "sexo": "A"
  },
  {
    "cod_dx": "P585",
    "nombre_dx": "P585-ICTERICIA NEONATAL DEBIDA A DEGLUCION DE SANGRE MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P588",
    "nombre_dx": "P588-ICTERICIA NEONATAL DEBIDA A OTRAS HEMOLISIS EXCESIVAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P589",
    "nombre_dx": "P589-ICTERICIA NEONATAL DEBIDA A HEMOLISIS EXCESIVA SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "P590",
    "nombre_dx": "P590-ICTERICIA NEONATAL ASOCIADA CON EL PARTO ANTES DE TERMINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P591",
    "nombre_dx": "P591-SINDROME DE LA BILIS ESPESA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P592",
    "nombre_dx": "P592-ICTERICIA NEONATAL DEBIDA A OTRA LESION HEPATICA ESPECIFICADA O NO",
    "sexo": "A"
  },
  {
    "cod_dx": "P593",
    "nombre_dx": "P593-ICTERICIA NEONATAL POR INHIBIDOR DE LA LECHE MATERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "P598",
    "nombre_dx": "P598-ICTERICIA NEONATAL POR OTRAS CAUSAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P599",
    "nombre_dx": "P599-ICTERICIA NEONATAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P60X",
    "nombre_dx": "P60X-COAGULACION INTRAVASCULAR DISEMINADA EN EL FETO Y EL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P610",
    "nombre_dx": "P610-TROMBOCITOPENIA NEONATAL TRANSITORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P611",
    "nombre_dx": "P611-POLICITEMIA NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P612",
    "nombre_dx": "P612-ANEMIA DE LA PREMATURIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "P613",
    "nombre_dx": "P613-ANEMIA CONGENITA DEBIDA A PERDIDA DE SANGRE FETAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P614",
    "nombre_dx": "P614-OTRAS ANEMIAS CONGENITAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P615",
    "nombre_dx": "P615-NEUTROPENIA NEONATAL TRANSITORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P616",
    "nombre_dx": "P616-OTROS TRASTORNOSNEONATALES TRANSITORIOS DE LA COAGULACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "P618",
    "nombre_dx": "P618-OTROS TRASTORNOS HEMATOLOGICOS PERINATALES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "P619",
    "nombre_dx": "P619-TRASTORNO HEMATOLOGICO PERINATAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P700",
    "nombre_dx": "P700-SINDROME DEL RECIEN NACIDO DE MADRE CON DIABETES GESTACIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P701",
    "nombre_dx": "P701-SINDROME DEL RECIEN NACIDO DE MADRE CON DIABETICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P702",
    "nombre_dx": "P702-DIABETES MELLITUS NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P703",
    "nombre_dx": "P703-HIPOGLICEMIA NEONATAL YATROGENICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P704",
    "nombre_dx": "P704-OTRAS HIPOGLICEMIAS NEONATALES",
    "sexo": "A"
  },
  {
    "cod_dx": "P708",
    "nombre_dx": "P708-OTROS TRASTORNOS TRANSITORIOS DEL METABOLISMO DE LOS CARBOHIDRATOS EN EL FETO Y EL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P709",
    "nombre_dx": "P709-TRASTORNO TRANSITORIO NO ESPECIFICADO DEL METABOLISMO DE LOS CARBOHIDRATOS EN EL FETO Y EL RECIEN NA",
    "sexo": "A"
  },
  {
    "cod_dx": "P710",
    "nombre_dx": "P710-HIPOCALCEMIA DEL RECIEN NACIDO DEBIDA A LA LECHE DE VACA",
    "sexo": "A"
  },
  {
    "cod_dx": "P711",
    "nombre_dx": "P711-OTRA HIPOCALCEMIA NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P712",
    "nombre_dx": "P712-HIPOMAGNESEMIA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P713",
    "nombre_dx": "P713-TETANIA NEONATAL SIN MENCION DE DEFICIENCIA DE CALCIO O DE MAGNESIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P714",
    "nombre_dx": "P714-HIPOPARATIROIDISMO NEONATAL TRANSITORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P718",
    "nombre_dx": "P718-OTROS TRASTORNOS NEONATALES TRANSITORIOS DEL METABOLISMO DEL CALCIO Y DEL MAGNESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "P719",
    "nombre_dx": "P719-TRASTORNO NEONATAL TRANSITORIO NO ESPECIFICADO DEL METABOLISMO DEL CALCIO Y DEL MAGNESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "P720",
    "nombre_dx": "P720-BOCIO NEONATAL, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "P721",
    "nombre_dx": "P721-HIPERTIROIDISMO NEONATAL TRANSITORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "P722",
    "nombre_dx": "P722-OTROS TRASTORNOS NEONATALES TRANSITORIOS DE LA FUNCION TIROIDEA, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "P728",
    "nombre_dx": "P728-OTROS TRASTORNOS ENDOCRINOS NEONATALES TRANSITORIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "P729",
    "nombre_dx": "P729-TRASTORNO ENDOCRINO NEONATAL TRANSITORIO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P740",
    "nombre_dx": "P740-ACIDOSIS METABOLICA TARDIA DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P741",
    "nombre_dx": "P741-DESHIDRATACION DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P742",
    "nombre_dx": "P742-ALTERACIONES DEL EQUILIBRIO DEL SODIO EN EL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P743",
    "nombre_dx": "P743-ALTERACIONES DEL EQUILIBRIO DEL POTASIO EN EL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P744",
    "nombre_dx": "P744-OTRAS ALTERACIONES ELECTROLITICAS TRANSITORIAS DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P745",
    "nombre_dx": "P745-TIROSINEMIA TRANSITORIA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P748",
    "nombre_dx": "P748-OTRAS ALTERACIONES METABOLICAS TRANSITORIAS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P749",
    "nombre_dx": "P749-TRASTORNO METABOLICO TRANSITORIO DEL RECIEN NACIDO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P75X",
    "nombre_dx": "P75X-Íleo meconial en la fibrosis quística (E84.1†)(ILEO MECONIAL (E84.1†))",
    "sexo": "A"
  },
  {
    "cod_dx": "P760",
    "nombre_dx": "P760-SINDROME DEL TAPON DE MECONIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P761",
    "nombre_dx": "P761-ILEO TRANSITORIO DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P762",
    "nombre_dx": "P762-OBSTRUCCION INTESTINAL DEBIDAA LA LECHE ESPESA",
    "sexo": "A"
  },
  {
    "cod_dx": "P768",
    "nombre_dx": "P768-OTRAS OBSTRUCCIONESINTESTINALES ESPECIFICADAS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P769",
    "nombre_dx": "P769-OBSTRUCCION INTESTINAL DEL RECIEN NACIDO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P77X",
    "nombre_dx": "P77X-ENTEROCOLITIS NECROTIZANTE DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P780",
    "nombre_dx": "P780-PERFORACION INTESTINAL PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P781",
    "nombre_dx": "P781-OTRAS PERITONITIS NEONATALES",
    "sexo": "A"
  },
  {
    "cod_dx": "P782",
    "nombre_dx": "P782-HEMATEMESIS Y MELENA NEONATALES DEBIDAS A LA DEGLUCION DESANGRE MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P783",
    "nombre_dx": "P783-DIARREA NEONATAL NO INFECCIOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "P788",
    "nombre_dx": "P788-OTROS TRASTORNOS PERINATALES ESPECIFICOS DEL SISTEMA DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "P789",
    "nombre_dx": "P789-TRASTORNO PERINATAL DEL SISTEMA DIGESTIVO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "P800",
    "nombre_dx": "P800-SINDROME DE ENFRIAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "P808",
    "nombre_dx": "P808-OTRAS HIPOTERMIAS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P809",
    "nombre_dx": "P809-HIPOTERMIA DEL RECIEN NACIDO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P810",
    "nombre_dx": "P810-HIPERTERMIA DEL RECIEN NACIDO INDUCIDA POR LAS CONDICIONES AMBIENTALES",
    "sexo": "A"
  },
  {
    "cod_dx": "P818",
    "nombre_dx": "P818-OTRAS ALTERACIONES ESPECIFICADAS DE LA REGULACION DE LA TEMPERATURA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P819",
    "nombre_dx": "P819-ALTERACION NO ESPECIFICADA DE LA REGULACION DE LA TEMPERATURA EN EL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P830",
    "nombre_dx": "P830-ESCLEREMA NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P831",
    "nombre_dx": "P831-ERITEMA TOXICO NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P832",
    "nombre_dx": "P832-HIDROPESIA FETAL NO DEBIDA A ENFERMEDAD HEMOLITICA",
    "sexo": "A"
  },
  {
    "cod_dx": "P833",
    "nombre_dx": "P833-OTROS EDEMAS Y LOS NO ESPECIFICADOS, PROPIOS DEL FETO Y DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P834",
    "nombre_dx": "P834-INGURGITACION MAMARIA DEL RECIENNACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P835",
    "nombre_dx": "P835-HIDROCELE CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P836",
    "nombre_dx": "P836-POLIPO UMBILICAL DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P838",
    "nombre_dx": "P838-OTRAS AFECCIONES ESPECIFICADAS DE LA PIEL, PROPIAS DEL FETOY DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P839",
    "nombre_dx": "P839-AFECCION NO ESPECIFICADA DE LA PIEL, PROPIAS DEL FETOY DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P90X",
    "nombre_dx": "P90X-CONVULSIONES DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P910",
    "nombre_dx": "P910-ISQUEMIA CEREBRAL NEONATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "P911",
    "nombre_dx": "P911-QUISTES PERIVENTRICULARES ADQUIRIDOS DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P912",
    "nombre_dx": "P912-LEUCOMALACIA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P913",
    "nombre_dx": "P913-IRRITABILIDAD CEREBRAL NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P914",
    "nombre_dx": "P914-DEPRESION CEREBRAL NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P915",
    "nombre_dx": "P915-COMA NEONATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P917",
    "nombre_dx": "P917-Hidrocefalia adquirida del recien nacido",
    "sexo": "A"
  },
  {
    "cod_dx": "P918",
    "nombre_dx": "P918-OTRAS ALTERACIONES CEREBRALES ESPECIFICADAS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P919",
    "nombre_dx": "P919-ALTERACION CEREBRAL NO ESPECIFICADA DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P920",
    "nombre_dx": "P920-VOMITOS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P921",
    "nombre_dx": "P921-REGURGITACION Y RUMIACION DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P922",
    "nombre_dx": "P922-LENTITUD EN LA INGESTION DE ALIMENTOS DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P923",
    "nombre_dx": "P923-HIPOALIMENTACION DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P924",
    "nombre_dx": "P924-HIPERALIMENTACION DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P925",
    "nombre_dx": "P925-DIFICULTAD NEONATAL EN LA LACTANCIA MATERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P928",
    "nombre_dx": "P928-OTROS PROBLEMAS DE ALIMENTACION DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P929",
    "nombre_dx": "P929-PROBLEMA NO ESPECIFICADO DE LA ALIMENTACION DEL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P93X",
    "nombre_dx": "P93X-REACCIONES E INTOXICACIONES DEBIDAS A DROGAS ADMINISTRADAS AL FETO Y AL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P940",
    "nombre_dx": "P940-MIASTENIA GRAVE NEONATAL TRANSITORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "P941",
    "nombre_dx": "P941-HIPERTONIA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "P942",
    "nombre_dx": "P942-HIPOTONIA CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P948",
    "nombre_dx": "P948-OTROS TRASTORNOS DEL TONO MUSCULAR EN EL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P949",
    "nombre_dx": "P949-TRASTORNO NO ESPECIFICADO DEL TONO MUSCULAR EN EL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P95X",
    "nombre_dx": "P95X-MUERTE FETAL DE CAUSA NO ESPECIFICADA ",
    "sexo": "M"
  },
  {
    "cod_dx": "P960",
    "nombre_dx": "P960-INSUFICIENCIA RENAL CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "P961",
    "nombre_dx": "P961-SINTOMAS NEONATALES DEABSTINENCIA POR DROGADICCION MATERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "P962",
    "nombre_dx": "P962-SINTOMAS DEABSTINENCIA POR EL USO TERAPEUTICO DE DROGAS EN EL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P963",
    "nombre_dx": "P963-AMPLITUD DE LA SUTURAS CRANEALES DEL RECIEN NACIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "P964",
    "nombre_dx": "P964-TERMINACION DEL EMBARAZO, QUE AFECTA AL FETO Y AL RECIEN NACIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "P965",
    "nombre_dx": "P965-COMPLICACIONES DE PROCEDIMIENTOS INTRAUTERINOS, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "P968",
    "nombre_dx": "P968-OTRAS AFECCIONES ESPECIFICADAS ORIGINADAS EN EL PERIODO PERINATAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "P969",
    "nombre_dx": "P969-AFECCION NO ESPECIFICADA ORIGINADA EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q000",
    "nombre_dx": "Q000-ANENCEFALIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q001",
    "nombre_dx": "Q001-CRANEORRAQUISQUISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q002",
    "nombre_dx": "Q002-INIENCEFALIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q010",
    "nombre_dx": "Q010-ENCEFALOCELE FRONTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q011",
    "nombre_dx": "Q011-ENCEFALOCELE NASOFRONTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q012",
    "nombre_dx": "Q012-ENCEFALOCELE OCCIPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q018",
    "nombre_dx": "Q018-ENCEFALOCELE DE OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q019",
    "nombre_dx": "Q019-ENCEFALOCELE, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q02X",
    "nombre_dx": "Q02X-MICROCEFALIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q030",
    "nombre_dx": "Q030-MALFORMACIONES DEL ACUEDUCTO DE SILVIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q031",
    "nombre_dx": "Q031-ATRESIA DE LOS AGUJEROS DE MAGENDIE Y DE LUSCHKA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q038",
    "nombre_dx": "Q038-OTROS HIDROCEFALOS CONGENITOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q039",
    "nombre_dx": "Q039-HIDROCEFALO CONGENITO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q040",
    "nombre_dx": "Q040-MALFORMACIONES CONGENITAS DEL CUERPO CALLOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q041",
    "nombre_dx": "Q041-ARRINENCEFALIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q042",
    "nombre_dx": "Q042-HOLOPROSENCEFALIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q043",
    "nombre_dx": "Q043-OTRAS ANOMALIAS HIPOPLASICAS DEL ENCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q044",
    "nombre_dx": "Q044-DISPLASIA OPTICOSEPTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q045",
    "nombre_dx": "Q045-MEGALENCEFALIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q046",
    "nombre_dx": "Q046-QUISTES CEREBRALES CONGENITOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q048",
    "nombre_dx": "Q048-OTRAS MALFORMACIONES CONGENITAS DEL ENCEFALO, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q049",
    "nombre_dx": "Q049-MALFORMACION CONGENITA DEL ENCEFALO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q050",
    "nombre_dx": "Q050-ESPINA BIFIDA CERVICAL CON HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q051",
    "nombre_dx": "Q051-ESPINA BIFIDA TORACICA CON HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q052",
    "nombre_dx": "Q052-ESPINA BIFIDA LUMBAR CON HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q053",
    "nombre_dx": "Q053-ESPINA BIFIDA SACRA CON HIDROCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q054",
    "nombre_dx": "Q054-ESPINA BIFIDACON HIDROCEFALO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q055",
    "nombre_dx": "Q055-ESPINA BIFIDA CERVICAL SIN HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q056",
    "nombre_dx": "Q056-ESPINA BIFIDA TORACICA SIN HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q057",
    "nombre_dx": "Q057-ESPINA BIFIDA LUMBAR SIN HIDROCEFALO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q058",
    "nombre_dx": "Q058-ESPINA BIFIDA SACRA SIN HIDROCEFALO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q059",
    "nombre_dx": "Q059-ESPINA BIFIDA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q060",
    "nombre_dx": "Q060-AMIELIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q061",
    "nombre_dx": "Q061-HIPOPLASIA Y DISPLASIA DE LA MEDULA ESPINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q062",
    "nombre_dx": "Q062-DIASTEMATOMIELIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q063",
    "nombre_dx": "Q063-OTRAS ANOMALIAS CONGENITAS DE LA COLA DE CABALLO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q064",
    "nombre_dx": "Q064-HIDROMIELIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q068",
    "nombre_dx": "Q068-OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE LA MEDULA ESPINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q069",
    "nombre_dx": "Q069-MALFORMACION CONGENITA DE LA MEDULA ESPINAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q070",
    "nombre_dx": "Q070-SINDROME DE ARNOLD-CHIARI ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q078",
    "nombre_dx": "Q078-OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA NERVIOSO, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q079",
    "nombre_dx": "Q079-MALFORMACION CONGENITA DEL SISTEMA NERVIOSO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q100",
    "nombre_dx": "Q100-BLEFAROPTOSIS CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q101",
    "nombre_dx": "Q101-ECTROPION CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q102",
    "nombre_dx": "Q102-ENTROPION CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q103",
    "nombre_dx": "Q103-OTRAS MALFORMACIONES CONGENITAS DE LOS PARPADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q104",
    "nombre_dx": "Q104-AUSENCIA Y AGENESIA DEL APARATO LAGRIMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q105",
    "nombre_dx": "Q105-ESTENOSIS Y ESTRECHEZ CONGENITAS DEL CONDUCTO LAGRIMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q106",
    "nombre_dx": "Q106-OTRAS MALFORMACIONES CONGENITAS DEL APARATO LAGRIMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q107",
    "nombre_dx": "Q107-MALFORMACION CONGENITA DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q110",
    "nombre_dx": "Q110-GLOBO OCULAR QUISTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q111",
    "nombre_dx": "Q111-OTRAS ANOFTALMIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q112",
    "nombre_dx": "Q112-MICROFTALMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q113",
    "nombre_dx": "Q113-MACROFTALMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q120",
    "nombre_dx": "Q120-CATARATACONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q121",
    "nombre_dx": "Q121-DESPLAZAMIENTO CONGENITO DEL CRISTALINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q122",
    "nombre_dx": "Q122-COLOBOMA DEL CRISTALINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q123",
    "nombre_dx": "Q123-AFAQUIA CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q124",
    "nombre_dx": "Q124-ESFEROFAQUIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q128",
    "nombre_dx": "Q128-OTRAS MALFORMACIONES CONGENITAS DEL CRISTALINO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q129",
    "nombre_dx": "Q129-MALFORMACION CONGENITA DEL CRISTALINO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q130",
    "nombre_dx": "Q130-COLOBOMA DEL IRIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q131",
    "nombre_dx": "Q131-AUSENCIA DEL IRIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q132",
    "nombre_dx": "Q132-OTRAS MALFORMACIONES DEL IRIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q133",
    "nombre_dx": "Q133-OPACIDAD CORNEAL CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q134",
    "nombre_dx": "Q134-OTRAS MALFORMACIONES CONGENITAS DE LA CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q135",
    "nombre_dx": "Q135-ESCLEROTICA AZUL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q138",
    "nombre_dx": "Q138-OTRAS MALFORMACIONES CONGENITAS DEL SEGMENTO ANTERIOR DEL OJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q139",
    "nombre_dx": "Q139-MALFORMACION CONGENITA DEL SEGMENTO ANTERIOR DEL OJO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q140",
    "nombre_dx": "Q140-MALFORMACION CONGENITA DEL HUMOR VITREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q141",
    "nombre_dx": "Q141-MALFORMACION CONGENITADE LA RETINA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q142",
    "nombre_dx": "Q142-MALFORMACION CONGENITA DEL DISCO OPTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q143",
    "nombre_dx": "Q143-MALFORMACION CONGENITA DE LA COROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q148",
    "nombre_dx": "Q148-OTRAS MALFORMACIONES CONGENITAS DEL SEGMENTO POSTERIOR DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q149",
    "nombre_dx": "Q149-MALFORMACION CONGENITA DEL SEGMENTO POSTERIOR DEL OJO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q150",
    "nombre_dx": "Q150-GLAUCOMA CONGENITO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q158",
    "nombre_dx": "Q158-OTRAS MALFORMACIONES CONGENITAS DEL OJO, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q159",
    "nombre_dx": "Q159-MALFORMACIONES CONGENITAS DEL OJO, NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q160",
    "nombre_dx": "Q160-AUSENCIA CONGENITA DEL PABELLON (DE LA OREJA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q161",
    "nombre_dx": "Q161-AUSENCIA CONGENITA, ATRESIA O ESTRECHEZ DEL CONDUCTO AUDITIVO (EXTERNO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q162",
    "nombre_dx": "Q162-AUSENCIA DE LA TROMPA DE EUSTAQUIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q163",
    "nombre_dx": "Q163-MALFORMACION CONGENITADE LOS HUESILLOS DEL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q164",
    "nombre_dx": "Q164-OTRAS MALFORMACIONES CONGENITAS DEL OIDO MEDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q165",
    "nombre_dx": "Q165-MALFORMACION CONGENITA DEL OIDO INTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q169",
    "nombre_dx": "Q169-MALFORMACION CONGENITA DEL OIDO QUE CAUSA ALTERACION DE LA AUDICION, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Q170",
    "nombre_dx": "Q170-OREJA SUPERNUMERARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q171",
    "nombre_dx": "Q171-MACROTIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q172",
    "nombre_dx": "Q172-MICROTIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q173",
    "nombre_dx": "Q173-OTRAS DEFORMIDADES DEL PABELLON AURICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q174",
    "nombre_dx": "Q174-ANOMALIA DE LA POSICION DE LA OREJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q175",
    "nombre_dx": "Q175-OREJA PROMINENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q178",
    "nombre_dx": "Q178-OTRASMALFORMACIONES CONGENITAS DEL OIDO, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q179",
    "nombre_dx": "Q179-MALFORMACION CONGENITA DEL OIDO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q180",
    "nombre_dx": "Q180-SENO, FISTULA O QUISTE DE LA HENDIDURA BRANQUIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q181",
    "nombre_dx": "Q181-SENO Y QUITE PREAURICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q182",
    "nombre_dx": "Q182-OTRAS MALFORMACIONES DE LAS HENDIDURAS BRANQUIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q183",
    "nombre_dx": "Q183-PTERIGION DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q184",
    "nombre_dx": "Q184-MACROSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q185",
    "nombre_dx": "Q185-MICROSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q186",
    "nombre_dx": "Q186-MACROQUEILIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q187",
    "nombre_dx": "Q187-MICROQUEILIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q188",
    "nombre_dx": "Q188-OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE CARA Y CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q189",
    "nombre_dx": "Q189-MALFORMACION CONGENITA DE LA CARA Y DEL CUELLO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q200",
    "nombre_dx": "Q200-TRONCO ARTERIOSO COMUN",
    "sexo": "A"
  },
  {
    "cod_dx": "Q201",
    "nombre_dx": "Q201-TRANSPOSICION DE LOS GRANDES VASOS DEL VENTRICULO DERECHO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q202",
    "nombre_dx": "Q202-TRANSPOSICION DE LOS GRANDES VASOS DEL VENTRICULO IZQUIERDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q203",
    "nombre_dx": "Q203-DISCORDANCIA DE LA CONEXIÓN VENTRICULOARTERIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q204",
    "nombre_dx": "Q204-VENTRICULO CON DOBLE ENTRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q205",
    "nombre_dx": "Q205-DISCORDANCIA DE LA CONEXIÓN AURICULOVENTRICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q206",
    "nombre_dx": "Q206-ISOMERISMO DE LOS APENDICES AURICULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q208",
    "nombre_dx": "Q208-OTRAS MALFORMACIONES CONGENITAS DE LAS CAMARAS CARDIACAS Y SUS CONEXIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q209",
    "nombre_dx": "Q209-MALFORMACION CONGENITAS DE LAS CAMARAS CARDIACAS Y SUS CONEXIONES, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q210",
    "nombre_dx": "Q210-DEFECTO DEL TABIQUE VENTRICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q211",
    "nombre_dx": "Q211-DEFECTO DEL TABIQUE AURICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q212",
    "nombre_dx": "Q212-DEFECTO DEL TABIQUE AURICULOVENTRICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q213",
    "nombre_dx": "Q213-TETRALOGIA DE FALLOT",
    "sexo": "A"
  },
  {
    "cod_dx": "Q214",
    "nombre_dx": "Q214-DEFECTO DEL TABIQUE AORTOPULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q218",
    "nombre_dx": "Q218-OTRAS MALFORMACIONES CONGENITAS DE LOS TABIQUES CARDIACOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q219",
    "nombre_dx": "Q219-MALFORMACION CONGENITA DEL TABIQUE CARDIACO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q220",
    "nombre_dx": "Q220-ATRESIA DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q221",
    "nombre_dx": "Q221-ESTENOSIS CONGENITA DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q222",
    "nombre_dx": "Q222-INSUFICIENCIA CONGENITA DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q223",
    "nombre_dx": "Q223-OTRAS MALFORMACIONES CONGENITAS DE LA VALVULA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q224",
    "nombre_dx": "Q224-ESTENOSIS CONGENITA DE LA VALVULA TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q225",
    "nombre_dx": "Q225-ANOMALIA DE EBSTEIN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q226",
    "nombre_dx": "Q226-SINDROME DE HIPOPLASIA DEL CORAZON DERECHO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q228",
    "nombre_dx": "Q228-OTRAS MALFORMACIONES CONGENITAS DE LA VALVULA TRICUSPIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q229",
    "nombre_dx": "Q229-MALFORMACION CONGENITA DE LA VALVULA TRICUSPIDE, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q230",
    "nombre_dx": "Q230-ESTENOSIS CONGENITA DE LA VALVULA AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q231",
    "nombre_dx": "Q231-INSUFICIENCIA CONGENITA DE LA VALVULA AORTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q232",
    "nombre_dx": "Q232-ESTENOSIS MITRAL CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q233",
    "nombre_dx": "Q233-INSUFICIENCIA MITRAL CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q234",
    "nombre_dx": "Q234-SINDROME DE HIPOPLASIA DEL CORAZON IZQUIERDO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q238",
    "nombre_dx": "Q238-OTRAS MALFORMACIONES CONGENITAS DE LAS VALVULAS AORTICA Y MITRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q239",
    "nombre_dx": "Q239-MALFORMACION CONGENITA DE LAS VALVULAS AORTICA Y MITRAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q240",
    "nombre_dx": "Q240-DEXTROCARDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q241",
    "nombre_dx": "Q241-LEVOCARDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q242",
    "nombre_dx": "Q242-CORAZON TRIAURICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q243",
    "nombre_dx": "Q243-ESTENOSIS DEL INFUNDIBULO PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q244",
    "nombre_dx": "Q244-ESTENOSIS SUBAORTICA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q245",
    "nombre_dx": "Q245-MALFORMACION DE LOS VASOS CORONARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q246",
    "nombre_dx": "Q246-BLOQUEO CARDIACO CONGENITO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q248",
    "nombre_dx": "Q248-OTRAS MALFORMACIONES CONGENITAS DEL CORAZON, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q249",
    "nombre_dx": "Q249-MALFORMACION CONGENITA DEL CORAZON, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q250",
    "nombre_dx": "Q250-CONDUCTO ARTERIOSO PERMEABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q251",
    "nombre_dx": "Q251-COARTACION DE LA AORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q252",
    "nombre_dx": "Q252-ATRESIA DE LA AORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q253",
    "nombre_dx": "Q253-ESTENOSIS DE LA AORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q254",
    "nombre_dx": "Q254-OTRAS MALFORMACIONES CONGENITAS DE LA AORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q255",
    "nombre_dx": "Q255-ATRESIA DE LA ARTERIA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q256",
    "nombre_dx": "Q256-ESTENOSISDE LA ARTERIA PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q257",
    "nombre_dx": "Q257-OTRAS MALFORMACIONES CONGENITAS DE LA ARTERIA PULMONAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q258",
    "nombre_dx": "Q258-OTRAS MALFORMACIONES CONGENITAS DE LASGRANDES ARTERIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q259",
    "nombre_dx": "Q259-MALFORMACION CONGENITA DE LAS GRANDES ARTERIAS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q260",
    "nombre_dx": "Q260-ESTENOSIS CONGENITA DE LA VENACAVA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q261",
    "nombre_dx": "Q261-PERSISTENCIA DE LA VENA CAVA SUPERIOR IZQUIERDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q262",
    "nombre_dx": "Q262-CONEXIÓN ANOMALA TOTAL DE LAS VENAS PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q263",
    "nombre_dx": "Q263-CONEXIÓN ANOMALA PARCIAL DE LAS VENAS PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q264",
    "nombre_dx": "Q264-CONEXIÓN ANOMALADE LAS VENAS PULMONARES, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Q265",
    "nombre_dx": "Q265-CONEXIÓN ANOMALADE LAVENA PORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q266",
    "nombre_dx": "Q266-FISTULA ARTERIA HEPATICA-VENA PORTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q268",
    "nombre_dx": "Q268-OTRAS MALFORMACIONES CONGENITAS DE LAS GRANDES VENAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q269",
    "nombre_dx": "Q269-MALFORMACION CONGENITA DE LAS GRANDES VENAS,NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q270",
    "nombre_dx": "Q270-AUSENCIA DE HIPOPLASIA CONGENITA DE LA ARTERIA UMBILICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q271",
    "nombre_dx": "Q271-ESTENOSIS CONGENITA DE LA ARTERIA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q272",
    "nombre_dx": "Q272-OTRAS MALFORMACIONES CONGENITAS DE LA ARTERIA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q273",
    "nombre_dx": "Q273-MALFORMACION ARTERIOVENOSA PERIFERICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q274",
    "nombre_dx": "Q274-FLEBECTASIA CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q278",
    "nombre_dx": "Q278-OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA VASCULAR PERIFERICO, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q279",
    "nombre_dx": "Q279-MALFORMACION CONGENITA DEL SISTEMA VASCULAR PERIFERICO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q280",
    "nombre_dx": "Q280-MALFORMACION ARTERIOVENOSA DE LOS VASOS PRECEREBRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q281",
    "nombre_dx": "Q281-OTRAS MALFORMACIONESDE LOS VASOS PRECEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q282",
    "nombre_dx": "Q282-MALFORMACION ARTERIOVENOSA DE LOS VASOS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q283",
    "nombre_dx": "Q283-OTRAS MALFORMACIONES DE LOS VASOS CEREBRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q288",
    "nombre_dx": "Q288-OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA CIRCULATORIO, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q289",
    "nombre_dx": "Q289-MALFORMACION CONGENITA DEL SISTEMA CIRCULATORIO NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q300",
    "nombre_dx": "Q300-ATRESIA DE LAS COANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q301",
    "nombre_dx": "Q301-AGENESIA O HIPOPLASIA DE LA NARIZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q302",
    "nombre_dx": "Q302-HENDIDURA, FISURA O MUESCA DE LA NARIZ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q303",
    "nombre_dx": "Q303-PERFORACION CONGENITA DEL TABIQUE NASAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q308",
    "nombre_dx": "Q308-OTRAS MALFORMACIONES CONGENITAS DE LA NARIZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q309",
    "nombre_dx": "Q309-MALFORMACION CONGENITA DE LA NARIZ, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q310",
    "nombre_dx": "Q310-PTERIGION DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q311",
    "nombre_dx": "Q311-ESTENOSIS SUBGLOTICA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q312",
    "nombre_dx": "Q312-HIPOPLASIA LARINGEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q313",
    "nombre_dx": "Q313-LARINGOCELE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q314",
    "nombre_dx": "Q314-ESTRIDOR LARINGEO CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q318",
    "nombre_dx": "Q318-OTRAS MALFORMACIONES CONGENITAS DE LALARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q319",
    "nombre_dx": "Q319-MALFORMACION CONGENITA DE LA LARINGE, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q320",
    "nombre_dx": "Q320-TRAQUEOMALACIA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q321",
    "nombre_dx": "Q321-OTRAS MALFORMACIONES CONGENITAS DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q322",
    "nombre_dx": "Q322-BRONCOMALACIA CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q323",
    "nombre_dx": "Q323-ESTENOSIS CONGENITA DE LOS BRONQUIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q324",
    "nombre_dx": "Q324-OTRAS MALFORMACIONES CONGENITAS DE LOS BRONQUIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q330",
    "nombre_dx": "Q330-QUISTE PULMONAR CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q331",
    "nombre_dx": "Q331-LOBULO PULMONAR SUPERNUMERARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q332",
    "nombre_dx": "Q332-SECUESTRO DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "Q333",
    "nombre_dx": "Q333-AGENESIA DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q334",
    "nombre_dx": "Q334-BRONQUIECTASIA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q335",
    "nombre_dx": "Q335-TEJIDO ECTOPICO EN EL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "Q336",
    "nombre_dx": "Q336-HIPOPLASIA Y DISPLASIA PULMONAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q338",
    "nombre_dx": "Q338-OTRAS MALFORMACIONES CONGENITAS DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "Q339",
    "nombre_dx": "Q339-MALFORMACION CONGENITA DEL PULMON, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q340",
    "nombre_dx": "Q340-ANOMALIA DE LA PLEURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q341",
    "nombre_dx": "Q341-QUISTE CONGENITODEL MEDIASTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q348",
    "nombre_dx": "Q348-OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DEL SISTEMA RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q349",
    "nombre_dx": "Q349-MALFORMACION CONGENITA DEL SISTEMA RESPIRATORIO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q351",
    "nombre_dx": "Q351-FISURA DEL PALADAR DURO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q353",
    "nombre_dx": "Q353-FISURA DEL PALADAR BLANDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q355",
    "nombre_dx": "Q355-FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q356",
    "nombre_dx": "Q356-FISURA DEL PALADAR, LINEA MEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q357",
    "nombre_dx": "Q357-FISURA DE LA UVULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q359",
    "nombre_dx": "Q359-FISURA DEL PALADAR, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q360",
    "nombre_dx": "Q360-LABIO LEPORINO, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q361",
    "nombre_dx": "Q361-LABIO LEPORINO, LINEA MEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q369",
    "nombre_dx": "Q369-LABIO LEPORINO, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q370",
    "nombre_dx": "Q370-FISURA DEL PALADAR DURO CON LABIO LEPORINO, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q371",
    "nombre_dx": "Q371-FISURA DEL PALADAR DURO CON LABIO LEPORINO, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q372",
    "nombre_dx": "Q372-FISURA DEL PALADAR BLANDO CON LABIO LEPORINO, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q373",
    "nombre_dx": "Q373-FISURA DEL PALADAR BLANDO CON LABIO LEPORINO, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q374",
    "nombre_dx": "Q374-FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q375",
    "nombre_dx": "Q375-FISURA DEL PALADAR DURO Y DEL PALADAR BLANDO CON LABIO LEPORINO, UNILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q378",
    "nombre_dx": "Q378-FISURA DEL PALADARCON LABIO LEPORINO BILATERAL, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q379",
    "nombre_dx": "Q379-FISURA DEL PALADARCON LABIO LEPORINO UNILATERAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Q380",
    "nombre_dx": "Q380-MALFORMACIONES CONGENITAS DE LOS LABIOS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q381",
    "nombre_dx": "Q381-ANQUILOGLOSIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q382",
    "nombre_dx": "Q382-MACROGLOSIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q383",
    "nombre_dx": "Q383-OTRAS MALFORMACIONES CONGENITAS DE LA LENGUA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q384",
    "nombre_dx": "Q384-MALFORMACIONES CONGENITAS DE LAS GLANDULAS Y DE LOS CONDUCTOS SALIVALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q385",
    "nombre_dx": "Q385-MALFORMACIONES CONGENITAS DEL PALADAR, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q386",
    "nombre_dx": "Q386-OTRAS MALFORMACIONES CONGENITAS DE LA BOCA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q387",
    "nombre_dx": "Q387-DIVERTICULO FARINGEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q388",
    "nombre_dx": "Q388-OTRAS MALFORMACIONES CONGENITAS DE LA LARINGE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q390",
    "nombre_dx": "Q390-ATRESIA DEL ESOFAGO SIN MENCION DE FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q391",
    "nombre_dx": "Q391-ATRESIA DEL ESOFAGO CON FISTULA TRAQUEOESOFAGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q392",
    "nombre_dx": "Q392-FISTULA TRAQUEOESOFAGICA CONGENITA SIN MENCION DE ATRESIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q393",
    "nombre_dx": "Q393-ESTRECHEZ O ESTENOSIS CONGENITA DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q394",
    "nombre_dx": "Q394-PTERIGION DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q395",
    "nombre_dx": "Q395-DILATACION CONGENITA DEL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q396",
    "nombre_dx": "Q396-DIVERTICULO DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q398",
    "nombre_dx": "Q398-OTRAS MALFORMACIONES CONGENITAS DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q399",
    "nombre_dx": "Q399-MALFORMACION CONGENITA DEL ESOFAGO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q400",
    "nombre_dx": "Q400-ESTENOSIS HIPERTROFICA CONGENITA DEL PILORO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q401",
    "nombre_dx": "Q401-HERNIA HIATAL CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q402",
    "nombre_dx": "Q402-OTRAS MALFORMACIONES CONGENITAS DEL ESTOMAGO, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q403",
    "nombre_dx": "Q403-MALFORMACION CONGENITA DEL ESTOMAGO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q408",
    "nombre_dx": "Q408-OTRAS MALFORMACIONES CONGENITAS DE LA PARTE SUPERIOR DEL TUBO DIGESTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q409",
    "nombre_dx": "Q409-MALFORMACION CONGENITA DE LA PARTE SUPERIOR DEL TUBO DIGESTIVO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q410",
    "nombre_dx": "Q410-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL DUODENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q411",
    "nombre_dx": "Q411-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL YEYUNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q412",
    "nombre_dx": "Q412-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ILEON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q418",
    "nombre_dx": "Q418-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DE OTRAS PARTES ESPECIFICADAS DEL INTESTINO DELGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q419",
    "nombre_dx": "Q419-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO DELGADO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q420",
    "nombre_dx": "Q420-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL RECTO, CON FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q421",
    "nombre_dx": "Q421-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL RECTO, SIN FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q422",
    "nombre_dx": "Q422-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ANO, CON FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q423",
    "nombre_dx": "Q423-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL ANO, SIN FISTULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q428",
    "nombre_dx": "Q428-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DE OTRAS PARTES DEL INTESTINO GRUESO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q429",
    "nombre_dx": "Q429-AUSENCIA, ATRESIA Y ESTENOSIS CONGENITA DEL INTESTINO GRUESO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q430",
    "nombre_dx": "Q430-DIVERTICULO DE MECKEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q431",
    "nombre_dx": "Q431-ENFERMEDAD DE HIRSCHSPRUNG",
    "sexo": "A"
  },
  {
    "cod_dx": "Q432",
    "nombre_dx": "Q432-OTROS TRASTORNOS FUNCIONALES CONGENITOS DEL COLON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q433",
    "nombre_dx": "Q433-MALFORMACIONES CONGENITAS DE LA FIJACION DEL INTESTINO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q434",
    "nombre_dx": "Q434-DUPLICACION DEL INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q435",
    "nombre_dx": "Q435-ANO ECTOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q436",
    "nombre_dx": "Q436-FISTULA CONGENITA DEL RECTO Y DEL ANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q437",
    "nombre_dx": "Q437-PERSISTENCIA DE LA CLOACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q438",
    "nombre_dx": "Q438-OTRAS MALFORMACIONES CONGENITAS DEL INTESTINO, NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q439",
    "nombre_dx": "Q439-MALFORMACION CONGENITA DEL INTESTINO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q440",
    "nombre_dx": "Q440-AGENESIA, APLASIA E HIPOPLASIA DE LA VESICULA BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q441",
    "nombre_dx": "Q441-OTRAS MALFORMACIONES CONGENITAS DE LA VESICULA BILIAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q442",
    "nombre_dx": "Q442-ATRESIA DE LOS CONDUCTOS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q443",
    "nombre_dx": "Q443-ESTRECHEZ Y ESTENOSIS CONGENITA DE LOS CONDUCTOS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q444",
    "nombre_dx": "Q444-QUISTE DEL COLEDOCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q445",
    "nombre_dx": "Q445-OTRAS MALFORMACIONES CONGENITAS DE LOS CONDUCTOS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q446",
    "nombre_dx": "Q446-ENFERMEDAD QUISTICA DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q447",
    "nombre_dx": "Q447-OTRAS MALFORMACIONES CONGENITAS DEL HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q450",
    "nombre_dx": "Q450-AGENESIA, APLASIA E HIPOPLASIA DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q451",
    "nombre_dx": "Q451-PANCREAS ANULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q452",
    "nombre_dx": "Q452-QUISTE CONGENITO DEL PANCREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q453",
    "nombre_dx": "Q453-OTRAS MALFORMACIONES CONGENITAS DEL PANCREAS Y DEL CONDUCTO PANCREATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q458",
    "nombre_dx": "Q458-OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA DIGESTIVO,ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q459",
    "nombre_dx": "Q459-MALFORMACIONCONGENITA DEL SISTEMA DIGESTIVO,NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q500",
    "nombre_dx": "Q500-AUSENCIA CONGENITA DEL OVARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q501",
    "nombre_dx": "Q501-QUISTE EN DESARROLLO DEL OVARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q502",
    "nombre_dx": "Q502-TORSION CONGENITA DEL OVARIO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q503",
    "nombre_dx": "Q503-OTRAS MALFORMACIONES CONGENITAS DE LOS OVARIOS",
    "sexo": "F"
  },
  {
    "cod_dx": "Q504",
    "nombre_dx": "Q504-QUISTE EMBRIONARIO DE LA TROMPA DE FALOPIO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q505",
    "nombre_dx": "Q505-QUISTE EMBRIONARIO DEL LIGAMENTO ANCHO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q506",
    "nombre_dx": "Q506-OTRAS MALFORMACIONES CONGENITAS DE LA TROMPA DE FALOPIO Y DEL LIGAMENTO ANCHO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q510",
    "nombre_dx": "Q510-AGENESIA Y APLASIA DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q511",
    "nombre_dx": "Q511-DUPLICACION DEL UTERO CON DUPLICACION DEL CUELLO UTERINO Y DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q512",
    "nombre_dx": "Q512-OTRA DUPLICACION DEL UTERO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q513",
    "nombre_dx": "Q513-UTERO BICORNE ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q514",
    "nombre_dx": "Q514-UTERO UNICORNE",
    "sexo": "F"
  },
  {
    "cod_dx": "Q515",
    "nombre_dx": "Q515-AGENESIA Y APLASIA DEL CUELLO UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q516",
    "nombre_dx": "Q516-QUISTE EMBRIONARIO DL CUELLO UTERINO",
    "sexo": "F"
  },
  {
    "cod_dx": "Q517",
    "nombre_dx": "Q517-FISTULA CONGENITA ENTRE EL UTERO Y EL TRACTO DIGESTIVO Y URINARIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q518",
    "nombre_dx": "Q518-OTRA MALFORMACIONES CONGENITAS DEL UTERO Y DEL CUELLO UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q519",
    "nombre_dx": "Q519-MALFORMACION CONGENITA DEL UTERO Y DEL CUELLO UTERINO, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q520",
    "nombre_dx": "Q520-AUSENCIA CONGENITA DE LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q521",
    "nombre_dx": "Q521-DUPLICACION DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q522",
    "nombre_dx": "Q522-FISTULA RECTOVAGINAL CONGENITA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q523",
    "nombre_dx": "Q523-HIMEN IMPERFORADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q524",
    "nombre_dx": "Q524-OTRAS MALFORMACIONES CONGENITAS DE LA VAGINA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q525",
    "nombre_dx": "Q525-FUSION DE LABIOS DE LA VULVA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q526",
    "nombre_dx": "Q526-MALFORMACION CONGENITA DEL CLITORIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q527",
    "nombre_dx": "Q527-OTRAS MALFORMACIONES CONGENITAS DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q528",
    "nombre_dx": "Q528-OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES FEMENINOS, ESPECIFICADAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q529",
    "nombre_dx": "Q529-MALFORMACION CONGENITA DE LOS GENITALES FEMENINOS, NO ESPECIFICADA",
    "sexo": "F"
  },
  {
    "cod_dx": "Q530",
    "nombre_dx": "Q530-ECTOPIA TESTICULAR",
    "sexo": "M"
  },
  {
    "cod_dx": "Q531",
    "nombre_dx": "Q531-TESTICULO NO DESCENDIDO, UNILATERAL ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q532",
    "nombre_dx": "Q532-TESTICULO NO DESCENDIDO, BILATERAL",
    "sexo": "M"
  },
  {
    "cod_dx": "Q539",
    "nombre_dx": "Q539-TESTICULO NO DESCENDIDO, SIN OTRA ESPECIFICACION",
    "sexo": "M"
  },
  {
    "cod_dx": "Q540",
    "nombre_dx": "Q540-HIPOSPADIAS DEL GLANDE",
    "sexo": "M"
  },
  {
    "cod_dx": "Q541",
    "nombre_dx": "Q541-HIPOSPADIAS PENEANA ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q542",
    "nombre_dx": "Q542-HIPOSPADIAS PENOSCROTAL ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q543",
    "nombre_dx": "Q543-HIPOSPADIAS PERINEAL",
    "sexo": "M"
  },
  {
    "cod_dx": "Q544",
    "nombre_dx": "Q544-ENCORDAMIENTO CONGENITO DEL PENE",
    "sexo": "M"
  },
  {
    "cod_dx": "Q548",
    "nombre_dx": "Q548-OTRAS HIPOSPADIAS ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q549",
    "nombre_dx": "Q549-HIPOSPADIAS, NO ESPECIFICADA",
    "sexo": "M"
  },
  {
    "cod_dx": "Q550",
    "nombre_dx": "Q550-AUSENCIA Y APLASIA DEL TESTICULO",
    "sexo": "M"
  },
  {
    "cod_dx": "Q551",
    "nombre_dx": "Q551-HIPOPLASIA DEL TESTICULO Y DEL ESCROTO",
    "sexo": "M"
  },
  {
    "cod_dx": "Q552",
    "nombre_dx": "Q552-OTRAS MALFORMACIONES CONGENITAS DE LOS TESTICULOS Y DEL ESCROTO ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q553",
    "nombre_dx": "Q553-ATRESIA DEL CONDUCTO DEFERENTE",
    "sexo": "M"
  },
  {
    "cod_dx": "Q554",
    "nombre_dx": "Q554-OTRAS MALFORMACIONES CONGENITAS DE LOS CONDUCTOS DEFERENTES, DEL EPIDIDIMO, DE LAS VESICULAS SEMINAL",
    "sexo": "M"
  },
  {
    "cod_dx": "Q555",
    "nombre_dx": "Q555-APLASIA Y AUSENCIA CONGENITA DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q556",
    "nombre_dx": "Q556-OTRAS MALFORMACIONES CONGENITAS DEL PENE",
    "sexo": "M"
  },
  {
    "cod_dx": "Q558",
    "nombre_dx": "Q558-OTRAS MALFORMACIONES CONGENITAS DE LOS ORGANOS GENITALES MASCULINOS, ESPECIFICADAS",
    "sexo": "M"
  },
  {
    "cod_dx": "Q559",
    "nombre_dx": "Q559-MALFORMACION CONGENITA DE LOS ORGANOS GENITALES MASCULINOS, NO ESPECIFICADA ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q560",
    "nombre_dx": "Q560-HERMAFRODITISMO, NO CLASIFICADO ENOTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q561",
    "nombre_dx": "Q561-SEUDOHERMAFRODITISMO MASCULINO, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q562",
    "nombre_dx": "Q562-SEUDOHERMAFRODITISMO FEMENINO, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q563",
    "nombre_dx": "Q563-SEUDOHERMAFRODITISMO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q564",
    "nombre_dx": "Q564-SEXO INDETERMINADO, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q600",
    "nombre_dx": "Q600-AGENESIA RENAL, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q601",
    "nombre_dx": "Q601-AGENESIA RENAL, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q602",
    "nombre_dx": "Q602-AGENESIA RENAL, SIN OTRA ESPECIFICACIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q603",
    "nombre_dx": "Q603-HIPOPLASIA RENAL, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q604",
    "nombre_dx": "Q604-HIPOPLASIA RENAL, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q605",
    "nombre_dx": "Q605-HIPOPLASIA RENAL, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q606",
    "nombre_dx": "Q606-SINDROME DE POTTER",
    "sexo": "A"
  },
  {
    "cod_dx": "Q610",
    "nombre_dx": "Q610-QUISTE RENAL SOLITARIO CONGENITO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q611",
    "nombre_dx": "Q611-RIÑON POLIQUISTICO, TIPO INFANTIL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q612",
    "nombre_dx": "Q612-RIÑON POLIQUISTICO, TIPO ADULTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q613",
    "nombre_dx": "Q613-RIÑON POLIQUISTICO, TIPO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q614",
    "nombre_dx": "Q614-DISPLASIA RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q615",
    "nombre_dx": "Q615-RIÑON QUISTICO MEDULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q618",
    "nombre_dx": "Q618-OTRAS ENFERMEDADES RENALES QUISTICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q619",
    "nombre_dx": "Q619-ENFERMEDAD QUISTICA DEL RIÑON, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q620",
    "nombre_dx": "Q620-HIDRONEFROSIS CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q621",
    "nombre_dx": "Q621-ATRESIA Y ESTENOSIS DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "Q622",
    "nombre_dx": "Q622-MEGALOURETER CONGENITO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q623",
    "nombre_dx": "Q623-OTROS DEFECTOS OBSTRUCTIVOS DE LA PELVIS RENAL Y DEL URETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q624",
    "nombre_dx": "Q624-AGENESIA DEL URETER ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q625",
    "nombre_dx": "Q625-DUPLICACION DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "Q626",
    "nombre_dx": "Q626-MALA POSICION DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "Q627",
    "nombre_dx": "Q627-REFLUJO VESICO-URETERO-RENAL CONGENITO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q628",
    "nombre_dx": "Q628-OTRAS MALFORMACIONES CONGENITAS DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "Q630",
    "nombre_dx": "Q630-RIÑONSUPERNUMERARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q631",
    "nombre_dx": "Q631-RIÑON LOBULADO, FUSIONADO Y EN HERRADURA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q632",
    "nombre_dx": "Q632-RIÑON ECTOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q633",
    "nombre_dx": "Q633-HIPERPLASIA RENAL Y RIÑON GIGANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q638",
    "nombre_dx": "Q638-OTRAS MALFORMACIONES CONGENITAS DEL RIÑON, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q639",
    "nombre_dx": "Q639-MALFORMACION CONGENITA DEL RIÑON, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q640",
    "nombre_dx": "Q640-EPISPADIAS",
    "sexo": "M"
  },
  {
    "cod_dx": "Q641",
    "nombre_dx": "Q641-EXTROFIA DE LA VEJIGA URINARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q642",
    "nombre_dx": "Q642-VALVULAS URETRALES POSTERIORES CONGENITAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q643",
    "nombre_dx": "Q643-OTRAS ATRESIAS Y ESTENOSIS DE LA URETRA Y DEL CUELLO DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q644",
    "nombre_dx": "Q644-MALFORMACION DEL URACO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q645",
    "nombre_dx": "Q645-AUSENCIA CONGENITA DE LAVEJIGA Y DE LA URETRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q646",
    "nombre_dx": "Q646-DIVERTICULO CONGENITO DE LAVEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q647",
    "nombre_dx": "Q647-OTRAS MALFORMACIONES CONGENITAS DE LAVEJIGA Y DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q648",
    "nombre_dx": "Q648-OTRAS MALFORMACIONESCONGENITAS DELAPARATO URINARIO, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q649",
    "nombre_dx": "Q649-MALFORMACION CONGENITA DELAPARATO URINARIO, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q650",
    "nombre_dx": "Q650-LUXACION CONGENITA DE LA CADERA, UNILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q651",
    "nombre_dx": "Q651-LUXACION CONGENITA DE LA CADERA, BILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q652",
    "nombre_dx": "Q652-LUXACION CONGENITA DE LA CADERA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q653",
    "nombre_dx": "Q653-SUBLUXACION CONGENITA DE LA CADERA, UNILATERAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q654",
    "nombre_dx": "Q654-SUBLUXACION CONGENITA DE LA CADERA, BILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q655",
    "nombre_dx": "Q655-SUBLUXACION CONGENITA DE LA CADERA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q656",
    "nombre_dx": "Q656-CADERA INESTABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q658",
    "nombre_dx": "Q658-OTRAS DEFORMIDADES CONGENITAS DE LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q659",
    "nombre_dx": "Q659-DEFORMIDAD CONGENITA DE LA CADERA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q660",
    "nombre_dx": "Q660-TALIPES EQUINOVARUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q661",
    "nombre_dx": "Q661-TALIPES CALCANEOVARUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q662",
    "nombre_dx": "Q662-METATARSUS VARUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q663",
    "nombre_dx": "Q663-OTRAS DEFORMIDADES VARUS CONGENITAS DE LOS PIES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q664",
    "nombre_dx": "Q664-TALIPES CALCANEOVALGUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q665",
    "nombre_dx": "Q665-PIE PLANO CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q666",
    "nombre_dx": "Q666-OTRAS DEFORMIDADES VALGUS CONGENITAS DE LOS PIES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q667",
    "nombre_dx": "Q667-PIE CAVUS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q668",
    "nombre_dx": "Q668-OTRAS DEFORMIDADES CONGENITAS DE LOS PIES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q669",
    "nombre_dx": "Q669-DEFORMIDAD CONGENITA DE LOS PIES, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q670",
    "nombre_dx": "Q670-ASIMETRIA FACIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q671",
    "nombre_dx": "Q671-FACIES COMPRIMIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q672",
    "nombre_dx": "Q672-DOLICOCEFALIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q673",
    "nombre_dx": "Q673-PLAGIOCEFALIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q674",
    "nombre_dx": "Q674-OTRAS DEFORMIDADES CONGENITAS DEL CRANEO, DE LA CARA Y DE LA MANDIBULA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q675",
    "nombre_dx": "Q675-DEFORMIDAD CONGENITA DE LA COLUMNA VERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q676",
    "nombre_dx": "Q676-TORAX EXCAVADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q677",
    "nombre_dx": "Q677-TORAX EN QUILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q678",
    "nombre_dx": "Q678-OTRAS DEFORMIDADESCONGENITAS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "Q680",
    "nombre_dx": "Q680-DEFORMIDAD CONGENITA DEL MUSCULO ESTERNOCLEIDOMASTOIDEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q681",
    "nombre_dx": "Q681-DEFORMIDAD CONGENITA DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q682",
    "nombre_dx": "Q682-DEFORMIDAD CONGENITA DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q683",
    "nombre_dx": "Q683-CURVATURA CONGENITA DEL FEMUR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q684",
    "nombre_dx": "Q684-CURVATURA CONGENITA DE LA TIBIA Y EL PERONE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q685",
    "nombre_dx": "Q685-CURVATURA CONGENITA DE HUESO(S) LARGO(S) DEL MIEMBRO INFERIOR, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Q688",
    "nombre_dx": "Q688-OTRAS DEFORMIDADES CONGENITAS OSTEOMUSCULARES, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q690",
    "nombre_dx": "Q690-DEDO(S) SUPERNUMERARIO(S) DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q691",
    "nombre_dx": "Q691-PULGAR(ES) SUPERNUMERARIO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q692",
    "nombre_dx": "Q692-DEDO(S) SUPERNUMERARIO(S) DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q699",
    "nombre_dx": "Q699-POLIDACTILIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q700",
    "nombre_dx": "Q700-FUSION DE LOS DEDOS DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q701",
    "nombre_dx": "Q701-MEMBRANA INTERDIGITAL DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q702",
    "nombre_dx": "Q702-FUSION DE LOS DEDOS DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q703",
    "nombre_dx": "Q703-MEMBRANA INTERDIGITAL DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q704",
    "nombre_dx": "Q704-POLISINDACTILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q709",
    "nombre_dx": "Q709-SINDACTILIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q710",
    "nombre_dx": "Q710-AUSENCIA CONGENITA COMPLETA DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q711",
    "nombre_dx": "Q711-AUSENCIA CONGENITA DEL BRAZO Y DEL ANTEBRAZO CON PRESENCIA DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q712",
    "nombre_dx": "Q712-AUSENCIA CONGENITADEL ANTEBRAZO Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q713",
    "nombre_dx": "Q713-AUSENCIA CONGENITA DE LA MANO Y EL (LOS) DEDO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q714",
    "nombre_dx": "Q714-DEFECTO POR REDUCCION LONGITUDINAL DEL RADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q715",
    "nombre_dx": "Q715-DEFECTO POR REDUCCION LONGITUDINAL DEL CUBITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q716",
    "nombre_dx": "Q716-MANO EN PINZA DE LANGOSTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q718",
    "nombre_dx": "Q718-OTROS DEFECTOS POR REDUCCION DEL (DE LOS) MIEMBRO(S) SUPERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q719",
    "nombre_dx": "Q719-DEFECTO POR REDUCCION DEL MIEMBRO SUPERIOR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q720",
    "nombre_dx": "Q720-AUSENCIA CONGENITA COMPLETA DEL (DE LOS) MIEMBRO(S) INFERIOR(ES)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q721",
    "nombre_dx": "Q721-AUSENCIA CONGENITA DEL MUSLO Y DE LA PIERNA CON PRESENCIA DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q722",
    "nombre_dx": "Q722-AUSENCIA CONGENITA DE LA PIERNA Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q723",
    "nombre_dx": "Q723-AUSENCIA CONGENITA DEL PIE Y DEDO(S) DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q724",
    "nombre_dx": "Q724-DEFECTO POR REDUCCION LONGITUDINAL DEL FEMUR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q725",
    "nombre_dx": "Q725-DEFECTO POR REDUCCION LONGITUDINAL DE LA TIBIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q726",
    "nombre_dx": "Q726-DEFECTO POR REDUCCION LONGITUDINAL DEL PERONE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q727",
    "nombre_dx": "Q727-PIE HENDIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q728",
    "nombre_dx": "Q728-OTROS DEFECTOS POR REDUCCION DEL (DE LOS) MIEMBRO(S) INFERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q729",
    "nombre_dx": "Q729-DEFECTO POR REDUCCION DEL MIEMBRO INFERIOR, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q730",
    "nombre_dx": "Q730-AUSENCIA COMPLETADE MIEMBRO(S) NO ESPECIFICADO(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q731",
    "nombre_dx": "Q731-FOCOMELIA, MIEMBRO(S) NO ESPECIFICADO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q738",
    "nombre_dx": "Q738-OTROS DEFECTOS POR REDUCCION DE MIEMBRO(S) NO ESPECIFICADO(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q740",
    "nombre_dx": "Q740-OTRAS MALFORMACIONES CONGENITAS DE (DE LOS) MIEMBRO(S) SUPERIOR(ES), INCLUIDA LA CINTURA ESCAPULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q741",
    "nombre_dx": "Q741-MALFORMACIONCONGENITA DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q742",
    "nombre_dx": "Q742-OTRAS MALFORMACIONES CONGENITAS DEL (DE LOS) MIEMBRO(S) INFERIOR(ES), INCLUIDALA CINTURA PELVIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q743",
    "nombre_dx": "Q743-ARTROGRIPOSIS MULTIPLE CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q748",
    "nombre_dx": "Q748-OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DEL (DE LOS) MIEMBRO(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q749",
    "nombre_dx": "Q749-MALFORMACION CONGENITA DE MIEMBRO(S), NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q750",
    "nombre_dx": "Q750-CRANEOSINOSTOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q751",
    "nombre_dx": "Q751-DISOSTOSIS CRANEOFACIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q752",
    "nombre_dx": "Q752-HIPERTELORISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q753",
    "nombre_dx": "Q753-MACROCEFALIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q754",
    "nombre_dx": "Q754-DISOSTOSIS MAXILOFACIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q755",
    "nombre_dx": "Q755-DISOSTOSIS OCULOMAXILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q758",
    "nombre_dx": "Q758-OTRAS MALFORMACIONES CONGENITAS ESPECIFICADAS DE LOS HUESOS DEL CRANEO Y DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q759",
    "nombre_dx": "Q759-MALFORMACION CONGENITA NO ESPECIFICADA DE LOS HUESOS DEL CRANEO Y DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q760",
    "nombre_dx": "Q760-ESPINA BIFIDA OCULTA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q761",
    "nombre_dx": "Q761-SINDROME DE KLIPPEL-FEIL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q762",
    "nombre_dx": "Q762-ESPONDILOLISTESIS CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q763",
    "nombre_dx": "Q763-ESCOLIOSIS CONGENITA DEBIDA A MALFORMACION CONGENITA OSEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q764",
    "nombre_dx": "Q764-OTRA MALFORMACION CONGENITA DE LA COLUMNA VERTEBRAL, NO ASOCIADA CON ESCOLIOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q765",
    "nombre_dx": "Q765-COSTILLA CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q766",
    "nombre_dx": "Q766-OTRAS MALFORMACIONES CONGENITAS DE LAS COSTILLAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q767",
    "nombre_dx": "Q767-MALFORMACION CONGENITA DEL ESTERNON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q768",
    "nombre_dx": "Q768-OTRAS MALFORMACIONES CONGENITAS DEL TORAX OSEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q769",
    "nombre_dx": "Q769-MALFORMACION CONGENITA DEL TORAX OSEO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q770",
    "nombre_dx": "Q770-ACONDROGENESIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q771",
    "nombre_dx": "Q771-ENANISMO TANATOFORICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q772",
    "nombre_dx": "Q772-SINDROME DE COSTILLA CORTA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q773",
    "nombre_dx": "Q773-CONDRODISPLASIA PUNCTATA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q774",
    "nombre_dx": "Q774-ACONDROPLASIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q775",
    "nombre_dx": "Q775-DISPLASIADISTROFICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q776",
    "nombre_dx": "Q776-DISPLASIA CONDROECTODERMICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q777",
    "nombre_dx": "Q777-DISPLASIA ESPONDILOEPIFISARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q778",
    "nombre_dx": "Q778-OTRAS OSTEOCONDRODISPLASIAS CON DEFECTOS DEL CRECIMIENTO DE LOS HUESOS LARGOS Y DE LA COLUMNA VERTEB",
    "sexo": "A"
  },
  {
    "cod_dx": "Q779",
    "nombre_dx": "Q779-OSTEOCONDRODISPLASIA CON DEFECTOS DEL CRECIMIENTO DE LOS HUESOS LARGOS Y DE LA COLUMNA VERTEBRAL, SI",
    "sexo": "A"
  },
  {
    "cod_dx": "Q780",
    "nombre_dx": "Q780-OSTEOGENESIS IMPERFECTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q781",
    "nombre_dx": "Q781-DISPLASIA POLIOSTOTICA FIBROSA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q782",
    "nombre_dx": "Q782-OSTEOPETROSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q783",
    "nombre_dx": "Q783-DISPLASIA DIAFISARIA PROGRESIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q784",
    "nombre_dx": "Q784-ENCONDROMATOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q785",
    "nombre_dx": "Q785-DISPLASIA METAFISARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q786",
    "nombre_dx": "Q786-EXOSTOSIS CONGENITA MULTIPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q788",
    "nombre_dx": "Q788-OTRAS OSTEOCONDRODISPLASIAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q789",
    "nombre_dx": "Q789-OSTEOCONDRODISPLASIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q790",
    "nombre_dx": "Q790-HERNIA DIAFRAGMATICA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q791",
    "nombre_dx": "Q791-OTRAS MALFORMACIONES CONGENITASDEL DIAFRAGMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q792",
    "nombre_dx": "Q792-EXONFALOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q793",
    "nombre_dx": "Q793-GASTROSQUISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q794",
    "nombre_dx": "Q794-SINDROME DEL ABDOMEN EN CIRUELA PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q795",
    "nombre_dx": "Q795-OTRAS MALFORMACIONES CONGENITAS DE LA PARED ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q796",
    "nombre_dx": "Q796-SINDROME DE EHLERS-DANLOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q798",
    "nombre_dx": "Q798-OTRAS MALFORMACIONES CONGENITAS DEL SISTEMA OSTEOMUSCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q799",
    "nombre_dx": "Q799-MALFORMACION CONGENITA DEL SISTEMA OSTEOMUSCULAR, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q800",
    "nombre_dx": "Q800-ICTIOSISVULGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q801",
    "nombre_dx": "Q801-ICTIOSIS LIGADAAL CROMOSOMA X ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q802",
    "nombre_dx": "Q802-ICTIOSIS LAMELAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q803",
    "nombre_dx": "Q803-ERITRODERMIA ICTIOSIFORME VESICULAR CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q804",
    "nombre_dx": "Q804-FETO ARLEQUÍN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q808",
    "nombre_dx": "Q808-OTRAS ICTIOSIS CONGENITAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q809",
    "nombre_dx": "Q809-ICTIOSIS CONGENITA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q810",
    "nombre_dx": "Q810-EPIDERMOLISIS BULLOSA SIMPLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q811",
    "nombre_dx": "Q811-EPIDERMOLISIS BULLOSA LETAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q812",
    "nombre_dx": "Q812-EPIDERMOLISIS BULLOSA DISTROFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q818",
    "nombre_dx": "Q818-OTRAS EPIDERMOLISIS BULLOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q819",
    "nombre_dx": "Q819-EPIDERMOLISIS BULLOSA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q820",
    "nombre_dx": "Q820-LINFEDEMA HEREDITARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q821",
    "nombre_dx": "Q821-XERODERMA PIGMENTOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q822",
    "nombre_dx": "Q822-MASTOCITOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q823",
    "nombre_dx": "Q823-INCONTINENCIA PIGMENTARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q824",
    "nombre_dx": "Q824-DISPLASIA ECTODERMICA (ANHIDROTICA) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q825",
    "nombre_dx": "Q825-NEVO NO NEOPLASICO, CONGENITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q828",
    "nombre_dx": "Q828-OTRAS MALFORMACIONES CONGENITAS DE LA PIEL, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q829",
    "nombre_dx": "Q829-MALFORMACION CONGENITA DE LA PIEL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q830",
    "nombre_dx": "Q830-AUSENCIA CONGENITA DE LA MAMA CON AUSENCIA DEL PEZON",
    "sexo": "A"
  },
  {
    "cod_dx": "Q831",
    "nombre_dx": "Q831-MAMA SUPERNUMERARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q832",
    "nombre_dx": "Q832-AUSENCIA DELPEZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q833",
    "nombre_dx": "Q833-PEZON SUPERNUMERARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q838",
    "nombre_dx": "Q838-OTRAS MALFORMACIONES CONGENITAS DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q839",
    "nombre_dx": "Q839-MALFORMACION CONGENITA DE LA MAMA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q840",
    "nombre_dx": "Q840-ALOPECIA CONGENITA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q841",
    "nombre_dx": "Q841-ALTERACIONES MORFOLOGICAS CONGENITAS DEL PELO, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q842",
    "nombre_dx": "Q842-OTRAS MALFORMACIONES CONGENITAS DEL PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q843",
    "nombre_dx": "Q843-ANONIQUIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q844",
    "nombre_dx": "Q844-LEUCONIQUIA CONGENITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q845",
    "nombre_dx": "Q845-AGRANDAMIENTO E HIPERTROFIA DE LAS UÑAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q846",
    "nombre_dx": "Q846-OTRAS MALFORMACIONES CONGENITAS DE LAS UÑAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q848",
    "nombre_dx": "Q848-OTRAS MALFORMACIONES CONGENITAS DE LAS FANERAS, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q849",
    "nombre_dx": "Q849-MALFORMACION CONGENITA DE LAS FANERAS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q850",
    "nombre_dx": "Q850-NEUROFIBROMATOSIS (NO MALIGNA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q851",
    "nombre_dx": "Q851-ESCLEROSIS TUBEROSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q858",
    "nombre_dx": "Q858-OTRAS FACOMATOSIS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q859",
    "nombre_dx": "Q859-FACOMATOSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q860",
    "nombre_dx": "Q860-SINDROME FETAL (DISMORFICO) DEBIDO AL ALCOHOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q861",
    "nombre_dx": "Q861-SINDROME DE HIDANTOINA FETAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q862",
    "nombre_dx": "Q862-DISMORFISMO DEBIDO A WARFARINA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q868",
    "nombre_dx": "Q868-OTROS SINDROMES DE MALFORMACIONES CONGENITAS DEBIDOS A CAUSAS EXOGENAS CONOCIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q870",
    "nombre_dx": "Q870-SINDROMES DE MALFORMACIONES CONGENITAS QUE AFECTAN PRINCIPALMENTELA APARIENCIA FACIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q871",
    "nombre_dx": "Q871-SINDROMES DE MALFORMACIONES CONGENITAS ASOCIADAS PRINCIPALMENTE CON ESTATURA BAJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q872",
    "nombre_dx": "Q872-SINDROMES DE MALFORMACIONES CONGENITAS QUE AFECTAN PRINCIPALMENTELOS MIEMBROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q873",
    "nombre_dx": "Q873-SINDROMES DE MALFORMACIONES CONGENITAS CON EXCESO DE CRECIMIENTO PRECOZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q874",
    "nombre_dx": "Q874-SINDROME DE MARFAN",
    "sexo": "A"
  },
  {
    "cod_dx": "Q875",
    "nombre_dx": "Q875-OTROS SINDROMES DE MALFORMACIONES CONGENITAS CON OTROS CAMBIOS ESQUELETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q878",
    "nombre_dx": "Q878-OTROS SINDROMES DE MALFORMACIONES CONGENITAS ESPECIFICADOS, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q890",
    "nombre_dx": "Q890-MALFORMACIONES CONGENITAS DEL BAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q891",
    "nombre_dx": "Q891-MALFORMACIONES CONGENITAS DE LA GLANDULA SUPRARRENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q892",
    "nombre_dx": "Q892-MALFORMACIONES CONGENITAS OTRAS GLANDULAS ENDOCRINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q893",
    "nombre_dx": "Q893-SITUS INVERSUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q894",
    "nombre_dx": "Q894-GEMELOS SIAMESES",
    "sexo": "A"
  },
  {
    "cod_dx": "Q897",
    "nombre_dx": "Q897-MALFORMACIONES CONGENITAS MULTIPLES, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Q898",
    "nombre_dx": "Q898-OTRAS MALFORMACIONES CONGENITAS,ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q899",
    "nombre_dx": "Q899-MALFORMACION CONGENITA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q900",
    "nombre_dx": "Q900-TRISOMIA 21,POR FALTA DE DISYUNCION MEIOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q901",
    "nombre_dx": "Q901-TRISOMIA 21,MOSAICO (POR FALTA DE DISYUNCION MITOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q902",
    "nombre_dx": "Q902-TRISOMIA 21,POR TRANSLOCACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q909",
    "nombre_dx": "Q909-SINDROME DE DOWN, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q910",
    "nombre_dx": "Q910-TRISOMIA 18,POR FALTA DE DISYUNCION MEIOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q911",
    "nombre_dx": "Q911-TRISOMIA 18,MOSAICO (POR FALTA DE DISYUNCION MITOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q912",
    "nombre_dx": "Q912-TRISOMIA 18,POR TRANSLOCACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q913",
    "nombre_dx": "Q913-SINDROME DE EDWARDS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q914",
    "nombre_dx": "Q914-TRISOMIA 13,POR FALTA DE DISYUNCION MEIOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q915",
    "nombre_dx": "Q915-TRISOMIA 13,MOSAICO (POR FALTA DE DISYUNCION MITOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q916",
    "nombre_dx": "Q916-TRISOMIA 13,POR TRANSLOCACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q917",
    "nombre_dx": "Q917-SINDROME DE PATAU, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q920",
    "nombre_dx": "Q920-TRISOMIA DE UN CROMOSOMA COMPLETO, POR FALTA DEDISYUNCION MEIOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q921",
    "nombre_dx": "Q921-TRISOMIA DE UN CROMOSOMA COMPLETO, MOSAICO (POR FALTA DEDISYUNCION MITOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q922",
    "nombre_dx": "Q922-TRISOMIA PARCIAL MAYOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q923",
    "nombre_dx": "Q923-TRISOMIA PARCIAL MENOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Q924",
    "nombre_dx": "Q924-DUPLICACIONES VISIBLES SOLO EN LA PROMETAFASE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q925",
    "nombre_dx": "Q925-DUPLICACIONES CON OTROS REORDENAMIENTOS COMPLEJOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q926",
    "nombre_dx": "Q926-CROMOSOMAS MARCADORES SUPLEMENTARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q927",
    "nombre_dx": "Q927-TRIPLOIDIA Y POLIPLOIDIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q928",
    "nombre_dx": "Q928-OTRAS TRISOMIAS Y TRISOMIAS PARCIALES DE LOS AUTOSOMAS, ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q929",
    "nombre_dx": "Q929-TRISOMIA Y TRISOMIA PARCIAL DE LOS AUTOSOMAS, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q930",
    "nombre_dx": "Q930-MONOSOMIA COMPLETA DE UN CROMOSOMA, POR FALTA DE DISYUNCION MEIOTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q931",
    "nombre_dx": "Q931-MONOSOMIA COMPLETA DE UN CROMOSOMA, MOSAICO (POR FALTA DE DISYUNCION MITOTICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "Q932",
    "nombre_dx": "Q932-CROMOSOMA REEMPLAZADO POR ANILLO O DICENTRICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q933",
    "nombre_dx": "Q933-SUPRESION DEL BRAZO CORTO DEL CROMOSOMA 4 ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q934",
    "nombre_dx": "Q934-SUPRESION DEL BRAZO CORTO DEL CROMOSOMA 5 ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q935",
    "nombre_dx": "Q935-OTRAS SUPRESIONES DE PARTE DE UN CROMOSOMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q936",
    "nombre_dx": "Q936-SUPRESIONES VISIBLES SOLO EN LA PROMETAFASE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q937",
    "nombre_dx": "Q937-SUPRESIONES CON OTROS REORDENAMIENTOS COMPLEJOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q938",
    "nombre_dx": "Q938-OTRAS SUPRESIONES DE LOS AUTOSOMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q939",
    "nombre_dx": "Q939-SUPRESION DE LOS AUTOSOMAS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q950",
    "nombre_dx": "Q950-TRANSLOCACION EQUILIBRADA E INSERCION EN INDIVIDUO NORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q951",
    "nombre_dx": "Q951-INVERSION CROMOSOMICA EN INDIVIDUO NORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q952",
    "nombre_dx": "Q952-REORDENAMIENTO AUTOSOMICO EQUILIBRADO EN INDIVIDUO ANORMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q953",
    "nombre_dx": "Q953-REORDENAMIENTO AUTOSOMICO/SEXUAL EQUILIBRADO EN INDIVIDUO ANORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q954",
    "nombre_dx": "Q954-INDIVIDUOS CON HETEROCROMATINA MARCADORA",
    "sexo": "A"
  },
  {
    "cod_dx": "Q955",
    "nombre_dx": "Q955-INDIVIDUOS CON SITIO FRAGIL AUTOSOMICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Q958",
    "nombre_dx": "Q958-OTROS REORDENAMIENTOS EQUILIBRADOS Y MARCADORES ESTRUCTURALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q959",
    "nombre_dx": "Q959-REORDENAMIENTO EQUILIBRADO Y MARCADOR ESTRUCTURAL, SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Q960",
    "nombre_dx": "Q960-CARIOTIPO 45,X",
    "sexo": "F"
  },
  {
    "cod_dx": "Q961",
    "nombre_dx": "Q961-CARIOTIPO 46,X ISO (XQ) ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q962",
    "nombre_dx": "Q962-CARIOTIPO 46,X CON CROMOSOMA SEXUAL ANORMAL EXCEPTO ISO (XQ)",
    "sexo": "F"
  },
  {
    "cod_dx": "Q963",
    "nombre_dx": "Q963-MOSAICO 45,X/46,XX O XY ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q964",
    "nombre_dx": "Q964-MOSAICO 45,X/OTRA(S) LINEA(S) CELULAR(ES) CON CROMOSOMA SEXUAL ANORMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q968",
    "nombre_dx": "Q968-OTRAS VARIANTES DEL SINDROME DE TURNER",
    "sexo": "F"
  },
  {
    "cod_dx": "Q969",
    "nombre_dx": "Q969-SINDROME DE TURNER, NO ESPECIFICADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q970",
    "nombre_dx": "Q970-CARIOTIPO 47,XXX",
    "sexo": "F"
  },
  {
    "cod_dx": "Q971",
    "nombre_dx": "Q971-MUJER CON MAS DE TRES CROMOSOMAS X",
    "sexo": "F"
  },
  {
    "cod_dx": "Q972",
    "nombre_dx": "Q972-MOSAICO, LINEAS CON NUMERO VARIABLE DE CROMOSOMAS X ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q973",
    "nombre_dx": "Q973-MUJERCON CARIOTIPO 46,XY",
    "sexo": "F"
  },
  {
    "cod_dx": "Q978",
    "nombre_dx": "Q978-OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO FEMENINO, ESPECIFICADAS",
    "sexo": "F"
  },
  {
    "cod_dx": "Q979",
    "nombre_dx": "Q979-ANOMALIA DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO FEMENINO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "Q980",
    "nombre_dx": "Q980-SINDROME DE KLINEFELTER, CARIOTIPO 47,XXY ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q981",
    "nombre_dx": "Q981-SINDROME DE KLINEFELTER, HOMBRE CON MAS DE DOS CROMOSOMAS X ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q982",
    "nombre_dx": "Q982-SINDROME DE KLINEFELTER, HOMBRE CON CARIOTIPO 46,XX ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q983",
    "nombre_dx": "Q983-OTRO HOMBRE CON CARIOTIPO 46,XX ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q984",
    "nombre_dx": "Q984-SINDROME DE KLINEFELTER, NO ESPECIFICADO",
    "sexo": "M"
  },
  {
    "cod_dx": "Q985",
    "nombre_dx": "Q985-CARIOTIPO 47,XYY",
    "sexo": "M"
  },
  {
    "cod_dx": "Q986",
    "nombre_dx": "Q986-HOMBRE CON CROMOSOMA SEXUAL ESTRUCTURALMENTE ANORMAL",
    "sexo": "M"
  },
  {
    "cod_dx": "Q987",
    "nombre_dx": "Q987-HOMBRE CON MOSAICO DE CROMOSOMAS SEXUALES ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q988",
    "nombre_dx": "Q988-OTRAS ANOMALIAS DE LOS CROMOSOMAS SEXUALES, CON FENOTIPO MASCULINO, ESPECIFICADAS ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q989",
    "nombre_dx": "Q989-ANOMALIA DE LOS CROMOSOMAS SEXUALES,FENOTIPO MASCULINO, SIN OTRA ESPECIFICACION ",
    "sexo": "M"
  },
  {
    "cod_dx": "Q990",
    "nombre_dx": "Q990-QUIMERA 46,XX/46,XY ",
    "sexo": "A"
  },
  {
    "cod_dx": "Q991",
    "nombre_dx": "Q991-HERMAFRODITA VERDADERO 46,XX",
    "sexo": "A"
  },
  {
    "cod_dx": "Q992",
    "nombre_dx": "Q992-CROMOSOMA X FRAGIL",
    "sexo": "A"
  },
  {
    "cod_dx": "Q998",
    "nombre_dx": "Q998-OTRAS ANOMALIAS DE LOS CROMOSOMAS. ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Q999",
    "nombre_dx": "Q999-ANOMALIA CROMOSOMICA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R000",
    "nombre_dx": "R000-TAQUICARDIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R001",
    "nombre_dx": "R001-BRADICARDIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R002",
    "nombre_dx": "R002-PALPITACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R008",
    "nombre_dx": "R008-OTRAS ANORMALIDADES DEL LATIDO CARDIACO Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R010",
    "nombre_dx": "R010-SOPLOS CARDIACOS BENIGNOS O INOCENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R011",
    "nombre_dx": "R011-SOPLO CARDIACO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R012",
    "nombre_dx": "R012-OTROS SONIDOS CARDIACOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R02X",
    "nombre_dx": "R02X-GANGRENA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "R030",
    "nombre_dx": "R030-LECTURA ELEVADA DE LA PRESION SANGUINEA, SIN DIAGNOSTICO DE HIPERTENSION",
    "sexo": "A"
  },
  {
    "cod_dx": "R031",
    "nombre_dx": "R031-LECTURADE PRESION BAJA NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "R040",
    "nombre_dx": "R040-EPISTAXIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R041",
    "nombre_dx": "R041-HEMORRAGIA DE LA GARGANTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R042",
    "nombre_dx": "R042-HEMOPTISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "R048",
    "nombre_dx": "R048-HEMORRAGIA DE OTROS SITIOS DE LAS VIAS RESPIRATORIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R049",
    "nombre_dx": "R049-HEMORRAGIA DE LAS VIAS RESPIRATORIAS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R05X",
    "nombre_dx": "R05X-TOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R060",
    "nombre_dx": "R060-DISNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "R061",
    "nombre_dx": "R061-ESTRIDOR",
    "sexo": "A"
  },
  {
    "cod_dx": "R062",
    "nombre_dx": "R062-SILBIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R063",
    "nombre_dx": "R063-RESPIRACION PERIODICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R064",
    "nombre_dx": "R064-HIPERVENTILACION",
    "sexo": "A"
  },
  {
    "cod_dx": "R065",
    "nombre_dx": "R065-RESPIRACION CON LA BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R066",
    "nombre_dx": "R066-HIPO",
    "sexo": "A"
  },
  {
    "cod_dx": "R067",
    "nombre_dx": "R067-ESTORNUDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R068",
    "nombre_dx": "R068-OTRAS ANORMALIDADES DE LA RESPIRACION Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R070",
    "nombre_dx": "R070-DOLOR DE GARGANTA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R071",
    "nombre_dx": "R071-DOLOR EN EL PECHO AL RESPIRAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R072",
    "nombre_dx": "R072-DOLOR PRECORDIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R073",
    "nombre_dx": "R073-OTROS DOLORES EN EL PECHO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R074",
    "nombre_dx": "R074-DOLOR EN EL PECHO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R090",
    "nombre_dx": "R090-ASFIXIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R091",
    "nombre_dx": "R091-PLEURESIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R092",
    "nombre_dx": "R092-PARO RESPIRATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R093",
    "nombre_dx": "R093-ESPUTO ANORMAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R098",
    "nombre_dx": "R098-OTROS SINTOMAS Y SIGNOSESPECIFICADOS QUE INVOLUCRAN LOS SISTEMAS CIRCULATORIO Y RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "R100",
    "nombre_dx": "R100-ABDOMEN AGUDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R101",
    "nombre_dx": "R101-DOLOR ABDOMINAL LOCALIZADO EN PARTE SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "R102",
    "nombre_dx": "R102-DOLOR PELVICO Y PERINEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R103",
    "nombre_dx": "R103-DOLOR LOCALIZADO EN OTRAS PARTES INFERIORES DEL ABDOMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "R104",
    "nombre_dx": "R104-OTROS DOLORES ABDOMINALES Y LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R11X",
    "nombre_dx": "R11X-NAUSEA Y VOMITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R12X",
    "nombre_dx": "R12X-ACIDEZ",
    "sexo": "A"
  },
  {
    "cod_dx": "R13X",
    "nombre_dx": "R13X-DISFAGIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R14X",
    "nombre_dx": "R14X-FLATULENCIA Y AFECCIONES AFINES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R15X",
    "nombre_dx": "R15X-INCONTINENCIA FECAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R160",
    "nombre_dx": "R160-HEPATOMEGALIA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R161",
    "nombre_dx": "R161-ESPLENOMEGALIA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "R162",
    "nombre_dx": "R162-HEPATOMEGALIA CON ESPLENOMEGALIA,NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "R17X",
    "nombre_dx": "R17X-ICTERICIA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R18X",
    "nombre_dx": "R18X-ASCITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R190",
    "nombre_dx": "R190-TUMEFACCION, MASA O PROMINENCIA INTRAABDOMINAL Y PELVICA",
    "sexo": "A"
  },
  {
    "cod_dx": "R191",
    "nombre_dx": "R191-SONIDOS INTESTINALES ANORMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "R192",
    "nombre_dx": "R192-PERISTALSIS VISIBLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R193",
    "nombre_dx": "R193-RIGIDEZ ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R194",
    "nombre_dx": "R194-CAMBIOS EN LOS HABITOS INTESTINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R195",
    "nombre_dx": "R195-OTRAS ANORMALIDADES FECALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R196",
    "nombre_dx": "R196-HALITOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R198",
    "nombre_dx": "R198-OTROS SINTOMAS Y SIGNOSESPECIFICADOS QUE INVOLUCRAN EL SISTEMA DIGESTIVO Y EL ABDOMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "R200",
    "nombre_dx": "R200-ANESTESIA DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "R201",
    "nombre_dx": "R201-HIPOESTESIA DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "R202",
    "nombre_dx": "R202-PARESTESIA DE LA PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R203",
    "nombre_dx": "R203-HIPERESTESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R208",
    "nombre_dx": "R208-OTRAS ALTERACIONES DE LA SENSIBILIDAD CUTANEA Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R21X",
    "nombre_dx": "R21X-SALPULLIDO Y OTRAS ERUPCIONES CUTANEAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R220",
    "nombre_dx": "R220-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R221",
    "nombre_dx": "R221-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R222",
    "nombre_dx": "R222-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R223",
    "nombre_dx": "R223-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R224",
    "nombre_dx": "R224-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN EL MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R227",
    "nombre_dx": "R227-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN SITIOS MULTIPLES",
    "sexo": "A"
  },
  {
    "cod_dx": "R229",
    "nombre_dx": "R229-TUMEFACCION, MASA O PROMINENCIA LOCALIZADA EN PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R230",
    "nombre_dx": "R230-CIANOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "R231",
    "nombre_dx": "R231-PALIDEZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "R232",
    "nombre_dx": "R232-RUBOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R233",
    "nombre_dx": "R233-EQUIMOSIS ESPONTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "R234",
    "nombre_dx": "R234-CAMBIOS EN LA TEXTURA DE LA PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "R238",
    "nombre_dx": "R238-OTROS CAMBIOS DE LA PIEL Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R250",
    "nombre_dx": "R250-MOVIMIENTOS ANORMALES DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "R251",
    "nombre_dx": "R251-TEMBLOR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R252",
    "nombre_dx": "R252-CALAMBRES Y ESPASMOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R253",
    "nombre_dx": "R253-FASCICULACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "R258",
    "nombre_dx": "R258-OTROS MOVIMIENTOS ANORMALES INVOLUNTARIOS Y LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R260",
    "nombre_dx": "R260-MARCHA ATAXICA",
    "sexo": "A"
  },
  {
    "cod_dx": "R261",
    "nombre_dx": "R261-MARCHA PARALITICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R262",
    "nombre_dx": "R262-DIFICULTAD PARA CAMINAR, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R263",
    "nombre_dx": "R263-Inmovilidad",
    "sexo": "A"
  },
  {
    "cod_dx": "R268",
    "nombre_dx": "R268-OTRAS ANORMALIDADES DE LA MARCHA Y DE LA MOVILIDAD Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R270",
    "nombre_dx": "R270-ATAXIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R278",
    "nombre_dx": "R278-OTRAS FALLAS DE LA COORDINACION Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R290",
    "nombre_dx": "R290-TETANIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R291",
    "nombre_dx": "R291-MENINGISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "R292",
    "nombre_dx": "R292-REFLEJOS ANORMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "R293",
    "nombre_dx": "R293-POSTURA ANORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R294",
    "nombre_dx": "R294-CHASQUIDO DE LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "R298",
    "nombre_dx": "R298-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LOS SISTEMAS NERVIOSO Y OSTEOMUSCULAR Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R300",
    "nombre_dx": "R300-DISURIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R301",
    "nombre_dx": "R301-TENESMO VESICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R309",
    "nombre_dx": "R309-MICCION DOLOROSA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R31X",
    "nombre_dx": "R31X-HEMATURIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R32X",
    "nombre_dx": "R32X-INCONTINENCIA URINARIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R33X",
    "nombre_dx": "R33X-RETENCION DE ORINA",
    "sexo": "A"
  },
  {
    "cod_dx": "R34X",
    "nombre_dx": "R34X-ANURIA Y OLIGURIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R35X",
    "nombre_dx": "R35X-POLIURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R36X",
    "nombre_dx": "R36X-DESCARGA URETRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R390",
    "nombre_dx": "R390-EXTRAVASACION DE LA ORINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R391",
    "nombre_dx": "R391-OTRAS DIFICULTADES DE LA MICCION",
    "sexo": "A"
  },
  {
    "cod_dx": "R392",
    "nombre_dx": "R392-UREMIA EXTRARRENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R398",
    "nombre_dx": "R398-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL SISTEMA URINARIO Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R400",
    "nombre_dx": "R400-SOMNOLENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R401",
    "nombre_dx": "R401-ESTUPOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R402",
    "nombre_dx": "R402-COMA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R410",
    "nombre_dx": "R410-DESORIENTACION NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R411",
    "nombre_dx": "R411-AMNESIA ANTEROGRADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R412",
    "nombre_dx": "R412-AMNESIA RETROGRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R413",
    "nombre_dx": "R413-OTRA AMNESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R418",
    "nombre_dx": "R418-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LA FUNCION COGNOSCITIVA Y LA CONCIENCIAY LOS NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "R42X",
    "nombre_dx": "R42X-MAREO Y DESVANECIMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R430",
    "nombre_dx": "R430-ANOSMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R431",
    "nombre_dx": "R431-PAROSMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R432",
    "nombre_dx": "R432-PARAGEUSIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R438",
    "nombre_dx": "R438-OTRASALTERACIONES DEL GUSTO Y DEL OLFATO Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R440",
    "nombre_dx": "R440-ALUCINACIONES AUDITIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R441",
    "nombre_dx": "R441-ALUCINACIONES VISUALES",
    "sexo": "A"
  },
  {
    "cod_dx": "R442",
    "nombre_dx": "R442-OTRAS ALUCINACIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R443",
    "nombre_dx": "R443-ALUCINACIONES, NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R448",
    "nombre_dx": "R448-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LAS SENSACIONES Y PERCEPCIONES GENERALES Y LOS NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "R450",
    "nombre_dx": "R450-NERVIOSISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R451",
    "nombre_dx": "R451-INQUIETUD Y AGITACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "R452",
    "nombre_dx": "R452-INFELICIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "R453",
    "nombre_dx": "R453-DESMORALIZACION Y APATIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R454",
    "nombre_dx": "R454-IRRITABILIDAD Y ENOJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R455",
    "nombre_dx": "R455-HOSTILIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "R456",
    "nombre_dx": "R456-VIOLENCIA FISICA",
    "sexo": "A"
  },
  {
    "cod_dx": "R457",
    "nombre_dx": "R457-TENSION Y ESTADO DE CHOQUE EMOCIONAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R458",
    "nombre_dx": "R458-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN EL ESTADO EMOCIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R460",
    "nombre_dx": "R460-MUY BAJO NIVEL DE HIGIENE PERSONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R461",
    "nombre_dx": "R461-APARIENCIA PERSONAL EXTRAÑA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R462",
    "nombre_dx": "R462-CONDUCTA EXTRAÑA E INEXPLICABLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R463",
    "nombre_dx": "R463-HIPERACTIVIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "R464",
    "nombre_dx": "R464-LENTITUD Y POBRE RESPUESTA",
    "sexo": "A"
  },
  {
    "cod_dx": "R465",
    "nombre_dx": "R465-SUSPICACIA Y EVASIVIDAD MARCADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R466",
    "nombre_dx": "R466-PREOCUPACION INDEBIDA POR SUCESOS QUE CAUSAN TENSION",
    "sexo": "A"
  },
  {
    "cod_dx": "R467",
    "nombre_dx": "R467-VERBOSIDAD Y DETALLES CIRCUNSTANCIALES QUE OSCURECEN LA RAZON DE LA CONSULTA O EL CONTACTO",
    "sexo": "A"
  },
  {
    "cod_dx": "R468",
    "nombre_dx": "R468-OTROS SINTOMAS Y SIGNOS QUE INVOLUCRAN LA APARIENCIA Y EL COMPORTAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "R470",
    "nombre_dx": "R470-DISFASIA Y AFASIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R471",
    "nombre_dx": "R471-DISARTRIA Y ANARTRIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R478",
    "nombre_dx": "R478-OTRAS ALTERACIONES DELHABLA Y LAS NOESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R480",
    "nombre_dx": "R480-DISLEXIA Y ALEXIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R481",
    "nombre_dx": "R481-AGNOSIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R482",
    "nombre_dx": "R482-APRAXIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R488",
    "nombre_dx": "R488-OTRAS DISFUNCIONES SIMBOLICAS Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R490",
    "nombre_dx": "R490-DISFONIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R491",
    "nombre_dx": "R491-AFONIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R492",
    "nombre_dx": "R492-HIPERNASALIDAD E HIPONASALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "R498",
    "nombre_dx": "R498-OTRAS ALTERACIONES DE LA VOZ Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R500",
    "nombre_dx": "R500-FIEBRE CON ESCALOFRIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R509",
    "nombre_dx": "R509-FIEBRE, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R51X",
    "nombre_dx": "R51X-CEFALEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R520",
    "nombre_dx": "R520-DOLOR AGUDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R521",
    "nombre_dx": "R521-DOLOR CRONICO INTRATABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "R522",
    "nombre_dx": "R522-OTRO DOLOR CRONICO",
    "sexo": "A"
  },
  {
    "cod_dx": "R529",
    "nombre_dx": "R529-DOLOR, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R53X",
    "nombre_dx": "R53X-MALESTAR Y FATIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R54X",
    "nombre_dx": "R54X-SENILIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "R55X",
    "nombre_dx": "R55X-SINCOPE Y COLAPSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R560",
    "nombre_dx": "R560-CONVULSIONES FEBRILES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R568",
    "nombre_dx": "R568-OTRAS CONVULSIONESY LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R570",
    "nombre_dx": "R570-CHOQUE CARDIOGENICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R571",
    "nombre_dx": "R571-CHOQUE HIPOVOLEMICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R572",
    "nombre_dx": "R572-Choque séptico",
    "sexo": "A"
  },
  {
    "cod_dx": "R578",
    "nombre_dx": "R578-OTRAS FORMAS DE CHOQUE",
    "sexo": "A"
  },
  {
    "cod_dx": "R579",
    "nombre_dx": "R579-CHOQUE , NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R58X",
    "nombre_dx": "R58X-HEMORRAGIA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "R590",
    "nombre_dx": "R590-ADENOMEGALIALOCALIZADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R591",
    "nombre_dx": "R591-ADENOMEGALIA GENERALIZADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R599",
    "nombre_dx": "R599-ADENOMEGALIA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R600",
    "nombre_dx": "R600-EDEMALOCALIZADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R601",
    "nombre_dx": "R601-EDEMA GENERALIZADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R609",
    "nombre_dx": "R609-EDEMA, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R610",
    "nombre_dx": "R610-HIPERHIDROSISLOCALIZADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R611",
    "nombre_dx": "R611-HIPERHIDROSIS GENERALIZADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R619",
    "nombre_dx": "R619-HIPERHIDROSIS, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R620",
    "nombre_dx": "R620-RETARDO EN DESARROLLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R628",
    "nombre_dx": "R628-OTRAS FALTAS DEL DESARROLLO FISIOLOGICO NORMAL ESPERADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R629",
    "nombre_dx": "R629-FALTA DEL DESARROLLO FISIOLOGICO NORMAL ESPERADO SIN OTRA ESPECIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "R630",
    "nombre_dx": "R630-ANOREXIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R631",
    "nombre_dx": "R631-POLIDIPSIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R632",
    "nombre_dx": "R632-POLIFAGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R633",
    "nombre_dx": "R633-DIFICULTADESYMALA ADMINISTRACION DE LA ALIMENTACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "R634",
    "nombre_dx": "R634-PERDIDA ANORMAL DE PESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R635",
    "nombre_dx": "R635-AUMENTO ANORMAL DE PESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R636",
    "nombre_dx": "R636-Ingesta insuficiente de alimentos y agua debida a descuido personal",
    "sexo": "A"
  },
  {
    "cod_dx": "R638",
    "nombre_dx": "R638-OTROS SINTOMAS Y SIGNOS CONCERNIENTES A LA ALIMENTACION Y A LA INGESTION DE LIQUIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R64X",
    "nombre_dx": "R64X-CAQUEXIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R650",
    "nombre_dx": "R650-Síndrome de respuesta inflamatoria sistémica de origen infeccioso, sin falla orgánica",
    "sexo": "A"
  },
  {
    "cod_dx": "R651",
    "nombre_dx": "R651-Síndrome de respuesta inflamatoria sistémica de origen infeccioso, con falla orgánica",
    "sexo": "A"
  },
  {
    "cod_dx": "R652",
    "nombre_dx": "R652-Síndrome de respuesta inflamatoria sistémica de origen no infeccioso, sin falla orgánica",
    "sexo": "A"
  },
  {
    "cod_dx": "R653",
    "nombre_dx": "R653-Síndrome de respuesta inflamatoria sistémica de origen no infeccioso, con falla orgánica",
    "sexo": "A"
  },
  {
    "cod_dx": "R659",
    "nombre_dx": "R659-Síndrome de respuesta inflamatoria sistémica, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "R680",
    "nombre_dx": "R680-HIPOTERMIA NO ASOCIADA CON BAJA TEMPERATURA DEL AMBIENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "R681",
    "nombre_dx": "R681-SINTOMAS NO ESPECIFICOS PROPIOS DE LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R682",
    "nombre_dx": "R682-BOCA SECA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R683",
    "nombre_dx": "R683-DEDOS DE LA MANO DEFORMES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R688",
    "nombre_dx": "R688-OTROS SINTOMAS Y SIGNOS GENERALES ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R69X",
    "nombre_dx": "R69X-CAUSAS DE MORBILIDAD DESCONOCIDAS YNO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R700",
    "nombre_dx": "R700-VELOCIDAD DE ERITROSEDIMENTACION ELEVADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R701",
    "nombre_dx": "R701-VISCOSIDAD PLASMATICA ANORMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R71X",
    "nombre_dx": "R71X-ANORMALIDAD DE LOS ERITROCITOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R72X",
    "nombre_dx": "R72X-ANORMALIDADES DE LOSLEUCOCITOS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R730",
    "nombre_dx": "R730-ANORMALIDADES EN LA PRUEBA DE TOLERANCIA A LA GLUCOSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R739",
    "nombre_dx": "R739-HIPERGLICEMIA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "R740",
    "nombre_dx": "R740-ELEVACION DE LOS NIVELES DE TRANSAMINASAS O DESHIDROGENASA LACTICA [DHL]",
    "sexo": "A"
  },
  {
    "cod_dx": "R748",
    "nombre_dx": "R748-NIVELES ANORMALES DE OTRAS ENZIMAS EN SUERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R749",
    "nombre_dx": "R749-NIVEL ANORMAL DEENZIMAS EN SUERO,NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "R75X",
    "nombre_dx": "R75X-EVIDENCIAS DE LABORATORIO DELVIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH] ",
    "sexo": "A"
  },
  {
    "cod_dx": "R760",
    "nombre_dx": "R760-TITULACION ELEVADA DE ANTICUERPOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R761",
    "nombre_dx": "R761-REACCION ANORMAL A LA PRUEBA CON TUBERCULINA",
    "sexo": "A"
  },
  {
    "cod_dx": "R762",
    "nombre_dx": "R762-FALSO POSITIVO EN LA PRUEBA SEROLOGICA PARA SIFILIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R768",
    "nombre_dx": "R768-OTROS HALLAZGOS INMUNOLOGICOS ANORMALES ESPECIFICADOS EN SUERO",
    "sexo": "A"
  },
  {
    "cod_dx": "R769",
    "nombre_dx": "R769-HALLAZGOS INMUNOLOGICOS ANORMALES ESPECIFICADOS EN SUERO",
    "sexo": "A"
  },
  {
    "cod_dx": "R770",
    "nombre_dx": "R770-ANORMALIDAD DE LA ALBUMINA",
    "sexo": "A"
  },
  {
    "cod_dx": "R771",
    "nombre_dx": "R771-ANORMALIDAD DE LA GLOBULINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R772",
    "nombre_dx": "R772-ANORMALIDAD DE LA ALFAFETOPROTEINA",
    "sexo": "A"
  },
  {
    "cod_dx": "R778",
    "nombre_dx": "R778-OTRAS ANORMALIDADESESPECIFICADAS DE LAS PROTEINAS PLASMATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R779",
    "nombre_dx": "R779-ANORMALIDADES NO ESPECIFICADAS DE LAS PROTEINAS PLASMATICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R780",
    "nombre_dx": "R780-HALLAZGO DE ALCOHOL EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R781",
    "nombre_dx": "R781-HALLAZGO DE DROGAS OPIACEAS EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R782",
    "nombre_dx": "R782-HALLAZGO DE COCAINA EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R783",
    "nombre_dx": "R783-HALLAZGO DE ALUCINOGENOS EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R784",
    "nombre_dx": "R784-HALLAZGO DE OTRAS DROGAS POTENCIALMENTE ADICTIVAS EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R785",
    "nombre_dx": "R785-HALLAZGO DE DROGAS PSICOTROPICAS EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R786",
    "nombre_dx": "R786-HALLAZGO DE AGENTES ESTEROIDES EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R787",
    "nombre_dx": "R787-HALLAZGO DE NIVELES ANORMALES DE METALES PESADOS EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R788",
    "nombre_dx": "R788-HALLAZGO DE OTRAS SUSTANCIAS ESPECIFICAS QUE NORMALMENTE NO SE ENCUENTRAN EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R789",
    "nombre_dx": "R789-HALLAZGO DESUSTANCIA NO ESPECIFICA QUE NORMALMENTE NO SE ENCUENTRAN EN LA SANGRE",
    "sexo": "A"
  },
  {
    "cod_dx": "R790",
    "nombre_dx": "R790-NIVEL ANORMAL DE MINERAL EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "R798",
    "nombre_dx": "R798-OTROS HALLAZGOS ANORMALES ESPECIFICADOS EN LA QUIMICA SANGUINEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R799",
    "nombre_dx": "R799-HALLAZGO ANORMAL EN LA QUIMICA SANGUINEA, SIN OTRA ESPECIFICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "R80X",
    "nombre_dx": "R80X-PROTEINURIA AISLADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R81X",
    "nombre_dx": "R81X-GLUCOSURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R820",
    "nombre_dx": "R820-QUILURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R821",
    "nombre_dx": "R821-MIOGLOBINURIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R822",
    "nombre_dx": "R822-BILIURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R823",
    "nombre_dx": "R823-HEMOGLOBINURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R824",
    "nombre_dx": "R824-ACETONURIA",
    "sexo": "A"
  },
  {
    "cod_dx": "R825",
    "nombre_dx": "R825-ELEVACION DE LOS NIVELES DE DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS EN LA ORINA",
    "sexo": "A"
  },
  {
    "cod_dx": "R826",
    "nombre_dx": "R826-NIVELES ANORMALES EN LA ORINA DE SUSTANCIAS DE ORIGEN PRINCIPALMENTE NO MEDICINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R827",
    "nombre_dx": "R827-HALLAZGOS ANORMALES EN EL EXAMEN MICROBIOLOGICO DE LA ORINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R828",
    "nombre_dx": "R828-HALLAZGOS ANORMALES EN EL EXAMEN CITOLOGICO E HISTOLOGICO DE LA ORINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R829",
    "nombre_dx": "R829-OTROS HALLAZGOS ANORMALES EN LA ORINAY LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R830",
    "nombre_dx": "R830-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: NIVEL ANORMAL DE ENZIMAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R831",
    "nombre_dx": "R831-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: NIVEL ANORMAL DE HORMONAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R832",
    "nombre_dx": "R832-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: NIVEL ANORMAL DE OTRAS DROGAS, MEDICAMENTOS Y SUS",
    "sexo": "A"
  },
  {
    "cod_dx": "R833",
    "nombre_dx": "R833-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: NIVEL ANORMAL DE SUSTANCIAS DE ORIGEN FUNDAMENTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R834",
    "nombre_dx": "R834-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: HALLAZGOS INMUNOLOGICOS ANORMALES",
    "sexo": "A"
  },
  {
    "cod_dx": "R835",
    "nombre_dx": "R835-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: HALLAZGOS MICROBIOLOGICOS ANORMALES HALLAZGOS POS",
    "sexo": "A"
  },
  {
    "cod_dx": "R836",
    "nombre_dx": "R836-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: HALLAZGOS CITOLOGICOS ANORMALES, FROTIS ANORMAL D",
    "sexo": "A"
  },
  {
    "cod_dx": "R837",
    "nombre_dx": "R837-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: HALLAZGOS HISTOLOGICOS ANORMALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R838",
    "nombre_dx": "R838-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: OTROS HALLAZGOS ANORMALES, HALLAZGOS CROMOSOMICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R839",
    "nombre_dx": "R839-HALLAZGOS ANORMALES EN EL LIQUIDO CEFALORRAQUIDEO: HALLAZGOS ANORMALES, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R840",
    "nombre_dx": "R840-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: NIVEL ANORMAL DE ENZIM",
    "sexo": "A"
  },
  {
    "cod_dx": "R841",
    "nombre_dx": "R841-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: NIVEL ANORMAL DE HORMO",
    "sexo": "A"
  },
  {
    "cod_dx": "R842",
    "nombre_dx": "R842-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: NIVEL ANORMAL DE OTRAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R843",
    "nombre_dx": "R843-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: NIVEL ANORMAL DE SUSTA",
    "sexo": "A"
  },
  {
    "cod_dx": "R844",
    "nombre_dx": "R844-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: HALLAZGOS INMUNOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "R845",
    "nombre_dx": "R845-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: HALLAZGOS MICROBIOLOGI",
    "sexo": "A"
  },
  {
    "cod_dx": "R846",
    "nombre_dx": "R846-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: HALLAZGOS CITOLOGICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R847",
    "nombre_dx": "R847-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: HALLAZGOS HISTOLOGICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R848",
    "nombre_dx": "R848-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: OTROS HALLAZGOS ANORMA",
    "sexo": "A"
  },
  {
    "cod_dx": "R849",
    "nombre_dx": "R849-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS RESPIRATORIOS Y TORACICOS: HALLAZGOS ANORMALES, N",
    "sexo": "A"
  },
  {
    "cod_dx": "R850",
    "nombre_dx": "R850-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: NIVEL ANORM",
    "sexo": "A"
  },
  {
    "cod_dx": "R851",
    "nombre_dx": "R851-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: NIVEL ANORM",
    "sexo": "A"
  },
  {
    "cod_dx": "R852",
    "nombre_dx": "R852-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: NIVEL ANORM",
    "sexo": "A"
  },
  {
    "cod_dx": "R853",
    "nombre_dx": "R853-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: NIVEL ANORM",
    "sexo": "A"
  },
  {
    "cod_dx": "R854",
    "nombre_dx": "R854-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: HALLAZGOS I",
    "sexo": "A"
  },
  {
    "cod_dx": "R855",
    "nombre_dx": "R855-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: HALLAZGOS M",
    "sexo": "A"
  },
  {
    "cod_dx": "R856",
    "nombre_dx": "R856-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: HALLAZGOS C",
    "sexo": "A"
  },
  {
    "cod_dx": "R857",
    "nombre_dx": "R857-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: HALLAZGOS H",
    "sexo": "A"
  },
  {
    "cod_dx": "R858",
    "nombre_dx": "R858-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: OTROS HALLA",
    "sexo": "A"
  },
  {
    "cod_dx": "R859",
    "nombre_dx": "R859-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS DIGESTIVOS Y DE LA CAVIDAD ABDOMINAL: HALLAZGOS A",
    "sexo": "A"
  },
  {
    "cod_dx": "R860",
    "nombre_dx": "R860-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS: NIVEL ANORMAL DE ENZIMAS ",
    "sexo": "M"
  },
  {
    "cod_dx": "R861",
    "nombre_dx": "R861-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:NIVEL ANORMAL DE HORMONAS ",
    "sexo": "M"
  },
  {
    "cod_dx": "R862",
    "nombre_dx": "R862-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS : NIVEL ANORMAL DE OTRAS DRO",
    "sexo": "M"
  },
  {
    "cod_dx": "R863",
    "nombre_dx": "R863-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:NIVEL ANORMAL DE SUSTANCIA",
    "sexo": "M"
  },
  {
    "cod_dx": "R864",
    "nombre_dx": "R864-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:HALLAZGOS INMUNOLOGICOS AN",
    "sexo": "M"
  },
  {
    "cod_dx": "R865",
    "nombre_dx": "R865-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:HALLAZGOS MICROBIOLOGICOS ",
    "sexo": "M"
  },
  {
    "cod_dx": "R866",
    "nombre_dx": "R866-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS: HALLAZGOS CITOLOGICOS ANO",
    "sexo": "M"
  },
  {
    "cod_dx": "R867",
    "nombre_dx": "R867-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:HALLAZGOS HISTOLOGICOS ANO",
    "sexo": "M"
  },
  {
    "cod_dx": "R868",
    "nombre_dx": "R868-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:OTROS HALLAZGOS ANORMALES,",
    "sexo": "M"
  },
  {
    "cod_dx": "R869",
    "nombre_dx": "R869-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES MASCULINOS:HALLAZGOS ANORMALES, NO ES",
    "sexo": "M"
  },
  {
    "cod_dx": "R870",
    "nombre_dx": "R870-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS: NIVEL ANORMAL DE ENZIMAS",
    "sexo": "F"
  },
  {
    "cod_dx": "R871",
    "nombre_dx": "R871-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:NIVEL ANORMAL DE HORMONAS",
    "sexo": "F"
  },
  {
    "cod_dx": "R872",
    "nombre_dx": "R872-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:NIVEL ANORMAL DE OTRAS DROG",
    "sexo": "F"
  },
  {
    "cod_dx": "R873",
    "nombre_dx": "R873-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:NIVEL ANORMAL DE SUSTANCIAS",
    "sexo": "F"
  },
  {
    "cod_dx": "R874",
    "nombre_dx": "R874-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:HALLAZGOS INMUNOLOGICOS ANO",
    "sexo": "F"
  },
  {
    "cod_dx": "R875",
    "nombre_dx": "R875-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:HALLAZGOS MICROBIOLOGICOS A",
    "sexo": "F"
  },
  {
    "cod_dx": "R876",
    "nombre_dx": "R876-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:HALLAZGOS HISTOLOGICOS ANOR",
    "sexo": "F"
  },
  {
    "cod_dx": "R877",
    "nombre_dx": "R877-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS: HALLAZGOS HISTOLOGICOS ANORM",
    "sexo": "F"
  },
  {
    "cod_dx": "R878",
    "nombre_dx": "R878-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:OTROS HALLAZGOS ANORMALES, ",
    "sexo": "F"
  },
  {
    "cod_dx": "R879",
    "nombre_dx": "R879-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE ORGANOS GENITALES FEMENINOS:HALLAZGOS ANORMALES, NO ESP",
    "sexo": "F"
  },
  {
    "cod_dx": "R890",
    "nombre_dx": "R890-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: NIVEL ANORMAL DE ENZIM",
    "sexo": "A"
  },
  {
    "cod_dx": "R891",
    "nombre_dx": "R891-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: NIVEL ANORMAL DE HORMO",
    "sexo": "A"
  },
  {
    "cod_dx": "R892",
    "nombre_dx": "R892-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS:NIVEL ANORMAL DE OTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "R893",
    "nombre_dx": "R893-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: NIVEL ANORMAL DE SUSTA",
    "sexo": "A"
  },
  {
    "cod_dx": "R894",
    "nombre_dx": "R894-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: HALLAZGOS INMUNOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "R895",
    "nombre_dx": "R895-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS:HALLAZGOS MICROBIOLOG",
    "sexo": "A"
  },
  {
    "cod_dx": "R896",
    "nombre_dx": "R896-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: HALLAZGOS CITOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "R897",
    "nombre_dx": "R897-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS:HALLAZGOS HISTOLOGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "R898",
    "nombre_dx": "R898-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS: OTROS HALLAZGOS ANORMA",
    "sexo": "A"
  },
  {
    "cod_dx": "R899",
    "nombre_dx": "R899-HALLAZGOS ANORMALES EN MUESTRAS TOMADAS DE OTROS ORGANOS, SISTEMAS Y TEJIDOS:HALLAZGOS ANORMALES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "R900",
    "nombre_dx": "R900-LESION QUE OCUPA EL ESPACIO INTRACRANEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R908",
    "nombre_dx": "R908-OTROS HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN Y DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "R91X",
    "nombre_dx": "R91X-HALLAZGOS ANORMALESEN DIAGNOSTICO POR IMAGEN DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "R92X",
    "nombre_dx": "R92X-HALLAZGOS ANORMALESEN DIAGNOSTICO POR IMAGEN DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R930",
    "nombre_dx": "R930-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL CRANEO Y DE LA CABEZA, NO CLASIFICADOS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "R931",
    "nombre_dx": "R931-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL CORAZON Y DE LA CIRCULACION CORONARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R932",
    "nombre_dx": "R932-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DEL HIGADO Y DE LAS VIAS BILIARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R933",
    "nombre_dx": "R933-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS PARTES DE LAS VIAS DIGESTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R934",
    "nombre_dx": "R934-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LOS ORGANOS URINARIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "R935",
    "nombre_dx": "R935-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS REGIONES ABDOMINALES, INCLUIDO EL RETROPERITO",
    "sexo": "A"
  },
  {
    "cod_dx": "R936",
    "nombre_dx": "R936-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE LOS MIEMBROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R937",
    "nombre_dx": "R937-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS PARTES DEL SISTEMA OSTEOMUSCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "R938",
    "nombre_dx": "R938-HALLAZGOS ANORMALES EN DIAGNOSTICO POR IMAGEN DE OTRAS ESTRUCTURAS ESPECIFICADAS DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R940",
    "nombre_dx": "R940-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL SISTEMA NERVIOSO CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "R941",
    "nombre_dx": "R941-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL SISTEMA NERVIOSO PERIFERICO Y SENTIDOSESPECIALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R942",
    "nombre_dx": "R942-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "R943",
    "nombre_dx": "R943-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES CARDIOVASCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R944",
    "nombre_dx": "R944-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL RIÑON",
    "sexo": "A"
  },
  {
    "cod_dx": "R945",
    "nombre_dx": "R945-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DEL HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "R946",
    "nombre_dx": "R946-RESULTADOS ANORMALES EN ESTUDIOS FUNCIONALES DE LA TIROIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "R947",
    "nombre_dx": "R947-RESULTADOS ANORMALES EN OTROS ESTUDIOS FUNCIONALES ENDOCRINOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "R948",
    "nombre_dx": "R948-RESULTADOS ANORMALES EN LOS ESTUDIOS FUNCIONALES DE OTROS ORGANOS Y SISTEMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "R950",
    "nombre_dx": "R950-Síndrome de la muerte súbita infantil, con mención de autopsia",
    "sexo": "A"
  },
  {
    "cod_dx": "R959",
    "nombre_dx": "R959-Síndrome de la muerte súbita infantil, sin mención de autopsia",
    "sexo": "A"
  },
  {
    "cod_dx": "R960",
    "nombre_dx": "R960-MUERTE INSTANTANEA",
    "sexo": "A"
  },
  {
    "cod_dx": "R961",
    "nombre_dx": "R961-MUERTE QUE OCURRE EN MENOS DE 24 HORAS DEL INICIO DE LOS SINTOMAS, NO EXPLICADA DE OTRA FORMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R98X",
    "nombre_dx": "R98X-MUERTE SIN ASISTENCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "R99X",
    "nombre_dx": "R99X-OTRAS CAUSASMAL DEFINIDAS Y LAS NO ESPECIFICADAS DE MORTALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "S000",
    "nombre_dx": "S000-TRAUMATISMO SUPERFICIAL DEL CUERO CABELLUDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S001",
    "nombre_dx": "S001-CONTUSION DE LOS PARPADOS Y DE LA REGION PERIOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S002",
    "nombre_dx": "S002-OTROS TRAUMATISMOS SUPERFICIALES DEL PARPADO Y DE LA REGION PERIOCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S003",
    "nombre_dx": "S003-TRAUMATISMO SUPERFICIAL DE LA NARIZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "S004",
    "nombre_dx": "S004-TRAUMATISMO SUPERFICIAL DEL OIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "S005",
    "nombre_dx": "S005-TRAUMATISMO SUPERFICIAL DEL LABIO Y DE LA CAVIDAD BUCAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S007",
    "nombre_dx": "S007-TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S008",
    "nombre_dx": "S008-TRAUMATISMO SUPERFICIAL DE OTRAS PARTES DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "S009",
    "nombre_dx": "S009-TRAUMATISMO SUPERFICIAL DE LA CABEZA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S010",
    "nombre_dx": "S010-HERIDA DEL CUERO CABELLUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "S011",
    "nombre_dx": "S011-HERIDA DEL PARPADO Y DE LA REGION PERIOCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S012",
    "nombre_dx": "S012-HERIDA DE LA NARIZ",
    "sexo": "A"
  },
  {
    "cod_dx": "S013",
    "nombre_dx": "S013-HERIDA DEL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S014",
    "nombre_dx": "S014-HERIDA DE LA MEJILLA Y DE LA REGION TEMPOROMANDIBULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S015",
    "nombre_dx": "S015-HERIDA DEL LABIO Y DE LA CAVIDAD BUCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S017",
    "nombre_dx": "S017-HERIDAS MULTIPLES DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "S018",
    "nombre_dx": "S018-HERIDA DE OTRAS PARTES DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S019",
    "nombre_dx": "S019-HERIDA DE LA CABEZA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S020",
    "nombre_dx": "S020-FRACTURA DE LA BOVEDA DEL CRANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "S021",
    "nombre_dx": "S021-FRACTURA DE LA BASE DEL CRANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "S022",
    "nombre_dx": "S022-FRACTURA DE LOS HUESOS DE LA NARIZ",
    "sexo": "A"
  },
  {
    "cod_dx": "S023",
    "nombre_dx": "S023-FRACTURA DEL SUELO DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S024",
    "nombre_dx": "S024-FRACTURA DEL MALAR Y DEL HUESO MAXILAR SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S025",
    "nombre_dx": "S025-FRACTURA DE LOS DIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S026",
    "nombre_dx": "S026-FRACTURA DEL MAXILAR INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S027",
    "nombre_dx": "S027-FRACTURAS MULTIPLES QUE COMPROMETEN EL CRANEO Y LOS HUESOS DE LA CARA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S028",
    "nombre_dx": "S028-FRACTURA DE OTROS HUESOS DEL CRANEO Y DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "S029",
    "nombre_dx": "S029-FRACTURA DEL CRANEO Y DE LOS HUESOS DE LA CARA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S030",
    "nombre_dx": "S030-LUXACION DEL MAXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S031",
    "nombre_dx": "S031-LUXACION DEL CARTILAGO SEPTAL DE LA NARIZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "S032",
    "nombre_dx": "S032-LUXACION DE DIENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "S033",
    "nombre_dx": "S033-LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S034",
    "nombre_dx": "S034-ESGUINCES Y TORCEDURAS DEL MAXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S035",
    "nombre_dx": "S035-ESGUINCES Y TORCEDURAS DE ARTICULACIONES Y LIGAMENTOS DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA C",
    "sexo": "A"
  },
  {
    "cod_dx": "S040",
    "nombre_dx": "S040-TRAUMATISMO DEL NERVIO OPTICO [II PAR] Y DE LAS VIAS OPTICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "S041",
    "nombre_dx": "S041-TRAUMATISMO DEL NERVIO MOTOR OCULAR COMUN [III PAR] ",
    "sexo": "A"
  },
  {
    "cod_dx": "S042",
    "nombre_dx": "S042-TRAUMATISMO DEL NERVIO PATETICO [IV PAR]",
    "sexo": "A"
  },
  {
    "cod_dx": "S043",
    "nombre_dx": "S043-TRAUMATISMO DEL NERVIO TRIGEMINO [V PAR]",
    "sexo": "A"
  },
  {
    "cod_dx": "S044",
    "nombre_dx": "S044-TRAUMATISMO DEL NERVIO MOTOR OCULAR EXTERNO [VI PAR]",
    "sexo": "A"
  },
  {
    "cod_dx": "S045",
    "nombre_dx": "S045-TRAUMATISMO DEL NERVIO FACIAL [VII PAR] ",
    "sexo": "A"
  },
  {
    "cod_dx": "S046",
    "nombre_dx": "S046-TRAUMATISMO DEL NERVIO ACUSTICO [VIII PAR]",
    "sexo": "A"
  },
  {
    "cod_dx": "S047",
    "nombre_dx": "S047-TRAUMATISMO DEL NERVIO ESPINAL [XI PAR] ",
    "sexo": "A"
  },
  {
    "cod_dx": "S048",
    "nombre_dx": "S048-TRAUMATISMO DE OTROS NERVIOS CRANEALES",
    "sexo": "A"
  },
  {
    "cod_dx": "S049",
    "nombre_dx": "S049-TRAUMATISMO DEL NERVIOS CRANEALES, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S050",
    "nombre_dx": "S050-TRAUMATISMO DE LA CONJUNTIVA Y ABRASION CORNEAL SIN MENCION DE CUERPO EXTRAÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S051",
    "nombre_dx": "S051-CONTUSION DEL GLOBO OCULAR Y DEL TEJIDO ORBITARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S052",
    "nombre_dx": "S052-LACERACION Y RUPTURA OCULAR CON PROLAPSO O PERDIDA DEL TEJIDO INTRAOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S053",
    "nombre_dx": "S053-LACERACION OCULAR SIN PROLAPSO O PERDIDA DEL TEJIDO INTRAOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S054",
    "nombre_dx": "S054-HERIDA PENETRANTE DE LA ORBITA CON O SIN CUERPO EXTRAÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S055",
    "nombre_dx": "S055-HERIDA PENETRANTE DEL GLOBO OCULAR CON CUERPO EXTRAÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S056",
    "nombre_dx": "S056-HERIDA PENETRANTE DEL GLOBO OCULAR SIN CUERPO EXTRAÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S057",
    "nombre_dx": "S057-AVULSION DEL OJO",
    "sexo": "A"
  },
  {
    "cod_dx": "S058",
    "nombre_dx": "S058-OTROS TRAUMATISMOS DEL OJO Y DE LA ORBITA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S059",
    "nombre_dx": "S059-TRAUMATISMO DEL OJO Y DE LA ORBITA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S060",
    "nombre_dx": "S060-CONC+B3108USION ",
    "sexo": "A"
  },
  {
    "cod_dx": "S061",
    "nombre_dx": "S061-EDEMA CEREBRAL TRAUMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S062",
    "nombre_dx": "S062-TRAUMATISMO CEREBRAL DIFUSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S063",
    "nombre_dx": "S063-TRAUMATISMO CEREBRAL FOCAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S064",
    "nombre_dx": "S064-HEMORRAGIA EPIDURAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S065",
    "nombre_dx": "S065-HEMORRAGIA SUBDURAL TRAUMATICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S066",
    "nombre_dx": "S066-HEMORRAGIA SUBARACNOIDEA TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S067",
    "nombre_dx": "S067-TRAUMATISMO INTRACRANEAL CON COMA PROLONGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S068",
    "nombre_dx": "S068-OTROS TRAUMATISMOS INTRACRANEALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S069",
    "nombre_dx": "S069-TRAUMATISMO INTRACRANEAL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S070",
    "nombre_dx": "S070-TRAUMATISMO POR APLASTAMIENTO DE LA CARA",
    "sexo": "A"
  },
  {
    "cod_dx": "S071",
    "nombre_dx": "S071-TRAUMATISMO POR APLASTAMIENTO DEL CRANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "S078",
    "nombre_dx": "S078-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "S079",
    "nombre_dx": "S079-TRAUMATISMO POR APLASTAMIENTO DE LA CABEZA, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S080",
    "nombre_dx": "S080-AVULSION DEL CUERO CABELLUDO",
    "sexo": "A"
  },
  {
    "cod_dx": "S081",
    "nombre_dx": "S081-AMPUTACION TRAUMATICA DE LA OREJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S088",
    "nombre_dx": "S088-AMPUTACION TRAUMATICA DE OTRAS PARTES DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "S089",
    "nombre_dx": "S089-AMPUTACION TRAUMATICA DE PARTE NO ESPECIFICADA DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S090",
    "nombre_dx": "S090-TRAUMATISMO DE LOS VASOS SANGUINEOS DE LA CABEZA NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "S091",
    "nombre_dx": "S091-TRAUMATISMO DE TENDON Y MUSCULOS DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S092",
    "nombre_dx": "S092-RUPTURA TRAUMATICA DEL TIMPANO DEL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S097",
    "nombre_dx": "S097-TRAUMATISMOS MULTIPLES DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S098",
    "nombre_dx": "S098-OTROS TRAUMATISMOS DE LA CABEZA, ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S099",
    "nombre_dx": "S099-TRAUMATISMO DE LA CABEZA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S100",
    "nombre_dx": "S100-CONTUSION DE LA GARGANTA",
    "sexo": "A"
  },
  {
    "cod_dx": "S101",
    "nombre_dx": "S101-OTROS TRAUMATISMOS SUPERFICIALES Y LOS NO ESPECIFICADOS DE LA GARGANTA",
    "sexo": "A"
  },
  {
    "cod_dx": "S107",
    "nombre_dx": "S107-TRAUMATISMO SUPERFICIAL MULTIPLE DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S108",
    "nombre_dx": "S108-TRAUMATISMO SUPERFICIAL DE OTRAS PARTES DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S109",
    "nombre_dx": "S109-TRAUMATISMO SUPERFICIAL DEL CUELLO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S110",
    "nombre_dx": "S110-HERIDA QUE COMPROMETE LA LARINGE Y LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S111",
    "nombre_dx": "S111-HERIDA QUE COMPROMETE LA GLANDULA TIROIDES",
    "sexo": "A"
  },
  {
    "cod_dx": "S112",
    "nombre_dx": "S112-HERIDA QUE COMPROMETE LA FARINGE Y EL ESOFAGO CERVICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S117",
    "nombre_dx": "S117-HERIDAS MULTIPLES DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S118",
    "nombre_dx": "S118-HERIDAS DE OTRAS PARTES DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S119",
    "nombre_dx": "S119-HERIDA DE CUELLO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S120",
    "nombre_dx": "S120-FRACTURA DE LA PRIMERA VERTEBRA CERVICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S121",
    "nombre_dx": "S121-FRACTURA DE LA SEGUNDA VERTEBRA CERVICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S122",
    "nombre_dx": "S122-FRACTURA DE OTRAS VERTEBRAS CERVICALES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "S127",
    "nombre_dx": "S127-FRACTURAS MULTIPLES DE COLUMNA CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S128",
    "nombre_dx": "S128-FRACTURA DE OTRAS PARTES DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S129",
    "nombre_dx": "S129-FRACTURA DEL CUELLO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S130",
    "nombre_dx": "S130-RUPTURA TRAUMATICA DE DISCO CERVICAL INTERVERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S131",
    "nombre_dx": "S131-LUXACION DE VERTEBRA CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S132",
    "nombre_dx": "S132-LUXACIONES DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S133",
    "nombre_dx": "S133-LUXACIONES MULTIPLES DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S134",
    "nombre_dx": "S134-ESGUINCES Y TORCEDURAS DE LA COLUMNA CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S135",
    "nombre_dx": "S135-ESGUINCES Y TORCEDURAS DE LA REGION TIROIDEA",
    "sexo": "A"
  },
  {
    "cod_dx": "S136",
    "nombre_dx": "S136-ESGUINCES Y TORCEDURAS DE ARTICULACIONES Y LIGAMENTOS DE OTROS SITIOS ESPECIFICADOS Y DE LOS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "S140",
    "nombre_dx": "S140-CONCUSION Y EDEMA DE LA MEDULA ESPINAL CERVICAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S141",
    "nombre_dx": "S141-OTROS TRAUMATISMOS DE LA MEDULA ESPINAL CERVICAL Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S142",
    "nombre_dx": "S142-TRAUMATISMO DE RAIZ NERVIOSA DE COLUMNA CERVICAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S143",
    "nombre_dx": "S143-TRAUMATISMO DE PLEXO BRAQUIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S144",
    "nombre_dx": "S144-TRAUMATISMO DE NERVIOS PERIFERICOS DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S145",
    "nombre_dx": "S145-TRAUMATISMO DE NERVIOS CERVICALES SIMPATICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S146",
    "nombre_dx": "S146-TRAUMATISMO DE OTROS NERVIOS Y DE LOS NO ESPECIFICADOS DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S150",
    "nombre_dx": "S150-TRAUMATISMO DE LA ARTERIA CAROTIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "S151",
    "nombre_dx": "S151-TRAUMATISMO DE LA ARTERIA VERTEBRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S152",
    "nombre_dx": "S152-TRAUMATISMO DE LA VENA YUGULAR EXTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S153",
    "nombre_dx": "S153-TRAUMATISMO DE LA VENA YUGULAR INTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S157",
    "nombre_dx": "S157-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S158",
    "nombre_dx": "S158-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S159",
    "nombre_dx": "S159-TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS A NIVEL DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S16X",
    "nombre_dx": "S16X-TRAUMATISMO DE TENDON Y MUSCULOS A NIVEL DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S170",
    "nombre_dx": "S170-TRAUMATISMO POR APLASTAMIENTO DE LA LARINGE Y DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S178",
    "nombre_dx": "S178-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S179",
    "nombre_dx": "S179-TRAUMATISMO POR APLASTAMIENTO DEL CUELLO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S18X",
    "nombre_dx": "S18X-AMPUTACION TRAUMATICA A NIVEL DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S197",
    "nombre_dx": "S197-TRAUMATISMOS MULTIPLES DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S198",
    "nombre_dx": "S198-OTROS TRAUMATISMOS DEL CUELLO, ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S199",
    "nombre_dx": "S199-TRAUMATISMO DEL CUELLO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S200",
    "nombre_dx": "S200-CONTUSION DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "S201",
    "nombre_dx": "S201-OTROS TRAUMATISMOS SUPERFICIALES Y LOS NO ESPECIFICADOS DE LA MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "S202",
    "nombre_dx": "S202-CONTUSION DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S203",
    "nombre_dx": "S203-OTROS TRAUMATISMOS SUPERFICIALES DE LA PARED ANTERIOR DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S204",
    "nombre_dx": "S204-OTROS TRAUMATISMOS SUPERFICIALES DE LA PARED POSTERIOR DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S207",
    "nombre_dx": "S207-TRAUMATISMOS SUPERFICIALES MULTIPLES DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S208",
    "nombre_dx": "S208-TRAUMATISMO SUPERFICIAL DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S210",
    "nombre_dx": "S210-HERIDA DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S211",
    "nombre_dx": "S211-HERIDA DE LA PARED ANTERIOR DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S212",
    "nombre_dx": "S212-HERIDA DE LA PARED POSTERIOR DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S217",
    "nombre_dx": "S217-HERIDA MULTIPLE DE LA PARED TORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S218",
    "nombre_dx": "S218-HERIDAS DE OTRAS PARTES DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S219",
    "nombre_dx": "S219-HERIDAS DEL TORAX, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S220",
    "nombre_dx": "S220-FRACTURA DE VERTEBRA TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S221",
    "nombre_dx": "S221-FRACTURAS MULTIPLES DE COLUMNA TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S222",
    "nombre_dx": "S222-FRACTURA DE ESTERNON",
    "sexo": "A"
  },
  {
    "cod_dx": "S223",
    "nombre_dx": "S223-FRACTURA DE COSTILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "S224",
    "nombre_dx": "S224-FRACTURAS MULTIPLES DE COSTILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S225",
    "nombre_dx": "S225-TORAX AZOTADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S228",
    "nombre_dx": "S228-FRACTURA DE OTRAS PARTES DEL TORAX OSEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S229",
    "nombre_dx": "S229-FRACTURA DEL TORAX OSEO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S230",
    "nombre_dx": "S230-RUPTURA TRAUMATICA DE DISCO INTERVERTEBRAL TORACICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S231",
    "nombre_dx": "S231-LUXACION DE VERTEBRA TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S232",
    "nombre_dx": "S232-LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S233",
    "nombre_dx": "S233-ESGUINCES Y TORCEDURAS DE COLUMNA TORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S234",
    "nombre_dx": "S234-ESGUINCES Y TORCEDURAS DE COSTILLAS Y ESTERNON",
    "sexo": "A"
  },
  {
    "cod_dx": "S235",
    "nombre_dx": "S235-ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S240",
    "nombre_dx": "S240-CONCUSION Y EDEMA DE LA MEDULA ESPINAL TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S241",
    "nombre_dx": "S241-OTROS TRAUMATISMOS Y LOS NO ESPECIFICADOS DE LA MEDULA ESPINAL TORACICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S242",
    "nombre_dx": "S242-TRAUMATISMO DE RAICES NERVIOSAS DE LA COLUMNA TORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S243",
    "nombre_dx": "S243-TRAUMATISMO DE NERVIOS PERIFERICOS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S244",
    "nombre_dx": "S244-TRAUMATISMO DE NERVIOS SIMPATICOS TORACICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S245",
    "nombre_dx": "S245-TRAUMATISMO DE OTROS NERVIOS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S246",
    "nombre_dx": "S246-TRAUMATISMO DE NERVIO NO ESPECIFICADO DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S250",
    "nombre_dx": "S250-TRAUMATISMO DE LA AORTA TORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S251",
    "nombre_dx": "S251-TRAUMATISMO DE LA ARTERIA INNOMINADA O SUBCLAVIA",
    "sexo": "A"
  },
  {
    "cod_dx": "S252",
    "nombre_dx": "S252-TRAUMATISMO DE LA VENA CAVA SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "S253",
    "nombre_dx": "S253-TRAUMATISMO DE LA VENA INNOMINADA O SUBCLAVIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S254",
    "nombre_dx": "S254-TRAUMATISMO DE VASOS SANGUINEOS PULMONARES",
    "sexo": "A"
  },
  {
    "cod_dx": "S255",
    "nombre_dx": "S255-TRAUMATISMO DE VASOS SANGUINEOS INTERCOSTALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S257",
    "nombre_dx": "S257-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S258",
    "nombre_dx": "S258-TRAUMATISMO DE OTROS VASOS SANGUINEOS DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S259",
    "nombre_dx": "S259-TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S260",
    "nombre_dx": "S260-TRAUMATISMO DEL CORAZON CON HEMOPERICARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "S268",
    "nombre_dx": "S268-OTROS TRAUMATISMOS DEL CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "S269",
    "nombre_dx": "S269-TRAUMATISMOS DEL CORAZON, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S270",
    "nombre_dx": "S270-NEUMOTORAX TRAUMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S271",
    "nombre_dx": "S271-HEMOTORAX TRAUMATICO",
    "sexo": "A"
  },
  {
    "cod_dx": "S272",
    "nombre_dx": "S272-HEMONEUMOTORAX TRAUMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S273",
    "nombre_dx": "S273-OTROS TRAUMATISMOS DEL PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "S274",
    "nombre_dx": "S274-TRAUMATISMO DE LOS BRONQUIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S275",
    "nombre_dx": "S275-TRAUMATISMO DE LA TRAQUEA TORACICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S276",
    "nombre_dx": "S276-TRAUMATISMO DE LA PLEURA",
    "sexo": "A"
  },
  {
    "cod_dx": "S277",
    "nombre_dx": "S277-TRAUMATISMO DE MULTIPLES DE ORGANOS INTRATORACICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S278",
    "nombre_dx": "S278-TRAUMATISMO DE OTROS ORGANOS INTRATORACICOS, ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S279",
    "nombre_dx": "S279-TRAUMATISMO DE ORGANO INTRATORACICO, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S280",
    "nombre_dx": "S280-APLASTAMIENTO DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S281",
    "nombre_dx": "S281-AMPUTACION TRAUMATICA DE PARTE DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S290",
    "nombre_dx": "S290-TRAUMATISMO DEL TENDON Y MUSCULOS A NIVEL DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S297",
    "nombre_dx": "S297-TRAUMATISMOS MULTIPLES DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "S298",
    "nombre_dx": "S298-OTROS TRAUMATISMOS DEL TORAX, ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S299",
    "nombre_dx": "S299-TRAUMATISMO DEL TORAX, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S300",
    "nombre_dx": "S300-CONTUSION DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S301",
    "nombre_dx": "S301-CONTUSION DE LA PARED ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S302",
    "nombre_dx": "S302-CONTUSION DE LOS ORGANOS GENITALES EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S307",
    "nombre_dx": "S307-TRAUMATISMOS SUPERFICIALES MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S308",
    "nombre_dx": "S308-OTROS TRAUMATISMOS SUPERFICIALES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S309",
    "nombre_dx": "S309-TRAUMATISMO SUPERFICIAL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S310",
    "nombre_dx": "S310-HERIDA DE LA REGION LUMBOSACRA Y DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S311",
    "nombre_dx": "S311-HERIDA DE LA PARED ABDOMINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S312",
    "nombre_dx": "S312-HERIDA DEL PENE ",
    "sexo": "M"
  },
  {
    "cod_dx": "S313",
    "nombre_dx": "S313-HERIDA DEL ESCROTO Y DE LOS TESTICULOS",
    "sexo": "M"
  },
  {
    "cod_dx": "S314",
    "nombre_dx": "S314-HERIDA DE LA VAGINA Y DE LA VULVA ",
    "sexo": "F"
  },
  {
    "cod_dx": "S315",
    "nombre_dx": "S315-HERIDA DE OTROS ORGANOS GENITALES EXTERNOS Y DE LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S317",
    "nombre_dx": "S317-HERIDAS MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S318",
    "nombre_dx": "S318-HERIDAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN ",
    "sexo": "A"
  },
  {
    "cod_dx": "S320",
    "nombre_dx": "S320-FRACTURA DE VERTEBRA LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S321",
    "nombre_dx": "S321-FRACTURA DEL SACRO",
    "sexo": "A"
  },
  {
    "cod_dx": "S322",
    "nombre_dx": "S322-FRACTURA DEL COCCIX ",
    "sexo": "A"
  },
  {
    "cod_dx": "S323",
    "nombre_dx": "S323-FRACTURA DEL HUESO ILIACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S324",
    "nombre_dx": "S324-FRACTURA DEL ACETABULO",
    "sexo": "A"
  },
  {
    "cod_dx": "S325",
    "nombre_dx": "S325-FRACTURA DEL PUBIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S327",
    "nombre_dx": "S327-FRACTURAS MULTIPLES DE LA COLUMNA LUMBAR Y DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S328",
    "nombre_dx": "S328-FRACTURA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S330",
    "nombre_dx": "S330-RUPTURA TRAUMATICA DE DISCO INTERVERTEBRAL LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S331",
    "nombre_dx": "S331-LUXACION DE VERTEBRA LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S332",
    "nombre_dx": "S332-LUXACION DE ARTICULACION SACROCOCCIGEA Y SACROILIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "S333",
    "nombre_dx": "S333-LUXACION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S334",
    "nombre_dx": "S334-RUPTURA TRAUMATICA DE LA SINFISIS DEL PUBIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S335",
    "nombre_dx": "S335-ESGUINCES Y TORCEDURAS DE LA COLUMNA LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S336",
    "nombre_dx": "S336-ESGUINCES Y TORCEDURAS DE LA ARTICULACION SACROILIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S337",
    "nombre_dx": "S337-ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA COLUMNA LUMBAR Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S340",
    "nombre_dx": "S340-CONCUSION Y EDEMA DE LA MEDULA ESPINAL LUMBAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S341",
    "nombre_dx": "S341-OTRO TRAUMATISMO DE LA MEDULA ESPINAL LUMBAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S342",
    "nombre_dx": "S342-TRAUMATISMO DE RAIZ NERVIOSA DE LA COLUMNA LUMBAR Y SACRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S343",
    "nombre_dx": "S343-TRAUMATISMO DE LA COLA DE CABALLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S344",
    "nombre_dx": "S344-TRAUMATISMO DEL PLEXO LUMBOSACRO",
    "sexo": "A"
  },
  {
    "cod_dx": "S345",
    "nombre_dx": "S345-TRAUMATISMO DE NERVIO(S) SIMPATICO(S) LUMBAR(ES), SACRO(S) Y PELVICO(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S346",
    "nombre_dx": "S346-TRAUMATISMO DE NERVIO(S) PERIFERICO(S) DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S348",
    "nombre_dx": "S348-TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS Y DE LOS NO",
    "sexo": "A"
  },
  {
    "cod_dx": "S350",
    "nombre_dx": "S350-TRAUMATISMO DE LA AORTA ABDOMINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S351",
    "nombre_dx": "S351-TRAUMATISMO DE LA VENA CAVA INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "S352",
    "nombre_dx": "S352-TRAUMATISMO DE LAS ARTERIAS CELIACAS Y MESENTERICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S353",
    "nombre_dx": "S353-TRAUMATISMO DE VENAS PORTA Y ESPLENICA",
    "sexo": "A"
  },
  {
    "cod_dx": "S354",
    "nombre_dx": "S354-TRAUMATISMO DE VASOS SANGUINEOS RENALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S355",
    "nombre_dx": "S355-TRAUMATISMO DE VASOS SANGUINEOS ILIACOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S357",
    "nombre_dx": "S357-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVI",
    "sexo": "A"
  },
  {
    "cod_dx": "S358",
    "nombre_dx": "S358-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S359",
    "nombre_dx": "S359-TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S360",
    "nombre_dx": "S360-TRAUMATISMO DEL BAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S361",
    "nombre_dx": "S361-TRAUMATISMO DEL HIGADO Y DE LA VESICULA BILIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S362",
    "nombre_dx": "S362-TRAUMATISMO DEL PANCREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "S363",
    "nombre_dx": "S363-TRAUMATISMO DEL ESTOMAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "S364",
    "nombre_dx": "S364-TRAUMATISMO DEL INTESTINO DELGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S365",
    "nombre_dx": "S365-TRAUMATISMO DEL COLON ",
    "sexo": "A"
  },
  {
    "cod_dx": "S366",
    "nombre_dx": "S366-TRAUMATISMO DEL RECTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S367",
    "nombre_dx": "S367-TRAUMATISMO DE MULTIPLES ORGANOS INTRAABDOMINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S368",
    "nombre_dx": "S368-TRAUMATISMO DE OTROS ORGANOS INTRAABDOMINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S369",
    "nombre_dx": "S369-TRAUMATISMO DE ORGANO INTRAABDOMINAL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S370",
    "nombre_dx": "S370-TRAUMATISMO DEL RIÑON ",
    "sexo": "A"
  },
  {
    "cod_dx": "S371",
    "nombre_dx": "S371-TRAUMATISMO DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "S372",
    "nombre_dx": "S372-TRAUMATISMO DE LA VEJIGA",
    "sexo": "A"
  },
  {
    "cod_dx": "S373",
    "nombre_dx": "S373-TRAUMATISMO DE LA URETRA",
    "sexo": "A"
  },
  {
    "cod_dx": "S374",
    "nombre_dx": "S374-TRAUMATISMO DEL OVARIO",
    "sexo": "F"
  },
  {
    "cod_dx": "S375",
    "nombre_dx": "S375-TRAUMATISMO DE LA TROMPA DE FALOPIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "S376",
    "nombre_dx": "S376-TRAUMATISMO DEL UTERO ",
    "sexo": "F"
  },
  {
    "cod_dx": "S377",
    "nombre_dx": "S377-TRAUMATISMO DE MULTIPLES ORGANOS PELVICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S378",
    "nombre_dx": "S378-TRAUMATISMO DE OTROS ORGANOS PELVICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S379",
    "nombre_dx": "S379-TRAUMATISMO DE ORGANO PELVICO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S380",
    "nombre_dx": "S380-TRAUMATISMO POR APLASTAMIENTO DE ORGANOS GENITALES EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S381",
    "nombre_dx": "S381-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN, DE LA REGION LU",
    "sexo": "A"
  },
  {
    "cod_dx": "S382",
    "nombre_dx": "S382-AMPUTACION TRAUMATICA DE ORGANOS GENITALES EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S383",
    "nombre_dx": "S383-AMPUTACION TRAUMATICA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL ABDOMEN, REGION LUMBOSACRA Y PEL",
    "sexo": "A"
  },
  {
    "cod_dx": "S390",
    "nombre_dx": "S390-TRAUMATISMO DEL TENDON Y DE MUSCULOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S396",
    "nombre_dx": "S396-TRAUMATISMO DE ORGANO(S) INTRAABDOMINAL(ES) CON ORGANO(S) PELVICO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S397",
    "nombre_dx": "S397-OTROS TRAUMATISMOS MULTIPLES DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S398",
    "nombre_dx": "S398-OTROS TRAUMATISMOS ESPECIFICADOS DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "S399",
    "nombre_dx": "S399-TRAUMATISMO NO ESPECIFICADO DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S400",
    "nombre_dx": "S400-CONTUSION DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S407",
    "nombre_dx": "S407-TRAUMATISMOS SUPERFICIALES MULTIPLES DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S408",
    "nombre_dx": "S408-OTROS TRAUMATISMOS SUPERFICIALES DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S409",
    "nombre_dx": "S409-TRAUMATISMO SUPERFICIAL NO ESPECIFICADO DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S410",
    "nombre_dx": "S410-HERIDA DEL HOMBRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S411",
    "nombre_dx": "S411-HERIDA DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S417",
    "nombre_dx": "S417-HERIDAS MULTIPLES DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S418",
    "nombre_dx": "S418-HERIDAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S420",
    "nombre_dx": "S420-FRACTURA DE LA CLAVICULA",
    "sexo": "A"
  },
  {
    "cod_dx": "S421",
    "nombre_dx": "S421-FRACTURA DEL OMOPLATO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S422",
    "nombre_dx": "S422-FRACTURA DE LA EPIFISIS SUPERIOR DEL HUMERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S423",
    "nombre_dx": "S423-FRACTURA DE LA DIAFISIS DEL HUMERO",
    "sexo": "A"
  },
  {
    "cod_dx": "S424",
    "nombre_dx": "S424-FRACTURA DE LA EPIFISIS INFERIOR DEL HUMERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S427",
    "nombre_dx": "S427-FRACTURAS MULTIPLES DE LA CLAVICULA, DEL OMOPLATO Y DEL HUMERO",
    "sexo": "A"
  },
  {
    "cod_dx": "S428",
    "nombre_dx": "S428-FRACTURA DE OTRAS PARTES DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S429",
    "nombre_dx": "S429-FRACTURA DEL HOMBRO Y DEL BRAZO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S430",
    "nombre_dx": "S430-LUXACION DE LA ARTICULACION DEL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "S431",
    "nombre_dx": "S431-LUXACION DE LA ARTICULACION ACROMIOCLAVICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S432",
    "nombre_dx": "S432-LUXACION DE LA ARTICULACION ESTERNOCLAVICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S433",
    "nombre_dx": "S433-LUXACION DE OTRAS PARTES DE LA CINTURA ESCAPULAR Y DE LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "S434",
    "nombre_dx": "S434-ESGUINCES Y TORCEDURAS DE LA ARTICULACION DEL HOMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "S435",
    "nombre_dx": "S435-ESGUINCES Y TORCEDURAS DE LA ARTICULACION ACROMIOCLAVICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S436",
    "nombre_dx": "S436-ESGUINCES Y TORCEDURAS DE LA ARTICULACION ESTERNOCLAVICULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S437",
    "nombre_dx": "S437-ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CINTURA ESCAPULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S440",
    "nombre_dx": "S440-TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S441",
    "nombre_dx": "S441-TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S442",
    "nombre_dx": "S442-TRAUMATISMO DEL NERVIO RADIAL A NIVEL DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S443",
    "nombre_dx": "S443-TRAUMATISMO DEL NERVIO AXILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S444",
    "nombre_dx": "S444-TRAUMATISMO DEL NERVIO MUSCULOCUTANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S445",
    "nombre_dx": "S445-TRAUMATISMO DEL NERVIO SENSITIVO CUTANEO A NIVEL DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S447",
    "nombre_dx": "S447-TRAUMATISMO DEL MULTIPLES NERVIOS A NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S448",
    "nombre_dx": "S448-TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S449",
    "nombre_dx": "S449-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S450",
    "nombre_dx": "S450-TRAUMATISMO DE LA ARTERIA AXILAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S451",
    "nombre_dx": "S451-TRAUMATISMO DE LA ARTERIA BRAQUIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S452",
    "nombre_dx": "S452-TRAUMATISMO DE LA VENA AXILAR O BRAQUIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "S453",
    "nombre_dx": "S453-TRAUMATISMO DE VENAS SUPERFICIAL A NIVEL DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S457",
    "nombre_dx": "S457-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S458",
    "nombre_dx": "S458-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S459",
    "nombre_dx": "S459-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S460",
    "nombre_dx": "S460-Traumatismo del músculo(s) y tendón(es) del manguito rotatorio del hombro",
    "sexo": "A"
  },
  {
    "cod_dx": "S461",
    "nombre_dx": "S461-TRAUMATISMO DE TENDON Y MUSCULO DE LA CABEZA LARGA DEL BICEPS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S462",
    "nombre_dx": "S462-TRAUMATISMO DE TENDON Y MUSCULO DE OTRAS PARTES DEL BICEPS",
    "sexo": "A"
  },
  {
    "cod_dx": "S463",
    "nombre_dx": "S463-TRAUMATISMO DE TENDON Y MUSCULO DEL TRICEPS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S467",
    "nombre_dx": "S467-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S468",
    "nombre_dx": "S468-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S469",
    "nombre_dx": "S469-TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADO NIVEL DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S47X",
    "nombre_dx": "S47X-TRAUMATISMO POR APLASTAMIENTO DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S480",
    "nombre_dx": "S480-AMPUTACION TRAUMATICA EN LA ARTICULACION DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S481",
    "nombre_dx": "S481-AMPUTACION TRAUMATICA A NIVEL ENTRE EL HOMBRO Y EL CODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S489",
    "nombre_dx": "S489-AMPUTACION TRAUMATICA DEL HOMBRO Y DEL BRAZO, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S497",
    "nombre_dx": "S497-TRAUMATISMOS MULTIPLES DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S498",
    "nombre_dx": "S498-OTROS TRAUMATISMOS ESPECIFICADOS DEL HOMBRO Y DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S499",
    "nombre_dx": "S499-TRAUMATISMOS NO ESPECIFICADOS DEL HOMBRO Y DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S500",
    "nombre_dx": "S500-CONTUSION DEL CODO",
    "sexo": "A"
  },
  {
    "cod_dx": "S501",
    "nombre_dx": "S501-CONTUSION DE OTRAS PARTES DEL ANTEBRAZO Y DE LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S507",
    "nombre_dx": "S507-TRAUMATISMOS SUPERFICIALES MULTIPLES DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S508",
    "nombre_dx": "S508-OTROS TRAUMATISMOS SUPERFICIALES DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S509",
    "nombre_dx": "S509-TRAUMATISMO SUPERFICIAL DEL ANTEBRAZO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S510",
    "nombre_dx": "S510-HERIDA DEL CODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S517",
    "nombre_dx": "S517-HERIDAS MULTIPLES DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S518",
    "nombre_dx": "S518-HERIDAS DE OTRAS PARTES DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S519",
    "nombre_dx": "S519-HERIDAS DEL ANTEBRAZO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S520",
    "nombre_dx": "S520-FRACTURA DE LA EPIFISIS SUPERIOR DEL CUBITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S521",
    "nombre_dx": "S521-FRACTURA DE LA EPIFISIS SUPERIOR DEL RADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "S522",
    "nombre_dx": "S522-FRACTURA DE LA DIAFISIS DEL CUBITO",
    "sexo": "A"
  },
  {
    "cod_dx": "S523",
    "nombre_dx": "S523-FRACTURA DE LA DIAFISIS DEL RADIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S524",
    "nombre_dx": "S524-FRACTURA DE LA DIAFISIS DEL CUBITO Y DEL RADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "S525",
    "nombre_dx": "S525-FRACTURA DE LA EPIFISIS INFERIOR DEL RADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "S526",
    "nombre_dx": "S526-FRACTURA DE LA EPIFISIS INFERIOR DEL CUBITO Y DEL RADIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S527",
    "nombre_dx": "S527-FRACTURAS MULTIPLES DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S528",
    "nombre_dx": "S528-FRACTURA DE OTRAS PARTES DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S529",
    "nombre_dx": "S529-FRACTURA DEL ANTEBRAZO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S530",
    "nombre_dx": "S530-LUXACION DE LA CABEZA DEL RADIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S531",
    "nombre_dx": "S531-LUXACION DEL CODO, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S532",
    "nombre_dx": "S532-RUPTURA TRAUMATICA DEL LIGAMENTO LATERAL DEL RADIO",
    "sexo": "A"
  },
  {
    "cod_dx": "S533",
    "nombre_dx": "S533-RUPTURA TRAUMATICA DEL LIGAMENTO LATERAL DEL CUBITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S534",
    "nombre_dx": "S534-ESGUINCES Y TORCEDURAS DEL CODO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S540",
    "nombre_dx": "S540-TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S541",
    "nombre_dx": "S541-TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S542",
    "nombre_dx": "S542-TRAUMATISMO DEL NERVIO RADIAL A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S543",
    "nombre_dx": "S543-TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S547",
    "nombre_dx": "S547-TRAUMATISMO DEL MULTIPLES NERVIOS A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S548",
    "nombre_dx": "S548-TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S549",
    "nombre_dx": "S549-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S550",
    "nombre_dx": "S550-TRAUMATISMO DE LA ARTERIA CUBITAL A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S551",
    "nombre_dx": "S551-TRAUMATISMO DE LA ARTERIA RADIAL A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S552",
    "nombre_dx": "S552-TRAUMATISMO DE VENA A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S557",
    "nombre_dx": "S557-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S558",
    "nombre_dx": "S558-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S559",
    "nombre_dx": "S559-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S560",
    "nombre_dx": "S560-TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DEL PULGAR A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S561",
    "nombre_dx": "S561-TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DE OTRO(S) DEDO(S) A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S562",
    "nombre_dx": "S562-TRAUMATISMO DEL OTRO TENDON Y MUSCULO FLEXOR A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S563",
    "nombre_dx": "S563-TRAUMATISMO DE TENDONES Y MUSCULOS ABDUCTORES Y EXTENSORES DEL PULGAR A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S564",
    "nombre_dx": "S564-TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DE OTRO(S) DEDO(S) A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S565",
    "nombre_dx": "S565-TRAUMATISMO DE OTRO TENDON Y MUSCULO EXTENSOR A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S567",
    "nombre_dx": "S567-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S568",
    "nombre_dx": "S568-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS Y DE LOS NO ESPECIFICADOS, A NIVEL DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S570",
    "nombre_dx": "S570-TRAUMATISMO POR APLASTAMIENTO DEL CODO",
    "sexo": "A"
  },
  {
    "cod_dx": "S578",
    "nombre_dx": "S578-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S579",
    "nombre_dx": "S579-TRAUMATISMO POR APLASTAMIENTO DEL ANTEBRAZO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S580",
    "nombre_dx": "S580-AMPUTACION TRAUMATICA A NIVEL DEL CODO",
    "sexo": "A"
  },
  {
    "cod_dx": "S581",
    "nombre_dx": "S581-AMPUTACION TRAUMATICA A NIVEL ENTRE EL CODO Y LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S589",
    "nombre_dx": "S589-AMPUTACION TRAUMATICA DEL ANTEBRAZO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S597",
    "nombre_dx": "S597-TRAUMATISMOS MULTIPLES DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S598",
    "nombre_dx": "S598-OTROS TRAUMATISMOS ESPECIFICADOS DEL ANTEBRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "S599",
    "nombre_dx": "S599-TRAUMATISMOS NO ESPECIFICADOS DEL ANTEBRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S600",
    "nombre_dx": "S600-CONTUSION DE DEDO(S) DE LA MANO, SIN DAÑO DE LA(S) UÑA(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S601",
    "nombre_dx": "S601-CONTUSION DE DEDO(S) DE LA MANO, CON DAÑO DE LA(S) UÑA(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S602",
    "nombre_dx": "S602-CONTUSION DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S607",
    "nombre_dx": "S607-TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S608",
    "nombre_dx": "S608-OTROS TRAUMATISMOS SUPERFICIALES DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S609",
    "nombre_dx": "S609-TRAUMATISMO SUPERFICIAL DE LA MUÑECA Y DE LA MANO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S610",
    "nombre_dx": "S610-HERIDA DE DEDO(S) DE LA MANO, SIN DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S611",
    "nombre_dx": "S611-HERIDA DE DEDO(S) DE LA MANO, CON DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S617",
    "nombre_dx": "S617-HERIDAS MULTIPLES DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S618",
    "nombre_dx": "S618-HERIDAS DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S619",
    "nombre_dx": "S619-HERIDA DE LA MUÑECA Y DE LA MANO, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S620",
    "nombre_dx": "S620-FRACTURA DEL HUESO ESCAFOIDES [NAVICULAR] DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S621",
    "nombre_dx": "S621-FRACTURA DE OTRO(S) HUESO(S) DEL CARPO",
    "sexo": "A"
  },
  {
    "cod_dx": "S622",
    "nombre_dx": "S622-FRACTURA DEL PRIMER METACARPIANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S623",
    "nombre_dx": "S623-FRACTURA DE OTROS HUESOS METACARPIANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S624",
    "nombre_dx": "S624-FRACTURAS MULTIPLES DE HUESOS METACARPIANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S625",
    "nombre_dx": "S625-FRACTURA DEL PULGAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S626",
    "nombre_dx": "S626-FRACTURA DE OTRO DEDO DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S627",
    "nombre_dx": "S627-FRACTURAS MULTIPLES DE LOS DEDOS DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S628",
    "nombre_dx": "S628-FRACTURA DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S630",
    "nombre_dx": "S630-LUXACION DE LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S631",
    "nombre_dx": "S631-LUXACION DE DEDOS DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S632",
    "nombre_dx": "S632-LUXACIONES MULTIPLES DE DEDOS DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S633",
    "nombre_dx": "S633-RUPTURA TRAUMATICA DE LIGAMENTOS DE LA MUÑECA Y DEL CARPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S634",
    "nombre_dx": "S634-RUPTURA TRAUMATICA DE LIGAMENTOS DEL DEDO DE LA MANO EN LA(S) ARTICULACION(ES) METACARPOFALANGICA E ",
    "sexo": "A"
  },
  {
    "cod_dx": "S635",
    "nombre_dx": "S635-ESGUINCES Y TORCEDURAS DE LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S636",
    "nombre_dx": "S636-ESGUINCES Y TORCEDURAS DE DEDO(S) DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S637",
    "nombre_dx": "S637-ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S640",
    "nombre_dx": "S640-TRAUMATISMO DEL NERVIO CUBITAL A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S641",
    "nombre_dx": "S641-TRAUMATISMO DEL NERVIO MEDIANO A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S642",
    "nombre_dx": "S642-TRAUMATISMO DEL NERVIO RADIAL A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S643",
    "nombre_dx": "S643-TRAUMATISMO DEL NERVIO DIGITAL DEL PULGAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S644",
    "nombre_dx": "S644-TRAUMATISMO DEL NERVIO DIGITAL DE OTRO DEDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S647",
    "nombre_dx": "S647-TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S648",
    "nombre_dx": "S648-TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S649",
    "nombre_dx": "S649-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S650",
    "nombre_dx": "S650-TRAUMATISMO DE LA ARTERIA CUBITAL A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S651",
    "nombre_dx": "S651-TRAUMATISMO DE LA ARTERIA RADIAL A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S652",
    "nombre_dx": "S652-TRAUMATISMO DEL ARCO PALMAR SUPERFICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S653",
    "nombre_dx": "S653-TRAUMATISMO DEL ARCO PALMAR PROFUNDO",
    "sexo": "A"
  },
  {
    "cod_dx": "S654",
    "nombre_dx": "S654-TRAUMATISMO DE VASO(S) SANGUINEO(S) DEL PULGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "S655",
    "nombre_dx": "S655-TRAUMATISMO DE VASO(S) SANGUINEO(S) DE OTRO DEDO",
    "sexo": "A"
  },
  {
    "cod_dx": "S657",
    "nombre_dx": "S657-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S658",
    "nombre_dx": "S658-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S659",
    "nombre_dx": "S659-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S660",
    "nombre_dx": "S660-TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR LARGO DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S661",
    "nombre_dx": "S661-TRAUMATISMO DEL TENDON Y MUSCULO FLEXOR DE OTRO DEDO A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S662",
    "nombre_dx": "S662-TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S663",
    "nombre_dx": "S663-TRAUMATISMO DEL TENDON Y MUSCULO EXTENSOR DE OTRO(S) DEDO(S) A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S664",
    "nombre_dx": "S664-TRAUMATISMO DEL MUSCULO Y TENDON INTRINSECO DEL PULGAR A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S665",
    "nombre_dx": "S665-TRAUMATISMO DEL MUSCULO Y TENDON INTRINSECO DE OTRO(S) DEDO(S) A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S666",
    "nombre_dx": "S666-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS FLEXORES A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S667",
    "nombre_dx": "S667-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS EXTENSORES A NIVEL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S668",
    "nombre_dx": "S668-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S669",
    "nombre_dx": "S669-TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADO, A NIVEL DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S670",
    "nombre_dx": "S670-TRAUMATISMO POR APLASTAMIENTO DEL PULGAR Y OTRO(S) DEDO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S678",
    "nombre_dx": "S678-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S680",
    "nombre_dx": "S680-AMPUTACION TRAUMATICA DEL PULGAR (COMPLETA) (PARCIAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S681",
    "nombre_dx": "S681-AMPUTACION TRAUMATICA DE OTRO DEDO UNICO (COMPLETA) (PARCIAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S682",
    "nombre_dx": "S682-AMPUTACION TRAUMATICA DE DOS O MAS DEDOS SOLAMENTE (COMPLETA) (PARCIAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S683",
    "nombre_dx": "S683-AMPUTACION TRAUMATICA COMBINADA (DE PARTE) DE DEDO(S) CON OTRAS PARTES DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S684",
    "nombre_dx": "S684-AMPUTACION TRAUMATICA DE LA MANO A NIVEL DE LA MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S688",
    "nombre_dx": "S688-AMPUTACION TRAUMATICA DE OTRAS PARTES DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S689",
    "nombre_dx": "S689-AMPUTACION TRAUMATICA DE LA MUÑECA Y DE LA MANO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S697",
    "nombre_dx": "S697-TRAUMATISMOS MULTIPLES DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S698",
    "nombre_dx": "S698-OTROS TRAUMATISMOS ESPECIFICADOS DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "S699",
    "nombre_dx": "S699-TRAUMATISMO NO ESPECIFICADO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S700",
    "nombre_dx": "S700-CONTUSION DE LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "S701",
    "nombre_dx": "S701-CONTUSION DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S707",
    "nombre_dx": "S707-TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S708",
    "nombre_dx": "S708-OTROS TRAUMATISMOS SUPERFICIALES DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S709",
    "nombre_dx": "S709-TRAUMATISMO SUPERFICIAL DE LA CADERA Y DEL MUSLO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S710",
    "nombre_dx": "S710-HERIDA DE LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S711",
    "nombre_dx": "S711-HERIDA DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S717",
    "nombre_dx": "S717-HERIDAS MULTIPLES DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S718",
    "nombre_dx": "S718-HERIDAS DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA CINTURA PELVICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S720",
    "nombre_dx": "S720-FRACTURA DEL CUELLO DEL FEMUR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S721",
    "nombre_dx": "S721-FRACTURA PERTROCANTERIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S722",
    "nombre_dx": "S722-FRACTURA SUBTROCANTERIANA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S723",
    "nombre_dx": "S723-FRACTURA DE LA DIAFISIS DEL FEMUR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S724",
    "nombre_dx": "S724-FRACTURA DE LA EPIFISIS INFERIOR DEL FEMUR",
    "sexo": "A"
  },
  {
    "cod_dx": "S727",
    "nombre_dx": "S727-FRACTURAS MULTIPLES DEL FEMUR ",
    "sexo": "A"
  },
  {
    "cod_dx": "S728",
    "nombre_dx": "S728-FRACTURA DE OTRAS PARTES DEL FEMUR",
    "sexo": "A"
  },
  {
    "cod_dx": "S729",
    "nombre_dx": "S729-FRACTURA DEL FEMUR, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S730",
    "nombre_dx": "S730-LUXACION DE CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "S731",
    "nombre_dx": "S731-ESGUINCES Y TORCEDURAS DE LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S740",
    "nombre_dx": "S740-TRAUMATISMO DEL NERVIO CIATICO A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S741",
    "nombre_dx": "S741-TRAUMATISMO DEL NERVIO FEMOROCUTANEO A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S742",
    "nombre_dx": "S742-TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S747",
    "nombre_dx": "S747-TRAUMATISMO DE NERVIOS MULTIPLES A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S748",
    "nombre_dx": "S748-TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S749",
    "nombre_dx": "S749-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S750",
    "nombre_dx": "S750-TRAUMATISMO DE LA ARTERIA FEMORAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "S751",
    "nombre_dx": "S751-TRAUMATISMO DE LA VENA FEMORAL A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S752",
    "nombre_dx": "S752-TRAUMATISMO DE LA GRAN VENA SAFENA A NIVEL DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S757",
    "nombre_dx": "S757-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S758",
    "nombre_dx": "S758-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S759",
    "nombre_dx": "S759-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S760",
    "nombre_dx": "S760-TRAUMATISMO DEL TENDON Y MUSCULO DE LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S761",
    "nombre_dx": "S761-TRAUMATISMO DEL TENDON Y MUSCULO CUADRICEPS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S762",
    "nombre_dx": "S762-TRAUMATISMO DEL TENDON Y MUSCULO ADUCTOR MAYOR DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S763",
    "nombre_dx": "S763-TRAUMATISMO DEL TENDON Y MUSCULO DEL GRUPO MUSCULAR POSTERIOR A NIVEL DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S764",
    "nombre_dx": "S764-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS Y LOS NO ESPECIFICADOS A NIVEL DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S767",
    "nombre_dx": "S767-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS Y LOS NO ESPECIFICADOS A NIVEL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S770",
    "nombre_dx": "S770-TRAUMATISMO POR APLASTAMIENTO DE LA CADERA",
    "sexo": "A"
  },
  {
    "cod_dx": "S771",
    "nombre_dx": "S771-TRAUMATISMO POR APLASTAMIENTO DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S772",
    "nombre_dx": "S772-TRAUMATISMO POR APLASTAMIENTO DE LA CADERA CON EL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S780",
    "nombre_dx": "S780-AMPUTACION TRAUMATICA DE LA ARTICULACION DE LA CADERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S781",
    "nombre_dx": "S781-AMPUTACION TRAUMATICA EN ALGUN NIVEL ENTRE LA CADERA Y LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S789",
    "nombre_dx": "S789-AMPUTACION TRAUMATICA DE CADERA Y MUSLO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S797",
    "nombre_dx": "S797-TRAUMATISMOS MULTIPLES DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S798",
    "nombre_dx": "S798-OTROS TRAUMATISMOS ESPECIFICADOS DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S799",
    "nombre_dx": "S799-TRAUMATISMO NO ESPECIFICADO DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S800",
    "nombre_dx": "S800-CONTUSION DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S801",
    "nombre_dx": "S801-CONTUSION DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S807",
    "nombre_dx": "S807-TRAUMATISMOS SUPERFICIALES MULTIPLES DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S808",
    "nombre_dx": "S808-OTROS TRAUMATISMOS SUPERFICIALES DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S809",
    "nombre_dx": "S809-TRAUMATISMO SUPERFICIAL DE LA PIERNA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S810",
    "nombre_dx": "S810-HERIDA DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "S817",
    "nombre_dx": "S817-HERIDAS MULTIPLES DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S818",
    "nombre_dx": "S818-HERIDA DE OTRAS PARTES DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S819",
    "nombre_dx": "S819-HERIDA DE LA PIERNA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S820",
    "nombre_dx": "S820-FRACTURA DE LA ROTULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S821",
    "nombre_dx": "S821-FRACTURA DE LA EPIFISIS SUPERIOR DE LA TIBIA",
    "sexo": "A"
  },
  {
    "cod_dx": "S822",
    "nombre_dx": "S822-FRACTURA DE LA DIAFISIS DE LA TIBIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S823",
    "nombre_dx": "S823-FRACTURA DE LA EPIFISIS INFERIOR DE LA TIBIA",
    "sexo": "A"
  },
  {
    "cod_dx": "S824",
    "nombre_dx": "S824-FRACTURA DEL PERONE SOLAMENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S825",
    "nombre_dx": "S825-FRACTURA DEL MALEOLO INTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "S826",
    "nombre_dx": "S826-FRACTURA DEL MALEOLO EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "S827",
    "nombre_dx": "S827-FRACTURAS MULTIPLES DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S828",
    "nombre_dx": "S828-FRACTURA DE OTRAS PARTES DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S829",
    "nombre_dx": "S829-FRACTURA DE LA PIERNA, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "S830",
    "nombre_dx": "S830-LUXACION DE LA ROTULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S831",
    "nombre_dx": "S831-LUXACION DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "S832",
    "nombre_dx": "S832-DESGARRO DE MENISCOS, PRESENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "S833",
    "nombre_dx": "S833-DESGARRO DEL CARTILAGO ARTICULAR DE LA RODILLA, PRESENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "S834",
    "nombre_dx": "S834-ESGUINCES Y TORCEDURAS QUE COMPROMETEN LOS LIGAMENTOS LATERALES (EXTERNO) (INTERNO) DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S835",
    "nombre_dx": "S835-ESGUINCES Y TORCEDURAS QUE COMPROMETEN EL LIGAMENTO CRUZADO (ANTERIOR) (POSTERIOR) DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "S836",
    "nombre_dx": "S836-ESGUINCES Y TORCEDURAS DE OTRAS PARTES Y LAS NO ESPECIFICADAS DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S837",
    "nombre_dx": "S837-TRAUMATISMO DE ESTRUCTURAS MULTIPLES DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "S840",
    "nombre_dx": "S840-TRAUMATISMO DEL NERVIO TIBIAL A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S841",
    "nombre_dx": "S841-TRAUMATISMO DEL NERVIO PERONEO A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S842",
    "nombre_dx": "S842-TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S847",
    "nombre_dx": "S847-TRAUMATISMO DE NERVIOS MULTIPLES A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S848",
    "nombre_dx": "S848-TRAUMATISMO DE OTROS NERVIOS A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S849",
    "nombre_dx": "S849-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S850",
    "nombre_dx": "S850-TRAUMATISMO DE LA ARTERIA POPLITEA",
    "sexo": "A"
  },
  {
    "cod_dx": "S851",
    "nombre_dx": "S851-TRAUMATISMO DE LA ARTERIA TIBIAL (ANTERIOR) (POSTERIOR) ",
    "sexo": "A"
  },
  {
    "cod_dx": "S852",
    "nombre_dx": "S852-TRAUMATISMO DE LA ARTERIA PERONEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S853",
    "nombre_dx": "S853-TRAUMATISMO DE LA GRAN VENA SAFENA A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S854",
    "nombre_dx": "S854-TRAUMATISMO DE LA VENA SAFENA EXTERNA NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S855",
    "nombre_dx": "S855-TRAUMATISMO DE LA VENA POPLITEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S857",
    "nombre_dx": "S857-TRAUMATISMO DE VASOS SANGUINEOS MULTIPLES A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S858",
    "nombre_dx": "S858-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S859",
    "nombre_dx": "S859-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S860",
    "nombre_dx": "S860-TRAUMATISMO DEL TENDON DE AQUILES ",
    "sexo": "A"
  },
  {
    "cod_dx": "S861",
    "nombre_dx": "S861-TRAUMATISMO DE OTRO TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR POSTERIOR A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S862",
    "nombre_dx": "S862-TRAUMATISMO DEL TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR ANTERIOR A NIVEL DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S863",
    "nombre_dx": "S863-TRAUMATISMO DEL TENDON(ES) Y MUSCULO(S) DEL GRUPO MUSCULAR PERONEO A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S867",
    "nombre_dx": "S867-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S868",
    "nombre_dx": "S868-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S869",
    "nombre_dx": "S869-TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADOS A NIVEL DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S870",
    "nombre_dx": "S870-TRAUMATISMO POR APLASTAMIENTO DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S878",
    "nombre_dx": "S878-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "S880",
    "nombre_dx": "S880-AMPUTACION TRAUMATICA A NIVEL DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S881",
    "nombre_dx": "S881-AMPUTACION TRAUMATICA EN ALGUN NIVEL ENTRE LA RODILLA Y EL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S889",
    "nombre_dx": "S889-AMPUTACION TRAUMATICA DE LA PIERNA, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S897",
    "nombre_dx": "S897-TRAUMATISMOS MULTIPLES DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S898",
    "nombre_dx": "S898-OTROS TRAUMATISMOS DE LA PIERNA, ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "S899",
    "nombre_dx": "S899-TRAUMATISMO DE LA PIERNA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S900",
    "nombre_dx": "S900-CONTUSION DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S901",
    "nombre_dx": "S901-CONTUSION DE DEDO(S) DEL PIE, SIN DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S902",
    "nombre_dx": "S902-CONTUSION DE DEDO(S) DEL PIE, CON DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S903",
    "nombre_dx": "S903-CONTUSION DE OTRAS PARTES Y DE LAS NO ESPECIFICADAS DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S907",
    "nombre_dx": "S907-TRAUMATISMOS SUPERFICIALES MULTIPLES DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S908",
    "nombre_dx": "S908-OTROS TRAUMATISMOS SUPERFICIALES DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S909",
    "nombre_dx": "S909-TRAUMATISMO SUPERFICIAL DEL PIE Y DEL TOBILLO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "S910",
    "nombre_dx": "S910-HERIDA DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S911",
    "nombre_dx": "S911-HERIDA DE DEDO(S) DEL PIE SIN DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S912",
    "nombre_dx": "S912-HERIDA DE DEDO(S) DEL PIE CON DAÑO DE LA(S) UÑA(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "S913",
    "nombre_dx": "S913-HERIDAS DE OTRAS PARTES DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S917",
    "nombre_dx": "S917-HERIDAS MULTIPLES DEL TOBILLO Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S920",
    "nombre_dx": "S920-FRACTURA DEL CALCANEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S921",
    "nombre_dx": "S921-FRACTURA DEL ASTRAGALO",
    "sexo": "A"
  },
  {
    "cod_dx": "S922",
    "nombre_dx": "S922-FRACTURA DE OTRO(S) HUESO(S) DEL TARSO",
    "sexo": "A"
  },
  {
    "cod_dx": "S923",
    "nombre_dx": "S923-FRACTURA DE HUESO DEL METATARSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S924",
    "nombre_dx": "S924-FRACTURA DE LOS HUESOS DEL DEDO GORDO DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S925",
    "nombre_dx": "S925-FRACTURA DE LOS HUESOS DE OTRO(S) DEDO(S) DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S927",
    "nombre_dx": "S927-FRACTURAS MULTIPLES DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S929",
    "nombre_dx": "S929-FRACTURA DEL PIE, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "S930",
    "nombre_dx": "S930-LUXACION DE LA ARTICULACION DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S931",
    "nombre_dx": "S931-LUXACION DE DEDO(S) DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S932",
    "nombre_dx": "S932-RUPTURA DE LIGAMENTOS A NIVEL DEL TOBILLO Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S933",
    "nombre_dx": "S933-LUXACION DE OTROS SITIOS Y LOS NO ESPECIFICADOS DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S934",
    "nombre_dx": "S934-ESGUINCES Y TORCEDURAS DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S935",
    "nombre_dx": "S935-ESGUINCES Y TORCEDURAS DE DEDO(S) DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S936",
    "nombre_dx": "S936-ESGUINCES Y TORCEDURAS DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "S940",
    "nombre_dx": "S940-TRAUMATISMO DEL NERVIO PLANTAR EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "S941",
    "nombre_dx": "S941-TRAUMATISMO DEL NERVIO PLANTAR INTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "S942",
    "nombre_dx": "S942-TRAUMATISMO DEL NERVIO PERONEAL PROFUNDO A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S943",
    "nombre_dx": "S943-TRAUMATISMO DEL NERVIO SENSORIAL CUTANEO A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S947",
    "nombre_dx": "S947-TRAUMATISMO DE MULTIPLES NERVIOS A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S948",
    "nombre_dx": "S948-TRAUMATISMO DE OTROS NERVIOS A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S949",
    "nombre_dx": "S949-TRAUMATISMO DE NERVIO NO ESPECIFICADO A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S950",
    "nombre_dx": "S950-TRAUMATISMO DE LA ARTERIA DORSAL DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "S951",
    "nombre_dx": "S951-TRAUMATISMO DE LA ARTERIA PLANTAR DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S952",
    "nombre_dx": "S952-TRAUMATISMO DE LA VENA DORSAL DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S957",
    "nombre_dx": "S957-TRAUMATISMO DE MULTIPLES VASOS SANGUINEOS A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S958",
    "nombre_dx": "S958-TRAUMATISMO DE OTROS VASOS SANGUINEOS A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S959",
    "nombre_dx": "S959-TRAUMATISMO DE VASO SANGUINEO NO ESPECIFICADO A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S960",
    "nombre_dx": "S960-TRAUMATISMO DEL TENDON Y MUSCULO DEL FLEXOR LARGO DELDEDO A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S961",
    "nombre_dx": "S961-TRAUMATISMO DEL TENDON Y MUSCULO DEL EXTENSOR LARGO DEL (DE LOS) DEDO(S) A NIVEL DEL PIE Y DEL TOBIL",
    "sexo": "A"
  },
  {
    "cod_dx": "S962",
    "nombre_dx": "S962-TRAUMATISMO DE TENDONES Y MUSCULOS INTRINSECOS A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S967",
    "nombre_dx": "S967-TRAUMATISMO DE MULTIPLES TENDONES Y MUSCULOS A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S968",
    "nombre_dx": "S968-TRAUMATISMO DE OTROS TENDONES Y MUSCULOS A NIVEL DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S969",
    "nombre_dx": "S969-TRAUMATISMO DE TENDONES Y MUSCULOS NO ESPECIFICADOS A NIVEL DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S970",
    "nombre_dx": "S970-TRAUMATISMO POR APLASTAMIENTO DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S971",
    "nombre_dx": "S971-TRAUMATISMO POR APLASTAMIENTO DE DEDO(S) DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "S978",
    "nombre_dx": "S978-TRAUMATISMO POR APLASTAMIENTO DE OTRAS PARTES DEL PIE Y DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S980",
    "nombre_dx": "S980-AMPUTACION TRAUMATICA DEL PIE A NIVEL DEL TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S981",
    "nombre_dx": "S981-AMPUTACION TRAUMATICA DE UN DEDO DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "S982",
    "nombre_dx": "S982-AMPUTACION TRAUMATICA DE DOS O MAS DEDOS DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "S983",
    "nombre_dx": "S983-AMPUTACION TRAUMATICA DE OTRAS PARTES DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "S984",
    "nombre_dx": "S984-AMPUTACION DEL PIE, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "S997",
    "nombre_dx": "S997-TRAUMATISMOS MULTIPLES DEL PIE Y DEL TOBILLO",
    "sexo": "A"
  },
  {
    "cod_dx": "S998",
    "nombre_dx": "S998-OTROS TRAUMATISMOS DEL PIE Y DEL TOBILLO, ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "S999",
    "nombre_dx": "S999-TRAUMATISMO DEL PIE Y DEL TOBILLO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T000",
    "nombre_dx": "T000-TRAUMATISMOS SUPERFICIALES QUE AFECTAN LA CABEZA CON EL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T001",
    "nombre_dx": "T001-TRAUMATISMOS SUPERFICIALES QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T002",
    "nombre_dx": "T002-TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL(OS) MIEMBRO(S) SUPERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T003",
    "nombre_dx": "T003-TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL(OS) MIEMBRO(S) INFERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T006",
    "nombre_dx": "T006-TRAUMATISMOS SUPERFICIALES QUE AFECTAN MULTIPLES REGIONES DEL(OS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBR",
    "sexo": "A"
  },
  {
    "cod_dx": "T008",
    "nombre_dx": "T008-TRAUMATISMOS SUPERFICIALES QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T009",
    "nombre_dx": "T009-TRAUMATISMOS SUPERFICIALES MULTIPLES, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T010",
    "nombre_dx": "T010-HERIDAS QUE AFECTAN LA CABEZA CON EL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T011",
    "nombre_dx": "T011-HERIDAS QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T012",
    "nombre_dx": "T012-HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES)",
    "sexo": "A"
  },
  {
    "cod_dx": "T013",
    "nombre_dx": "T013-HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) INFERIOR(ES)",
    "sexo": "A"
  },
  {
    "cod_dx": "T016",
    "nombre_dx": "T016-HERIDAS QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(E",
    "sexo": "A"
  },
  {
    "cod_dx": "T018",
    "nombre_dx": "T018-HERIDAS QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T019",
    "nombre_dx": "T019-HERIDAS MULTIPLES, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T020",
    "nombre_dx": "T020-FRACTURAS QUE AFECTAN LA CABEZA CON EL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T021",
    "nombre_dx": "T021-FRACTURAS QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T022",
    "nombre_dx": "T022-FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE UN MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T023",
    "nombre_dx": "T023-FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE UN MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T024",
    "nombre_dx": "T024-FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE AMBOS MIEMBROS SUPERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T025",
    "nombre_dx": "T025-FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE AMBOS MIEMBROS INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T026",
    "nombre_dx": "T026-FRACTURAS QUE AFECTAN MULTIPLES REGIONES DE MIEMBRO(S) SUPERIOR(ES) CON MIEMBRO(S) INFERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T027",
    "nombre_dx": "T027-FRACTURAS QUE AFECTAN EL TORAX CON LA REGION LUMBOSACRA Y LA PELVIS CON MIEMBRO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "T028",
    "nombre_dx": "T028-FRACTURAS QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T029",
    "nombre_dx": "T029-FRACTURAS MULTIPLES, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T030",
    "nombre_dx": "T030-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN LA CABEZA CON EL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T031",
    "nombre_dx": "T031-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN EL TORAX CON LA REGION LUMBOSACRA Y LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T032",
    "nombre_dx": "T032-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES",
    "sexo": "A"
  },
  {
    "cod_dx": "T033",
    "nombre_dx": "T033-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) INFERIOR(ES",
    "sexo": "A"
  },
  {
    "cod_dx": "T034",
    "nombre_dx": "T034-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES",
    "sexo": "A"
  },
  {
    "cod_dx": "T038",
    "nombre_dx": "T038-LUXACIONES, TORCEDURAS Y ESGUINCES QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T039",
    "nombre_dx": "T039-LUXACIONES, TORCEDURAS Y ESGUINCES MULTIPLES, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T040",
    "nombre_dx": "T040-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN LA CABEZA CON EL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T041",
    "nombre_dx": "T041-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN EL TORAX CON EL ABDOMEN, LA REGION LUMBOSACRA Y LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T042",
    "nombre_dx": "T042-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T043",
    "nombre_dx": "T043-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) INFERIOR(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T044",
    "nombre_dx": "T044-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN MULTIPLES REGIONES DEL(DE LOS) MIEMBRO(S) SUPERIOR(ES) CO",
    "sexo": "A"
  },
  {
    "cod_dx": "T047",
    "nombre_dx": "T047-TRAUMATISMOS POR APLASTAMIENTO DEL TORAX CON EL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS CON ",
    "sexo": "A"
  },
  {
    "cod_dx": "T048",
    "nombre_dx": "T048-TRAUMATISMOS POR APLASTAMIENTO QUE AFECTAN OTRAS COMBINACIONES DE REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T049",
    "nombre_dx": "T049-TRAUMATISMOS POR APLASTAMIENTO MULTIPLES, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T050",
    "nombre_dx": "T050-AMPUTACION TRAUMATICA DE AMBAS MANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T051",
    "nombre_dx": "T051-AMPUTACION TRAUMATICA DE UNA MANO Y EL OTRO BRAZO [CUALQUIER NIVEL, EXCEPTO MANO] ",
    "sexo": "A"
  },
  {
    "cod_dx": "T052",
    "nombre_dx": "T052-AMPUTACION TRAUMATICA DE AMBOS BRAZOS [CUALQUIER NIVEL] ",
    "sexo": "A"
  },
  {
    "cod_dx": "T053",
    "nombre_dx": "T053-AMPUTACION TRAUMATICA DE AMBOS PIES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T054",
    "nombre_dx": "T054-AMPUTACION TRAUMATICA DE UN PIE Y LA OTRA PIERNA [CUALQUIER NIVEL, EXCEPTO PIE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "T055",
    "nombre_dx": "T055-AMPUTACION TRAUMATICA DE AMBAS PIERNAS [CUALQUIER NIVEL]",
    "sexo": "A"
  },
  {
    "cod_dx": "T056",
    "nombre_dx": "T056-AMPUTACION TRAUMATICA DE MIEMBROS SUPERIOR(ES) E INFERIOR(ES), CUALQUIER COMBINACION [CUALQUIER NIVE",
    "sexo": "A"
  },
  {
    "cod_dx": "T058",
    "nombre_dx": "T058-AMPUTACION TRAUMATICA QUE AFECTA OTRAS COMBINACIONES DE REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T059",
    "nombre_dx": "T059-AMPUTACION TRAUMATICA MULTIPLES, NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T060",
    "nombre_dx": "T060-TRAUMATISMOS DEL ENCEFALO Y DE LOS NERVIOS CRANEALES CON TRAUMATISMO DE NERVIOS Y MEDULA ESPINAL A N",
    "sexo": "A"
  },
  {
    "cod_dx": "T061",
    "nombre_dx": "T061-TRAUMATISMOS DE NERVIOS Y MEDULA ESPINAL QUE AFECTAN OTRAS MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T062",
    "nombre_dx": "T062-TRAUMATISMOS DE NERVIOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T063",
    "nombre_dx": "T063-TRAUMATISMOS DE VASOS SANGUINEOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T064",
    "nombre_dx": "T064-TRAUMATISMOS DE TENDONES Y MUSCULOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T065",
    "nombre_dx": "T065-TRAUMATISMOS DE ORGANOS INTRATORACICOS CON ORGANOS INTRAABDOMINALES Y PELVICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T068",
    "nombre_dx": "T068-OTROS TRAUMATISMOS ESPECIFICADOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T07X",
    "nombre_dx": "T07X-TRAUMATISMOS MULTIPLES, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T080",
    "nombre_dx": "T080-FRACTURA DE LA COLUMNA VERTEBRAL, NIVEL NO ESPECIFICADO, ABIERTA",
    "sexo": "A"
  },
  {
    "cod_dx": "T081",
    "nombre_dx": "T081-FRACTURA DE LA COLUMNA VERTEBRAL, NIVEL NO ESPECIFICADO, CERRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T090",
    "nombre_dx": "T090-TRAUMATISMOS SUPERFICIAL DEL TRONCO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T091",
    "nombre_dx": "T091-HERIDA DEL TRONCO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T092",
    "nombre_dx": "T092-LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION Y LIGAMENTOS DEL TRONCO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T093",
    "nombre_dx": "T093-TRAUMATISMO DE LA MEDULA ESPINAL, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T094",
    "nombre_dx": "T094-TRAUMATISMO DE NERVIOS, RAIZ DE NERVIO ESPINAL Y PLEXOS DEL TRONCO NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T095",
    "nombre_dx": "T095-TRAUMATISMO DE TENDONES Y MUSCULOS DEL TRONCO NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T096",
    "nombre_dx": "T096-AMPUTACION TRAUMATICA DEL TRONCO, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T098",
    "nombre_dx": "T098-OTROS TRAUMATISMOS ESPECIFICADOS DEL TRONCO, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T099",
    "nombre_dx": "T099-TRAUMATISMO NO ESPECIFICADO DEL TRONCO, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T100",
    "nombre_dx": "T100-FRACTURA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO, CERRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T101",
    "nombre_dx": "T101-FRACTURA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO, ABIERTA",
    "sexo": "A"
  },
  {
    "cod_dx": "T110",
    "nombre_dx": "T110-TRAUMATISMOS SUPERFICIAL DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T111",
    "nombre_dx": "T111-HERIDA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T112",
    "nombre_dx": "T112-LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION O LIGAMENTO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVE",
    "sexo": "A"
  },
  {
    "cod_dx": "T113",
    "nombre_dx": "T113-TRAUMATISMO DE NERVIO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T114",
    "nombre_dx": "T114-TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOSDE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T115",
    "nombre_dx": "T115-TRAUMATISMO DE TENDON Y MUSCULO NO ESPECIFICADOSDE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T116",
    "nombre_dx": "T116-AMPUTACION TRAUMATICA DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T118",
    "nombre_dx": "T118-OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T119",
    "nombre_dx": "T119-TRAUMATISMO NO ESPECIFICADO DE MIEMBRO SUPERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T120",
    "nombre_dx": "T120-FRACTURA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO, CERRADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T121",
    "nombre_dx": "T121-FRACTURA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO, ABIERTA",
    "sexo": "A"
  },
  {
    "cod_dx": "T130",
    "nombre_dx": "T130-TRAUMATISMO SUPERFICIAL DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T131",
    "nombre_dx": "T131-HERIDA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T132",
    "nombre_dx": "T132-LUXACION, ESGUINCE O TORCEDURA DE ARTICULACION Y LIGAMENTOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NI",
    "sexo": "A"
  },
  {
    "cod_dx": "T133",
    "nombre_dx": "T133-TRAUMATISMO DE NERVIOS NO ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T134",
    "nombre_dx": "T134-TRAUMATISMO DE VASOS SANGUINEOS NO ESPECIFICADOSDE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T135",
    "nombre_dx": "T135-TRAUMATISMO DE TENDONES Y MUSCULOS NO ESPECIFICADOSDE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T136",
    "nombre_dx": "T136-AMPUTACION TRAUMATICA DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T138",
    "nombre_dx": "T138-OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T139",
    "nombre_dx": "T139-TRAUMATISMO NO ESPECIFICADO DE MIEMBRO INFERIOR, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T140",
    "nombre_dx": "T140-TRAUMATISMOS SUPERFICIAL DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T141",
    "nombre_dx": "T141-HERIDA DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T142",
    "nombre_dx": "T142-FRACTURA DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T143",
    "nombre_dx": "T143-LUXACION, ESGUINCE O TORCEDURA DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T144",
    "nombre_dx": "T144-TRAUMATISMO DE NERVIO(S) DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T145",
    "nombre_dx": "T145-TRAUMATISMO DE VASO(S) SANGUINEO(S) DE REGION NO ESPECIFICADA DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T146",
    "nombre_dx": "T146-TRAUMATISMO DE TENDONES Y MUSCULOS DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T147",
    "nombre_dx": "T147-TRAUMATISMO POR APLASTAMIENTO Y AMPUTACION TRAUMATICA DE REGIONES NO ESPECIFICADAS DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T148",
    "nombre_dx": "T148-OTROS TRAUMATISMOS DE REGION NO ESPECIFICADA DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T149",
    "nombre_dx": "T149-TRAUMATISMO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T150",
    "nombre_dx": "T150-CUERPO EXTRAÑO EN LA CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T151",
    "nombre_dx": "T151-CUERPO EXTRAÑO EN EL SACO CONJUNTIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T158",
    "nombre_dx": "T158-CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LA PARTE EXTERNA DEL OJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T159",
    "nombre_dx": "T159-CUERPO EXTRAÑO EN PARTE EXTERNA DEL OJO, SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T16X",
    "nombre_dx": "T16X-CUERPO EXTRAÑO EN EL OIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T170",
    "nombre_dx": "T170-CUERPO EXTRAÑO EN SENO PARANASAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T171",
    "nombre_dx": "T171-CUERPO EXTRAÑO EN EL ORIFICIO NASAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T172",
    "nombre_dx": "T172-CUERPO EXTRAÑO EN LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "T173",
    "nombre_dx": "T173-CUERPO EXTRAÑO EN LA LARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "T174",
    "nombre_dx": "T174-CUERPO EXTRAÑO EN LA TRAQUEA",
    "sexo": "A"
  },
  {
    "cod_dx": "T175",
    "nombre_dx": "T175-CUERPO EXTRAÑO EN BRONQUIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T178",
    "nombre_dx": "T178-CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LAS VIAS RESPIRATORIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T179",
    "nombre_dx": "T179-CUERPO EXTRAÑO EN LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T180",
    "nombre_dx": "T180-CUERPO EXTRAÑO EN LA BOCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T181",
    "nombre_dx": "T181-CUERPO EXTRAÑO EN EL ESOFAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "T182",
    "nombre_dx": "T182-CUERPO EXTRAÑO EN EL ESTOMAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T183",
    "nombre_dx": "T183-CUERPO EXTRAÑO EN EL INTESTINO DELGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T184",
    "nombre_dx": "T184-CUERPO EXTRAÑO EN EL COLON",
    "sexo": "A"
  },
  {
    "cod_dx": "T185",
    "nombre_dx": "T185-CUERPO EXTRAÑO EN EL ANO Y EN EL RECTO",
    "sexo": "A"
  },
  {
    "cod_dx": "T188",
    "nombre_dx": "T188-CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DEL TUBO DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "T189",
    "nombre_dx": "T189-CUERPO EXTRAÑO EN EL TUBO DIGESTIVO, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T190",
    "nombre_dx": "T190-CUERPO EXTRAÑO EN LA URETRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T191",
    "nombre_dx": "T191-CUERPO EXTRAÑO EN LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T192",
    "nombre_dx": "T192-CUERPO EXTRAÑO EN LA VULVA Y EN LA VAGINA ",
    "sexo": "F"
  },
  {
    "cod_dx": "T193",
    "nombre_dx": "T193-CUERPO EXTRAÑO EN EL UTERO [CUALQUIER PARTE]",
    "sexo": "F"
  },
  {
    "cod_dx": "T198",
    "nombre_dx": "T198-CUERPO EXTRAÑO EN OTRAS Y EN MULTIPLES PARTES DE LAS VIAS GENITOURINARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T199",
    "nombre_dx": "T199-CUERPO EXTRAÑO EN LAS VIAS GENITOURINARIAS, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T200",
    "nombre_dx": "T200-QUEMADURA DE LA CABEZA Y DEL CUELLO, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T201",
    "nombre_dx": "T201-QUEMADURA DE LA CABEZA Y DEL CUELLO, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T202",
    "nombre_dx": "T202-QUEMADURA DE LA CABEZA Y DEL CUELLO, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T203",
    "nombre_dx": "T203-QUEMADURA DE LA CABEZA Y DEL CUELLO, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T204",
    "nombre_dx": "T204-CORROSION DE LA CABEZA Y DEL CUELLO, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T205",
    "nombre_dx": "T205-CORROSION DE LA CABEZA Y DEL CUELLO, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T206",
    "nombre_dx": "T206-CORROSION DE LA CABEZA Y DEL CUELLO, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T207",
    "nombre_dx": "T207-CORROSION DE LA CABEZA Y DEL CUELLO, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T210",
    "nombre_dx": "T210-QUEMADURA DEL TRONCO, GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T211",
    "nombre_dx": "T211-QUEMADURA DEL TRONCO, DE PRIMER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T212",
    "nombre_dx": "T212-QUEMADURA DEL TRONCO, DE SEGUNDO GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T213",
    "nombre_dx": "T213-QUEMADURA DEL TRONCO, DE TERCER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T214",
    "nombre_dx": "T214-CORROSION DEL TRONCO, GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T215",
    "nombre_dx": "T215-CORROSION DEL TRONCO, DE PRIMER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T216",
    "nombre_dx": "T216-CORROSION DEL TRONCO, DE SEGUNDO GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T217",
    "nombre_dx": "T217-CORROSION DEL TRONCO, DE TERCER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T220",
    "nombre_dx": "T220-QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, GRADO NO ESPECIFICADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T221",
    "nombre_dx": "T221-QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE PRIMER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T222",
    "nombre_dx": "T222-QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE SEGUNDO GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "T223",
    "nombre_dx": "T223-QUEMADURA DEL HOMBRO Y MIEMBRO SUPERIOR, DE TERCER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T224",
    "nombre_dx": "T224-CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, GRADO NO ESPECIFICADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T225",
    "nombre_dx": "T225-CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE PRIMER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T226",
    "nombre_dx": "T226-CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE SEGUNDO GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "T227",
    "nombre_dx": "T227-CORROSION DEL HOMBRO Y MIEMBRO SUPERIOR, DE TERCER GRADO, EXCEPTO DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T230",
    "nombre_dx": "T230-QUEMADURA DE LA MUÑECA Y DE LA MANO, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T231",
    "nombre_dx": "T231-QUEMADURA DE LA MUÑECA Y DE LA MANO, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T232",
    "nombre_dx": "T232-QUEMADURA DE LA MUÑECA Y DE LA MANO, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T233",
    "nombre_dx": "T233-QUEMADURA DE LA MUÑECA Y DE LA MANO, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T234",
    "nombre_dx": "T234-CORROSION DE LA MUÑECA Y DE LA MANO, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T235",
    "nombre_dx": "T235-CORROSION DE LA MUÑECA Y DE LA MANO, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T236",
    "nombre_dx": "T236-CORROSION DE LA MUÑECA Y DE LA MANO, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T237",
    "nombre_dx": "T237-CORROSION DE LA MUÑECA Y DE LA MANO, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T240",
    "nombre_dx": "T240-QUEMADURA DE LA CADERA Y DEL MIEMBRO INFERIOR, GRADO NO ESPECIFICADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T241",
    "nombre_dx": "T241-QUEMADURA DE LA CADERA Y DEL MIEMBRO INFERIOR, DE PRIMER GRADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T242",
    "nombre_dx": "T242-QUEMADURA DE LA CADERA Y DEL MIEMBRO INFERIOR, DE SEGUNDO GRADO, EXCEPTO TOBILLO Y PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "T243",
    "nombre_dx": "T243-QUEMADURA DE LA CADERA Y DEL MIEMBRO INFERIOR, DE TERCER GRADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T244",
    "nombre_dx": "T244-CORROSION DE LA CADERA Y DEL MIEMBRO INFERIOR, GRADO NO ESPECIFICADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T245",
    "nombre_dx": "T245-CORROSION DE LA CADERA Y DEL MIEMBRO INFERIOR, DE PRIMER GRADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T246",
    "nombre_dx": "T246-CORROSION DE LA CADERA Y DEL MIEMBRO INFERIOR, DE SEGUNDO GRADO, EXCEPTO TOBILLO Y PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "T247",
    "nombre_dx": "T247-CORROSION DE LA CADERA Y DEL MIEMBRO INFERIOR, DE TERCER GRADO, EXCEPTO TOBILLO Y PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T250",
    "nombre_dx": "T250-QUEMADURA DEL TOBILLO Y DEL PIE, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T251",
    "nombre_dx": "T251-QUEMADURA DEL TOBILLO Y DEL PIE, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T252",
    "nombre_dx": "T252-QUEMADURA DEL TOBILLO Y DEL PIE, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T253",
    "nombre_dx": "T253-QUEMADURA DEL TOBILLO Y DEL PIE, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T254",
    "nombre_dx": "T254-CORROSION DEL TOBILLO Y DEL PIE, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T255",
    "nombre_dx": "T255-CORROSION DEL TOBILLO Y DEL PIE, DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T256",
    "nombre_dx": "T256-CORROSION DEL TOBILLO Y DEL PIE, DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T257",
    "nombre_dx": "T257-CORROSION DEL TOBILLO Y DEL PIE, DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T260",
    "nombre_dx": "T260-QUEMADURA DEL PARPADO Y AREA PERIOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T261",
    "nombre_dx": "T261-QUEMADURA DE LA CORNEA Y SACO CONJUNTIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T262",
    "nombre_dx": "T262-QUEMADURA CON RUPTURA Y DESTRUCCION RESULTANTES DEL GLOBO OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T263",
    "nombre_dx": "T263-QUEMADURA DE OTRAS PARTES DEL OJO Y SUS ANEXOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T264",
    "nombre_dx": "T264-QUEMADURA DEL OJO Y ANEXOS, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T265",
    "nombre_dx": "T265-CORROSION DEL PARPADO Y AREA PERIOCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T266",
    "nombre_dx": "T266-CORROSION DE LA CORNEA Y SACO CONJUNTIVAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T267",
    "nombre_dx": "T267-CORROSION CON RUPTURA Y DESTRUCCION RESULTANTES DEL GLOBO OCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T268",
    "nombre_dx": "T268-CORROSION DE OTRAS PARTES DEL OJO Y SUS ANEXOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T269",
    "nombre_dx": "T269-CORROSION DEL OJO Y ANEXOS, PARTE NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T270",
    "nombre_dx": "T270-QUEMADURA DE LA LARINGE Y LA TRAQUEA",
    "sexo": "A"
  },
  {
    "cod_dx": "T271",
    "nombre_dx": "T271-QUEMADURA QUE AFECTA LA LARINGE Y LA TRAQUEA CON EL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "T272",
    "nombre_dx": "T272-QUEMADURA DE OTRAS PARTES DE LAS VIAS RESPIRATORIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T273",
    "nombre_dx": "T273-QUEMADURA DE LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T274",
    "nombre_dx": "T274-CORROSION DE LA LARINGE Y DE LA TRAQUEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T275",
    "nombre_dx": "T275-CORROSION QUE AFECTA LA LARINGE Y LA TRAQUEA CON EL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "T276",
    "nombre_dx": "T276-CORROSION DE OTRAS PARTES DE LAS VIAS RESPIRATORIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T277",
    "nombre_dx": "T277-CORROSION DE LAS VIAS RESPIRATORIAS, PARTE NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T280",
    "nombre_dx": "T280-QUEMADURA DE LA BOCA Y DE LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "T281",
    "nombre_dx": "T281-QUEMADURA DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T282",
    "nombre_dx": "T282-QUEMADURA DE OTRAS PARTES DEL TUBO DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "T283",
    "nombre_dx": "T283-QUEMADURA DE ORGANOS GENITOURINARIOS INTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T284",
    "nombre_dx": "T284-QUEMADURA DE OTROS ORGANOS INTERNOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T285",
    "nombre_dx": "T285-CORROSION DE LA BOCA Y DE LA FARINGE",
    "sexo": "A"
  },
  {
    "cod_dx": "T286",
    "nombre_dx": "T286-CORROSION DEL ESOFAGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T287",
    "nombre_dx": "T287-CORROSION DE OTRAS PARTES DEL TUBO DIGESTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "T288",
    "nombre_dx": "T288-CORROSION DE ORGANOS GENITOURINARIOS INTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T289",
    "nombre_dx": "T289-CORROSION DE OTROS ORGANOS INTERNOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T290",
    "nombre_dx": "T290-QUEMADURAS DE MULTIPLES REGIONES, GRADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T291",
    "nombre_dx": "T291-QUEMADURAS DE MULTIPLES REGIONES, MENCIONADAS COMO DE NO MAS DE PRIMER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T292",
    "nombre_dx": "T292-QUEMADURAS DE MULTIPLES REGIONES, MENCIONADAS COMO DE NO MAS DE SEGUNDO GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T293",
    "nombre_dx": "T293-QUEMADURAS DE MULTIPLES REGIONES, CON MENCION AL MENOS DE UNA QUEMADURA DE TERCER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T294",
    "nombre_dx": "T294-CORROSIONES DE MULTIPLES REGIONES, GRADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T295",
    "nombre_dx": "T295-CORROSIONES MULTIPLES, MENCIONADAS COMO DE NO MAS DE PRIMER GRADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T296",
    "nombre_dx": "T296-CORROSIONES MULTIPLES, MENCIONADAS COMO DE NO MAS DE SEGUNDO GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T297",
    "nombre_dx": "T297-CORROSIONES MULTIPLES, CON MENCION AL MENOS DE UNA QUEMADURA DE TERCER GRADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T300",
    "nombre_dx": "T300-QUEMADURA DE REGION DEL CUERPO Y GRADO NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T301",
    "nombre_dx": "T301-QUEMADURA DE PRIMER GRADO, REGION DEL CUERPO NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T302",
    "nombre_dx": "T302-QUEMADURA DE SEGUNDO GRADO, REGION DEL CUERPO NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T303",
    "nombre_dx": "T303-QUEMADURA DE TERCER GRADO, REGION DEL CUERPO NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T304",
    "nombre_dx": "T304-CORROSION DE REGION DEL CUERPO Y GRADO NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T305",
    "nombre_dx": "T305-CORROSION DE PRIMER GRADO, REGION DEL CUERPO NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T306",
    "nombre_dx": "T306-CORROSION DE SEGUNDO GRADO, REGION DEL CUERPO NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T307",
    "nombre_dx": "T307-CORROSION DE TERCER GRADO, REGION DEL CUERPO NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T310",
    "nombre_dx": "T310-QUEMADURAS QUE AFECTAN MENOS DEL 10% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T311",
    "nombre_dx": "T311-QUEMADURAS QUE AFECTAN DEL 10% AL 19% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T312",
    "nombre_dx": "T312-QUEMADURAS QUE AFECTAN DEL 20% AL 29% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T313",
    "nombre_dx": "T313-QUEMADURAS QUE AFECTAN DEL 30% AL 39% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T314",
    "nombre_dx": "T314-QUEMADURAS QUE AFECTAN DEL 40% AL 49% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T315",
    "nombre_dx": "T315-QUEMADURAS QUE AFECTAN DEL 50% AL 59% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T316",
    "nombre_dx": "T316-QUEMADURAS QUE AFECTAN DEL 60% AL 69% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T317",
    "nombre_dx": "T317-QUEMADURAS QUE AFECTAN DEL 70% AL 79% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T318",
    "nombre_dx": "T318-QUEMADURAS QUE AFECTAN DEL 80% AL 89% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T319",
    "nombre_dx": "T319-QUEMADURAS QUE AFECTAN DEL 90% O MAS DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T320",
    "nombre_dx": "T320-CORROSIONES QUE AFECTAN MENOS DEL 10% DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T321",
    "nombre_dx": "T321-CORROSIONES QUE AFECTAN DEL 10% AL 19% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T322",
    "nombre_dx": "T322-CORROSIONES QUE AFECTAN DEL 20% AL 29% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T323",
    "nombre_dx": "T323-CORROSIONES QUE AFECTAN DEL 30% AL 39% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T324",
    "nombre_dx": "T324-CORROSIONES QUE AFECTAN DEL 40% AL 49% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T325",
    "nombre_dx": "T325-CORROSIONES QUE AFECTAN DEL 50% AL 59% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T326",
    "nombre_dx": "T326-CORROSIONES QUE AFECTAN DEL 60% AL 69% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T327",
    "nombre_dx": "T327-CORROSIONES QUE AFECTAN DEL 70% AL 79% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T328",
    "nombre_dx": "T328-CORROSIONES QUE AFECTAN DEL 80% AL 89% DE LA SUPERFICIE DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T329",
    "nombre_dx": "T329-CORROSIONES QUE AFECTAN DEL 90% O MAS DE LA SUPERFICIE DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T330",
    "nombre_dx": "T330-CONGELAMIENTO SUPERFICIAL DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "T331",
    "nombre_dx": "T331-CONGELAMIENTO SUPERFICIAL DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T332",
    "nombre_dx": "T332-CONGELAMIENTO SUPERFICIAL DEL TORAX ",
    "sexo": "A"
  },
  {
    "cod_dx": "T333",
    "nombre_dx": "T333-CONGELAMIENTO SUPERFICIAL DE LA PARED ABDOMINAL, REGION LUMBOSACRA Y PELVIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T334",
    "nombre_dx": "T334-CONGELAMIENTO SUPERFICIAL DEL BRAZO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T335",
    "nombre_dx": "T335-CONGELAMIENTO SUPERFICIAL DE LA MUÑECA Y DE LA MANO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T336",
    "nombre_dx": "T336-CONGELAMIENTO SUPERFICIAL DE LA CADERA Y DEL MUSLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T337",
    "nombre_dx": "T337-CONGELAMIENTO SUPERFICIAL DE LA RODILLA Y DE LA PIERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "T338",
    "nombre_dx": "T338-CONGELAMIENTO SUPERFICIAL DEL TOBILLO Y DEL PIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T339",
    "nombre_dx": "T339-CONGELAMIENTO SUPERFICIAL DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T340",
    "nombre_dx": "T340-CONGELAMIENTO CON NECROSIS TISULAR DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T341",
    "nombre_dx": "T341-CONGELAMIENTO CON NECROSIS TISULAR DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T342",
    "nombre_dx": "T342-CONGELAMIENTO CON NECROSIS TISULAR DEL TORAX",
    "sexo": "A"
  },
  {
    "cod_dx": "T343",
    "nombre_dx": "T343-CONGELAMIENTO CON NECROSIS TISULAR DE LA PARED ABDOMINAL, REGION LUMBOSACRA Y PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T344",
    "nombre_dx": "T344-CONGELAMIENTO CON NECROSIS TISULAR DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "T345",
    "nombre_dx": "T345-CONGELAMIENTO CON NECROSIS TISULAR DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "T346",
    "nombre_dx": "T346-CONGELAMIENTO CON NECROSIS TISULAR DE LA CADERA Y DEL MUSLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T347",
    "nombre_dx": "T347-CONGELAMIENTO CON NECROSIS TISULAR DE LA RODILLA Y DE LA PIERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T348",
    "nombre_dx": "T348-CONGELAMIENTO CON NECROSIS TISULAR DEL TOBILLO Y DEL PIE",
    "sexo": "A"
  },
  {
    "cod_dx": "T349",
    "nombre_dx": "T349-CONGELAMIENTO CON NECROSIS TISULAR DE OTROS SITIOS Y DE LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T350",
    "nombre_dx": "T350-CONGELAMIENTO SUPERFICIAL QUE AFECTA MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T351",
    "nombre_dx": "T351-CONGELAMIENTO CON NECROSIS TISULAR QUE AFECTA MULTIPLES REGIONES DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T352",
    "nombre_dx": "T352-CONGELAMIENTO NO ESPECIFICADO DE LA CABEZA Y DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T353",
    "nombre_dx": "T353-CONGELAMIENTO NO ESPECIFICADO DEL TORAX, DEL ABDOMEN, DE LA REGION LUMBOSACRA Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T354",
    "nombre_dx": "T354-CONGELAMIENTO NO ESPECIFICADO DEL MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T355",
    "nombre_dx": "T355-CONGELAMIENTO NO ESPECIFICADO DEL MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T356",
    "nombre_dx": "T356-CONGELAMIENTO NO ESPECIFICADO QUE AFECTA MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T357",
    "nombre_dx": "T357-CONGELAMIENTO NO ESPECIFICADO, DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T360",
    "nombre_dx": "T360-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: PENICILINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T361",
    "nombre_dx": "T361-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: CEFALOSPORINAS Y OTROS ANTIBIOTICOS BETA-LACTAMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T362",
    "nombre_dx": "T362-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: GRUPO DEL CLORAMFENICOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T363",
    "nombre_dx": "T363-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: MACROLIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T364",
    "nombre_dx": "T364-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: TETRACICLINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T365",
    "nombre_dx": "T365-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: AMINOGLUCOSIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T366",
    "nombre_dx": "T366-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: RIFAMICINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T367",
    "nombre_dx": "T367-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: ANTIBIOTICOS ANTIMICOTICOS USADOS SISTEMICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "T368",
    "nombre_dx": "T368-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: OTROS ANTIBIOTICOS SISTEMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T369",
    "nombre_dx": "T369-ENVENENAMIENTO POR ANTIBIOTICOS SISTEMICOS: ANTIBIOTICOS SISTEMICOS, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T370",
    "nombre_dx": "T370-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: SULFONAMIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T371",
    "nombre_dx": "T371-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: DROGAS ANTIMICOBACTERIANAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T372",
    "nombre_dx": "T372-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: ANTIPALUDICOS Y DROGAS DE AC",
    "sexo": "A"
  },
  {
    "cod_dx": "T373",
    "nombre_dx": "T373-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: OTRAS DROGAS ANTIPROTOZOARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "T374",
    "nombre_dx": "T374-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: ANTIHELMINTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T375",
    "nombre_dx": "T375-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: DROGAS ANTIVIRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "T378",
    "nombre_dx": "T378-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: OTROS ANTIINFECCIOSOS Y ANTI",
    "sexo": "A"
  },
  {
    "cod_dx": "T379",
    "nombre_dx": "T379-ENVENENAMIENTO POR OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS: OTROS ANTIINFECCIOSOS Y ANTI",
    "sexo": "A"
  },
  {
    "cod_dx": "T380",
    "nombre_dx": "T380-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T381",
    "nombre_dx": "T381-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T382",
    "nombre_dx": "T382-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T383",
    "nombre_dx": "T383-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T384",
    "nombre_dx": "T384-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T385",
    "nombre_dx": "T385-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T386",
    "nombre_dx": "T386-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T387",
    "nombre_dx": "T387-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T388",
    "nombre_dx": "T388-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T389",
    "nombre_dx": "T389-ENVENENAMIENTO POR HORMONAS Y SUS SUSTITUTOS Y ANTAGONISTAS SINTETICOS, NO CLASIFICADOS EN OTRA PART",
    "sexo": "A"
  },
  {
    "cod_dx": "T390",
    "nombre_dx": "T390-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: SALICILATOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T391",
    "nombre_dx": "T391-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: DERIVADOS DEL PARAAMI",
    "sexo": "A"
  },
  {
    "cod_dx": "T392",
    "nombre_dx": "T392-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: DERIVADOS DE LA PIRAZ",
    "sexo": "A"
  },
  {
    "cod_dx": "T393",
    "nombre_dx": "T393-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: OTRAS DROGAS ANTIINFL",
    "sexo": "A"
  },
  {
    "cod_dx": "T394",
    "nombre_dx": "T394-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: ANTIRREUMATICOS, NO C",
    "sexo": "A"
  },
  {
    "cod_dx": "T398",
    "nombre_dx": "T398-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: OTROS ANALGESICOS NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T399",
    "nombre_dx": "T399-ENVENENAMIENTO POR ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS: ANALGESICOS NO NARCOT",
    "sexo": "A"
  },
  {
    "cod_dx": "T400",
    "nombre_dx": "T400-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: OPIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T401",
    "nombre_dx": "T401-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: HEROINA",
    "sexo": "A"
  },
  {
    "cod_dx": "T402",
    "nombre_dx": "T402-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: OTROS OPIACEOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T403",
    "nombre_dx": "T403-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: METADONA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T404",
    "nombre_dx": "T404-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: OTROS NARCOTICOS SINTETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T405",
    "nombre_dx": "T405-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: COCAINA",
    "sexo": "A"
  },
  {
    "cod_dx": "T406",
    "nombre_dx": "T406-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: OTROS NARCOTICOS Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "T407",
    "nombre_dx": "T407-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: CANNABIS (DERIVADOS) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T408",
    "nombre_dx": "T408-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: ACIDO LISERGICO [LSD]",
    "sexo": "A"
  },
  {
    "cod_dx": "T409",
    "nombre_dx": "T409-ENVENENAMIENTO POR NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS]: OTROS PSICODISLEPTICOS Y LOS NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "T410",
    "nombre_dx": "T410-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: ANESTESICOS POR INHALACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T411",
    "nombre_dx": "T411-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: ANESTESICOS INTRAVENOSOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T412",
    "nombre_dx": "T412-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: OTROS ANESTESICOS GENERALES Y LOS NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T413",
    "nombre_dx": "T413-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: ANESTESICOS LOCALES",
    "sexo": "A"
  },
  {
    "cod_dx": "T414",
    "nombre_dx": "T414-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: ANESTESICOS, NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T415",
    "nombre_dx": "T415-ENVENENAMIENTO POR ANESTESICOS Y GASES TERAPEUTICOS: GASES TERAPEUTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T420",
    "nombre_dx": "T420-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: DERIVADOS DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "T421",
    "nombre_dx": "T421-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: IMINOSTILBENOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T422",
    "nombre_dx": "T422-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: SUCCINAMIDAS Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "T423",
    "nombre_dx": "T423-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: BARBITURICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T424",
    "nombre_dx": "T424-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: BENZODIAZEPINAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T425",
    "nombre_dx": "T425-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: ANTIEPILEPTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T426",
    "nombre_dx": "T426-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: OTROS ANTIEPILE",
    "sexo": "A"
  },
  {
    "cod_dx": "T427",
    "nombre_dx": "T427-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: ANTIEPILEPTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T428",
    "nombre_dx": "T428-ENVENENAMIENTO POR ANTIEPILEPTICOS, HIPNOTICOS-SEDANTES Y DROGAS ANTIPARKINSONIANAS: DROGAS ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "T430",
    "nombre_dx": "T430-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: ANTIDEPRESIVOS TRICICLICOS Y TETRAC",
    "sexo": "A"
  },
  {
    "cod_dx": "T431",
    "nombre_dx": "T431-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: ANTIDEPRESIVOS INHIBIDORES DE LA MO",
    "sexo": "A"
  },
  {
    "cod_dx": "T432",
    "nombre_dx": "T432-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: OTROS ANTIDEPRESIVOS Y LOS NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "T433",
    "nombre_dx": "T433-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: ANTIPSICOTICOS Y NEUROLEPTICOS FENO",
    "sexo": "A"
  },
  {
    "cod_dx": "T434",
    "nombre_dx": "T434-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: BUTIROFENONA Y NEUROLEPTICOS TIOXAN",
    "sexo": "A"
  },
  {
    "cod_dx": "T435",
    "nombre_dx": "T435-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: OTROS ANTIPSICOTICOS Y NEUROLEPTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T436",
    "nombre_dx": "T436-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: PSICOESTIMULANTES CON ABUSO POTENCI",
    "sexo": "A"
  },
  {
    "cod_dx": "T438",
    "nombre_dx": "T438-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: OTRAS DROGAS PSICOTROPICAS, NO CLAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T439",
    "nombre_dx": "T439-ENVENENAMIENTO POR PSICOTROPICOS, NO CLASIFICADOS EN OTRA PARTE: DROGA PSICOTROPICA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T440",
    "nombre_dx": "T440-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: AGENTES ANTICOLIN",
    "sexo": "A"
  },
  {
    "cod_dx": "T441",
    "nombre_dx": "T441-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: OTROS PARASIMPATI",
    "sexo": "A"
  },
  {
    "cod_dx": "T442",
    "nombre_dx": "T442-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: DROGAS BLOQUEADOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T443",
    "nombre_dx": "T443-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: OTROS PARASIMPATI",
    "sexo": "A"
  },
  {
    "cod_dx": "T444",
    "nombre_dx": "T444-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: AGONISTAS, PREDOM",
    "sexo": "A"
  },
  {
    "cod_dx": "T445",
    "nombre_dx": "T445-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: AGONISTAS, PREDOM",
    "sexo": "A"
  },
  {
    "cod_dx": "T446",
    "nombre_dx": "T446-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: ANTAGONISTAS, ALF",
    "sexo": "A"
  },
  {
    "cod_dx": "T447",
    "nombre_dx": "T447-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: ANTAGONISTAS, BET",
    "sexo": "A"
  },
  {
    "cod_dx": "T448",
    "nombre_dx": "T448-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: AGENTES DE ACCION",
    "sexo": "A"
  },
  {
    "cod_dx": "T449",
    "nombre_dx": "T449-ENVENENAMIENTO POR DROGAS QUE AFECTAN PRINCIPALMENTE EL SISTEMA NERVIOSO AUTONOMO: OTRAS DROGAS Y LA",
    "sexo": "A"
  },
  {
    "cod_dx": "T450",
    "nombre_dx": "T450-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T451",
    "nombre_dx": "T451-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T452",
    "nombre_dx": "T452-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T453",
    "nombre_dx": "T453-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T454",
    "nombre_dx": "T454-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T455",
    "nombre_dx": "T455-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T456",
    "nombre_dx": "T456-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T457",
    "nombre_dx": "T457-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T458",
    "nombre_dx": "T458-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T459",
    "nombre_dx": "T459-ENVENENAMIENTO POR AGENTES PRINCIPALMENTE SISTEMICOS Y HEMATOLOGICOS, NO CLASIFICADOS EN OTRA PARTE:",
    "sexo": "A"
  },
  {
    "cod_dx": "T460",
    "nombre_dx": "T460-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR:GLUCOSIDOS CARDIOT",
    "sexo": "A"
  },
  {
    "cod_dx": "T461",
    "nombre_dx": "T461-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: BLOQUEADORES DEL CA",
    "sexo": "A"
  },
  {
    "cod_dx": "T462",
    "nombre_dx": "T462-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: OTRAS DROGAS ANTIAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T463",
    "nombre_dx": "T463-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: VASODILATADORES COR",
    "sexo": "A"
  },
  {
    "cod_dx": "T464",
    "nombre_dx": "T464-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: INHIBIDORES DE LA E",
    "sexo": "A"
  },
  {
    "cod_dx": "T465",
    "nombre_dx": "T465-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: OTRAS DROGAS ANTIHI",
    "sexo": "A"
  },
  {
    "cod_dx": "T466",
    "nombre_dx": "T466-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: DROGAS ANTILIPEMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T467",
    "nombre_dx": "T467-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: VASODILATADORES PER",
    "sexo": "A"
  },
  {
    "cod_dx": "T468",
    "nombre_dx": "T468-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: DROGAS ANTIVARICOSA",
    "sexo": "A"
  },
  {
    "cod_dx": "T469",
    "nombre_dx": "T469-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA CARDIOVASCULAR: OTROS AGENTES Y LOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T470",
    "nombre_dx": "T470-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: ANTAGONISTAS DEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T471",
    "nombre_dx": "T471-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: OTRAS DROGAS ANTI",
    "sexo": "A"
  },
  {
    "cod_dx": "T472",
    "nombre_dx": "T472-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: LAXANTES ESTIMULA",
    "sexo": "A"
  },
  {
    "cod_dx": "T473",
    "nombre_dx": "T473-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: LAXANTES SALINOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T474",
    "nombre_dx": "T474-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: OTROS LAXANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T475",
    "nombre_dx": "T475-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: DIGESTIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T476",
    "nombre_dx": "T476-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: DROGAS ANTIDIARRE",
    "sexo": "A"
  },
  {
    "cod_dx": "T477",
    "nombre_dx": "T477-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: EMETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T478",
    "nombre_dx": "T478-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: OTROS AGENTES QUE",
    "sexo": "A"
  },
  {
    "cod_dx": "T479",
    "nombre_dx": "T479-ENVENENAMIENTO POR AGENTES QUE AFECTAN PRINCIPALMENTE EL SISTEMA GASTROINTESTINAL: AGENTES NO ESPECI",
    "sexo": "A"
  },
  {
    "cod_dx": "T480",
    "nombre_dx": "T480-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T481",
    "nombre_dx": "T481-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T482",
    "nombre_dx": "T482-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T483",
    "nombre_dx": "T483-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T484",
    "nombre_dx": "T484-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T485",
    "nombre_dx": "T485-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T486",
    "nombre_dx": "T486-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T487",
    "nombre_dx": "T487-ENVENENAMIENTO POR AGENTES CON ACCION PRINCIPAL SOBRE LOS MUSCULOS LISOS Y ESQUELETICOS Y SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "T490",
    "nombre_dx": "T490-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T491",
    "nombre_dx": "T491-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T492",
    "nombre_dx": "T492-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T493",
    "nombre_dx": "T493-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T494",
    "nombre_dx": "T494-ENVENENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y PO",
    "sexo": "A"
  },
  {
    "cod_dx": "T495",
    "nombre_dx": "T495-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T496",
    "nombre_dx": "T496-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T497",
    "nombre_dx": "T497-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T498",
    "nombre_dx": "T498-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T499",
    "nombre_dx": "T499-ENVENENAMIENTO POR AGENTES TOPICOS QUE AFECTAN PRINCIPALMENTE LA PIEL Y LAS MEMBRANAS MUCOSAS Y POR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T500",
    "nombre_dx": "T500-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T501",
    "nombre_dx": "T501-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T502",
    "nombre_dx": "T502-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T503",
    "nombre_dx": "T503-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T504",
    "nombre_dx": "T504-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T505",
    "nombre_dx": "T505-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T506",
    "nombre_dx": "T506-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T507",
    "nombre_dx": "T507-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T508",
    "nombre_dx": "T508-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T509",
    "nombre_dx": "T509-ENVENENAMIENTO POR DIURETICOS Y OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T510",
    "nombre_dx": "T510-EFECTO TOXICO DEL ALCOHOL: ETANOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T511",
    "nombre_dx": "T511-EFECTO TOXICO DEL ALCOHOL: METANOL",
    "sexo": "A"
  },
  {
    "cod_dx": "T512",
    "nombre_dx": "T512-EFECTO TOXICO DEL ALCOHOL: PROPANOL-2 ",
    "sexo": "A"
  },
  {
    "cod_dx": "T513",
    "nombre_dx": "T513-EFECTO TOXICO DEL ALCOHOL: LICOR DE ALCOHOL INSUFICIENTEMENTE DESTILADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T518",
    "nombre_dx": "T518-EFECTO TOXICO DEL ALCOHOL: OTROS ALCOHOLES",
    "sexo": "A"
  },
  {
    "cod_dx": "T519",
    "nombre_dx": "T519-EFECTO TOXICO DEL ALCOHOL: ALCOHOL, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T520",
    "nombre_dx": "T520-EFECTO TOXICO DE DISOLVENTES ORGANICOS: PRODUCTOS DEL PETROLEO",
    "sexo": "A"
  },
  {
    "cod_dx": "T521",
    "nombre_dx": "T521-EFECTO TOXICO DE DISOLVENTES ORGANICOS: BENCENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T522",
    "nombre_dx": "T522-EFECTO TOXICO DE DISOLVENTES ORGANICOS: HOMOLOGOS DEL BENCENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T523",
    "nombre_dx": "T523-EFECTO TOXICO DE DISOLVENTES ORGANICOS: GLICOLES",
    "sexo": "A"
  },
  {
    "cod_dx": "T524",
    "nombre_dx": "T524-EFECTO TOXICO DE DISOLVENTES ORGANICOS: CETONAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T528",
    "nombre_dx": "T528-EFECTO TOXICO DE DISOLVENTES ORGANICOS: OTROS DISOLVENTES ORGANICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T529",
    "nombre_dx": "T529-EFECTO TOXICO DE DISOLVENTES ORGANICOS: DISOLVENTES ORGANICOS, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T530",
    "nombre_dx": "T530-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: TETRACLORUR",
    "sexo": "A"
  },
  {
    "cod_dx": "T531",
    "nombre_dx": "T531-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: CLOROFORMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T532",
    "nombre_dx": "T532-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: TRICLOROETI",
    "sexo": "A"
  },
  {
    "cod_dx": "T533",
    "nombre_dx": "T533-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: TETRACLOROE",
    "sexo": "A"
  },
  {
    "cod_dx": "T534",
    "nombre_dx": "T534-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: DICLOROETAN",
    "sexo": "A"
  },
  {
    "cod_dx": "T535",
    "nombre_dx": "T535-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: CLOROFLUORC",
    "sexo": "A"
  },
  {
    "cod_dx": "T536",
    "nombre_dx": "T536-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: OTROS DERIV",
    "sexo": "A"
  },
  {
    "cod_dx": "T537",
    "nombre_dx": "T537-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: OTROS DERIV",
    "sexo": "A"
  },
  {
    "cod_dx": "T539",
    "nombre_dx": "T539-EFECTO TOXICO DE LOS DERIVADOS HALOGENADOS DE LOS HIDROCARBUROS ALIFATICOS Y AROMATICOS: DERIVADOS H",
    "sexo": "A"
  },
  {
    "cod_dx": "T540",
    "nombre_dx": "T540-EFECTO TOXICO DE SUSTANCIAS CORROSIVAS: FENOL Y HOMOLOGOS DEL FENOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T541",
    "nombre_dx": "T541-EFECTO TOXICO DE SUSTANCIAS CORROSIVAS: OTROS COMPUESTOS ORGANICOS CORROSIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T542",
    "nombre_dx": "T542-EFECTO TOXICO DE SUSTANCIAS CORROSIVAS: ACIDOS CORROSIVOS Y SUSTANCIAS ACIDAS SIMILARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T543",
    "nombre_dx": "T543-EFECTO TOXICO DE SUSTANCIAS CORROSIVAS: ALCALIS CAUSTICOS Y SUSTANCIAS ALCALINAS SIMILARES",
    "sexo": "A"
  },
  {
    "cod_dx": "T549",
    "nombre_dx": "T549-EFECTO TOXICO DE SUSTANCIAS CORROSIVAS: EFECTO TOXICO DE SUSTANCIA CORROSIVA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T55X",
    "nombre_dx": "T55X-EFECTO TOXICO DE DETERGENTES Y JABONES",
    "sexo": "A"
  },
  {
    "cod_dx": "T560",
    "nombre_dx": "T560-EFECTO TOXICO DE METALES: PLOMO Y SUS COMPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T561",
    "nombre_dx": "T561-EFECTO TOXICO DE METALES: MERCURIO Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T562",
    "nombre_dx": "T562-EFECTO TOXICO DE METALES: CROMO Y SUS COMPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T563",
    "nombre_dx": "T563-EFECTO TOXICO DE METALES: CADMIO Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T564",
    "nombre_dx": "T564-EFECTO TOXICO DE METALES: COBRE Y SUS COMPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T565",
    "nombre_dx": "T565-EFECTO TOXICO DE METALES: ZINC Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T566",
    "nombre_dx": "T566-EFECTO TOXICO DE METALES: ESTAÑO Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T567",
    "nombre_dx": "T567-EFECTO TOXICO DE METALES: BERILIO Y SUS COMPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T568",
    "nombre_dx": "T568-EFECTO TOXICO DE METALES: OTROS METALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T569",
    "nombre_dx": "T569-EFECTO TOXICO DE METALES: METAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T570",
    "nombre_dx": "T570-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: ARSENICO Y SUS COMPUESTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T571",
    "nombre_dx": "T571-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: FOSFORO Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T572",
    "nombre_dx": "T572-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: MANGANESO Y SUS COMPUESTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T573",
    "nombre_dx": "T573-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: ACIDO CIANHIDRICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T578",
    "nombre_dx": "T578-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: OTRAS SUSTANCIAS INORGANICAS, ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T579",
    "nombre_dx": "T579-EFECTO TOXICO DE OTRAS SUSTANCIAS INORGANICAS: SUSTANCIA INORGANICAS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T58X",
    "nombre_dx": "T58X-EFECTO TOXICO DEL MONOXIDO DE CARBONO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T590",
    "nombre_dx": "T590-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: OXIDOS DE NITROGENO",
    "sexo": "A"
  },
  {
    "cod_dx": "T591",
    "nombre_dx": "T591-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: DIOXIDO DE SULFURO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T592",
    "nombre_dx": "T592-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: FORMALDEHIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T593",
    "nombre_dx": "T593-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: GAS LACRIMOGENO",
    "sexo": "A"
  },
  {
    "cod_dx": "T594",
    "nombre_dx": "T594-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: CLORO GASEOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "T595",
    "nombre_dx": "T595-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: GAS DE FLUOR Y FLUORURO DE HIDROGENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T596",
    "nombre_dx": "T596-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: SULFURO DE HIDROGENO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T597",
    "nombre_dx": "T597-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: DIOXIDO DE CARBONO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T598",
    "nombre_dx": "T598-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: OTROS GASES, HUMOS Y VAPORES ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T599",
    "nombre_dx": "T599-EFECTO TOXICO DE GASES, HUMOS Y VAPORES: GASES, HUMOS Y VAPORES NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T600",
    "nombre_dx": "T600-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: INSECTICIDAS FOSFORADOS Y CARBAMATOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T601",
    "nombre_dx": "T601-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: INSECTICIDAS HALOGENADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T602",
    "nombre_dx": "T602-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: OTROS INSECTICIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T603",
    "nombre_dx": "T603-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: HERBICIDAS Y FUNGICIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T604",
    "nombre_dx": "T604-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: RODENTICIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T608",
    "nombre_dx": "T608-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: OTROS PLAGUICIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T609",
    "nombre_dx": "T609-EFECTO TOXICO DE PLAGUICIDAS [PESTICIDAS]: PLAGUICIDA NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T610",
    "nombre_dx": "T610-EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS: ENVENENAMIENTO CIGUATERO POR P",
    "sexo": "A"
  },
  {
    "cod_dx": "T611",
    "nombre_dx": "T611-EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS: ENVENENAMIENTO ESCOMBROIDEO PO",
    "sexo": "A"
  },
  {
    "cod_dx": "T612",
    "nombre_dx": "T612-EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS: OTROS ENVENENAMIENTOS POR PESC",
    "sexo": "A"
  },
  {
    "cod_dx": "T618",
    "nombre_dx": "T618-EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS: EFECTO TOXICO DE OTROS ALIMENT",
    "sexo": "A"
  },
  {
    "cod_dx": "T619",
    "nombre_dx": "T619-EFECTO TOXICO DE SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTOS MARINOS: EFECTO TOXICO DE ALIMENTOS MAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T620",
    "nombre_dx": "T620-EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO: HONGOS INGERIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T621",
    "nombre_dx": "T621-EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO: BAYAS INGERIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T622",
    "nombre_dx": "T622-EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO: OTRA(S) (PARTES DE) PLANTA(S) ING",
    "sexo": "A"
  },
  {
    "cod_dx": "T628",
    "nombre_dx": "T628-EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO: OTRAS SUSTANCIAS NOCIVAS INGERIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "T629",
    "nombre_dx": "T629-EFECTO TOXICO DE OTRAS SUSTANCIAS NOCIVAS INGERIDAS COMO ALIMENTO: SUSTANCIA NOCIVA INGERIDA COMO AL",
    "sexo": "A"
  },
  {
    "cod_dx": "T630",
    "nombre_dx": "T630-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: VENENO DE SERPIENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "T631",
    "nombre_dx": "T631-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: VENENO DE OTROS REPTILES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T632",
    "nombre_dx": "T632-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: VENENO DE ESCORPION",
    "sexo": "A"
  },
  {
    "cod_dx": "T633",
    "nombre_dx": "T633-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: VENENO DE ARAÑAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T634",
    "nombre_dx": "T634-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: VENENO DE OTROS ARTROPODOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T635",
    "nombre_dx": "T635-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: EFECTO TOXICO DEL CONTACTO CON PECES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T636",
    "nombre_dx": "T636-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: EFECTO TOXICO DEL CONTACTO CON OTROS ANIMALES MAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T638",
    "nombre_dx": "T638-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: EFECTO TOXICO DEL CONTACTO CON OTROS ANIMALES VEN",
    "sexo": "A"
  },
  {
    "cod_dx": "T639",
    "nombre_dx": "T639-EFECTO TOXICO DEL CONTACTO CON ANIMALES VENENOSOS: EFECTO TOXICO DEL CONTACTO CON ANIMAL VENENOSO NO",
    "sexo": "A"
  },
  {
    "cod_dx": "T64X",
    "nombre_dx": "T64X-EFECTO TOXICO DE AFLATOXINA Y OTRAS MICOTOXINAS CONTAMINANTES DE ALIMENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T650",
    "nombre_dx": "T650-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: CIANURO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T651",
    "nombre_dx": "T651-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: ESTRICNINA Y SUS SALES",
    "sexo": "A"
  },
  {
    "cod_dx": "T652",
    "nombre_dx": "T652-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: TABACO Y NICOTINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T653",
    "nombre_dx": "T653-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: NITRODERIVADOS Y AMINODERIVADOS DEL BENCEN",
    "sexo": "A"
  },
  {
    "cod_dx": "T654",
    "nombre_dx": "T654-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: BISULFURO DE CARBONO",
    "sexo": "A"
  },
  {
    "cod_dx": "T655",
    "nombre_dx": "T655-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: NITROGLICERINA Y OTROS ACIDOS Y ESTERES NI",
    "sexo": "A"
  },
  {
    "cod_dx": "T656",
    "nombre_dx": "T656-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: PINTURAS Y COLORANTES, NO CLASIFICADOS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "T658",
    "nombre_dx": "T658-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: EFECTOS TOXICOS DE OTRAS SUSTANCIAS ESPECI",
    "sexo": "A"
  },
  {
    "cod_dx": "T659",
    "nombre_dx": "T659-EFECTO TOXICO DE OTRAS SUSTANCIAS Y LAS NO ESPECIFICADAS: EFECTO TOXICO DE SUSTANCIA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "T66X",
    "nombre_dx": "T66X-EFECTOS NO ESPECIFICADOS DE LA RADIACION",
    "sexo": "A"
  },
  {
    "cod_dx": "T670",
    "nombre_dx": "T670-GOLPE DE CALOR E INSOLACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T671",
    "nombre_dx": "T671-SINCOPE DE CALOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T672",
    "nombre_dx": "T672-CALAMBRE POR CALOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T673",
    "nombre_dx": "T673-AGOTAMIENTO POR CALOR, ANHIDROTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T674",
    "nombre_dx": "T674-AGOTAMIENTO POR CALOR DEBIDO A DEPLECION DE SAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T675",
    "nombre_dx": "T675-AGOTAMIENTO POR CALOR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T676",
    "nombre_dx": "T676-FATIGA POR CALOR, TRANSITORIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T677",
    "nombre_dx": "T677-EDEMA POR CALOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T678",
    "nombre_dx": "T678-OTROS EFECTOS DEL CALOR Y DE LA LUZ ",
    "sexo": "A"
  },
  {
    "cod_dx": "T679",
    "nombre_dx": "T679-EFECTO DEL CALOR Y DE LA LUZ, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T68X",
    "nombre_dx": "T68X-HIPOTERMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "T690",
    "nombre_dx": "T690-MANO Y PIE DE INMERSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T691",
    "nombre_dx": "T691-SABAÑON(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T698",
    "nombre_dx": "T698-OTROS EFECTOS ESPECIFICADOS DE LA REDUCCION DE LA TEMPERATURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T699",
    "nombre_dx": "T699-EFECTO DE LA REDUCCION DE LA TEMPERATURA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T700",
    "nombre_dx": "T700-BAROTRAUMA OTITICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T701",
    "nombre_dx": "T701-BAROTRAUMA SINUSAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T702",
    "nombre_dx": "T702-OTROS EFECTOS Y LOS NO ESPECIFICADOS DE LA GRAN ALTITUD ",
    "sexo": "A"
  },
  {
    "cod_dx": "T703",
    "nombre_dx": "T703-ENFERMEDAD POR DESCOMPRESION [DE LOS CAJONES SUMERGIDOS]",
    "sexo": "A"
  },
  {
    "cod_dx": "T704",
    "nombre_dx": "T704-EFECTOS DE LIQUIDOS CON ALTA PRESION",
    "sexo": "A"
  },
  {
    "cod_dx": "T708",
    "nombre_dx": "T708-OTROS EFECTOS DE LA PRESION DEL AIRE Y DEL AGUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T709",
    "nombre_dx": "T709-EFECTO DE LA PRESION DEL AIRE Y DEL AGUA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T71X",
    "nombre_dx": "T71X-ASFIXIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T730",
    "nombre_dx": "T730-EFECTOS DEL HAMBRE",
    "sexo": "A"
  },
  {
    "cod_dx": "T731",
    "nombre_dx": "T731-EFECTOS DE LA SED ",
    "sexo": "A"
  },
  {
    "cod_dx": "T732",
    "nombre_dx": "T732-AGOTAMIENTO DEBIDO A EXPOSICION A LA INTEMPERIE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T733",
    "nombre_dx": "T733-AGOTAMIENTO DEBIDO A ESFUERZO EXCESIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "T738",
    "nombre_dx": "T738-OTROS EFECTOS DEPRIVACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T739",
    "nombre_dx": "T739-EFECTOS DEPRIVACION, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T740",
    "nombre_dx": "T740-NEGLIGENCIA O ABANDONO",
    "sexo": "A"
  },
  {
    "cod_dx": "T741",
    "nombre_dx": "T741-ABUSO FISICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T742",
    "nombre_dx": "T742-ABUSO SEXUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T743",
    "nombre_dx": "T743-ABUSO PSICOLOGICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T748",
    "nombre_dx": "T748-OTROS SINDROMES DE MALTRATO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T749",
    "nombre_dx": "T749-SINDROME DE MALTRATO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T750",
    "nombre_dx": "T750-EFECTOS DEL RAYO",
    "sexo": "A"
  },
  {
    "cod_dx": "T751",
    "nombre_dx": "T751-AHOGAMIENTO Y SUMERSION NO MORTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T752",
    "nombre_dx": "T752-EFECTOS DE LA VIBRACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T753",
    "nombre_dx": "T753-MAL DEL MOVIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "T754",
    "nombre_dx": "T754-EFECTOS DE LA CORRIENTE ELECTRICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T758",
    "nombre_dx": "T758-OTROS EFECTOS ESPECIFICADOSDE CAUSAS EXTERNAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T780",
    "nombre_dx": "T780-CHOQUE ANAFILACTICO DEBIDO A REACCION ADVERSA A ALIMENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T781",
    "nombre_dx": "T781-OTRA REACCION ADVERSA A ALIMENTOS, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T782",
    "nombre_dx": "T782-CHOQUE ANAFILACTICO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T783",
    "nombre_dx": "T783-EDEMA ANGIONEUROTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T784",
    "nombre_dx": "T784-ALERGIA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T788",
    "nombre_dx": "T788-OTROS EFECTOS ADVERSOS, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T789",
    "nombre_dx": "T789-EFECTOS ADVERSOS NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T790",
    "nombre_dx": "T790-EMBOLIA GASEOSA (TRAUMATICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "T791",
    "nombre_dx": "T791-EMBOLIA GRASA (TRAUMATICA)",
    "sexo": "A"
  },
  {
    "cod_dx": "T792",
    "nombre_dx": "T792-HEMORRAGIA TRAUMATICA SECUNDARIA Y RECURRENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T793",
    "nombre_dx": "T793-INFECCION POSTRAUMATICA DE HERIDA, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T794",
    "nombre_dx": "T794-CHOQUE TRAUMATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T795",
    "nombre_dx": "T795-ANURIA TRAUMATICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T796",
    "nombre_dx": "T796-ISQUEMIA TRAUMATICA DEL MUSCULO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T797",
    "nombre_dx": "T797-ENFISEMA SUBCUTANEO TRAUMATICO",
    "sexo": "A"
  },
  {
    "cod_dx": "T798",
    "nombre_dx": "T798-OTRAS COMPLICACIONES PRECOCES DE LOS TRAUMATISMOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T799",
    "nombre_dx": "T799-COMPLICACIONES PRECOCES NO ESPECIFICADAS DE LOS TRAUMATISMOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T800",
    "nombre_dx": "T800-EMBOLIA GASEOSA CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T801",
    "nombre_dx": "T801-COMPLICACIONES VASCULARES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T802",
    "nombre_dx": "T802-INFECCIONES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T803",
    "nombre_dx": "T803-REACCION DE INCOMPATIBILIDAD AL GRUPO ABO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T804",
    "nombre_dx": "T804-REACCION DE INCOMPATIBILIDAD A Rh ",
    "sexo": "A"
  },
  {
    "cod_dx": "T805",
    "nombre_dx": "T805-CHOQUE ANAFILACTICO DEBIDO A SUERO",
    "sexo": "A"
  },
  {
    "cod_dx": "T806",
    "nombre_dx": "T806-OTRAS REACCIONES AL SUERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T808",
    "nombre_dx": "T808-OTRAS COMPLICACIONES CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T809",
    "nombre_dx": "T809-COMPLICACIONES NO ESPECIFICADAS CONSECUTIVAS A INFUSION, TRANSFUSION E INYECCION TERAPEUTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T810",
    "nombre_dx": "T810-HEMORRAGIA Y HEMATOMA QUE COMPLICAN UN PROCEDIMIENTO, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T811",
    "nombre_dx": "T811-CHOQUE DURANTE O RESULTANTE DE UN PROCEDIMIENTO, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T812",
    "nombre_dx": "T812-PUNCION O LACERACION ACCIDENTAL DURANTE UN PROCEDIMIENTO, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T813",
    "nombre_dx": "T813-DESGARRO DE HERIDA OPERATORIA, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T814",
    "nombre_dx": "T814-INFECCION CONSECUTIVA A PROCEDIMIENTO, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T815",
    "nombre_dx": "T815-CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN CAVIDAD CORPORAL O EN HERIDA OPERATORIA CONSECUTIVA A PROCE",
    "sexo": "A"
  },
  {
    "cod_dx": "T816",
    "nombre_dx": "T816-REACCIÓN AGUDA A SUSTANCIA EXTRAÑA DEJADA ACCIDENTALMENTE DURANTE UN PROCEDIMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "T817",
    "nombre_dx": "T817-COMPLICACIONES VASCULARES CONSECUTIVAS A PROCEDIMIENTOS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "T818",
    "nombre_dx": "T818-OTRAS COMPLICACIONES DE PROCEDIMIENTOS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T819",
    "nombre_dx": "T819-COMPLICACIONES DE PROCEDIMIENTOS, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T820",
    "nombre_dx": "T820-COMPLICACION MECANICA DE PROTESIS DE VALVULA CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T821",
    "nombre_dx": "T821-COMPLICACION MECANICA DE DISPOSITIVO ELECTRONICO CARDIACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T822",
    "nombre_dx": "T822-COMPLICACION MECANICA DE DERIVACION DE ARTERIA CORONARIA E INJERTO VASCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T823",
    "nombre_dx": "T823-COMPLICACION MECANICA DE OTROS INJERTOS VASCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "T824",
    "nombre_dx": "T824-COMPLICACION MECANICA DE CATETER PARA DIALISIS VASCULAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T825",
    "nombre_dx": "T825-COMPLICACION MECANICA DE OTROS DISPOSITIVOS E IMPLANTES CARDIOVASCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "T826",
    "nombre_dx": "T826-INFECCION Y REACCION INFLAMATORIA DEBIDAS A PROTESIS DE VALVULA CARDIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "T827",
    "nombre_dx": "T827-INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVOS, IMPLANTES E INJERTOS CARDIOVASCULARE",
    "sexo": "A"
  },
  {
    "cod_dx": "T828",
    "nombre_dx": "T828-Otras complicaciones especificadas de dispositivos protésicos, implantes e injertos cardiovasculares",
    "sexo": "A"
  },
  {
    "cod_dx": "T829",
    "nombre_dx": "T829-COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO CARDIOVASCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "T830",
    "nombre_dx": "T830-COMPLICACION MECANICA DE CATETER URINARIO (FIJO)",
    "sexo": "A"
  },
  {
    "cod_dx": "T831",
    "nombre_dx": "T831-COMPLICACION MECANICA DE OTROS DISPOSITIVOS E IMPLANTES URINARIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T832",
    "nombre_dx": "T832-COMPLICACION MECANICA DE INJERTO EN ORGANO URINARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T833",
    "nombre_dx": "T833-COMPLICACION MECANICA DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO",
    "sexo": "F"
  },
  {
    "cod_dx": "T834",
    "nombre_dx": "T834-COMPLICACION MECANICA DE OTROS DISPOSITIVOS, IMPLANTES E INJERTOS EN EL TRACTO GENITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T835",
    "nombre_dx": "T835-INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO PROTESICO, IMPLANTE E INJERTO EN EL SISTEMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T836",
    "nombre_dx": "T836-INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO PROTESICO, IMPLANTE E INJERTO EN EL TRACTO G",
    "sexo": "A"
  },
  {
    "cod_dx": "T838",
    "nombre_dx": "T838-OTRAS COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS GENITOURINARIOS:",
    "sexo": "A"
  },
  {
    "cod_dx": "T839",
    "nombre_dx": "T839-COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO GENITOURINARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "T840",
    "nombre_dx": "T840-COMPLICACION MECANICA DE PROTESIS ARTICULAR INTERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T841",
    "nombre_dx": "T841-COMPLICACION MECANICA DE DISPOSITIVO DE FIJACION INTERNA DE HUESOS DE UN MIEMBRO",
    "sexo": "A"
  },
  {
    "cod_dx": "T842",
    "nombre_dx": "T842-COMPLICACION MECANICA DE DISPOSITIVO DE FIJACION INTERNA DE OTROS HUESOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T843",
    "nombre_dx": "T843-COMPLICACION MECANICA DE OTROS DISPOSITIVOS OSEOS, IMPLANTES E INJERTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T844",
    "nombre_dx": "T844-COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T845",
    "nombre_dx": "T845-INFECCION Y REACCION INFLAMATORIA DEBIDAS A PROTESIS ARTICULAR INTERNA",
    "sexo": "A"
  },
  {
    "cod_dx": "T846",
    "nombre_dx": "T846-INFECCION Y REACCION INFLAMATORIA DEBIDAS A DISPOSITIVO DE FIJACION INTERNA (CUALQUIER SITIO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T847",
    "nombre_dx": "T847-INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVO DE FIJACION INTERNA (CUALQUIER SITIO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "T848",
    "nombre_dx": "T848-OTRAS COMPLICACIONES DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T849",
    "nombre_dx": "T849-COMPLICACIONES NO ESPECIFICADAS DE DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS ORTOPEDICOS INTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "T850",
    "nombre_dx": "T850-COMPLICACION MECANICA DE DERIVACION (ANASTOMOTICA) VENTRICULAR INTRACRANEAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T851",
    "nombre_dx": "T851-COMPLICACION MECANICA DE IMPLANTE DE ESTIMULADOR ELECTRONICO DEL SISTEMA NERVIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T852",
    "nombre_dx": "T852-COMPLICACION MECANICA DE LENTES INTRAOCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T853",
    "nombre_dx": "T853-COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS OCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T854",
    "nombre_dx": "T854-COMPLICACION MECANICA DE PROTESIS E IMPLANTE DE MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "T855",
    "nombre_dx": "T855-COMPLICACION MECANICA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO GASTROINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "T856",
    "nombre_dx": "T856-COMPLICACION MECANICA DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTERNOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T857",
    "nombre_dx": "T857-INFECCION Y REACCION INFLAMATORIA DEBIDAS A OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTE",
    "sexo": "A"
  },
  {
    "cod_dx": "T858",
    "nombre_dx": "T858-OTRAS COMPLICACIONES DE OTROS DISPOSITIVOS PROTESICOS, IMPLANTES E INJERTOS INTERNOS, NO CLASIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "T859",
    "nombre_dx": "T859-COMPLICACION NO ESPECIFICADA DE DISPOSITIVO PROTESICO, IMPLANTE E INJERTO INTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T860",
    "nombre_dx": "T860-RECHAZO DE TRASPLANTE DE MEDULA OSEA",
    "sexo": "A"
  },
  {
    "cod_dx": "T861",
    "nombre_dx": "T861-FALLA Y RECHAZO DE TRASPLANTE DE RIÑON",
    "sexo": "A"
  },
  {
    "cod_dx": "T862",
    "nombre_dx": "T862-FALLA Y RECHAZO DE TRASPLANTE DE CORAZON",
    "sexo": "A"
  },
  {
    "cod_dx": "T863",
    "nombre_dx": "T863-FALLA Y RECHAZO DE TRASPLANTE DE PULMON-CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "T864",
    "nombre_dx": "T864-FALLA Y RECHAZO DE TRASPLANTE DE HIGADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T868",
    "nombre_dx": "T868-FALLA Y RECHAZO DE OTROS ORGANOS Y TEJIDOS TRASPLANTADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T869",
    "nombre_dx": "T869-FALLA Y RECHAZO DEL TRASPLANTE DE ORGANOS Y TEJIDOS NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T870",
    "nombre_dx": "T870-COMPLICACIONES DE LA REINSERCION (DE PARTE) DE EXTREMIDAD SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T871",
    "nombre_dx": "T871-COMPLICACIONES DE LA REINSERCION (DE PARTE) DE EXTREMIDAD INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T872",
    "nombre_dx": "T872-COMPLICACIONES DE OTRAS PARTES DEL CUERPO REINSERTADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T873",
    "nombre_dx": "T873-NEUROMA DE MUÑON DE AMPUTACION",
    "sexo": "A"
  },
  {
    "cod_dx": "T874",
    "nombre_dx": "T874-INFECCION DE MUÑON DE AMPUTACION",
    "sexo": "A"
  },
  {
    "cod_dx": "T875",
    "nombre_dx": "T875-NECROSIS DE MUÑON DE AMPUTACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T876",
    "nombre_dx": "T876-OTRAS COMPLICACIONES Y LAS NO ESPECIFICADAS DE MUÑON DE AMPUTACION",
    "sexo": "A"
  },
  {
    "cod_dx": "T880",
    "nombre_dx": "T880-INFECCION CONSECUTIVA A INMUNIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "T881",
    "nombre_dx": "T881-OTRAS COMPLICACIONES CONSECUTIVAS A INMUNIZACION, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "T882",
    "nombre_dx": "T882-CHOQUE DEBIDA A ANESTESIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T883",
    "nombre_dx": "T883-HIPERTERMIA MALIGNA DEBIDA A ANESTESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "T884",
    "nombre_dx": "T884-FALLA O DIFICULTAD DE LA INTUBACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "T885",
    "nombre_dx": "T885-OTRAS COMPLICACIONES DE LA ANESTESIA",
    "sexo": "A"
  },
  {
    "cod_dx": "T886",
    "nombre_dx": "T886-CHOQUE ANAFILACTICO DEBIDO A EFECTO ADVERSO DE DROGA O MEDICAMENTO CORRECTO ADMINISTRADO APROPIADAME",
    "sexo": "A"
  },
  {
    "cod_dx": "T887",
    "nombre_dx": "T887-EFECTO ADVERSO NO ESPECIFICADO DE DROGA O MEDICAMENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T888",
    "nombre_dx": "T888-OTRAS COMPLICACIONES ESPECIFICADAS DE LA ATENCION MEDICA Y QUIRURGICA, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "T889",
    "nombre_dx": "T889-COMPLICACIONES NO ESPECIFICADAS DE LA ATENCION MEDICA Y QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "T900",
    "nombre_dx": "T900-SECUELAS DE TRAUMATISMO SUPERFICIAL DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "T901",
    "nombre_dx": "T901-SECUELAS DE HERIDA DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T902",
    "nombre_dx": "T902-SECUELAS DE FRACTURA DEL CRANEO Y DE HUESOS FACIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "T903",
    "nombre_dx": "T903-SECUELAS DE TRAUMATISMO DE NERVIOS CRANEALES",
    "sexo": "A"
  },
  {
    "cod_dx": "T904",
    "nombre_dx": "T904-SECUELAS DE TRAUMATISMO DEL OJO Y DE LA ORBITA",
    "sexo": "A"
  },
  {
    "cod_dx": "T905",
    "nombre_dx": "T905-SECUELAS DE TRAUMATISMO INTRACRANEAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T908",
    "nombre_dx": "T908-SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE LA CABEZA ",
    "sexo": "A"
  },
  {
    "cod_dx": "T909",
    "nombre_dx": "T909-SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE LA CABEZA",
    "sexo": "A"
  },
  {
    "cod_dx": "T910",
    "nombre_dx": "T910-SECUELAS DE TRAUMATISMO SUPERFICIAL Y HERIDAS DEL CUELLO Y DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T911",
    "nombre_dx": "T911-SECUELAS DE FRACTURA DE LA COLUMNA VERTEBRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T912",
    "nombre_dx": "T912-SECUELAS DE OTRA FRACTURA DEL TORAX Y DE LA PELVIS",
    "sexo": "A"
  },
  {
    "cod_dx": "T913",
    "nombre_dx": "T913-SECUELAS DE TRAUMATISMO DE LA MEDULA ESPINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T914",
    "nombre_dx": "T914-SECUELAS DE TRAUMATISMO DE ORGANOS INTRATORACICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T915",
    "nombre_dx": "T915-SECUELAS DE TRAUMATISMO DE ORGANOS INTRAABDOMINALES Y PELVICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T918",
    "nombre_dx": "T918-SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DEL CUELLO Y DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "T919",
    "nombre_dx": "T919-SECUELAS DE TRAUMATISMO NO ESPECIFICADOS DEL CUELLO Y DEL TRONCO",
    "sexo": "A"
  },
  {
    "cod_dx": "T920",
    "nombre_dx": "T920-SECUELAS DE HERIDA DE MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T921",
    "nombre_dx": "T921-SECUELAS DE FRACTURA DEL BRAZO",
    "sexo": "A"
  },
  {
    "cod_dx": "T922",
    "nombre_dx": "T922-SECUELAS DE FRACTURA DE LA MUÑECA Y DE LA MANO",
    "sexo": "A"
  },
  {
    "cod_dx": "T923",
    "nombre_dx": "T923-SECUELAS DE LUXACION, TORCEDURA Y ESGUINCE DE MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T924",
    "nombre_dx": "T924-SECUELAS DE TRAUMATISMO DE NERVIO DE MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T925",
    "nombre_dx": "T925-SECUELAS DE TRAUMATISMO DE TENDON Y MUSCULO DE MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T926",
    "nombre_dx": "T926-SECUELAS DE APLASTAMIENTO Y AMPUTACION TRAUMATICASDE MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T928",
    "nombre_dx": "T928-SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T929",
    "nombre_dx": "T929-SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE MIEMBRO SUPERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T930",
    "nombre_dx": "T930-SECUELAS DE HERIDA DE MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T931",
    "nombre_dx": "T931-SECUELAS DE FRACTURA DE FEMUR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T932",
    "nombre_dx": "T932-SECUELAS DE OTRAS FRACTURAS DE MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T933",
    "nombre_dx": "T933-SECUELAS DE LUXACION, TORCEDURA Y ESGUINCE DE MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T934",
    "nombre_dx": "T934-SECUELAS DE TRAUMATISMO DE NERVIO DE MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T935",
    "nombre_dx": "T935-SECUELAS DE TRAUMATISMO DE TENDON Y MUSCULO DE MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T936",
    "nombre_dx": "T936-SECUELAS DE APLASTAMIENTO Y AMPUTACION TRAUMATICASDE MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T938",
    "nombre_dx": "T938-SECUELAS DE OTROS TRAUMATISMOS ESPECIFICADOS DE MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T939",
    "nombre_dx": "T939-SECUELAS DE TRAUMATISMO NO ESPECIFICADO DE MIEMBRO INFERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "T940",
    "nombre_dx": "T940-SECUELAS DE TRAUMATISMOS QUE AFECTAN MULTIPLES REGIONES DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T941",
    "nombre_dx": "T941-SECUELAS DE TRAUMATISMOS DE REGIONES NO ESPECIFICADAS DEL CUERPO",
    "sexo": "A"
  },
  {
    "cod_dx": "T950",
    "nombre_dx": "T950-SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE LA CABEZA Y DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "T951",
    "nombre_dx": "T951-SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "T952",
    "nombre_dx": "T952-SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE MIEMBRO SUPERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T953",
    "nombre_dx": "T953-SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO DE MIEMBRO INFERIOR",
    "sexo": "A"
  },
  {
    "cod_dx": "T954",
    "nombre_dx": "T954-SECUELAS DE QUEMADURA Y CORROSION CLASIFICABLES SOLO DE ACUERDO CON LA EXTENSION DE LA SUPERFICIE DE",
    "sexo": "A"
  },
  {
    "cod_dx": "T958",
    "nombre_dx": "T958-SECUELAS DE OTRAS QUEMADURAS, CORROSIONES Y CONGELAMIENTOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "T959",
    "nombre_dx": "T959-SECUELAS DE QUEMADURA, CORROSION Y CONGELAMIENTO NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T96X",
    "nombre_dx": "T96X-SECUELAS DE ENVENENAMIENTOS POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "T97X",
    "nombre_dx": "T97X-SECUELAS DE EFECTOS TOXICOS DE SUSTANCIAS DE PROCEDENCIA PRINCIPALMENTE NO MEDICINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "T980",
    "nombre_dx": "T980-SECUELAS DE EFECTOS DE CUERPOS EXTRAÑOS QUE PENETRAN EN ORIFICIOS NATURALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "T981",
    "nombre_dx": "T981-SECUELAS DE OTROS EFECTOS Y LOS NO ESPECIFICADOS DE CAUSAS EXTERNAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T982",
    "nombre_dx": "T982-SECUELAS DE CIERTAS COMPLICACIONES PRECOCES DE LOS TRAUMATISMOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "T983",
    "nombre_dx": "T983-SECUELAS DE COMPLICACIONES DE LA ATENCION MEDICA Y QUIRURGICA, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "U060",
    "nombre_dx": "U060-Uso emergente de U06.0",
    "sexo": "A"
  },
  {
    "cod_dx": "U061",
    "nombre_dx": "U061-Uso emergente de U06.1",
    "sexo": "A"
  },
  {
    "cod_dx": "U062",
    "nombre_dx": "U062-Uso emergente de U06.2",
    "sexo": "A"
  },
  {
    "cod_dx": "U063",
    "nombre_dx": "U063-Uso emergente de U06.3",
    "sexo": "A"
  },
  {
    "cod_dx": "U064",
    "nombre_dx": "U064-Uso emergente de U06.4",
    "sexo": "A"
  },
  {
    "cod_dx": "U065",
    "nombre_dx": "U065-Uso emergente de U06.5",
    "sexo": "A"
  },
  {
    "cod_dx": "U066",
    "nombre_dx": "U066-Uso emergente de U06.6",
    "sexo": "A"
  },
  {
    "cod_dx": "U067",
    "nombre_dx": "U067-Uso emergente de U06.7",
    "sexo": "A"
  },
  {
    "cod_dx": "U068",
    "nombre_dx": "U068-Uso emergente de U06.8",
    "sexo": "A"
  },
  {
    "cod_dx": "U069",
    "nombre_dx": "U069-Enfermedad por el virus del Zika, sin especificacion",
    "sexo": "A"
  },
  {
    "cod_dx": "U070",
    "nombre_dx": "U070-Trastorno relacionado con el vapeo",
    "sexo": "A"
  },
  {
    "cod_dx": "U071",
    "nombre_dx": "U071-COVID-19 (virus identificado)",
    "sexo": "A"
  },
  {
    "cod_dx": "U072",
    "nombre_dx": "U072-COVID-19 (Virus no identificado)",
    "sexo": "A"
  },
  {
    "cod_dx": "U073",
    "nombre_dx": "U073-Uso emergente de U07.3",
    "sexo": "A"
  },
  {
    "cod_dx": "U074",
    "nombre_dx": "U074-Uso emergente de U07.4",
    "sexo": "A"
  },
  {
    "cod_dx": "U075",
    "nombre_dx": "U075-Uso emergente de U07.5",
    "sexo": "A"
  },
  {
    "cod_dx": "U076",
    "nombre_dx": "U076-Uso emergente de U07.6",
    "sexo": "A"
  },
  {
    "cod_dx": "U077",
    "nombre_dx": "U077-Uso emergente de U07.7",
    "sexo": "A"
  },
  {
    "cod_dx": "U078",
    "nombre_dx": "U078-Uso emergente de U07.8",
    "sexo": "A"
  },
  {
    "cod_dx": "U079",
    "nombre_dx": "U079-Uso emergente de U07.9",
    "sexo": "A"
  },
  {
    "cod_dx": "U089",
    "nombre_dx": "U089-Historia personal de COVID-19, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "U099",
    "nombre_dx": "U099-Condición de salud posterior a COVID-19, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "U109",
    "nombre_dx": "U109-Sindrome inflamatorio multisistemico asociado con COVID-19, no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "U119",
    "nombre_dx": "U119-Necesidad de Inmunización contra COVID-19, no especificada",
    "sexo": "A"
  },
  {
    "cod_dx": "U129",
    "nombre_dx": "U129-Vacunas COVID-19 que causan efectos adversos en uso terapéutico, no especificados",
    "sexo": "A"
  },
  {
    "cod_dx": "U800",
    "nombre_dx": "U800-Agente bacteriano resistente a penicilina ",
    "sexo": "A"
  },
  {
    "cod_dx": "U801",
    "nombre_dx": "U801-Agente bacteriano resistente a meticilina",
    "sexo": "A"
  },
  {
    "cod_dx": "U808",
    "nombre_dx": "U808-Agente bacteriano resistente a otro antibiótico similar a la penicilina",
    "sexo": "A"
  },
  {
    "cod_dx": "U810",
    "nombre_dx": "U810-Agente bacteriano resistente a vancomicina",
    "sexo": "A"
  },
  {
    "cod_dx": "U818",
    "nombre_dx": "U818-Agente bacteriano resistente a otro antibiótico similar a la vancomicina",
    "sexo": "A"
  },
  {
    "cod_dx": "U820",
    "nombre_dx": "U820-Resistencia a penicilina ",
    "sexo": "A"
  },
  {
    "cod_dx": "U821",
    "nombre_dx": "U821-Resistencia a meticilina",
    "sexo": "A"
  },
  {
    "cod_dx": "U822",
    "nombre_dx": "U822-Resistencia a betalactamasa de espectro extendido (BLEE)",
    "sexo": "A"
  },
  {
    "cod_dx": "U828",
    "nombre_dx": "U828-Resistencia a otros antibióticos betaláctamicos",
    "sexo": "A"
  },
  {
    "cod_dx": "U829",
    "nombre_dx": "U829-Resistencia a antibióticos betaláctamicos, no especificados",
    "sexo": "A"
  },
  {
    "cod_dx": "U830",
    "nombre_dx": "U830-Resistencia a vancomicina",
    "sexo": "A"
  },
  {
    "cod_dx": "U831",
    "nombre_dx": "U831-Resistencia a otros antibióticos similares a vancomicina",
    "sexo": "A"
  },
  {
    "cod_dx": "U832",
    "nombre_dx": "U832-Resistencia a quinolonas",
    "sexo": "A"
  },
  {
    "cod_dx": "U837",
    "nombre_dx": "U837-Resistencia a múltiples antibióticos",
    "sexo": "A"
  },
  {
    "cod_dx": "U838",
    "nombre_dx": "U838-Resistencia a otros antibióticos únicos especificados",
    "sexo": "A"
  },
  {
    "cod_dx": "U839",
    "nombre_dx": "U839-Resistencia a antibióticos no especificados",
    "sexo": "A"
  },
  {
    "cod_dx": "U840",
    "nombre_dx": "U840-Resistencia a drogas antiparasitarias",
    "sexo": "A"
  },
  {
    "cod_dx": "U841",
    "nombre_dx": "U841-Resistencia a drogas antimicóticas",
    "sexo": "A"
  },
  {
    "cod_dx": "U842",
    "nombre_dx": "U842-Resistencia a drogas antivirales",
    "sexo": "A"
  },
  {
    "cod_dx": "U843",
    "nombre_dx": "U843-Resistencia a drogas antituberculosas",
    "sexo": "A"
  },
  {
    "cod_dx": "U847",
    "nombre_dx": "U847-Resistencia a múltiples drogas antimicrobianas",
    "sexo": "A"
  },
  {
    "cod_dx": "U848",
    "nombre_dx": "U848-Resistencia a otras drogas antimicrobianas especificadas",
    "sexo": "A"
  },
  {
    "cod_dx": "U849",
    "nombre_dx": "U849-Resistencia a drogas antimicrobianas no especificadas",
    "sexo": "A"
  },
  {
    "cod_dx": "U85X",
    "nombre_dx": "U85X-Resistencia a drogas antineoplásicas",
    "sexo": "A"
  },
  {
    "cod_dx": "U88X",
    "nombre_dx": "U88X-Agente bacteriano resistente a múltiples antibióticos",
    "sexo": "A"
  },
  {
    "cod_dx": "U898",
    "nombre_dx": "U898-Agente bacteriano resistente a otro antibiótico único especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "U899",
    "nombre_dx": "U899-Agente bacteriano resistente a antibiótico no especificado",
    "sexo": "A"
  },
  {
    "cod_dx": "V010",
    "nombre_dx": "V010-PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL: ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V011",
    "nombre_dx": "V011-PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL: ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V019",
    "nombre_dx": "V019-PEATON LESIONADO POR COLISION CON VEHICULO DE PEDAL: ACCIDENTE NO ESPECIFICADO COMO DE TRANSITO O NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V020",
    "nombre_dx": "V020-PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V021",
    "nombre_dx": "V021-PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V029",
    "nombre_dx": "V029-PEATON LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: ACCIDENTE NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V030",
    "nombre_dx": "V030-PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V031",
    "nombre_dx": "V031-PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V039",
    "nombre_dx": "V039-PEATON LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: NO ESPECIFICADO COMO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V040",
    "nombre_dx": "V040-PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V041",
    "nombre_dx": "V041-PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V049",
    "nombre_dx": "V049-PEATON LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: ACCIDENTE NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V050",
    "nombre_dx": "V050-PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V051",
    "nombre_dx": "V051-PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V059",
    "nombre_dx": "V059-PEATON LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: ACCIDENTE NO ESPECIFICADO COMO DE TRANS",
    "sexo": "A"
  },
  {
    "cod_dx": "V060",
    "nombre_dx": "V060-PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V061",
    "nombre_dx": "V061-PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V069",
    "nombre_dx": "V069-PEATON LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: ACCIDENTE NO ESPECIFICADO COMO DE TRANS",
    "sexo": "A"
  },
  {
    "cod_dx": "V090",
    "nombre_dx": "V090-PEATON LESIONADO EN ACCIDENTE NO DE TRANSITOQUE INVOLUCRA OTROS VEHICULOS DE MOTOR, Y LOS NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "V091",
    "nombre_dx": "V091-PEATON LESIONADO EN ACCIDENTE NO DE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V092",
    "nombre_dx": "V092-PEATON LESIONADO EN ACCIDENTE DE TRANSITO QUE INVOLUCRA OTROS VEHICULOS DE MOTOR, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V093",
    "nombre_dx": "V093-PEATON LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V099",
    "nombre_dx": "V099-PEATON LESIONADO EN ACCIDENTE DE TRANSPORTE NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V100",
    "nombre_dx": "V100-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V101",
    "nombre_dx": "V101-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V102",
    "nombre_dx": "V102-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENT",
    "sexo": "A"
  },
  {
    "cod_dx": "V103",
    "nombre_dx": "V103-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA LESIONADA AL SUBIR OBAJAR DELVEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V104",
    "nombre_dx": "V104-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V105",
    "nombre_dx": "V105-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V109",
    "nombre_dx": "V109-CICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENT",
    "sexo": "A"
  },
  {
    "cod_dx": "V110",
    "nombre_dx": "V110-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V111",
    "nombre_dx": "V111-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: PASAJERO LESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V112",
    "nombre_dx": "V112-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: NO ESPECIFICADO, LESIONADO EN ACCIDENTE NO DE TRA",
    "sexo": "A"
  },
  {
    "cod_dx": "V113",
    "nombre_dx": "V113-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: PERSONA LESIONADA AL SUBIR OBAJAR DELVEHICULO",
    "sexo": "A"
  },
  {
    "cod_dx": "V114",
    "nombre_dx": "V114-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V115",
    "nombre_dx": "V115-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V119",
    "nombre_dx": "V119-CICLISTA LESIONADO POR COLISION CON OTRO CICLISTA: CICLISTA NO ESPECIFICADO, LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V120",
    "nombre_dx": "V120-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V121",
    "nombre_dx": "V121-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V122",
    "nombre_dx": "V122-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CICLISTA NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V123",
    "nombre_dx": "V123-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA LESIONADA AL SUB",
    "sexo": "A"
  },
  {
    "cod_dx": "V124",
    "nombre_dx": "V124-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V125",
    "nombre_dx": "V125-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V129",
    "nombre_dx": "V129-CICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CICLISTA NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V130",
    "nombre_dx": "V130-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LESIONADO EN ACCIDEN",
    "sexo": "A"
  },
  {
    "cod_dx": "V131",
    "nombre_dx": "V131-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO EN ACCIDENT",
    "sexo": "A"
  },
  {
    "cod_dx": "V132",
    "nombre_dx": "V132-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CICLISTA NO ESPECIFICADO, LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V133",
    "nombre_dx": "V133-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA:PERSONA LESIONADA AL SUBIR O ",
    "sexo": "A"
  },
  {
    "cod_dx": "V134",
    "nombre_dx": "V134-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LESIONADO EN ACCIDEN",
    "sexo": "A"
  },
  {
    "cod_dx": "V135",
    "nombre_dx": "V135-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO EN ACCIDENT",
    "sexo": "A"
  },
  {
    "cod_dx": "V139",
    "nombre_dx": "V139-CICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CICLISTA NO ESPECIFICADO, LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V140",
    "nombre_dx": "V140-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V141",
    "nombre_dx": "V141-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V142",
    "nombre_dx": "V142-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CICLISTA NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V143",
    "nombre_dx": "V143-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA LESIONADA AL SU",
    "sexo": "A"
  },
  {
    "cod_dx": "V144",
    "nombre_dx": "V144-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V145",
    "nombre_dx": "V145-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V149",
    "nombre_dx": "V149-CICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CICLISTA NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V150",
    "nombre_dx": "V150-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACCIDENTE NO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V151",
    "nombre_dx": "V151-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN ACCIDENTE NO DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V152",
    "nombre_dx": "V152-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CICLISTA NO ESPECIFICADO, LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V153",
    "nombre_dx": "V153-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA LESIONADA AL SUBIR OBAJAR D",
    "sexo": "A"
  },
  {
    "cod_dx": "V154",
    "nombre_dx": "V154-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACCIDENTE DE T",
    "sexo": "A"
  },
  {
    "cod_dx": "V155",
    "nombre_dx": "V155-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES:PASAJERO LESIONADO EN ACCIDENTE DE T",
    "sexo": "A"
  },
  {
    "cod_dx": "V159",
    "nombre_dx": "V159-CICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CICLISTA NO ESPECIFICADO, LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V160",
    "nombre_dx": "V160-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: CONDUCTOR LESIONADO EN ACCIDENTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V161",
    "nombre_dx": "V161-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: PASAJERO LESIONADO EN ACCIDENTE NO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V162",
    "nombre_dx": "V162-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: CICLISTA NO ESPECIFICADO, LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V163",
    "nombre_dx": "V163-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: PERSONA LESIONADA AL SUBIR OBAJAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V164",
    "nombre_dx": "V164-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: CONDUCTOR LESIONADO EN ACCIDENTE DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V165",
    "nombre_dx": "V165-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: PASAJERO LESIONADO EN ACCIDENTE DE T",
    "sexo": "A"
  },
  {
    "cod_dx": "V169",
    "nombre_dx": "V169-CICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SINMOTOR: CICLISTA NO ESPECIFICADO, LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V170",
    "nombre_dx": "V170-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: CONDUCTOR LESIONADO EN ACCIDENTE NO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V171",
    "nombre_dx": "V171-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: PASAJERO LESIONADO EN ACCIDENTE NO DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V172",
    "nombre_dx": "V172-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: CICLISTA NO ESPECIFICADO, LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V173",
    "nombre_dx": "V173-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: PERSONA LESIONADA AL SUBIR OBAJAR D",
    "sexo": "A"
  },
  {
    "cod_dx": "V174",
    "nombre_dx": "V174-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO CONDUCTOR LESIONADO EN ACCIDENTE DE TR",
    "sexo": "A"
  },
  {
    "cod_dx": "V175",
    "nombre_dx": "V175-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: PASAJERO LESIONADO EN ACCIDENTE DE TR",
    "sexo": "A"
  },
  {
    "cod_dx": "V179",
    "nombre_dx": "V179-CICLISTA LESIONADO POR COLISION CON OBJETO ESTACIONADO O FIJO: CICLISTA NO ESPECIFICADO, LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V180",
    "nombre_dx": "V180-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CONDUCTOR LESIONADO EN ACCIDENTE NO DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V181",
    "nombre_dx": "V181-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: PASAJERO LESIONADO EN ACCIDENTE NO DE T",
    "sexo": "A"
  },
  {
    "cod_dx": "V182",
    "nombre_dx": "V182-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CICLISTA NO ESPECIFICADO, LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V183",
    "nombre_dx": "V183-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION:PERSONA LESIONADA AL SUBIR OBAJAR DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V184",
    "nombre_dx": "V184-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CONDUCTOR LESIONADO EN ACCIDENTE DE TRA",
    "sexo": "A"
  },
  {
    "cod_dx": "V185",
    "nombre_dx": "V185-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: PASAJERO LESIONADO EN ACCIDENTE DE TRAN",
    "sexo": "A"
  },
  {
    "cod_dx": "V189",
    "nombre_dx": "V189-CICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CICLISTA NO ESPECIFICADO, LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V190",
    "nombre_dx": "V190-CONDUCTOR DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V191",
    "nombre_dx": "V191-PASAJERO DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "V192",
    "nombre_dx": "V192-CICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V193",
    "nombre_dx": "V193-CICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V194",
    "nombre_dx": "V194-CONDUCTOR DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V195",
    "nombre_dx": "V195-PASAJERO DE VEHICULO DE PEDAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "V196",
    "nombre_dx": "V196-CICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V198",
    "nombre_dx": "V198-CICLISTA [CUALQUIERA] LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "V199",
    "nombre_dx": "V199-CICLISTA [CUALQUIERA] LESIONADO ENACCIDENTE DE TRANSITO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V200",
    "nombre_dx": "V200-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE NO DE TRAN",
    "sexo": "A"
  },
  {
    "cod_dx": "V201",
    "nombre_dx": "V201-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE NO DE TRANS",
    "sexo": "A"
  },
  {
    "cod_dx": "V202",
    "nombre_dx": "V202-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: MOTOCICLISTA NO ESPECIFICADO, LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V203",
    "nombre_dx": "V203-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHI",
    "sexo": "A"
  },
  {
    "cod_dx": "V204",
    "nombre_dx": "V204-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE DE TRANSIT",
    "sexo": "A"
  },
  {
    "cod_dx": "V205",
    "nombre_dx": "V205-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V209",
    "nombre_dx": "V209-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: MOTOCICLISTANO ESPECIFICADO, LESIONADO EN",
    "sexo": "A"
  },
  {
    "cod_dx": "V210",
    "nombre_dx": "V210-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO EN ACCIDENTE NO DE TR",
    "sexo": "A"
  },
  {
    "cod_dx": "V211",
    "nombre_dx": "V211-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO EN ACCIDENTE NO DE TRA",
    "sexo": "A"
  },
  {
    "cod_dx": "V212",
    "nombre_dx": "V212-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL: MOTOCICLISTA NO ESPECIFICADO, LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V213",
    "nombre_dx": "V213-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA LESIONADA AL SUBIR O BAJAR DEL VE",
    "sexo": "A"
  },
  {
    "cod_dx": "V214",
    "nombre_dx": "V214-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL:CONDUCTOR LESIONADO EN ACCIDENTE DE TRAN",
    "sexo": "A"
  },
  {
    "cod_dx": "V215",
    "nombre_dx": "V215-MOTOCICLISTA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V219",
    "nombre_dx": "V219-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE PEDAL:MOTOCICLISTA NO ESPECIFICADO, LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V220",
    "nombre_dx": "V220-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V221",
    "nombre_dx": "V221-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V222",
    "nombre_dx": "V222-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: MOTOCICLISTA NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "V223",
    "nombre_dx": "V223-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA LESIONADA AL",
    "sexo": "A"
  },
  {
    "cod_dx": "V224",
    "nombre_dx": "V224-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V225",
    "nombre_dx": "V225-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V229",
    "nombre_dx": "V229-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: MOTOCICLISTA NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "V230",
    "nombre_dx": "V230-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTORLESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V231",
    "nombre_dx": "V231-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V232",
    "nombre_dx": "V232-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: MOTOCICLISTA NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V233",
    "nombre_dx": "V233-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA LESIONADA AL SUBIR",
    "sexo": "A"
  },
  {
    "cod_dx": "V234",
    "nombre_dx": "V234-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V235",
    "nombre_dx": "V235-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V239",
    "nombre_dx": "V239-MOTOCICLISTA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: MOTOCICLISTA NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V240",
    "nombre_dx": "V240-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V241",
    "nombre_dx": "V241-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V242",
    "nombre_dx": "V242-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: MOTOCICLISTA NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V243",
    "nombre_dx": "V243-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA LESIONADA A",
    "sexo": "A"
  },
  {
    "cod_dx": "V244",
    "nombre_dx": "V244-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V245",
    "nombre_dx": "V245-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V249",
    "nombre_dx": "V249-MOTOCICLISTA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: MOTOCICLISTA NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V250",
    "nombre_dx": "V250-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V251",
    "nombre_dx": "V251-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN ACCIDENTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V252",
    "nombre_dx": "V252-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V253",
    "nombre_dx": "V253-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA LESIONADA AL SUBIR O BAJA",
    "sexo": "A"
  },
  {
    "cod_dx": "V254",
    "nombre_dx": "V254-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V255",
    "nombre_dx": "V255-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN ACCIDENTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V259",
    "nombre_dx": "V259-MOTOCICLISTA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V260",
    "nombre_dx": "V260-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V261",
    "nombre_dx": "V261-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LESIONADO EN ACCIDENTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V262",
    "nombre_dx": "V262-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V263",
    "nombre_dx": "V263-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA LESIONADA AL SUBIR O BAJA",
    "sexo": "A"
  },
  {
    "cod_dx": "V264",
    "nombre_dx": "V264-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V265",
    "nombre_dx": "V265-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LESIONADO EN ACCIDENTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V269",
    "nombre_dx": "V269-MOTOCICLISTA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V270",
    "nombre_dx": "V270-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V271",
    "nombre_dx": "V271-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN ACCIDENTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V272",
    "nombre_dx": "V272-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V273",
    "nombre_dx": "V273-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA LESIONADA AL SUBIR O BAJA",
    "sexo": "A"
  },
  {
    "cod_dx": "V274",
    "nombre_dx": "V274-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V275",
    "nombre_dx": "V275-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN ACCIDENTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V279",
    "nombre_dx": "V279-MOTOCICLISTA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: MOTOCICLISTA NO ESPECIFICADO, LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V280",
    "nombre_dx": "V280-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CONDUCTOR LESIONADO EN ACCIDENTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V281",
    "nombre_dx": "V281-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: PASAJERO LESIONADO EN ACCIDENTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V282",
    "nombre_dx": "V282-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: MOTOCICLISTA NO ESPECIFICADO, LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V283",
    "nombre_dx": "V283-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: PERSONA LESIONADA AL SUBIR O BAJAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V284",
    "nombre_dx": "V284-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: CONDUCTOR LESIONADO EN ACCIDENTE DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V285",
    "nombre_dx": "V285-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: PASAJERO LESIONADO EN ACCIDENTE DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V289",
    "nombre_dx": "V289-MOTOCICLISTA LESIONADO EN ACCIDENTE DE TRANSPORTESIN COLISION: MOTOCICLISTA NO ESPECIFICADO, LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V290",
    "nombre_dx": "V290-CONDUCTOR DE MOTOCICLETA LESIONADO POR COLISIÓN CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V291",
    "nombre_dx": "V291-PASAJERO DE MOTOCICLETA LESIONADO POR COLISIÓN CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V292",
    "nombre_dx": "V292-MOTOCICLISTA NO ESPECIFICADO LESIONADO POR COLISIÓN CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "V293",
    "nombre_dx": "V293-MOTOCICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V294",
    "nombre_dx": "V294-CONDUCTOR DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULO DE MOTOR, Y CON LOS NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V295",
    "nombre_dx": "V295-PASAJERO DE MOTOCICLETA LESIONADO POR COLISION CON OTROS VEHICULO DE MOTOR, Y CON LOS NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V296",
    "nombre_dx": "V296-MOTOCICLISTA NO ESPECIFICADO LESIONADO POR COLISION CON OTROS VEHICULO DE MOTOR, Y CON LOS NO ESPECI",
    "sexo": "A"
  },
  {
    "cod_dx": "V298",
    "nombre_dx": "V298-MOTOCICLISTA [CUALQUIERA] LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "V299",
    "nombre_dx": "V299-MOTOCICLISTA [CUALQUIERA] LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V300",
    "nombre_dx": "V300-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR L",
    "sexo": "A"
  },
  {
    "cod_dx": "V301",
    "nombre_dx": "V301-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V302",
    "nombre_dx": "V302-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE",
    "sexo": "A"
  },
  {
    "cod_dx": "V303",
    "nombre_dx": "V303-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V304",
    "nombre_dx": "V304-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V305",
    "nombre_dx": "V305-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR L",
    "sexo": "A"
  },
  {
    "cod_dx": "V306",
    "nombre_dx": "V306-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V307",
    "nombre_dx": "V307-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE",
    "sexo": "A"
  },
  {
    "cod_dx": "V309",
    "nombre_dx": "V309-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V310",
    "nombre_dx": "V310-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "V311",
    "nombre_dx": "V311-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V312",
    "nombre_dx": "V312-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA Q",
    "sexo": "A"
  },
  {
    "cod_dx": "V313",
    "nombre_dx": "V313-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V314",
    "nombre_dx": "V314-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA L",
    "sexo": "A"
  },
  {
    "cod_dx": "V315",
    "nombre_dx": "V315-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "V316",
    "nombre_dx": "V316-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V317",
    "nombre_dx": "V317-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA Q",
    "sexo": "A"
  },
  {
    "cod_dx": "V319",
    "nombre_dx": "V319-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V320",
    "nombre_dx": "V320-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V321",
    "nombre_dx": "V321-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V322",
    "nombre_dx": "V322-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V323",
    "nombre_dx": "V323-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V324",
    "nombre_dx": "V324-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V325",
    "nombre_dx": "V325-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V326",
    "nombre_dx": "V326-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V327",
    "nombre_dx": "V327-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V329",
    "nombre_dx": "V329-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTRO VEHICULO DE MOTOR DE DO",
    "sexo": "A"
  },
  {
    "cod_dx": "V330",
    "nombre_dx": "V330-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V331",
    "nombre_dx": "V331-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V332",
    "nombre_dx": "V332-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V333",
    "nombre_dx": "V333-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V334",
    "nombre_dx": "V334-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V335",
    "nombre_dx": "V335-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V336",
    "nombre_dx": "V336-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V337",
    "nombre_dx": "V337-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V339",
    "nombre_dx": "V339-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGO",
    "sexo": "A"
  },
  {
    "cod_dx": "V340",
    "nombre_dx": "V340-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V341",
    "nombre_dx": "V341-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V342",
    "nombre_dx": "V342-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V343",
    "nombre_dx": "V343-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V344",
    "nombre_dx": "V344-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V345",
    "nombre_dx": "V345-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V346",
    "nombre_dx": "V346-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V347",
    "nombre_dx": "V347-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V349",
    "nombre_dx": "V349-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V350",
    "nombre_dx": "V350-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V351",
    "nombre_dx": "V351-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V352",
    "nombre_dx": "V352-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V353",
    "nombre_dx": "V353-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V354",
    "nombre_dx": "V354-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V355",
    "nombre_dx": "V355-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V356",
    "nombre_dx": "V356-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V357",
    "nombre_dx": "V357-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V359",
    "nombre_dx": "V359-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V360",
    "nombre_dx": "V360-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V361",
    "nombre_dx": "V361-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V362",
    "nombre_dx": "V362-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V363",
    "nombre_dx": "V363-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V364",
    "nombre_dx": "V364-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V365",
    "nombre_dx": "V365-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V366",
    "nombre_dx": "V366-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V367",
    "nombre_dx": "V367-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V369",
    "nombre_dx": "V369-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V370",
    "nombre_dx": "V370-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V371",
    "nombre_dx": "V371-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V372",
    "nombre_dx": "V372-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V373",
    "nombre_dx": "V373-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V374",
    "nombre_dx": "V374-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V375",
    "nombre_dx": "V375-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: C",
    "sexo": "A"
  },
  {
    "cod_dx": "V376",
    "nombre_dx": "V376-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V377",
    "nombre_dx": "V377-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: P",
    "sexo": "A"
  },
  {
    "cod_dx": "V379",
    "nombre_dx": "V379-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: O",
    "sexo": "A"
  },
  {
    "cod_dx": "V380",
    "nombre_dx": "V380-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V381",
    "nombre_dx": "V381-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V382",
    "nombre_dx": "V382-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V383",
    "nombre_dx": "V383-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V384",
    "nombre_dx": "V384-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V385",
    "nombre_dx": "V385-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V386",
    "nombre_dx": "V386-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V387",
    "nombre_dx": "V387-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V389",
    "nombre_dx": "V389-OCUPANTE DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V390",
    "nombre_dx": "V390-CONDUCTOR DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y",
    "sexo": "A"
  },
  {
    "cod_dx": "V391",
    "nombre_dx": "V391-PASAJERO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "V392",
    "nombre_dx": "V392-OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V393",
    "nombre_dx": "V393-OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V394",
    "nombre_dx": "V394-CONDUCTOR DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y",
    "sexo": "A"
  },
  {
    "cod_dx": "V395",
    "nombre_dx": "V395-PASAJERO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "V396",
    "nombre_dx": "V396-OCUPANTE NO ESPECIFICADO DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO POR COLISION CON OTROS VEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V398",
    "nombre_dx": "V398-OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN OTROS ACCIDENTES DE TRANSPORT",
    "sexo": "A"
  },
  {
    "cod_dx": "V399",
    "nombre_dx": "V399-OCUPANTE [CUALQUIERA] DE VEHICULO DE MOTOR DE TRES RUEDAS LESIONADO EN ACCIDENTE DE TRANSITO, NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V400",
    "nombre_dx": "V400-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V401",
    "nombre_dx": "V401-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V402",
    "nombre_dx": "V402-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: PERSONA QUE VIAJA FUERA DEL VEHIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V403",
    "nombre_dx": "V403-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: OCUPANTE NO ESPECIFICADO DE AUTOM",
    "sexo": "A"
  },
  {
    "cod_dx": "V404",
    "nombre_dx": "V404-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: PERSONA LESIONADA AL SUBIR O BAJA",
    "sexo": "A"
  },
  {
    "cod_dx": "V405",
    "nombre_dx": "V405-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V406",
    "nombre_dx": "V406-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ACCIDENTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V407",
    "nombre_dx": "V407-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: PERSONA QUE VIAJA FUERA DEL VEHIC",
    "sexo": "A"
  },
  {
    "cod_dx": "V409",
    "nombre_dx": "V409-OCUPANTE DE AUTOMOVIL LESIONADO PORCOLISION CON PEATON O ANIMAL: OCUPANTE NO ESPECIFICADO DE AUTOM",
    "sexo": "A"
  },
  {
    "cod_dx": "V410",
    "nombre_dx": "V410-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO EN ACCIDENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "V411",
    "nombre_dx": "V411-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V412",
    "nombre_dx": "V412-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FUERA DEL VEHI",
    "sexo": "A"
  },
  {
    "cod_dx": "V413",
    "nombre_dx": "V413-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFICADO DE AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "V414",
    "nombre_dx": "V414-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA LESIONADA AL SUBIR O BAJ",
    "sexo": "A"
  },
  {
    "cod_dx": "V415",
    "nombre_dx": "V415-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO EN ACCIDENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "V416",
    "nombre_dx": "V416-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO EN ACCIDENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V417",
    "nombre_dx": "V417-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FUERA DEL VEHI",
    "sexo": "A"
  },
  {
    "cod_dx": "V419",
    "nombre_dx": "V419-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFICADO DE AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "V420",
    "nombre_dx": "V420-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR L",
    "sexo": "A"
  },
  {
    "cod_dx": "V421",
    "nombre_dx": "V421-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V422",
    "nombre_dx": "V422-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA QUE",
    "sexo": "A"
  },
  {
    "cod_dx": "V423",
    "nombre_dx": "V423-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: OCUPANTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V424",
    "nombre_dx": "V424-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V425",
    "nombre_dx": "V425-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR L",
    "sexo": "A"
  },
  {
    "cod_dx": "V426",
    "nombre_dx": "V426-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V427",
    "nombre_dx": "V427-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA QUE",
    "sexo": "A"
  },
  {
    "cod_dx": "V429",
    "nombre_dx": "V429-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: OCUPANTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V430",
    "nombre_dx": "V430-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V431",
    "nombre_dx": "V431-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V432",
    "nombre_dx": "V432-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V433",
    "nombre_dx": "V433-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V434",
    "nombre_dx": "V434-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V435",
    "nombre_dx": "V435-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V436",
    "nombre_dx": "V436-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: PASAJEROLE",
    "sexo": "A"
  },
  {
    "cod_dx": "V437",
    "nombre_dx": "V437-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V439",
    "nombre_dx": "V439-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTRO AUTOMOVIL, CAMIONETA O FURGONETA: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V440",
    "nombre_dx": "V440-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V441",
    "nombre_dx": "V441-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO L",
    "sexo": "A"
  },
  {
    "cod_dx": "V442",
    "nombre_dx": "V442-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA QU",
    "sexo": "A"
  },
  {
    "cod_dx": "V443",
    "nombre_dx": "V443-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: OCUPANTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V444",
    "nombre_dx": "V444-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V445",
    "nombre_dx": "V445-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V446",
    "nombre_dx": "V446-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO",
    "sexo": "A"
  },
  {
    "cod_dx": "V447",
    "nombre_dx": "V447-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA QU",
    "sexo": "A"
  },
  {
    "cod_dx": "V449",
    "nombre_dx": "V449-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: OCUPANTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V450",
    "nombre_dx": "V450-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V451",
    "nombre_dx": "V451-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V452",
    "nombre_dx": "V452-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE VIAJA FUERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V453",
    "nombre_dx": "V453-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V454",
    "nombre_dx": "V454-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA LESIONADA AL SUB",
    "sexo": "A"
  },
  {
    "cod_dx": "V455",
    "nombre_dx": "V455-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V456",
    "nombre_dx": "V456-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJEROLESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V457",
    "nombre_dx": "V457-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE VIAJA FUERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V459",
    "nombre_dx": "V459-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V460",
    "nombre_dx": "V460-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V461",
    "nombre_dx": "V461-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: PASAJERO LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V462",
    "nombre_dx": "V462-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: PERSONA QUE VIAJA FUERA",
    "sexo": "A"
  },
  {
    "cod_dx": "V463",
    "nombre_dx": "V463-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: OCUPANTE NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V464",
    "nombre_dx": "V464-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: PERSONA LESIONADA AL SU",
    "sexo": "A"
  },
  {
    "cod_dx": "V465",
    "nombre_dx": "V465-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V466",
    "nombre_dx": "V466-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: PASAJERO LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V467",
    "nombre_dx": "V467-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: PERSONA QUE VIAJA FUERA",
    "sexo": "A"
  },
  {
    "cod_dx": "V469",
    "nombre_dx": "V469-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OTROSVEHICULOS SIN MOTOR: OCUPANTE NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V470",
    "nombre_dx": "V470-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V471",
    "nombre_dx": "V471-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V472",
    "nombre_dx": "V472-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE VIAJA FUERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V473",
    "nombre_dx": "V473-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V474",
    "nombre_dx": "V474-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA LESIONADA AL SUB",
    "sexo": "A"
  },
  {
    "cod_dx": "V475",
    "nombre_dx": "V475-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN A",
    "sexo": "A"
  },
  {
    "cod_dx": "V476",
    "nombre_dx": "V476-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN AC",
    "sexo": "A"
  },
  {
    "cod_dx": "V477",
    "nombre_dx": "V477-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE VIAJA FUERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V479",
    "nombre_dx": "V479-OCUPANTE DE AUTOMOVIL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V480",
    "nombre_dx": "V480-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V481",
    "nombre_dx": "V481-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESIONADO EN ACCID",
    "sexo": "A"
  },
  {
    "cod_dx": "V482",
    "nombre_dx": "V482-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIAJA FUERA DEL",
    "sexo": "A"
  },
  {
    "cod_dx": "V483",
    "nombre_dx": "V483-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESPECIFICADO DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V484",
    "nombre_dx": "V484-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA LESIONADA AL SUBIR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V485",
    "nombre_dx": "V485-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V486",
    "nombre_dx": "V486-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESIONADO EN ACCID",
    "sexo": "A"
  },
  {
    "cod_dx": "V487",
    "nombre_dx": "V487-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIAJA FUERA DEL",
    "sexo": "A"
  },
  {
    "cod_dx": "V489",
    "nombre_dx": "V489-OCUPANTE DE AUTOMOVIL LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESPECIFICADO DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V490",
    "nombre_dx": "V490-CONDUCTOR DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V491",
    "nombre_dx": "V491-PASAJERO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V492",
    "nombre_dx": "V492-OCUPANTE NO ESPECIFICADO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V493",
    "nombre_dx": "V493-OCUPANTE [CUALQUIERA] DE AUTOMOVIL LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V494",
    "nombre_dx": "V494-CONDUCTOR DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V495",
    "nombre_dx": "V495-PASAJERO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V496",
    "nombre_dx": "V496-OCUPANTE NO ESPECIFICADO DE AUTOMOVIL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V498",
    "nombre_dx": "V498-OCUPANTE [CUALQUIERA]) DE AUTOMOVIL LESIONADO EN OTROS ACCIDENTES DE TRANSPORTEESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V499",
    "nombre_dx": "V499-OCUPANTE [CUALQUIERA] DE AUTOMOVIL LESIONADO EN ACCIDENTEDE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V500",
    "nombre_dx": "V500-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN",
    "sexo": "A"
  },
  {
    "cod_dx": "V501",
    "nombre_dx": "V501-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIONADO EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "V502",
    "nombre_dx": "V502-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE VIAJA FUER",
    "sexo": "A"
  },
  {
    "cod_dx": "V503",
    "nombre_dx": "V503-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V504",
    "nombre_dx": "V504-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA LESIONADA AL S",
    "sexo": "A"
  },
  {
    "cod_dx": "V505",
    "nombre_dx": "V505-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESIONADO EN",
    "sexo": "A"
  },
  {
    "cod_dx": "V506",
    "nombre_dx": "V506-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJEROLESIONADO EN",
    "sexo": "A"
  },
  {
    "cod_dx": "V507",
    "nombre_dx": "V507-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE VIAJA FUER",
    "sexo": "A"
  },
  {
    "cod_dx": "V509",
    "nombre_dx": "V509-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "V510",
    "nombre_dx": "V510-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V511",
    "nombre_dx": "V511-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V512",
    "nombre_dx": "V512-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FU",
    "sexo": "A"
  },
  {
    "cod_dx": "V513",
    "nombre_dx": "V513-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFI",
    "sexo": "A"
  },
  {
    "cod_dx": "V514",
    "nombre_dx": "V514-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA LESIONADA AL",
    "sexo": "A"
  },
  {
    "cod_dx": "V515",
    "nombre_dx": "V515-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V516",
    "nombre_dx": "V516-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V517",
    "nombre_dx": "V517-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FU",
    "sexo": "A"
  },
  {
    "cod_dx": "V519",
    "nombre_dx": "V519-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFI",
    "sexo": "A"
  },
  {
    "cod_dx": "V520",
    "nombre_dx": "V520-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V521",
    "nombre_dx": "V521-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V522",
    "nombre_dx": "V522-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V523",
    "nombre_dx": "V523-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V524",
    "nombre_dx": "V524-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V525",
    "nombre_dx": "V525-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V526",
    "nombre_dx": "V526-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V527",
    "nombre_dx": "V527-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V529",
    "nombre_dx": "V529-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS:",
    "sexo": "A"
  },
  {
    "cod_dx": "V530",
    "nombre_dx": "V530-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDU",
    "sexo": "A"
  },
  {
    "cod_dx": "V531",
    "nombre_dx": "V531-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJ",
    "sexo": "A"
  },
  {
    "cod_dx": "V532",
    "nombre_dx": "V532-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "V533",
    "nombre_dx": "V533-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: OCUPA",
    "sexo": "A"
  },
  {
    "cod_dx": "V534",
    "nombre_dx": "V534-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "V535",
    "nombre_dx": "V535-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDU",
    "sexo": "A"
  },
  {
    "cod_dx": "V536",
    "nombre_dx": "V536-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJ",
    "sexo": "A"
  },
  {
    "cod_dx": "V537",
    "nombre_dx": "V537-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "V539",
    "nombre_dx": "V539-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: OCUPA",
    "sexo": "A"
  },
  {
    "cod_dx": "V540",
    "nombre_dx": "V540-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V541",
    "nombre_dx": "V541-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V542",
    "nombre_dx": "V542-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V543",
    "nombre_dx": "V543-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V544",
    "nombre_dx": "V544-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V545",
    "nombre_dx": "V545-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V546",
    "nombre_dx": "V546-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V547",
    "nombre_dx": "V547-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V549",
    "nombre_dx": "V549-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V550",
    "nombre_dx": "V550-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V551",
    "nombre_dx": "V551-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V552",
    "nombre_dx": "V552-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V553",
    "nombre_dx": "V553-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V554",
    "nombre_dx": "V554-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V555",
    "nombre_dx": "V555-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V556",
    "nombre_dx": "V556-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJEROLE",
    "sexo": "A"
  },
  {
    "cod_dx": "V557",
    "nombre_dx": "V557-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V559",
    "nombre_dx": "V559-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V560",
    "nombre_dx": "V560-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V561",
    "nombre_dx": "V561-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V562",
    "nombre_dx": "V562-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V563",
    "nombre_dx": "V563-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V564",
    "nombre_dx": "V564-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V565",
    "nombre_dx": "V565-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V566",
    "nombre_dx": "V566-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V567",
    "nombre_dx": "V567-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V569",
    "nombre_dx": "V569-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V570",
    "nombre_dx": "V570-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V571",
    "nombre_dx": "V571-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V572",
    "nombre_dx": "V572-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V573",
    "nombre_dx": "V573-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V574",
    "nombre_dx": "V574-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V575",
    "nombre_dx": "V575-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V576",
    "nombre_dx": "V576-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V577",
    "nombre_dx": "V577-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V579",
    "nombre_dx": "V579-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V580",
    "nombre_dx": "V580-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V581",
    "nombre_dx": "V581-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESION",
    "sexo": "A"
  },
  {
    "cod_dx": "V582",
    "nombre_dx": "V582-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIA",
    "sexo": "A"
  },
  {
    "cod_dx": "V583",
    "nombre_dx": "V583-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V584",
    "nombre_dx": "V584-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA LESIONA",
    "sexo": "A"
  },
  {
    "cod_dx": "V585",
    "nombre_dx": "V585-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V586",
    "nombre_dx": "V586-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESION",
    "sexo": "A"
  },
  {
    "cod_dx": "V587",
    "nombre_dx": "V587-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIA",
    "sexo": "A"
  },
  {
    "cod_dx": "V589",
    "nombre_dx": "V589-OCUPANTE DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V590",
    "nombre_dx": "V590-CONDUCTOR DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V591",
    "nombre_dx": "V591-PASAJERO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V592",
    "nombre_dx": "V592-OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTO",
    "sexo": "A"
  },
  {
    "cod_dx": "V593",
    "nombre_dx": "V593-OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESPECIFICAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V594",
    "nombre_dx": "V594-CONDUCTOR DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V595",
    "nombre_dx": "V595-PASAJERO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V596",
    "nombre_dx": "V596-OCUPANTE NO ESPECIFICADO DE CAMIONETA O FURGONETA LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTO",
    "sexo": "A"
  },
  {
    "cod_dx": "V598",
    "nombre_dx": "V598-OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN OTROS ACCIDENTESDE TRANSPORTEESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "V599",
    "nombre_dx": "V599-OCUPANTE [CUALQUIERA] DE CAMIONETA O FURGONETA LESIONADO EN ACCIDENTEDE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V600",
    "nombre_dx": "V600-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V601",
    "nombre_dx": "V601-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJERO LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V602",
    "nombre_dx": "V602-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE VI",
    "sexo": "A"
  },
  {
    "cod_dx": "V603",
    "nombre_dx": "V603-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO ES",
    "sexo": "A"
  },
  {
    "cod_dx": "V604",
    "nombre_dx": "V604-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA LESION",
    "sexo": "A"
  },
  {
    "cod_dx": "V605",
    "nombre_dx": "V605-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: CONDUCTOR LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V606",
    "nombre_dx": "V606-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: PASAJEROLESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V607",
    "nombre_dx": "V607-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: PERSONA QUE VI",
    "sexo": "A"
  },
  {
    "cod_dx": "V609",
    "nombre_dx": "V609-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON PEATON O ANIMAL: OCUPANTE NO ES",
    "sexo": "A"
  },
  {
    "cod_dx": "V610",
    "nombre_dx": "V610-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V611",
    "nombre_dx": "V611-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V612",
    "nombre_dx": "V612-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V613",
    "nombre_dx": "V613-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V614",
    "nombre_dx": "V614-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V615",
    "nombre_dx": "V615-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V616",
    "nombre_dx": "V616-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V617",
    "nombre_dx": "V617-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V619",
    "nombre_dx": "V619-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V620",
    "nombre_dx": "V620-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V621",
    "nombre_dx": "V621-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V622",
    "nombre_dx": "V622-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V623",
    "nombre_dx": "V623-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V624",
    "nombre_dx": "V624-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V625",
    "nombre_dx": "V625-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V626",
    "nombre_dx": "V626-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V627",
    "nombre_dx": "V627-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V629",
    "nombre_dx": "V629-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES",
    "sexo": "A"
  },
  {
    "cod_dx": "V630",
    "nombre_dx": "V630-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V631",
    "nombre_dx": "V631-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V632",
    "nombre_dx": "V632-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V633",
    "nombre_dx": "V633-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V634",
    "nombre_dx": "V634-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V635",
    "nombre_dx": "V635-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V636",
    "nombre_dx": "V636-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V637",
    "nombre_dx": "V637-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V639",
    "nombre_dx": "V639-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONET",
    "sexo": "A"
  },
  {
    "cod_dx": "V640",
    "nombre_dx": "V640-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V641",
    "nombre_dx": "V641-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V642",
    "nombre_dx": "V642-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V643",
    "nombre_dx": "V643-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V644",
    "nombre_dx": "V644-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V645",
    "nombre_dx": "V645-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V646",
    "nombre_dx": "V646-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V647",
    "nombre_dx": "V647-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V649",
    "nombre_dx": "V649-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTRO VEHICULO DE TRANSPORTE PES",
    "sexo": "A"
  },
  {
    "cod_dx": "V650",
    "nombre_dx": "V650-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V651",
    "nombre_dx": "V651-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V652",
    "nombre_dx": "V652-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V653",
    "nombre_dx": "V653-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V654",
    "nombre_dx": "V654-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V655",
    "nombre_dx": "V655-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V656",
    "nombre_dx": "V656-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V657",
    "nombre_dx": "V657-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V659",
    "nombre_dx": "V659-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V660",
    "nombre_dx": "V660-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V661",
    "nombre_dx": "V661-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V662",
    "nombre_dx": "V662-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V663",
    "nombre_dx": "V663-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V664",
    "nombre_dx": "V664-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V665",
    "nombre_dx": "V665-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V666",
    "nombre_dx": "V666-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V667",
    "nombre_dx": "V667-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V669",
    "nombre_dx": "V669-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V670",
    "nombre_dx": "V670-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V671",
    "nombre_dx": "V671-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V672",
    "nombre_dx": "V672-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V673",
    "nombre_dx": "V673-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V674",
    "nombre_dx": "V674-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V675",
    "nombre_dx": "V675-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: COND",
    "sexo": "A"
  },
  {
    "cod_dx": "V676",
    "nombre_dx": "V676-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASA",
    "sexo": "A"
  },
  {
    "cod_dx": "V677",
    "nombre_dx": "V677-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERS",
    "sexo": "A"
  },
  {
    "cod_dx": "V679",
    "nombre_dx": "V679-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUP",
    "sexo": "A"
  },
  {
    "cod_dx": "V680",
    "nombre_dx": "V680-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCT",
    "sexo": "A"
  },
  {
    "cod_dx": "V681",
    "nombre_dx": "V681-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJER",
    "sexo": "A"
  },
  {
    "cod_dx": "V682",
    "nombre_dx": "V682-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA",
    "sexo": "A"
  },
  {
    "cod_dx": "V683",
    "nombre_dx": "V683-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANT",
    "sexo": "A"
  },
  {
    "cod_dx": "V684",
    "nombre_dx": "V684-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA",
    "sexo": "A"
  },
  {
    "cod_dx": "V685",
    "nombre_dx": "V685-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCT",
    "sexo": "A"
  },
  {
    "cod_dx": "V686",
    "nombre_dx": "V686-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJER",
    "sexo": "A"
  },
  {
    "cod_dx": "V687",
    "nombre_dx": "V687-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA",
    "sexo": "A"
  },
  {
    "cod_dx": "V689",
    "nombre_dx": "V689-OCUPANTE DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANT",
    "sexo": "A"
  },
  {
    "cod_dx": "V690",
    "nombre_dx": "V690-CONDUCTOR DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CO",
    "sexo": "A"
  },
  {
    "cod_dx": "V691",
    "nombre_dx": "V691-PASAJERO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON",
    "sexo": "A"
  },
  {
    "cod_dx": "V692",
    "nombre_dx": "V692-OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V693",
    "nombre_dx": "V693-OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE NO DE TRANSITO, NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "V694",
    "nombre_dx": "V694-CONDUCTOR DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CO",
    "sexo": "A"
  },
  {
    "cod_dx": "V695",
    "nombre_dx": "V695-PASAJERO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON",
    "sexo": "A"
  },
  {
    "cod_dx": "V696",
    "nombre_dx": "V696-OCUPANTE NO ESPECIFICADO DE VEHICULO DE TRANSPORTE PESADO LESIONADO POR COLISION CON OTROS VEHICULOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V698",
    "nombre_dx": "V698-OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN OTROS ACCIDENTESDE TRANSPORTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V699",
    "nombre_dx": "V699-OCUPANTE [CUALQUIERA] DE VEHICULO DE TRANSPORTE PESADO LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "V700",
    "nombre_dx": "V700-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V701",
    "nombre_dx": "V701-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: PASAJERO LESIONADO EN ACCIDENTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V702",
    "nombre_dx": "V702-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: PERSONA QUE VIAJA FUERA DEL VEHICUL",
    "sexo": "A"
  },
  {
    "cod_dx": "V703",
    "nombre_dx": "V703-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: OCUPANTE NO ESPECIFICADO DE AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V704",
    "nombre_dx": "V704-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: PERSONA LESIONADA AL SUBIR O BAJAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V705",
    "nombre_dx": "V705-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: CONDUCTOR LESIONADO EN ACCIDENTE DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V706",
    "nombre_dx": "V706-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: PASAJERO LESIONADO EN ACCIDENTE DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V707",
    "nombre_dx": "V707-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: PERSONA QUE VIAJA FUERA DEL VEHICUL",
    "sexo": "A"
  },
  {
    "cod_dx": "V709",
    "nombre_dx": "V709-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON PEATON OANIMAL: OCUPANTE NO ESPECIFICADO DE AUTOBUS",
    "sexo": "A"
  },
  {
    "cod_dx": "V710",
    "nombre_dx": "V710-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO EN ACCIDENTE N",
    "sexo": "A"
  },
  {
    "cod_dx": "V711",
    "nombre_dx": "V711-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO EN ACCIDENTE NO",
    "sexo": "A"
  },
  {
    "cod_dx": "V712",
    "nombre_dx": "V712-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FUERA DEL VEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V713",
    "nombre_dx": "V713-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFICADO DE AUTOBU",
    "sexo": "A"
  },
  {
    "cod_dx": "V714",
    "nombre_dx": "V714-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA LESIONADA AL SUBIR O BAJAR",
    "sexo": "A"
  },
  {
    "cod_dx": "V715",
    "nombre_dx": "V715-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: CONDUCTOR LESIONADO EN ACCIDENTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V716",
    "nombre_dx": "V716-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PASAJERO LESIONADO EN ACCIDENTE DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V717",
    "nombre_dx": "V717-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: PERSONA QUE VIAJA FUERA DEL VEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V719",
    "nombre_dx": "V719-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE PEDAL: OCUPANTE NO ESPECIFICADO DE AUTOBU",
    "sexo": "A"
  },
  {
    "cod_dx": "V720",
    "nombre_dx": "V720-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V721",
    "nombre_dx": "V721-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJERO LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V722",
    "nombre_dx": "V722-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA QUE V",
    "sexo": "A"
  },
  {
    "cod_dx": "V723",
    "nombre_dx": "V723-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: OCUPANTE NO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V724",
    "nombre_dx": "V724-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA LESIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V725",
    "nombre_dx": "V725-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: CONDUCTOR LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V726",
    "nombre_dx": "V726-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PASAJEROLES",
    "sexo": "A"
  },
  {
    "cod_dx": "V727",
    "nombre_dx": "V727-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: PERSONA QUE V",
    "sexo": "A"
  },
  {
    "cod_dx": "V729",
    "nombre_dx": "V729-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS O TRES RUEDAS: OCUPANTE NO E",
    "sexo": "A"
  },
  {
    "cod_dx": "V730",
    "nombre_dx": "V730-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V731",
    "nombre_dx": "V731-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V732",
    "nombre_dx": "V732-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA QUE VIAJA F",
    "sexo": "A"
  },
  {
    "cod_dx": "V733",
    "nombre_dx": "V733-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: OCUPANTE NO ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "V734",
    "nombre_dx": "V734-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA LESIONADA A",
    "sexo": "A"
  },
  {
    "cod_dx": "V735",
    "nombre_dx": "V735-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: CONDUCTOR LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V736",
    "nombre_dx": "V736-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PASAJERO LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V737",
    "nombre_dx": "V737-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: PERSONA QUE VIAJA F",
    "sexo": "A"
  },
  {
    "cod_dx": "V739",
    "nombre_dx": "V739-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O FURGONETA: OCUPANTE NO ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "V740",
    "nombre_dx": "V740-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V741",
    "nombre_dx": "V741-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V742",
    "nombre_dx": "V742-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V743",
    "nombre_dx": "V743-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V744",
    "nombre_dx": "V744-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA LESI",
    "sexo": "A"
  },
  {
    "cod_dx": "V745",
    "nombre_dx": "V745-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: CONDUCTOR LE",
    "sexo": "A"
  },
  {
    "cod_dx": "V746",
    "nombre_dx": "V746-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PASAJERO LES",
    "sexo": "A"
  },
  {
    "cod_dx": "V747",
    "nombre_dx": "V747-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: PERSONA QUE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V749",
    "nombre_dx": "V749-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON VEHICULO DE TRANSPORTE PESADO O AUTOBUS: OCUPANTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V750",
    "nombre_dx": "V750-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V751",
    "nombre_dx": "V751-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V752",
    "nombre_dx": "V752-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V753",
    "nombre_dx": "V753-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ESPECIFICADO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V754",
    "nombre_dx": "V754-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA LESIONADA AL SUBIR",
    "sexo": "A"
  },
  {
    "cod_dx": "V755",
    "nombre_dx": "V755-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V756",
    "nombre_dx": "V756-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V757",
    "nombre_dx": "V757-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V759",
    "nombre_dx": "V759-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON TREN O VEHICULO DE RIELES: OCUPANTE NO ESPECIFICADO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V760",
    "nombre_dx": "V760-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V761",
    "nombre_dx": "V761-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V762",
    "nombre_dx": "V762-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V763",
    "nombre_dx": "V763-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUPANTE NO ESPECIFICADO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V764",
    "nombre_dx": "V764-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA LESIONADA AL SUBIR",
    "sexo": "A"
  },
  {
    "cod_dx": "V765",
    "nombre_dx": "V765-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V766",
    "nombre_dx": "V766-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V767",
    "nombre_dx": "V767-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V769",
    "nombre_dx": "V769-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS SIN MOTOR: OCUPANTE DE AUTOBUS LESION",
    "sexo": "A"
  },
  {
    "cod_dx": "V770",
    "nombre_dx": "V770-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V771",
    "nombre_dx": "V771-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V772",
    "nombre_dx": "V772-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V773",
    "nombre_dx": "V773-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ESPECIFICADO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V774",
    "nombre_dx": "V774-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA LESIONADA AL SUBIR",
    "sexo": "A"
  },
  {
    "cod_dx": "V775",
    "nombre_dx": "V775-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: CONDUCTOR LESIONADO EN ACC",
    "sexo": "A"
  },
  {
    "cod_dx": "V776",
    "nombre_dx": "V776-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PASAJERO LESIONADO EN ACCI",
    "sexo": "A"
  },
  {
    "cod_dx": "V777",
    "nombre_dx": "V777-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: PERSONA QUE VIAJA FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V779",
    "nombre_dx": "V779-OCUPANTE DE AUTOBUS LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONADO: OCUPANTE NO ESPECIFICADO D",
    "sexo": "A"
  },
  {
    "cod_dx": "V780",
    "nombre_dx": "V780-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIONADO EN ACCIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "V781",
    "nombre_dx": "V781-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESIONADO EN ACCIDEN",
    "sexo": "A"
  },
  {
    "cod_dx": "V782",
    "nombre_dx": "V782-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIAJA FUERA DEL V",
    "sexo": "A"
  },
  {
    "cod_dx": "V783",
    "nombre_dx": "V783-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESPECIFICADO DE A",
    "sexo": "A"
  },
  {
    "cod_dx": "V784",
    "nombre_dx": "V784-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA LESIONADA AL SUBIR O ",
    "sexo": "A"
  },
  {
    "cod_dx": "V785",
    "nombre_dx": "V785-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: CONDUCTOR LESIONADO EN ACCIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "V786",
    "nombre_dx": "V786-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PASAJERO LESIONADO EN ACCIDEN",
    "sexo": "A"
  },
  {
    "cod_dx": "V787",
    "nombre_dx": "V787-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: PERSONA QUE VIAJA FUERA DEL V",
    "sexo": "A"
  },
  {
    "cod_dx": "V789",
    "nombre_dx": "V789-OCUPANTE DE AUTOBUS LESIONADO EN ACCIDENTE DE TRANSPORTE SIN COLISION: OCUPANTE NO ESPECIFICADO DE A",
    "sexo": "A"
  },
  {
    "cod_dx": "V790",
    "nombre_dx": "V790-CONDUCTOR DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V791",
    "nombre_dx": "V791-PASAJERO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS,",
    "sexo": "A"
  },
  {
    "cod_dx": "V792",
    "nombre_dx": "V792-OCUPANTE NO ESPECIFICADO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "V793",
    "nombre_dx": "V793-OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO ENACCIDENTE NO DE TRANSITO, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V794",
    "nombre_dx": "V794-CONDUCTOR DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V795",
    "nombre_dx": "V795-PASAJERO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS NO ESPECIFICADOS,",
    "sexo": "A"
  },
  {
    "cod_dx": "V796",
    "nombre_dx": "V796-OCUPANTE NO ESPECIFICADO DE AUTOBUS LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR, Y CON LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "V798",
    "nombre_dx": "V798-OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V799",
    "nombre_dx": "V799-OCUPANTE [CUALQUIERA] DE AUTOBUS LESIONADO EN ACCIDENTEDE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V800",
    "nombre_dx": "V800-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR CAIDA (O POR SER DESPEDIDO) DEL ANIMA",
    "sexo": "A"
  },
  {
    "cod_dx": "V801",
    "nombre_dx": "V801-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON PEATON O ANIMAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "V802",
    "nombre_dx": "V802-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON VEHICULO DE PEDAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "V803",
    "nombre_dx": "V803-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON VEHICULO DE MOTOR DE DOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V804",
    "nombre_dx": "V804-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON AUTOMOVIL, CAMIONETA O F",
    "sexo": "A"
  },
  {
    "cod_dx": "V805",
    "nombre_dx": "V805-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON OTROS VEHICULOS DE MOTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "V806",
    "nombre_dx": "V806-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON TREN O VEHICULO DE RIELE",
    "sexo": "A"
  },
  {
    "cod_dx": "V807",
    "nombre_dx": "V807-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON VEHICULOS SIN MOTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V808",
    "nombre_dx": "V808-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO POR COLISION CON OBJETO FIJO O ESTACIONAD",
    "sexo": "A"
  },
  {
    "cod_dx": "V809",
    "nombre_dx": "V809-JINETE U OCUPANTE DE VEHICULO DE TRACCION ANIMAL LESIONADO EN OTROS ACCIDENTES DE TRANSPORTE, Y EN L",
    "sexo": "A"
  },
  {
    "cod_dx": "V810",
    "nombre_dx": "V810-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON VEHÍCULO DE MOTOR, EN ACCIDENTE NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V811",
    "nombre_dx": "V811-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON VEHÍCULO DE MOTOR, EN ACCIDENTE DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V812",
    "nombre_dx": "V812-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON, O GOLPEADO POR VAGON",
    "sexo": "A"
  },
  {
    "cod_dx": "V813",
    "nombre_dx": "V813-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR COLISION CON OTROS OBJETOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V814",
    "nombre_dx": "V814-PERSONA LESIONADA AL SUBIR O BAJARDE TREN O VEHICULO DE RIELES",
    "sexo": "A"
  },
  {
    "cod_dx": "V815",
    "nombre_dx": "V815-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR CAIDA DENTRO DEL TREN O VEHICULO DE RIELES",
    "sexo": "A"
  },
  {
    "cod_dx": "V816",
    "nombre_dx": "V816-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO POR CAIDA DESDE EL TREN O VEHICULO DE RIELES",
    "sexo": "A"
  },
  {
    "cod_dx": "V817",
    "nombre_dx": "V817-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN DESCARRILAMIENTO SIN COLISION ANTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V818",
    "nombre_dx": "V818-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN OTROS ACCIDENTES FERROVIARIOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V819",
    "nombre_dx": "V819-OCUPANTE DE TREN O VEHICULO DE RIELES LESIONADO EN ACCIDENTE FERROVIARIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V820",
    "nombre_dx": "V820-OCUPANTE DE TRANVIA LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V821",
    "nombre_dx": "V821-OCUPANTE DE TRANVIA LESIONADO POR COLISION CON VEHICULO DE MOTOR, EN ACCIDENTEDE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V822",
    "nombre_dx": "V822-OCUPANTE DE TRANVIA LESIONADO POR COLISION CON, O GOLPEADO POR VAGON",
    "sexo": "A"
  },
  {
    "cod_dx": "V823",
    "nombre_dx": "V823-OCUPANTE DE TRANVIA LESIONADO POR COLISION CON OTROS OBJETOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V824",
    "nombre_dx": "V824-PERSONA LESIONADA AL SUBIR O BAJAR DEL TRANVIA",
    "sexo": "A"
  },
  {
    "cod_dx": "V825",
    "nombre_dx": "V825-OCUPANTE DE TRANVIA LESIONADO POR CAIDA DENTRO DEL TRANVIA",
    "sexo": "A"
  },
  {
    "cod_dx": "V826",
    "nombre_dx": "V826-OCUPANTE DE TRANVIA LESIONADO POR CAIDA DESDE DEL TRANVIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V827",
    "nombre_dx": "V827-OCUPANTE DE TRANVIA LESIONADO POR DESCARRILAMIENTO, SIN COLISION ANTERIOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V828",
    "nombre_dx": "V828-OCUPANTE DE TRANVIA LESIONADO OTROS ACCIDENTES DE TRANSPORTE, ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "V829",
    "nombre_dx": "V829-OCUPANTE DE TRANVIA LESIONADO EN ACCIDENTE DE TRANSITO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V830",
    "nombre_dx": "V830-CONDUCTOR DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V831",
    "nombre_dx": "V831-PASAJERO DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V832",
    "nombre_dx": "V832-PERSONA QUE VIAJA FUERA DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V833",
    "nombre_dx": "V833-OCUPANTE NO ESPECIFICADO DEVEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V834",
    "nombre_dx": "V834-PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO INDUSTRIAL ESPECIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "V835",
    "nombre_dx": "V835-CONDUCTOR DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V836",
    "nombre_dx": "V836-PASAJERO DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V837",
    "nombre_dx": "V837-PERSONA QUE VIAJA FUERA DE VEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTENO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V839",
    "nombre_dx": "V839-OCUPANTE NO ESPECIFICADO DEVEHICULO INDUSTRIAL ESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V840",
    "nombre_dx": "V840-CONDUCTOR DE VEHICULO AGRICOLAESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V841",
    "nombre_dx": "V841-PASAJERO DE VEHICULO AGRICOLAESPECIAL LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V842",
    "nombre_dx": "V842-PERSONA QUE VIAJA FUERA DEL VEHICULO AGRICOLAESPECIALLESIONADA EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V843",
    "nombre_dx": "V843-OCUPANTE NO ESPECIFICADO DE VEHICULO AGRICOLAESPECIALLESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V844",
    "nombre_dx": "V844-PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO AGRICOLAESPECIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "V845",
    "nombre_dx": "V845-CONDUCTOR DE VEHICULO AGRICOLAESPECIAL LESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V846",
    "nombre_dx": "V846-PASAJERO DE VEHICULO AGRICOLAESPECIALLESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V847",
    "nombre_dx": "V847-PERSONA QUE VIAJA FUERA DEL VEHICULO AGRICOLAESPECIALLESIONADA EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V849",
    "nombre_dx": "V849-OCUPANTE NO ESPECIFICADO DE VEHICULO AGRICOLAESPECIALLESIONADO EN ACCIDENTE NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V850",
    "nombre_dx": "V850-CONDUCTOR DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V851",
    "nombre_dx": "V851-PASAJERO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V852",
    "nombre_dx": "V852-PERSONA QUE VIAJA FUERA DEL VEHICULO ESPECIAL PARA CONSTRUCCIÓN LESIONADA EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V853",
    "nombre_dx": "V853-OCUPANTE NO ESPECIFICADO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V854",
    "nombre_dx": "V854-PERSONA LESIONADA AL SUBIR O BAJAR DEL VEHICULO ESPECIALPARA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "V855",
    "nombre_dx": "V855-CONDUCTOR DE VEHICULO ESPECIAL PARA CONSTRUCCIONLESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V856",
    "nombre_dx": "V856-PASAJERO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE NO DE TRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V857",
    "nombre_dx": "V857-PERSONA QUE VIAJA FUERA DEL VEHICULO ESPECIALPARA CONSTRUCCION LESIONADA EN ACCIDENTE NO DE TRANSI",
    "sexo": "A"
  },
  {
    "cod_dx": "V859",
    "nombre_dx": "V859-OCUPANTE NO ESPECIFICADO DE VEHICULO ESPECIAL PARA CONSTRUCCION LESIONADO EN ACCIDENTE NO DE TRANSIT",
    "sexo": "A"
  },
  {
    "cod_dx": "V860",
    "nombre_dx": "V860-CONDUCTOR DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA L",
    "sexo": "A"
  },
  {
    "cod_dx": "V861",
    "nombre_dx": "V861-PASAJERO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULODE MOTOR PARA USO FUERA DE LA CARRETERA L",
    "sexo": "A"
  },
  {
    "cod_dx": "V862",
    "nombre_dx": "V862-PERSONA QUE VIAJA FUERADEL VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA D",
    "sexo": "A"
  },
  {
    "cod_dx": "V863",
    "nombre_dx": "V863-OCUPANTE NO ESPECIFICADO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V864",
    "nombre_dx": "V864-PERSONA LESIONADA EN ACCIDENTE DE TRANSITO AL SUBIR O BAJAR DE VEHICULO PARA TODO TERRENO O DE OTRO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V865",
    "nombre_dx": "V865-CONDUCTOR DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE LA CARRETERA L",
    "sexo": "A"
  },
  {
    "cod_dx": "V866",
    "nombre_dx": "V866-PASAJERO DE VEHICULO PARA TODO TERRENO O DE OTRO VEHICULODE MOTOR PARA USO FUERA DE LA CARRETERA L",
    "sexo": "A"
  },
  {
    "cod_dx": "V867",
    "nombre_dx": "V867-PERSONA QUE VIAJA FUERA DEL VEHICULO PARA TODO TERRENO O DE OTRO VEHICULO DE MOTOR PARA USO FUERA DE",
    "sexo": "A"
  },
  {
    "cod_dx": "V869",
    "nombre_dx": "V869-OCUPANTE NO ESPECIFICADO DEL VEHICULO PARA TODO TERRENO O DE OTRO VEHICULODE MOTOR PARA USO FUERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V870",
    "nombre_dx": "V870-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE MOTOR DE DOS O TRES RUEDAS (TRANSITO)",
    "sexo": "A"
  },
  {
    "cod_dx": "V871",
    "nombre_dx": "V871-PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR Y UN VEHICULO DE MOTOR DE DOS O TRES R",
    "sexo": "A"
  },
  {
    "cod_dx": "V872",
    "nombre_dx": "V872-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y CAMIONETA O FURGONETA (TRANSITO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V873",
    "nombre_dx": "V873-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y AUTOBUS (TRANSITO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V874",
    "nombre_dx": "V874-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE MOTOR DE TRANSPORTE PESADO (TRANSITO)",
    "sexo": "A"
  },
  {
    "cod_dx": "V875",
    "nombre_dx": "V875-PERSONA LESIONADA POR COLISION ENTRE VEHICULO DE TRANSPORTE PESADO Y AUTOBUS (TRANSITO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V876",
    "nombre_dx": "V876-PERSONA LESIONADA POR COLISION ENTRE TREN O VEHICULO DE RIELES Y AUTOMOVIL (TRANSITO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V877",
    "nombre_dx": "V877-PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOSDE MOTOR ESPECIFICADOS (TRANSITO) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V878",
    "nombre_dx": "V878-PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO DE MOTOR SIN COLISION ",
    "sexo": "A"
  },
  {
    "cod_dx": "V879",
    "nombre_dx": "V879-PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO SIN MOTOR (CON COLISIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V880",
    "nombre_dx": "V880-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE MOTOR DE DOS O TRES RUEDAS, NO DE TRANS",
    "sexo": "A"
  },
  {
    "cod_dx": "V881",
    "nombre_dx": "V881-PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOS DE MOTOR Y VEHICULO DE MOTOR DE DOS O TRES RUED",
    "sexo": "A"
  },
  {
    "cod_dx": "V882",
    "nombre_dx": "V882-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y CAMIONETA O FURGONETA, NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V883",
    "nombre_dx": "V883-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y AUTOBUS, NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V884",
    "nombre_dx": "V884-PERSONA LESIONADA POR COLISION ENTRE AUTOMOVIL Y VEHICULO DE TRANSPORTE PESADO, NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V885",
    "nombre_dx": "V885-PERSONA LESIONADA POR COLISION ENTRE VEHICULO DE TRANSPORTE PESADO Y AUTOBUS, NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V886",
    "nombre_dx": "V886-PERSONA LESIONADA POR COLISION ENTRE TREN O VEHICULO DE RIELES O AUTOMOVIL, NO DE TRANSITO",
    "sexo": "A"
  },
  {
    "cod_dx": "V887",
    "nombre_dx": "V887-PERSONA LESIONADA POR COLISION ENTRE OTROS VEHICULOSDE MOTOR ESPECIFICADOS, NO DETRANSITO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V888",
    "nombre_dx": "V888-PERSONA LESIONADAEN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO DE MOTOR SIN COLISION",
    "sexo": "A"
  },
  {
    "cod_dx": "V889",
    "nombre_dx": "V889-PERSONA LESIONADA EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE DE VEHICULO SIN MOTOR (CON COLISIO",
    "sexo": "A"
  },
  {
    "cod_dx": "V890",
    "nombre_dx": "V890-PERSONA LESIONADA EN ACCIDENTE NO DE TRANSITO, DE VEHICULO DE MOTOR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V891",
    "nombre_dx": "V891-PERSONA LESIONADA EN ACCIDENTE NO DE TRANSITO, DE VEHICULO SIN MOTOR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V892",
    "nombre_dx": "V892-PERSONA LESIONADA EN ACCIDENTEDE TRANSITO, DE VEHICULO DE MOTOR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V893",
    "nombre_dx": "V893-PERSONA LESIONADA EN ACCIDENTE DE TRANSITO, DE VEHICULO SIN MOTOR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V899",
    "nombre_dx": "V899-PERSONA LESIONADA EN ACCIDENTE DE VEHICULO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V900",
    "nombre_dx": "V900-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: BARCO MERCANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "V901",
    "nombre_dx": "V901-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: BARCO DE PASAJEROS",
    "sexo": "A"
  },
  {
    "cod_dx": "V902",
    "nombre_dx": "V902-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: BOTE DE PESCA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V903",
    "nombre_dx": "V903-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: OTRO VEHICULO ACUATICO CON MOTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "V904",
    "nombre_dx": "V904-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: VELERO",
    "sexo": "A"
  },
  {
    "cod_dx": "V905",
    "nombre_dx": "V905-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: CANOA O KAYAK ",
    "sexo": "A"
  },
  {
    "cod_dx": "V906",
    "nombre_dx": "V906-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: BALSA INFLABLE (SIN MOTOR)",
    "sexo": "A"
  },
  {
    "cod_dx": "V907",
    "nombre_dx": "V907-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: ESQUI ACUATICO",
    "sexo": "A"
  },
  {
    "cod_dx": "V908",
    "nombre_dx": "V908-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: OTRO VEHICULO ACUATICO SIN MOTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "V909",
    "nombre_dx": "V909-ACCIDENTE DE EMBARCACION QUE CAUSA AHOGAMIENTO Y SUMERSION: VEHICULO ACUATICO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V910",
    "nombre_dx": "V910-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: BARCO MERCANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V911",
    "nombre_dx": "V911-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: BARCO DE PASAJEROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "V912",
    "nombre_dx": "V912-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: BOTE DE PESCA",
    "sexo": "A"
  },
  {
    "cod_dx": "V913",
    "nombre_dx": "V913-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: OTRO VEHICULO ACUATICO CON MOTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V914",
    "nombre_dx": "V914-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: VELERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V915",
    "nombre_dx": "V915-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: CANOA O KAYAK",
    "sexo": "A"
  },
  {
    "cod_dx": "V916",
    "nombre_dx": "V916-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: BALSA INFLABLE (SIN MOTOR) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V917",
    "nombre_dx": "V917-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: ESQUI ACUATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V918",
    "nombre_dx": "V918-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: OTRO VEHICULO ACUATICO SIN MOTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V919",
    "nombre_dx": "V919-ACCIDENTE DE EMBARCACION QUE CAUSA OTROS TIPOS DE TRAUMATISMO: VEHICULO ACUATICO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V920",
    "nombre_dx": "V920-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: BARCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V921",
    "nombre_dx": "V921-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: BARCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V922",
    "nombre_dx": "V922-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: BOTE D",
    "sexo": "A"
  },
  {
    "cod_dx": "V923",
    "nombre_dx": "V923-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: OTRO V",
    "sexo": "A"
  },
  {
    "cod_dx": "V924",
    "nombre_dx": "V924-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: VELERO",
    "sexo": "A"
  },
  {
    "cod_dx": "V925",
    "nombre_dx": "V925-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: CANOA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V926",
    "nombre_dx": "V926-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: BALSA ",
    "sexo": "A"
  },
  {
    "cod_dx": "V927",
    "nombre_dx": "V927-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: ESQUI ",
    "sexo": "A"
  },
  {
    "cod_dx": "V928",
    "nombre_dx": "V928-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: OTRO V",
    "sexo": "A"
  },
  {
    "cod_dx": "V929",
    "nombre_dx": "V929-AHOGAMIENTO Y SUMERSION RELACIONADOS CON TRANSPORTE POR AGUA, SIN ACCIDENTE A LA EMBARCACION: VEHICU",
    "sexo": "A"
  },
  {
    "cod_dx": "V930",
    "nombre_dx": "V930-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V931",
    "nombre_dx": "V931-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V932",
    "nombre_dx": "V932-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V933",
    "nombre_dx": "V933-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V934",
    "nombre_dx": "V934-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V935",
    "nombre_dx": "V935-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V936",
    "nombre_dx": "V936-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V937",
    "nombre_dx": "V937-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V938",
    "nombre_dx": "V938-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V939",
    "nombre_dx": "V939-ACCIDENTE EN UNA EMBARCACION, SIN ACCIDENTE ALA EMBARCACION, QUE NO CAUSA AHOGAMIENTO O SUMERSION:",
    "sexo": "A"
  },
  {
    "cod_dx": "V940",
    "nombre_dx": "V940-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: BARCO MERCANTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V941",
    "nombre_dx": "V941-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: BARCO DE PASAJEROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "V942",
    "nombre_dx": "V942-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: BOTE DE PESCA",
    "sexo": "A"
  },
  {
    "cod_dx": "V943",
    "nombre_dx": "V943-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: OTRO VEHICULO ACUATICO CON MOTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V944",
    "nombre_dx": "V944-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: VELERO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V945",
    "nombre_dx": "V945-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: CANOA O KAYAK",
    "sexo": "A"
  },
  {
    "cod_dx": "V946",
    "nombre_dx": "V946-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: BALSA INFLABLE (SIN MOTOR) ",
    "sexo": "A"
  },
  {
    "cod_dx": "V947",
    "nombre_dx": "V947-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS: ESQUI ACUATICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V948",
    "nombre_dx": "V948-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS. OTRO VEHICULO ACUATICO SIN MOTOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "V949",
    "nombre_dx": "V949-OTROS ACCIDENTES DE TRANSPORTE POR AGUA, Y LOS NO ESPECIFICADOS:VEHICULO ACUATICO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V950",
    "nombre_dx": "V950-ACCIDENTE DE HELICOPTERO CON OCUPANTE LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V951",
    "nombre_dx": "V951-ACCIDENTE DE PLANEADOR ULTRA LIVIANO, MICRO LIVIANO O MOTORIZADO, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V952",
    "nombre_dx": "V952-ACCIDENTE DE OTROS VEHICULOS AEREOS DE ALAS FIJAS, PRIVADOS, CON OCUPANTE LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V953",
    "nombre_dx": "V953-ACCIDENTE DE VEHICULO AEREO DE ALAS FIJAS, COMERCIAL, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V954",
    "nombre_dx": "V954-ACCIDENTE DE NAVE ESPACIAL, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V958",
    "nombre_dx": "V958-ACCIDENTE DE OTRAS AERONAVES, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V959",
    "nombre_dx": "V959-ACCIDENTE DE AERONAVE NO ESPECIFICADA, CON OCUPANTE LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V960",
    "nombre_dx": "V960-ACCIDENTE DE GLOBO AEROSTATICO, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V961",
    "nombre_dx": "V961-ACCIDENTE DE ALA DELTA, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V962",
    "nombre_dx": "V962-ACCIDENTE DE PLANEADOR (SIN MOTOR), CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V968",
    "nombre_dx": "V968-ACCIDENTE DE OTRAS AERONAVES SIN MOTOR, CON OCUPANTE LESIONADO",
    "sexo": "A"
  },
  {
    "cod_dx": "V969",
    "nombre_dx": "V969-ACCIDENTE DE AERONAVE SIN MOTOR NO ESPECIFICADA, CON OCUPANTE LESIONADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V970",
    "nombre_dx": "V970-OCUPANTE DE AERONAVE LESIONADO EN OTROS ACCIDENTES ESPECIFICADOS DE TRANSPORTE AEREO",
    "sexo": "A"
  },
  {
    "cod_dx": "V971",
    "nombre_dx": "V971-PERSONA LESIONADA AL SUBIR O BAJAR DE UNA AERONAVE",
    "sexo": "A"
  },
  {
    "cod_dx": "V972",
    "nombre_dx": "V972-PARACAIDISTA LESIONADO EN ACCIDENTE DE TRANSPORTE AEREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V973",
    "nombre_dx": "V973-PERSONA EN TIERRA LESIONADA POR ACCIDENTE DE TRANSPORTE AEREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "V978",
    "nombre_dx": "V978-OTROS ACCIDENTES DE TRANSPORTE AEREO, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "V98X",
    "nombre_dx": "V98X-OTROS ACCIDENTES DE TRANSPORTE ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "V99X",
    "nombre_dx": "V99X-ACCIDENTE DE TRANSPORTE NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W000",
    "nombre_dx": "W000-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W001",
    "nombre_dx": "W001-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W002",
    "nombre_dx": "W002-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUB",
    "sexo": "A"
  },
  {
    "cod_dx": "W003",
    "nombre_dx": "W003-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W004",
    "nombre_dx": "W004-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W005",
    "nombre_dx": "W005-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W006",
    "nombre_dx": "W006-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W007",
    "nombre_dx": "W007-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W008",
    "nombre_dx": "W008-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W009",
    "nombre_dx": "W009-CAIDA EN EL MISMO NIVEL POR HIELO O NIEVE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W010",
    "nombre_dx": "W010-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W011",
    "nombre_dx": "W011-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W012",
    "nombre_dx": "W012-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W013",
    "nombre_dx": "W013-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W014",
    "nombre_dx": "W014-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W015",
    "nombre_dx": "W015-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W016",
    "nombre_dx": "W016-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W017",
    "nombre_dx": "W017-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W018",
    "nombre_dx": "W018-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W019",
    "nombre_dx": "W019-CAIDA EN EL MISMO NIVEL POR DESLIZAMIENTO, TROPEZON Y TRASPIE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W020",
    "nombre_dx": "W020-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W021",
    "nombre_dx": "W021-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W022",
    "nombre_dx": "W022-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: ESCUELAS, OTRAS INSTITUCIONES Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "W023",
    "nombre_dx": "W023-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W024",
    "nombre_dx": "W024-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W025",
    "nombre_dx": "W025-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W026",
    "nombre_dx": "W026-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: AREA INDUSTRIAL Y DE LA CONSTRUC",
    "sexo": "A"
  },
  {
    "cod_dx": "W027",
    "nombre_dx": "W027-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W028",
    "nombre_dx": "W028-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W029",
    "nombre_dx": "W029-CAIDA POR PATINES PARA HIELO, ESQUIS, PATINES DE RUEDAS O PATINETA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W030",
    "nombre_dx": "W030-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W031",
    "nombre_dx": "W031-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: INSTITUCION RESIDENCI",
    "sexo": "A"
  },
  {
    "cod_dx": "W032",
    "nombre_dx": "W032-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: ESCUELAS, OTRAS INSTI",
    "sexo": "A"
  },
  {
    "cod_dx": "W033",
    "nombre_dx": "W033-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: AREAS DE DEPORTE Y AT",
    "sexo": "A"
  },
  {
    "cod_dx": "W034",
    "nombre_dx": "W034-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W035",
    "nombre_dx": "W035-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: COMERCIO Y AREA DE SE",
    "sexo": "A"
  },
  {
    "cod_dx": "W036",
    "nombre_dx": "W036-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: AREA INDUSTRIAL Y DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "W037",
    "nombre_dx": "W037-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W038",
    "nombre_dx": "W038-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: OTRO LUGAR ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "W039",
    "nombre_dx": "W039-OTRAS CAIDAS EN EL MISMO NIVEL POR COLISION CON O POR EMPUJON DE OTRA PERSONA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W040",
    "nombre_dx": "W040-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W041",
    "nombre_dx": "W041-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W042",
    "nombre_dx": "W042-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "W043",
    "nombre_dx": "W043-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W044",
    "nombre_dx": "W044-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W045",
    "nombre_dx": "W045-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W046",
    "nombre_dx": "W046-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W047",
    "nombre_dx": "W047-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W048",
    "nombre_dx": "W048-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W049",
    "nombre_dx": "W049-CAIDA AL SER TRASLADADO O SOSTENIDO POR OTRAS PERSONAS:LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W050",
    "nombre_dx": "W050-CAIDA QUE IMPLICA SILLA DE RUEDAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W051",
    "nombre_dx": "W051-CAIDA QUE IMPLICA SILLA DE RUEDAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W052",
    "nombre_dx": "W052-CAIDA QUE IMPLICA SILLA DE RUEDAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W053",
    "nombre_dx": "W053-CAIDA QUE IMPLICA SILLA DE RUEDAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W054",
    "nombre_dx": "W054-CAIDA QUE IMPLICA SILLA DE RUEDAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W055",
    "nombre_dx": "W055-CAIDA QUE IMPLICA SILLA DE RUEDAS: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W056",
    "nombre_dx": "W056-CAIDA QUE IMPLICA SILLA DE RUEDAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W057",
    "nombre_dx": "W057-CAIDA QUE IMPLICA SILLA DE RUEDAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W058",
    "nombre_dx": "W058-CAIDA QUE IMPLICA SILLA DE RUEDAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W059",
    "nombre_dx": "W059-CAIDA QUE IMPLICA SILLA DE RUEDAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W060",
    "nombre_dx": "W060-CAIDA QUE IMPLICA CAMA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W061",
    "nombre_dx": "W061-CAIDA QUE IMPLICA CAMA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W062",
    "nombre_dx": "W062-CAIDA QUE IMPLICA CAMA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W063",
    "nombre_dx": "W063-CAIDA QUE IMPLICA CAMA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W064",
    "nombre_dx": "W064-CAIDA QUE IMPLICA CAMA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W065",
    "nombre_dx": "W065-CAIDA QUE IMPLICA CAMA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W066",
    "nombre_dx": "W066-CAIDA QUE IMPLICA CAMA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W067",
    "nombre_dx": "W067-CAIDA QUE IMPLICA CAMA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W068",
    "nombre_dx": "W068-CAIDA QUE IMPLICA CAMA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W069",
    "nombre_dx": "W069-CAIDA QUE IMPLICA CAMA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W070",
    "nombre_dx": "W070-CAIDA QUE IMPLICA SILLA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W071",
    "nombre_dx": "W071-CAIDA QUE IMPLICA SILLA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W072",
    "nombre_dx": "W072-CAIDA QUE IMPLICA SILLA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W073",
    "nombre_dx": "W073-CAIDA QUE IMPLICA SILLA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W074",
    "nombre_dx": "W074-CAIDA QUE IMPLICA SILLA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W075",
    "nombre_dx": "W075-CAIDA QUE IMPLICA SILLA: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W076",
    "nombre_dx": "W076-CAIDA QUE IMPLICA SILLA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W077",
    "nombre_dx": "W077-CAIDA QUE IMPLICA SILLA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W078",
    "nombre_dx": "W078-CAIDA QUE IMPLICA SILLA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W079",
    "nombre_dx": "W079-CAIDA QUE IMPLICA SILLA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W080",
    "nombre_dx": "W080-CAIDA QUE IMPLICAOTRO MUEBLE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W081",
    "nombre_dx": "W081-CAIDA QUE IMPLICAOTRO MUEBLE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W082",
    "nombre_dx": "W082-CAIDA QUE IMPLICAOTRO MUEBLE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W083",
    "nombre_dx": "W083-CAIDA QUE IMPLICAOTRO MUEBLE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W084",
    "nombre_dx": "W084-CAIDA QUE IMPLICAOTRO MUEBLE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W085",
    "nombre_dx": "W085-CAIDA QUE IMPLICAOTRO MUEBLE: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W086",
    "nombre_dx": "W086-CAIDA QUE IMPLICAOTRO MUEBLE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W087",
    "nombre_dx": "W087-CAIDA QUE IMPLICAOTRO MUEBLE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W088",
    "nombre_dx": "W088-CAIDA QUE IMPLICAOTRO MUEBLE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W089",
    "nombre_dx": "W089-CAIDA QUE IMPLICAOTRO MUEBLE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W090",
    "nombre_dx": "W090-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W091",
    "nombre_dx": "W091-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W092",
    "nombre_dx": "W092-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATI",
    "sexo": "A"
  },
  {
    "cod_dx": "W093",
    "nombre_dx": "W093-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W094",
    "nombre_dx": "W094-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W095",
    "nombre_dx": "W095-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W096",
    "nombre_dx": "W096-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W097",
    "nombre_dx": "W097-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W098",
    "nombre_dx": "W098-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W099",
    "nombre_dx": "W099-CAIDA QUE IMPLICA EQUIPOS PARA JUEGOS INFANTILES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W100",
    "nombre_dx": "W100-CAIDA EN O DESDE ESCALERA Y ESCALONES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W101",
    "nombre_dx": "W101-CAIDA EN O DESDE ESCALERA Y ESCALONES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W102",
    "nombre_dx": "W102-CAIDA EN O DESDE ESCALERA Y ESCALONES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "W103",
    "nombre_dx": "W103-CAIDA EN O DESDE ESCALERA Y ESCALONES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W104",
    "nombre_dx": "W104-CAIDA EN O DESDE ESCALERA Y ESCALONES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W105",
    "nombre_dx": "W105-CAIDA EN O DESDE ESCALERA Y ESCALONES: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W106",
    "nombre_dx": "W106-CAIDA EN O DESDE ESCALERA Y ESCALONES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W107",
    "nombre_dx": "W107-CAIDA EN O DESDE ESCALERA Y ESCALONES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W108",
    "nombre_dx": "W108-CAIDA EN O DESDE ESCALERA Y ESCALONES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W109",
    "nombre_dx": "W109-CAIDA EN O DESDE ESCALERA Y ESCALONES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W110",
    "nombre_dx": "W110-CAIDA EN O DESDE ESCALERAS MANUALES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W111",
    "nombre_dx": "W111-CAIDA EN O DESDE ESCALERAS MANUALES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W112",
    "nombre_dx": "W112-CAIDA EN O DESDE ESCALERAS MANUALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W113",
    "nombre_dx": "W113-CAIDA EN O DESDE ESCALERAS MANUALES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W114",
    "nombre_dx": "W114-CAIDA EN O DESDE ESCALERAS MANUALES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W115",
    "nombre_dx": "W115-CAIDA EN O DESDE ESCALERAS MANUALES: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W116",
    "nombre_dx": "W116-CAIDA EN O DESDE ESCALERAS MANUALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W117",
    "nombre_dx": "W117-CAIDA EN O DESDE ESCALERAS MANUALES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W118",
    "nombre_dx": "W118-CAIDA EN O DESDE ESCALERAS MANUALES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W119",
    "nombre_dx": "W119-CAIDA EN O DESDE ESCALERAS MANUALES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W120",
    "nombre_dx": "W120-CAIDA EN O DESDE ANDAMIO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W121",
    "nombre_dx": "W121-CAIDA EN O DESDE ANDAMIO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W122",
    "nombre_dx": "W122-CAIDA EN O DESDE ANDAMIO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W123",
    "nombre_dx": "W123-CAIDA EN O DESDE ANDAMIO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W124",
    "nombre_dx": "W124-CAIDA EN O DESDE ANDAMIO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W125",
    "nombre_dx": "W125-CAIDA EN O DESDE ANDAMIO: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W126",
    "nombre_dx": "W126-CAIDA EN O DESDE ANDAMIO: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W127",
    "nombre_dx": "W127-CAIDA EN O DESDE ANDAMIO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W128",
    "nombre_dx": "W128-CAIDA EN O DESDE ANDAMIO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W129",
    "nombre_dx": "W129-CAIDA EN O DESDE ANDAMIO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W130",
    "nombre_dx": "W130-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W131",
    "nombre_dx": "W131-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W132",
    "nombre_dx": "W132-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "W133",
    "nombre_dx": "W133-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W134",
    "nombre_dx": "W134-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W135",
    "nombre_dx": "W135-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W136",
    "nombre_dx": "W136-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "W137",
    "nombre_dx": "W137-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W138",
    "nombre_dx": "W138-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W139",
    "nombre_dx": "W139-CAIDA DESDE, FUERA O A TRAVÉS DE UN EDIFICIO U OTRA CONSTRUCCION: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W140",
    "nombre_dx": "W140-CAIDA DESDE UN ARBOL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W141",
    "nombre_dx": "W141-CAIDA DESDE UN ARBOL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W142",
    "nombre_dx": "W142-CAIDA DESDE UN ARBOL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W143",
    "nombre_dx": "W143-CAIDA DESDE UN ARBOL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W144",
    "nombre_dx": "W144-CAIDA DESDE UN ARBOL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W145",
    "nombre_dx": "W145-CAIDA DESDE UN ARBOL: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W146",
    "nombre_dx": "W146-CAIDA DESDE UN ARBOL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W147",
    "nombre_dx": "W147-CAIDA DESDE UN ARBOL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W148",
    "nombre_dx": "W148-CAIDA DESDE UN ARBOL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W149",
    "nombre_dx": "W149-CAIDA DESDE UN ARBOL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W150",
    "nombre_dx": "W150-CAIDA DESDE PEÑASCO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W151",
    "nombre_dx": "W151-CAIDA DESDE PEÑASCO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W152",
    "nombre_dx": "W152-CAIDA DESDE PEÑASCO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W153",
    "nombre_dx": "W153-CAIDA DESDE PEÑASCO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W154",
    "nombre_dx": "W154-CAIDA DESDE PEÑASCO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W155",
    "nombre_dx": "W155-CAIDA DESDE PEÑASCO: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W156",
    "nombre_dx": "W156-CAIDA DESDE PEÑASCO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W157",
    "nombre_dx": "W157-CAIDA DESDE PEÑASCO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W158",
    "nombre_dx": "W158-CAIDA DESDE PEÑASCO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W159",
    "nombre_dx": "W159-CAIDA DESDE PEÑASCO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W160",
    "nombre_dx": "W160-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W161",
    "nombre_dx": "W161-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: INSTITUCI",
    "sexo": "A"
  },
  {
    "cod_dx": "W162",
    "nombre_dx": "W162-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: ESCUELAS,",
    "sexo": "A"
  },
  {
    "cod_dx": "W163",
    "nombre_dx": "W163-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: AREAS DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "W164",
    "nombre_dx": "W164-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: CALLES Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "W165",
    "nombre_dx": "W165-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: COMERCIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W166",
    "nombre_dx": "W166-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: AREA INDU",
    "sexo": "A"
  },
  {
    "cod_dx": "W167",
    "nombre_dx": "W167-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W168",
    "nombre_dx": "W168-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: OTRO LUGA",
    "sexo": "A"
  },
  {
    "cod_dx": "W169",
    "nombre_dx": "W169-SALTO O ZAMBULLIDA DENTRO DEL AGUA QUE CAUSA OTRO TRAUMATISMO SIN SUMERSION O AHOGAMIENTO: LUGAR NO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W170",
    "nombre_dx": "W170-OTRAS CAIDAS DE UN NIVEL A OTRO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W171",
    "nombre_dx": "W171-OTRAS CAIDAS DE UN NIVEL A OTRO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W172",
    "nombre_dx": "W172-OTRAS CAIDAS DE UN NIVEL A OTRO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W173",
    "nombre_dx": "W173-OTRAS CAIDAS DE UN NIVEL A OTRO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W174",
    "nombre_dx": "W174-OTRAS CAIDAS DE UN NIVEL A OTRO:CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W175",
    "nombre_dx": "W175-OTRAS CAIDAS DE UN NIVEL A OTRO: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W176",
    "nombre_dx": "W176-OTRAS CAIDAS DE UN NIVEL A OTRO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W177",
    "nombre_dx": "W177-OTRAS CAIDAS DE UN NIVEL A OTRO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W178",
    "nombre_dx": "W178-OTRAS CAIDAS DE UN NIVEL A OTRO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W179",
    "nombre_dx": "W179-OTRAS CAIDAS DE UN NIVEL A OTRO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W180",
    "nombre_dx": "W180-OTRAS CAIDAS EN EL MISMO NIVEL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W181",
    "nombre_dx": "W181-OTRAS CAIDAS EN EL MISMO NIVEL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W182",
    "nombre_dx": "W182-OTRAS CAIDAS EN EL MISMO NIVEL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W183",
    "nombre_dx": "W183-OTRAS CAIDAS EN EL MISMO NIVEL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W184",
    "nombre_dx": "W184-OTRAS CAIDAS EN EL MISMO NIVEL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W185",
    "nombre_dx": "W185-OTRAS CAIDAS EN EL MISMO NIVEL: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W186",
    "nombre_dx": "W186-OTRAS CAIDAS EN EL MISMO NIVEL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W187",
    "nombre_dx": "W187-OTRAS CAIDAS EN EL MISMO NIVEL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W188",
    "nombre_dx": "W188-OTRAS CAIDAS EN EL MISMO NIVEL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W189",
    "nombre_dx": "W189-OTRAS CAIDAS EN EL MISMO NIVEL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W190",
    "nombre_dx": "W190-CAIDA NO ESPECIFICADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W191",
    "nombre_dx": "W191-CAIDA NO ESPECIFICADA: INSTITUCIÓN RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W192",
    "nombre_dx": "W192-CAIDA NO ESPECIFICADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W193",
    "nombre_dx": "W193-CAIDA NO ESPECIFICADA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W194",
    "nombre_dx": "W194-CAIDA NO ESPECIFICADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W195",
    "nombre_dx": "W195-CAIDA NO ESPECIFICADA: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W196",
    "nombre_dx": "W196-CAIDA NO ESPECIFICADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W197",
    "nombre_dx": "W197-CAIDA NO ESPECIFICADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W198",
    "nombre_dx": "W198-CAIDA NO ESPECIFICADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W199",
    "nombre_dx": "W199-CAIDA NO ESPECIFICADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W200",
    "nombre_dx": "W200-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W201",
    "nombre_dx": "W201-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W202",
    "nombre_dx": "W202-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIV",
    "sexo": "A"
  },
  {
    "cod_dx": "W203",
    "nombre_dx": "W203-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W204",
    "nombre_dx": "W204-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W205",
    "nombre_dx": "W205-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W206",
    "nombre_dx": "W206-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W207",
    "nombre_dx": "W207-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W208",
    "nombre_dx": "W208-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W209",
    "nombre_dx": "W209-GOLPE POR OBJETO ARROJADO, PROYECTADO O QUE CAE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W210",
    "nombre_dx": "W210-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES:VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W211",
    "nombre_dx": "W211-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W212",
    "nombre_dx": "W212-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATI",
    "sexo": "A"
  },
  {
    "cod_dx": "W213",
    "nombre_dx": "W213-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W214",
    "nombre_dx": "W214-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W215",
    "nombre_dx": "W215-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W216",
    "nombre_dx": "W216-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W217",
    "nombre_dx": "W217-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W218",
    "nombre_dx": "W218-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W219",
    "nombre_dx": "W219-GOLPE CONTRA O GOLPEADO POR EQUIPO PARA DEPORTES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W220",
    "nombre_dx": "W220-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W221",
    "nombre_dx": "W221-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W222",
    "nombre_dx": "W222-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUB",
    "sexo": "A"
  },
  {
    "cod_dx": "W223",
    "nombre_dx": "W223-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: AREASDE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W224",
    "nombre_dx": "W224-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W225",
    "nombre_dx": "W225-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W226",
    "nombre_dx": "W226-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W227",
    "nombre_dx": "W227-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W228",
    "nombre_dx": "W228-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W229",
    "nombre_dx": "W229-GOLPE CONTRA O GOLPEADO POR OTROS OBJETOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W230",
    "nombre_dx": "W230-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W231",
    "nombre_dx": "W231-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W232",
    "nombre_dx": "W232-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS AD",
    "sexo": "A"
  },
  {
    "cod_dx": "W233",
    "nombre_dx": "W233-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W234",
    "nombre_dx": "W234-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W235",
    "nombre_dx": "W235-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W236",
    "nombre_dx": "W236-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W237",
    "nombre_dx": "W237-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W238",
    "nombre_dx": "W238-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W239",
    "nombre_dx": "W239-ATRAPADO, APLASTADO, TRABADO O APRETADO EN O ENTRE OBJETOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W240",
    "nombre_dx": "W240-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: VIV",
    "sexo": "A"
  },
  {
    "cod_dx": "W241",
    "nombre_dx": "W241-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: INS",
    "sexo": "A"
  },
  {
    "cod_dx": "W242",
    "nombre_dx": "W242-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: ESC",
    "sexo": "A"
  },
  {
    "cod_dx": "W243",
    "nombre_dx": "W243-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "W244",
    "nombre_dx": "W244-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: CAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W245",
    "nombre_dx": "W245-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: COM",
    "sexo": "A"
  },
  {
    "cod_dx": "W246",
    "nombre_dx": "W246-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "W247",
    "nombre_dx": "W247-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: GRA",
    "sexo": "A"
  },
  {
    "cod_dx": "W248",
    "nombre_dx": "W248-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W249",
    "nombre_dx": "W249-CONTACTO TRAUMATICO CON DISPOSITIVOS DE ELEVACION YTRANSMISION, NO CLASIFICADOS EN OTRA PARTE: LUG",
    "sexo": "A"
  },
  {
    "cod_dx": "W250",
    "nombre_dx": "W250-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W251",
    "nombre_dx": "W251-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W252",
    "nombre_dx": "W252-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLI",
    "sexo": "A"
  },
  {
    "cod_dx": "W253",
    "nombre_dx": "W253-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W254",
    "nombre_dx": "W254-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W255",
    "nombre_dx": "W255-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W256",
    "nombre_dx": "W256-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W257",
    "nombre_dx": "W257-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W258",
    "nombre_dx": "W258-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W259",
    "nombre_dx": "W259-CONTACTO TRAUMATICO CON VIDRIO CORTANTE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W260",
    "nombre_dx": "W260-Contacto traumatico con cuchillo, espada o daga",
    "sexo": "A"
  },
  {
    "cod_dx": "W261",
    "nombre_dx": "W261-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W262",
    "nombre_dx": "W262-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINI",
    "sexo": "A"
  },
  {
    "cod_dx": "W263",
    "nombre_dx": "W263-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W264",
    "nombre_dx": "W264-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W265",
    "nombre_dx": "W265-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W266",
    "nombre_dx": "W266-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W267",
    "nombre_dx": "W267-CONTACTO TRAUMATICO CON CUCHILLO, ESPADA, DAGA O PUÑAL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W268",
    "nombre_dx": "W268-Contacto traumatico con otro(s) objeto(s) afilado(s) en otra parte",
    "sexo": "A"
  },
  {
    "cod_dx": "W269",
    "nombre_dx": "W269-Contacto traumatico con otros objetos puntiagudos no especificados ",
    "sexo": "A"
  },
  {
    "cod_dx": "W270",
    "nombre_dx": "W270-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W271",
    "nombre_dx": "W271-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W272",
    "nombre_dx": "W272-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "W273",
    "nombre_dx": "W273-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W274",
    "nombre_dx": "W274-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W275",
    "nombre_dx": "W275-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W276",
    "nombre_dx": "W276-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W277",
    "nombre_dx": "W277-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W278",
    "nombre_dx": "W278-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W279",
    "nombre_dx": "W279-CONTACTO TRAUMATICO CON HERRAMIENTAS MANUALES SIN MOTOR: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W280",
    "nombre_dx": "W280-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W281",
    "nombre_dx": "W281-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CONMOTOR: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W282",
    "nombre_dx": "W282-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINI",
    "sexo": "A"
  },
  {
    "cod_dx": "W283",
    "nombre_dx": "W283-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W284",
    "nombre_dx": "W284-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W285",
    "nombre_dx": "W285-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W286",
    "nombre_dx": "W286-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W287",
    "nombre_dx": "W287-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W288",
    "nombre_dx": "W288-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W289",
    "nombre_dx": "W289-CONTACTO TRAUMATICO CON CORTADORA DE CESPED, CON MOTOR: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W290",
    "nombre_dx": "W290-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W291",
    "nombre_dx": "W291-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: INSTITUCION R",
    "sexo": "A"
  },
  {
    "cod_dx": "W292",
    "nombre_dx": "W292-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: ESCUELAS, OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W293",
    "nombre_dx": "W293-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: AREAS DE DEPO",
    "sexo": "A"
  },
  {
    "cod_dx": "W294",
    "nombre_dx": "W294-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: CALLES Y CARR",
    "sexo": "A"
  },
  {
    "cod_dx": "W295",
    "nombre_dx": "W295-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: COMERCIO Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "W296",
    "nombre_dx": "W296-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: AREA INDUSTRI",
    "sexo": "A"
  },
  {
    "cod_dx": "W297",
    "nombre_dx": "W297-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W298",
    "nombre_dx": "W298-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: OTRO LUGAR ES",
    "sexo": "A"
  },
  {
    "cod_dx": "W299",
    "nombre_dx": "W299-CONTACTO TRAUMATICO CON OTRAS HERRAMIENTAS MANUALES Y ARTEFACTOS DEL HOGAR, CON MOTOR: LUGAR NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "W300",
    "nombre_dx": "W300-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W301",
    "nombre_dx": "W301-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W302",
    "nombre_dx": "W302-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS P",
    "sexo": "A"
  },
  {
    "cod_dx": "W303",
    "nombre_dx": "W303-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W304",
    "nombre_dx": "W304-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W305",
    "nombre_dx": "W305-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W306",
    "nombre_dx": "W306-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W307",
    "nombre_dx": "W307-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W308",
    "nombre_dx": "W308-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W309",
    "nombre_dx": "W309-CONTACTO TRAUMATICO CON MAQUINARIA AGRICOLA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W310",
    "nombre_dx": "W310-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W311",
    "nombre_dx": "W311-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W312",
    "nombre_dx": "W312-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "W313",
    "nombre_dx": "W313-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W314",
    "nombre_dx": "W314-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W315",
    "nombre_dx": "W315-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "W316",
    "nombre_dx": "W316-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "W317",
    "nombre_dx": "W317-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W318",
    "nombre_dx": "W318-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W319",
    "nombre_dx": "W319-CONTACTO TRAUMATICO CON OTRAS MAQUINARIAS Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W320",
    "nombre_dx": "W320-DISPARO DE ARMA CORTA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W321",
    "nombre_dx": "W321-DISPARO DE ARMA CORTA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W322",
    "nombre_dx": "W322-DISPARO DE ARMA CORTA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W323",
    "nombre_dx": "W323-DISPARO DE ARMA CORTA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W324",
    "nombre_dx": "W324-DISPARO DE ARMA CORTA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W325",
    "nombre_dx": "W325-DISPARO DE ARMA CORTA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W326",
    "nombre_dx": "W326-DISPARO DE ARMA CORTA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W327",
    "nombre_dx": "W327-DISPARO DE ARMA CORTA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W328",
    "nombre_dx": "W328-DISPARO DE ARMA CORTA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W329",
    "nombre_dx": "W329-DISPARO DE ARMA CORTA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W330",
    "nombre_dx": "W330-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W331",
    "nombre_dx": "W331-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W332",
    "nombre_dx": "W332-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLI",
    "sexo": "A"
  },
  {
    "cod_dx": "W333",
    "nombre_dx": "W333-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W334",
    "nombre_dx": "W334-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W335",
    "nombre_dx": "W335-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W336",
    "nombre_dx": "W336-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W337",
    "nombre_dx": "W337-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W338",
    "nombre_dx": "W338-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W339",
    "nombre_dx": "W339-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W340",
    "nombre_dx": "W340-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W341",
    "nombre_dx": "W341-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W342",
    "nombre_dx": "W342-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "W343",
    "nombre_dx": "W343-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W344",
    "nombre_dx": "W344-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W345",
    "nombre_dx": "W345-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS:COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W346",
    "nombre_dx": "W346-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W347",
    "nombre_dx": "W347-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W348",
    "nombre_dx": "W348-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W349",
    "nombre_dx": "W349-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W350",
    "nombre_dx": "W350-EXPLOSION Y ROTURA DE CALDERA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W351",
    "nombre_dx": "W351-EXPLOSION Y ROTURA DE CALDERA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W352",
    "nombre_dx": "W352-EXPLOSION Y ROTURA DE CALDERA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W353",
    "nombre_dx": "W353-EXPLOSION Y ROTURA DE CALDERA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W354",
    "nombre_dx": "W354-EXPLOSION Y ROTURA DE CALDERA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W355",
    "nombre_dx": "W355-EXPLOSION Y ROTURA DE CALDERA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W356",
    "nombre_dx": "W356-EXPLOSION Y ROTURA DE CALDERA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W357",
    "nombre_dx": "W357-EXPLOSION Y ROTURA DE CALDERA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W358",
    "nombre_dx": "W358-EXPLOSION Y ROTURA DE CALDERA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W359",
    "nombre_dx": "W359-EXPLOSION Y ROTURA DE CALDERA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W360",
    "nombre_dx": "W360-EXPLOSION Y ROTURA DE CILINDRO CON GAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W361",
    "nombre_dx": "W361-EXPLOSION Y ROTURA DE CILINDRO CON GAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W362",
    "nombre_dx": "W362-EXPLOSION Y ROTURA DE CILINDRO CON GAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLIC",
    "sexo": "A"
  },
  {
    "cod_dx": "W363",
    "nombre_dx": "W363-EXPLOSION Y ROTURA DE CILINDRO CON GAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W364",
    "nombre_dx": "W364-EXPLOSION Y ROTURA DE CILINDRO CON GAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W365",
    "nombre_dx": "W365-EXPLOSION Y ROTURA DE CILINDRO CON GAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W366",
    "nombre_dx": "W366-EXPLOSION Y ROTURA DE CILINDRO CON GAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W367",
    "nombre_dx": "W367-EXPLOSION Y ROTURA DE CILINDRO CON GAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W368",
    "nombre_dx": "W368-EXPLOSION Y ROTURA DE CILINDRO CON GAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W369",
    "nombre_dx": "W369-EXPLOSION Y ROTURA DE CILINDRO CON GAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W370",
    "nombre_dx": "W370-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W371",
    "nombre_dx": "W371-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W372",
    "nombre_dx": "W372-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: ESCUELAS, OTRAS INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "W373",
    "nombre_dx": "W373-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W374",
    "nombre_dx": "W374-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W375",
    "nombre_dx": "W375-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W376",
    "nombre_dx": "W376-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: AREA INDUSTRIAL Y DE LA CONSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W377",
    "nombre_dx": "W377-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W378",
    "nombre_dx": "W378-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W379",
    "nombre_dx": "W379-EXPLOSION Y ROTURA DE NEUMATICO, TUBO O MANGUERA DE GOMA PRESURIZADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W380",
    "nombre_dx": "W380-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W381",
    "nombre_dx": "W381-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W382",
    "nombre_dx": "W382-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y",
    "sexo": "A"
  },
  {
    "cod_dx": "W383",
    "nombre_dx": "W383-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W384",
    "nombre_dx": "W384-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W385",
    "nombre_dx": "W385-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W386",
    "nombre_dx": "W386-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRU",
    "sexo": "A"
  },
  {
    "cod_dx": "W387",
    "nombre_dx": "W387-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W388",
    "nombre_dx": "W388-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W389",
    "nombre_dx": "W389-EXPLOSION Y ROTURA DE OTROS DISPOSITIVOS PRESURIZADOS ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W390",
    "nombre_dx": "W390-EXPLOSION DE FUEGOS ARTIFICIALES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W391",
    "nombre_dx": "W391-EXPLOSION DE FUEGOS ARTIFICIALES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W392",
    "nombre_dx": "W392-EXPLOSION DE FUEGOS ARTIFICIALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W393",
    "nombre_dx": "W393-EXPLOSION DE FUEGOS ARTIFICIALES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W394",
    "nombre_dx": "W394-EXPLOSION DE FUEGOS ARTIFICIALES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W395",
    "nombre_dx": "W395-EXPLOSION DE FUEGOS ARTIFICIALES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W396",
    "nombre_dx": "W396-EXPLOSION DE FUEGOS ARTIFICIALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W397",
    "nombre_dx": "W397-EXPLOSION DE FUEGOS ARTIFICIALES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W398",
    "nombre_dx": "W398-EXPLOSION DE FUEGOS ARTIFICIALES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W399",
    "nombre_dx": "W399-EXPLOSION DE FUEGOS ARTIFICIALES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W400",
    "nombre_dx": "W400-EXPLOSION DE OTROS MATERIALES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W401",
    "nombre_dx": "W401-EXPLOSION DE OTROS MATERIALES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W402",
    "nombre_dx": "W402-EXPLOSION DE OTROS MATERIALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W403",
    "nombre_dx": "W403-EXPLOSION DE OTROS MATERIALES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W404",
    "nombre_dx": "W404-EXPLOSION DE OTROS MATERIALES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W405",
    "nombre_dx": "W405-EXPLOSION DE OTROS MATERIALES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W406",
    "nombre_dx": "W406-EXPLOSION DE OTROS MATERIALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W407",
    "nombre_dx": "W407-EXPLOSION DE OTROS MATERIALES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W408",
    "nombre_dx": "W408-EXPLOSION DE OTROS MATERIALES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W409",
    "nombre_dx": "W409-EXPLOSION DE OTROS MATERIALES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W410",
    "nombre_dx": "W410-EXPOSICION A CHORRO DE ALTA PRESION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W411",
    "nombre_dx": "W411-EXPOSICION A CHORRO DE ALTA PRESION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W412",
    "nombre_dx": "W412-EXPOSICION A CHORRO DE ALTA PRESION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W413",
    "nombre_dx": "W413-EXPOSICION A CHORRO DE ALTA PRESION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W414",
    "nombre_dx": "W414-EXPOSICION A CHORRO DE ALTA PRESION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W415",
    "nombre_dx": "W415-EXPOSICION A CHORRO DE ALTA PRESION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W416",
    "nombre_dx": "W416-EXPOSICION A CHORRO DE ALTA PRESION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W417",
    "nombre_dx": "W417-EXPOSICION A CHORRO DE ALTA PRESION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W418",
    "nombre_dx": "W418-EXPOSICION A CHORRO DE ALTA PRESION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W419",
    "nombre_dx": "W419-EXPOSICION A CHORRO DE ALTA PRESION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W420",
    "nombre_dx": "W420-EXPOSICION AL RUIDO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W421",
    "nombre_dx": "W421-EXPOSICION AL RUIDO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W422",
    "nombre_dx": "W422-EXPOSICION AL RUIDO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W423",
    "nombre_dx": "W423-EXPOSICION AL RUIDO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W424",
    "nombre_dx": "W424-EXPOSICION AL RUIDO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W425",
    "nombre_dx": "W425-EXPOSICION AL RUIDO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W426",
    "nombre_dx": "W426-EXPOSICION AL RUIDO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W427",
    "nombre_dx": "W427-EXPOSICION AL RUIDO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W428",
    "nombre_dx": "W428-EXPOSICION AL RUIDO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W429",
    "nombre_dx": "W429-EXPOSICION AL RUIDO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W430",
    "nombre_dx": "W430-EXPOSICION A VIBRACIONES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W431",
    "nombre_dx": "W431-EXPOSICION A VIBRACIONES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W432",
    "nombre_dx": "W432-EXPOSICION A VIBRACIONES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W433",
    "nombre_dx": "W433-EXPOSICION A VIBRACIONES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W434",
    "nombre_dx": "W434-EXPOSICION A VIBRACIONES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W435",
    "nombre_dx": "W435-EXPOSICION A VIBRACIONES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W436",
    "nombre_dx": "W436-EXPOSICION A VIBRACIONES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W437",
    "nombre_dx": "W437-EXPOSICION A VIBRACIONES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W438",
    "nombre_dx": "W438-EXPOSICION A VIBRACIONES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W439",
    "nombre_dx": "W439-EXPOSICION A VIBRACIONES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W440",
    "nombre_dx": "W440-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W441",
    "nombre_dx": "W441-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W442",
    "nombre_dx": "W442-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMI",
    "sexo": "A"
  },
  {
    "cod_dx": "W443",
    "nombre_dx": "W443-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W444",
    "nombre_dx": "W444-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W445",
    "nombre_dx": "W445-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W446",
    "nombre_dx": "W446-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W447",
    "nombre_dx": "W447-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W448",
    "nombre_dx": "W448-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W449",
    "nombre_dx": "W449-CUERPO EXTRAÑO QUE PENETRA POR EL OJO U ORIFICIO NATURAL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W450",
    "nombre_dx": "W450-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W451",
    "nombre_dx": "W451-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W452",
    "nombre_dx": "W452-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "W453",
    "nombre_dx": "W453-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W454",
    "nombre_dx": "W454-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W455",
    "nombre_dx": "W455-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W456",
    "nombre_dx": "W456-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W457",
    "nombre_dx": "W457-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W458",
    "nombre_dx": "W458-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W459",
    "nombre_dx": "W459-CUERPO EXTRAÑO QUE PENETRA A TRAVES DE LA PIEL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W490",
    "nombre_dx": "W490-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W491",
    "nombre_dx": "W491-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W492",
    "nombre_dx": "W492-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W493",
    "nombre_dx": "W493-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "W494",
    "nombre_dx": "W494-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W495",
    "nombre_dx": "W495-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICI",
    "sexo": "A"
  },
  {
    "cod_dx": "W496",
    "nombre_dx": "W496-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "W497",
    "nombre_dx": "W497-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W498",
    "nombre_dx": "W498-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W499",
    "nombre_dx": "W499-EXPOSICION A OTRAS FUERZAS MECANICAS INANIMADAS, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W500",
    "nombre_dx": "W500-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W501",
    "nombre_dx": "W501-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: INSTITUCION RESI",
    "sexo": "A"
  },
  {
    "cod_dx": "W502",
    "nombre_dx": "W502-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: ESCUELAS, OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W503",
    "nombre_dx": "W503-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: AREAS DE DEPORTE",
    "sexo": "A"
  },
  {
    "cod_dx": "W504",
    "nombre_dx": "W504-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: CALLES Y CARRETE",
    "sexo": "A"
  },
  {
    "cod_dx": "W505",
    "nombre_dx": "W505-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: COMERCIO Y AREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W506",
    "nombre_dx": "W506-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: AREA INDUSTRIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W507",
    "nombre_dx": "W507-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W508",
    "nombre_dx": "W508-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: OTRO LUGAR ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "W509",
    "nombre_dx": "W509-APORREO, GOLPE, MORDEDURA, PATADA, RASGUÑO O TORCEDURA INFLIGIDOS POR OTRA PERSONA: LUGAR NO ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "W510",
    "nombre_dx": "W510-CHOQUE O EMPELLON CONTRA OTRA PERSONA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W511",
    "nombre_dx": "W511-CHOQUE O EMPELLON CONTRA OTRA PERSONA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W512",
    "nombre_dx": "W512-CHOQUE O EMPELLON CONTRA OTRA PERSONA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "W513",
    "nombre_dx": "W513-CHOQUE O EMPELLON CONTRA OTRA PERSONA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W514",
    "nombre_dx": "W514-CHOQUE O EMPELLON CONTRA OTRA PERSONA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W515",
    "nombre_dx": "W515-CHOQUE O EMPELLON CONTRA OTRA PERSONA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W516",
    "nombre_dx": "W516-CHOQUE O EMPELLON CONTRA OTRA PERSONA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W517",
    "nombre_dx": "W517-CHOQUE O EMPELLON CONTRA OTRA PERSONA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W518",
    "nombre_dx": "W518-CHOQUE O EMPELLON CONTRA OTRA PERSONA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W519",
    "nombre_dx": "W519-CHOQUE O EMPELLON CONTRA OTRA PERSONA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W520",
    "nombre_dx": "W520-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W521",
    "nombre_dx": "W521-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W522",
    "nombre_dx": "W522-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: ESCUELAS, OTRAS INSTITU",
    "sexo": "A"
  },
  {
    "cod_dx": "W523",
    "nombre_dx": "W523-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: AREAS DE DEPORTE Y ATLE",
    "sexo": "A"
  },
  {
    "cod_dx": "W524",
    "nombre_dx": "W524-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W525",
    "nombre_dx": "W525-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: COMERCIO Y AREAS DE SER",
    "sexo": "A"
  },
  {
    "cod_dx": "W526",
    "nombre_dx": "W526-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: AREA INDUSTRIAL Y DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "W527",
    "nombre_dx": "W527-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W528",
    "nombre_dx": "W528-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W529",
    "nombre_dx": "W529-PERSONA APLASTADA, EMPUJADA O PISOTEADA POR UNA MULTITUD O ESTAMPIDA HUMANA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W530",
    "nombre_dx": "W530-MORDEDURA DE RATA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W531",
    "nombre_dx": "W531-MORDEDURA DE RATA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W532",
    "nombre_dx": "W532-MORDEDURA DE RATA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W533",
    "nombre_dx": "W533-MORDEDURA DE RATA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W534",
    "nombre_dx": "W534-MORDEDURA DE RATA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W535",
    "nombre_dx": "W535-MORDEDURA DE RATA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W536",
    "nombre_dx": "W536-MORDEDURA DE RATA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W537",
    "nombre_dx": "W537-MORDEDURA DE RATA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W538",
    "nombre_dx": "W538-MORDEDURA DE RATA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W539",
    "nombre_dx": "W539-MORDEDURA DE RATA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W540",
    "nombre_dx": "W540-MORDEDURA O ATAQUE DE PERRO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W541",
    "nombre_dx": "W541-MORDEDURA O ATAQUE DE PERRO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W542",
    "nombre_dx": "W542-MORDEDURA O ATAQUE DE PERRO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W543",
    "nombre_dx": "W543-MORDEDURA O ATAQUE DE PERRO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W544",
    "nombre_dx": "W544-MORDEDURA O ATAQUE DE PERRO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W545",
    "nombre_dx": "W545-MORDEDURA O ATAQUE DE PERRO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W546",
    "nombre_dx": "W546-MORDEDURA O ATAQUE DE PERRO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W547",
    "nombre_dx": "W547-MORDEDURA O ATAQUE DE PERRO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W548",
    "nombre_dx": "W548-MORDEDURA O ATAQUE DE PERRO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W549",
    "nombre_dx": "W549-MORDEDURA O ATAQUE DE PERRO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W550",
    "nombre_dx": "W550-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W551",
    "nombre_dx": "W551-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W552",
    "nombre_dx": "W552-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "W553",
    "nombre_dx": "W553-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W554",
    "nombre_dx": "W554-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W555",
    "nombre_dx": "W555-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W556",
    "nombre_dx": "W556-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W557",
    "nombre_dx": "W557-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W558",
    "nombre_dx": "W558-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W559",
    "nombre_dx": "W559-MORDEDURA O ATAQUE DE OTROS MAMIFEROS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W560",
    "nombre_dx": "W560-CONTACTO TRAUMATICO CON ANIMALES MARINOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W561",
    "nombre_dx": "W561-CONTACTO TRAUMATICO CON ANIMALES MARINOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W562",
    "nombre_dx": "W562-CONTACTO TRAUMATICO CON ANIMALES MARINOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBL",
    "sexo": "A"
  },
  {
    "cod_dx": "W563",
    "nombre_dx": "W563-CONTACTO TRAUMATICO CON ANIMALES MARINOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W564",
    "nombre_dx": "W564-CONTACTO TRAUMATICO CON ANIMALES MARINOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W565",
    "nombre_dx": "W565-CONTACTO TRAUMATICO CON ANIMALES MARINOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W566",
    "nombre_dx": "W566-CONTACTO TRAUMATICO CON ANIMALES MARINOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W567",
    "nombre_dx": "W567-CONTACTO TRAUMATICO CON ANIMALES MARINOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W568",
    "nombre_dx": "W568-CONTACTO TRAUMATICO CON ANIMALES MARINOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W569",
    "nombre_dx": "W569-CONTACTO TRAUMATICO CON ANIMALES MARINOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W570",
    "nombre_dx": "W570-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W571",
    "nombre_dx": "W571-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W572",
    "nombre_dx": "W572-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "W573",
    "nombre_dx": "W573-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W574",
    "nombre_dx": "W574-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W575",
    "nombre_dx": "W575-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W576",
    "nombre_dx": "W576-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "W577",
    "nombre_dx": "W577-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W578",
    "nombre_dx": "W578-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W579",
    "nombre_dx": "W579-MORDEDURA O PICADURA DE INSECTOS Y OTROS ARTROPODOS NO VENENOSOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W580",
    "nombre_dx": "W580-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W581",
    "nombre_dx": "W581-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W582",
    "nombre_dx": "W582-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBL",
    "sexo": "A"
  },
  {
    "cod_dx": "W583",
    "nombre_dx": "W583-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W584",
    "nombre_dx": "W584-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W585",
    "nombre_dx": "W585-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W586",
    "nombre_dx": "W586-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W587",
    "nombre_dx": "W587-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W588",
    "nombre_dx": "W588-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W589",
    "nombre_dx": "W589-MORDEDURA O ATAQUE DE COCODRILO O CAIMAN: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W590",
    "nombre_dx": "W590-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W591",
    "nombre_dx": "W591-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W592",
    "nombre_dx": "W592-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W593",
    "nombre_dx": "W593-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W594",
    "nombre_dx": "W594-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W595",
    "nombre_dx": "W595-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W596",
    "nombre_dx": "W596-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W597",
    "nombre_dx": "W597-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W598",
    "nombre_dx": "W598-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W599",
    "nombre_dx": "W599-MORDEDURA O APLASTAMIENTO POR OTROS REPTILES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W600",
    "nombre_dx": "W600-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W601",
    "nombre_dx": "W601-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W602",
    "nombre_dx": "W602-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: ESCUELAS, OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W603",
    "nombre_dx": "W603-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "W604",
    "nombre_dx": "W604-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W605",
    "nombre_dx": "W605-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: COMERCIO Y AREAS DE SERVICI",
    "sexo": "A"
  },
  {
    "cod_dx": "W606",
    "nombre_dx": "W606-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "W607",
    "nombre_dx": "W607-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W608",
    "nombre_dx": "W608-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W609",
    "nombre_dx": "W609-CONTACTO TRAUMATICO CON AGUIJONES, ESPINAS U HOJAS CORTANTES DE PLANTAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W640",
    "nombre_dx": "W640-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W641",
    "nombre_dx": "W641-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W642",
    "nombre_dx": "W642-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "W643",
    "nombre_dx": "W643-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W644",
    "nombre_dx": "W644-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W645",
    "nombre_dx": "W645-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W646",
    "nombre_dx": "W646-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONST",
    "sexo": "A"
  },
  {
    "cod_dx": "W647",
    "nombre_dx": "W647-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W648",
    "nombre_dx": "W648-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W649",
    "nombre_dx": "W649-EXPOSICION A OTRAS FUERZAS MECANICAS ANIMADAS, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W650",
    "nombre_dx": "W650-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W651",
    "nombre_dx": "W651-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W652",
    "nombre_dx": "W652-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINIS",
    "sexo": "A"
  },
  {
    "cod_dx": "W653",
    "nombre_dx": "W653-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W654",
    "nombre_dx": "W654-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W655",
    "nombre_dx": "W655-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W656",
    "nombre_dx": "W656-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W657",
    "nombre_dx": "W657-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W658",
    "nombre_dx": "W658-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W659",
    "nombre_dx": "W659-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN LA BAÑERA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W660",
    "nombre_dx": "W660-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W661",
    "nombre_dx": "W661-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W662",
    "nombre_dx": "W662-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADM",
    "sexo": "A"
  },
  {
    "cod_dx": "W663",
    "nombre_dx": "W663-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W664",
    "nombre_dx": "W664-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W665",
    "nombre_dx": "W665-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W666",
    "nombre_dx": "W666-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W667",
    "nombre_dx": "W667-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W668",
    "nombre_dx": "W668-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W669",
    "nombre_dx": "W669-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN LA BAÑERA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W670",
    "nombre_dx": "W670-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W671",
    "nombre_dx": "W671-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W672",
    "nombre_dx": "W672-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "W673",
    "nombre_dx": "W673-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W674",
    "nombre_dx": "W674-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W675",
    "nombre_dx": "W675-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W676",
    "nombre_dx": "W676-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W677",
    "nombre_dx": "W677-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W678",
    "nombre_dx": "W678-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W679",
    "nombre_dx": "W679-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN UNA PISCINA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W680",
    "nombre_dx": "W680-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W681",
    "nombre_dx": "W681-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W682",
    "nombre_dx": "W682-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS A",
    "sexo": "A"
  },
  {
    "cod_dx": "W683",
    "nombre_dx": "W683-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W684",
    "nombre_dx": "W684-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W685",
    "nombre_dx": "W685-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W686",
    "nombre_dx": "W686-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W687",
    "nombre_dx": "W687-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W688",
    "nombre_dx": "W688-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W689",
    "nombre_dx": "W689-AHOGAMIENTO Y SUMERSION CONSECUTIVOS A CAIDA EN UNA PISCINA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W690",
    "nombre_dx": "W690-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W691",
    "nombre_dx": "W691-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W692",
    "nombre_dx": "W692-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS A",
    "sexo": "A"
  },
  {
    "cod_dx": "W693",
    "nombre_dx": "W693-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W694",
    "nombre_dx": "W694-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W695",
    "nombre_dx": "W695-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W696",
    "nombre_dx": "W696-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W697",
    "nombre_dx": "W697-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W698",
    "nombre_dx": "W698-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W699",
    "nombre_dx": "W699-AHOGAMIENTO Y SUMERSION MIENTRAS SE ESTA EN AGUAS NATURALES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W700",
    "nombre_dx": "W700-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W701",
    "nombre_dx": "W701-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W702",
    "nombre_dx": "W702-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W703",
    "nombre_dx": "W703-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W704",
    "nombre_dx": "W704-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W705",
    "nombre_dx": "W705-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W706",
    "nombre_dx": "W706-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W707",
    "nombre_dx": "W707-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W708",
    "nombre_dx": "W708-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W709",
    "nombre_dx": "W709-AHOGAMIENTO Y SUMERSION POSTERIOR A CAIDA EN AGUAS NATURALES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W730",
    "nombre_dx": "W730-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W731",
    "nombre_dx": "W731-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W732",
    "nombre_dx": "W732-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "W733",
    "nombre_dx": "W733-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W734",
    "nombre_dx": "W734-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W735",
    "nombre_dx": "W735-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W736",
    "nombre_dx": "W736-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W737",
    "nombre_dx": "W737-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W738",
    "nombre_dx": "W738-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W739",
    "nombre_dx": "W739-OTROS AHOGAMIENTOS Y SUMERSIONES ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W740",
    "nombre_dx": "W740-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W741",
    "nombre_dx": "W741-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W742",
    "nombre_dx": "W742-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBL",
    "sexo": "A"
  },
  {
    "cod_dx": "W743",
    "nombre_dx": "W743-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W744",
    "nombre_dx": "W744-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W745",
    "nombre_dx": "W745-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W746",
    "nombre_dx": "W746-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W747",
    "nombre_dx": "W747-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W748",
    "nombre_dx": "W748-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W749",
    "nombre_dx": "W749-AHOGAMIENTO Y SUMERSION NO ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W750",
    "nombre_dx": "W750-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W751",
    "nombre_dx": "W751-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W752",
    "nombre_dx": "W752-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W753",
    "nombre_dx": "W753-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W754",
    "nombre_dx": "W754-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W755",
    "nombre_dx": "W755-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W756",
    "nombre_dx": "W756-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W757",
    "nombre_dx": "W757-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W758",
    "nombre_dx": "W758-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W759",
    "nombre_dx": "W759-SOFOCACION Y ESTRANGULAMIENTO ACCIDENTAL EN LA CAMA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W760",
    "nombre_dx": "W760-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W761",
    "nombre_dx": "W761-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W762",
    "nombre_dx": "W762-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINIST",
    "sexo": "A"
  },
  {
    "cod_dx": "W763",
    "nombre_dx": "W763-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W764",
    "nombre_dx": "W764-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W765",
    "nombre_dx": "W765-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W766",
    "nombre_dx": "W766-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W767",
    "nombre_dx": "W767-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W768",
    "nombre_dx": "W768-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W769",
    "nombre_dx": "W769-OTROS ESTRANGULAMIENTOS Y AHORCAMIENTOS ACCIDENTALES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W770",
    "nombre_dx": "W770-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W771",
    "nombre_dx": "W771-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: INSTITUCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W772",
    "nombre_dx": "W772-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: ESCUELAS, OT",
    "sexo": "A"
  },
  {
    "cod_dx": "W773",
    "nombre_dx": "W773-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: AREAS DE DEP",
    "sexo": "A"
  },
  {
    "cod_dx": "W774",
    "nombre_dx": "W774-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: CALLES Y CAR",
    "sexo": "A"
  },
  {
    "cod_dx": "W775",
    "nombre_dx": "W775-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: COMERCIO Y A",
    "sexo": "A"
  },
  {
    "cod_dx": "W776",
    "nombre_dx": "W776-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: AREA INDUSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W777",
    "nombre_dx": "W777-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W778",
    "nombre_dx": "W778-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: OTRO LUGAR E",
    "sexo": "A"
  },
  {
    "cod_dx": "W779",
    "nombre_dx": "W779-OBSTRUCCION DE LA RESPIRACION DEBIDA A HUNDIMIENTO, CAIDA DE TIERRA U OTRAS SUSTANCIAS: LUGAR NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "W780",
    "nombre_dx": "W780-INHALACION DE CONTENIDOS GASTRICOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W781",
    "nombre_dx": "W781-INHALACION DE CONTENIDOS GASTRICOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W782",
    "nombre_dx": "W782-INHALACION DE CONTENIDOS GASTRICOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W783",
    "nombre_dx": "W783-INHALACION DE CONTENIDOS GASTRICOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W784",
    "nombre_dx": "W784-INHALACION DE CONTENIDOS GASTRICOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W785",
    "nombre_dx": "W785-INHALACION DE CONTENIDOS GASTRICOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W786",
    "nombre_dx": "W786-INHALACION DE CONTENIDOS GASTRICOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W787",
    "nombre_dx": "W787-INHALACION DE CONTENIDOS GASTRICOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W788",
    "nombre_dx": "W788-INHALACION DE CONTENIDOS GASTRICOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W789",
    "nombre_dx": "W789-INHALACION DE CONTENIDOS GASTRICOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W790",
    "nombre_dx": "W790-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W791",
    "nombre_dx": "W791-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: INSTITUCION RESI",
    "sexo": "A"
  },
  {
    "cod_dx": "W792",
    "nombre_dx": "W792-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: ESCUELAS, OTRAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W793",
    "nombre_dx": "W793-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: AREAS DE DEPORTE",
    "sexo": "A"
  },
  {
    "cod_dx": "W794",
    "nombre_dx": "W794-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: CALLES Y CARRETE",
    "sexo": "A"
  },
  {
    "cod_dx": "W795",
    "nombre_dx": "W795-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: COMERCIO Y AREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W796",
    "nombre_dx": "W796-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: AREA INDUSTRIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W797",
    "nombre_dx": "W797-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W798",
    "nombre_dx": "W798-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: OTRO LUGAR ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "W799",
    "nombre_dx": "W799-INHALACION E INGESTION DE ALIMENTO QUE CAUSA OBSTRUCCION DE LAS VIAS RESPIRATORIAS: LUGAR NO ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "W800",
    "nombre_dx": "W800-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W801",
    "nombre_dx": "W801-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: INSTITUCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W802",
    "nombre_dx": "W802-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: ESCUELAS, ",
    "sexo": "A"
  },
  {
    "cod_dx": "W803",
    "nombre_dx": "W803-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: AREAS DE D",
    "sexo": "A"
  },
  {
    "cod_dx": "W804",
    "nombre_dx": "W804-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: CALLES Y C",
    "sexo": "A"
  },
  {
    "cod_dx": "W805",
    "nombre_dx": "W805-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: COMERCIO Y",
    "sexo": "A"
  },
  {
    "cod_dx": "W806",
    "nombre_dx": "W806-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: AREA INDUS",
    "sexo": "A"
  },
  {
    "cod_dx": "W807",
    "nombre_dx": "W807-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W808",
    "nombre_dx": "W808-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: OTRO LUGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "W809",
    "nombre_dx": "W809-INHALACION E INGESTION DE OTROS OBJETOS QUE CAUSAN OBSTRUCCION DE LAS VIAS RESPIRATORIAS: LUGAR NO E",
    "sexo": "A"
  },
  {
    "cod_dx": "W810",
    "nombre_dx": "W810-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W811",
    "nombre_dx": "W811-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W812",
    "nombre_dx": "W812-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: ESCUELAS, OTRAS INSTITUCIONES Y A",
    "sexo": "A"
  },
  {
    "cod_dx": "W813",
    "nombre_dx": "W813-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W814",
    "nombre_dx": "W814-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W815",
    "nombre_dx": "W815-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W816",
    "nombre_dx": "W816-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: AREA INDUSTRIAL Y DE LA CONSTRUCC",
    "sexo": "A"
  },
  {
    "cod_dx": "W817",
    "nombre_dx": "W817-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W818",
    "nombre_dx": "W818-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W819",
    "nombre_dx": "W819-CONFINADO O ATRAPADO EN UN AMBIENTE CON BAJO CONTENIDO DE OXIGENO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W830",
    "nombre_dx": "W830-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W831",
    "nombre_dx": "W831-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W832",
    "nombre_dx": "W832-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W833",
    "nombre_dx": "W833-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W834",
    "nombre_dx": "W834-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W835",
    "nombre_dx": "W835-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W836",
    "nombre_dx": "W836-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W837",
    "nombre_dx": "W837-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W838",
    "nombre_dx": "W838-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W839",
    "nombre_dx": "W839-OTRAS OBSTRUCCIONES ESPECIFICADAS DE LA RESPIRACION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W840",
    "nombre_dx": "W840-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W841",
    "nombre_dx": "W841-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W842",
    "nombre_dx": "W842-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIV",
    "sexo": "A"
  },
  {
    "cod_dx": "W843",
    "nombre_dx": "W843-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W844",
    "nombre_dx": "W844-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W845",
    "nombre_dx": "W845-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W846",
    "nombre_dx": "W846-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W847",
    "nombre_dx": "W847-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W848",
    "nombre_dx": "W848-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W849",
    "nombre_dx": "W849-OBSTRUCCIONES NO ESPECIFICADA DE LA RESPIRACION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W850",
    "nombre_dx": "W850-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W851",
    "nombre_dx": "W851-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W852",
    "nombre_dx": "W852-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W853",
    "nombre_dx": "W853-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W854",
    "nombre_dx": "W854-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W855",
    "nombre_dx": "W855-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W856",
    "nombre_dx": "W856-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W857",
    "nombre_dx": "W857-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W858",
    "nombre_dx": "W858-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W859",
    "nombre_dx": "W859-EXPOSICION A LINEAS DE TRANSMISION ELECTRICA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W860",
    "nombre_dx": "W860-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W861",
    "nombre_dx": "W861-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W862",
    "nombre_dx": "W862-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINI",
    "sexo": "A"
  },
  {
    "cod_dx": "W863",
    "nombre_dx": "W863-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W864",
    "nombre_dx": "W864-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W865",
    "nombre_dx": "W865-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W866",
    "nombre_dx": "W866-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W867",
    "nombre_dx": "W867-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W868",
    "nombre_dx": "W868-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W869",
    "nombre_dx": "W869-EXPOSICION A OTRAS CORRIENTES ELECTRICAS ESPECIFICADAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W870",
    "nombre_dx": "W870-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W871",
    "nombre_dx": "W871-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W872",
    "nombre_dx": "W872-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATI",
    "sexo": "A"
  },
  {
    "cod_dx": "W873",
    "nombre_dx": "W873-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W874",
    "nombre_dx": "W874-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W875",
    "nombre_dx": "W875-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W876",
    "nombre_dx": "W876-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W877",
    "nombre_dx": "W877-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W878",
    "nombre_dx": "W878-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W879",
    "nombre_dx": "W879-EXPOSICION A CORRIENTE ELECTRICA NO ESPECIFICADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W880",
    "nombre_dx": "W880-EXPOSICION A RADIACION IONIZANTE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W881",
    "nombre_dx": "W881-EXPOSICION A RADIACION IONIZANTE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W882",
    "nombre_dx": "W882-EXPOSICION A RADIACION IONIZANTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W883",
    "nombre_dx": "W883-EXPOSICION A RADIACION IONIZANTE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W884",
    "nombre_dx": "W884-EXPOSICION A RADIACION IONIZANTE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W885",
    "nombre_dx": "W885-EXPOSICION A RADIACION IONIZANTE: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W886",
    "nombre_dx": "W886-EXPOSICION A RADIACION IONIZANTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W887",
    "nombre_dx": "W887-EXPOSICION A RADIACION IONIZANTE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W888",
    "nombre_dx": "W888-EXPOSICION A RADIACION IONIZANTE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W889",
    "nombre_dx": "W889-EXPOSICION A RADIACION IONIZANTE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W890",
    "nombre_dx": "W890-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W891",
    "nombre_dx": "W891-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W892",
    "nombre_dx": "W892-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: ESCUELAS, OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W893",
    "nombre_dx": "W893-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "W894",
    "nombre_dx": "W894-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W895",
    "nombre_dx": "W895-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: COMERCIO Y AREAS DE SERVICI",
    "sexo": "A"
  },
  {
    "cod_dx": "W896",
    "nombre_dx": "W896-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "W897",
    "nombre_dx": "W897-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W898",
    "nombre_dx": "W898-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W899",
    "nombre_dx": "W899-EXPOSICION A FUENTE DE LUZ VISIBLE Y ULTRAVIOLETA, DE ORIGEN ARTIFICIAL: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W900",
    "nombre_dx": "W900-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W901",
    "nombre_dx": "W901-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W902",
    "nombre_dx": "W902-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "W903",
    "nombre_dx": "W903-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W904",
    "nombre_dx": "W904-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W905",
    "nombre_dx": "W905-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W906",
    "nombre_dx": "W906-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W907",
    "nombre_dx": "W907-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W908",
    "nombre_dx": "W908-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W909",
    "nombre_dx": "W909-EXPOSICION A OTROS TIPOS DE RADIACION NO IONIZANTE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W910",
    "nombre_dx": "W910-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W911",
    "nombre_dx": "W911-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W912",
    "nombre_dx": "W912-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "W913",
    "nombre_dx": "W913-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W914",
    "nombre_dx": "W914-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W915",
    "nombre_dx": "W915-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W916",
    "nombre_dx": "W916-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W917",
    "nombre_dx": "W917-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W918",
    "nombre_dx": "W918-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W919",
    "nombre_dx": "W919-EXPOSICION A RADIACION DE TIPO NO ESPECIFICADO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W920",
    "nombre_dx": "W920-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W921",
    "nombre_dx": "W921-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "W922",
    "nombre_dx": "W922-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATI",
    "sexo": "A"
  },
  {
    "cod_dx": "W923",
    "nombre_dx": "W923-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "W924",
    "nombre_dx": "W924-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "W925",
    "nombre_dx": "W925-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "W926",
    "nombre_dx": "W926-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "W927",
    "nombre_dx": "W927-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W928",
    "nombre_dx": "W928-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W929",
    "nombre_dx": "W929-EXPOSICION A CALOR EXCESIVO DE ORIGEN ARTIFICIAL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W930",
    "nombre_dx": "W930-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W931",
    "nombre_dx": "W931-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W932",
    "nombre_dx": "W932-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIV",
    "sexo": "A"
  },
  {
    "cod_dx": "W933",
    "nombre_dx": "W933-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W934",
    "nombre_dx": "W934-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W935",
    "nombre_dx": "W935-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "W936",
    "nombre_dx": "W936-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W937",
    "nombre_dx": "W937-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W938",
    "nombre_dx": "W938-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W939",
    "nombre_dx": "W939-EXPOSICION A FRIO EXCESIVO DE ORIGEN ARTIFICIAL: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W940",
    "nombre_dx": "W940-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W941",
    "nombre_dx": "W941-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "W942",
    "nombre_dx": "W942-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: ESCUELAS, OTRAS INSTITU",
    "sexo": "A"
  },
  {
    "cod_dx": "W943",
    "nombre_dx": "W943-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: AREAS DE DEPORTE Y ATLE",
    "sexo": "A"
  },
  {
    "cod_dx": "W944",
    "nombre_dx": "W944-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "W945",
    "nombre_dx": "W945-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: COMERCIO Y AREAS DE SER",
    "sexo": "A"
  },
  {
    "cod_dx": "W946",
    "nombre_dx": "W946-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: AREA INDUSTRIAL Y DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "W947",
    "nombre_dx": "W947-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "W948",
    "nombre_dx": "W948-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W949",
    "nombre_dx": "W949-EXPOSICION A PRESION DE AIRE ALTA Y BAJA Y A CAMBIOS EN LA PRESION DEL AIRE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "W990",
    "nombre_dx": "W990-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "W991",
    "nombre_dx": "W991-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: INSTITUCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "W992",
    "nombre_dx": "W992-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: ESCUELAS, OT",
    "sexo": "A"
  },
  {
    "cod_dx": "W993",
    "nombre_dx": "W993-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: AREAS DE DEP",
    "sexo": "A"
  },
  {
    "cod_dx": "W994",
    "nombre_dx": "W994-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: CALLES Y CAR",
    "sexo": "A"
  },
  {
    "cod_dx": "W995",
    "nombre_dx": "W995-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: COMERCIO Y A",
    "sexo": "A"
  },
  {
    "cod_dx": "W996",
    "nombre_dx": "W996-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: AREA INDUSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "W997",
    "nombre_dx": "W997-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "W998",
    "nombre_dx": "W998-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: OTRO LUGAR E",
    "sexo": "A"
  },
  {
    "cod_dx": "W999",
    "nombre_dx": "W999-EXPOSICION A OTROS FACTORES AMBIENTALES Y A LOS NO ESPECIFICADOS, DE ORIGEN ARTIFICIAL: LUGAR NO ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "X000",
    "nombre_dx": "X000-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X001",
    "nombre_dx": "X001-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X002",
    "nombre_dx": "X002-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "X003",
    "nombre_dx": "X003-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X004",
    "nombre_dx": "X004-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X005",
    "nombre_dx": "X005-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X006",
    "nombre_dx": "X006-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X007",
    "nombre_dx": "X007-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X008",
    "nombre_dx": "X008-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X009",
    "nombre_dx": "X009-EXPOSICION A FUEGO NO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X010",
    "nombre_dx": "X010-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X011",
    "nombre_dx": "X011-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: INSTITUCION RESIDE",
    "sexo": "A"
  },
  {
    "cod_dx": "X012",
    "nombre_dx": "X012-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: ESCUELAS, OTRAS IN",
    "sexo": "A"
  },
  {
    "cod_dx": "X013",
    "nombre_dx": "X013-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: AREAS DE DEPORTE Y",
    "sexo": "A"
  },
  {
    "cod_dx": "X014",
    "nombre_dx": "X014-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: CALLES Y CARRETERA",
    "sexo": "A"
  },
  {
    "cod_dx": "X015",
    "nombre_dx": "X015-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: COMERCIO Y AREAS D",
    "sexo": "A"
  },
  {
    "cod_dx": "X016",
    "nombre_dx": "X016-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: AREAS INDUSTRIAL Y",
    "sexo": "A"
  },
  {
    "cod_dx": "X017",
    "nombre_dx": "X017-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X018",
    "nombre_dx": "X018-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: OTRO LUGAR ESPECIF",
    "sexo": "A"
  },
  {
    "cod_dx": "X019",
    "nombre_dx": "X019-EXPOSICION A FUEGO NO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: LUGAR NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "X020",
    "nombre_dx": "X020-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X021",
    "nombre_dx": "X021-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X022",
    "nombre_dx": "X022-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X023",
    "nombre_dx": "X023-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X024",
    "nombre_dx": "X024-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X025",
    "nombre_dx": "X025-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: COMERCIO Y AREA DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X026",
    "nombre_dx": "X026-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X027",
    "nombre_dx": "X027-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X028",
    "nombre_dx": "X028-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X029",
    "nombre_dx": "X029-EXPOSICION A FUEGO CONTROLADO EN EDIFICIO U OTRA CONSTRUCCION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X030",
    "nombre_dx": "X030-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X031",
    "nombre_dx": "X031-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: INSTITUCION RESIDENCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X032",
    "nombre_dx": "X032-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: ESCUELAS, OTRAS INSTI",
    "sexo": "A"
  },
  {
    "cod_dx": "X033",
    "nombre_dx": "X033-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: AREAS DE DEPORTE Y AT",
    "sexo": "A"
  },
  {
    "cod_dx": "X034",
    "nombre_dx": "X034-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X035",
    "nombre_dx": "X035-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: COMERCIO Y AREAS DE S",
    "sexo": "A"
  },
  {
    "cod_dx": "X036",
    "nombre_dx": "X036-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: AREA INDUSTRIAL Y DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "X037",
    "nombre_dx": "X037-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X038",
    "nombre_dx": "X038-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: OTRO LUGAR ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "X039",
    "nombre_dx": "X039-EXPOSICION A FUEGO CONTROLADO EN LUGAR QUE NO ES EDIFICIO U OTRA CONSTRUCCION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X040",
    "nombre_dx": "X040-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X041",
    "nombre_dx": "X041-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X042",
    "nombre_dx": "X042-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINI",
    "sexo": "A"
  },
  {
    "cod_dx": "X043",
    "nombre_dx": "X043-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X044",
    "nombre_dx": "X044-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X045",
    "nombre_dx": "X045-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X046",
    "nombre_dx": "X046-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X047",
    "nombre_dx": "X047-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X048",
    "nombre_dx": "X048-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X049",
    "nombre_dx": "X049-EXPOSICION A IGNICION DE MATERIAL ALTAMENTE INFLAMABLE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X050",
    "nombre_dx": "X050-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X051",
    "nombre_dx": "X051-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X052",
    "nombre_dx": "X052-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X053",
    "nombre_dx": "X053-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X054",
    "nombre_dx": "X054-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X055",
    "nombre_dx": "X055-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X056",
    "nombre_dx": "X056-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X057",
    "nombre_dx": "X057-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X058",
    "nombre_dx": "X058-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X059",
    "nombre_dx": "X059-EXPOSICION A IGNICION O FUSION DE ROPAS DE DORMIR: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X060",
    "nombre_dx": "X060-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X061",
    "nombre_dx": "X061-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X062",
    "nombre_dx": "X062-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS AD",
    "sexo": "A"
  },
  {
    "cod_dx": "X063",
    "nombre_dx": "X063-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X064",
    "nombre_dx": "X064-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X065",
    "nombre_dx": "X065-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X066",
    "nombre_dx": "X066-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X067",
    "nombre_dx": "X067-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X068",
    "nombre_dx": "X068-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X069",
    "nombre_dx": "X069-EXPOSICION A IGNICION O FUSION DE OTRAS ROPAS Y ACCESORIOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X080",
    "nombre_dx": "X080-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X081",
    "nombre_dx": "X081-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X082",
    "nombre_dx": "X082-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "X083",
    "nombre_dx": "X083-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X084",
    "nombre_dx": "X084-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X085",
    "nombre_dx": "X085-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X086",
    "nombre_dx": "X086-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X087",
    "nombre_dx": "X087-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X088",
    "nombre_dx": "X088-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X089",
    "nombre_dx": "X089-EXPOSICION A OTROS HUMOS, FUEGOS O LLAMAS ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X090",
    "nombre_dx": "X090-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X091",
    "nombre_dx": "X091-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X092",
    "nombre_dx": "X092-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINIST",
    "sexo": "A"
  },
  {
    "cod_dx": "X093",
    "nombre_dx": "X093-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X094",
    "nombre_dx": "X094-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X095",
    "nombre_dx": "X095-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X096",
    "nombre_dx": "X096-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X097",
    "nombre_dx": "X097-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X098",
    "nombre_dx": "X098-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X099",
    "nombre_dx": "X099-EXPOSICION A HUMOS, FUEGOS O LLAMAS NO ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X100",
    "nombre_dx": "X100-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X101",
    "nombre_dx": "X101-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X102",
    "nombre_dx": "X102-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: ESCUELAS, OTRAS INSTITUCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X103",
    "nombre_dx": "X103-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: AREAS DE DEPORTE Y ATLETI",
    "sexo": "A"
  },
  {
    "cod_dx": "X104",
    "nombre_dx": "X104-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X105",
    "nombre_dx": "X105-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: COMERCIO Y AREAS DE SERVI",
    "sexo": "A"
  },
  {
    "cod_dx": "X106",
    "nombre_dx": "X106-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: AREA INDUSTRIAL Y DE LA C",
    "sexo": "A"
  },
  {
    "cod_dx": "X107",
    "nombre_dx": "X107-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X108",
    "nombre_dx": "X108-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X109",
    "nombre_dx": "X109-CONTACTO CON BEBIDAS, ALIMENTOS, GRASAS Y ACEITES PARA COCINAR, CALIENTES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X110",
    "nombre_dx": "X110-CONTACTO CON AGUA CALIENTE CORRIENTE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X111",
    "nombre_dx": "X111-CONTACTO CON AGUA CALIENTE CORRIENTE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X112",
    "nombre_dx": "X112-CONTACTO CON AGUA CALIENTE CORRIENTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X113",
    "nombre_dx": "X113-CONTACTO CON AGUA CALIENTE CORRIENTE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X114",
    "nombre_dx": "X114-CONTACTO CON AGUA CALIENTE CORRIENTE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X115",
    "nombre_dx": "X115-CONTACTO CON AGUA CALIENTE CORRIENTE: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X116",
    "nombre_dx": "X116-CONTACTO CON AGUA CALIENTE CORRIENTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X117",
    "nombre_dx": "X117-CONTACTO CON AGUA CALIENTE CORRIENTE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X118",
    "nombre_dx": "X118-CONTACTO CON AGUA CALIENTE CORRIENTE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X119",
    "nombre_dx": "X119-CONTACTO CON AGUA CALIENTE CORRIENTE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X120",
    "nombre_dx": "X120-CONTACTO CON OTROS LIQUIDOS CALIENTES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X121",
    "nombre_dx": "X121-CONTACTO CON OTROS LIQUIDOS CALIENTES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X122",
    "nombre_dx": "X122-CONTACTO CON OTROS LIQUIDOS CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICA",
    "sexo": "A"
  },
  {
    "cod_dx": "X123",
    "nombre_dx": "X123-CONTACTO CON OTROS LIQUIDOS CALIENTES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X124",
    "nombre_dx": "X124-CONTACTO CON OTROS LIQUIDOS CALIENTES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X125",
    "nombre_dx": "X125-CONTACTO CON OTROS LIQUIDOS CALIENTES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X126",
    "nombre_dx": "X126-CONTACTO CON OTROS LIQUIDOS CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X127",
    "nombre_dx": "X127-CONTACTO CON OTROS LIQUIDOS CALIENTES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X128",
    "nombre_dx": "X128-CONTACTO CON OTROS LIQUIDOS CALIENTES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X129",
    "nombre_dx": "X129-CONTACTO CON OTROS LIQUIDOS CALIENTES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X130",
    "nombre_dx": "X130-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X131",
    "nombre_dx": "X131-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X132",
    "nombre_dx": "X132-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINIST",
    "sexo": "A"
  },
  {
    "cod_dx": "X133",
    "nombre_dx": "X133-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X134",
    "nombre_dx": "X134-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X135",
    "nombre_dx": "X135-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X136",
    "nombre_dx": "X136-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X137",
    "nombre_dx": "X137-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X138",
    "nombre_dx": "X138-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X139",
    "nombre_dx": "X139-CONTACTO CON VAPOR DE AGUA Y OTROS VAPORES CALIENTES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X140",
    "nombre_dx": "X140-CONTACTO CON AIRE Y GASES CALIENTES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X141",
    "nombre_dx": "X141-CONTACTO CON AIRE Y GASES CALIENTES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X142",
    "nombre_dx": "X142-CONTACTO CON AIRE Y GASES CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X143",
    "nombre_dx": "X143-CONTACTO CON AIRE Y GASES CALIENTES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X144",
    "nombre_dx": "X144-CONTACTO CON AIRE Y GASES CALIENTES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X145",
    "nombre_dx": "X145-CONTACTO CON AIRE Y GASES CALIENTES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X146",
    "nombre_dx": "X146-CONTACTO CON AIRE Y GASES CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X147",
    "nombre_dx": "X147-CONTACTO CON AIRE Y GASES CALIENTES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X148",
    "nombre_dx": "X148-CONTACTO CON AIRE Y GASES CALIENTES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X149",
    "nombre_dx": "X149-CONTACTO CON AIRE Y GASES CALIENTES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X150",
    "nombre_dx": "X150-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X151",
    "nombre_dx": "X151-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X152",
    "nombre_dx": "X152-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X153",
    "nombre_dx": "X153-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X154",
    "nombre_dx": "X154-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X155",
    "nombre_dx": "X155-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X156",
    "nombre_dx": "X156-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X157",
    "nombre_dx": "X157-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X158",
    "nombre_dx": "X158-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES OTRO LUGAR ESPECIFICADO: ",
    "sexo": "A"
  },
  {
    "cod_dx": "X159",
    "nombre_dx": "X159-CONTACTO CON UTENSILIOS DOMESTICOS CALIENTES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X160",
    "nombre_dx": "X160-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X161",
    "nombre_dx": "X161-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X162",
    "nombre_dx": "X162-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: ESCUELAS, OTRAS INSTITUC",
    "sexo": "A"
  },
  {
    "cod_dx": "X163",
    "nombre_dx": "X163-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: AREAS DE DEPORTE Y ATLET",
    "sexo": "A"
  },
  {
    "cod_dx": "X164",
    "nombre_dx": "X164-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X165",
    "nombre_dx": "X165-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: COMERCIO Y AREAS DE SERV",
    "sexo": "A"
  },
  {
    "cod_dx": "X166",
    "nombre_dx": "X166-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: AREA INDUSTRIAL Y DE LA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X167",
    "nombre_dx": "X167-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X168",
    "nombre_dx": "X168-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X169",
    "nombre_dx": "X169-CONTACTO CON RADIADORES, CAÑERIAS Y ARTEFACTOS PARA CALEFACCION, CALIENTES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X170",
    "nombre_dx": "X170-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X171",
    "nombre_dx": "X171-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X172",
    "nombre_dx": "X172-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "X173",
    "nombre_dx": "X173-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X174",
    "nombre_dx": "X174-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X175",
    "nombre_dx": "X175-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X176",
    "nombre_dx": "X176-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X177",
    "nombre_dx": "X177-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X178",
    "nombre_dx": "X178-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X179",
    "nombre_dx": "X179-CONTACTO CON MAQUINAS, MOTORES Y HERRAMIENTAS CALIENTES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X180",
    "nombre_dx": "X180-CONTACTO CON OTROS METALES CALIENTES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X181",
    "nombre_dx": "X181-CONTACTO CON OTROS METALES CALIENTES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X182",
    "nombre_dx": "X182-CONTACTO CON OTROS METALES CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X183",
    "nombre_dx": "X183-CONTACTO CON OTROS METALES CALIENTES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X184",
    "nombre_dx": "X184-CONTACTO CON OTROS METALES CALIENTES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X185",
    "nombre_dx": "X185-CONTACTO CON OTROS METALES CALIENTES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X186",
    "nombre_dx": "X186-CONTACTO CON OTROS METALES CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X187",
    "nombre_dx": "X187-CONTACTO CON OTROS METALES CALIENTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X188",
    "nombre_dx": "X188-CONTACTO CON OTROS METALES CALIENTES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X189",
    "nombre_dx": "X189-CONTACTO CON OTROS METALES CALIENTES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X190",
    "nombre_dx": "X190-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X191",
    "nombre_dx": "X191-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X192",
    "nombre_dx": "X192-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "X193",
    "nombre_dx": "X193-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X194",
    "nombre_dx": "X194-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X195",
    "nombre_dx": "X195-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X196",
    "nombre_dx": "X196-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRUCCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X197",
    "nombre_dx": "X197-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X198",
    "nombre_dx": "X198-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X199",
    "nombre_dx": "X199-CONTACTO CON OTRAS SUSTANCIAS CALIENTES, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X200",
    "nombre_dx": "X200-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X201",
    "nombre_dx": "X201-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X202",
    "nombre_dx": "X202-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "X203",
    "nombre_dx": "X203-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X204",
    "nombre_dx": "X204-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X205",
    "nombre_dx": "X205-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X206",
    "nombre_dx": "X206-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X207",
    "nombre_dx": "X207-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X208",
    "nombre_dx": "X208-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X209",
    "nombre_dx": "X209-CONTACTO TRAUMATICO CON SERPIENTES Y LAGARTOS VENENOSOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X210",
    "nombre_dx": "X210-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X211",
    "nombre_dx": "X211-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X212",
    "nombre_dx": "X212-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBL",
    "sexo": "A"
  },
  {
    "cod_dx": "X213",
    "nombre_dx": "X213-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X214",
    "nombre_dx": "X214-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X215",
    "nombre_dx": "X215-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X216",
    "nombre_dx": "X216-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X217",
    "nombre_dx": "X217-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X218",
    "nombre_dx": "X218-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X219",
    "nombre_dx": "X219-CONTACTO TRAUMATICO CON ARAÑAS VENENOSAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X220",
    "nombre_dx": "X220-CONTACTO TRAUMATICO CON ESCORPION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X221",
    "nombre_dx": "X221-CONTACTO TRAUMATICO CON ESCORPION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X222",
    "nombre_dx": "X222-CONTACTO TRAUMATICO CON ESCORPION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X223",
    "nombre_dx": "X223-CONTACTO TRAUMATICO CON ESCORPION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X224",
    "nombre_dx": "X224-CONTACTO TRAUMATICO CON ESCORPION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X225",
    "nombre_dx": "X225-CONTACTO TRAUMATICO CON ESCORPION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X226",
    "nombre_dx": "X226-CONTACTO TRAUMATICO CON ESCORPION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X227",
    "nombre_dx": "X227-CONTACTO TRAUMATICO CON ESCORPION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X228",
    "nombre_dx": "X228-CONTACTO TRAUMATICO CON ESCORPION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X229",
    "nombre_dx": "X229-CONTACTO TRAUMATICO CON ESCORPION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X230",
    "nombre_dx": "X230-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X231",
    "nombre_dx": "X231-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X232",
    "nombre_dx": "X232-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTR",
    "sexo": "A"
  },
  {
    "cod_dx": "X233",
    "nombre_dx": "X233-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X234",
    "nombre_dx": "X234-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X235",
    "nombre_dx": "X235-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X236",
    "nombre_dx": "X236-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X237",
    "nombre_dx": "X237-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X238",
    "nombre_dx": "X238-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X239",
    "nombre_dx": "X239-CONTACTO TRAUMATICO CON AVISPONES, AVISPAS Y ABEJAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X240",
    "nombre_dx": "X240-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X241",
    "nombre_dx": "X241-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X242",
    "nombre_dx": "X242-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): ESCUELAS, OTRAS INSTITUCIONE",
    "sexo": "A"
  },
  {
    "cod_dx": "X243",
    "nombre_dx": "X243-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X244",
    "nombre_dx": "X244-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X245",
    "nombre_dx": "X245-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X246",
    "nombre_dx": "X246-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): AREA INDUSTRIAL Y DE LA CONS",
    "sexo": "A"
  },
  {
    "cod_dx": "X247",
    "nombre_dx": "X247-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X248",
    "nombre_dx": "X248-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X249",
    "nombre_dx": "X249-CONTACTO TRAUMATICO CON CENTIPODOS Y MIRIAPODOS VENENOSOS (TROPICALES): LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X250",
    "nombre_dx": "X250-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X251",
    "nombre_dx": "X251-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X252",
    "nombre_dx": "X252-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "X253",
    "nombre_dx": "X253-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X254",
    "nombre_dx": "X254-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X255",
    "nombre_dx": "X255-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X256",
    "nombre_dx": "X256-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X257",
    "nombre_dx": "X257-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X258",
    "nombre_dx": "X258-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X259",
    "nombre_dx": "X259-CONTACTO TRAUMATICO CON OTROS ARTROPODOS VENENOSOS ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X260",
    "nombre_dx": "X260-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X261",
    "nombre_dx": "X261-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X262",
    "nombre_dx": "X262-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X263",
    "nombre_dx": "X263-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X264",
    "nombre_dx": "X264-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X265",
    "nombre_dx": "X265-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X266",
    "nombre_dx": "X266-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X267",
    "nombre_dx": "X267-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X268",
    "nombre_dx": "X268-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X269",
    "nombre_dx": "X269-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS MARINAS VENENOSOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X270",
    "nombre_dx": "X270-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X271",
    "nombre_dx": "X271-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X272",
    "nombre_dx": "X272-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREA",
    "sexo": "A"
  },
  {
    "cod_dx": "X273",
    "nombre_dx": "X273-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X274",
    "nombre_dx": "X274-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X275",
    "nombre_dx": "X275-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X276",
    "nombre_dx": "X276-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X277",
    "nombre_dx": "X277-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X278",
    "nombre_dx": "X278-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X279",
    "nombre_dx": "X279-CONTACTO TRAUMATICO CON OTROS ANIMALES VENENOSOS ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X280",
    "nombre_dx": "X280-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X281",
    "nombre_dx": "X281-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X282",
    "nombre_dx": "X282-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X283",
    "nombre_dx": "X283-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X284",
    "nombre_dx": "X284-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X285",
    "nombre_dx": "X285-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X286",
    "nombre_dx": "X286-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X287",
    "nombre_dx": "X287-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X288",
    "nombre_dx": "X288-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X289",
    "nombre_dx": "X289-CONTACTO TRAUMATICO CON OTRAS PLANTAS VENENOSAS ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X290",
    "nombre_dx": "X290-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X291",
    "nombre_dx": "X291-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X292",
    "nombre_dx": "X292-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "X293",
    "nombre_dx": "X293-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X294",
    "nombre_dx": "X294-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X295",
    "nombre_dx": "X295-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X296",
    "nombre_dx": "X296-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONST",
    "sexo": "A"
  },
  {
    "cod_dx": "X297",
    "nombre_dx": "X297-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X298",
    "nombre_dx": "X298-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X299",
    "nombre_dx": "X299-CONTACTO TRAUMATICO CON ANIMALES Y PLANTAS VENENOSOS NO ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X300",
    "nombre_dx": "X300-EXPOSICION AL CALOR NATURAL EXCESIVO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X301",
    "nombre_dx": "X301-EXPOSICION AL CALOR NATURAL EXCESIVO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X302",
    "nombre_dx": "X302-EXPOSICION AL CALOR NATURAL EXCESIVO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X303",
    "nombre_dx": "X303-EXPOSICION AL CALOR NATURAL EXCESIVO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X304",
    "nombre_dx": "X304-EXPOSICION AL CALOR NATURAL EXCESIVO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X305",
    "nombre_dx": "X305-EXPOSICION AL CALOR NATURAL EXCESIVO: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X306",
    "nombre_dx": "X306-EXPOSICION AL CALOR NATURAL EXCESIVO: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X307",
    "nombre_dx": "X307-EXPOSICION AL CALOR NATURAL EXCESIVO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X308",
    "nombre_dx": "X308-EXPOSICION AL CALOR NATURAL EXCESIVO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X309",
    "nombre_dx": "X309-EXPOSICION AL CALOR NATURAL EXCESIVO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X310",
    "nombre_dx": "X310-EXPOSICION AL FRIO NATURAL EXCESIVO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X311",
    "nombre_dx": "X311-EXPOSICION AL FRIO NATURAL EXCESIVO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X312",
    "nombre_dx": "X312-EXPOSICION AL FRIO NATURAL EXCESIVO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X313",
    "nombre_dx": "X313-EXPOSICION AL FRIO NATURAL EXCESIVO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X314",
    "nombre_dx": "X314-EXPOSICION AL FRIO NATURAL EXCESIVO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X315",
    "nombre_dx": "X315-EXPOSICION AL FRIO NATURAL EXCESIVO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X316",
    "nombre_dx": "X316-EXPOSICION AL FRIO NATURAL EXCESIVO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X317",
    "nombre_dx": "X317-EXPOSICION AL FRIO NATURAL EXCESIVO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X318",
    "nombre_dx": "X318-EXPOSICION AL FRIO NATURAL EXCESIVO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X319",
    "nombre_dx": "X319-EXPOSICION AL FRIO NATURAL EXCESIVO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X320",
    "nombre_dx": "X320-EXPOSICION A RAYOS SOLARES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X321",
    "nombre_dx": "X321-EXPOSICION A RAYOS SOLARES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X322",
    "nombre_dx": "X322-EXPOSICION A RAYOS SOLARES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X323",
    "nombre_dx": "X323-EXPOSICION A RAYOS SOLARES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X324",
    "nombre_dx": "X324-EXPOSICION A RAYOS SOLARES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X325",
    "nombre_dx": "X325-EXPOSICION A RAYOS SOLARES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X326",
    "nombre_dx": "X326-EXPOSICION A RAYOS SOLARES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X327",
    "nombre_dx": "X327-EXPOSICION A RAYOS SOLARES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X328",
    "nombre_dx": "X328-EXPOSICION A RAYOS SOLARES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X329",
    "nombre_dx": "X329-EXPOSICION A RAYOS SOLARES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X330",
    "nombre_dx": "X330-VICTIMA DE RAYO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X331",
    "nombre_dx": "X331-VICTIMA DE RAYO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X332",
    "nombre_dx": "X332-VICTIMA DE RAYO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X333",
    "nombre_dx": "X333-VICTIMA DE RAYO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X334",
    "nombre_dx": "X334-VICTIMA DE RAYO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X335",
    "nombre_dx": "X335-VICTIMA DE RAYO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X336",
    "nombre_dx": "X336-VICTIMA DE RAYO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X337",
    "nombre_dx": "X337-VICTIMA DE RAYO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X338",
    "nombre_dx": "X338-VICTIMA DE RAYO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X339",
    "nombre_dx": "X339-VICTIMA DE RAYO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X340",
    "nombre_dx": "X340-Víctima de movimientos cataclísmicos de la tierra causados por terremoto ",
    "sexo": "A"
  },
  {
    "cod_dx": "X341",
    "nombre_dx": "X341-Víctima de tsunami ",
    "sexo": "A"
  },
  {
    "cod_dx": "X348",
    "nombre_dx": "X348-Víctima de otros efectos de terremoto especificados ",
    "sexo": "A"
  },
  {
    "cod_dx": "X349",
    "nombre_dx": "X349-Víctima de efectos de terremoto no especificados ",
    "sexo": "A"
  },
  {
    "cod_dx": "X350",
    "nombre_dx": "X350-VICTIMA DE ERUPCION VOLCANICA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X351",
    "nombre_dx": "X351-VICTIMA DE ERUPCION VOLCANICA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X352",
    "nombre_dx": "X352-VICTIMA DE ERUPCION VOLCANICA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X353",
    "nombre_dx": "X353-VICTIMA DE ERUPCION VOLCANICA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X354",
    "nombre_dx": "X354-VICTIMA DE ERUPCION VOLCANICA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X355",
    "nombre_dx": "X355-VICTIMA DE ERUPCION VOLCANICA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X356",
    "nombre_dx": "X356-VICTIMA DE ERUPCION VOLCANICA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X357",
    "nombre_dx": "X357-VICTIMA DE ERUPCION VOLCANICA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X358",
    "nombre_dx": "X358-VICTIMA DE ERUPCION VOLCANICA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X359",
    "nombre_dx": "X359-VICTIMA DE ERUPCION VOLCANICA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X360",
    "nombre_dx": "X360-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X361",
    "nombre_dx": "X361-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X362",
    "nombre_dx": "X362-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X363",
    "nombre_dx": "X363-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X364",
    "nombre_dx": "X364-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X365",
    "nombre_dx": "X365-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X366",
    "nombre_dx": "X366-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X367",
    "nombre_dx": "X367-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X368",
    "nombre_dx": "X368-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X369",
    "nombre_dx": "X369-VICTIMA DE AVALANCHA, DERRUMBE Y OTROS MOVIMIENTOS DE TIERRA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X370",
    "nombre_dx": "X370-VICTIMA DE TORMENTA CATACLISMICA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X371",
    "nombre_dx": "X371-VICTIMA DE TORMENTA CATACLISMICA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X372",
    "nombre_dx": "X372-VICTIMA DE TORMENTA CATACLISMICA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X373",
    "nombre_dx": "X373-VICTIMA DE TORMENTA CATACLISMICA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X374",
    "nombre_dx": "X374-VICTIMA DE TORMENTA CATACLISMICA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X375",
    "nombre_dx": "X375-VICTIMA DE TORMENTA CATACLISMICA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X376",
    "nombre_dx": "X376-VICTIMA DE TORMENTA CATACLISMICA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X377",
    "nombre_dx": "X377-VICTIMA DE TORMENTA CATACLISMICA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X378",
    "nombre_dx": "X378-VICTIMA DE TORMENTA CATACLISMICA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X379",
    "nombre_dx": "X379-VICTIMA DE TORMENTA CATACLISMICA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X380",
    "nombre_dx": "X380-VICTIMA DE INUNDACION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X381",
    "nombre_dx": "X381-VICTIMA DE INUNDACION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X382",
    "nombre_dx": "X382-VICTIMA DE INUNDACION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X383",
    "nombre_dx": "X383-VICTIMA DE INUNDACION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X384",
    "nombre_dx": "X384-VICTIMA DE INUNDACION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X385",
    "nombre_dx": "X385-VICTIMA DE INUNDACION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X386",
    "nombre_dx": "X386-VICTIMA DE INUNDACION: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X387",
    "nombre_dx": "X387-VICTIMA DE INUNDACION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X388",
    "nombre_dx": "X388-VICTIMA DE INUNDACION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X389",
    "nombre_dx": "X389-VICTIMA DE INUNDACION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X390",
    "nombre_dx": "X390-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X391",
    "nombre_dx": "X391-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X392",
    "nombre_dx": "X392-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES Y",
    "sexo": "A"
  },
  {
    "cod_dx": "X393",
    "nombre_dx": "X393-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X394",
    "nombre_dx": "X394-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X395",
    "nombre_dx": "X395-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X396",
    "nombre_dx": "X396-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTRU",
    "sexo": "A"
  },
  {
    "cod_dx": "X397",
    "nombre_dx": "X397-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X398",
    "nombre_dx": "X398-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X399",
    "nombre_dx": "X399-EXPOSICION A OTRAS FUERZAS DE LA NATURALEZA, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X400",
    "nombre_dx": "X400-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X401",
    "nombre_dx": "X401-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X402",
    "nombre_dx": "X402-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X403",
    "nombre_dx": "X403-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X404",
    "nombre_dx": "X404-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X405",
    "nombre_dx": "X405-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X406",
    "nombre_dx": "X406-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X407",
    "nombre_dx": "X407-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X408",
    "nombre_dx": "X408-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X409",
    "nombre_dx": "X409-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMAT",
    "sexo": "A"
  },
  {
    "cod_dx": "X410",
    "nombre_dx": "X410-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X411",
    "nombre_dx": "X411-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X412",
    "nombre_dx": "X412-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X413",
    "nombre_dx": "X413-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X414",
    "nombre_dx": "X414-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X415",
    "nombre_dx": "X415-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X416",
    "nombre_dx": "X416-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X417",
    "nombre_dx": "X417-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X418",
    "nombre_dx": "X418-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X419",
    "nombre_dx": "X419-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARK",
    "sexo": "A"
  },
  {
    "cod_dx": "X420",
    "nombre_dx": "X420-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X421",
    "nombre_dx": "X421-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X422",
    "nombre_dx": "X422-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X423",
    "nombre_dx": "X423-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X424",
    "nombre_dx": "X424-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X425",
    "nombre_dx": "X425-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X426",
    "nombre_dx": "X426-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X427",
    "nombre_dx": "X427-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X428",
    "nombre_dx": "X428-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X429",
    "nombre_dx": "X429-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "X430",
    "nombre_dx": "X430-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X431",
    "nombre_dx": "X431-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X432",
    "nombre_dx": "X432-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X433",
    "nombre_dx": "X433-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X434",
    "nombre_dx": "X434-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X435",
    "nombre_dx": "X435-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X436",
    "nombre_dx": "X436-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X437",
    "nombre_dx": "X437-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X438",
    "nombre_dx": "X438-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X439",
    "nombre_dx": "X439-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTO",
    "sexo": "A"
  },
  {
    "cod_dx": "X440",
    "nombre_dx": "X440-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X441",
    "nombre_dx": "X441-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X442",
    "nombre_dx": "X442-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X443",
    "nombre_dx": "X443-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X444",
    "nombre_dx": "X444-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X445",
    "nombre_dx": "X445-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X446",
    "nombre_dx": "X446-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X447",
    "nombre_dx": "X447-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X448",
    "nombre_dx": "X448-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X449",
    "nombre_dx": "X449-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X450",
    "nombre_dx": "X450-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X451",
    "nombre_dx": "X451-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X452",
    "nombre_dx": "X452-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINI",
    "sexo": "A"
  },
  {
    "cod_dx": "X453",
    "nombre_dx": "X453-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X454",
    "nombre_dx": "X454-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X455",
    "nombre_dx": "X455-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X456",
    "nombre_dx": "X456-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X457",
    "nombre_dx": "X457-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X458",
    "nombre_dx": "X458-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X459",
    "nombre_dx": "X459-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION AL ALCOHOL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X460",
    "nombre_dx": "X460-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X461",
    "nombre_dx": "X461-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X462",
    "nombre_dx": "X462-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X463",
    "nombre_dx": "X463-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X464",
    "nombre_dx": "X464-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X465",
    "nombre_dx": "X465-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X466",
    "nombre_dx": "X466-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X467",
    "nombre_dx": "X467-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X468",
    "nombre_dx": "X468-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X469",
    "nombre_dx": "X469-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SU",
    "sexo": "A"
  },
  {
    "cod_dx": "X470",
    "nombre_dx": "X470-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X471",
    "nombre_dx": "X471-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X472",
    "nombre_dx": "X472-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: ESCUELAS, OTRAS INSTITUCIONES Y",
    "sexo": "A"
  },
  {
    "cod_dx": "X473",
    "nombre_dx": "X473-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X474",
    "nombre_dx": "X474-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X475",
    "nombre_dx": "X475-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X476",
    "nombre_dx": "X476-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: AREA INDUSTRIAL Y DE LA CONSTRU",
    "sexo": "A"
  },
  {
    "cod_dx": "X477",
    "nombre_dx": "X477-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X478",
    "nombre_dx": "X478-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X479",
    "nombre_dx": "X479-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS GASES Y VAPORES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X480",
    "nombre_dx": "X480-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X481",
    "nombre_dx": "X481-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X482",
    "nombre_dx": "X482-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADM",
    "sexo": "A"
  },
  {
    "cod_dx": "X483",
    "nombre_dx": "X483-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X484",
    "nombre_dx": "X484-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: CALLES Y CARRETERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X485",
    "nombre_dx": "X485-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X486",
    "nombre_dx": "X486-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X487",
    "nombre_dx": "X487-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X488",
    "nombre_dx": "X488-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X489",
    "nombre_dx": "X489-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A PLAGUICIDAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X490",
    "nombre_dx": "X490-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X491",
    "nombre_dx": "X491-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X492",
    "nombre_dx": "X492-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X493",
    "nombre_dx": "X493-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X494",
    "nombre_dx": "X494-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X495",
    "nombre_dx": "X495-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X496",
    "nombre_dx": "X496-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X497",
    "nombre_dx": "X497-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X498",
    "nombre_dx": "X498-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X499",
    "nombre_dx": "X499-ENVENENAMIENTO ACCIDENTAL POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS N",
    "sexo": "A"
  },
  {
    "cod_dx": "X500",
    "nombre_dx": "X500-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X501",
    "nombre_dx": "X501-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X502",
    "nombre_dx": "X502-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS AD",
    "sexo": "A"
  },
  {
    "cod_dx": "X503",
    "nombre_dx": "X503-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X504",
    "nombre_dx": "X504-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X505",
    "nombre_dx": "X505-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X506",
    "nombre_dx": "X506-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X507",
    "nombre_dx": "X507-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X508",
    "nombre_dx": "X508-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X509",
    "nombre_dx": "X509-EXCESO DE ESFUERZO Y MOVIMIENTOS EXTENUANTES Y REPETITIVOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X510",
    "nombre_dx": "X510-VIAJES Y DESPLAZAMIENTOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X511",
    "nombre_dx": "X511-VIAJES Y DESPLAZAMIENTOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X512",
    "nombre_dx": "X512-VIAJES Y DESPLAZAMIENTOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X513",
    "nombre_dx": "X513-VIAJES Y DESPLAZAMIENTOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X514",
    "nombre_dx": "X514-VIAJES Y DESPLAZAMIENTOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X515",
    "nombre_dx": "X515-VIAJES Y DESPLAZAMIENTOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X516",
    "nombre_dx": "X516-VIAJES Y DESPLAZAMIENTOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X517",
    "nombre_dx": "X517-VIAJES Y DESPLAZAMIENTOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X518",
    "nombre_dx": "X518-VIAJES Y DESPLAZAMIENTOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X519",
    "nombre_dx": "X519-VIAJES Y DESPLAZAMIENTOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X520",
    "nombre_dx": "X520-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X521",
    "nombre_dx": "X521-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X522",
    "nombre_dx": "X522-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIV",
    "sexo": "A"
  },
  {
    "cod_dx": "X523",
    "nombre_dx": "X523-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X524",
    "nombre_dx": "X524-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X525",
    "nombre_dx": "X525-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X526",
    "nombre_dx": "X526-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X527",
    "nombre_dx": "X527-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X528",
    "nombre_dx": "X528-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X529",
    "nombre_dx": "X529-PERMANENCIA PROLONGADA EN AMBIENTE SIN GRAVEDAD: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X530",
    "nombre_dx": "X530-PRIVACION DE ALIMENTOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X531",
    "nombre_dx": "X531-PRIVACION DE ALIMENTOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X532",
    "nombre_dx": "X532-PRIVACION DE ALIMENTOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X533",
    "nombre_dx": "X533-PRIVACION DE ALIMENTOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X534",
    "nombre_dx": "X534-PRIVACION DE ALIMENTOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X535",
    "nombre_dx": "X535-PRIVACION DE ALIMENTOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X536",
    "nombre_dx": "X536-PRIVACION DE ALIMENTOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X537",
    "nombre_dx": "X537-PRIVACION DE ALIMENTOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X538",
    "nombre_dx": "X538-PRIVACION DE ALIMENTOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X539",
    "nombre_dx": "X539-PRIVACION DE ALIMENTOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X540",
    "nombre_dx": "X540-PRIVACION DE AGUA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X541",
    "nombre_dx": "X541-PRIVACION DE AGUA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X542",
    "nombre_dx": "X542-PRIVACION DE AGUA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X543",
    "nombre_dx": "X543-PRIVACION DE AGUA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X544",
    "nombre_dx": "X544-PRIVACION DE AGUA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X545",
    "nombre_dx": "X545-PRIVACION DE AGUA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X546",
    "nombre_dx": "X546-PRIVACION DE AGUA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X547",
    "nombre_dx": "X547-PRIVACION DE AGUA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X548",
    "nombre_dx": "X548-PRIVACION DE AGUA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X549",
    "nombre_dx": "X549-PRIVACION DE AGUA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X570",
    "nombre_dx": "X570-PRIVACION NO ESPECIFICADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X571",
    "nombre_dx": "X571-PRIVACION NO ESPECIFICADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X572",
    "nombre_dx": "X572-PRIVACION NO ESPECIFICADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X573",
    "nombre_dx": "X573-PRIVACION NO ESPECIFICADA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X574",
    "nombre_dx": "X574-PRIVACION NO ESPECIFICADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X575",
    "nombre_dx": "X575-PRIVACION NO ESPECIFICADA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X576",
    "nombre_dx": "X576-PRIVACION NO ESPECIFICADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X577",
    "nombre_dx": "X577-PRIVACION NO ESPECIFICADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X578",
    "nombre_dx": "X578-PRIVACION NO ESPECIFICADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X579",
    "nombre_dx": "X579-PRIVACION NO ESPECIFICADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X580",
    "nombre_dx": "X580-EXPOSICION A FACTORES ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X581",
    "nombre_dx": "X581-EXPOSICION A FACTORES ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X582",
    "nombre_dx": "X582-EXPOSICION A FACTORES ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X583",
    "nombre_dx": "X583-EXPOSICION A FACTORES ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X584",
    "nombre_dx": "X584-EXPOSICION A FACTORES ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X585",
    "nombre_dx": "X585-EXPOSICION A FACTORES ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X586",
    "nombre_dx": "X586-EXPOSICION A FACTORES ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X587",
    "nombre_dx": "X587-EXPOSICION A FACTORES ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X588",
    "nombre_dx": "X588-EXPOSICION A FACTORES ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X589",
    "nombre_dx": "X589-EXPOSICION A FACTORES ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X590",
    "nombre_dx": "X590-EXPOSICION A FACTORES NO ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X591",
    "nombre_dx": "X591-EXPOSICION A FACTORES NO ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X592",
    "nombre_dx": "X592-EXPOSICION A FACTORES NO ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLIC",
    "sexo": "A"
  },
  {
    "cod_dx": "X593",
    "nombre_dx": "X593-EXPOSICION A FACTORES NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X594",
    "nombre_dx": "X594-EXPOSICION A FACTORES NO ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X595",
    "nombre_dx": "X595-EXPOSICION A FACTORES NO ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X596",
    "nombre_dx": "X596-EXPOSICION A FACTORES NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X597",
    "nombre_dx": "X597-EXPOSICION A FACTORES NO ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X598",
    "nombre_dx": "X598-EXPOSICION A FACTORES NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X599",
    "nombre_dx": "X599-EXPOSICION A FACTORES NO ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X600",
    "nombre_dx": "X600-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X601",
    "nombre_dx": "X601-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X602",
    "nombre_dx": "X602-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X603",
    "nombre_dx": "X603-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X604",
    "nombre_dx": "X604-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X605",
    "nombre_dx": "X605-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X606",
    "nombre_dx": "X606-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X607",
    "nombre_dx": "X607-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X608",
    "nombre_dx": "X608-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X609",
    "nombre_dx": "X609-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIR",
    "sexo": "A"
  },
  {
    "cod_dx": "X610",
    "nombre_dx": "X610-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X611",
    "nombre_dx": "X611-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X612",
    "nombre_dx": "X612-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X613",
    "nombre_dx": "X613-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X614",
    "nombre_dx": "X614-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X615",
    "nombre_dx": "X615-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X616",
    "nombre_dx": "X616-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X617",
    "nombre_dx": "X617-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X618",
    "nombre_dx": "X618-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X619",
    "nombre_dx": "X619-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "X620",
    "nombre_dx": "X620-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X621",
    "nombre_dx": "X621-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X622",
    "nombre_dx": "X622-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X623",
    "nombre_dx": "X623-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X624",
    "nombre_dx": "X624-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X625",
    "nombre_dx": "X625-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X626",
    "nombre_dx": "X626-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X627",
    "nombre_dx": "X627-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X628",
    "nombre_dx": "X628-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X629",
    "nombre_dx": "X629-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALU",
    "sexo": "A"
  },
  {
    "cod_dx": "X630",
    "nombre_dx": "X630-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X631",
    "nombre_dx": "X631-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X632",
    "nombre_dx": "X632-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X633",
    "nombre_dx": "X633-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X634",
    "nombre_dx": "X634-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X635",
    "nombre_dx": "X635-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X636",
    "nombre_dx": "X636-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X637",
    "nombre_dx": "X637-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X638",
    "nombre_dx": "X638-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X639",
    "nombre_dx": "X639-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL S",
    "sexo": "A"
  },
  {
    "cod_dx": "X640",
    "nombre_dx": "X640-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X641",
    "nombre_dx": "X641-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X642",
    "nombre_dx": "X642-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X643",
    "nombre_dx": "X643-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X644",
    "nombre_dx": "X644-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X645",
    "nombre_dx": "X645-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X646",
    "nombre_dx": "X646-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X647",
    "nombre_dx": "X647-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X648",
    "nombre_dx": "X648-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X649",
    "nombre_dx": "X649-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTRAS DROGAS MEDICAMENTOS Y SUSTAN",
    "sexo": "A"
  },
  {
    "cod_dx": "X650",
    "nombre_dx": "X650-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X651",
    "nombre_dx": "X651-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X652",
    "nombre_dx": "X652-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: ESCUELAS, OTRAS INSTITUC",
    "sexo": "A"
  },
  {
    "cod_dx": "X653",
    "nombre_dx": "X653-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: AREAS DE DEPORTE Y ATLET",
    "sexo": "A"
  },
  {
    "cod_dx": "X654",
    "nombre_dx": "X654-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X655",
    "nombre_dx": "X655-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: COMERCIO Y AREAS DE SERV",
    "sexo": "A"
  },
  {
    "cod_dx": "X656",
    "nombre_dx": "X656-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: AREA INDUSTRIAL Y DE LA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X657",
    "nombre_dx": "X657-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X658",
    "nombre_dx": "X658-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X659",
    "nombre_dx": "X659-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION AL ALCOHOL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X660",
    "nombre_dx": "X660-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X661",
    "nombre_dx": "X661-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X662",
    "nombre_dx": "X662-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X663",
    "nombre_dx": "X663-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X664",
    "nombre_dx": "X664-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X665",
    "nombre_dx": "X665-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X666",
    "nombre_dx": "X666-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X667",
    "nombre_dx": "X667-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X668",
    "nombre_dx": "X668-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X669",
    "nombre_dx": "X669-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBU",
    "sexo": "A"
  },
  {
    "cod_dx": "X670",
    "nombre_dx": "X670-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X671",
    "nombre_dx": "X671-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X672",
    "nombre_dx": "X672-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: ESCUELAS, O",
    "sexo": "A"
  },
  {
    "cod_dx": "X673",
    "nombre_dx": "X673-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: AREAS DE DE",
    "sexo": "A"
  },
  {
    "cod_dx": "X674",
    "nombre_dx": "X674-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: CALLES Y CA",
    "sexo": "A"
  },
  {
    "cod_dx": "X675",
    "nombre_dx": "X675-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: COMERCIO Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "X676",
    "nombre_dx": "X676-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: AREA INDUST",
    "sexo": "A"
  },
  {
    "cod_dx": "X677",
    "nombre_dx": "X677-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X678",
    "nombre_dx": "X678-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: OTRO LUGAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "X679",
    "nombre_dx": "X679-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS GASES Y VAPORES: LUGAR NO ES",
    "sexo": "A"
  },
  {
    "cod_dx": "X680",
    "nombre_dx": "X680-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X681",
    "nombre_dx": "X681-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: INSTITUCION RESIDENCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X682",
    "nombre_dx": "X682-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: ESCUELAS, OTRAS INSTI",
    "sexo": "A"
  },
  {
    "cod_dx": "X683",
    "nombre_dx": "X683-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: AREAS DE DEPORTE Y AT",
    "sexo": "A"
  },
  {
    "cod_dx": "X684",
    "nombre_dx": "X684-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X685",
    "nombre_dx": "X685-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: COMERCIO Y AREAS DE S",
    "sexo": "A"
  },
  {
    "cod_dx": "X686",
    "nombre_dx": "X686-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: AREA INDUSTRIAL Y DE ",
    "sexo": "A"
  },
  {
    "cod_dx": "X687",
    "nombre_dx": "X687-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X688",
    "nombre_dx": "X688-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: OTRO LUGAR ESPECIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "X689",
    "nombre_dx": "X689-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A PLAGUICIDAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X690",
    "nombre_dx": "X690-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X691",
    "nombre_dx": "X691-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X692",
    "nombre_dx": "X692-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X693",
    "nombre_dx": "X693-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X694",
    "nombre_dx": "X694-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X695",
    "nombre_dx": "X695-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X696",
    "nombre_dx": "X696-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X697",
    "nombre_dx": "X697-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X698",
    "nombre_dx": "X698-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X699",
    "nombre_dx": "X699-ENVENENAMIENTO AUTOINFLIGIDO INTENCIONALMENTE POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANC",
    "sexo": "A"
  },
  {
    "cod_dx": "X700",
    "nombre_dx": "X700-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X701",
    "nombre_dx": "X701-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: INSTITUCION R",
    "sexo": "A"
  },
  {
    "cod_dx": "X702",
    "nombre_dx": "X702-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: ESCUELAS, OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "X703",
    "nombre_dx": "X703-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: AREAS DE DEPO",
    "sexo": "A"
  },
  {
    "cod_dx": "X704",
    "nombre_dx": "X704-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: CALLES Y CARR",
    "sexo": "A"
  },
  {
    "cod_dx": "X705",
    "nombre_dx": "X705-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: COMERCIO Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "X706",
    "nombre_dx": "X706-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: AREA INDUSTRI",
    "sexo": "A"
  },
  {
    "cod_dx": "X707",
    "nombre_dx": "X707-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X708",
    "nombre_dx": "X708-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: OTRO LUGAR ES",
    "sexo": "A"
  },
  {
    "cod_dx": "X709",
    "nombre_dx": "X709-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHORCAMIENTO, ESTRANGULAMIENTO O SOFOCACION: LUGAR NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "X710",
    "nombre_dx": "X710-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X711",
    "nombre_dx": "X711-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X712",
    "nombre_dx": "X712-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: ESCUELAS, OTRAS INSTITUCIONES Y A",
    "sexo": "A"
  },
  {
    "cod_dx": "X713",
    "nombre_dx": "X713-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X714",
    "nombre_dx": "X714-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X715",
    "nombre_dx": "X715-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X716",
    "nombre_dx": "X716-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: AREA INDUSTRIAL Y DE LA CONSTRUCC",
    "sexo": "A"
  },
  {
    "cod_dx": "X717",
    "nombre_dx": "X717-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X718",
    "nombre_dx": "X718-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X719",
    "nombre_dx": "X719-LESION AUTOINFLIGIDA INTENCIONALMENTE POR AHOGAMIENTO Y SUMERSION: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X720",
    "nombre_dx": "X720-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X721",
    "nombre_dx": "X721-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X722",
    "nombre_dx": "X722-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: ESCUELAS, OTRAS INSTITUCIONES Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "X723",
    "nombre_dx": "X723-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X724",
    "nombre_dx": "X724-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X725",
    "nombre_dx": "X725-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X726",
    "nombre_dx": "X726-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: AREA INDUSTRIAL Y DE LA CONSTRUCCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X727",
    "nombre_dx": "X727-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X728",
    "nombre_dx": "X728-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X729",
    "nombre_dx": "X729-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE ARMA CORTA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X730",
    "nombre_dx": "X730-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X731",
    "nombre_dx": "X731-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: INSTITUCION RESID",
    "sexo": "A"
  },
  {
    "cod_dx": "X732",
    "nombre_dx": "X732-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: ESCUELAS, OTRAS I",
    "sexo": "A"
  },
  {
    "cod_dx": "X733",
    "nombre_dx": "X733-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREAS DE DEPORTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "X734",
    "nombre_dx": "X734-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: CALLES Y CARRETER",
    "sexo": "A"
  },
  {
    "cod_dx": "X735",
    "nombre_dx": "X735-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: COMERCIO Y AREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X736",
    "nombre_dx": "X736-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREA INDUSTRIAL Y",
    "sexo": "A"
  },
  {
    "cod_dx": "X737",
    "nombre_dx": "X737-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X738",
    "nombre_dx": "X738-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: OTRO LUGAR ESPECI",
    "sexo": "A"
  },
  {
    "cod_dx": "X739",
    "nombre_dx": "X739-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: LUGAR NO ESPECIFI",
    "sexo": "A"
  },
  {
    "cod_dx": "X740",
    "nombre_dx": "X740-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: V",
    "sexo": "A"
  },
  {
    "cod_dx": "X741",
    "nombre_dx": "X741-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: I",
    "sexo": "A"
  },
  {
    "cod_dx": "X742",
    "nombre_dx": "X742-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: E",
    "sexo": "A"
  },
  {
    "cod_dx": "X743",
    "nombre_dx": "X743-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: A",
    "sexo": "A"
  },
  {
    "cod_dx": "X744",
    "nombre_dx": "X744-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: C",
    "sexo": "A"
  },
  {
    "cod_dx": "X745",
    "nombre_dx": "X745-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: C",
    "sexo": "A"
  },
  {
    "cod_dx": "X746",
    "nombre_dx": "X746-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: A",
    "sexo": "A"
  },
  {
    "cod_dx": "X747",
    "nombre_dx": "X747-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: G",
    "sexo": "A"
  },
  {
    "cod_dx": "X748",
    "nombre_dx": "X748-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: O",
    "sexo": "A"
  },
  {
    "cod_dx": "X749",
    "nombre_dx": "X749-LESION AUTOINFLIGIDA INTENCIONALMENTE POR DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: L",
    "sexo": "A"
  },
  {
    "cod_dx": "X750",
    "nombre_dx": "X750-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X751",
    "nombre_dx": "X751-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X752",
    "nombre_dx": "X752-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X753",
    "nombre_dx": "X753-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X754",
    "nombre_dx": "X754-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X755",
    "nombre_dx": "X755-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X756",
    "nombre_dx": "X756-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X757",
    "nombre_dx": "X757-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X758",
    "nombre_dx": "X758-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X759",
    "nombre_dx": "X759-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MATERIAL EXPLOSIVO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X760",
    "nombre_dx": "X760-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X761",
    "nombre_dx": "X761-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X762",
    "nombre_dx": "X762-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: ESCUELAS, OTRAS INSTITUCIONES Y AREA",
    "sexo": "A"
  },
  {
    "cod_dx": "X763",
    "nombre_dx": "X763-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X764",
    "nombre_dx": "X764-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X765",
    "nombre_dx": "X765-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X766",
    "nombre_dx": "X766-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X767",
    "nombre_dx": "X767-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X768",
    "nombre_dx": "X768-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X769",
    "nombre_dx": "X769-LESION AUTOINFLIGIDA INTENCIONALMENTE POR HUMO, FUEGO Y LLAMAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X770",
    "nombre_dx": "X770-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X771",
    "nombre_dx": "X771-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: INSTITUCION RE",
    "sexo": "A"
  },
  {
    "cod_dx": "X772",
    "nombre_dx": "X772-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: ESCUELAS, OTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "X773",
    "nombre_dx": "X773-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: AREAS DE DEPOR",
    "sexo": "A"
  },
  {
    "cod_dx": "X774",
    "nombre_dx": "X774-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: CALLES Y CARRE",
    "sexo": "A"
  },
  {
    "cod_dx": "X775",
    "nombre_dx": "X775-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: COMERCIO Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "X776",
    "nombre_dx": "X776-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: AREA INDUSTRIA",
    "sexo": "A"
  },
  {
    "cod_dx": "X777",
    "nombre_dx": "X777-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X778",
    "nombre_dx": "X778-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: OTRO LUGAR ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "X779",
    "nombre_dx": "X779-LESION AUTOINFLIGIDA INTENCIONALMENTE POR VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: LUGAR NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "X780",
    "nombre_dx": "X780-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X781",
    "nombre_dx": "X781-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X782",
    "nombre_dx": "X782-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADM",
    "sexo": "A"
  },
  {
    "cod_dx": "X783",
    "nombre_dx": "X783-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X784",
    "nombre_dx": "X784-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X785",
    "nombre_dx": "X785-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X786",
    "nombre_dx": "X786-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X787",
    "nombre_dx": "X787-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X788",
    "nombre_dx": "X788-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X789",
    "nombre_dx": "X789-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO CORTANTE: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X790",
    "nombre_dx": "X790-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X791",
    "nombre_dx": "X791-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X792",
    "nombre_dx": "X792-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: ESCUELAS, OTRAS INSTITUCIONES Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "X793",
    "nombre_dx": "X793-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X794",
    "nombre_dx": "X794-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X795",
    "nombre_dx": "X795-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X796",
    "nombre_dx": "X796-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: AREA INDUSTRIAL Y DE LA CONSTRUCCI",
    "sexo": "A"
  },
  {
    "cod_dx": "X797",
    "nombre_dx": "X797-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X798",
    "nombre_dx": "X798-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X799",
    "nombre_dx": "X799-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OBJETO ROMO O SIN FILO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X800",
    "nombre_dx": "X800-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X801",
    "nombre_dx": "X801-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X802",
    "nombre_dx": "X802-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: ESCUELAS, OTRAS INSTITUCIONE",
    "sexo": "A"
  },
  {
    "cod_dx": "X803",
    "nombre_dx": "X803-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X804",
    "nombre_dx": "X804-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X805",
    "nombre_dx": "X805-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X806",
    "nombre_dx": "X806-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: AREA INDUSTRIAL Y DE LA CONS",
    "sexo": "A"
  },
  {
    "cod_dx": "X807",
    "nombre_dx": "X807-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X808",
    "nombre_dx": "X808-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X809",
    "nombre_dx": "X809-LESION AUTOINFLIGIDA INTENCIONALMENTE AL SALTAR DESDE UN LUGAR ELEVADO: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X810",
    "nombre_dx": "X810-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: VIV",
    "sexo": "A"
  },
  {
    "cod_dx": "X811",
    "nombre_dx": "X811-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: INS",
    "sexo": "A"
  },
  {
    "cod_dx": "X812",
    "nombre_dx": "X812-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: ESC",
    "sexo": "A"
  },
  {
    "cod_dx": "X813",
    "nombre_dx": "X813-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "X814",
    "nombre_dx": "X814-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: CAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X815",
    "nombre_dx": "X815-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: COM",
    "sexo": "A"
  },
  {
    "cod_dx": "X816",
    "nombre_dx": "X816-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "X817",
    "nombre_dx": "X817-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: GRA",
    "sexo": "A"
  },
  {
    "cod_dx": "X818",
    "nombre_dx": "X818-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "X819",
    "nombre_dx": "X819-LESION AUTOINFLIGIDA INTENCIONALMENTE POR ARROJARSE O COLOCARSE DELANTE DE OBJETO EN MOVIMIENTO: LUG",
    "sexo": "A"
  },
  {
    "cod_dx": "X820",
    "nombre_dx": "X820-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X821",
    "nombre_dx": "X821-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DEMOTOR: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X822",
    "nombre_dx": "X822-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: ESCUELAS, OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X823",
    "nombre_dx": "X823-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "X824",
    "nombre_dx": "X824-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X825",
    "nombre_dx": "X825-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: COMERCIO Y AREAS DE SERVICI",
    "sexo": "A"
  },
  {
    "cod_dx": "X826",
    "nombre_dx": "X826-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "X827",
    "nombre_dx": "X827-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X828",
    "nombre_dx": "X828-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X829",
    "nombre_dx": "X829-LESION AUTOINFLIGIDA INTENCIONALMENTE POR COLISION DE VEHICULO DE MOTOR: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X830",
    "nombre_dx": "X830-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X831",
    "nombre_dx": "X831-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X832",
    "nombre_dx": "X832-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "X833",
    "nombre_dx": "X833-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X834",
    "nombre_dx": "X834-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X835",
    "nombre_dx": "X835-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X836",
    "nombre_dx": "X836-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "X837",
    "nombre_dx": "X837-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X838",
    "nombre_dx": "X838-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X839",
    "nombre_dx": "X839-LESION AUTOINFLIGIDA INTENCIONALMENTE POR OTROS MEDIOS ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X840",
    "nombre_dx": "X840-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X841",
    "nombre_dx": "X841-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X842",
    "nombre_dx": "X842-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y A",
    "sexo": "A"
  },
  {
    "cod_dx": "X843",
    "nombre_dx": "X843-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X844",
    "nombre_dx": "X844-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X845",
    "nombre_dx": "X845-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X846",
    "nombre_dx": "X846-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCC",
    "sexo": "A"
  },
  {
    "cod_dx": "X847",
    "nombre_dx": "X847-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X848",
    "nombre_dx": "X848-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X849",
    "nombre_dx": "X849-LESION AUTOINFLIGIDA INTENCIONALMENTE POR MEDIOS NO ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X850",
    "nombre_dx": "X850-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X851",
    "nombre_dx": "X851-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X852",
    "nombre_dx": "X852-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADM",
    "sexo": "A"
  },
  {
    "cod_dx": "X853",
    "nombre_dx": "X853-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X854",
    "nombre_dx": "X854-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X855",
    "nombre_dx": "X855-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X856",
    "nombre_dx": "X856-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X857",
    "nombre_dx": "X857-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X858",
    "nombre_dx": "X858-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X859",
    "nombre_dx": "X859-AGRESION CON DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X860",
    "nombre_dx": "X860-AGRESION CON SUSTANCIA CORROSIVA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X861",
    "nombre_dx": "X861-AGRESION CON SUSTANCIACORROSIVA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X862",
    "nombre_dx": "X862-AGRESION CON SUSTANCIA CORROSIVA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X863",
    "nombre_dx": "X863-AGRESION CON SUSTANCIACORROSIVA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X864",
    "nombre_dx": "X864-AGRESION CON SUSTANCIA CORROSIVA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X865",
    "nombre_dx": "X865-AGRESION CON SUSTANCIA CORROSIVA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X866",
    "nombre_dx": "X866-AGRESION CON SUSTANCIA CORROSIVA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X867",
    "nombre_dx": "X867-AGRESION CON SUSTANCIA CORROSIVA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X868",
    "nombre_dx": "X868-AGRESION CON SUSTANCIACORROSIVA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X869",
    "nombre_dx": "X869-AGRESION CON SUSTANCIA CORROSIVA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X870",
    "nombre_dx": "X870-AGRESION CON PLAGUICIDAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X871",
    "nombre_dx": "X871-AGRESION CON PLAGUICIDAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X872",
    "nombre_dx": "X872-AGRESION CON PLAGUICIDAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X873",
    "nombre_dx": "X873-AGRESION CON PLAGUICIDAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X874",
    "nombre_dx": "X874-AGRESION CON PLAGUICIDAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X875",
    "nombre_dx": "X875-AGRESION CON PLAGUICIDAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X876",
    "nombre_dx": "X876-AGRESION CON PLAGUICIDAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X877",
    "nombre_dx": "X877-AGRESION CON PLAGUICIDAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X878",
    "nombre_dx": "X878-AGRESION CON PLAGUICIDAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X879",
    "nombre_dx": "X879-AGRESION CON PLAGUICIDAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X880",
    "nombre_dx": "X880-AGRESION CON GASES Y VAPORES: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X881",
    "nombre_dx": "X881-AGRESION CON GASES Y VAPORES: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X882",
    "nombre_dx": "X882-AGRESION CON GASES Y VAPORES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X883",
    "nombre_dx": "X883-AGRESION CON GASES Y VAPORES: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X884",
    "nombre_dx": "X884-AGRESION CON GASES Y VAPORES: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X885",
    "nombre_dx": "X885-AGRESION CON GASES Y VAPORES: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X886",
    "nombre_dx": "X886-AGRESION CON GASES Y VAPORES: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X887",
    "nombre_dx": "X887-AGRESION CON GASES Y VAPORES: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X888",
    "nombre_dx": "X888-AGRESION CON GASES Y VAPORES: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X889",
    "nombre_dx": "X889-AGRESION CON GASES Y VAPORES: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X890",
    "nombre_dx": "X890-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X891",
    "nombre_dx": "X891-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X892",
    "nombre_dx": "X892-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X893",
    "nombre_dx": "X893-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: AREAS DE DEPORTE Y ATLETIS",
    "sexo": "A"
  },
  {
    "cod_dx": "X894",
    "nombre_dx": "X894-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X895",
    "nombre_dx": "X895-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: COMERCIO Y AREAS DE SERVIC",
    "sexo": "A"
  },
  {
    "cod_dx": "X896",
    "nombre_dx": "X896-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CO",
    "sexo": "A"
  },
  {
    "cod_dx": "X897",
    "nombre_dx": "X897-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X898",
    "nombre_dx": "X898-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X899",
    "nombre_dx": "X899-AGRESION CON OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS ESPECIFICADAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X900",
    "nombre_dx": "X900-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X901",
    "nombre_dx": "X901-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X902",
    "nombre_dx": "X902-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "X903",
    "nombre_dx": "X903-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X904",
    "nombre_dx": "X904-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X905",
    "nombre_dx": "X905-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X906",
    "nombre_dx": "X906-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONST",
    "sexo": "A"
  },
  {
    "cod_dx": "X907",
    "nombre_dx": "X907-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X908",
    "nombre_dx": "X908-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X909",
    "nombre_dx": "X909-AGRESION CON PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X910",
    "nombre_dx": "X910-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X911",
    "nombre_dx": "X911-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X912",
    "nombre_dx": "X912-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMI",
    "sexo": "A"
  },
  {
    "cod_dx": "X913",
    "nombre_dx": "X913-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X914",
    "nombre_dx": "X914-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X915",
    "nombre_dx": "X915-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X916",
    "nombre_dx": "X916-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X917",
    "nombre_dx": "X917-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X918",
    "nombre_dx": "X918-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X919",
    "nombre_dx": "X919-AGRESION POR AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X920",
    "nombre_dx": "X920-AGRESION POR AHOGAMIENTO Y SUMERSION: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X921",
    "nombre_dx": "X921-AGRESION POR AHOGAMIENTO Y SUMERSION: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X922",
    "nombre_dx": "X922-AGRESION POR AHOGAMIENTO Y SUMERSION: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X923",
    "nombre_dx": "X923-AGRESION POR AHOGAMIENTO Y SUMERSION: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X924",
    "nombre_dx": "X924-AGRESION POR AHOGAMIENTO Y SUMERSION: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X925",
    "nombre_dx": "X925-AGRESION POR AHOGAMIENTO Y SUMERSION: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X926",
    "nombre_dx": "X926-AGRESION POR AHOGAMIENTO Y SUMERSION: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X927",
    "nombre_dx": "X927-AGRESION POR AHOGAMIENTO Y SUMERSION: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X928",
    "nombre_dx": "X928-AGRESION POR AHOGAMIENTO Y SUMERSION: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X929",
    "nombre_dx": "X929-AGRESION POR AHOGAMIENTO Y SUMERSION: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X930",
    "nombre_dx": "X930-AGRESION CON DISPARO DE ARMA CORTA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X931",
    "nombre_dx": "X931-AGRESION CON DISPARO DE ARMA CORTA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X932",
    "nombre_dx": "X932-AGRESION CON DISPARO DE ARMA CORTA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X933",
    "nombre_dx": "X933-AGRESION CON DISPARO DE ARMA CORTA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X934",
    "nombre_dx": "X934-AGRESION CON DISPARO DE ARMA CORTA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X935",
    "nombre_dx": "X935-AGRESION CON DISPARO DE ARMA CORTA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X936",
    "nombre_dx": "X936-AGRESION CON DISPARO DE ARMA CORTA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X937",
    "nombre_dx": "X937-AGRESION CON DISPARO DE ARMA CORTA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X938",
    "nombre_dx": "X938-AGRESION CON DISPARO DE ARMA CORTA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X939",
    "nombre_dx": "X939-AGRESION CON DISPARO DE ARMA CORTA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X940",
    "nombre_dx": "X940-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X941",
    "nombre_dx": "X941-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X942",
    "nombre_dx": "X942-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINIST",
    "sexo": "A"
  },
  {
    "cod_dx": "X943",
    "nombre_dx": "X943-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X944",
    "nombre_dx": "X944-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X945",
    "nombre_dx": "X945-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X946",
    "nombre_dx": "X946-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X947",
    "nombre_dx": "X947-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X948",
    "nombre_dx": "X948-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X949",
    "nombre_dx": "X949-AGRESION CON DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X950",
    "nombre_dx": "X950-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X951",
    "nombre_dx": "X951-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X952",
    "nombre_dx": "X952-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: ESCUELAS, OTRAS INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "X953",
    "nombre_dx": "X953-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X954",
    "nombre_dx": "X954-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X955",
    "nombre_dx": "X955-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X956",
    "nombre_dx": "X956-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: AREA INDUSTRIAL Y DE LA CONSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "X957",
    "nombre_dx": "X957-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X958",
    "nombre_dx": "X958-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X959",
    "nombre_dx": "X959-AGRESION CON DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X960",
    "nombre_dx": "X960-AGRESION CON MATERIAL EXPLOSIVO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X961",
    "nombre_dx": "X961-AGRESION CON MATERIAL EXPLOSIVO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X962",
    "nombre_dx": "X962-AGRESION CON MATERIAL EXPLOSIVO: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X963",
    "nombre_dx": "X963-AGRESION CON MATERIAL EXPLOSIVO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X964",
    "nombre_dx": "X964-AGRESION CON MATERIAL EXPLOSIVO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X965",
    "nombre_dx": "X965-AGRESION CON MATERIAL EXPLOSIVO: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X966",
    "nombre_dx": "X966-AGRESION CON MATERIAL EXPLOSIVO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X967",
    "nombre_dx": "X967-AGRESION CON MATERIAL EXPLOSIVO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X968",
    "nombre_dx": "X968-AGRESION CON MATERIAL EXPLOSIVO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X969",
    "nombre_dx": "X969-AGRESION CON MATERIAL EXPLOSIVO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X970",
    "nombre_dx": "X970-AGRESION CON HUMO, FUEGO Y LLAMAS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X971",
    "nombre_dx": "X971-AGRESION CON HUMO, FUEGO Y LLAMAS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X972",
    "nombre_dx": "X972-AGRESION CON HUMO, FUEGO Y LLAMAS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X973",
    "nombre_dx": "X973-AGRESION CON HUMO, FUEGO Y LLAMAS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X974",
    "nombre_dx": "X974-AGRESION CON HUMO, FUEGO Y LLAMAS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X975",
    "nombre_dx": "X975-AGRESION CON HUMO, FUEGO Y LLAMAS: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X976",
    "nombre_dx": "X976-AGRESION CON HUMO, FUEGO Y LLAMAS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X977",
    "nombre_dx": "X977-AGRESION CON HUMO, FUEGO Y LLAMAS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X978",
    "nombre_dx": "X978-AGRESION CON HUMO, FUEGO Y LLAMAS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X979",
    "nombre_dx": "X979-AGRESION CON HUMO, FUEGO Y LLAMAS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X980",
    "nombre_dx": "X980-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X981",
    "nombre_dx": "X981-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "X982",
    "nombre_dx": "X982-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMIN",
    "sexo": "A"
  },
  {
    "cod_dx": "X983",
    "nombre_dx": "X983-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X984",
    "nombre_dx": "X984-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X985",
    "nombre_dx": "X985-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: COMERCIO Y AREAS DE SERVICIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X986",
    "nombre_dx": "X986-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "X987",
    "nombre_dx": "X987-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "X988",
    "nombre_dx": "X988-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X989",
    "nombre_dx": "X989-AGRESION CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "X990",
    "nombre_dx": "X990-AGRESION CON OBJETO CORTANTE: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "X991",
    "nombre_dx": "X991-AGRESION CON OBJETO CORTANTE: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "X992",
    "nombre_dx": "X992-AGRESION CON OBJETO CORTANTE: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS PUBLICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "X993",
    "nombre_dx": "X993-AGRESION CON OBJETO CORTANTE: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "X994",
    "nombre_dx": "X994-AGRESION CON OBJETO CORTANTE: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "X995",
    "nombre_dx": "X995-AGRESION CON OBJETO CORTANTE: COMERCIO Y AREAS DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "X996",
    "nombre_dx": "X996-AGRESION CON OBJETO CORTANTE: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "X997",
    "nombre_dx": "X997-AGRESION CON OBJETO CORTANTE: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "X998",
    "nombre_dx": "X998-AGRESION CON OBJETO CORTANTE: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "X999",
    "nombre_dx": "X999-AGRESION CON OBJETO CORTANTE: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y000",
    "nombre_dx": "Y000-AGRESION CON OBJETO ROMO O SIN FILO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y001",
    "nombre_dx": "Y001-AGRESION CON OBJETO ROMO O SIN FILO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y002",
    "nombre_dx": "Y002-AGRESION CON OBJETO ROMO O SIN FILO: ESCUELAS OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y003",
    "nombre_dx": "Y003-AGRESION CON OBJETO ROMO O SIN FILO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y004",
    "nombre_dx": "Y004-AGRESION CON OBJETO ROMO O SIN FILO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y005",
    "nombre_dx": "Y005-AGRESION CON OBJETO ROMO O SIN FILO: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y006",
    "nombre_dx": "Y006-AGRESION CON OBJETO ROMO O SIN FILO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y007",
    "nombre_dx": "Y007-AGRESION CON OBJETO ROMO O SIN FILO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y008",
    "nombre_dx": "Y008-AGRESION CON OBJETO ROMO O SIN FILO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y009",
    "nombre_dx": "Y009-AGRESION CON OBJETO ROMO O SIN FILO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y010",
    "nombre_dx": "Y010-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y011",
    "nombre_dx": "Y011-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y012",
    "nombre_dx": "Y012-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: ESCUELAS OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y013",
    "nombre_dx": "Y013-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y014",
    "nombre_dx": "Y014-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y015",
    "nombre_dx": "Y015-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y016",
    "nombre_dx": "Y016-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y017",
    "nombre_dx": "Y017-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y018",
    "nombre_dx": "Y018-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y019",
    "nombre_dx": "Y019-AGRESION POR EMPUJON DESDE UN LUGAR ELEVADO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y020",
    "nombre_dx": "Y020-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y021",
    "nombre_dx": "Y021-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y022",
    "nombre_dx": "Y022-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: ESCUELAS OTRAS INSTITUC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y023",
    "nombre_dx": "Y023-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: AREAS DE DEPORTE Y ATLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y024",
    "nombre_dx": "Y024-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y025",
    "nombre_dx": "Y025-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: COMERCIO Y AREA DE SERV",
    "sexo": "A"
  },
  {
    "cod_dx": "Y026",
    "nombre_dx": "Y026-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: AREA INDUSTRIAL Y DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y027",
    "nombre_dx": "Y027-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y028",
    "nombre_dx": "Y028-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y029",
    "nombre_dx": "Y029-AGRESION POR EMPUJAR O COLOCAR A LA VICTIMA DELANTE DE OBJETO EN MOVIMIENTO: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y030",
    "nombre_dx": "Y030-AGRESION POR COLISION DE VEHICULO DE MOTOR: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y031",
    "nombre_dx": "Y031-AGRESION POR COLISION DE VEHICULO DE MOTOR: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y032",
    "nombre_dx": "Y032-AGRESION POR COLISION DE VEHICULO DE MOTOR: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y033",
    "nombre_dx": "Y033-AGRESION POR COLISION DE VEHICULO DE MOTOR: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y034",
    "nombre_dx": "Y034-AGRESION POR COLISION DE VEHICULO DE MOTOR: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y035",
    "nombre_dx": "Y035-AGRESION POR COLISION DE VEHICULO DE MOTOR: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y036",
    "nombre_dx": "Y036-AGRESION POR COLISION DE VEHICULO DE MOTOR: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y037",
    "nombre_dx": "Y037-AGRESION POR COLISION DE VEHICULO DE MOTOR: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y038",
    "nombre_dx": "Y038-AGRESION POR COLISION DE VEHICULO DE MOTOR: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y039",
    "nombre_dx": "Y039-AGRESION POR COLISION DE VEHICULO DE MOTOR: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y040",
    "nombre_dx": "Y040-AGRESION CON FUERZA CORPORAL: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y041",
    "nombre_dx": "Y041-AGRESION CON FUERZA CORPORAL: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y042",
    "nombre_dx": "Y042-AGRESION CON FUERZA CORPORAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y043",
    "nombre_dx": "Y043-AGRESION CON FUERZA CORPORAL: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y044",
    "nombre_dx": "Y044-AGRESION CON FUERZA CORPORAL: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y045",
    "nombre_dx": "Y045-AGRESION CON FUERZA CORPORAL: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y046",
    "nombre_dx": "Y046-AGRESION CON FUERZA CORPORAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y047",
    "nombre_dx": "Y047-AGRESION CON FUERZA CORPORAL: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y048",
    "nombre_dx": "Y048-AGRESION CON FUERZA CORPORAL: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y049",
    "nombre_dx": "Y049-AGRESION CON FUERZA CORPORAL: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y050",
    "nombre_dx": "Y050-AGRESION SEXUAL CON FUERZA CORPORAL: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y051",
    "nombre_dx": "Y051-AGRESION SEXUAL CON FUERZA CORPORAL: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y052",
    "nombre_dx": "Y052-AGRESION SEXUAL CON FUERZA CORPORAL: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y053",
    "nombre_dx": "Y053-AGRESION SEXUAL CON FUERZA CORPORAL: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y054",
    "nombre_dx": "Y054-AGRESION SEXUAL CON FUERZA CORPORAL: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y055",
    "nombre_dx": "Y055-AGRESION SEXUAL CON FUERZA CORPORAL: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y056",
    "nombre_dx": "Y056-AGRESION SEXUAL CON FUERZA CORPORAL: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y057",
    "nombre_dx": "Y057-AGRESION SEXUAL CON FUERZA CORPORAL: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y058",
    "nombre_dx": "Y058-AGRESION SEXUAL CON FUERZA CORPORAL: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y059",
    "nombre_dx": "Y059-AGRESION SEXUAL CON FUERZA CORPORAL: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y060",
    "nombre_dx": "Y060-NEGLICENCIA Y ABANDONO: POR ESPOSO O PAREJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y061",
    "nombre_dx": "Y061-NEGLICENCIA Y ABANDONO: POR PADRE O MADRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y062",
    "nombre_dx": "Y062-NEGLICENCIA Y ABANDONO: POR CONOCIDO O AMIGO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y068",
    "nombre_dx": "Y068-NEGLICENCIA Y ABANDONO: POR OTRA PERSONA ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y069",
    "nombre_dx": "Y069-NEGLICENCIA Y ABANDONO: POR PERSONA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y070",
    "nombre_dx": "Y070-OTROS SINDROMES DE MALTRATO: POR ESPOSO O PAREJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y071",
    "nombre_dx": "Y071-OTROS SINDROMES DE MALTRATO: POR PADRE O MADRE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y072",
    "nombre_dx": "Y072-OTROS SINDROMES DE MALTRATO: POR CONOCIDO O AMIGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y073",
    "nombre_dx": "Y073-OTROS SINDROMES DE MALTRATO: POR AUTORIDADES OFICIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y078",
    "nombre_dx": "Y078-OTROS SINDROMES DE MALTRATO: POR OTRA PERSONA ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y079",
    "nombre_dx": "Y079-OTROS SINDROMES DE MALTRATO: POR PERSONA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y07X",
    "nombre_dx": "Y07X-Otros maltratos (antes OTROS SINDROMES DE MALTRATO)",
    "sexo": "A"
  },
  {
    "cod_dx": "Y080",
    "nombre_dx": "Y080-AGRESION POR OTROS MEDIOS ESPECIFICADOS: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y081",
    "nombre_dx": "Y081-AGRESION POR OTROS MEDIOS ESPECIFICADOS: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y082",
    "nombre_dx": "Y082-AGRESION POR OTROS MEDIOS ESPECIFICADOS: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y083",
    "nombre_dx": "Y083-AGRESION POR OTROS MEDIOS ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y084",
    "nombre_dx": "Y084-AGRESION POR OTROS MEDIOS ESPECIFICADOS: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y085",
    "nombre_dx": "Y085-AGRESION POR OTROS MEDIOS ESPECIFICADOS: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y086",
    "nombre_dx": "Y086-AGRESION POR OTROS MEDIOS ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y087",
    "nombre_dx": "Y087-AGRESION POR OTROS MEDIOS ESPECIFICADOS: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y088",
    "nombre_dx": "Y088-AGRESION POR OTROS MEDIOS ESPECIFICADOS: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y089",
    "nombre_dx": "Y089-AGRESION POR OTROS MEDIOS ESPECIFICADOS: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y090",
    "nombre_dx": "Y090-AGRESION POR MEDIOS NO ESPECIFICADOS: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y091",
    "nombre_dx": "Y091-AGRESION POR MEDIOS NO ESPECIFICADOS: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y092",
    "nombre_dx": "Y092-AGRESION POR MEDIOS NO ESPECIFICADOS: ESCUELAS OTRAS INSTITUCIONES Y AREAS ADMINISTRATIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y093",
    "nombre_dx": "Y093-AGRESION POR MEDIOS NO ESPECIFICADOS: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y094",
    "nombre_dx": "Y094-AGRESION POR MEDIOS NO ESPECIFICADOS: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y095",
    "nombre_dx": "Y095-AGRESION POR MEDIOS NO ESPECIFICADOS: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y096",
    "nombre_dx": "Y096-AGRESION POR MEDIOS NO ESPECIFICADOS: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y097",
    "nombre_dx": "Y097-AGRESION POR MEDIOS NO ESPECIFICADOS: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y098",
    "nombre_dx": "Y098-AGRESION POR MEDIOS NO ESPECIFICADOS: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y099",
    "nombre_dx": "Y099-AGRESION POR MEDIOS NO ESPECIFICADOS: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y100",
    "nombre_dx": "Y100-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y101",
    "nombre_dx": "Y101-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y102",
    "nombre_dx": "Y102-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y103",
    "nombre_dx": "Y103-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y104",
    "nombre_dx": "Y104-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y105",
    "nombre_dx": "Y105-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y106",
    "nombre_dx": "Y106-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y107",
    "nombre_dx": "Y107-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y108",
    "nombre_dx": "Y108-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y109",
    "nombre_dx": "Y109-ENVENENAMIENTO POR, Y EXPOSICION A ANALGESICOS NO NARCOTICOS, ANTIPIRETICOS Y ANTIRREUMATICOS, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y110",
    "nombre_dx": "Y110-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y111",
    "nombre_dx": "Y111-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y112",
    "nombre_dx": "Y112-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y113",
    "nombre_dx": "Y113-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y114",
    "nombre_dx": "Y114-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y115",
    "nombre_dx": "Y115-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y116",
    "nombre_dx": "Y116-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y117",
    "nombre_dx": "Y117-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y118",
    "nombre_dx": "Y118-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y119",
    "nombre_dx": "Y119-ENVENENAMIENTO POR, Y EXPOSICION A DROGAS ANTIEPILEPTICAS, SEDANTES, HIPNOTICAS, ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y120",
    "nombre_dx": "Y120-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y121",
    "nombre_dx": "Y121-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y122",
    "nombre_dx": "Y122-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y123",
    "nombre_dx": "Y123-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y124",
    "nombre_dx": "Y124-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y125",
    "nombre_dx": "Y125-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y126",
    "nombre_dx": "Y126-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y127",
    "nombre_dx": "Y127-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y128",
    "nombre_dx": "Y128-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y129",
    "nombre_dx": "Y129-ENVENENAMIENTO POR, Y EXPOSICION A NARCOTICOS Y PSICODISLEPTICOS [ALUCINOGENOS], NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y130",
    "nombre_dx": "Y130-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y131",
    "nombre_dx": "Y131-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y132",
    "nombre_dx": "Y132-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y133",
    "nombre_dx": "Y133-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y134",
    "nombre_dx": "Y134-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y135",
    "nombre_dx": "Y135-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y136",
    "nombre_dx": "Y136-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y137",
    "nombre_dx": "Y137-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y138",
    "nombre_dx": "Y138-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y139",
    "nombre_dx": "Y139-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS QUE ACTUAN SOBRE EL SISTEMA NERVIOSO AUTONOMO, DE IN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y140",
    "nombre_dx": "Y140-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y141",
    "nombre_dx": "Y141-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y142",
    "nombre_dx": "Y142-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y143",
    "nombre_dx": "Y143-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y144",
    "nombre_dx": "Y144-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y145",
    "nombre_dx": "Y145-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y146",
    "nombre_dx": "Y146-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y147",
    "nombre_dx": "Y147-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y148",
    "nombre_dx": "Y148-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y149",
    "nombre_dx": "Y149-ENVENENAMIENTO POR, Y EXPOSICION A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS, Y LAS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y150",
    "nombre_dx": "Y150-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y151",
    "nombre_dx": "Y151-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y152",
    "nombre_dx": "Y152-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: ESCUELAS OTRAS INSTITUCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y153",
    "nombre_dx": "Y153-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y154",
    "nombre_dx": "Y154-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y155",
    "nombre_dx": "Y155-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y156",
    "nombre_dx": "Y156-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA C",
    "sexo": "A"
  },
  {
    "cod_dx": "Y157",
    "nombre_dx": "Y157-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y158",
    "nombre_dx": "Y158-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y159",
    "nombre_dx": "Y159-ENVENENAMIENTO POR, Y EXPOSICION AL ALCOHOL , DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y160",
    "nombre_dx": "Y160-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y161",
    "nombre_dx": "Y161-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y162",
    "nombre_dx": "Y162-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y163",
    "nombre_dx": "Y163-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y164",
    "nombre_dx": "Y164-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y165",
    "nombre_dx": "Y165-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y166",
    "nombre_dx": "Y166-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y167",
    "nombre_dx": "Y167-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y168",
    "nombre_dx": "Y168-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y169",
    "nombre_dx": "Y169-ENVENENAMIENTO POR, Y EXPOSICION A DISOLVENTES ORGANICOS E HIDROCARBUROS HALOGENADOS Y SUS VAPORES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y170",
    "nombre_dx": "Y170-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y171",
    "nombre_dx": "Y171-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: INSTITUCION R",
    "sexo": "A"
  },
  {
    "cod_dx": "Y172",
    "nombre_dx": "Y172-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: ESCUELAS, OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y173",
    "nombre_dx": "Y173-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: AREAS DE DEPO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y174",
    "nombre_dx": "Y174-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: CALLES Y CARR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y175",
    "nombre_dx": "Y175-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: COMERCIO Y AR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y176",
    "nombre_dx": "Y176-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: AREA INDUSTRI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y177",
    "nombre_dx": "Y177-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y178",
    "nombre_dx": "Y178-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: OTRO LUGAR ES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y179",
    "nombre_dx": "Y179-ENVENENAMIENTO POR, Y EXPOSICION A OTROS GASES Y VAPORES, DE INTENCION NO DETERMINADA: LUGAR NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y180",
    "nombre_dx": "Y180-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y181",
    "nombre_dx": "Y181-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y182",
    "nombre_dx": "Y182-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: ESCUELAS OTRAS INSTITUC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y183",
    "nombre_dx": "Y183-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y184",
    "nombre_dx": "Y184-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y185",
    "nombre_dx": "Y185-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERV",
    "sexo": "A"
  },
  {
    "cod_dx": "Y186",
    "nombre_dx": "Y186-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y187",
    "nombre_dx": "Y187-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y188",
    "nombre_dx": "Y188-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y189",
    "nombre_dx": "Y189-ENVENENAMIENTO POR, Y EXPOSICION A PLAGUICIDAS, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y190",
    "nombre_dx": "Y190-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y191",
    "nombre_dx": "Y191-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y192",
    "nombre_dx": "Y192-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y193",
    "nombre_dx": "Y193-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y194",
    "nombre_dx": "Y194-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y195",
    "nombre_dx": "Y195-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y196",
    "nombre_dx": "Y196-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y197",
    "nombre_dx": "Y197-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y198",
    "nombre_dx": "Y198-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y199",
    "nombre_dx": "Y199-ENVENENAMIENTO POR, Y EXPOSICION A OTROS PRODUCTOS QUIMICOS Y SUSTANCIAS NOCIVAS, Y LOS NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y200",
    "nombre_dx": "Y200-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y201",
    "nombre_dx": "Y201-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y202",
    "nombre_dx": "Y202-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: ESCUELAS OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y203",
    "nombre_dx": "Y203-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y204",
    "nombre_dx": "Y204-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y205",
    "nombre_dx": "Y205-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y206",
    "nombre_dx": "Y206-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y207",
    "nombre_dx": "Y207-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y208",
    "nombre_dx": "Y208-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y209",
    "nombre_dx": "Y209-AHORCAMIENTO, ESTRANGULAMIENTO Y SOFOCACION, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y210",
    "nombre_dx": "Y210-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y211",
    "nombre_dx": "Y211-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y212",
    "nombre_dx": "Y212-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: ESCUELAS OTRAS INSTITUCIONES Y AREAS ADMINISTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y213",
    "nombre_dx": "Y213-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y214",
    "nombre_dx": "Y214-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y215",
    "nombre_dx": "Y215-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y216",
    "nombre_dx": "Y216-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y217",
    "nombre_dx": "Y217-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y218",
    "nombre_dx": "Y218-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y219",
    "nombre_dx": "Y219-AHOGAMIENTO Y SUMERSION, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y220",
    "nombre_dx": "Y220-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y221",
    "nombre_dx": "Y221-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y222",
    "nombre_dx": "Y222-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y223",
    "nombre_dx": "Y223-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y224",
    "nombre_dx": "Y224-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y225",
    "nombre_dx": "Y225-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y226",
    "nombre_dx": "Y226-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y227",
    "nombre_dx": "Y227-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y228",
    "nombre_dx": "Y228-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y229",
    "nombre_dx": "Y229-DISPARO DE ARMA CORTA, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y230",
    "nombre_dx": "Y230-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y231",
    "nombre_dx": "Y231-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y232",
    "nombre_dx": "Y232-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y233",
    "nombre_dx": "Y233-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y234",
    "nombre_dx": "Y234-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y235",
    "nombre_dx": "Y235-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y236",
    "nombre_dx": "Y236-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y237",
    "nombre_dx": "Y237-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y238",
    "nombre_dx": "Y238-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y239",
    "nombre_dx": "Y239-DISPARO DE RIFLE, ESCOPETA Y ARMA LARGA, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y240",
    "nombre_dx": "Y240-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y241",
    "nombre_dx": "Y241-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: INSTITUCION RE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y242",
    "nombre_dx": "Y242-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: ESCUELAS, OTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y243",
    "nombre_dx": "Y243-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: AREAS DE DEPOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y244",
    "nombre_dx": "Y244-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: CALLES Y CARRE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y245",
    "nombre_dx": "Y245-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: COMERCIO Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y246",
    "nombre_dx": "Y246-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: AREA INDUSTRIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y247",
    "nombre_dx": "Y247-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y248",
    "nombre_dx": "Y248-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: OTRO LUGAR ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "Y249",
    "nombre_dx": "Y249-DISPARO DE OTRAS ARMAS DE FUEGO, Y LAS NO ESPECIFICADAS, DE INTENCION NO DETERMINADA: LUGAR NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y250",
    "nombre_dx": "Y250-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y251",
    "nombre_dx": "Y251-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y252",
    "nombre_dx": "Y252-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: ESCUELAS OTRAS INSTITUCIONE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y253",
    "nombre_dx": "Y253-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "Y254",
    "nombre_dx": "Y254-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y255",
    "nombre_dx": "Y255-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y256",
    "nombre_dx": "Y256-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "Y257",
    "nombre_dx": "Y257-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y258",
    "nombre_dx": "Y258-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y259",
    "nombre_dx": "Y259-CONTACTO TRAUMATICO CON MATERIAL EXPLOSIVO, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y260",
    "nombre_dx": "Y260-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y261",
    "nombre_dx": "Y261-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y262",
    "nombre_dx": "Y262-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y263",
    "nombre_dx": "Y263-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y264",
    "nombre_dx": "Y264-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y265",
    "nombre_dx": "Y265-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y266",
    "nombre_dx": "Y266-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y267",
    "nombre_dx": "Y267-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y268",
    "nombre_dx": "Y268-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y269",
    "nombre_dx": "Y269-EXPOSICION AL HUMO, FUEGO Y LLAMAS, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y270",
    "nombre_dx": "Y270-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y271",
    "nombre_dx": "Y271-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: INSTITUCION RE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y272",
    "nombre_dx": "Y272-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: ESCUELAS, OTRA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y273",
    "nombre_dx": "Y273-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: AREAS DE DEPOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y274",
    "nombre_dx": "Y274-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: CALLES Y CARRE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y275",
    "nombre_dx": "Y275-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: COMERCIO Y ARE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y276",
    "nombre_dx": "Y276-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: AREA INDUSTRIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y277",
    "nombre_dx": "Y277-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y278",
    "nombre_dx": "Y278-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: OTRO LUGAR ESP",
    "sexo": "A"
  },
  {
    "cod_dx": "Y279",
    "nombre_dx": "Y279-CONTACTO CON VAPOR DE AGUA, VAPORES Y OBJETOS CALIENTES, DE INTENCION NO DETERMINADA: LUGAR NO ESPEC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y280",
    "nombre_dx": "Y280-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y281",
    "nombre_dx": "Y281-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y282",
    "nombre_dx": "Y282-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y283",
    "nombre_dx": "Y283-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y284",
    "nombre_dx": "Y284-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y285",
    "nombre_dx": "Y285-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y286",
    "nombre_dx": "Y286-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y287",
    "nombre_dx": "Y287-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y288",
    "nombre_dx": "Y288-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y289",
    "nombre_dx": "Y289-CONTACTO TRAUMATICO CON OBJETO CORTANTE, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y290",
    "nombre_dx": "Y290-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y291",
    "nombre_dx": "Y291-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y292",
    "nombre_dx": "Y292-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITU",
    "sexo": "A"
  },
  {
    "cod_dx": "Y293",
    "nombre_dx": "Y293-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y294",
    "nombre_dx": "Y294-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y295",
    "nombre_dx": "Y295-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERV",
    "sexo": "A"
  },
  {
    "cod_dx": "Y296",
    "nombre_dx": "Y296-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y297",
    "nombre_dx": "Y297-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y298",
    "nombre_dx": "Y298-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y299",
    "nombre_dx": "Y299-CONTACTO TRAUMATICO CON OBJETO ROMO O SIN FILO, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y300",
    "nombre_dx": "Y300-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y301",
    "nombre_dx": "Y301-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y302",
    "nombre_dx": "Y302-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y303",
    "nombre_dx": "Y303-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISM",
    "sexo": "A"
  },
  {
    "cod_dx": "Y304",
    "nombre_dx": "Y304-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y305",
    "nombre_dx": "Y305-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y306",
    "nombre_dx": "Y306-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CON",
    "sexo": "A"
  },
  {
    "cod_dx": "Y307",
    "nombre_dx": "Y307-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y308",
    "nombre_dx": "Y308-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y309",
    "nombre_dx": "Y309-CAIDA, SALTO O EMPUJON DESDE LUGAR ELEVADO, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y310",
    "nombre_dx": "Y310-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: VIVI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y311",
    "nombre_dx": "Y311-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: INST",
    "sexo": "A"
  },
  {
    "cod_dx": "Y312",
    "nombre_dx": "Y312-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: ESCU",
    "sexo": "A"
  },
  {
    "cod_dx": "Y313",
    "nombre_dx": "Y313-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: AREA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y314",
    "nombre_dx": "Y314-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: CALL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y315",
    "nombre_dx": "Y315-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: COME",
    "sexo": "A"
  },
  {
    "cod_dx": "Y316",
    "nombre_dx": "Y316-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: AREA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y317",
    "nombre_dx": "Y317-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: GRAN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y318",
    "nombre_dx": "Y318-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: OTRO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y319",
    "nombre_dx": "Y319-CAIDA, PERMANENCIA O CARRERA DELANTE O HACIA OBJETO EN MOVIMIENTO, DE INTENCION NO DETERMINADA: LUGA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y320",
    "nombre_dx": "Y320-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y321",
    "nombre_dx": "Y321-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y322",
    "nombre_dx": "Y322-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS AD",
    "sexo": "A"
  },
  {
    "cod_dx": "Y323",
    "nombre_dx": "Y323-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y324",
    "nombre_dx": "Y324-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y325",
    "nombre_dx": "Y325-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y326",
    "nombre_dx": "Y326-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y327",
    "nombre_dx": "Y327-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y328",
    "nombre_dx": "Y328-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y329",
    "nombre_dx": "Y329-COLISION DE VEHICULO DE MOTOR, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y330",
    "nombre_dx": "Y330-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: VIVIENDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y331",
    "nombre_dx": "Y331-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y332",
    "nombre_dx": "Y332-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y333",
    "nombre_dx": "Y333-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y334",
    "nombre_dx": "Y334-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y335",
    "nombre_dx": "Y335-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y336",
    "nombre_dx": "Y336-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y337",
    "nombre_dx": "Y337-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: GRANJA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y338",
    "nombre_dx": "Y338-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y339",
    "nombre_dx": "Y339-OTROS EVENTOS ESPECIFICADOS, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y340",
    "nombre_dx": "Y340-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y341",
    "nombre_dx": "Y341-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: INSTITUCION RESIDENCIAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y342",
    "nombre_dx": "Y342-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: ESCUELAS, OTRAS INSTITUCIONES Y AREAS ADMINISTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y343",
    "nombre_dx": "Y343-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: AREAS DE DEPORTE Y ATLETISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y344",
    "nombre_dx": "Y344-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: CALLES Y CARRETERAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y345",
    "nombre_dx": "Y345-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: COMERCIO Y AREA DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y346",
    "nombre_dx": "Y346-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: AREA INDUSTRIAL Y DE LA CONSTRUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y347",
    "nombre_dx": "Y347-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: GRANJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y348",
    "nombre_dx": "Y348-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: OTRO LUGAR ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y349",
    "nombre_dx": "Y349-EVENTO NO ESPECIFICADO, DE INTENCION NO DETERMINADA: LUGAR NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y350",
    "nombre_dx": "Y350-INTERVENCION LEGAL CON DISPARO DE ARMA DE FUEGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y351",
    "nombre_dx": "Y351-INTERVENCION LEGAL CON EXPLOSIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y352",
    "nombre_dx": "Y352-INTERVENCION LEGAL CON GAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y353",
    "nombre_dx": "Y353-INTERVENCION LEGAL CON OBJETOS ROMOS O SIN FILO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y354",
    "nombre_dx": "Y354-INTERVENCION LEGAL CON OBJETOS CORTANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y355",
    "nombre_dx": "Y355-EJECUCION LEGAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y356",
    "nombre_dx": "Y356-INTERVENCION LEGAL CON OTROS MEDIOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y357",
    "nombre_dx": "Y357-INTERVENCION LEGAL, MEDIOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y360",
    "nombre_dx": "Y360-OPERACIONES DE GUERRA CON EXPLOSION DE ARMAMENTO NAVAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y361",
    "nombre_dx": "Y361-OPERACIONES DE GUERRA CON DESTRUCCION DE AERONAVE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y362",
    "nombre_dx": "Y362-OPERACIONES DE GUERRA CON OTRAS EXPLOSIONES Y ESQUIRLAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y363",
    "nombre_dx": "Y363-OPERACIONES DE GUERRA CON FUEGO Y SUSTANCIAS INCENDIARIAS Y CALIENTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y364",
    "nombre_dx": "Y364-OPERACIONES DE GUERRA CON DISPARO DE ARMA DE FUEGO Y OTRAS FORMAS DE GUERRA CONVENCIONAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y365",
    "nombre_dx": "Y365-OPERACIONES DE GUERRA CON ARMAS NUCLEARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y366",
    "nombre_dx": "Y366-OPERACIONES DE GUERRA CON ARMAS BIOLOGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y367",
    "nombre_dx": "Y367-OPERACIONES DE GUERRA CON ARMAS QUIMICAS Y OTRAS FORMAS DE GUERRA NO CONVENCIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y368",
    "nombre_dx": "Y368-OPERACIONES DE GUERRA QUE OCURREN DESPUES DEL CESE DE HOSTILIDADES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y369",
    "nombre_dx": "Y369-OPERACION DE GUERRA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y400",
    "nombre_dx": "Y400-EFECTOS ADVERSOS DE PENICILINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y401",
    "nombre_dx": "Y401-EFECTOS ADVERSOS DE CEFALOSPORINAS Y OTROS ANTIBIOTICOS BETALACTAMICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y402",
    "nombre_dx": "Y402-EFECTOS ADVERSOS DEL GRUPO DE CLORAMFENICOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y403",
    "nombre_dx": "Y403-EFECTOS ADVERSOS DE LOS MACROLIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y404",
    "nombre_dx": "Y404-EFECTOS ADVERSOS DE TETRACICLINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y405",
    "nombre_dx": "Y405-EFECTOS ADVERSOS DE AMINOGLICOSIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y406",
    "nombre_dx": "Y406-EFECTOS ADVERSOS DE RIFAMICINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y407",
    "nombre_dx": "Y407-EFECTOS ADVERSOS DE ANTIBIOTICOS ANTIMICOTICOS USADOS SISTEMATICAMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y408",
    "nombre_dx": "Y408-EFECTOS ADVERSOS DE OTROS ANTIBIOTICOS SISTEMICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y409",
    "nombre_dx": "Y409-EFECTOS ADVERSOS DE ANTIBIOTICO SISTEMICO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y410",
    "nombre_dx": "Y410-EFECTOS ADVERSOS DE SULFONAMIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y411",
    "nombre_dx": "Y411-EFECTOS ADVERSOS DE DROGAS ANTIMICOBACTERIANAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y412",
    "nombre_dx": "Y412-EFECTOS ADVERSOS DE DROGAS ANTIPALUDICAS Y AGENTES QUE ACTUAN SOBRE OTROS PROTOZOARIOS DE LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y413",
    "nombre_dx": "Y413-EFECTOS ADVERSOS DE OTRAS DROGAS ANTIPROTOZOARIAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y414",
    "nombre_dx": "Y414-EFECTOS ADVERSOS DE ANTIHELMINTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y415",
    "nombre_dx": "Y415-EFECTOS ADVERSOS DE DROGAS ANTIVIRALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y418",
    "nombre_dx": "Y418-EFECTOS ADVERSOS DE OTROS ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y419",
    "nombre_dx": "Y419-EFECTOS ADVERSOS DE ANTIINFECCIOSOS Y ANTIPARASITARIOS SISTEMICOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y420",
    "nombre_dx": "Y420-EFECTOS ADVERSOS DE GLUCOCORTICOIDES Y ANALOGOS SINTETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y421",
    "nombre_dx": "Y421-EFECTOS ADVERSOS DE HORMONAS TIROIDEAS Y SUSTITUTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y422",
    "nombre_dx": "Y422-EFECTOS ADVERSOS DE DROGAS ANTITIROIDEAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y423",
    "nombre_dx": "Y423-EFECTOS ADVERSOS DE DROGAS HIPOGLUCEMIANTES ORALES E INSULINA [ANTIDIABETICAS]",
    "sexo": "A"
  },
  {
    "cod_dx": "Y424",
    "nombre_dx": "Y424-EFECTOS ADVERSOS DE ANTICONCEPTIVOS ORALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y425",
    "nombre_dx": "Y425-EFECTOS ADVERSOS DE OTROS ESTROGENOS Y PROGESTAGENOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y426",
    "nombre_dx": "Y426-EFECTOS ADVERSOS DE ANTIGONADOTROPINAS, ANTIESTROGENOS Y ANTIANDROGENOS, NO CLASIFICADOS EN OTRA PAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y427",
    "nombre_dx": "Y427-EFECTOS ADVERSOS DE ANDROGENOS Y CONGENERES ANABOLICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y428",
    "nombre_dx": "Y428-EFECTOS ADVERSOS DE OTRAS HORMONAS Y SUS SUSTITUTOS SINTETICOS, Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y429",
    "nombre_dx": "Y429-EFECTOS ADVERSOS DE OTRAS HORMONAS ANTAGONISTAS, Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y430",
    "nombre_dx": "Y430-EFECTOS ADVERSOS DE ANTIALERGICOS Y ANTIEMETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y431",
    "nombre_dx": "Y431-EFECTOS ADVERSOS DE ANTIMETABOLITOS ANTINEOPLASICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y432",
    "nombre_dx": "Y432-EFECTOS ADVERSOS DE PRODUCTOS NATURALES ANTINEOPLASICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y433",
    "nombre_dx": "Y433-EFECTOS ADVERSOS DE OTRAS DROGAS ANTINEOPLASICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y434",
    "nombre_dx": "Y434-EFECTOS ADVERSOS DE AGENTES INMUNOSUPRESORES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y435",
    "nombre_dx": "Y435-EFECTOS ADVERSOS DE AGENTES ACIDIFICANTES Y ALCALINIZANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y436",
    "nombre_dx": "Y436-EFECTOS ADVERSOS DE ENZIMAS NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y438",
    "nombre_dx": "Y438-EFECTOS ADVERSOS DE OTROS AGENTES SISTEMICOS PRIMARIOS NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y439",
    "nombre_dx": "Y439-EFECTOS ADVERSOS DE AGENTE SISTEMICO PRIMARIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y440",
    "nombre_dx": "Y440-EFECTOS ADVERSOS DE PREPARACIONES CON HIERRO Y OTROS PREPARADOS CONTRA LA ANEMIA HIPOCROMICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y441",
    "nombre_dx": "Y441-EFECTOS ADVERSOS DE VITAMINA B12, ACIDO FOLICO Y OTROS PREPARADOS CONTRA LA ANEMIA MEGALOBLASTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y442",
    "nombre_dx": "Y442-EFECTOS ADVERSOS DE ANTICOAGULANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y443",
    "nombre_dx": "Y443-EFECTOS ADVERSOS DE ANTAGONISTAS DE ANTICOAGULANTES, VITAMINA K Y OTROS COAGULANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y444",
    "nombre_dx": "Y444-EFECTOS ADVERSOS DE DROGAS ANTITROMBOTICAS [INHIBIDORAS DE LA AGREGACION PLAQUETARIA] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y445",
    "nombre_dx": "Y445-EFECTOS ADVERSOS DE DROGAS TROMBOLITICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y446",
    "nombre_dx": "Y446-EFECTOS ADVERSOS DE SANGRE NATURAL Y PRODUCTOS SANGUINEOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y447",
    "nombre_dx": "Y447-EFECTOS ADVERSOS DE LOS SUSTITUTOS DEL PLASMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y449",
    "nombre_dx": "Y449-EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN LOS CONSTITUYENTES DE LA SANGRE, Y LOS NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y450",
    "nombre_dx": "Y450-EFECTOS ADVERSOS DE OPIACEOS Y ANALGESICOS RELACIONADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y451",
    "nombre_dx": "Y451-EFECTOS ADVERSOS DE SALICILATOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y452",
    "nombre_dx": "Y452-EFECTOS ADVERSOS DE DERIVADOS DEL ACIDO PROPIONICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y453",
    "nombre_dx": "Y453-EFECTOS ADVERSOS DE OTRAS DROGAS ANTIINFLAMATORIAS NO ESTEROIDES [DAINE]",
    "sexo": "A"
  },
  {
    "cod_dx": "Y454",
    "nombre_dx": "Y454-EFECTOS ADVERSOS DE LOS ANTIRREUMATICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y455",
    "nombre_dx": "Y455-EFECTOS ADVERSOS DE LOS DERIVADOS DEL 4-AMINOFENOL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y458",
    "nombre_dx": "Y458-EFECTOS ADVERSOS DE OTROS ANALGESICOS Y ANTIPIRETICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y459",
    "nombre_dx": "Y459-EFECTOS ADVERSOS DE DROGAS ANALGESICAS, ANTIPIRETICAS Y ANTIINFLAMATORIAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y460",
    "nombre_dx": "Y460-EFECTOS ADVERSOS DE SUCCINAMIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y461",
    "nombre_dx": "Y461-EFECTOS ADVERSOS DE OXAZOLIDINADIONAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y462",
    "nombre_dx": "Y462-EFECTOS ADVERSOS DE DERIVADOS DE LA HIDANTOINA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y463",
    "nombre_dx": "Y463-EFECTOS ADVERSOS DE DESOXIBARBITURICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y464",
    "nombre_dx": "Y464-EFECTOS ADVERSOS DE IMINOESTILBENOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y465",
    "nombre_dx": "Y465-EFECTOS ADVERSOS DEL ACIDO VALPROICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y466",
    "nombre_dx": "Y466-EFECTOS ADVERSOS DE OTROS ANTIEPILEPTICOS, Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y467",
    "nombre_dx": "Y467-EFECTOS ADVERSOS DE DROGAS ANTIPARKINSONIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y468",
    "nombre_dx": "Y468-EFECTOS ADVERSOS DE DROGAS ANTIESPASTICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y470",
    "nombre_dx": "Y470-EFECTOS ADVERSOS DE BARBITURICOS, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y471",
    "nombre_dx": "Y471-EFECTOS ADVERSOS DE BENZODIAZEPINAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y472",
    "nombre_dx": "Y472-EFECTOS ADVERSOS DE DERIVADOS CLORALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y473",
    "nombre_dx": "Y473-EFECTOS ADVERSOS DE PARALDEHIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y474",
    "nombre_dx": "Y474-EFECTOS ADVERSOS DE COMPUESTOS DE BROMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y475",
    "nombre_dx": "Y475-EFECTOS ADVERSOS DE MEZCLAS SEDANTES E HIPNOTICAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y478",
    "nombre_dx": "Y478-EFECTOS ADVERSOS DE OTRAS DROGAS SEDANTES, HIPNOTICAS Y ANSIOLITICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y479",
    "nombre_dx": "Y479-EFECTOS ADVERSOS DE DROGAS SEDANTES, HIPNOTICAS Y ANSIOLITICAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y480",
    "nombre_dx": "Y480-EFECTOS ADVERSOS DE GASES ANESTESICOS POR INHALACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y481",
    "nombre_dx": "Y481-EFECTOS ADVERSOS DE GASES ANESTESICOS PARENTERALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y482",
    "nombre_dx": "Y482-EFECTOS ADVERSOS DE OTROS GASES ANESTESICOS GENERALES, Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y483",
    "nombre_dx": "Y483-EFECTOS ADVERSOS DE GASES ANESTESICOS LOCALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y484",
    "nombre_dx": "Y484-EFECTOS ADVERSOS DE ANESTESICOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y485",
    "nombre_dx": "Y485-EFECTOS ADVERSOS DE GASES TERAPEUTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y490",
    "nombre_dx": "Y490-EFECTOS ADVERSOS DE ANTIDEPRESIVOS TRICICLICOS Y TETRACICLICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y491",
    "nombre_dx": "Y491-EFECTOS ADVERSOS DE ANTIDEPRESIVOS INHIBIDORES DE LA MONOAMINOOXIDASA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y492",
    "nombre_dx": "Y492-EFECTOS ADVERSOS DE OTROS ANTIDEPRESIVOS Y LOS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y493",
    "nombre_dx": "Y493-EFECTOS ADVERSOS DE ANTIPSICOTICOS Y NEUROLEPTICOS FENOTIAZINICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y494",
    "nombre_dx": "Y494-EFECTOS ADVERSOS DE NEUROLEPTICOS DE LA BUTIROFENONA Y TIOXANTINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y495",
    "nombre_dx": "Y495-EFECTOS ADVERSOS DE OTROS ANTIPSICOTICOS Y NEUROLEPTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y496",
    "nombre_dx": "Y496-EFECTOS ADVERSOS DE PSICODISLEPTICOS [ALUCINOGENOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y497",
    "nombre_dx": "Y497-EFECTOS ADVERSOS DE PSICOESTIMULANTES CON ABUSO POTENCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y498",
    "nombre_dx": "Y498-EFECTOS ADVERSOS DE OTRAS DROGAS PSICOTROPICAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y499",
    "nombre_dx": "Y499-EFECTOS ADVERSOS DE DROGAS PSICOTROPICAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y500",
    "nombre_dx": "Y500-EFECTOS ADVERSOS DE ANALEPTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y501",
    "nombre_dx": "Y501-EFECTOS ADVERSOS DE ANTAGONISTAS DE OPIACEOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y502",
    "nombre_dx": "Y502-EFECTOS ADVERSOS DE METILXANTINAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y508",
    "nombre_dx": "Y508-EFECTOS ADVERSOS DE OTROS ESTIMULANTES DEL SISTEMA NERVIOSO CENTRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y509",
    "nombre_dx": "Y509-EFECTOS ADVERSOS DE ESTIMULANTE NO ESPECIFICADO DEL SISTEMA NERVIOSO CENTRAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y510",
    "nombre_dx": "Y510-EFECTOS ADVERSOS DE AGENTES ANTICOLINESTERASA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y511",
    "nombre_dx": "Y511-EFECTOS ADVERSOS DE OTROS PARASIMPATICOMIMETICOS [COLINERGICOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y512",
    "nombre_dx": "Y512-EFECTOS ADVERSOS DE DROGAS BLOQUEADORAS GANGLIONARES, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y513",
    "nombre_dx": "Y513-EFECTOS ADVERSOS DE OTROS PARASIMPATICOLITICOS [ANTICOLINERGICOS Y ANTIMUSCARINICOS] Y ESPASMOLITICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y514",
    "nombre_dx": "Y514-EFECTOS ADVERSOS DE AGONISTAS [ESTIMULANTES] PREDOMINANTEMENTE ALFA-ADRENERGICOS, NO CLASIFICADOS EN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y515",
    "nombre_dx": "Y515-EFECTOS ADVERSOS DE AGONISTAS [ESTIMULANTES] PREDOMINANTEMENTE BETA-ADRENERGICOS, NO CLASIFICADOS EN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y516",
    "nombre_dx": "Y516-EFECTOS ADVERSOS DE ANTAGONISTAS [BLOQUEADORES] ALFA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y517",
    "nombre_dx": "Y517-EFECTOS ADVERSOS DE ANTAGONISTAS [BLOQUEADORES] BETA-ADRENERGICOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y518",
    "nombre_dx": "Y518-EFECTOS ADVERSOS DE AGENTES BLOQUEADORES NEURO-ADRENERGICOS QUE ACTUAN CENTRALMENTE, NO CLASIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y519",
    "nombre_dx": "Y519-EFECTOS ADVERSOS DE OTRAS DROGAS QUE AFECTAN PRIMARIAMENTE EL SISTEMA NERVIOSO AUTONOMO, Y LAS NO ES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y520",
    "nombre_dx": "Y520-EFECTOS ADVERSOS DE GLUCOSIDOS CARDIOTONICOS Y DROGAS DE ACCION SIMILAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y521",
    "nombre_dx": "Y521-EFECTOS ADVERSOS DE BLOQUEADORES DEL CANAL DEL CALCIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y522",
    "nombre_dx": "Y522-EFECTOS ADVERSOS DE OTRAS DROGAS ANTIARRITMICAS, NO CLASIFICADAS EN OTRAS PARTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y523",
    "nombre_dx": "Y523-EFECTOS ADVERSOS DE VASODILATADORES CORONARIOS, NO CLASIFICADOS EN OTRAS PARTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y524",
    "nombre_dx": "Y524-EFECTOS ADVERSOS DE INHIBIDORES DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y525",
    "nombre_dx": "Y525-EFECTOS ADVERSOS DE OTRAS DROGAS ANTIHIPERTENSIVAS, NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y526",
    "nombre_dx": "Y526-EFECTOS ADVERSOS DE DROGAS ANTIHIPERLIPIDEMICAS Y ANTIARTERIOSCLEROTICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y527",
    "nombre_dx": "Y527-EFECTOS ADVERSOS DE VASODILATADORES PERIFERICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y528",
    "nombre_dx": "Y528-EFECTOS ADVERSOS DE DROGAS ANTIVARICOSAS, INCLUSIVE AGENTES ESCLEROSANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y529",
    "nombre_dx": "Y529-EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA CARDIOVASCULAR, Y LOS NO ESPE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y530",
    "nombre_dx": "Y530-EFECTOS ADVERSOS DE BLOQUEADORES DE LOS RECEPTORES H2 DE HISTAMINA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y531",
    "nombre_dx": "Y531-EFECTOS ADVERSOS DE OTRAS DROGAS ANTIACIDAS E INHIBIDORAS DE LA SECRECION GASTRICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y532",
    "nombre_dx": "Y532-EFECTOS ADVERSOS DE LAXANTES ESTIMULANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y533",
    "nombre_dx": "Y533-EFECTOS ADVERSOS DE LAXANTES SALINOS Y OSMOTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y534",
    "nombre_dx": "Y534-EFECTOS ADVERSOS DE OTROS LAXANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y535",
    "nombre_dx": "Y535-EFECTOS ADVERSOS DE DIGESTIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y536",
    "nombre_dx": "Y536-EFECTOS ADVERSOS DE DROGAS ANTIDIARREICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y537",
    "nombre_dx": "Y537-EFECTOS ADVERSOS DE EMETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y538",
    "nombre_dx": "Y538-EFECTOS ADVERSOS DE OTROS AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA GASTROINTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y539",
    "nombre_dx": "Y539-EFECTOS ADVERSOS DE AGENTES QUE AFECTAN PRIMARIAMENTE EL SISTEMA GASTROINTESTINAL, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y540",
    "nombre_dx": "Y540-EFECTOS ADVERSOS DE MINERALOCORTICOIDES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y541",
    "nombre_dx": "Y541-EFECTOS ADVERSOS DE LOS BLOQUEADORES DE MINERALOCORTICOIDES [ANTAGONISTAS DE LA ALDOSTERONA]",
    "sexo": "A"
  },
  {
    "cod_dx": "Y542",
    "nombre_dx": "Y542-EFECTOS ADVERSOS DE LOS INHIBIDORES DE LA ANHIDRASA CARBONICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y543",
    "nombre_dx": "Y543-EFECTOS ADVERSOS DE LOS DERIVADOS DE LA BENZOTIADIAZINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y544",
    "nombre_dx": "Y544-EFECTOS ADVERSOS DE DIURETICOS DE ASA [HIGH-CEILING]\"\"",
    "sexo": "A"
  },
  {
    "cod_dx": "Y545",
    "nombre_dx": "Y545-EFECTOS ADVERSOS DE OTROS DIURETICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y546",
    "nombre_dx": "Y546-EFECTOS ADVERSOS DE AGENTES ELECTROLITICOS, CALORICOS Y DEL EQUILIBRIO HIDRICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y547",
    "nombre_dx": "Y547-EFECTOS ADVERSOS DE AGENTES QUE AFECTAN LA CALCIFICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y548",
    "nombre_dx": "Y548-EFECTOS ADVERSOS DE AGENTES QUE AFECTAN EL METABOLISMO DEL ACIDO URICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y549",
    "nombre_dx": "Y549-EFECTOS ADVERSOS DE SALES MINERALES NO CLASIFICADAS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y550",
    "nombre_dx": "Y550-EFECTOS ADVERSOS DE DROGAS OXITOCICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y551",
    "nombre_dx": "Y551-EFECTOS ADVERSOS DE RELAJANTES DE LOS MUSCULOS ESTRIADOS [AGENTES BLOQUEADORES NEUROMUSCULARES] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y552",
    "nombre_dx": "Y552-EFECTOS ADVERSOS DE OTROS AGENTES QUE ACTUAN PRIMARIAMENTE SOBRE LOS MUSCULOS, Y LOS NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y553",
    "nombre_dx": "Y553-EFECTOS ADVERSOS DE ANTITUSIGENOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y554",
    "nombre_dx": "Y554-EFECTOS ADVERSOS DE EXPECTORANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y555",
    "nombre_dx": "Y555-EFECTOS ADVERSOS DE DROGAS CONTRA EL RESFRIADO COMUN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y556",
    "nombre_dx": "Y556-EFECTOS ADVERSOS DE ANTIASMATICOS, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y557",
    "nombre_dx": "Y557-EFECTOS ADVERSOS DE OTROS AGENTES QUE ACTUAN PRIMARIAMENTE SOBRE EL SISTEMA RESPIRATORIO, Y LOS NO E",
    "sexo": "A"
  },
  {
    "cod_dx": "Y560",
    "nombre_dx": "Y560-EFECTOS ADVERSOS DE DROGAS ANTIMICOTICAS, ANTIINFECCIOSAS Y ANTIINFLAMATORIAS DE USO LOCAL, NO CLASI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y561",
    "nombre_dx": "Y561-EFECTOS ADVERSOS DE ANTIPRURIGINOSOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y562",
    "nombre_dx": "Y562-EFECTOS ADVERSOS DE ASTRINGENTES Y DETERGENTES LOCALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y563",
    "nombre_dx": "Y563-EFECTOS ADVERSOS DE EMOLIENTES, DEMULCENTES Y PROTECTORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y564",
    "nombre_dx": "Y564-EFECTOS ADVERSOS DE DROGAS Y PREPARADOS QUERATOLITICOS, QUERATOPLASTICOS Y OTROS PARA EL TRATAMIENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y565",
    "nombre_dx": "Y565-EFECTOS ADVERSOS DE DROGAS Y PREPARADOS OFTALMOLOGICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y566",
    "nombre_dx": "Y566-EFECTOS ADVERSOS DE DROGAS Y PREPARADOS OTORRINOLARINGOLOGICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y567",
    "nombre_dx": "Y567-EFECTOS ADVERSOS DE DROGAS DENTALES, DE APLICACIÓN TOPICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y568",
    "nombre_dx": "Y568-EFECTOS ADVERSOS DE OTROS AGENTES TOPICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y569",
    "nombre_dx": "Y569-EFECTOS ADVERSOS DE OTROS AGENTES TOPICOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y570",
    "nombre_dx": "Y570-EFECTOS ADVERSOS DE DEPRESORES DEL APETITO [ANOREXICOS] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y571",
    "nombre_dx": "Y571-EFECTOS ADVERSOS DE DROGAS LIPOTROPICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y572",
    "nombre_dx": "Y572-EFECTOS ADVERSOS DE ANTIDOTOS Y AGENTES QUELANTES, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y573",
    "nombre_dx": "Y573-EFECTOS ADVERSOS DE DISUASIVOS DEL ALCOHOL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y574",
    "nombre_dx": "Y574-EFECTOS ADVERSOS DE EXCIPIENTES FARMACEUTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y575",
    "nombre_dx": "Y575-EFECTOS ADVERSOS DE MEDIOS DE CONTRASTE PARA RAYOS X",
    "sexo": "A"
  },
  {
    "cod_dx": "Y576",
    "nombre_dx": "Y576-EFECTOS ADVERSOS DE OTROS AGENTES DIAGNOSTICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y577",
    "nombre_dx": "Y577-EFECTOS ADVERSOS DE VITAMINAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y578",
    "nombre_dx": "Y578-EFECTOS ADVERSOS DE OTRAS DROGAS Y MEDICAMENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y579",
    "nombre_dx": "Y579-EFECTOS ADVERSOS DE DROGAS Y MEDICAMENTOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y580",
    "nombre_dx": "Y580-EFECTOS ADVERSOS DE LA VACUNA BCG ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y581",
    "nombre_dx": "Y581-EFECTOS ADVERSOS DE LA VACUNA TIFOIDEA Y PARATIFOIDEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y582",
    "nombre_dx": "Y582-EFECTOS ADVERSOS DE LA VACUNA CONTRA EL COLERA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y583",
    "nombre_dx": "Y583-EFECTOS ADVERSOS DE LA VACUNA CONTRA LA PESTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y584",
    "nombre_dx": "Y584-EFECTOS ADVERSOS DE LA VACUNA CONTRA EL TETANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y585",
    "nombre_dx": "Y585-EFECTOS ADVERSOS DE LA VACUNA CONTRA LA DIFTERIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y586",
    "nombre_dx": "Y586-EFECTOS ADVERSOS DE LA VACUNA CONTRA LA TOS FERINA, INCLUSIVE COMBINACIONES CON UN COMPONENTE PERTUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y588",
    "nombre_dx": "Y588-EFECTOS ADVERSOS DE VACUNAS BACTERIANAS MIXTAS, EXCEPTO COMBINACIONES CON UN COMPONENTE PERTUSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y589",
    "nombre_dx": "Y589-EFECTOS ADVERSOS DE OTRAS VACUNAS BACTERIANAS, Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y590",
    "nombre_dx": "Y590-EFECTOS ADVERSOS DE VACUNAS VIRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y591",
    "nombre_dx": "Y591-EFECTOS ADVERSOS DE VACUNAS CONTRA RICKETTSIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y592",
    "nombre_dx": "Y592-EFECTOS ADVERSOS DE VACUNAS ANTIPROTOZOARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y593",
    "nombre_dx": "Y593-EFECTOS ADVERSOS DE LA INMUNOGLOBULINA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y598",
    "nombre_dx": "Y598-EFECTOS ADVERSOS DE OTRAS VACUNAS Y SUSTANCIAS BIOLOGICAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y599",
    "nombre_dx": "Y599-EFECTOS ADVERSOS DE OTRAS VACUNAS O SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y600",
    "nombre_dx": "Y600-INCIDENTE DURANTE OPERACIÓN QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y601",
    "nombre_dx": "Y601-INCIDENTE DURANTE INFUSION O TRANSFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y602",
    "nombre_dx": "Y602-INCIDENTE DURANTE DIALISIS RENAL U OTRA PERFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y603",
    "nombre_dx": "Y603-INCIDENTE DURANTE INYECCION O INMUNIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y604",
    "nombre_dx": "Y604-INCIDENTE DURANTE EXAMEN ENDOSCOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y605",
    "nombre_dx": "Y605-INCIDENTE DURANTE CATETERIZACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y606",
    "nombre_dx": "Y606-INCIDENTE DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y607",
    "nombre_dx": "Y607-INCIDENTE DURANTE ADMINISTRACION DE ENEMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y608",
    "nombre_dx": "Y608-INCIDENTE DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y609",
    "nombre_dx": "Y609-INCIDENTE DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y610",
    "nombre_dx": "Y610-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE OPERACIÓN QUIRURGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y611",
    "nombre_dx": "Y611-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE INFUSION O TRANSFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y612",
    "nombre_dx": "Y612-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE DIALISIS RENAL U OTRA PERFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y613",
    "nombre_dx": "Y613-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE INYECCION O INMUNIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y614",
    "nombre_dx": "Y614-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE EXAMEN ENDOSCOPICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y615",
    "nombre_dx": "Y615-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE CATETERIZACION CARDIACA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y616",
    "nombre_dx": "Y616-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y617",
    "nombre_dx": "Y617-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE REMOCION DE CATETER O TAPONAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y618",
    "nombre_dx": "Y618-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y619",
    "nombre_dx": "Y619-OBJETO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y620",
    "nombre_dx": "Y620-FALLAS EN LA ESTERILIZACION DURANTE OPERACIÓN QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y621",
    "nombre_dx": "Y621-FALLAS EN LA ESTERILIZACION DURANTE INFUSION O TRANSFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y622",
    "nombre_dx": "Y622-FALLAS EN LA ESTERILIZACION DURANTE DIALISIS RENAL U OTRA PERFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y623",
    "nombre_dx": "Y623-FALLAS EN LA ESTERILIZACION DURANTE INYECCION O INMUNIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y624",
    "nombre_dx": "Y624-FALLAS EN LA ESTERILIZACION DURANTE EXAMEN ENDOSCOPICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y625",
    "nombre_dx": "Y625-FALLAS EN LA ESTERILIZACION DURANTE CATETERIZACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y626",
    "nombre_dx": "Y626-FALLAS EN LA ESTERILIZACION DURANTE ASPIRACION, PUNCION Y OTRA CATETERIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y628",
    "nombre_dx": "Y628-FALLAS EN LA ESTERILIZACION DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y629",
    "nombre_dx": "Y629-FALLAS EN LA ESTERILIZACION DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y630",
    "nombre_dx": "Y630-EXCESIVA CANTIDAD DE SANGRE U OTRO LIQUIDO ADMINISTRADO DURANTE UNA INFUSION O TRANSFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y631",
    "nombre_dx": "Y631-DILUCION INCORRECTA DE LIQUIDO DURANTE UNA INFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y632",
    "nombre_dx": "Y632-SOBREDOSIS DE RADIACION ADMINISTRADA DURANTE TERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y633",
    "nombre_dx": "Y633-EXPOSICION INADVERTIDA DEL PACIENTE A RADIACION DURANTE LA ATENCION MEDICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y634",
    "nombre_dx": "Y634-FALLA EN LA DOSIFICACION EN ELECTROCHOQUE O EN CHOQUE INSULINICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y635",
    "nombre_dx": "Y635-FALLA EN EL CONTROL DE LA TEMPERATURA, EN TAPONAMIENTOS Y APLICACIONES LOCALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y636",
    "nombre_dx": "Y636-NO ADMINISTRACION DE DROGAS, MEDICAMENTOS O SUSTANCIAS BIOLOGICAS NECESARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y638",
    "nombre_dx": "Y638-FALLA EN LA DOSIFICACION DURANTE OTRAS ATENCIONES MEDICAS Y QUIRURGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y639",
    "nombre_dx": "Y639-FALLA EN LA DOSIFICACION DURANTE ATENCION MEDICA Y QUIRURGICA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y640",
    "nombre_dx": "Y640-MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO EN INFUSION O TRANSFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y641",
    "nombre_dx": "Y641-MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, INYECTADO O USADO PARA INMUNIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y648",
    "nombre_dx": "Y648-MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, ADMINISTRADO POR OTROS MEDIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y649",
    "nombre_dx": "Y649-MEDICAMENTO O SUSTANCIA BIOLOGICA CONTAMINADO, ADMINISTRADO PORMEDIOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y650",
    "nombre_dx": "Y650-SANGRE INCOMPATIBLE USADA EN TRANSFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Y651",
    "nombre_dx": "Y651-LIQUIDO ERRONEO USADO EN INFUSION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y652",
    "nombre_dx": "Y652-FALLA EN LA SUTURA O LIGADURA DURANTE OPERACIÓN QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y653",
    "nombre_dx": "Y653-TUBO ENDOTRAQUEAL COLOCADO ERRONEAMENTE DURANTE PROCEDIMIENTO ANESTESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y654",
    "nombre_dx": "Y654-FALLA EN LA INTRODUCCION O REMOCION DE OTRO TUBO O INSTRUMENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y655",
    "nombre_dx": "Y655-REALIZACION DE UNA OPERACIÓN INADECUADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y658",
    "nombre_dx": "Y658-OTROS INCIDENTES ESPECIFICADOS DURANTE LA ATENCION MEDICA Y QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y66X",
    "nombre_dx": "Y66X-NO ADMINISTRACION DE LA ATENCION MEDICA Y QUIRURGICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y69X",
    "nombre_dx": "Y69X-INCIDENTES NO ESPECIFICADOS DURANTE LA ATENCION MEDICA Y QUIRURGICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y700",
    "nombre_dx": "Y700-DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y701",
    "nombre_dx": "Y701-DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y702",
    "nombre_dx": "Y702-DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IM",
    "sexo": "A"
  },
  {
    "cod_dx": "Y703",
    "nombre_dx": "Y703-DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSIT",
    "sexo": "A"
  },
  {
    "cod_dx": "Y708",
    "nombre_dx": "Y708-DISPOSITIVOS DE ANESTESIOLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y710",
    "nombre_dx": "Y710-DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONIT",
    "sexo": "A"
  },
  {
    "cod_dx": "Y711",
    "nombre_dx": "Y711-DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRU",
    "sexo": "A"
  },
  {
    "cod_dx": "Y712",
    "nombre_dx": "Y712-DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMP",
    "sexo": "A"
  },
  {
    "cod_dx": "Y713",
    "nombre_dx": "Y713-DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y718",
    "nombre_dx": "Y718-DISPOSITIVOS CARDIOVASCULARES ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y720",
    "nombre_dx": "Y720-DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y",
    "sexo": "A"
  },
  {
    "cod_dx": "Y721",
    "nombre_dx": "Y721-DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y722",
    "nombre_dx": "Y722-DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y723",
    "nombre_dx": "Y723-DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y728",
    "nombre_dx": "Y728-DISPOSITIVOS OTORRINOLARINGOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y730",
    "nombre_dx": "Y730-DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAG",
    "sexo": "A"
  },
  {
    "cod_dx": "Y731",
    "nombre_dx": "Y731-DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEU",
    "sexo": "A"
  },
  {
    "cod_dx": "Y732",
    "nombre_dx": "Y732-DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y733",
    "nombre_dx": "Y733-DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURG",
    "sexo": "A"
  },
  {
    "cod_dx": "Y738",
    "nombre_dx": "Y738-DISPOSITIVOS DE GASTROENTEROLOGIA Y UROLOGIA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y740",
    "nombre_dx": "Y740-DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y741",
    "nombre_dx": "Y741-DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y742",
    "nombre_dx": "Y742-DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y743",
    "nombre_dx": "Y743-DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y748",
    "nombre_dx": "Y748-DISPOSITIVOS PARA USO HOSPITALARIO GENERAL Y PERSONAL ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y750",
    "nombre_dx": "Y750-DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y751",
    "nombre_dx": "Y751-DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRURGIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y752",
    "nombre_dx": "Y752-DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMPLANT",
    "sexo": "A"
  },
  {
    "cod_dx": "Y753",
    "nombre_dx": "Y753-DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y758",
    "nombre_dx": "Y758-DISPOSITIVOS NEUROLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y760",
    "nombre_dx": "Y760-DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOST",
    "sexo": "F"
  },
  {
    "cod_dx": "Y761",
    "nombre_dx": "Y761-DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICO",
    "sexo": "F"
  },
  {
    "cod_dx": "Y762",
    "nombre_dx": "Y762-DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS ",
    "sexo": "F"
  },
  {
    "cod_dx": "Y763",
    "nombre_dx": "Y763-DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS",
    "sexo": "F"
  },
  {
    "cod_dx": "Y768",
    "nombre_dx": "Y768-DISPOSITIVOS GINECOLOGICOS Y OBSTETRICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, N",
    "sexo": "F"
  },
  {
    "cod_dx": "Y770",
    "nombre_dx": "Y770-DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y771",
    "nombre_dx": "Y771-DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y772",
    "nombre_dx": "Y772-DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y773",
    "nombre_dx": "Y773-DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y778",
    "nombre_dx": "Y778-DISPOSITIVOS OFTALMICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN",
    "sexo": "A"
  },
  {
    "cod_dx": "Y780",
    "nombre_dx": "Y780-APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y781",
    "nombre_dx": "Y781-APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICOS) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y782",
    "nombre_dx": "Y782-APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMPLANTES, ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y783",
    "nombre_dx": "Y783-APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y MA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y788",
    "nombre_dx": "Y788-APARATOS RADIOLOGICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICADOS EN O",
    "sexo": "A"
  },
  {
    "cod_dx": "Y790",
    "nombre_dx": "Y790-DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONITOREO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y791",
    "nombre_dx": "Y791-DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRURGICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y792",
    "nombre_dx": "Y792-DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMPLANTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y793",
    "nombre_dx": "Y793-DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITIVOS Y",
    "sexo": "A"
  },
  {
    "cod_dx": "Y798",
    "nombre_dx": "Y798-DISPOSITIVOS ORTOPEDICOS ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICADOS E",
    "sexo": "A"
  },
  {
    "cod_dx": "Y800",
    "nombre_dx": "Y800-APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DE DIAGNOSTICO Y MONITOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y801",
    "nombre_dx": "Y801-APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTICOS (NO QUIRURG",
    "sexo": "A"
  },
  {
    "cod_dx": "Y802",
    "nombre_dx": "Y802-APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICOS Y OTROS IMPLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y803",
    "nombre_dx": "Y803-APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGICOS, DISPOSITIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y808",
    "nombre_dx": "Y808-APARATOS DE MEDICINA FISICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS, NO CLASIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y810",
    "nombre_dx": "Y810-DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS TERAPEUTI",
    "sexo": "A"
  },
  {
    "cod_dx": "Y811",
    "nombre_dx": "Y811-DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS,",
    "sexo": "A"
  },
  {
    "cod_dx": "Y812",
    "nombre_dx": "Y812-DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS PROTESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y813",
    "nombre_dx": "Y813-DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS QUIRURGIC",
    "sexo": "A"
  },
  {
    "cod_dx": "Y818",
    "nombre_dx": "Y818-DISPOSITIVOS DE CIRUGIA GENERAL Y PLASTICA ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS DIVERSOS,",
    "sexo": "A"
  },
  {
    "cod_dx": "Y820",
    "nombre_dx": "Y820-OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y821",
    "nombre_dx": "Y821-OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y822",
    "nombre_dx": "Y822-OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y823",
    "nombre_dx": "Y823-OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS: INSTRUMENTOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y828",
    "nombre_dx": "Y828-OTROS DISPOSITIVOS MEDICOS, Y LOS NO ESPECIFICADOS, ASOCIADOS CON INCIDENTES ADVERSOS: DISPOSITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y830",
    "nombre_dx": "Y830-OPERACIÓN QUIRURGICA CON TRASPLANTE DE UN ORGANO COMPLETO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y831",
    "nombre_dx": "Y831-OPERACIÓN QUIRURGICA CON IMPLANTE DE UN DISPOSITIVO ARTIFICIAL INTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y832",
    "nombre_dx": "Y832-OPERACIÓN QUIRURGICA CON ANASTOMOSIS, DERIVACION O INJERTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y833",
    "nombre_dx": "Y833-OPERACIÓN QUIRURGICA CON FORMACION DE ESTOMA EXTERNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y834",
    "nombre_dx": "Y834-OTRA CIRUGIA RECONSTRUCTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y835",
    "nombre_dx": "Y835-AMPUTACION DE MIEMBRO(S)",
    "sexo": "A"
  },
  {
    "cod_dx": "Y836",
    "nombre_dx": "Y836-REMOCION DE OTRO ORGANO (PARCIAL) (TOTAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y838",
    "nombre_dx": "Y838-OTROS PROCEDIMIENTOS QUIRURGICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y839",
    "nombre_dx": "Y839-PROCEDIMIENTO QUIRURGICO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y840",
    "nombre_dx": "Y840-CATETERIZACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y841",
    "nombre_dx": "Y841-DIALISIS RENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y842",
    "nombre_dx": "Y842-PROCEDIMIENTO RADIOLOGICO Y RADIOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y843",
    "nombre_dx": "Y843-TERAPIA POR CHOQUE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y844",
    "nombre_dx": "Y844-ASPIRACION DE LIQUIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y845",
    "nombre_dx": "Y845-INSERCION DE SONDA GASTRICA O DUODENAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y846",
    "nombre_dx": "Y846-CATETERIZACION URINARIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y847",
    "nombre_dx": "Y847-MUESTRA DE SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y848",
    "nombre_dx": "Y848-OTROS PROCEDIMIENTOS MEDICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y849",
    "nombre_dx": "Y849-PROCEDIMIENTO MEDICO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y850",
    "nombre_dx": "Y850-SECUELAS DE ACCIDENTE DE VEHICULO DE MOTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Y859",
    "nombre_dx": "Y859-SECUELAS DE OTROS ACCIDENTES DE TRANSPORTE, Y LOS NO ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y86X",
    "nombre_dx": "Y86X-SECUELAS DE OTROS ACCIDENTES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y870",
    "nombre_dx": "Y870-SECUELAS DE LESIONES AUTOINFLIGIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y871",
    "nombre_dx": "Y871-SECUELAS DE AGRESIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Y872",
    "nombre_dx": "Y872-SECUELAS DE EVENTOS DE INTENCION NO DETERMINADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y880",
    "nombre_dx": "Y880-SECUELAS DE EFECTOS ADVERSOS CAUSADOS POR DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS EN SU USO TER",
    "sexo": "A"
  },
  {
    "cod_dx": "Y881",
    "nombre_dx": "Y881-SECUELAS DE INCIDENTES OCURRIDOS AL PACIENTE DURANTE PROCEDIMIENTOS MEDICOS Y QUIRURGICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y882",
    "nombre_dx": "Y882-SECUELAS DE INCIDENTES ADVERSOS ASOCIADOS CON DISPOSITIVOS MEDICOS EN USO DIAGNOSTICO Y TERAPEUTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y883",
    "nombre_dx": "Y883-SECUELAS DE PROCEDIMIENTOS MEDICOS Y QUIRURGICOS COMO LA CAUSA DE REACCION ANORMAL DEL PACIENTE O DE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y890",
    "nombre_dx": "Y890-SECUELAS DE INTERVENCION LEGAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Y891",
    "nombre_dx": "Y891-SECUELAS DE OPERACIONES DE GUERRA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y899",
    "nombre_dx": "Y899-SECUELAS DE CAUSA EXTERNA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y900",
    "nombre_dx": "Y900-NIVEL DE ALCOHOL EN LA SANGRE MENOR DE 20 mg/100 ml ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y901",
    "nombre_dx": "Y901-NIVEL DE ALCOHOL EN LA SANGRE DE 20 A 39 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y902",
    "nombre_dx": "Y902-NIVEL DE ALCOHOL EN LA SANGRE DE 40 A 59 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y903",
    "nombre_dx": "Y903-NIVEL DE ALCOHOL EN LA SANGRE DE 60 A 79 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y904",
    "nombre_dx": "Y904-NIVEL DE ALCOHOL EN LA SANGRE DE 80 A 99 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y905",
    "nombre_dx": "Y905-NIVEL DE ALCOHOL EN LA SANGRE DE 100 A 119 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y906",
    "nombre_dx": "Y906-NIVEL DE ALCOHOL EN LA SANGRE DE 120 A 199 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y907",
    "nombre_dx": "Y907-NIVEL DE ALCOHOL EN LA SANGRE DE 200 A 239 mg/100 ml",
    "sexo": "A"
  },
  {
    "cod_dx": "Y908",
    "nombre_dx": "Y908-NIVEL DE ALCOHOL EN LA SANGRE DE 240 mg/100 ml O MAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Y909",
    "nombre_dx": "Y909-PRESENCIA DE ALCOHOL EN LA SANGRE, NIVEL NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y910",
    "nombre_dx": "Y910-INTOXICACION ALCOHOLICA LEVE",
    "sexo": "A"
  },
  {
    "cod_dx": "Y911",
    "nombre_dx": "Y911-INTOXICACION ALCOHOLICA MODERADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y912",
    "nombre_dx": "Y912-INTOXICACION ALCOHOLICA SEVERA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y913",
    "nombre_dx": "Y913-INTOXICACION ALCOHOLICA MUY SEVERA",
    "sexo": "A"
  },
  {
    "cod_dx": "Y919",
    "nombre_dx": "Y919-ALCOHOLISMO, NIVEL DE INTOXICACION NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Y95X",
    "nombre_dx": "Y95X-AFECCION NOSOCOMIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y96X",
    "nombre_dx": "Y96X-AFECCION RELACIONADA CON EL TRABAJO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y97X",
    "nombre_dx": "Y97X-AFECCION RELACIONADA CON LA CONTAMINACION AMBIENTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Y98X",
    "nombre_dx": "Y98X-AFECCION RELACIONADA CON ESTILO DE VIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z000",
    "nombre_dx": "Z000-EXAMEN MEDICO GENERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z001",
    "nombre_dx": "Z001-CONTROL DE SALUD DE RUTINA DEL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z002",
    "nombre_dx": "Z002-EXAMEN DURANTE EL PERIODO DE CRECIMIENTO RAPIDO EN LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z003",
    "nombre_dx": "Z003-EXAMEN DEL ESTADO DE DESARROLLO DEL ADOLESCENTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z004",
    "nombre_dx": "Z004-EXAMEN PSIQUIATRICO GENERAL, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z005",
    "nombre_dx": "Z005-EXAMEN DE DONANTE POTENCIAL DE ORGANO O TEJIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z006",
    "nombre_dx": "Z006-EXAMEN PARA COMPARACION Y CONTROL NORMALES EN PROGRAMA DE INVESTIGACIONCLINICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z008",
    "nombre_dx": "Z008-OTROS EXAMENES GENERALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z010",
    "nombre_dx": "Z010-EXAMEN DE OJOS Y DE LA VISION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z011",
    "nombre_dx": "Z011-EXAMEN DE OIDOS Y DE LA AUDICION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z012",
    "nombre_dx": "Z012-EXAMEN ODONTOLOGICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z013",
    "nombre_dx": "Z013-EXAMEN DE LA PRESION SANGUINEA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z014",
    "nombre_dx": "Z014-EXAMEN GINECOLOGICO (GENERAL) (DE RUTINA) ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z015",
    "nombre_dx": "Z015-PRUEBAS DE SENSIBILIZACION Y DIAGNOSTICO CUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z016",
    "nombre_dx": "Z016-EXAMEN RADIOLOGICO, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z017",
    "nombre_dx": "Z017-EXAMEN DE LABORATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z018",
    "nombre_dx": "Z018-OTROS EXAMENES ESPECIALES ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z019",
    "nombre_dx": "Z019-EXAMEN ESPECIAL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z020",
    "nombre_dx": "Z020-EXAMEN PARA ADMISION A INSTITUCIONES EDUCATIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z021",
    "nombre_dx": "Z021-EXAMEN PREEMPLEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z022",
    "nombre_dx": "Z022-EXAMEN PARA ADMISION A INSTITUCIONES RESIDENCIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z023",
    "nombre_dx": "Z023-EXAMEN PARA RECLUTAMIENTO EN LAS FUERZAS ARMADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z024",
    "nombre_dx": "Z024-EXAMEN PARA OBTENCION DE LICENCIA DE CONDUCIR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z025",
    "nombre_dx": "Z025-EXAMEN PARA PARTICIPACION EN COMPETENCIAS DEPORTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z026",
    "nombre_dx": "Z026-EXAMEN PARA FINES DE SEGUROS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z027",
    "nombre_dx": "Z027-EXTENSION DE CERTIFICADO MEDICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z028",
    "nombre_dx": "Z028-OTROS EXAMENES PARA FINES ADMINISTRATIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z029",
    "nombre_dx": "Z029-EXAMEN PARA FINES ADMINISTRATIVOS, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z030",
    "nombre_dx": "Z030-OBSERVACION POR SOSPECHA DE TUBERCULOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z031",
    "nombre_dx": "Z031-OBSERVACION POR SOSPECHA DE TUMOR MALIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z032",
    "nombre_dx": "Z032-OBSERVACION POR SOSPECHA DE TRASTORNO MENTAL Y DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z033",
    "nombre_dx": "Z033-OBSERVACION POR SOSPECHA DE TRASTORNO DEL SISTEMA NERVIOSO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z034",
    "nombre_dx": "Z034-OBSERVACION POR SOSPECHA DE INFARTO DE MIOCARDIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z035",
    "nombre_dx": "Z035-OBSERVACION POR SOSPECHA DE OTRAS ENFERMEDADES CARDIOVASCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z036",
    "nombre_dx": "Z036-OBSERVACION POR SOSPECHA DE EFECTOS TOXICOS DE SUSTANCIAS INGERIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z038",
    "nombre_dx": "Z038-OBSERVACION POR SOSPECHA DE OTRAS ENFERMEDADES Y AFECCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z039",
    "nombre_dx": "Z039-OBSERVACION POR SOSPECHA DE ENFERMEDAD O AFECCION NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z040",
    "nombre_dx": "Z040-PRUEBA DE ALCOHOL O DROGAS EN LA SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z041",
    "nombre_dx": "Z041-EXAMEN Y OBSERVACION CONSECUTIVOS A ACCIDENTE DE TRANSPORTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z042",
    "nombre_dx": "Z042-EXAMEN Y OBSERVACION CONSECUTIVOS A ACCIDENTE DE TRABAJO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z043",
    "nombre_dx": "Z043-EXAMEN Y OBSERVACION CONSECUTIVOS A OTRO ACCIDENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z044",
    "nombre_dx": "Z044-EXAMEN Y OBSERVACION CONSECUTIVOS A DENUNCIA DE VIOLACION Y SEDUCCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z045",
    "nombre_dx": "Z045-EXAMEN Y OBSERVACION CONSECUTIVOS A OTRA LESION INFLIGIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z046",
    "nombre_dx": "Z046-EXAMEN PSIQUIATRICO GENERAL, SOLICITADO POR UNA AUTORIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z048",
    "nombre_dx": "Z048-EXAMEN Y OBSERVACION POR OTRAS RAZONES ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z049",
    "nombre_dx": "Z049-EXAMEN Y OBSERVACION POR RAZONES NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z080",
    "nombre_dx": "Z080-EXAMEN DE SEGUIMIENTO CONSECUTIVO A CIRUGIA POR TUMOR MALIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z081",
    "nombre_dx": "Z081-EXAMEN DE SEGUIMIENTO CONSECUTIVO A RADIOTERAPIA POR TUMOR MALIGNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z082",
    "nombre_dx": "Z082-EXAMEN DE SEGUIMIENTO CONSECUTIVO A QUIMIOTERAPIA POR TUMOR MALIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z087",
    "nombre_dx": "Z087-EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO COMBINADO POR TUMOR MALIGNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z088",
    "nombre_dx": "Z088-EXAMEN DE SEGUIMIENTO CONSECUTIVO A OTRO TRATAMIENTO POR TUMOR MALIGNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z089",
    "nombre_dx": "Z089-EXAMEN DE SEGUIMIENTO CONSECUTIVO A OTRO TRATAMIENTO NO ESPECIFICADO POR TUMOR MALIGNO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z090",
    "nombre_dx": "Z090-EXAMEN DE SEGUIMIENTO CONSECUTIVO A CIRUGIA POR OTRAS AFECCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z091",
    "nombre_dx": "Z091-EXAMEN DE SEGUIMIENTO CONSECUTIVO A RADIOTERAPIA POR OTRAS AFECCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z092",
    "nombre_dx": "Z092-EXAMEN DE SEGUIMIENTO CONSECUTIVO A QUIMIOTERAPIA POR OTRAS AFECCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z093",
    "nombre_dx": "Z093-EXAMEN DE SEGUIMIENTO CONSECUTIVO A PSICOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z094",
    "nombre_dx": "Z094-EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO DE FRACTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z097",
    "nombre_dx": "Z097-EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO COMBINADO POR OTRAS AFECCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z098",
    "nombre_dx": "Z098-EXAMEN DE SEGUIMIENTO CONSECUTIVO A OTRO TRATAMIENTO POR OTRAS AFECCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z099",
    "nombre_dx": "Z099-EXAMEN DE SEGUIMIENTO CONSECUTIVO A TRATAMIENTO NO ESPECIFICADO POR OTRAS AFECCIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z100",
    "nombre_dx": "Z100-EXAMEN DE SALUD OCUPACIONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z101",
    "nombre_dx": "Z101-CONTROL GENERAL DE SALUD DE RUTINA DE RESIDENTES DE INSTITUCIONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z102",
    "nombre_dx": "Z102-CONTROL GENERAL DE SALUD DE RUTINA A MIEMBROS DE LAS FUERZAS ARMADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z103",
    "nombre_dx": "Z103-CONTROL GENERAL DE SALUD DE RUTINA A INTEGRANTES DE EQUIPOS DEPORTIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z108",
    "nombre_dx": "Z108-OTROS CONTROLES GENERALES DE SALUD DE RUTINA DE OTRAS SUBPOBLACIONES DEFINIDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z110",
    "nombre_dx": "Z110-EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES INFECCIOSAS INTESTINALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z111",
    "nombre_dx": "Z111-EXAMEN DE PESQUISA ESPECIAL PARA TUBERCULOSIS RESPIRATORIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z112",
    "nombre_dx": "Z112-EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES BACTERIANAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z113",
    "nombre_dx": "Z113-EXAMEN DE PESQUISA ESPECIAL PARA INFECCIONES DE TRANSMISION PREDOMINANTEMENTE SEXUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z114",
    "nombre_dx": "Z114-EXAMEN DE PESQUISA ESPECIAL PARA EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z115",
    "nombre_dx": "Z115-EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES VIRALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z116",
    "nombre_dx": "Z116-EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES DEBIDAS A PROTOZOARIOS Y HELMINTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z118",
    "nombre_dx": "Z118-EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z119",
    "nombre_dx": "Z119-EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES INFECCIOSAS Y PARASITARIAS NOESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z120",
    "nombre_dx": "Z120-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE ESTOMAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z121",
    "nombre_dx": "Z121-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE INTESTINO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z122",
    "nombre_dx": "Z122-EXAMEN DE PESQUISA ESPECIAL PARA TUMORES DE ORGANOS RESPIRATORIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z123",
    "nombre_dx": "Z123-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z124",
    "nombre_dx": "Z124-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DEL CUELLO UTERINO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z125",
    "nombre_dx": "Z125-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA PROSTATA ",
    "sexo": "M"
  },
  {
    "cod_dx": "Z126",
    "nombre_dx": "Z126-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE LA VEJIGA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z128",
    "nombre_dx": "Z128-EXAMEN DE PESQUISA ESPECIAL PARA TUMORES DE OTROS SITIOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z129",
    "nombre_dx": "Z129-EXAMEN DE PESQUISA ESPECIAL PARA TUMOR DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z130",
    "nombre_dx": "Z130-EXAMEN DE PESQUISA ESPECIAL PARA ENFERMEDADES DE LA SANGRE Y ORGANOS HEMATOPOYETICOS Y CIERTOS TRAST",
    "sexo": "A"
  },
  {
    "cod_dx": "Z131",
    "nombre_dx": "Z131-EXAMEN DE PESQUISA ESPECIAL PARA DIABETES MELLITUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z132",
    "nombre_dx": "Z132-EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS DE LA NUTRICION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z133",
    "nombre_dx": "Z133-EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS MENTALES Y DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z134",
    "nombre_dx": "Z134-EXAMEN DE PESQUISA ESPECIAL PARA CIERTOS TRASTORNOS DEL DESARROLLO EN EL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z135",
    "nombre_dx": "Z135-EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS DEL OJO Y DEL OIDO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z136",
    "nombre_dx": "Z136-EXAMEN DE PESQUISA ESPECIAL PARA TRASTORNOS CARDIOVASCULARES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z137",
    "nombre_dx": "Z137-EXAMEN DE PESQUISA ESPECIAL PARA MALFORMACIONES CONGENITAS, DEFORMIDADES Y ANOMALIAS CROMOSOMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z138",
    "nombre_dx": "Z138-EXAMEN DE PESQUISA ESPECIAL PARA OTRAS ENFERMEDADES Y TRASTORNOS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z139",
    "nombre_dx": "Z139-EXAMEN DE PESQUISA ESPECIAL, NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z200",
    "nombre_dx": "Z200-CONTACTO CON Y EXPOSICION A ENFERMEDADES INFECCIOSAS INTESTINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z201",
    "nombre_dx": "Z201-CONTACTO CON Y EXPOSICION A TUBERCULOSIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z202",
    "nombre_dx": "Z202-CONTACTO CON Y EXPOSICION A ENFERMEDADES INFECCIOSAS CON UN MODO DE TRANSMISION PREDOMINANTEMENTE SE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z203",
    "nombre_dx": "Z203-CONTACTO CON Y EXPOSICION A RABIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z204",
    "nombre_dx": "Z204-CONTACTO CON Y EXPOSICION A RUBEOLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z205",
    "nombre_dx": "Z205-CONTACTO CON Y EXPOSICION A HEPATITIS VIRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z206",
    "nombre_dx": "Z206-CONTACTO CON Y EXPOSICION AL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z207",
    "nombre_dx": "Z207-CONTACTO CON Y EXPOSICION A PEDICULOSIS, ACARIASIS Y OTRAS INFESTACIONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z208",
    "nombre_dx": "Z208-CONTACTO CON Y EXPOSICION A OTRAS ENFERMEDADES TRANSMISIBLES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z209",
    "nombre_dx": "Z209-CONTACTO CON Y EXPOSICION A ENFERMEDADES TRANSMISIBLES NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z21X",
    "nombre_dx": "Z21X-ESTADO DE INFECCION ASINTOMATICA POR EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z220",
    "nombre_dx": "Z220-PORTADOR DE FIEBRE TIFOIDEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z221",
    "nombre_dx": "Z221-PORTADOR DE OTRAS ENFERMEDADES INFECCIOSAS INTESTINALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z222",
    "nombre_dx": "Z222-PORTADOR DE DIFTERIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z223",
    "nombre_dx": "Z223-PORTADOR DE OTRAS ENFERMEDADES BACTERIANAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z224",
    "nombre_dx": "Z224-PORTADOR DE ENFERMEDADES INFECCIOSAS CON UN MODO DE TRANSMISION PREDOMINANTEMENTE SEXUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z226",
    "nombre_dx": "Z226-PORTADOR DE ENFERMEDAD INFECCIOSA DEBIDA AL VIRUS HUMANO T-LINFOTROPICO TIPO 1 [VHTL-1] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z228",
    "nombre_dx": "Z228-PORTADOR DE OTRAS ENFERMEDADES INFECCIOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z229",
    "nombre_dx": "Z229-PORTADOR DE ENFERMEDAD INFECCIOSA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z230",
    "nombre_dx": "Z230-NECESIDAD DE INMUNIZACION SOLO CONTRA EL COLERA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z231",
    "nombre_dx": "Z231-NECESIDAD DE INMUNIZACION SOLO CONTRA LA TIFOIDEA - PARATIFOIDEA [TAB]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z232",
    "nombre_dx": "Z232-NECESIDAD DE INMUNIZACION CONTRA LA TUBERCULOSIS [BCG]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z233",
    "nombre_dx": "Z233-NECESIDAD DE INMUNIZACION CONTRA LA PESTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z234",
    "nombre_dx": "Z234-NECESIDAD DE INMUNIZACION CONTRA LA TULAREMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z235",
    "nombre_dx": "Z235-NECESIDAD DE INMUNIZACION SOLO CONTRA EL TETANOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z236",
    "nombre_dx": "Z236-NECESIDAD DE INMUNIZACION SOLO CONTRA LA DIFTERIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z237",
    "nombre_dx": "Z237-NECESIDAD DE INMUNIZACION SOLO CONTRA LA TOS FERINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z238",
    "nombre_dx": "Z238-NECESIDAD DE INMUNIZACION SOLO CONTRA OTRA ENFERMEDAD BACTERIANA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z240",
    "nombre_dx": "Z240-NECESIDAD DE INMUNIZACION CONTRA LA POLIOMIELITIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z241",
    "nombre_dx": "Z241-NECESIDAD DE INMUNIZACION CONTRA LA ENCEFALITIS VIRAL TRANSMITIDA POR ARTROPODOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z242",
    "nombre_dx": "Z242-NECESIDAD DE INMUNIZACION CONTRA LA RABIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z243",
    "nombre_dx": "Z243-NECESIDAD DE INMUNIZACION CONTRA LA FIEBRE AMARILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z244",
    "nombre_dx": "Z244-NECESIDAD DE INMUNIZACION SOLO CONTRA EL SARAMPION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z245",
    "nombre_dx": "Z245-NECESIDAD DE INMUNIZACION SOLO CONTRA LA RUBEOLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z246",
    "nombre_dx": "Z246-NECESIDAD DE INMUNIZACION CONTRA LA HEPATITIS VIRAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z250",
    "nombre_dx": "Z250-NECESIDAD DE INMUNIZACION SOLO CONTRA LA PAROTIDITIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z251",
    "nombre_dx": "Z251-NECESIDAD DE INMUNIZACION CONTRA LA INFLUENZA [GRIPE] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z258",
    "nombre_dx": "Z258-NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES VIRALES UNICAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z260",
    "nombre_dx": "Z260-NECESIDAD DE INMUNIZACION CONTRA LA LEISHMANIASIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z268",
    "nombre_dx": "Z268-NECESIDAD DE INMUNIZACION CONTRA OTRAS ENFERMEDADES INFECCIOSAS UNICAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z269",
    "nombre_dx": "Z269-NECESIDAD DE INMUNIZACION CONTRA ENFERMEDAD INFECCIOSA NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z270",
    "nombre_dx": "Z270-NECESIDAD DE INMUNIZACION CONTRA EL COLERA Y LA TIFOIDEA - PARATIFOIDEA [COLERA + TAB]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z271",
    "nombre_dx": "Z271-NECESIDAD DE INMUNIZACION CONTRA DIFTERIA - PERTUSSIS - TETANOS COMBINADOS [DPT]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z272",
    "nombre_dx": "Z272-NECESIDAD DE INMUNIZACION CONTRA DIFTERIA - PERTUSSIS - TETANOS Y TIFOIDEA - PARATIFOIDEA [DPT + TAB",
    "sexo": "A"
  },
  {
    "cod_dx": "Z273",
    "nombre_dx": "Z273-NECESIDAD DE INMUNIZACION CONTRA DIFTERIA - PERTUSSIS - TETANOS Y POLIOMIELITIS [DPT + POLIO]]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z274",
    "nombre_dx": "Z274-NECESIDAD DE INMUNIZACION CONTRA SARAMPION - PAROTIDITIS - RUBEOLA [SPR] [MMR]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z278",
    "nombre_dx": "Z278-NECESIDAD DE INMUNIZACION CONTRA OTRAS COMBINACIONES DE ENFERMEDADES INFECCIOSAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z279",
    "nombre_dx": "Z279-NECESIDAD DE INMUNIZACION CONTRA COMBINACIONES NO ESPECIFICADAS DE ENFERMEDADES INFECCIOSAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z280",
    "nombre_dx": "Z280-INMUNIZACION NO REALIZADA POR CONTRAINDICACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z281",
    "nombre_dx": "Z281-INMUNIZACION NO REALIZADA POR DECISION DEL PACIENTE, POR MOTIVOS DE CREENCIA O PRESION DEL GRUPO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z282",
    "nombre_dx": "Z282-INMUNIZACION NO REALIZADA POR DECISION DEL PACIENTE, POR OTRAS RAZONES Y LAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z288",
    "nombre_dx": "Z288-INMUNIZACION NO REALIZADA POR OTRAS RAZONES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z289",
    "nombre_dx": "Z289-INMUNIZACION NO REALIZADA POR RAZON NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z290",
    "nombre_dx": "Z290-AISLAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z291",
    "nombre_dx": "Z291-INMUNOTERAPIA PROFILACTICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z292",
    "nombre_dx": "Z292-OTRA QUIMIOTERAPIA PROFILACTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z298",
    "nombre_dx": "Z298-OTRAS MEDIDAS PROFILACTICAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z299",
    "nombre_dx": "Z299-MEDIDA PROFILACTICA NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z300",
    "nombre_dx": "Z300-CONSEJO Y ASESORAMIENTO GENERAL SOBRE LA ANTICONCEPCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z301",
    "nombre_dx": "Z301-INSERCION DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)",
    "sexo": "F"
  },
  {
    "cod_dx": "Z302",
    "nombre_dx": "Z302-ESTERILIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z303",
    "nombre_dx": "Z303-EXTRACCION MENSTRUAL",
    "sexo": "F"
  },
  {
    "cod_dx": "Z304",
    "nombre_dx": "Z304-SUPERVISION DEL USO DE DROGAS ANTICONCEPTIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z305",
    "nombre_dx": "Z305-SUPERVISION DEL USO DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)",
    "sexo": "F"
  },
  {
    "cod_dx": "Z308",
    "nombre_dx": "Z308-OTRAS ATENCIONES ESPECIFICADAS PARA LA ANTICONCEPCION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z309",
    "nombre_dx": "Z309-ASISTENCIA PARA LA ANTICONCEPCION, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z310",
    "nombre_dx": "Z310-TUBOPLASTIA O VASOPLASTIA POSTERIOR A ESTERILIZACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z311",
    "nombre_dx": "Z311-INSEMINACION ARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z312",
    "nombre_dx": "Z312-FECUNDACION IN VITRO",
    "sexo": "F"
  },
  {
    "cod_dx": "Z313",
    "nombre_dx": "Z313-OTROS METODOS DE ATENCION PARA LA FECUNDACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z314",
    "nombre_dx": "Z314-INVESTIGACION Y PRUEBA PARA LA PROCREACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z315",
    "nombre_dx": "Z315-ASESORAMIENTO GENETICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z316",
    "nombre_dx": "Z316-CONSEJO Y ASESORAMIENTO GENERAL SOBRE LA PROCREACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z318",
    "nombre_dx": "Z318-OTRA ATENCION ESPECIFICADA PARA LA PROCREACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z319",
    "nombre_dx": "Z319-ATENCION NO ESPECIFICADA RELACIONADA CON LA PROCREACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z320",
    "nombre_dx": "Z320-EMBARAZO (AUN) NO CONFIRMADO",
    "sexo": "F"
  },
  {
    "cod_dx": "Z321",
    "nombre_dx": "Z321-EMBARAZO CONFIRMADO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z33X",
    "nombre_dx": "Z33X-ESTADO DE EMBARAZO, INCIDENTAL",
    "sexo": "F"
  },
  {
    "cod_dx": "Z340",
    "nombre_dx": "Z340-SUPERVISION DE PRIMER EMBARAZO NORMAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z348",
    "nombre_dx": "Z348-SUPERVISION DE OTROS EMBARAZOS NORMALES ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z349",
    "nombre_dx": "Z349-SUPERVISION DE EMBARAZO NORMAL NO ESPECIFICADO",
    "sexo": "F"
  },
  {
    "cod_dx": "Z350",
    "nombre_dx": "Z350-SUPERVISION DE EMBARAZO CON HISTORIA DE ESTERILIDAD ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z351",
    "nombre_dx": "Z351-SUPERVISION DE EMBARAZO CON HISTORIA DE ABORTO",
    "sexo": "F"
  },
  {
    "cod_dx": "Z352",
    "nombre_dx": "Z352-SUPERVISION DE EMBARAZO CON OTRO RIESGO EN LA HISTORIA OBSTETRICA O REPRODUCTIVA",
    "sexo": "F"
  },
  {
    "cod_dx": "Z353",
    "nombre_dx": "Z353-SUPERVISION DE EMBARAZO CON HISTORIA DE INSUFICIENTE ATENCION PRENATAL",
    "sexo": "F"
  },
  {
    "cod_dx": "Z354",
    "nombre_dx": "Z354-SUPERVISION DE EMBARAZO CON GRAN MULTIPARIDAD ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z355",
    "nombre_dx": "Z355-SUPERVISION DE PRIMIGESTA AÑOSA ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z356",
    "nombre_dx": "Z356-SUPERVISION DE PRIMIGESTA MUY JOVEN ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z357",
    "nombre_dx": "Z357-SUPERVISION DE EMBARAZO DE ALTO RIESGO DEBIDO A PROBLEMAS SOCIALES",
    "sexo": "F"
  },
  {
    "cod_dx": "Z358",
    "nombre_dx": "Z358-SUPERVISION DE OTROS EMBARAZOS DE ALTO RIESGO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z359",
    "nombre_dx": "Z359-SUPERVISION DE EMBARAZO DE ALTO RIESGO, SIN OTRA ESPECIFICACION ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z360",
    "nombre_dx": "Z360-PESQUISA PRENATAL PARA ANOMALIAS CROMOSOMICAS ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z361",
    "nombre_dx": "Z361-PESQUISA PRENATAL PARA MEDIR NIVELES ELEVADOS DE ALFAFETOPROTEINAS",
    "sexo": "F"
  },
  {
    "cod_dx": "Z362",
    "nombre_dx": "Z362-OTRAS PESQUISAS PRENATALES BASADAS EN AMNIOCENTESIS ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z363",
    "nombre_dx": "Z363-PESQUISA PRENATAL DE MALFORMACIONES USANDO ALTRASONIDO Y OTROS METODOS FISICOS",
    "sexo": "F"
  },
  {
    "cod_dx": "Z364",
    "nombre_dx": "Z364-PESQUISA PRENATAL DEL RETARDO DEL CRECIMIENTO FETAL USANDO ULTRASONIDO Y OTROS METODOS FISICOS",
    "sexo": "F"
  },
  {
    "cod_dx": "Z365",
    "nombre_dx": "Z365-PESQUISA PRENATAL PARA ISOINMUNIZACION",
    "sexo": "F"
  },
  {
    "cod_dx": "Z368",
    "nombre_dx": "Z368-OTRAS PESQUISAS PRENATALES ESPECIFICAS",
    "sexo": "F"
  },
  {
    "cod_dx": "Z369",
    "nombre_dx": "Z369-PESQUISA PRENATAL, SIN OTRA ESPECIFICACION",
    "sexo": "F"
  },
  {
    "cod_dx": "Z370",
    "nombre_dx": "Z370-NACIDO VIVO, UNICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z371",
    "nombre_dx": "Z371-NACIDO MUERTO, UNICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z372",
    "nombre_dx": "Z372-GEMELOS, AMBOS NACIDOS VIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z373",
    "nombre_dx": "Z373-GEMELOS, UN NACIDO VIVO Y UN NACIDO MUERTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z374",
    "nombre_dx": "Z374-GEMELOS, AMBOS NACIDOS MUERTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z375",
    "nombre_dx": "Z375-OTROS NACIMIENTOS MULTIPLES, TODOS NACIDOS VIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z376",
    "nombre_dx": "Z376-OTROS NACIMIENTOS MULTIPLES, ALGUNOS NACIDOS VIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z377",
    "nombre_dx": "Z377-OTROS NACIMIENTOS MULTIPLES, TODOS NACIDOS MUERTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z379",
    "nombre_dx": "Z379-PRODUCTO DEL PARTO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z380",
    "nombre_dx": "Z380-PRODUCTO UNICO, NACIDO EN HOSPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z381",
    "nombre_dx": "Z381-PRODUCTO UNICO, NACIDO FUERA DE HOSPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z382",
    "nombre_dx": "Z382-PRODUCTO UNICO, LUGAR DE NACIMIENTO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z383",
    "nombre_dx": "Z383-GEMELOS, NACIDOS EN HOSPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z384",
    "nombre_dx": "Z384-GEMELOS, NACIDOS FUERA DE HOSPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z385",
    "nombre_dx": "Z385-GEMELOS, LUGAR DE NACIMIENTO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z386",
    "nombre_dx": "Z386-OTROS NACIMIENTOS MULTIPLES, EN HOSPITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z387",
    "nombre_dx": "Z387-OTROS NACIMIENTOS MULTIPLES, FUERA DEL HOSPITAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z388",
    "nombre_dx": "Z388-OTROS NACIMIENTOS MULTIPLES, LUGAR DE NACIMIENTO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z390",
    "nombre_dx": "Z390-ATENCION Y EXAMEN INMEDIATAMENTE DESPUES DEL PARTO",
    "sexo": "F"
  },
  {
    "cod_dx": "Z391",
    "nombre_dx": "Z391-ATENCION Y EXAMEN DE MADRE EN PERIODO DE LACTANCIA",
    "sexo": "F"
  },
  {
    "cod_dx": "Z392",
    "nombre_dx": "Z392-SEGUIMIENTO POSTPARTO, DE RUTINA",
    "sexo": "F"
  },
  {
    "cod_dx": "Z400",
    "nombre_dx": "Z400-CIRUGIA PROFILACTICA POR FACTORES DE RIESGO RELACIONADOS CON TUMORES MALIGNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z408",
    "nombre_dx": "Z408-OTRA CIRUGIA PROFILACTICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z409",
    "nombre_dx": "Z409-CIRUGIA PROFILACTICA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z410",
    "nombre_dx": "Z410-TRASPLANTE DE PELO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z411",
    "nombre_dx": "Z411-OTRAS CIRUGIAS PLASTICAS POR RAZONES ESTETICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z412",
    "nombre_dx": "Z412-CIRCUNCISION RITUAL O DE RUTINA ",
    "sexo": "M"
  },
  {
    "cod_dx": "Z413",
    "nombre_dx": "Z413-PERFORACION DE LA OREJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z418",
    "nombre_dx": "Z418-OTROS PROCEDIMIENTOS PARA OTROS PROPOSITOS QUE NO SEAN LOS DE MEJORAR EL ESTADO DE SALUD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z419",
    "nombre_dx": "Z419-PROCEDIMIENTOS NO ESPECIFICADO PARA OTROS PROPOSITOS QUE NO SEAN LOS DE MEJORAR EL ESTADO DE SALUD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z420",
    "nombre_dx": "Z420-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LA CABEZA Y DEL CUELLO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z421",
    "nombre_dx": "Z421-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LA MAMA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z422",
    "nombre_dx": "Z422-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE OTRAS PARTES ESPECIFICADAS DEL TRONCO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z423",
    "nombre_dx": "Z423-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LAS EXTREMIDADES SUPERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z424",
    "nombre_dx": "Z424-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE LAS EXTREMIDADES INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z428",
    "nombre_dx": "Z428-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA DE OTRAS PARTES ESPECIFICADAS DEL CUERPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z429",
    "nombre_dx": "Z429-CUIDADOS POSTERIORES A LA CIRUGIA PLASTICA NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z430",
    "nombre_dx": "Z430-ATENCION DE TRAQUEOSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z431",
    "nombre_dx": "Z431-ATENCION DE GASTROSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z432",
    "nombre_dx": "Z432-ATENCION DE ILEOSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z433",
    "nombre_dx": "Z433-ATENCION DE COLOSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z434",
    "nombre_dx": "Z434-ATENCION DE OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS DIGESTIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z435",
    "nombre_dx": "Z435-ATENCION DE CISTOSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z436",
    "nombre_dx": "Z436-ATENCION DE OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z437",
    "nombre_dx": "Z437-ATENCION DE VAGINA ARTIFICIAL ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z438",
    "nombre_dx": "Z438-ATENCION DE OTROS ORIFICIOS ARTIFICIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z439",
    "nombre_dx": "Z439-ATENCION DE ORIFICIO ARTIFICIAL NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z440",
    "nombre_dx": "Z440-PRUEBA Y AJUSTE DE BRAZO ARTIFICIAL (COMPLETO) (PARCIAL)",
    "sexo": "A"
  },
  {
    "cod_dx": "Z441",
    "nombre_dx": "Z441-PRUEBA Y AJUSTE DE PIERNA ARTIFICIAL (COMPLETA) (PARCIAL) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z442",
    "nombre_dx": "Z442-PRUEBA Y AJUSTE DE OJO ARTIFICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z443",
    "nombre_dx": "Z443-PRUEBA Y AJUSTE DE PROTESIS MAMARIA EXTERNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z448",
    "nombre_dx": "Z448-PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS PROTESICOS EXTERNOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z449",
    "nombre_dx": "Z449-PRUEBA Y AJUSTE DE DISPOSITIVO PROTESICO EXTERNO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z450",
    "nombre_dx": "Z450-Asistencia y ajuste de dispositivos cardíacos",
    "sexo": "A"
  },
  {
    "cod_dx": "Z451",
    "nombre_dx": "Z451-ASISTENCIA Y AJUSTE DE BOMBA DE INFUSION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z452",
    "nombre_dx": "Z452-ASISTENCIA Y AJUSTE DE DISPOSITIVOS DE ACCESO VASCULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z453",
    "nombre_dx": "Z453-ASISTENCIA Y AJUSTE DE DISPOSITIVO AUDITIVO IMPLANTADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z458",
    "nombre_dx": "Z458-ASISTENCIA Y AJUSTE DE OTROS DISPOSITIVOS IMPLANTADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z459",
    "nombre_dx": "Z459-ASISTENCIA Y AJUSTE DE DISPOSITIVO IMPLANTADO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z460",
    "nombre_dx": "Z460-PRUEBA Y AJUSTE DE ANTEOJOS Y LENTES DE CONTACTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z461",
    "nombre_dx": "Z461-PRUEBA Y AJUSTE DE AUDIFONOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z462",
    "nombre_dx": "Z462-PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS RELACIONADOS CON EL SISTEMA NERVIOSO Y LOS SENTIDOS ESPECIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z463",
    "nombre_dx": "Z463-PRUEBA Y AJUSTE DE PROTESIS DENTAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z464",
    "nombre_dx": "Z464-PRUEBA Y AJUSTE DE DISPOSITIVO ORTODONCICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z465",
    "nombre_dx": "Z465-PRUEBA Y AJUSTE DE ILEOSTOMIA U OTRO DISPOSITIVO INTESTINAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z466",
    "nombre_dx": "Z466-PRUEBA Y AJUSTE DE DISPOSITIVO URINARIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z467",
    "nombre_dx": "Z467-PRUEBA Y AJUSTE DE DISPOSITIVO ORTOPEDICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z468",
    "nombre_dx": "Z468-PRUEBA Y AJUSTE DE OTROS DISPOSITIVOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z469",
    "nombre_dx": "Z469-PRUEBA Y AJUSTE DE DISPOSITIVO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z470",
    "nombre_dx": "Z470-CUIDADOS POSTERIORES A LA EXTRACCION DE PLACA U OTRO DISPOSITIVO DE FIJACION INTERNA EN FRACTURA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z478",
    "nombre_dx": "Z478-OTROS CUIDADOS ESPECIFICADOS POSTERIORES A LA ORTOPEDIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z479",
    "nombre_dx": "Z479-CUIDADO POSTERIOR A LA ORTOPEDIA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z480",
    "nombre_dx": "Z480-ATENCION DE LOS APOSITOS Y SUTURAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z488",
    "nombre_dx": "Z488-OTROS CUIDADOS ESPECIFICADOS POSTERIORES A LA CIRUGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z489",
    "nombre_dx": "Z489-CUIDADO POSTERIOR A LA CIRUGIA, NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z490",
    "nombre_dx": "Z490-CUIDADOS PREOPERATORIOS PARA DIALISIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z491",
    "nombre_dx": "Z491-DIALISIS EXTRACORPOREA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z492",
    "nombre_dx": "Z492-OTRAS DIALISIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z500",
    "nombre_dx": "Z500-REHABILITACION CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z501",
    "nombre_dx": "Z501-OTRAS TERAPIAS FISICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z502",
    "nombre_dx": "Z502-REHABILITACION DEL ALCOHOLICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z503",
    "nombre_dx": "Z503-REHABILITACION DEL DROGADICTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z504",
    "nombre_dx": "Z504-PSICOTERAPIA, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z505",
    "nombre_dx": "Z505-TERAPIA DEL LENGUAJE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z506",
    "nombre_dx": "Z506-ADIESTRAMIENTO ORTOPTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z507",
    "nombre_dx": "Z507-TERAPIA OCUPACIONAL Y REHABILITACION VOCACIONAL, NO CLASIFICADA EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z508",
    "nombre_dx": "Z508-ATENCION POR OTROS PROCEDIMIENTOS DE REHABILITACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z509",
    "nombre_dx": "Z509-ATENCION POR PROCEDIMIENTO DE REHABILITACION, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z510",
    "nombre_dx": "Z510-SESION DE RADIOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z511",
    "nombre_dx": "Z511-SESION DE QUIMIOTERAPIA POR TUMOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z512",
    "nombre_dx": "Z512-OTRA QUIMIOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z513",
    "nombre_dx": "Z513-Transfusión de sangre sin diagnóstico informado",
    "sexo": "A"
  },
  {
    "cod_dx": "Z514",
    "nombre_dx": "Z514-ATENCION PREPARATORIA PARA TRATAMIENTO SUBSECUENTE, NO CLASIFICADO EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z515",
    "nombre_dx": "Z515-ATENCION PALIATIVA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z516",
    "nombre_dx": "Z516-DESENSIBILIZACION A ALERGENOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z518",
    "nombre_dx": "Z518-OTRAS ATENCIONES MEDICAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z519",
    "nombre_dx": "Z519-ATENCION MEDICA, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z520",
    "nombre_dx": "Z520-DONANTE DE SANGRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z521",
    "nombre_dx": "Z521-DONANTE DE PIEL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z522",
    "nombre_dx": "Z522-DONANTE DE HUESO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z523",
    "nombre_dx": "Z523-DONANTE DE MEDULA OSEA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z524",
    "nombre_dx": "Z524-DONANTE DE RIÑON",
    "sexo": "A"
  },
  {
    "cod_dx": "Z525",
    "nombre_dx": "Z525-DONANTE DE CORNEA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z528",
    "nombre_dx": "Z528-DONANTE DE OTROS ORGANOS O TEJIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z529",
    "nombre_dx": "Z529-DONANTE DE ORGANO O TEJIDO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z530",
    "nombre_dx": "Z530-PROCEDIMIENTO NO REALIZADO POR CONTRAINDICACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z531",
    "nombre_dx": "Z531-PROCEDIMIENTO NO REALIZADO POR DECISION DEL PACIENTE, POR RAZONES DE CREENCIA O PRESION DEL GRUPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z532",
    "nombre_dx": "Z532-PROCEDIMIENTO NO REALIZADO POR DECISION DEL PACIENTE, POR OTRAS RAZONES Y LAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z538",
    "nombre_dx": "Z538-PROCEDIMIENTO NO REALIZADO POR OTRAS RAZONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z539",
    "nombre_dx": "Z539-PROCEDIMIENTO NO REALIZADO POR RAZON NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z540",
    "nombre_dx": "Z540-CONVALECENCIA CONSECUTIVA A CIRUGIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z541",
    "nombre_dx": "Z541-CONVALECENCIA CONSECUTIVA A RADIOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z542",
    "nombre_dx": "Z542-CONVALECENCIA CONSECUTIVA A QUIMIOTERAPIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z543",
    "nombre_dx": "Z543-CONVALECENCIA CONSECUTIVA A PSICOTERAPIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z544",
    "nombre_dx": "Z544-CONVALECENCIA CONSECUTIVA A TRATAMIENTO DE FRACTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z547",
    "nombre_dx": "Z547-CONVALECENCIA CONSECUTIVA A TRATAMIENTO COMBINADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z548",
    "nombre_dx": "Z548-CONVALECENCIA CONSECUTIVA A OTROS TRATAMIENTOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z549",
    "nombre_dx": "Z549-CONVALECENCIA CONSECUTIVA A TRATAMIENTO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z550",
    "nombre_dx": "Z550-PROBLEMAS RELACIONADOS CON EL ANALFABETISMO O BAJO NIVEL DE INSTRUCCIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z551",
    "nombre_dx": "Z551-PROBLEMAS RELACIONADOS CON LA EDUCACION NO DISPONIBLE O INACCESIBLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z552",
    "nombre_dx": "Z552-PROBLEMAS RELACIONADOS CON LA FALLA EN LOS EXAMENES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z553",
    "nombre_dx": "Z553-PROBLEMAS RELACIONADOS CON EL BAJO RENDIMIENTO ESCOLAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z554",
    "nombre_dx": "Z554-PROBLEMAS RELACIONADOS CON LA INADAPTACION EDUCACIONAL Y DESAVENENCIAS CON MAESTROS Y COMPAÑEROS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z558",
    "nombre_dx": "Z558-OTROS PROBLEMAS RELACIONADOS CON LA EDUCACION Y LA ALFABETIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z559",
    "nombre_dx": "Z559-PROBLEMA NO ESPECIFICADO RELACIONADO CON LA EDUCACION Y LA ALFABETIZACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z560",
    "nombre_dx": "Z560-PROBLEMAS RELACIONADOS CON EL DESEMPLEO, NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z561",
    "nombre_dx": "Z561-PROBLEMAS RELACIONADOS CON EL CAMBIO DE EMPLEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z562",
    "nombre_dx": "Z562-PROBLEMAS RELACIONADOS CON AMENAZA DE PERDIDA DEL EMPLEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z563",
    "nombre_dx": "Z563-PROBLEMAS RELACIONADOS CON HORARIO ESTRESANTE DE TRABAJO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z564",
    "nombre_dx": "Z564-PROBLEMAS RELACIONADOS CON DESAVENENCIAS CON EL JEFE Y LOS COMPAÑEROS DE TRABAJO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z565",
    "nombre_dx": "Z565-PROBLEMAS RELACIONADOS CON EL TRABAJO INCOMPATIBLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z566",
    "nombre_dx": "Z566-OTROS PROBLEMAS DE TENSION FISICA O MENTAL RELACIONADAS CON EL TRABAJO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z567",
    "nombre_dx": "Z567-OTROS PROBLEMAS Y LOS NO ESPECIFICADOS RELACIONADOS CON EL EMPLEO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z570",
    "nombre_dx": "Z570-EXPOSICION OCUPACIONAL AL RUIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z571",
    "nombre_dx": "Z571-EXPOSICION OCUPACIONAL A LA RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z572",
    "nombre_dx": "Z572-EXPOSICION OCUPACIONAL AL POLVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z573",
    "nombre_dx": "Z573-EXPOSICION OCUPACIONAL A OTRO CONTAMINANTE DEL AIRE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z574",
    "nombre_dx": "Z574-EXPOSICION OCUPACIONAL A AGENTES TOXICOS EN AGRICULTURA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z575",
    "nombre_dx": "Z575-EXPOSICION OCUPACIONAL A AGENTES TOXICOS EN OTRAS INDUSTRIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z576",
    "nombre_dx": "Z576-EXPOSICION OCUPACIONAL A TEMPERATURA EXTREMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z577",
    "nombre_dx": "Z577-EXPOSICION OCUPACIONAL A LA VIBRACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z578",
    "nombre_dx": "Z578-EXPOSICION OCUPACIONAL A OTROS FACTORES DE RIESGO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z579",
    "nombre_dx": "Z579-EXPOSICION OCUPACIONAL A FACTOR DE RIESGO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z580",
    "nombre_dx": "Z580-EXPOSICION AL RUIDO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z581",
    "nombre_dx": "Z581-EXPOSICION AL AIRE CONTAMINADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z582",
    "nombre_dx": "Z582-EXPOSICION AL AGUA CONTAMINADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z583",
    "nombre_dx": "Z583-EXPOSICION AL SUELO CONTAMINADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z584",
    "nombre_dx": "Z584-EXPOSICION A LA RADIACION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z585",
    "nombre_dx": "Z585-EXPOSICION A OTRAS CONTAMINACIONES DEL AMBIENTE FISICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z586",
    "nombre_dx": "Z586-SUMINISTRO INADECUADO DE AGUA POTABLE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z588",
    "nombre_dx": "Z588-OTROS PROBLEMAS RELACIONADOS CON EL AMBIENTE FISICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z589",
    "nombre_dx": "Z589-PROBLEMA NO ESPECIFICADO RELACIONADO CON EL AMBIENTE FISICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z590",
    "nombre_dx": "Z590-PROBLEMAS RELACIONADOS CON LA FALTA DE VIVIENDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z591",
    "nombre_dx": "Z591-PROBLEMAS RELACIONADOS CON VIVIENDA INADECUADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z592",
    "nombre_dx": "Z592-PROBLEMAS CASEROS Y CON VECINOS E INQUILINOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z593",
    "nombre_dx": "Z593-PROBLEMAS RELACIONADOS CON PERSONA QUE RESIDE EN UNA INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z594",
    "nombre_dx": "Z594-PROBLEMAS RELACIONADOS CON FALTA DE ALIMENTOS ADECUADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z595",
    "nombre_dx": "Z595-PROBLEMAS RELACIONADOS CON POBREZA EXTREMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z596",
    "nombre_dx": "Z596-PROBLEMAS RELACIONADOS CON BAJOS INGRESOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z597",
    "nombre_dx": "Z597-PROBLEMAS RELACIONADOS CON SEGURIDAD SOCIAL Y SOSTENIMIENTO INSUFICIENTES PARA EL BIENESTAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z598",
    "nombre_dx": "Z598-OTROS PROBLEMAS RELACIONADOS CON LA VIVIENDA Y LAS CIRCUNSTANCIAS ECONOMICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z599",
    "nombre_dx": "Z599-PROBLEMAS NO ESPECIFICADOS RELACIONADOS CON LA VIVIENDA Y LAS CIRCUNSTANCIAS ECONOMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z600",
    "nombre_dx": "Z600-PROBLEMAS RELACIONADOS CON EL AJUSTE A LAS TRANSICIONES DEL CICLO VITAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z601",
    "nombre_dx": "Z601-PROBLEMAS RELACIONADOS CON SITUACION FAMILIAR ATIPICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z602",
    "nombre_dx": "Z602-PROBLEMAS RELACIONADOS CON PERSONA QUE VIVE SOLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z603",
    "nombre_dx": "Z603-PROBLEMAS RELACIONADOS CON LA ADAPTACION CULTURAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z604",
    "nombre_dx": "Z604-PROBLEMAS RELACIONADOS CON EXCLUSION Y RECHAZO SOCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z605",
    "nombre_dx": "Z605-PROBLEMAS RELACIONADOS CON LA DISCRIMINACION Y PERSECUCION PERCIBIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z608",
    "nombre_dx": "Z608-OTROS PROBLEMAS RELACIONADOS CON EL AMBIENTE SOCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z609",
    "nombre_dx": "Z609-PROBLEMA NO ESPECIFICADO RELACIONADO CON EL AMBIENTE SOCIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z610",
    "nombre_dx": "Z610-PROBLEMAS RELACIONADOS CON LA PERDIDA DE RELACION AFECTIVA EN LA INFANCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z611",
    "nombre_dx": "Z611-PROBLEMAS RELACIONADOS CON EL ALEJAMIENTO DEL HOGAR EN LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z612",
    "nombre_dx": "Z612-PROBLEMAS RELACIONADOS CON ALTERACION EN EL PATRON DE LA RELACION FAMILIAR EN LA INFANCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z613",
    "nombre_dx": "Z613-PROBLEMAS RELACIONADOS CON EVENTOS QUE LLEVARON A LA PERDIDA DE LA AUTOESTIMA EN LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z614",
    "nombre_dx": "Z614-PROBLEMAS RELACIONADOS CON EL ABUSO SEXUAL DEL NIÑO POR PERSONA DENTRO DEL GRUPO DE APOYO PRIMARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z615",
    "nombre_dx": "Z615-PROBLEMAS RELACIONADOS CON EL ABUSO SEXUAL DEL NIÑO POR PERSONA AJENA AL GRUPO DE APOYO PRIMARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z616",
    "nombre_dx": "Z616-PROBLEMAS RELACIONADOS CON ABUSO FISICO DEL NIÑO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z617",
    "nombre_dx": "Z617-PROBLEMAS RELACIONADOS CON EXPERIENCIAS PERSONALES ATEMORIZANTES EN LA INFANCIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z618",
    "nombre_dx": "Z618-PROBLEMAS RELACIONADOS CON OTRAS EXPERIENCIAS NEGATIVAS EN LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z619",
    "nombre_dx": "Z619-PROBLEMAS RELACIONADOS CON EXPERIENCIA NEGATIVA NO ESPECIFICADA EN LA INFANCIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z620",
    "nombre_dx": "Z620-PROBLEMAS RELACIONADOS CON LA SUPERVISION O EL CONTROL INADECUADOS DE LOS PADRES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z621",
    "nombre_dx": "Z621-PROBLEMAS RELACIONADOS CON LA SOBREPROTECCION DE LOS PADRES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z622",
    "nombre_dx": "Z622-PROBLEMAS RELACIONADOS CON LA CRIANZA EN INSTITUCION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z623",
    "nombre_dx": "Z623-PROBLEMAS RELACIONADOS CON HOSTILIDAD Y REPROBACION AL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z624",
    "nombre_dx": "Z624-PROBLEMAS RELACIONADOS CON EL ABANDONO EMOCIONAL DEL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z625",
    "nombre_dx": "Z625-OTROS PROBLEMAS RELACIONADOS CON NEGLIGENCIA EN LA CRIANZA DEL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z626",
    "nombre_dx": "Z626-PROBLEMAS RELACIONADOS CON PRESIONES INAPROPIADAS DE LOS PADRES Y OTRAS ANORMALIDADES EN LA CALIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z628",
    "nombre_dx": "Z628-OTROS PROBLEMAS ESPECIFICADOS Y RELACIONADOS CON LA CRIANZA DEL NIÑO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z629",
    "nombre_dx": "Z629-PROBLEMA NO ESPECIFICADO RELACIONADO CON LA CRIANZA DEL NIÑO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z630",
    "nombre_dx": "Z630-PROBLEMAS EN LA RELACION ENTRE ESPOSOS O PAREJA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z631",
    "nombre_dx": "Z631-PROBLEMAS EN LA RELACION CON LOS PADRES Y LOS FAMILIARES POLITICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z632",
    "nombre_dx": "Z632-PROBLEMAS RELACIONADOS CON EL APOYO FAMILIAR INADECUADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z633",
    "nombre_dx": "Z633-PROBLEMAS RELACIONADOS CON LA AUSENCIA DE UN MIEMBRO DE LA FAMILIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z634",
    "nombre_dx": "Z634-PROBLEMAS RELACIONADOS CON LA DESAPARICION O MUERTE DE UN MIEMBRO DE LA FAMILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z635",
    "nombre_dx": "Z635-PROBLEMAS RELACIONADOS CON LA RUPTURA FAMILIAR POR SEPARACION O DIVORCIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z636",
    "nombre_dx": "Z636-PROBLEMAS RELACIONADOS CON FAMILIAR DEPENDIENTE, NECESITADO DE CUIDADO EN LA CASA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z637",
    "nombre_dx": "Z637-PROBLEMAS RELACIONADOS CON OTROS HECHOS ESTRESANTES QUE AFECTAN A LA FAMILIA Y AL HOGAR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z638",
    "nombre_dx": "Z638-OTROS PROBLEMAS ESPECIFICADOS RELACIONADOS CON EL GRUPO PRIMARIO DE APOYO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z639",
    "nombre_dx": "Z639-PROBLEMA NO ESPECIFICADO RELACIONADO CON EL GRUPO PRIMARIO DE APOYO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z640",
    "nombre_dx": "Z640-PROBLEMAS RELACIONADOS CON EMBARAZO NO DESEADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z641",
    "nombre_dx": "Z641-PROBLEMAS RELACIONADOS CON LA MULTIPARIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z642",
    "nombre_dx": "Z642-PROBLEMAS RELACIONADOS CON LA SOLICITUD O ACEPTACION DE INTERVENCIONES FISICAS, NUTRICIONALES Y QUIM",
    "sexo": "A"
  },
  {
    "cod_dx": "Z643",
    "nombre_dx": "Z643-PROBLEMAS RELACIONADOS CON LA SOLICITUD O ACEPTACION DE INTERVENCIONES PSICOLOGICAS O DE LA CONDUCTA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z644",
    "nombre_dx": "Z644-PROBLEMAS RELACIONADOS CON EL DESACUERDO CON CONSEJEROS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z650",
    "nombre_dx": "Z650-PROBLEMAS RELACIONADOS CON CULPABILIDAD EN PROCEDIMIENTOS CIVILES O CRIMINALES SIN PRISION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z651",
    "nombre_dx": "Z651-PROBLEMAS RELACIONADOS CON PRISION Y OTRO ENCARCELAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z652",
    "nombre_dx": "Z652-PROBLEMAS RELACIONADOS CON LA LIBERACION DE LA PRISION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z653",
    "nombre_dx": "Z653-PROBLEMAS RELACIONADOS CON OTRAS CIRCUNSTANCIAS LEGALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z654",
    "nombre_dx": "Z654-PROBLEMAS RELACIONADOS CON VICTIMA DE CRIMEN O TERRORISMO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z655",
    "nombre_dx": "Z655-PROBLEMAS RELACIONADOS CON LA EXPOSICION A DESASTRE, GUERRA U OTRAS HOSTILIDADES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z658",
    "nombre_dx": "Z658-OTROS PROBLEMAS ESPECIFICADOS RELACIONADOS CON CIRCUNSTANCIAS PSICOSOCIALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z659",
    "nombre_dx": "Z659-PROBLEMAS RELACIONADOS CON CIRCUNSTANCIAS PSICOSOCIALES NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z700",
    "nombre_dx": "Z700-CONSULTA RELACIONADA CON LA ACTITUD SEXUAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z701",
    "nombre_dx": "Z701-CONSULTA RELACIONADA CON LA ORIENTACION Y CONDUCTA SEXUAL DEL PACIENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z702",
    "nombre_dx": "Z702-CONSULTA RELACIONADA CON LA ORIENTACION Y CONDUCTA SEXUAL DE UNA TERCERA PERSONA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z703",
    "nombre_dx": "Z703-CONSULTA RELACIONADA CON PREOCUPACIONES COMBINADAS SOBRE LA ACTITUD, LA CONDUCTA Y LA ORIENTACION SE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z708",
    "nombre_dx": "Z708-OTRAS CONSULTAS SEXUALES ESPECIFICAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z709",
    "nombre_dx": "Z709-CONSULTA SEXUAL, NOESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z710",
    "nombre_dx": "Z710-PERSONA QUE CONSULTA EN NOMBRE DE OTRA PERSONA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z711",
    "nombre_dx": "Z711-PERSONA QUE TEME ESTAR ENFERMA, A QUIEN NO SE HACE DIAGNOSTICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z712",
    "nombre_dx": "Z712-PERSONA QUE CONSULTA PARA LA EXPLICACION DE HALLAZGOS DE INVESTIGACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z713",
    "nombre_dx": "Z713-CONSULTA PARA INSTRUCCIÓN Y VIGILANCIA DE LA DIETA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z714",
    "nombre_dx": "Z714-CONSULTA PARA ASESORIA Y VIGILANCIA POR ABUSO DE ALCOHOL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z715",
    "nombre_dx": "Z715-CONSULTA PARA ASESORIA Y VIGILANCIA POR ABUSO DE DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z716",
    "nombre_dx": "Z716-CONSULTA PARA ASESORIA POR ABUSO DE TABACO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z717",
    "nombre_dx": "Z717-CONSULTA PARA ASESORIA SOBRE EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z718",
    "nombre_dx": "Z718-OTRAS CONSULTAS ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z719",
    "nombre_dx": "Z719-CONSULTA, NO ESPECIFICADA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z720",
    "nombre_dx": "Z720-PROBLEMAS RELACIONADOS CON EL USO DE TABACO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z721",
    "nombre_dx": "Z721-PROBLEMAS RELACIONADOS CON EL USO DE ALCOHOL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z722",
    "nombre_dx": "Z722-PROBLEMAS RELACIONADOS CON EL USO DE DROGAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z723",
    "nombre_dx": "Z723-PROBLEMAS RELACIONADOS CON LA FALTA DE EJERCICIO FISICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z724",
    "nombre_dx": "Z724-PROBLEMAS RELACIONADOS CON LA DIETA Y HABITOS ALIMENTARIOS INAPROPIADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z725",
    "nombre_dx": "Z725-PROBLEMAS RELACIONADOS CON LA CONDUCTA SEXUAL DE ALTO RIESGO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z726",
    "nombre_dx": "Z726-PROBLEMAS RELACIONADOS CON EL JUEGO Y LAS APUESTAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z728",
    "nombre_dx": "Z728-OTROS PROBLEMAS RELACIONADOS CON EL ESTILO DE VIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z729",
    "nombre_dx": "Z729-PROBLEMA NO ESPECIFICADO RELACIONADO CON EL ESTILO DE VIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z730",
    "nombre_dx": "Z730-PROBLEMAS RELACIONADOS CON LA ENFERMEDAD CONSUNTIVA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z731",
    "nombre_dx": "Z731-PROBLEMAS RELACIONADOS CON LA ACENTUACION DE RASGOS DE LA PERSONALIDAD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z732",
    "nombre_dx": "Z732-PROBLEMAS RELACIONADOS CON LA FALTA DE RELAJACION Y DESCANSO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z733",
    "nombre_dx": "Z733-PROBLEMAS RELACIONADOS CON EL ESTRÉS, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z734",
    "nombre_dx": "Z734-PROBLEMAS RELACIONADOS CON HABILIDADES SOCIALES INADECUADAS, NO CLASIFICADAS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z735",
    "nombre_dx": "Z735-PROBLEMAS RELACIONADOS CON EL CONFLICTO DEL ROL SOCIAL, NO CLASIFICADOS EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z736",
    "nombre_dx": "Z736-PROBLEMAS RELACIONADOS CON LA LIMITACION DE LAS ACTIVIDADES DEBIDO A DISCAPACIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z738",
    "nombre_dx": "Z738-OTROS PROBLEMAS RELACIONADOS CON DIFICULTADES CON EL MODO DE VIDA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z739",
    "nombre_dx": "Z739-PROBLEMAS NO ESPECIFICADOS RELACIONADOS CON DIFICULTADES CON EL MODO DE VIDA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z740",
    "nombre_dx": "Z740-Necesidad de asistencia debida a movilidad reducida",
    "sexo": "A"
  },
  {
    "cod_dx": "Z741",
    "nombre_dx": "Z741-PROBLEMAS RELACIONADOS CON LA NECESIDAD DE AYUDA PARA EL CUIDADO PERSONAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z742",
    "nombre_dx": "Z742-PROBLEMAS RELACIONADOS CON LA NECESIDAD DE ASISTENCIA DOMICILIARIA Y QUE NINGUN OTRO MIEMBRO DEL HOG",
    "sexo": "A"
  },
  {
    "cod_dx": "Z743",
    "nombre_dx": "Z743-PROBLEMAS RELACIONADOS CON LA NECESIDAD DE SUPERVISION CONTINUA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z748",
    "nombre_dx": "Z748-OTROS PROBLEMAS RELACIONADOS CON DEPENDENCIA DEL PRESTADOR DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z749",
    "nombre_dx": "Z749-PROBLEMA NO ESPECIFICADO RELACIONADO CON DEPENDENCIA DEL PRESTADOR DE SERVICIOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z750",
    "nombre_dx": "Z750-PROBLEMAS RELACIONADOS CON SERVICIO MEDICO NO DISPONIBLE EN EL DOMICILIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z751",
    "nombre_dx": "Z751-PROBLEMAS RELACIONADOS CON PERSONA ESPERANDO ADMISION EN UNA INSTITUCION APROPIADA EN OTRO LUGAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z752",
    "nombre_dx": "Z752-PROBLEMAS RELACIONADOS CON PERSONA EN OTRO PERIODO DE ESPERA PARA INVESTIGACION Y TRATAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z753",
    "nombre_dx": "Z753-PROBLEMAS RELACIONADOS CON ATENCION DE SALUD NO DISPONIBLE O INACCESIBLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z754",
    "nombre_dx": "Z754-PROBLEMAS RELACIONADOS CON OTROS SERVICIOS ASISTENCIALES NO DISPONIBLES O INACCESIBLES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z755",
    "nombre_dx": "Z755-PROBLEMAS RELACIONADOS CON LA ATENCION DURANTE VACACIONES DE LA FAMILIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z758",
    "nombre_dx": "Z758-OTROS PROBLEMAS RELACIONADOS CON SERVICIOS MEDICOS Y DE SALUD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z759",
    "nombre_dx": "Z759-PROBLEMA NO ESPECIFICADO RELACIONADO CON SERVICIOS MEDICOS Y DE SALUD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z760",
    "nombre_dx": "Z760-CONSULTA PARA REPETICION DE RECETA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z761",
    "nombre_dx": "Z761-CONSULTA PARA ATENCION Y SUPERVISION DE LA SALUD DEL NIÑO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z762",
    "nombre_dx": "Z762-CONSULTA PARA ATENCION Y SUPERVISION DE LA SALUD DE OTROS NIÑOS O LACTANTES SANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z763",
    "nombre_dx": "Z763-PERSONA SANA QUE ACOMPAÑA AL ENFERMO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z764",
    "nombre_dx": "Z764-OTRO HUESPED EN SERVICIOS DE SALUD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z765",
    "nombre_dx": "Z765-PERSONA QUE CONSULTA CON SIMULACION CONSCIENTE [SIMULADOR]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z768",
    "nombre_dx": "Z768-PERSONA EN CONTACTO CON LOS SERVICIOS DE SALUD EN OTRAS CIRCUNSTANCIAS ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z769",
    "nombre_dx": "Z769-PERSONA EN CONTACTO CON LOS SERVICIOS DE SALUD EN CIRCUNSTANCIAS NO ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z800",
    "nombre_dx": "Z800-HISTORIA FAMILIAR DE TUMOR MALIGNO DE ORGANOS DIGESTIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z801",
    "nombre_dx": "Z801-HISTORIA FAMILIAR DE TUMOR MALIGNO DE TRAQUEA, BRONQUIOS Y PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z802",
    "nombre_dx": "Z802-HISTORIA FAMILIAR DE TUMOR MALIGNO DE OTROS ORGANOS RESPIRATORIOS E INTRATORACICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z803",
    "nombre_dx": "Z803-HISTORIA FAMILIAR DE TUMOR MALIGNO DE MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z804",
    "nombre_dx": "Z804-HISTORIA FAMILIAR DE TUMOR MALIGNO DE ORGANOS GENITALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z805",
    "nombre_dx": "Z805-HISTORIA FAMILIAR DE TUMOR MALIGNO DE VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z806",
    "nombre_dx": "Z806-HISTORIA FAMILIAR DE LEUCEMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z807",
    "nombre_dx": "Z807-HISTORIA FAMILIAR DE OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJIDOS RELACIONAD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z808",
    "nombre_dx": "Z808-HISTORIA FAMILIAR DE TUMOR MALIGNO DE OTROS ORGANOS O SISTEMAS ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z809",
    "nombre_dx": "Z809-HISTORIA FAMILIAR DE TUMOR MALIGNO, DE SITIO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z810",
    "nombre_dx": "Z810-HISTORIA FAMILIAR DE RETARDO MENTAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z811",
    "nombre_dx": "Z811-HISTORIA FAMILIAR DE ABUSO DE ALCOHOL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z812",
    "nombre_dx": "Z812-HISTORIA FAMILIAR DE ABUSO DE TABACO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z813",
    "nombre_dx": "Z813-HISTORIA FAMILIAR DE ABUSO DE OTRAS SUSTANCIA PSICOACTIVAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z814",
    "nombre_dx": "Z814-HISTORIA FAMILIAR DE ABUSO DE OTRAS SUSTANCIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z818",
    "nombre_dx": "Z818-HISTORIA FAMILIAR DE OTROS TRASTORNOS MENTALES Y DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z820",
    "nombre_dx": "Z820-HISTORIA FAMILIAR DE EPILEPSIA Y DE OTRAS ENFERMEDADES DEL SISTEMA NERVIOSO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z821",
    "nombre_dx": "Z821-HISTORIA FAMILIAR DE CEGUERA O PERDIDA DE LA VISION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z822",
    "nombre_dx": "Z822-HISTORIA FAMILIAR DE SORDERA O PERDIDA DE LA AUDICION ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z823",
    "nombre_dx": "Z823-HISTORIA FAMILIAR DE APOPLEJIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z824",
    "nombre_dx": "Z824-HISTORIA FAMILIAR DE ENFERMEDAD ISQUEMICA DEL CORAZON Y OTRAS ENFERMEDADES DEL SISTEMA CIRCULATORIO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z825",
    "nombre_dx": "Z825-HISTORIA FAMILIAR DE ASMA Y DE OTRAS ENFERMEDADES CRONICAS DE LAS VIAS RESPIRATORIAS INFERIORES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z826",
    "nombre_dx": "Z826-HISTORIA FAMILIAR DE ARTRITIS Y OTRAS ENFERMEDADES DEL SISTEMA OSTEOMUSCULAR Y TEJIDO CONJUNTIVO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z827",
    "nombre_dx": "Z827-HISTORIA FAMILIAR DE MALFORMACIONES CONGENITAS, DEFORMIDADES Y OTRAS ANOMALIAS CROMOSOMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z828",
    "nombre_dx": "Z828-HISTORIA FAMILIAR DE OTRAS DISCAPACIDADES Y ENFERMEDADES CRONICAS INCAPACITANTES NO CLASIFICADAS EN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z830",
    "nombre_dx": "Z830-HISTORIA FAMILIAR DE INFECCION POR EL VIRUS DE LA INMUNODEFICIENCIA HUMANA [VIH]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z831",
    "nombre_dx": "Z831-HISTORIA FAMILIAR DE OTRAS ENFERMEDADES INFECCIOSAS Y PARASITARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z832",
    "nombre_dx": "Z832-HISTORIA FAMILIAR DE ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS Y DE CIERTOS TRASTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z833",
    "nombre_dx": "Z833-HISTORIA FAMILIAR DE DIABETES MELLITUS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z834",
    "nombre_dx": "Z834-HISTORIA FAMILIAR DE OTRAS ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z835",
    "nombre_dx": "Z835-HISTORIA FAMILIAR DE TRASTORNOS DE LOS OJOS Y DE LOS OIDOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z836",
    "nombre_dx": "Z836-HISTORIA FAMILIAR DE ENFERMEDADES DEL SISTEMA RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z837",
    "nombre_dx": "Z837-HISTORIA FAMILIAR DE ENFERMEDADES DEL SISTEMA DIGESTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z840",
    "nombre_dx": "Z840-HISTORIA FAMILIAR DE ENFERMEDADES DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z841",
    "nombre_dx": "Z841-HISTORIA FAMILIAR DE TRASTORNOS DEL RIÑON Y DEL URETER",
    "sexo": "A"
  },
  {
    "cod_dx": "Z842",
    "nombre_dx": "Z842-HISTORIA FAMILIAR DE OTRAS ENFERMEDADES DEL SISTEMA GENITOURINARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z843",
    "nombre_dx": "Z843-HISTORIA FAMILIAR DE CONSANGUINIDAD ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z848",
    "nombre_dx": "Z848-HISTORIA FAMILIAR DE OTRAS AFECCIONES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z850",
    "nombre_dx": "Z850-HISTORIA PERSONAL DE TUMOR MALIGNO DE ORGANOS DIGESTIVOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z851",
    "nombre_dx": "Z851-HISTORIA PERSONAL DE TUMOR MALIGNO DE TRAQUEA, BRONQUIOS Y PULMON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z852",
    "nombre_dx": "Z852-HISTORIA PERSONAL DE TUMOR MALIGNO DE OTROS ORGANOS RESPIRATORIOS E INTRATORACICOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z853",
    "nombre_dx": "Z853-HISTORIA PERSONAL DE TUMOR MALIGNO DE MAMA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z854",
    "nombre_dx": "Z854-HISTORIA PERSONAL DE TUMOR MALIGNO DE ORGANOS GENITALES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z855",
    "nombre_dx": "Z855-HISTORIA PERSONAL DE TUMOR MALIGNO DE VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z856",
    "nombre_dx": "Z856-HISTORIA PERSONAL DE LEUCEMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z857",
    "nombre_dx": "Z857-HISTORIA PERSONAL DE OTROS TUMORES MALIGNOS DEL TEJIDO LINFOIDE, HEMATOPOYETICO Y TEJIDOS RELACIONAD",
    "sexo": "A"
  },
  {
    "cod_dx": "Z858",
    "nombre_dx": "Z858-HISTORIA PERSONAL DE TUMOR MALIGNO DE OTROS ORGANOS Y SISTEMAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z859",
    "nombre_dx": "Z859-HISTORIA PERSONAL DE TUMOR MALIGNO,DE SITIO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z860",
    "nombre_dx": "Z860-HISTORIA PERSONAL DE OTROS TUMORES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z861",
    "nombre_dx": "Z861-HISTORIA PERSONAL DE ENFERMEDADES INFECCIOSAS Y PARASITARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z862",
    "nombre_dx": "Z862-HISTORIA PERSONAL DE ENFERMEDADES DE LA SANGRE Y DE LOS ORGANOS HEMATOPOYETICOS Y DE CIERTOS TRASTOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z863",
    "nombre_dx": "Z863-HISTORIA PERSONAL DE ENFERMEDADES ENDOCRINAS, NUTRICIONALES Y METABOLICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z864",
    "nombre_dx": "Z864-HISTORIA PERSONAL DE ABUSO DE SUSTANCIAS PSICOACTIVAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z865",
    "nombre_dx": "Z865-HISTORIA PERSONAL DE OTROS TRASTORNOS MENTALES O DEL COMPORTAMIENTO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z866",
    "nombre_dx": "Z866-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA NERVIOSO Y DE LOS ORGANOS DE LOS SENTIDOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z867",
    "nombre_dx": "Z867-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA CIRCULATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z870",
    "nombre_dx": "Z870-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA RESPIRATORIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z871",
    "nombre_dx": "Z871-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA DIGESTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z872",
    "nombre_dx": "Z872-HISTORIA PERSONAL DE ENFERMEDADES DE LA PIEL Y DEL TEJIDO SUBCUTANEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z873",
    "nombre_dx": "Z873-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA OSTEOMUSCULAR Y DEL TEJIDO CONJUNTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z874",
    "nombre_dx": "Z874-HISTORIA PERSONAL DE ENFERMEDADES DEL SISTEMA GENITOURINARIO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z875",
    "nombre_dx": "Z875-HISTORIA PERSONAL DE COMPLICACIONES DEL EMBARAZO, DEL PARTO Y DEL PUERPERIO ",
    "sexo": "F"
  },
  {
    "cod_dx": "Z876",
    "nombre_dx": "Z876-HISTORIA PERSONAL DE CIERTAS AFECCIONES ORIGINADAS EN EL PERIODO PERINATAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z877",
    "nombre_dx": "Z877-HISTORIA PERSONAL DE MALFORMACIONES CONGENITAS, DEFORMIDADES Y ANOMALIAS CROMOSOMICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z878",
    "nombre_dx": "Z878-HISTORIA PERSONAL DE OTRAS AFECCIONES ESPECIFICADAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z880",
    "nombre_dx": "Z880-HISTORIA PERSONAL DE ALERGIA A PENICILINA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z881",
    "nombre_dx": "Z881-HISTORIA PERSONAL DE ALERGIA A OTROS AGENTES ANTIBIOTICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z882",
    "nombre_dx": "Z882-HISTORIA PERSONAL DE ALERGIA A SULFONAMIDAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z883",
    "nombre_dx": "Z883-HISTORIA PERSONAL DE ALERGIA A OTROS AGENTES ANTIINFECCIOSOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z884",
    "nombre_dx": "Z884-HISTORIA PERSONAL DE ALERGIA A AGENTE ANESTESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z885",
    "nombre_dx": "Z885-HISTORIA PERSONAL DE ALERGIA A AGENTE NARCOTICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z886",
    "nombre_dx": "Z886-HISTORIA PERSONAL DE ALERGIA A AGENTE ANALGESICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z887",
    "nombre_dx": "Z887-HISTORIA PERSONAL DE ALERGIA A SUERO O VACUNA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z888",
    "nombre_dx": "Z888-HISTORIA PERSONAL DE ALERGIA A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z889",
    "nombre_dx": "Z889-HISTORIA PERSONAL DE ALERGIA A OTRAS DROGAS, MEDICAMENTOS Y SUSTANCIAS BIOLOGICAS NO ESPECIFICADAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z890",
    "nombre_dx": "Z890-AUSENCIA ADQUIRIDA DE DEDO(S), [INCLUIDO EL PULGAR], UNILATERAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z891",
    "nombre_dx": "Z891-AUSENCIA ADQUIRIDA DE MANO Y MUÑECA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z892",
    "nombre_dx": "Z892-AUSENCIA ADQUIRIDA DE MIEMBRO SUPERIOR POR ARRIBA DE LA MUÑECA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z893",
    "nombre_dx": "Z893-AUSENCIA ADQUIRIDA DE AMBOS MIEMBROS SUPERIORES [CUALQUIER NIVEL] ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z894",
    "nombre_dx": "Z894-AUSENCIA ADQUIRIDA DE PIE Y TOBILLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z895",
    "nombre_dx": "Z895-AUSENCIA ADQUIRIDA DE PIERNA A NIVEL DE O DEBAJO DE LA RODILLA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z896",
    "nombre_dx": "Z896-AUSENCIA ADQUIRIDA DE PIERNA POR ARRIBA DE LA RODILLA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z897",
    "nombre_dx": "Z897-AUSENCIA ADQUIRIDA DE AMBOS MIEMBROS INFERIORES [CUALQUIER NIVEL, EXCEPTO DEDOS DEL PIE SOLAMENTE]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z898",
    "nombre_dx": "Z898-AUSENCIA ADQUIRIDA DE MIEMBROS SUPERIORES E INFERIORES [CUALQUIER NIVEL]",
    "sexo": "A"
  },
  {
    "cod_dx": "Z899",
    "nombre_dx": "Z899-AUSENCIA ADQUIRIDA DE MIEMBROS NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z900",
    "nombre_dx": "Z900-AUSENCIA ADQUIRIDA DE PARTE DE LA CABEZA Y DEL CUELLO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z901",
    "nombre_dx": "Z901-AUSENCIA ADQUIRIDA DE MAMA(S) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z902",
    "nombre_dx": "Z902-AUSENCIA ADQUIRIDA (DE PARTE) DEL PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "Z903",
    "nombre_dx": "Z903-AUSENCIA ADQUIRIDA DE PARTE DEL ESTOMAGO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z904",
    "nombre_dx": "Z904-AUSENCIA ADQUIRIDA DE OTRAS PARTES DEL TUBO DIGESTIVO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z905",
    "nombre_dx": "Z905-AUSENCIA ADQUIRIDA DE RIÑON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z906",
    "nombre_dx": "Z906-AUSENCIA ADQUIRIDA DE OTRAS PARTES DE LAS VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z907",
    "nombre_dx": "Z907-AUSENCIA ADQUIRIDA DE ORGANO(S) GENITAL(ES) ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z908",
    "nombre_dx": "Z908-AUSENCIA ADQUIRIDA DE OTROS ORGANOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z910",
    "nombre_dx": "Z910-HISTORIA PERSONAL DE ALERGIA, NO DEBIDA A DROGAS NI A SUSTANCIAS BIOLOGICAS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z911",
    "nombre_dx": "Z911-HISTORIA PERSONAL DE INCUMPLIMIENTO DEL REGIMEN O TRATAMIENTO MEDICO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z912",
    "nombre_dx": "Z912-HISTORIA PERSONAL DE HIGIENE PERSONAL DEFICIENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z913",
    "nombre_dx": "Z913-HISTORIA PERSONAL DEL CICLO SUEÑO - VIGILIA NO SALUDABLE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z914",
    "nombre_dx": "Z914-HISTORIA PERSONAL DE TRAUMA PSICOLOGICO, NO CLASIFICADO EN OTRA PARTE ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z915",
    "nombre_dx": "Z915-HISTORIA PERSONAL DE LESION AUTOINFLIGIDA INTENCIONALMENTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z916",
    "nombre_dx": "Z916-HISTORIA PERSONAL DE OTRO TRAUMA FISICO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z917",
    "nombre_dx": "Z917-Historia personal de la mutilación genital femenina ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z918",
    "nombre_dx": "Z918-HISTORIA PERSONAL DE OTROS FACTORES DE RIESGO, NO CLASIFICADOS EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z920",
    "nombre_dx": "Z920-HISTORIA PERSONAL DE ANTICONCEPCIÓN ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z921",
    "nombre_dx": "Z921-HISTORIA PERSONAL DE USO (PRESENTE) DE ANTICOAGULANTES POR LARGO TIEMPO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z922",
    "nombre_dx": "Z922-HISTORIA PERSONAL DE USO (PRESENTE) DE OTROS MEDICAMENTOS POR LARGO TIEMPO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z923",
    "nombre_dx": "Z923-HISTORIA PERSONAL DE IRRADIACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z924",
    "nombre_dx": "Z924-HISTORIA PERSONAL DE CIRUGIA MAYOR, NO CLASIFICADA EN OTRA PARTE",
    "sexo": "A"
  },
  {
    "cod_dx": "Z925",
    "nombre_dx": "Z925-HISTORIA PERSONAL DE MEDIDAS DE REHABILITACION",
    "sexo": "A"
  },
  {
    "cod_dx": "Z928",
    "nombre_dx": "Z928-HISTORIA PERSONAL DE OTROS TRATAMIENTOS MEDICOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z929",
    "nombre_dx": "Z929-HISTORIA PERSONAL DE TRATAMIENTO MEDICO NO ESPECIFICADO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z930",
    "nombre_dx": "Z930-TRAQUEOSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z931",
    "nombre_dx": "Z931-GASTROSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z932",
    "nombre_dx": "Z932-ILEOSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z933",
    "nombre_dx": "Z933-COLOSTOMIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z934",
    "nombre_dx": "Z934-OTROS ORIFICIOS ARTIFICIALES DEL TUBO GASTROINTESTINAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z935",
    "nombre_dx": "Z935-CISTOSTOMIA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z936",
    "nombre_dx": "Z936-OTROS ORIFICIOS ARTIFICIALES DE LAS VIAS URINARIAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z938",
    "nombre_dx": "Z938-OTRAS ABERTURAS ARTIFICIALES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z939",
    "nombre_dx": "Z939-ABERTURA ARTIFICIAL, NO ESPECIFICADA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z940",
    "nombre_dx": "Z940-TRASPLANTE DE RIÑON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z941",
    "nombre_dx": "Z941-TRASPLANTE DE CORAZON ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z942",
    "nombre_dx": "Z942-TRASPLANTE DE PULMON",
    "sexo": "A"
  },
  {
    "cod_dx": "Z943",
    "nombre_dx": "Z943-TRASPLANTE DE CORAZON Y PULMONES",
    "sexo": "A"
  },
  {
    "cod_dx": "Z944",
    "nombre_dx": "Z944-TRASPLANTE DE HIGADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z945",
    "nombre_dx": "Z945-TRASPLANTE DE PIEL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z946",
    "nombre_dx": "Z946-TRASPLANTE DE HUESO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z947",
    "nombre_dx": "Z947-TRASPLANTE DE CORNEA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z948",
    "nombre_dx": "Z948-OTROS ORGANOS Y TEJIDOS TRASPLANTADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z949",
    "nombre_dx": "Z949-ORGANO Y TEJIDO TRASPLANTADO NO ESPECIFICADO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z950",
    "nombre_dx": "Z950-Presencia de dispositivos cardíacos electrónicos",
    "sexo": "A"
  },
  {
    "cod_dx": "Z951",
    "nombre_dx": "Z951-PRESENCIA DE DERIVACION AORTOCORONARIA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z952",
    "nombre_dx": "Z952-PRESENCIA DE VALVULA CARDIACA PROTESICA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z953",
    "nombre_dx": "Z953-PRESENCIA DE VALVULA CARDIACA XENOGENICA",
    "sexo": "A"
  },
  {
    "cod_dx": "Z954",
    "nombre_dx": "Z954-PRESENCIA DE OTROS REEMPLAZOS DE VALVULA CARDIACA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z955",
    "nombre_dx": "Z955-PRESENCIA DE ANGIOPLASTIA, INJERTOS Y PROTESIS CARDIOVASCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z958",
    "nombre_dx": "Z958-PRESENCIA DE OTROS INJERTOS Y PROTESIS CARDIOVASCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z959",
    "nombre_dx": "Z959-PRESENCIA DE INJERTOS E IMPLANTES CARDIOVASCULARES NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z960",
    "nombre_dx": "Z960-PRESENCIA DE IMPLANTE UROGENITAL",
    "sexo": "A"
  },
  {
    "cod_dx": "Z961",
    "nombre_dx": "Z961-PRESENCIA DE LENTES INTRAOCULARES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z962",
    "nombre_dx": "Z962-PRESENCIA DE IMPLANTES OTICOS Y AUDITIVOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z963",
    "nombre_dx": "Z963-PRESENCIA DE LARINGE ARTIFICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z964",
    "nombre_dx": "Z964-PRESENCIA DE IMPLANTES ENDOCRINOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z965",
    "nombre_dx": "Z965-PRESENCIA DE IMPLANTES DE RAIZ DE DIENTE Y DE MANDIBULA ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z966",
    "nombre_dx": "Z966-PRESENCIA DE IMPLANTE ORTOPEDICO ARTICULAR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z967",
    "nombre_dx": "Z967-PRESENCIA DE OTROS IMPLANTES DE TENDONES Y HUESOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z968",
    "nombre_dx": "Z968-PRESENCIA DE OTROS IMPLANTES FUNCIONALES ESPECIFICADOS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z969",
    "nombre_dx": "Z969-PRESENCIA DE IMPLANTES FUNCIONALES NO ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z970",
    "nombre_dx": "Z970-PRESENCIA DE OJO ARTIFICIAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z971",
    "nombre_dx": "Z971-PRESENCIA DE MIEMBRO ARTIFICIAL (COMPLETO) (PARCIAL)",
    "sexo": "A"
  },
  {
    "cod_dx": "Z972",
    "nombre_dx": "Z972-PRESENCIA DE DISPOSITIVO PROTESICO DENTAL (COMPLETO) (PARCIAL)",
    "sexo": "A"
  },
  {
    "cod_dx": "Z973",
    "nombre_dx": "Z973-PRESENCIA DE ANTEOJOS Y LENTES DE CONTACTO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z974",
    "nombre_dx": "Z974-PRESENCIA DE AUDIFONO EXTERNO ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z975",
    "nombre_dx": "Z975-PRESENCIA DE DISPOSITIVO ANTICONCEPTIVO (INTRAUTERINO)",
    "sexo": "F"
  },
  {
    "cod_dx": "Z978",
    "nombre_dx": "Z978-PRESENCIA DE OTROS DISPOSITIVOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z980",
    "nombre_dx": "Z980-ESTADO DE DERIVACION INTESTINAL O ANASTOMOSIS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z981",
    "nombre_dx": "Z981-ESTADO DE ARTRODESIS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z982",
    "nombre_dx": "Z982-PRESENCIA DE DISPOSITIVO PARA DRENAJE DE LIQUIDO CEFALORRAQUIDEO",
    "sexo": "A"
  },
  {
    "cod_dx": "Z988",
    "nombre_dx": "Z988-OTROS ESTADOS POSTQUIRURGICOS ESPECIFICADOS ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z990",
    "nombre_dx": "Z990-DEPENDENCIA DE ASPIRADOR",
    "sexo": "A"
  },
  {
    "cod_dx": "Z991",
    "nombre_dx": "Z991-DEPENDENCIA DE RESPIRADOR ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z992",
    "nombre_dx": "Z992-DEPENDENCIA DE DIALISIS RENAL ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z993",
    "nombre_dx": "Z993-DEPENDENCIA DE SILLA DE RUEDAS",
    "sexo": "A"
  },
  {
    "cod_dx": "Z994",
    "nombre_dx": "Z994-Dependencia de corazón artificial",
    "sexo": "A"
  },
  {
    "cod_dx": "Z998",
    "nombre_dx": "Z998-DEPENDENCIA DE OTRAS MAQUINAS Y DISPOSITIVOS CAPACITANTES ",
    "sexo": "A"
  },
  {
    "cod_dx": "Z999",
    "nombre_dx": "Z999-DEPENDENCIA DE MAQUINA Y DISPOSITIVO CAPACITANTE, NO ESPECIFICADA ",
    "sexo": "A"
  }
]




class Agenda_profesional_2 extends Component {

  constructor()
    {
     super()
      this.state={
        Horario: [], 
        Parametro:[],
        Agendas: [],         
        Pager_Agendas: [],
        pager_infoagendas:'', 
        Agendas_inactivas: [],         
        Pager_Agendas_inactivas: [],
        pager_infoagendas_inactivas:'', 
        Agendas_vencidas: [],         
        Pager_Agendas_vencidas: [],
        pager_infoagendas_vencidas:'',
        Agendas_anulada: [],         
        Pager_Agendas_anulada: [],
        Diagnotico_Multiple:[],
        Diagnotico_Multiple_edit:[],
        Diagnostico_hc:[],
        pager_infoagendas_anulada:'',
        loading: false,
        Sedes:[] ,
        profesionales: [],
        IntervaloAgenda: [],
        Especialidades:[],
        Servicios: [],
        Tipo_anexos:[],
        Historia:[],
        Historial_anexos:[],
        loading_button: true,
        active_button: true,
        loading_button_cancelacita: true,
        active_button_cancelacita: true,
        active: true,
        loading_button_intervalo: true,
        active_button_intervalo: true,
        loading_button_eliminar: true,
        active_button_eliminar: true,
        loading_btnaddanexo: true,
        active_btnaddanexo: true,
        loading_btnhisanexo: true,
        active_btnhisanexo: true,
        loading_button_eliminaanexo:true,
        active_button_eliminaanexo:true,
        active_check:true,
        form:{ 
          nom_agenda: '',         
          fecha_ini:'',
          fecha_fin:'',
          id_agenda_edit:'',
          nom_agenda_edit:'',
          fechaini_edit:new Date,
          fechafin_edit:new Date,
          inicio:'',
          fin:'',
          intervalo:'',
          espe:'0',
          buscar_agendas:'',
          buscar_agendas_inactiva:'',

          id_cita:'',
          id_pacie_soli:'',
          tipoid_pacien_hc:'',
          id_pacien_hc:'',
          nom1_pacien:'',
          nom2_pacien:'',
          apell1_pacien:'',
          apell2_pacien:'',
          obser:'',
          fecha_cita:'',
              
          espe_soli:'',
              
          fecha_naci:'',
          edad_pcte:'',
          genero_pcte:'',
          dir_pcte:'',
          tel_pcte:'',
          municipio_pcte:'',
          departamento_pct: '',
          responsable_pcte:'',
          telresponsable_pcte:'',
          parentescoresp_pcte:'',
          eps_pcte:'',
          regimen_pcte:'',
          email_pcte:'', 
          
          idconsulta:'',
          id_paciente:'',
          nom_pctehc:'',
          eps:'',

          acompanante:'',
          tel_acompanante:'',
          motivo_consulta:'',
          enfermada_actual:'',
          antecedentes_rel:'',
          revision_sistema:'',
          examen_fis:'',
          analisis:'',
          conducta:'',
          formula_med:'',
          orden_med:'',

          nombre_anexo:'',
          descripcion_anexo:'',
          num_file:'Ningún archivo seleccionado'
          

          }
      }
    }

    Selectdrop(){
      if(id_profe=='0' && this.state.form.fecha_ini!=''){
        $("#api_profesional").val($('#api_profesional > option:first').val()); 
      }
    }

    handlerSelectdrop(){

      $("#nom_agenda").val("");
      $("#fecha_ini").val("");
      $("#fecha_fin").val("");
      $("#profesionales").val($('#profesionales > option:first').val());
      $("#sede").val($('#sede > option:first').val());
      $("#espe").val($('#espe > option:first').val());
      $("#div_agenda1").find("*").prop('disabled', false);
      $("#div_agenda2").find("*").prop('disabled', false);
      $("#div_agenda3").find("*").prop('disabled', false);

      id_profe='0';
      id_especialidad='0';
      id_sede='0';

      this.setState({Especialidades: []})
     
    }

      handleModalrespuestacitadrop()
        {
          $('#modal-consulta').on('show.bs.modal', function (event) {
            $("#modal-consulta input").val("");
            $("#modal-consulta textarea").val("");
            $("#modal-consulta select").val("Seleccione...");
            
        });

        
          this.setState({
            form:{
            nombre_anexo:'',
            descripcion_anexo:'',
          }
        })

        this.setState({num_file:'Ningún archivo seleccionado'})
    
          
          file_base64_doc="";
          id_tipoanexo="0";

          this.getDiagnoticos();

      }


      handleModaldetallehcdrop()
        {
          $('#modal-imprimirconsulta').on('show.bs.modal', function (event) {
            $("#modal-imprimirconsulta input").val("");
            $("#modal-imprimirconsulta textarea").val("");
            $("#modal-imprimirconsulta select").val("Seleccione...");
            
        });

        
        this.setState({
            form:{
            nombre_anexo:'',
            descripcion_anexo:'',
            id_paciente:''
          }
        })

        this.setState({num_file:'Ningún archivo seleccionado'})
    
          
          file_base64_doc="";
          id_tipoanexo="0";

          this.getDiagnoticos();

      }
      

    handlerdropIntervalo(){


      $("#inicio").val("");
      $("#fin").val("");
      $("#dia_agenda").val($('#dia_agenda > option:first').val());
      $("#tipo_servicio").val($('#tipo_servicio > option:first').val());
      $("#intervalo").val("");
      

      dia_intervalo='null';
      id_tipo_servi=0;
     
     
     
    }

   
    handleChange=async e=>{
      await this.setState({
         form:{
              ...this.state.form,
              [e.target.name]: e.target.value
              }
         })
         console.log(this.state.form);    
         this.Selectdrop();     
    }

    Campo_numerico(){
      $(".camponum").keypress(function(tecla)
      {
        if(tecla.charCode<48 || tecla.charCode>57){
         
          return false;

        }
      })
    }

    componentDidMount(){

      $('[data-toggle="tooltip"]').tooltip()

      $('#filtrar_agenda').hide(); 
      $('#select_modalidad_filtro').hide(); 
      $('#select_tipoconsulta_filtro').hide(); 
      $('#texto_filtro').hide();

      $('#filtrar_atendidos').hide(); 
      $('#select_modalidad_filtro_atendidos').hide(); 
      $('#select_tipoconsulta_filtro_atendidos').hide(); 
      $('#texto_id_pcte').hide();

      this.CargarAgendas(); 
      this.getDiagnoticos();    
      this.Cargar_Tipo_Anexo();

    }


    empty_page_hide(){
      $('#tabla1').hide();     
      $('#empty_page').hide();
      $('#text_page').hide();

      $('#tabla2').hide();     
      $('#empty_page2').hide();
      $('#text_page2').hide();

      $('#tabla3').hide();     
      $('#empty_page3').hide();
      $('#text_page3').hide();

      $('#tabla4').hide();     
      $('#empty_page4').hide();
      $('#text_page4').hide();
      
    }

    modal_informacionpcte(){
         
          $('#modal-infopcte').modal('show');
         
    }

    Traerdato_Cancelar_cita(agenda){
          id_cita_cancela  = agenda.id;
    
          $('#modal-cancela_cita').modal('show'); // <- to show modal elimiinar intervalo
    
    }

    handleModal_realizahc()
    {      
      $('#modal-consulta').modal('show'); // <- to show modal editar contrato       
    }

    handleModalconsultashow()
    {      
      $('#modal-imprimirconsulta').modal('show'); // <- to show modal editar contrato       
    }

    handleModalhistorialanexo()
    {     
      $('#modal-historial_anexo').modal('show'); // <- to show modal historial de citas 
      
    }

    Traerdato_historial_anexo(historial){
          id_anexo_elimina  = historial.id;

          if (historial.profesionalId == id_med_anexo){

             $('#modal-elimina_anexo').modal('show'); // <- to show modal elimiinar intervalo

          }else{
            
                store.addNotification({
                  title: 'Atención',
                  message: "No tiene permiso para eliminar el anexo",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })

          }
    
          
    
    }

   

    seleccionarconsulta_agendahc=(agenda)=>{

      this.Crear_consulta(agenda.id);

          this.setState({
              form:{
              id_cita:agenda.id,
              idconsulta:id_consulta, 
              id_paciente:agenda.patient.user.typeId +'-'+ agenda.patient.user.identification,
              nom_paciente: agenda.patient.user.name1 ? agenda.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: agenda.patient.user.name2 ? agenda.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: agenda.patient.user.lastname1 ? agenda.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: agenda.patient.user.lastname2 ? agenda.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:agenda.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),

              acompanante:this.state.form.acompanante,
              tel_acompanante:this.state.form.tel_acompanante,
              motivo_consulta:this.state.form.motivo_consulta,
              enfermada_actual:this.state.form.enfermada_actual,
              antecedentes_rel:this.state.form.antecedentes_rel,
              revision_sistema:this.state.form.revision_sistema,
              examen_fis:this.state.form.examen_fis,
              analisis:this.state.form.analisis,
              conducta:this.state.form.conducta,
              formula_med:this.state.form.formula_med,
              orden_med:this.state.form.orden_med

              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    seleccionarconsulta=(Agendas_inactivas)=>{

          id_consulta=Agendas_inactivas.id
          this.setState({ Historia:Agendas_inactivas.consultationData })
          this.setState({Diagnostico_hc: Agendas_inactivas.diagnostic})
          //this.saverecurso(id_consulta);

          this.setState({
              form:{
              idconsulta:Agendas_inactivas.id, 
              id_paciente:Agendas_inactivas.patient.user.typeId +'-'+ Agendas_inactivas.patient.user.identification,
              nom_paciente: Agendas_inactivas.patient.user.name1 ? Agendas_inactivas.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: Agendas_inactivas.patient.user.name2 ? Agendas_inactivas.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: Agendas_inactivas.patient.user.lastname1 ? Agendas_inactivas.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: Agendas_inactivas.patient.user.lastname2 ? Agendas_inactivas.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:Agendas_inactivas.appointment.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    seleccionarconsulta_hc=(Agendas_inactivas)=>{

          id_consulta=Agendas_inactivas.id
          

          this.setState({
              form:{
              idconsulta:Agendas_inactivas.id, 
              id_paciente:Agendas_inactivas.patient.user.typeId +'-'+ Agendas_inactivas.patient.user.identification,
              nom_paciente: Agendas_inactivas.patient.user.name1 ? Agendas_inactivas.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: Agendas_inactivas.patient.user.name2 ? Agendas_inactivas.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: Agendas_inactivas.patient.user.lastname1 ? Agendas_inactivas.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: Agendas_inactivas.patient.user.lastname2 ? Agendas_inactivas.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:Agendas_inactivas.appointment.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    Get_id_tipoanexo = (ta) =>{
    //this.setState({tipoid:id.target.value})
    console.log(ta.target.value)
    id_tipoanexo=(ta.target.value) 

    nombre_tipoanexo=this.state.Tipo_anexos.filter(item => item.id == id_tipoanexo)[0].name
    //alert(nombre_tipoanexo)    
    
    }

    GetDoc= (i) =>{  

    avatar=i.target.files[0]
    let reader = new FileReader();
    reader.readAsDataURL(avatar);
    reader.onloadend =  () => {
      
      file_base64_doc = (reader.result).split(',')[1];
      this.setState({num_file:"Ha seleccionado "+(i.target.files.length)+" archivo(s)"})
      //num_file="Ha seleccionado "+(i.target.files.length)+" archivo(s)"
    
      //alert(base64data)
      //console.log(file_base64_doc)   
      //console.log(tipo_file_base64_doc) 
     
    } 

    //this.Sweetaler_subir_documento();
    //files_view=URL.createObjectURL(i.target.files[0]);
    
    //$('#modal_documento').modal('show');
    //alert(avatar)
  }

    descargar_consulta=async()=>{        
    
            this.setState({ loading_button: this.state.loading_button = false })
            this.setState({ active_button: this.state.active_button = false })
            //$('#modal-loader').modal('show') // <- to show modal descarga video
            //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
            await axios.get(ApiURL+"/api/Consultations/PrintConsultation/"+id_consulta,{            
              
              responseType:'blob'
    
            })  
        
            .then(response=>{
              
              fileDownload(response.data,'Consultation-'+id_consulta+'.pdf')
              const blob = new Blob([response.data], { type: 'application/pdf' })
              const objectUrl = window.URL.createObjectURL(blob)
              window.open(objectUrl)
              
              store.addNotification({
                title: 'Mensaje',
                message: "El documento ha sido descargado",
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
    
              this.setState({ loading_button: this.state.loading_button = true })
              this.setState({ active_button: this.state.active_button = true })
              //this.handleModalarecurdodrop();   
              
            })
            .catch((error)=>{
    
              if (error.response) {
    
                console.log(error.response);
                mensaje=error.message;                    
    
                store.addNotification({
                  title: 'Atención',
                  message: "No se encontró información",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })            
                
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
                //this.handleModalrecursodrop(); 
      
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
              }
              //console.log(error.config);            
              
          })    
        
    }
    
    
    descargar_formula=async()=>{        
    
          this.setState({ loading_button: this.state.loading_button = false })
          this.setState({ active_button: this.state.active_button = false })
          //$('#modal-loader').modal('show') // <- to show modal descarga video
          //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
          await axios.get(ApiURL+"/api/Consultations/PrintMedicalPrescription/"+id_consulta,{            
            
            responseType:'blob'
    
          })  
      
          .then(response=>{
            
            fileDownload(response.data,'Formula-'+id_consulta+'.pdf')
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const objectUrl = window.URL.createObjectURL(blob)
            window.open(objectUrl)
             
            
            store.addNotification({
              title: 'Mensaje',
              message: "El documento ha sido descargado",
              type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            }) 
            
            this.setState({ loading_button: this.state.loading_button = true })
            this.setState({ active_button: this.state.active_button = true })
            //$('#modal-loader').modal('hide');
            
          })
          .catch((error)=>{
    
            if (error.response) {
    
            console.log(error.response);
            mensaje=error.message;                    
    
            store.addNotification({
              title: 'Atención',
              message: "No se encontró información",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })            
            
            this.setState({ loading_button: this.state.loading_button = true })
            this.setState({ active_button: this.state.active_button = true })
            //this.handleModalrecursodrop(); 
    
          } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
          } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
          }
          //console.log(error.config);                       
            
        })  
      
          }
    
    
    descargar_orden=async()=>{        
    
        this.setState({ loading_button: this.state.loading_button = false })
        this.setState({ active_button: this.state.active_button = false })
        //$('#modal-loader').modal('show') // <- to show modal descarga video
        //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
        await axios.get(ApiURL+"/api/Consultations/PrintMedicalOrder/"+id_consulta,{            
          
          responseType:'blob'
    
        })  
    
        .then(response=>{
          
          fileDownload(response.data,'Orden-'+id_consulta+'.pdf')
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const objectUrl = window.URL.createObjectURL(blob)
          window.open(objectUrl)
     
          
          store.addNotification({
            title: 'Mensaje',
            message: "El documento ha sido descargado",
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })   
          
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
          //$('#modal-loader').modal('hide');
          
        })
        .catch((error)=>{
    
          if (error.response) {
    
          console.log(error.response);
          mensaje=error.message;                    
    
          store.addNotification({
            title: 'Atención',
            message: "No se encontró información",
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })            
          
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
    
        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
        }
        //console.log(error.config);                       
          
      })
    
    
    }


    async getDiagnoticos(){
            const res = await axios.get('https://medicall-api-test.azurewebsites.net/api/TypeServices')
            const data = res.data
        
            /*const options = data.map(d => ({
              "value" : d.id,
              "label" : d.name
        
            }))*/

            
            const options = diagnosticos_hc.map(d => ({
              "value" : d.cod_dx,
              "label" : d.nombre_dx
        
            }))
        
            this.setState({Diagnotico_Multiple: options})
        
    }

    async getDiagnoticos_edit(dato){
           
        
            /*const options = data.map(d => ({
              "value" : d.id,
              "label" : d.name
        
            }))*/

            
            const options = dato.map(d => ({
              "value" : d.id,
              "label" : d.nombre_dx
        
            }))
        
            this.setState({Diagnotico_Multiple_edit: options})
        
    }


    Gettipo_filtro = (tf) =>{
          //this.setState({tipoid:id.target.value})
          $("#modalidad_filtro").val($('#sede_filtro > option:first').val());
          $("#tipoconsulta_filtro").val($('#tipoconsulta_filtro > option:first').val());      
          $("#buscar_solicitadas").val("");  
          console.log(tf.target.value)
          tipo_filtro=(tf.target.value)
          
          if(tipo_filtro=="1"){
            $('#select_modalidad_filtro').show(); 
            $('#select_tipoconsulta_filtro').hide(); 
            $('#texto_filtro').hide();
            
            $('#texto_filtro').hide();
          }
            if(tipo_filtro=="2"){
              $('#texto_filtro').hide();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').show(); 
              
            }
            if(tipo_filtro=="3"){
              $('#texto_filtro').show();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            }
            
            if(tipo_filtro=="10"){
              $('#texto_filtro').hide();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            } 
        }
        

    Gettipo_filtro_atendidos = (fa) =>{
          //this.setState({tipoid:id.target.value})
          $("#modalidad_filtro_atendidos").val($('#sede_filtro > option:first').val());
          $("#modalidad_filtro_atendidos").val($('#modalidad_filtro_atendidos > option:first').val());      
          $("#modalidad_filtro_atendidos").val("");  
          console.log(fa.target.value)
          tipo_filtro_atendidos=(fa.target.value)
          
          if(tipo_filtro_atendidos=="1"){
            $('#select_modalidad_filtro_atendidos').show(); 
            $('#select_tipoconsulta_filtro_atendidos').hide(); 
            $('#texto_id_pcte').hide();
            
          
          }
            if(tipo_filtro_atendidos=="2"){
              $('#texto_id_pcte').hide();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').show(); 
              
            }
            if(tipo_filtro_atendidos=="3"){
              $('#texto_id_pcte').show();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            }
            
            if(tipo_filtro_atendidos=="10"){
              $('#texto_id_pcte').hide();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            } 
        }

    Buscar_atenciones_idpcte = (bs) =>{
      console.log(bs.target.value)
      var buscar_atenciones_idpcte=(bs.target.value)
      //alert(buscar_atenciones_idpcte)
      this.searchDataagenda(buscar_atenciones_idpcte)
     
    }


    seleccionar_cita=(agenda)=>{
          var citaid=agenda.id
        
          this.setState({
            form:{
              id_cita:agenda.id,
              id_pacie_soli:agenda.patient.user.typeId +'-'+ agenda.patient.user.identification,
              tipoid_pacien_hc:agenda.patient.user.typeId,
              id_pacien_hc:agenda.patient.user.identification,
              nom1_pacien:agenda.patient.user.name1 ? agenda.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_pacien:agenda.patient.user.name2 ? agenda.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' ,
              apell1_pacien:agenda.patient.user.lastname1 ? agenda.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              apell2_pacien:agenda.patient.user.lastname2 ? agenda.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              obser:'',
              fecha_cita:moment(agenda.fecha).format("DD/MM/YYYY HH:mm"),
              
              espe_soli:agenda.specialty.name.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
              fecha_naci:moment(agenda.patient.user.birthday).format("DD/MM/YYYY"),
              edad_pcte:moment(agenda.patient.user.birthday).toNow(true),
              genero_pcte:agenda.patient.user.gender,
              dir_pcte:agenda.patient.user.address,
              tel_pcte:agenda.patient.user.phone,
              municipio_pcte:agenda.patient.user.municipality.nombre ? agenda.patient.user.municipality.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              departamento_pct: agenda.patient.user.department.nombre ? agenda.patient.user.department.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              responsable_pcte:agenda.patient.user.personInCharge,
              telresponsable_pcte:agenda.patient.user.phonePerson,
              parentescoresp_pcte:agenda.patient.user.relationshipPerson,
              eps_pcte:agenda.contract.entity.razonSocial,
              regimen_pcte:agenda.patient.regimen.nombre ? agenda.patient.regimen.nombre : '',
              email_pcte:agenda.patient.user.email
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(cita_proce.fecha);
    
          
          axios.get(ApiURL+"/api/Citas/GetAppointment/"+citaid)
          .then((response) => {
            console.log(response);
            this.setState({Autorizacion: response.data.authorizations})
              
          })
          .catch((error) => {
            console.log(error);
          })
         
        }


    seleccionar_cita2=(agenda_inactiva)=>{
          //var citaid=agenda.id
        
          this.setState({
            form:{
              id_cita:agenda_inactiva.appointmentId,
              id_pacie_soli:agenda_inactiva.patient.user.typeId +'-'+ agenda_inactiva.patient.user.identification,
              tipoid_pacien_hc:agenda_inactiva.patient.user.typeId,
              id_pacien_hc:agenda_inactiva.patient.user.identification,
              nom1_pacien:agenda_inactiva.patient.user.name1 ? agenda_inactiva.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_pacien:agenda_inactiva.patient.user.name2 ? agenda_inactiva.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' ,
              apell1_pacien:agenda_inactiva.patient.user.lastname1 ? agenda_inactiva.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              apell2_pacien:agenda_inactiva.patient.user.lastname2 ? agenda_inactiva.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              obser:'',
              fecha_cita:moment(agenda_inactiva.appointment.fecha).format("DD/MM/YYYY HH:mm"),
              
              //espe_soli:agenda_inactiva.specialty.name.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
              fecha_naci:moment(agenda_inactiva.patient.user.birthday).format("DD/MM/YYYY"),
              edad_pcte:moment(agenda_inactiva.patient.user.birthday).toNow(true),
              genero_pcte:agenda_inactiva.patient.user.gender,
              dir_pcte:agenda_inactiva.patient.user.address,
              tel_pcte:agenda_inactiva.patient.user.phone,
              //municipio_pcte:agenda_inactiva.patient.user.municipality.nombre ? agenda_inactiva.patient.user.municipality.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              //departamento_pct: agenda_inactiva.patient.user.department.nombre ? agenda_inactiva.patient.user.department.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              responsable_pcte:agenda_inactiva.patient.user.personInCharge,
              telresponsable_pcte:agenda_inactiva.patient.user.phonePerson,
              parentescoresp_pcte:agenda_inactiva.patient.user.relationshipPerson,
              eps_pcte:agenda_inactiva.appointment.contract.entity.razonSocial,
              regimen_pcte:agenda_inactiva.patient.regimen.nombre ? agenda_inactiva.patient.regimen.nombre : '',
              email_pcte:agenda_inactiva.patient.user.email


              
            }
          })
          var  dato  = agenda_inactiva.diagnostic;
          //alert(cita_proce.fecha);
          
          //this.getDiagnoticos_edit(dato);
          
         
        }



    Cargar_sedes(){    
    
      axios.get(ApiURL+"/api/Sedes/ListAll")
      .then((response) => {
        console.log(response);
        this.setState({Sedes: response.data})

        if(this.state.Sedes.length==0){

          $('#modal-verifisede').modal('show');
       
        }else{

          
        }


      })
      .catch((error) => {
        console.log(error);
      })
    }


    CargarAgendas(){  

      this.empty_page_hide();

      this.setState({ loading: this.state.loading = false })
      axios.get(ApiURL+"/api/Citas/GetAppointmentsProfessional")
      .then((response) => {

        console.log(response);
        this.setState({Agendas: response.data})
        

        if(this.state.Agendas.length==0){

          $('#tabla1').hide();
          $('#empty_page').show();
          $('#text_page').show();   
          
        }else{

          $('#tabla1').show();
          $('#empty_page').hide();
          $('#text_page').hide(); 
          
        }

        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    }


    CargarAgendas_busquedapcte(buscar_atenciones_idpcte){  

      //this.empty_page_hide();

      this.setState({ loading: this.state.loading = false })
      axios.get(ApiURL+"/api/Citas/GetAppointmentsProfessional")
      .then((response) => {

        console.log(response);
        this.setState({Agendas: response.data.filter(item => item.patient.user.identification.includes(buscar_atenciones_idpcte) )})
        

        if(this.state.Agendas.length==0){

          $('#tabla1').hide();
          $('#empty_page').show();
          $('#text_page').show();   
          
        }else{

          $('#tabla1').show();
          $('#empty_page').hide();
          $('#text_page').hide(); 
          
        }

        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    }


    Cargar_Tipo_Anexo(){    
        
          axios.get(ApiURL+"/api/Attach/GetTypeAttachs")
          .then((response) => {
            console.log(response.data);
            this.setState({Tipo_anexos: response.data})
            //this.setState({Tipo_anexos: response.data.filter(item => item.id !== 1)})
          })
          .catch((error) => {
            console.log(error);
          })
    }


    Subir_Anexo=async()=>{     
    
          var idpaciente =this.state.form.id_paciente.slice(3);     
          var fecha_anexo=moment().format('DD-MM-YYYY')
          //alert(fecha_anexo)

          if(nom_med_anexo.length==0 ||id_med_anexo.length==0 || file_base64_doc=="" || id_tipoanexo=="0" ){
    
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos para subir el anexo",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
    
          }else{
            this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = false })
            this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = false })
            await axios.post(ApiURL+"/api/Attach/Create",
      
              {
    
              typeAttachId: id_tipoanexo,
              patientId: idpaciente,
              patientName: this.state.form.nom_paciente +" "+ this.state.form.nom2_paciente +" "+ this.state.form.apell1_paciente +" "+ this.state.form.apell2_paciente ,
              institutionId: 1,
              fileBase64:file_base64_doc,
              name: nombre_tipoanexo +" "+ fecha_anexo,
              description: this.state.form.descripcion_anexo,
              profesionalId: id_med_anexo,
              profesionalName: nom_med_anexo
              
              })  
            .then(response=>{
              console.log(response.data)
              var  mensaje  = response.data.message;
              //alert(mensaje);
              //const [text, setText] = LocalStorage(text, '')
              //setText(dato);
                     
              //window.location.href="/home";
            store.addNotification({
                title: 'Muy bien',
                message: mensaje,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                duration: 10000,
                showIcon:true
                }
              })
    
              this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
              this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
              //this.setState({ active: this.state.active = false })
    
              this.setState({
                form:{
                nombre_anexo:'',
                descripcion_anexo:'',
                id_paciente:this.state.form.id_paciente
                  }
                })

              this.setState({num_file:'Ningún archivo seleccionado'})
          
                
                file_base64_doc="";
                id_tipoanexo="0";
  
              
            })
            .catch(error=>{
             
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
              this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
              this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
    
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
    
                this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = false })
                this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = false })
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
                this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
                this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
            }
            //console.log(error.config);
          
            })    
          }     
      }


      Historial_Anexos=async()=>{

        var idpaciente =this.state.form.id_paciente.slice(3);
        //alert(idpaciente)
      
            this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = false })
            this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = false })
      
            axios.get(ApiURL+"/api/Attach/GetAttachsPatient/"+idpaciente+"?numeroPagina=1")

              .then((response) => {
                console.log(response.data)      
                
                this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
      
                this.setState({Historial_anexos: response.data.data})   
                
                if(this.state.Historial_anexos.length==0){
      
                  store.addNotification({
                    title: 'Atención',
                    message: 'El paciente no tiene anexos relacionados',
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                }else{
      
                  this.handleModalhistorialanexo();
                  //alert("Con anexos")
      
                }
               
                
                
              })
              .catch(error=>{
                
                if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  //console.log(error.response.data.message);
                  //console.log(error.response.status);
                  //console.log(error.response.headers);
                  mensaje=error.response.data.message
                  
                  store.addNotification({
                    title: 'Atención',
                    message: mensaje,
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              }
              //console.log(error.config);
            
            })
        
      }


      Eliminar_anexo=()=>{
           
            //var  dato  = horario.id;
            //alert(id_cita_cancela);
      
            this.setState({ loading_button_eliminaanexo: this.state.loading_button_eliminaanexo = false })
            this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = false })
      
            axios.delete(ApiURL+"/api/Attach/Delete/"+id_anexo_elimina)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
                this.setState({ loading_button_eliminaanexo: this.state.loading_button_eliminaanexo = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
      
                this.Historial_Anexos();
                $('#modal-elimina_anexo').modal('hide');          
               
              
            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
      }



      searchDataagenda(buscar_atenciones_idpcte) {

        this.setState({ loading: this.state.loading = false })
        
        axios.get(ApiURL+"/api/Consultations/ListByProfessional/"+institution_id+"?texto="+buscar_atenciones_idpcte)
        .then((response) => {
        console.log(response);

        this.setState({Agendas_inactivas: response.data})

            $('#tabla2').show();
            $('#empty_page2').hide();
            $('#text_page2').hide();


            this.setState({ loading: this.state.loading = true })
        
        })
        .catch((error) => {
          console.log(error);

            $('#tabla2').hide();
            $('#empty_page2').show();
            $('#text_page2').show();   

            this.setState({ loading: this.state.loading = true })
        })
      
      }



    Crear_consulta=async(dato)=>{ 

            axios.put(ApiURL+"/api/Citas/ConfirmPresencialAppointment/"+dato)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;

                id_consulta=response.data.consultation.id;

                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
               
                this.CargarAgendas();
                

              
            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
      }

      Cancelar_cita=()=>{
           
            //var  dato  = horario.id;
            //alert(id_cita_cancela);
      
            this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = false })
            this.setState({ active_button_cancelacita: this.state.active_button_cancelacita = false })
      
            axios.put(ApiURL+"/api/Citas/Cancelation/"+id_cita_cancela)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.active_button_cancelacita = true })
      
                this.Citas_Asignadas();
                $('#modal-cancela_cita').modal('hide');          
               
              
            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
          }



      savehc=async()=>{     
      
            if(this.state.form.acompanante.length==0 || this.state.form.tel_acompanante.length==0 || this.state.form.motivo_consulta.length==0 || this.state.form.enfermada_actual.length==0 || this.state.form.antecedentes_rel.length==0 || this.state.form.revision_sistema.length==0 || this.state.form.examen_fis.length==0 || this.state.form.analisis.length==0 || this.state.form.conducta.length==0 ){
      
              store.addNotification({
                title: 'Atención',
                message: "Complete los datos faltantes para continuar.",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
      
            }else{
              this.setState({ loading_button: this.state.loading_button = false })
              this.setState({ active_button: this.state.active_button = false })
              await axios.put(ApiURL+"/api/Consultations/SaveClinicalHistory",
        
                {
                  
                 
              consultationId: id_consulta,
              escort: this.state.form.acompanante,
              phoneEscort: this.state.form.tel_acompanante,
              consultationData: [
                {
                  field: "Motivo de consulta",
                  value: this.state.form.motivo_consulta
                },
                {
                  field: "Enfermedad actual",
                  value: this.state.form.enfermada_actual
                },
                {
                  field: "Antecedentes relevantes",
                  value: this.state.form.antecedentes_rel
                },
                {
                  field: "Revisión por sistemas",
                  value: this.state.form.revision_sistema
                },
                {
                  field: "Examen físico",
                  value: this.state.form.examen_fis
                },
                {
                  field: "Análisis",
                  value: this.state.form.analisis
                },
                {
                  field: "Conducta",
                  value: this.state.form.conducta
                },
                {
                  field: "Fórmula médica",
                  value: this.state.form.formula_med
                },
                {
                  field: "Orden médica",
                  value: this.state.form.orden_med
                }
                
              ],
              diagnostics: diagnosticos_pcte,
              medicalPrescription: [
                {
                  number: 1,
                  medicineName: "Dipirona 2.5 mg",
                  concentration: "2.5 mg",
                  administrationRoute: "Intravenosa",
                  frequencyDose: "cada 8 Horas",
                  duration: "24 Horas",
                  quantities: "3"
                }
              ]
      
                })  
              .then(response=>{
                console.log(response.data)
                var  mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);
                       
                //window.location.href="/home";
              store.addNotification({
                  title: 'Muy bien',
                  message: "La historia clínica fue guardada correctamente.",
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                  duration: 10000,
                  showIcon:true
                  }
                })
      
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
      
                this.Consulta_profesional();

                window.location.href="/agenda_profesional"

                this.setState({
              form:{
                  id_cita:'',
                  idconsulta:'', 
                  id_paciente:'',
                  nom_paciente: '',
                  nom2_paciente: '',
                  apell1_paciente: '',
                  apell2_paciente: '',

                  eps:'',

                  acompanante:'',
                  tel_acompanante:'',
                  motivo_consulta:'',
                  enfermada_actual:'',
                  antecedentes_rel:'',
                  revision_sistema:'',
                  examen_fis:'',
                  analisis:'',
                  conducta:'',
                  formula_med:'',
                  orden_med:''
                  
                }
              })
      
                
                
              })
              .catch(error=>{
               
                if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  //console.log(error.response.data.message);
                  //console.log(error.response.status);
                  //console.log(error.response.headers);
                  mensaje=error.response.data.message
                  
                  store.addNotification({
                    title: 'Atención',
                    message: mensaje,
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
      
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
      
                  this.setState({ loading_button: this.state.loading_button = false })
                  this.setState({ loading_button: this.state.active_button = false })
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
                  this.setState({ loading_button: this.state.loading_button = true })
                  this.setState({ active_button: this.state.active_button = true })
              }
              //console.log(error.config);
            
              })
      
              }  
            
      
        
      }


      Consulta_profesional(){  

          this.empty_page_hide();
    
          this.setState({ loading: this.state.loading = false })
          axios.get(ApiURL+"/api/Consultations/ListByProfessional/"+institution_id)
          .then((response) => {
    
            console.log(response);
            this.setState({Agendas_inactivas: response.data})
           
    
            if(this.state.Agendas_inactivas.length==0){
    
              $('#tabla2').hide();
              $('#empty_page2').show();
              $('#text_page2').show();   
              
            }else{
    
              $('#tabla2').show();
              $('#empty_page2').hide();
              $('#text_page2').hide(); 
              
            }
    
            this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        }


        searchDataagenda_inactiva(buscar_agenda_inactiva) {

          this.setState({ loading: this.state.loading = false })
          
          axios.get(ApiURL+"/api/Schedules/ListInactive?texto="+buscar_agenda_inactiva)
          .then((response) => {
          console.log(response);
  
          this.setState({Agendas_inactivas: response.data.data})
          this.setState({Pager_Agendas_inactivas: response.data.pager.items})
          this.setState({pager_infoagendas_inactivas: response.data.pager.showData})
          
          this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        
        }


        loadMoreDataagendas_inactiva(page_agenda_inactiva) {
          var page=page_agenda_inactiva.pagina
          this.setState({ loading: this.state.loading = false })
          
          axios.get(ApiURL+"/api/Schedules/ListInactive?numeroPagina="+page)
          .then((response) => {
    
            console.log(response);
    
            this.setState({Agendas_inactivas: response.data.data})
            this.setState({Pager_Agendas_inactivas: response.data.pager.items})
            this.setState({pager_infoagendas_inactivas: response.data.pager.showData})
      
          
            this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        
        }

    handleridservi =  servicios_multi => {      
    
      this.setState({ servicios_multi});
      diagnosticos_pcte=servicios_multi;

      console.log(servicios_multi)  
      
      diagnosticos_pcte = servicios_multi.map(d => ({
              "id" : d.value,
              "name" : d.label.slice(5)
        
            }))

      console.log(diagnosticos_pcte) 
      
      
    }



    render(){ 
      
      const {form} = this.state;

     return (
     
          <div className="content-wrapper">   
         
              <div className="col-12 col-sm-12">

                  <div className="row">
            
                      <div className="col-sm-12"> 
                      <br></br>           
                         <div className="text-center" id="title"> <h6> <b> HISTORIAL DE CONSULTA </b>  </h6> </div>            
                      </div>             
            
                  </div>

                  <div className="card card-primary card-outline card-tabs">

                        <div className="card-header p-0 pt-1 border-bottom-0">
                          
                          <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                              
                              <li className="nav-item">
                                <a className="nav-link active" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="true" onClick={()=>{this.CargarAgendas()}} >Agenda <Logo_agenda/> </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" id="custom-tabs-three-agenda_inactiva-tab" data-toggle="pill" href="#custom-tabs-three-agenda_inactiva" role="tab" aria-controls="custom-tabs-three-agenda_inactiva" aria-selected="false" onClick={()=>{this.Consulta_profesional()}} >Atendidas <Logo_agenda/> </a>
                              </li>
                              
                          </ul>
                        
                        </div>
                  
                      <div className="card-body">
                        
                          <div className="tab-content" id="custom-tabs-three-tabContent"> 
  

                              <div className="tab-pane fade show active" id="custom-tabs-three-profile" role="tabpanel" aria-labelledby="custom-tabs-three-profile-tab"> 

                                  <div class="d-flex justify-content-center">
                                                
                                      {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}
                                        
                                  </div>
                                  
                                  <div className="card table-responsive" id="tabla1">    
                                       

                                      <div id="filtrar_agenda" className="row">                                   
                                                                                      
                                          <div className="col-sm-3">
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                                                      
                                                <select onChange={this.Gettipo_filtro}  className="form-control" id="tipo_filtro" name="tipo_filtro">
                                                    <option  value="0"> Filtrar por...</option>
                                                    <option  value="1"> Modalida de atención</option>
                                                    <option  value="2"> Tipo de consulta</option>
                                                    <option  value="3"> Texto</option>
                                                    <option  value="10"> Limpiar filtro</option>
                                                        
                                                </select>                      
                                              </div>                       
                                          </div>

                                          <div className="col-sm-3" id="texto_filtro">
                                                <div className="input-group input-group-sm mb-3 mr-sm-2">
                                                    <div className="input-group-prepend">
                                                      <div className="input-group-text"><Buscar/></div>
                                                    </div>
                                                    <input type="search" className="form-control" placeholder="Buscar" name="buscar_solicitadas" id="buscar_solicitadas" onChange={this.BuscarSolicitada}/>
                                                </div>                                
                                          </div>

                                          <div className="col-md-3" id="select_modalidad_filtro">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="modalidad_filtro" name="modalidad_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="presencial"> Presencial</option> ,
                                                            <option  value="telemedicina"> Telemedicina</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div> 

                                           <div className="col-md-3" id="select_tipoconsulta_filtro">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="tipoconsulta_filtro" name="tipoconsulta_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="999"> Cita particular</option> ,
                                                            <option  value="998"> Examen bexa</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div>
                                          
                                      </div>                      
                              
                                        
                                      <table id="tabla_agendas" className="table table-bordered table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th>ID</th>
                                            <th>Fecha cita</th>
                                            <th>Paciente</th>                                           
                                            <th>Especialidad</th>
                                           
                                            <th>Prestador</th>
                                            <th>Sede</th>
                                            <th>Modalidad de cita</th>
                                            <th>Tipo de cita</th>                                            
                                            <th>Historia clínica</th>  
                                            <th>Cancelar</th>        
                                          </tr>
                                        </thead>
    
                                        <tbody>
                                             {this.state.Agendas.map(agenda=>{

                                                    var tipo_cita=agenda.contract.entityId                                                   

                                                          if(tipo_cita=='999'){

                                                            tipo_cita='Cita particular'
                                                           

                                                          }else{

                                                            if(tipo_cita=='998'){

                                                            tipo_cita='Cita BEXA'
                                                           

                                                          }else{

                                                             tipo_cita='Cita por EPS'

                                                            }                                                           
                                                            
                                                          }

                                               return(
                                            
                                               <tr>
                                                 <td>{agenda.id}</td> 
                                                 <td> 
                                                 <Moment format="YYYY/MM/DD HH:mm">
                                                 {agenda.fecha}
                                                 </Moment>
                                                 </td>
                                                 <td>{agenda.patient.user.name1 ? (agenda.patient.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {agenda.patient.user.name2 ? (agenda.patient.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda.patient.user.lastname1 ? (agenda.patient.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda.patient.user.lastname2 ? (agenda.patient.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } <a data-toggle="tooltip" data-placement="top" title="Más información del paciente."  id="btn-registrarse" href="#" onClick={()=>{this.seleccionar_cita(agenda);this.modal_informacionpcte()}} > <spam  > <Info/> </spam> </a></td>
                                                 
                                                 <td>{(agenda.specialty.name).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                 <td>{agenda.institution.name.trim().toUpperCase()}</td> 
                                                 <td>{(agenda.schedule.sede.name).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>        
                                                  
                                                 <td>{(agenda.type).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                 <td>{tipo_cita}</td>
                                                 <td onClick={()=>{this.handleModal_realizahc();this.seleccionarconsulta_agendahc(agenda)}}> <BtnEdit  />
                                                 </td>
                                                 <td onClick={()=>{this.Traerdato_Cancelar_cita(agenda)}}> <BtnDelete />  </td>
                                               </tr>
                                               )
                                              }
                                            )}                                                            
                                                                               
                                        </tbody>
                                        
                                      </table>

                                                          
                
                                  </div>

                                  <div className="d-flex justify-content-center">                              
                                        <img id="empty_page" src={emptypage} alt="logo"  width= "200"/>                             
                                  </div>

                                  <div className="d-flex justify-content-center">                  
                                       <h5 id="text_page"> <b>No hay información que mostrar</b> </h5>                          
                                  </div>

                              </div>

                              <div className="tab-pane fade" id="custom-tabs-three-agenda_inactiva" role="tabpanel" aria-labelledby="custom-tabs-three-agenda_inactiva"> 

                                  <div className="col-sm-3" id="texto_id_pcteee">
                                        <div className="input-group input-group-sm mb-3 mr-sm-2">
                                            <div className="input-group-prepend">
                                              <div className="input-group-text"><Buscar/></div>
                                            </div>
                                            <input type="search" className="form-control" placeholder="Buscar" name="buscar_solicitadas" id="buscar_solicitadas" onChange={this.Buscar_atenciones_idpcte}/>
                                        </div>                                
                                  </div>

                                  <div className="d-flex justify-content-center">
                                                
                                      {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}
                                        
                                  </div>
                                  
                                  <div className="card table-responsive" id="tabla2">    
                                       

                                      <div id="filtrar_atendidos" className="row">                                   
                                                                                      
                                          <div className="col-sm-3">
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                                                      
                                                <select onChange={this.Gettipo_filtro_atendidos}  className="form-control" id="tipo_filtro_atendidos" name="tipo_filtro">
                                                    <option  value="0"> Filtrar por...</option>
                                                    <option  value="1"> Modalida de atención</option>
                                                    <option  value="2"> Tipo de consulta</option>
                                                    <option  value="3"> ID Paciente</option>
                                                    <option  value="10"> Limpiar filtro</option>
                                                        
                                                </select>                      
                                              </div>                       
                                          </div>                                          

                                          <div className="col-md-3" id="select_modalidad_filtro_atendidos">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="modalidad_filtro" name="modalidad_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="presencial"> Presencial</option> ,
                                                            <option  value="telemedicina"> Telemedicina</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div> 

                                           <div className="col-md-3" id="select_tipoconsulta_filtro_atendidos">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="tipoconsulta_filtro" name="tipoconsulta_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="999"> Cita particular</option> ,
                                                            <option  value="998"> Examen bexa</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div>
                                          
                                      </div>  

                                                          
                              
                                        
                                      <table id="tabla_agendas" className="table table-bordered table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th>ID consulta</th>
                                            <th>ID cita</th>
                                            <th>Fecha cita</th>
                                            <th>Fecha consulta</th>
                                            <th>Paciente</th>                                       
                                                                               
                                            <th>Prestador</th>                                           
                                            <th>Modalidad de cita</th>
                                            <th>Tipo de cita</th>
                                            <th>Estado de la consulta</th>                                            
                                            <th>Opciones</th>  
                                           
                                                 
                                          </tr>
                                        </thead>
    
                                        <tbody>
                                             {this.state.Agendas_inactivas.map(agenda_inactiva=>{

                                                    var tipo_cita=agenda_inactiva.appointment.contract.entityId
               
                                                          if(tipo_cita=='999'){

                                                            tipo_cita='Cita particular'
                                                           

                                                          }else{

                                                            if(tipo_cita=='998'){

                                                            tipo_cita='Cita BEXA'
                                                           

                                                          }else{

                                                             tipo_cita='Cita por EPS'

                                                            }                                                           
                                                            
                                                          }

                                                    var estado_consulta=agenda_inactiva.status
                                                    var btn_estado_consulta

                                                          if(estado_consulta=='cerrada'){

                                                            estado_consulta='Consulta en progreso'
                                                            btn_estado_consulta=<td data-toggle="tooltip" data-placement="top" title="Terminar historia clínica" onClick={()=>{this.handleModal_realizahc();this.seleccionarconsulta_hc(agenda_inactiva)}}> <BtnEdit  /> </td>
                                                           

                                                          }else{

                                                            if(estado_consulta=='finalizada'){

                                                            estado_consulta='Exitosa'
                                                            btn_estado_consulta=<td  onClick={()=>{this.handleModalconsultashow();this.seleccionarconsulta(agenda_inactiva)}}><BtnVer  /></td>
                                                           

                                                          }else{

                                                             estado_consulta='Fallida'

                                                            }                                                           
                                                            
                                                          }
                                               return(
                                            
                                               <tr>
                                                 <td>{agenda_inactiva.id}</td>  
                                                 <td>{agenda_inactiva.appointmentId}</td>
                                                 <td> 
                                                 <Moment format="YYYY/MM/DD HH:mm">
                                                 {agenda_inactiva.appointment.fecha}
                                                 </Moment>
                                                 </td>
                                                  <td> 
                                                 <Moment format="YYYY/MM/DD HH:mm">
                                                 {agenda_inactiva.date}
                                                 </Moment>
                                                 </td>
                                                 <td>{agenda_inactiva.patient.user.name1 ? (agenda_inactiva.patient.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {agenda_inactiva.patient.user.name2 ? (agenda_inactiva.patient.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda_inactiva.patient.user.lastname1 ? (agenda_inactiva.patient.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda_inactiva.patient.user.lastname2 ? (agenda_inactiva.patient.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } <a data-toggle="tooltip" data-placement="top" title="Más información del paciente."  id="btn-registrarse" href="#" onClick={()=>{this.seleccionar_cita2(agenda_inactiva);this.modal_informacionpcte()}} > <spam  > <Info/> </spam> </a></td>
                                                 <td>{agenda_inactiva.institution.name.trim().toUpperCase()}</td> 
                                                 <td>{(agenda_inactiva.appointment.type).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                 <td>{tipo_cita}</td>                                                
                                                 <td>{estado_consulta}</td>
                                                 {btn_estado_consulta}
                                                 
                                               </tr>
                                               )
                                              }
                                            )}                                                            
                                                                               
                                        </tbody>
                                        
                                      </table>

                                      <span>{this.state.pager_infoagendas_inactivas}</span>
                                                <nav className="nav">
                                                
                                                    <ul className="pagination">
              
                                                        {this.state.Pager_Agendas_inactivas.map(page_agenda_inactiva=>{
                                                        
                                                          var activo=page_agenda_inactiva.activo
                                                          if(activo==true){
                                                            activo='page-item active'
                                                          }else{
                                                            activo='page-item'
                                                          }
              
                                                         // alert(activo)
                                                          
                                                         return(                          
                                                                  
                                                                 <li className={activo}>
                                                                   <a className="nav-link" onClick={()=>{this.loadMoreDataagendas_inactiva(page_agenda_inactiva)}}>{page_agenda_inactiva.texto}</a>
                                                                 </li>                                            
                                                           )
                                                          }
                                                         )
                                                        }

                                                    </ul>
                                                          
                                                </nav>                          
                
                                  </div>

                                  <div className="d-flex justify-content-center">                              
                                        <img id="empty_page2" src={emptypage} alt="logo"  width= "200"/>                             
                                  </div>

                                  <div className="d-flex justify-content-center">                  
                                       <h5 id="text_page2"> <b>No hay información que mostrar</b> </h5>                          
                                  </div>

                              </div> 
                              
                       
                          </div>

                      </div>
               
                  </div>

              </div>
   
   
   

              <div className="modal fade" id="modal-consulta" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><b>Realizar historia clínica</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true"  onClick={()=> this.handleModalrespuestacitadrop()}>×</span>
                        </button>
                      </div>
  
                          <div className="modal-body">                         
                                
                              <div className="row">
                                  
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >ID:</label>
                                          <input type="text" className="form-control" name="idconsulta"  value={form.idconsulta} readOnly />                      
                                        </div>                 
                                  </div>
                      
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >ID Paciente:</label>
                                          <input type="text" className="form-control" value={form.id_paciente} readOnly />                      
                                        </div>                 
                                  </div>
  
                      
                              </div>
  
                              <div className="row">

                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Paciente:</label>
                                          <input type="text" className="form-control"  value={form.nom_paciente + ' '+ form.nom2_paciente + ' '+ form.apell1_paciente + ' '+ form.apell2_paciente} readOnly />                      
                                        </div>                 
                                  </div>
                                             
                                  <div className="col-md-6">
                                      <div className="form-group">                    
                                              <label >EPS:</label>
                                              <input type="text" className="form-control"  value={form.eps} readOnly/>                    
                                      </div>                 
                                  </div>                                                                
                                                                          
                              </div> 

                              <div className="row">
                                  
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Acompañante:</label>
                                          <input type="text" className="form-control" name="acompanante" onChange={this.handleChange}  />                      
                                        </div>                 
                                  </div>
                      
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Télefono acompañante:</label>
                                          <input type="text" className="form-control" name="tel_acompanante" onChange={this.handleChange} />                      
                                        </div>                 
                                  </div>
  
                      
                              </div>
  
                              <div className="row">
                                  <div className="col-md-12">

                                     <div className="form-group">                    
                                              <label >Motivo de consulta:</label>
                                              <textarea className="form-control" rows="2" name="motivo_consulta" onChange={this.handleChange} > </textarea> 
                                      </div>

                                  </div>
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                     <div className="form-group">                    
                                              <label >Enfermedad actual:</label>
                                              <textarea className="form-control" rows="2" name="enfermada_actual" onChange={this.handleChange} > </textarea> 
                                      </div>


                                  </div>                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                     <div className="form-group">                    
                                              <label >Antecedentes:</label>
                                              <textarea className="form-control" rows="2" name="antecedentes_rel" onChange={this.handleChange} > </textarea> 
                                      </div>

                                  </div>                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                     <div className="form-group">                    
                                              <label >Revisión por sistemas:</label>
                                              <textarea className="form-control" rows="2" name="revision_sistema" onChange={this.handleChange} > </textarea> 
                                      </div>


                                  </div>                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                     <div className="form-group">                    
                                              <label >Examen físico:</label>
                                              <textarea className="form-control" rows="2" name="examen_fis" onChange={this.handleChange} > </textarea> 
                                      </div>


                                  </div>
                                  
                              </div>

                              <div className="row">

                                  <div className="col-md-12">
                                        <div className="form-group">                    
                                          <label >Diagnoticos:</label>
                                          <Select                                                  
                                              options={this.state.Diagnotico_Multiple}
                                              onChange={this.handleridservi}
                                              isMulti
                                              id="especialidad"
                                              className="basic-multi-select"
                                              classNamePrefix="select"
                                              placeholder="Seleccione..."                
                                          />                      
                                        </div>

                                  </div>
                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                    <div className="form-group">                    
                                              <label >Análisis:</label>
                                              <textarea className="form-control" rows="2" name="analisis" onChange={this.handleChange} > </textarea> 
                                    </div>


                                  </div>
                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                    <div className="form-group">                    
                                              <label >Conducta:</label>
                                              <textarea className="form-control" rows="2" name="conducta" onChange={this.handleChange} > </textarea> 
                                    </div>

                                  </div>
                                  
                              </div>  

                              <div className="row">
                                  <div className="col-md-12">

                                    <div className="form-group">                    
                                              <label >Fórmula médica:</label>
                                              <textarea className="form-control" rows="2" name="formula_med" onChange={this.handleChange} > </textarea> 
                                    </div>


                                  </div>
                                  
                              </div>

                              <div className="row">
                                  <div className="col-md-12">

                                    <div className="form-group">                    
                                              <label >Ordenes médicas:</label>
                                              <textarea className="form-control" rows="2" name="orden_med" onChange={this.handleChange} > </textarea> 
                                    </div>


                                  </div>
                                  
                              </div>

                              <hr></hr>

                              <h5 className="text-center"> <b>CARGAR ANEXOS</b> </h5>
                              <br></br>

                              <div className="row" id="seccion_anexo1">

                                <div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Profesional que reporta:</label>
                                          <input type="text" className="form-control" name="nom_med_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange} value={nom_med_anexo}  />                      
                                      </div>                 
                                </div>

                                <div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Identificación del profesional que reporta :</label>
                                          <input type="text" className="form-control" name="id_med_anexo" maxLength="20" autocorrect="off" onChange={this.handleChange} value={id_med_anexo} />                      
                                      </div>                 
                                </div>                      

                              </div>
                              
                              <div className="row" id="seccion_anexo2">

                                <div className="col-md-6">

                                    <div className="form-group">                    
                                        <label >Tipo de anexo:</label>                                                                          
                                        <select onChange={this.Get_id_tipoanexo} className="form-control" id="id_tipo_anexo" name="id_tipo_anexo" >
                                            <option  value="0"> Seleccione...</option> ,
                                            {this.state.Tipo_anexos.map(item=>                              
                                            <option key={item.id} value={item.id}> {item.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                            )}
                                                    
                                        </select>                              
                                    </div>
                        
                                </div>

                                {/*<div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Nombre del anexo:</label>
                                          <input type="text" className="form-control" name="nombre_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange}  />                      
                                      </div>                 
                                </div>*/}  

                                <div className="row" id="input_file">               
                                                                        
                                  <div className="col-md-12 col-auto text-center"> 
        
                                      <div className="form-group">    
      
                                          <label >Seleccione un archivo</label>
                                          
                                          <div className="custom-file">
                                                <input type="file" name="selectedFile" id="exampleInputFile" multiple="true" className="inputfile inputfile-5" accept=".pdf" onChange={this.GetDoc}/>
                                            
                                                <label htmlFor="file-5" for="exampleInputFile">
                                                  <figure>
                                                  <img src={file_pdf}/>
                                                  </figure>
                                                  <span className="iborrainputfile">{this.state.num_file}</span>
                                                </label>
                                          </div>
                                                                
                                      </div> 

                                  </div>                                    
            
                                </div>                    

                              </div>

                              {/*<div className="row" id="seccion_anexo3">
                       
                                <div className="col-md-6">
                                      <div className="form-group">                    
                                            <label >Descripción del anexo:</label>
                                            <textarea className="form-control" rows="4" name="descripcion_anexo" onChange={this.handleChange} > </textarea> 
                                      </div>                
                                </div>

                                

                              </div>*/}

                              <div className="row">

                                <div className="col-md-12 col-auto text-center">

                                    <button type="button"  className="btn btn-success" disabled={!this.state.active_btnaddanexo} onClick={()=> this.Subir_Anexo()}> {this.state.loading_btnaddanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Subir anexo
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 640 640">{/*!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                                          <path d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z" />
                                        </svg>
                                    </button>  &nbsp;
                                      
                                    <button type="button" id="btn_save" className="btn btn-success" disabled={!this.state.active_btnhisanexo} onClick={()=> this.Historial_Anexos()}> {this.state.loading_btnhisanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Historial de anexos 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" class="bi bi-card-list" viewBox="-1 0 17 17">
                                          <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                          <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </button>

                                </div>
                              </div>

                              
                              

                          </div>

  
                          <div className="modal-footer justify-content-between">        
                               
                                <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.savehc()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar 
                                  <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-check2-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                      <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h10a1.5 1.5 0 0 0 1.5-1.5V8a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 3v10z"/>
                                  </svg>
                                </button>

                               

                                
                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.handleModalrespuestacitadrop()}>Cerrar</button>
                          </div>
  
                    </div>
                    
                  </div>
                  
              </div>
              

              <div className="modal fade" id="modal-imprimirconsulta" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><b>Detalle de consulta</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
  
                          <div className="modal-body">                         
                                
                              <div className="row">
                                  
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >ID consulta:</label>
                                          <input type="text" className="form-control"  value={form.idconsulta} readOnly />                      
                                        </div>                 
                                  </div>
                      
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >ID Paciente:</label>
                                          <input type="text" className="form-control"  value={form.id_paciente} readOnly />                      
                                        </div>                 
                                  </div>
  
                                  
                      
                              </div>
  
                              <div className="row">
                                  
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Paciente:</label>
                                          <input type="text" className="form-control"  value={form.nom_paciente + ' '+ form.nom2_paciente + ' '+ form.apell1_paciente + ' '+ form.apell2_paciente} readOnly />                      
                                        </div>                 
                                  </div>
                                                    
                                  <div className="col-md-6">
                                      <div className="form-group">                    
                                              <label >EPS:</label>
                                              <input type="text" className="form-control"  value={form.eps} readOnly/>                    
                                      </div>                 
                                  </div>                                                                
                                                                          
                              </div> 

  
                                    {this.state.Historia.map(histo=>{
                                        return( 
                                          
                                                  
                                            <div className="form-group">                    
                                                    <label >{histo.field}:</label>
                                                    <textarea className="form-control" rows="2" name="nom_medico" value={histo.value} readOnly> </textarea> 
                                            </div>       
                                      
                                      
                                
                                          )
                                          }
                                        )
                                    }
                              <div className="row">
                                      
                                      <div className="col-md-12">
                                          <label >Diagnóstico(s):</label>
                                          <div className="card table-responsive">
                                    
                                              
                                              <div className="card-body">
                                                  <table id="tabla_dxhc" className="table table-bordered table-striped table-hover">
                                                    <thead>
                                                      <tr>
                                                        <th>Código diagnóstico</th>                              
                                                        <th>Nombre diagnóstico</th>                                                                                                
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.Diagnostico_hc.map(dx_hc=>{
                      
                                                        return(      
                                                        
                                                        <tr>          
                                                          <td>{dx_hc.id}</td>                                                                                                               
                                                          <td>{(dx_hc.name).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                        </tr>
                                                
                                                            )
                                                          }
                                                        )
                                                      }                
                                                    </tbody>
                                                  </table>
                                              </div>
    
                                              
                                          </div>            
                    
                                      </div>
    
                              </div>

                              <hr></hr>

                              <h5 className="text-center"> <b>CARGAR ANEXOS</b> </h5>
                              <br></br>

                              <div className="row" id="seccion_anexo1">

                                <div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Profesional que reporta:</label>
                                          <input type="text" className="form-control" name="nom_med_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange} value={nom_med_anexo}  />                      
                                      </div>                 
                                </div>

                                <div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Identificación del profesional que reporta :</label>
                                          <input type="text" className="form-control" name="id_med_anexo" maxLength="20" autocorrect="off" onChange={this.handleChange} value={id_med_anexo} />                      
                                      </div>                 
                                </div>                      

                              </div>
                              
                              <div className="row" id="seccion_anexo2">

                                <div className="col-md-6">

                                    <div className="form-group">                    
                                        <label >Tipo de anexo:</label>                                                                          
                                        <select onChange={this.Get_id_tipoanexo} className="form-control" id="id_tipo_anexo" name="id_tipo_anexo" >
                                            <option  value="0"> Seleccione...</option> ,
                                            {this.state.Tipo_anexos.map(item=>                              
                                            <option key={item.id} value={item.id}> {item.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                            )}
                                                    
                                        </select>                              
                                    </div>
                        
                                </div>

                                {/*<div className="col-md-6">
                                      <div className="form-group">                    
                                          <label >Nombre del anexo:</label>
                                          <input type="text" className="form-control" name="nombre_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange}  />                      
                                      </div>                 
                                </div>*/}  

                                <div className="row" id="input_file">               
                                                                        
                                  <div className="col-md-12 col-auto text-center"> 
        
                                      <div className="form-group">    
      
                                          <label >Seleccione un archivo</label>
                                          
                                          <div className="custom-file">
                                                <input type="file" name="selectedFile" id="exampleInputFile" multiple="true" className="inputfile inputfile-5" accept=".pdf" onChange={this.GetDoc}/>
                                            
                                                <label htmlFor="file-5" for="exampleInputFile">
                                                  <figure>
                                                  <img src={file_pdf}/>
                                                  </figure>
                                                  <span className="iborrainputfile">{this.state.num_file}</span>
                                                </label>
                                          </div>
                                                                
                                      </div> 

                                  </div>                                    
            
                                </div>                    

                              </div>

                              {/*<div className="row" id="seccion_anexo3">
                       
                                <div className="col-md-6">
                                      <div className="form-group">                    
                                            <label >Descripción del anexo:</label>
                                            <textarea className="form-control" rows="4" name="descripcion_anexo" onChange={this.handleChange} > </textarea> 
                                      </div>                
                                </div>

                                

                              </div>*/}

                              <div className="row">

                                <div className="col-md-12 col-auto text-center">

                                    <button type="button"  className="btn btn-success" disabled={!this.state.active_btnaddanexo} onClick={()=> this.Subir_Anexo()}> {this.state.loading_btnaddanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Subir anexo
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 640 640">{/*!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                                          <path d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z" />
                                        </svg>
                                    </button>  &nbsp;
                                      
                                    <button type="button" id="btn_save" className="btn btn-success" disabled={!this.state.active_btnhisanexo} onClick={()=> this.Historial_Anexos()}> {this.state.loading_btnhisanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Historial de anexos 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" class="bi bi-card-list" viewBox="-1 0 17 17">
                                          <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                          <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </button>

                                </div>
                              </div>              

                          </div>
  
                          <div className="modal-footer justify-content-between">      
                                <div className="btn-group dropup">
                                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={!this.state.active_button}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Imprimir
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                                            </svg>
                                    </button>
                                    <div className="dropdown-menu">
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_consulta()}>Historia clinica</a>
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_formula()}>Formula médica</a>
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_orden()}>Orden médica</a>
                                    </div>
                                </div>
                                <button type="button" className="btn btn-success" onClick={()=> this.saverecurso()}> Descargar video
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                                    <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                    <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>
                                  </svg>
                                </button>

                              
                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.handleModaldetallehcdrop()}>Cerrar</button>
                          
                                
                          </div>
  
                    </div>
                    
                  </div>
                  
              </div>   


              <div className="modal fade" id="modal-cancela_cita" data-backdrop="static">
              
                              <div className="modal-dialog modal-sm">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h4 className="modal-title"><b>Cancelar cita</b></h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                
                                        <div className="col-md-12">
                
                                        La cancelación de una cita no se puede revertir. <br/> <br/>
                                        ¿Seguro que desea cancelar esta cita?
                
                                        </div>
                                               
                                  </div>
                        
                                        <div className="modal-footer justify-content-between">        
                                           <button type="button" className="btn btn-primary" data-dismiss="modal"  disabled={!this.state.active_button_cancelacita} onClick={()=> this.Cancelar_cita()}> {this.state.loading_button_cancelacita?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Si</button>
                                           <button type="button" className="btn btn-danger" data-dismiss="modal">No</button>
                                        </div>
                                </div>                
                              </div>
                          
              </div>

             
              <div className="modal fade" id="modal-infopcte" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Más información del paciente</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      
                          <div className="row">

                              <div className="col-md-3">
                                  <div className="form-group">                    
                                          <label >Identificación:</label>
                                          <input type="text" className="form-control" id="id_pacie_soli" name="fecha_naci" value={form.id_pacie_soli} readOnly/>                                                                         
                                  </div>
              
                              </div>                      
                                          
                              <div className="col-md-3">
                                  <div className="form-group">                    
                                          <label >Fecha de nacimiento:</label>
                                          <input type="text" className="form-control" id="fecha_naci" name="fecha_naci" value={form.fecha_naci} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-3">
                                  <div className="form-group">                    
                                          <label >Edad:</label>
                                          <input type="text" className="form-control" id="edad_pcte" name="edad_pcte" value={form.edad_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-3">
              
                                  <div className="form-group">                    
                                          <label >Género:</label>
                                          <input type="text"  className="form-control" id="genero_pcte" name="genero_pcte" value={form.genero_pcte} readOnly/>                       
                                  </div>
              
                              </div>

                              
                          
                          </div>

                          <div className="row">

                              <div className="col-md-6">
                                  <div className="form-group">                    
                                          <label >Teléfono:</label>
                                          <input type="text" className="form-control" id="tel_pcte" name="tel_pcte" value={form.tel_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-6">

                                  <div className="form-group">                    
                                              <label >Correo eletrónico:</label>
                                              <input type="text" className="form-control" id="email_pcte" name="email_pcte" value={form.email_pcte} readOnly/>                                                                         
                                  </div>

                              </div>

                          </div>

                          <div className="row">

                              <div className="col-md-6">
              
                                  <div className="form-group">                    
                                          <label >Dirección:</label>
                                          <input type="text"  className="form-control" id="dir_pcte" name="dir_pcte" value={form.dir_pcte} readOnly/>                       
                                  </div>
              
                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">                    
                                          <label >Municipio:</label>
                                          <input type="text" className="form-control" id="municipio_pcte" name="municipio_pcte" value={form.municipio_pcte} readOnly/>                                                                         
                                  </div>

                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">                    
                                          <label >Departamento:</label>
                                          <input type="text" className="form-control" id="departamento_pct" name="departamento_pct" value={form.departamento_pct} readOnly/>                                                                         
                                  </div>
              
                              </div>
       
                          
                          </div>

                          <div className="row">
                                          
                              <div className="col-md-6">

                                  <div className="form-group">                    
                                          <label >EPS:</label>
                                          <input type="text" className="form-control" id="eps_pcte" name="eps_pcte" value={form.eps_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-6">

                                  <div className="form-group">                    
                                          <label >Régimen:</label>
                                          <input type="text" className="form-control" id="regimen_pcte" name="regimen_pcte" value={form.regimen_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>
                            
                          
                          </div>  

                          <div className="row">
                                          
                              <div className="col-md-6">

                                  <div className="form-group">                    
                                          <label >Persona responsable:</label>
                                          <input type="text" className="form-control" id="responsable_pcte" name="responsable_pcte" value={form.responsable_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">                    
                                          <label >Teléfono:</label>
                                          <input type="text" className="form-control" id="telresponsable_pcte" name="telresponsable_pcte" value={form.telresponsable_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">                    
                                          <label >Parentesco:</label>
                                          <input type="text" className="form-control" id="parentescoresp_pcte" name="regimeparentescoresp_pcten_pcte" value={form.parentescoresp_pcte} readOnly/>                                                                         
                                  </div>
              
                              </div>
                            
                          
                          </div>   

                         
              
                    </div>
                  
                  </div>
                  {/* /.modal-content */}
                </div>
              {/* /.modal-dialog */}
              </div>

              <div className="modal fade" id="modal-historial_anexo" data-backdrop="static">
                <div className="modal-dialog modal-lg modal-dialog-scrollable" >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Lista de anexos: {form.nom_paciente +' '+ form.apell1_paciente}</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body"> 
    
    
                          <div className="row">
                                      
                                      <div className="col-md-12">
                                          
                                          <div className="card table-responsive">
                                    
                                              
                                              <div className="card-body">
                                                  <table id="tabla_historial" className="table table-bordered table-striped table-hover">
                                                    <thead>
                                                      <tr>
                                                        <th>ID Anexo</th>                              
                                                        <th>Fecha anexo</th>
                                                        <th>Profesional</th>   
                                                        <th>Nombre anexo</th>
                                                        <th>Ver anexo</th>
                                                        <th>Eliminar</th>                                           
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.Historial_anexos.map(historial=>{
                      
                                                        return(      
                                                        
                                                        <tr>          
                                                          <td>{historial.id}</td> 
                                                          <td>
                                                            <Moment format="YYYY/MM/DD HH:mm">
                                                              {historial.date}
                                                            </Moment>
                                                          </td>                                                         
                                                          <td>{(historial.profesionalName).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>                                          
                                                          <td>{(historial.name).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                          <td>  
                                                              <a href={"https://medicall-api-test.azurewebsites.net/api/Files?path="+historial.path} target="_blank"> 
                                                                  <button className="btn btn-edit">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-file-earmark-image" viewBox="0 0 16 16">
                                                                      <path d="M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                                                                      <path d="M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z"/>
                                                                    </svg>
                                                                  </button> 
                                                              </a> 
                                                          </td>
                                                          <td onClick={()=>{this.Traerdato_historial_anexo(historial)}}> <BtnDelete />  </td>
                                                        </tr>
                                                
                                                            )
                                                          }
                                                        )
                                                      }                
                                                    </tbody>
                                                  </table>
                                              </div>
    
                                              
                                          </div>            
                    
                                      </div>
    
                          </div>                 

                    </div>
    
                    {/*<div className="modal-footer justify-content-between">
                      <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>        
                    </div>*/}
                  </div>
                  
                </div>
                
              </div> 

              <div className="modal fade" id="modal-elimina_anexo" data-backdrop="static">
              
                  <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><b>Eliminar anexo</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
    
                            <div className="col-md-12">
    
                            Al eliminar el anexo seleccionado no será posible recuperarlo. <br/> <br/>
                            ¿Seguro que desea eliminar este anexo?
    
                            </div>
                                    
                      </div>
            
                            <div className="modal-footer justify-content-between">        
                                <button type="button" className="btn btn-primary" data-dismiss="modal"  disabled={!this.state.active_button_eliminaanexo} onClick={()=> this.Eliminar_anexo()}> {this.state.loading_button_eliminaanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Si</button>
                                <button type="button" className="btn btn-danger" data-dismiss="modal">No</button>
                            </div>
                    </div>                
                  </div>
                          
              </div>

          </div>    
      
    )

  }
  
}

export default Agenda_profesional_2;